
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefe96"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefe96"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8rWe0"));

});
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.6";

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.6" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.6"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.6"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.6";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.6";

});



parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $040dbb9c344a508d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $040dbb9c344a508d$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "useSearchParams", () => $040dbb9c344a508d$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2vsP7 = parcelRequire("2vsP7");
var $aphAM = parcelRequire("aphAM");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aphAM.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $aphAM.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2vsP7.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aphAM.UNSAFE_useRouteId)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2vsP7.UNSAFE_invariant)(false);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2vsP7.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $2vsP7.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aphAM.useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2vsP7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2vsP7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2vsP7.matchPath)(path.pathname, nextPath) != null || (0, $2vsP7.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $1d34d5c4a288b213$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $1d34d5c4a288b213$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $1d34d5c4a288b213$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $1d34d5c4a288b213$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $1d34d5c4a288b213$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $1d34d5c4a288b213$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isAbsoluteUrl = (url)=>$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($1d34d5c4a288b213$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $7939e29d663dd3ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $7939e29d663dd3ed$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7939e29d663dd3ed$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $7939e29d663dd3ed$export$b273b3273281a049);
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", () => $7939e29d663dd3ed$export$db5148ec97d6af7a);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $7939e29d663dd3ed$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Route", () => $7939e29d663dd3ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $7939e29d663dd3ed$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7939e29d663dd3ed$export$52b333d321859367);
/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, (0, $2vsP7.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $2vsP7.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $2vsP7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $2vsP7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2vsP7.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2vsP7.resolveTo)(to, (0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("70wbS", function(module, exports) {

$parcel$export(module.exports, "AuthProvider", () => $b622ef53e38024e7$export$87091915187a1a85);
$parcel$export(module.exports, "useAuth", () => $b622ef53e38024e7$export$1d39dc5b47e56ff0);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");
const $b622ef53e38024e7$var$AuthContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $b622ef53e38024e7$var$parseJwt = (token)=>{
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        const decoded = JSON.parse(jsonPayload);
        // Enforce required fields
        if (!decoded.sub || !decoded.id) return null;
        return {
            // Managed-account tokens retain the manager as `sub` for audit,
            // while API/market-data state must be keyed by the effective user.
            id: decoded.acting_as_user_id || decoded.id,
            username: decoded.acting_as_username || decoded.sub,
            // JWT claims provide only a provisional cache identity. Permissions
            // and profile fields always come from the authenticated /me endpoint.
            role: 'viewer',
            is_active: true
        };
    } catch  {
        return null;
    }
};
const $b622ef53e38024e7$export$87091915187a1a85 = ({ children: children })=>{
    // Decode only the effective identity synchronously so tenant-scoped query
    // caches start under the right key; profile and role are refreshed below.
    const [token, setToken] = (0, $acw62.useState)(()=>localStorage.getItem('token'));
    const [user, setUser] = (0, $acw62.useState)(()=>{
        const persistedToken = localStorage.getItem('token');
        return persistedToken ? $b622ef53e38024e7$var$parseJwt(persistedToken) : null;
    });
    const [isUserLoading, setIsUserLoading] = (0, $acw62.useState)(()=>!!localStorage.getItem('token'));
    const [userProfileError, setUserProfileError] = (0, $acw62.useState)(null);
    const [profileRefreshKey, setProfileRefreshKey] = (0, $acw62.useState)(0);
    const isAuthenticated = !!token;
    (0, $acw62.useEffect)(()=>{
        if (token) {
            localStorage.setItem('token', token);
            setIsUserLoading(true);
            setUserProfileError(null);
            setUser((currentUser)=>currentUser || $b622ef53e38024e7$var$parseJwt(token));
            const controller = new AbortController();
            (0, $2wVnk.tradingApi).getCurrentUser(controller.signal).then((currentUser)=>setUser(currentUser)).catch((error)=>{
                if (!controller.signal.aborted) {
                    setUser(null);
                    setUserProfileError(error instanceof Error ? error.message : 'Unable to load the account profile.');
                    console.warn('Failed to load authenticated user profile:', error);
                }
            }).finally(()=>{
                if (!controller.signal.aborted) setIsUserLoading(false);
            });
            return ()=>controller.abort();
        } else {
            localStorage.removeItem('token');
            setUser(null);
            setIsUserLoading(false);
            setUserProfileError(null);
        }
    }, [
        token,
        profileRefreshKey
    ]);
    const login = (newToken)=>{
        localStorage.setItem('token', newToken);
        setUser($b622ef53e38024e7$var$parseJwt(newToken));
        setIsUserLoading(true);
        setUserProfileError(null);
        setProfileRefreshKey((current)=>current + 1);
        setToken(newToken);
    };
    const refreshUserProfile = ()=>{
        setUser(null);
        setUserProfileError(null);
        setIsUserLoading(true);
        setProfileRefreshKey((current)=>current + 1);
    };
    const logout = ()=>{
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
        setIsUserLoading(false);
        setUserProfileError(null);
        // Force full reload/redirect to clear state
        window.location.href = '/login';
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b622ef53e38024e7$var$AuthContext.Provider, {
        value: {
            token: token,
            user: user,
            isAuthenticated: isAuthenticated,
            isUserLoading: isUserLoading,
            userProfileError: userProfileError,
            login: login,
            logout: logout,
            refreshUserProfile: refreshUserProfile
        },
        children: children
    });
};
const $b622ef53e38024e7$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, $acw62.useContext)($b622ef53e38024e7$var$AuthContext);
    if (context === undefined) throw new Error('useAuth must be used within an AuthProvider');
    return context;
};

});
parcelRegister("2wVnk", function(module, exports) {

$parcel$export(module.exports, "tradingApi", () => $488bc2deb3b9875a$export$9fce83b5ea9fffcd);
// API service for fetching data from the IB Trading System API

var $eDW2g = parcelRequire("eDW2g");

var $iBebR = parcelRequire("iBebR");

var $1D6KC = parcelRequire("1D6KC");

var $fESFA = parcelRequire("fESFA");

var $6qqCz = parcelRequire("6qqCz");

var $g6W1K = parcelRequire("g6W1K");

var $1BzxW = parcelRequire("1BzxW");

var $9RTqT = parcelRequire("9RTqT");

var $4XlMV = parcelRequire("4XlMV");

var $bGHkr = parcelRequire("bGHkr");

var $6N9Dd = parcelRequire("6N9Dd");

var $6dP1v = parcelRequire("6dP1v");

var $l26Xf = parcelRequire("l26Xf");
class $488bc2deb3b9875a$var$TradingApiService {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.accountsApi = new (0, $iBebR.AccountsApiService)(baseUrl);
        this.authApi = new (0, $1D6KC.AuthApiService)(baseUrl);
        this.backtestsApi = new (0, $fESFA.BacktestsApiService)(baseUrl);
        this.dataApi = new (0, $6qqCz.DataApiService)(baseUrl);
        this.logsApi = new (0, $g6W1K.LogsApiService)(baseUrl);
        this.managedAccountsApi = new (0, $1BzxW.ManagedAccountsApiService)(baseUrl);
        this.marketApi = new (0, $9RTqT.MarketApiService)(baseUrl);
        this.notificationsApi = new (0, $4XlMV.NotificationsApiService)(baseUrl);
        this.ordersApi = new (0, $bGHkr.OrdersApiService)(baseUrl);
        this.strategiesApi = new (0, $6N9Dd.StrategiesApiService)(baseUrl);
        this.systemApi = new (0, $6dP1v.SystemApiService)(baseUrl);
        this.userAdministrationApi = new (0, $l26Xf.UserAdministrationApiService)(baseUrl);
    }
    async login(username, password) {
        return this.authApi.login(username, password);
    }
    async signup(email, password, role = 'trader', firstName, lastName, isCompany, companyName) {
        return this.authApi.signup(email, password, role, firstName, lastName, isCompany, companyName);
    }
    async getRegistrationStatus() {
        return this.authApi.getRegistrationStatus();
    }
    async joinWaitlist(email, firstName, lastName) {
        return this.authApi.joinWaitlist(email, firstName, lastName);
    }
    // --- Onboarding ---
    async sendInvite(userId) {
        return this.authApi.sendInvite(userId);
    }
    async activateUser(userId) {
        return this.authApi.activateUser(userId);
    }
    async verifyInvite(token) {
        return this.authApi.verifyInvite(token);
    }
    async setupAccount(token, password) {
        return this.authApi.setupAccount(token, password);
    }
    async getUsers() {
        return this.userAdministrationApi.getUsers();
    }
    async adminCreateUser(user) {
        return this.userAdministrationApi.adminCreateUser(user);
    }
    async adminUpdateUser(userId, user) {
        return this.userAdministrationApi.adminUpdateUser(userId, user);
    }
    async deleteUser(userId) {
        return this.userAdministrationApi.deleteUser(userId);
    }
    async getUserDetails(userId) {
        return this.userAdministrationApi.getUserDetails(userId);
    }
    async adminConfigureUserGateway(userId, config) {
        return this.userAdministrationApi.adminConfigureUserGateway(userId, config);
    }
    async adminControlUserGateway(userId, gatewayId, action) {
        return this.userAdministrationApi.adminControlUserGateway(userId, gatewayId, action);
    }
    async adminActivateUserGateway(userId, gatewayId) {
        return this.userAdministrationApi.adminActivateUserGateway(userId, gatewayId);
    }
    async adminDeleteUserGateway(userId, gatewayId) {
        return this.userAdministrationApi.adminDeleteUserGateway(userId, gatewayId);
    }
    async getPortfolio() {
        return this.accountsApi.getPortfolio();
    }
    async getPositions() {
        return this.accountsApi.getPositions();
    }
    async getHistoricalData(symbol, timeframe, duration, source = 'auto', signal) {
        return this.marketApi.getHistoricalData(symbol, timeframe, duration, source, signal);
    }
    async getMarketStatus() {
        return this.marketApi.getMarketStatus();
    }
    async getCurrentUser(signal) {
        return this.authApi.getCurrentUser(signal);
    }
    async getStrategyDescriptionTags() {
        return this.accountsApi.getStrategyDescriptionTags();
    }
    async createStrategyDescriptionTag(payload) {
        return this.accountsApi.createStrategyDescriptionTag(payload);
    }
    async updateStrategyDescriptionTag(tagId, payload) {
        return this.accountsApi.updateStrategyDescriptionTag(tagId, payload);
    }
    async deleteStrategyDescriptionTag(tagId) {
        return this.accountsApi.deleteStrategyDescriptionTag(tagId);
    }
    async updatePositionStrategyTags(positionKey, tagIds) {
        return this.accountsApi.updatePositionStrategyTags(positionKey, tagIds);
    }
    async updatePositionCustomStrategy(positionKey, strategyName) {
        return this.accountsApi.updatePositionCustomStrategy(positionKey, strategyName);
    }
    async updatePositionMetadata(positionKey, strategyName, tagIds) {
        return this.accountsApi.updatePositionMetadata(positionKey, strategyName, tagIds);
    }
    async closePosition(symbol, secType, contract) {
        return this.accountsApi.closePosition(symbol, secType, contract);
    }
    async controlIBGateway(action, gatewayId) {
        return this.systemApi.controlIBGateway(action, gatewayId);
    }
    async getOpenOrders(page = 1, pageSize = 5, secType) {
        return this.ordersApi.getOpenOrders(page, pageSize, secType);
    }
    async getFilledOrdersToday(page = 1, pageSize = 5, secType) {
        return this.ordersApi.getFilledOrdersToday(page, pageSize, secType);
    }
    async cancelOrder(orderId) {
        return this.ordersApi.cancelOrder(orderId);
    }
    async modifyOrder(orderId, order) {
        return this.ordersApi.modifyOrder(orderId, order);
    }
    async getTradeLogs(page = 1, pageSize = 50, filters = {}) {
        return this.logsApi.getTradeLogs(page, pageSize, filters);
    }
    async getRecentLogs(maxLines = 100, levelFilter, logFile = "all") {
        return this.logsApi.getRecentLogs(maxLines, levelFilter, logFile);
    }
    async getSecurityEvents(filters = {}) {
        return this.logsApi.getSecurityEvents(filters);
    }
    async exportSecurityEvents(filters = {}) {
        return this.logsApi.exportSecurityEvents(filters);
    }
    async getSecurityAlertSettings() {
        return this.logsApi.getSecurityAlertSettings();
    }
    async updateSecurityAlertSettings(settings) {
        return this.logsApi.updateSecurityAlertSettings(settings);
    }
    // Generic strategy status method (for backward compatibility)
    async getStrategyStatus() {
        return this.strategiesApi.getStrategyStatus();
    }
    // ON strategy specific methods
    async getONStrategyStatus() {
        return this.strategiesApi.getONStrategyStatus();
    }
    async getONPositions() {
        return this.strategiesApi.getONPositions();
    }
    // ORB strategy specific methods
    async getORBStrategyStatus() {
        return this.strategiesApi.getORBStrategyStatus();
    }
    async getORBPositions() {
        return this.strategiesApi.getORBPositions();
    }
    // All strategies overview
    async getAllStrategiesStatus() {
        return this.strategiesApi.getAllStrategiesStatus();
    }
    async getSystemStatus() {
        return this.systemApi.getSystemStatus();
    }
    async getTradingSignal(symbol) {
        return this.strategiesApi.getTradingSignal(symbol);
    }
    async getMarketAnalysis(symbol) {
        return this.strategiesApi.getMarketAnalysis(symbol);
    }
    // Generic strategy status with parameter
    async getStrategyStatusByName(strategyName) {
        return this.strategiesApi.getStrategyStatusByName(strategyName);
    }
    async getNQMMStrategyStatus() {
        return this.strategiesApi.getNQMMStrategyStatus();
    }
    async getNQMMPositions() {
        return this.strategiesApi.getNQMMPositions();
    }
    async getNQMMPreviousPositions() {
        return this.strategiesApi.getNQMMPreviousPositions();
    }
    async addNQMMPreviousPosition(position) {
        return this.strategiesApi.addNQMMPreviousPosition(position);
    }
    async deleteNQMMPreviousPosition(symbol) {
        return this.strategiesApi.deleteNQMMPreviousPosition(symbol);
    }
    async getSystemControlState() {
        return this.systemApi.getSystemControlState();
    }
    async setSystemEnabled(enabled) {
        return this.systemApi.setSystemEnabled(enabled);
    }
    async getQuotes(symbols) {
        return this.marketApi.getQuotes(symbols);
    }
    async getContractQuote(contract) {
        return this.marketApi.getContractQuote(contract);
    }
    async setStrategyEnabled(strategyName, enabled) {
        return this.systemApi.setStrategyEnabled(strategyName, enabled);
    }
    async emergencyLiquidate() {
        return this.systemApi.emergencyLiquidate();
    }
    async resetEmergencyMode() {
        return this.systemApi.resetEmergencyMode();
    }
    async connectIB() {
        return this.systemApi.connectIB();
    }
    async disconnectIB() {
        return this.systemApi.disconnectIB();
    }
    // --- Strategy Configuration (User-Specific) ---
    async getStrategyDbConfig(strategyName) {
        return this.strategiesApi.getStrategyDbConfig(strategyName);
    }
    async getStrategyDbConfigHistory(strategyName) {
        return this.strategiesApi.getStrategyDbConfigHistory(strategyName);
    }
    // --- Signals & Audit ---
    async getStrategySignals(params) {
        return this.strategiesApi.getStrategySignals(params);
    }
    async resetStrategyDbConfig(strategyName) {
        return this.strategiesApi.resetStrategyDbConfig(strategyName);
    }
    async updateStrategyConfig(strategyName, payload) {
        return this.strategiesApi.updateStrategyConfig(strategyName, payload);
    }
    async updateStrategyDbConfig(strategyName, payload) {
        return this.strategiesApi.updateStrategyDbConfig(strategyName, payload);
    }
    // --- Admin Log Management ---
    async listLogFiles() {
        return this.logsApi.listLogFiles();
    }
    async getLoggingSettings() {
        return this.logsApi.getLoggingSettings();
    }
    async setDebugLogging(enabled) {
        return this.logsApi.setDebugLogging(enabled);
    }
    async getTradingRuntimeSettings() {
        return this.systemApi.getTradingRuntimeSettings();
    }
    async updateTradingRuntimeSettings(settings) {
        return this.systemApi.updateTradingRuntimeSettings(settings);
    }
    async getLogFileContent(filename, page = 1, pageSize = 100, level, search, startDate, endDate) {
        return this.logsApi.getLogFileContent(filename, page, pageSize, level, search, startDate, endDate);
    }
    async exportLogFile(filename) {
        return this.logsApi.exportLogFile(filename);
    }
    async configureIBGateway(username, password, mode = 'paper', gatewayId, publicPort, originalGatewayId) {
        return this.systemApi.configureIBGateway(username, password, mode, gatewayId, publicPort, originalGatewayId);
    }
    async deleteIBGatewayConfig(gatewayId) {
        return this.systemApi.deleteIBGatewayConfig(gatewayId);
    }
    async activateIBGateway(gatewayId) {
        return this.systemApi.activateIBGateway(gatewayId);
    }
    // --- Manual Orders ---
    async placeOrder(order) {
        return this.ordersApi.placeOrder(order);
    }
    async lookupOrderContracts(params) {
        return this.ordersApi.lookupOrderContracts(params);
    }
    async getBacktestStrategies() {
        return this.backtestsApi.getStrategies();
    }
    async getNQMMBacktestUniverse() {
        return this.backtestsApi.getNQMMUniverse();
    }
    async getLatestTradingDay() {
        return this.dataApi.getLatestTradingDay();
    }
    async getBacktestProgress() {
        return this.backtestsApi.getProgress();
    }
    async cancelBacktest() {
        return this.backtestsApi.cancel();
    }
    async runBacktest(config, onQueued, onProgress) {
        return this.backtestsApi.run(config, onQueued, onProgress);
    }
    async checkBacktestCache(config) {
        return this.dataApi.checkBacktestCache(config);
    }
    async getMarketDataInventory(filters = {}, pagination = {}) {
        return this.dataApi.getMarketDataInventory(filters, pagination);
    }
    async deleteMarketDataSeries(params) {
        return this.dataApi.deleteMarketDataSeries(params);
    }
    async getLakeBackupStatus(params) {
        return this.dataApi.getLakeBackupStatus(params);
    }
    async syncMarketDataToLake(params) {
        return this.dataApi.syncMarketDataToLake(params);
    }
    async getMarketDataSeries(filters) {
        return this.dataApi.getMarketDataSeries(filters);
    }
    async getDataDownloadTasks() {
        return this.dataApi.getDataDownloadTasks();
    }
    async getDataDownloadTask(taskId) {
        return this.dataApi.getDataDownloadTask(taskId);
    }
    async createDataDownloadTask(config, idempotencyKey) {
        return this.dataApi.createDataDownloadTask(config, idempotencyKey);
    }
    async cancelDataDownloadTask(taskId) {
        return this.dataApi.cancelDataDownloadTask(taskId);
    }
    async getAutomatedDataTasks() {
        return this.dataApi.getAutomatedDataTasks();
    }
    async createAutomatedDataTask(task) {
        return this.dataApi.createAutomatedDataTask(task);
    }
    async updateAutomatedDataTask(taskId, updates) {
        return this.dataApi.updateAutomatedDataTask(taskId, updates);
    }
    async deleteAutomatedDataTask(taskId) {
        return this.dataApi.deleteAutomatedDataTask(taskId);
    }
    async runAutomatedDataTask(taskId, idempotencyKey) {
        return this.dataApi.runAutomatedDataTask(taskId, idempotencyKey);
    }
    async getDurableJob(jobId) {
        return this.dataApi.getDurableJob(jobId);
    }
    async cancelDurableJob(jobId) {
        return this.dataApi.cancelDurableJob(jobId);
    }
    async runPortfolioBacktest(config, onQueued) {
        return this.backtestsApi.runPortfolio(config, onQueued);
    }
    async savePortfolioBacktest(result) {
        return this.backtestsApi.savePortfolio(result);
    }
    async runOptimization(config, onQueued, onProgress) {
        return this.backtestsApi.runOptimization(config, onQueued, onProgress);
    }
    async saveBacktest(result) {
        return this.backtestsApi.saveBacktest(result);
    }
    async getBacktestHistory(page = 1, pageSize = 20, startDate, endDate, scope = 'all') {
        return this.backtestsApi.getHistory(page, pageSize, startDate, endDate, scope);
    }
    async getBacktestDetail(id) {
        return this.backtestsApi.getDetail(id);
    }
    async getBacktestShareUsers() {
        return this.backtestsApi.getShareUsers();
    }
    async getBacktestSharing(id) {
        return this.backtestsApi.getSharing(id);
    }
    async updateBacktestSharing(id, shareAll, userIds) {
        return this.backtestsApi.updateSharing(id, shareAll, userIds);
    }
    async extendBacktest(id, config = {}) {
        return this.backtestsApi.extend(id, config);
    }
    async deleteBacktest(id) {
        return this.backtestsApi.delete(id);
    }
    async saveOptimization(result) {
        return this.backtestsApi.saveOptimization(result);
    }
    async getOptimizationHistory(skip = 0, limit = 20) {
        return this.backtestsApi.getOptimizationHistory(skip, limit);
    }
    async getOptimizationDetail(id) {
        return this.backtestsApi.getOptimizationDetail(id);
    }
    async deleteOptimization(id) {
        return this.backtestsApi.deleteOptimization(id);
    }
    // --- Managed Accounts ---
    async getManagedAccounts() {
        return this.managedAccountsApi.getManagedAccounts();
    }
    async addManagedAccount(managedUserId) {
        return this.managedAccountsApi.addManagedAccount(managedUserId);
    }
    async removeManagedAccount(managedUserId) {
        return this.managedAccountsApi.removeManagedAccount(managedUserId);
    }
    async switchToManagedAccount(managedUserId) {
        return this.managedAccountsApi.switchToManagedAccount(managedUserId);
    }
    async switchBackToOwnAccount() {
        return this.managedAccountsApi.switchBackToOwnAccount();
    }
    async getCurrentContext() {
        return this.authApi.getCurrentContext();
    }
    // --- Admin: Managed Accounts for Any User ---
    async adminGetUserManagers(userId) {
        return this.userAdministrationApi.adminGetUserManagers(userId);
    }
    async adminAddUserManager(userId, managerUserId) {
        return this.userAdministrationApi.adminAddUserManager(userId, managerUserId);
    }
    async adminRemoveUserManager(userId, managerUserId) {
        return this.userAdministrationApi.adminRemoveUserManager(userId, managerUserId);
    }
    // --- Notifications ---
    async getNotifications(limit = 50, unreadOnly = false) {
        return this.notificationsApi.getNotifications(limit, unreadOnly);
    }
    async getUnreadCount() {
        return this.notificationsApi.getUnreadCount();
    }
    async markNotificationRead(id) {
        return this.notificationsApi.markNotificationRead(id);
    }
    async markAllRead() {
        return this.notificationsApi.markAllRead();
    }
    async updateNotificationPreferences(prefs) {
        return this.notificationsApi.updateNotificationPreferences(prefs);
    }
    // --- Portfolio History ---
    async getPortfolioHistory(skip = 0, limit = 100) {
        return this.backtestsApi.getPortfolioHistory(skip, limit);
    }
    async deletePortfolio(id) {
        return this.backtestsApi.deletePortfolio(id);
    }
    async getPortfolioById(id) {
        return this.backtestsApi.getPortfolioById(id);
    }
}
const $488bc2deb3b9875a$export$9fce83b5ea9fffcd = new $488bc2deb3b9875a$var$TradingApiService();
var $488bc2deb3b9875a$export$2e2bcd8739ae039 = $488bc2deb3b9875a$var$TradingApiService;

});
parcelRegister("eDW2g", function(module, exports) {

$parcel$export(module.exports, "ApiError", () => $b5c19a706a62adb8$export$f2e832acab1bdd79);
$parcel$export(module.exports, "API_BASE_URL", () => $b5c19a706a62adb8$export$c3ee1e672e1e24e7);
$parcel$export(module.exports, "apiRequest", () => $b5c19a706a62adb8$export$52e83573e7782585);
$parcel$export(module.exports, "apiRequestBlob", () => $b5c19a706a62adb8$export$25b5a7454673d50b);
class $b5c19a706a62adb8$export$f2e832acab1bdd79 extends Error {
    constructor(message, statusCode, endpoint, response, code = 'HTTP_ERROR', requestId, details = []){
        super(message);
        this.name = 'ApiError';
        this.statusCode = statusCode;
        this.endpoint = endpoint;
        this.response = response;
        this.code = code;
        this.requestId = requestId;
        this.details = details;
    }
}
const $b5c19a706a62adb8$export$fc80ab207c069933 = ()=>{
    if (typeof window !== 'undefined') {
        if (window.location.port === '3001') return 'http://localhost:8001/api/v1';
        return '/api/v1';
    }
    return 'http://localhost:8000/api/v1';
};
const $b5c19a706a62adb8$export$c3ee1e672e1e24e7 = $b5c19a706a62adb8$export$fc80ab207c069933();
const $b5c19a706a62adb8$var$RETRYABLE_STATUS_CODES = new Set([
    502,
    503,
    504
]);
const $b5c19a706a62adb8$var$isIdempotentRequest = (method)=>[
        'GET',
        'HEAD',
        'OPTIONS'
    ].includes((method || 'GET').toUpperCase());
const $b5c19a706a62adb8$var$isTransientError = (error)=>error instanceof $b5c19a706a62adb8$export$f2e832acab1bdd79 && ($b5c19a706a62adb8$var$RETRYABLE_STATUS_CODES.has(error.statusCode) || error.code === 'TIMEOUT') || error instanceof TypeError;
const $b5c19a706a62adb8$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $b5c19a706a62adb8$var$getStoredToken = ()=>{
    try {
        return typeof localStorage === 'undefined' ? null : localStorage.getItem('token');
    } catch  {
        return null;
    }
};
const $b5c19a706a62adb8$var$createRequestId = ()=>{
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
    return `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};
const $b5c19a706a62adb8$var$normalizeFieldErrors = (value)=>{
    if (!Array.isArray(value)) return [];
    return value.flatMap((item)=>{
        if (!item || typeof item !== 'object') return [];
        const record = item;
        const location = Array.isArray(record.location) ? record.location : Array.isArray(record.loc) ? record.loc : [];
        const message = typeof record.message === 'string' ? record.message : typeof record.msg === 'string' ? record.msg : 'Invalid value';
        const code = typeof record.code === 'string' ? record.code : typeof record.type === 'string' ? record.type : undefined;
        return [
            {
                location: location.filter((part)=>typeof part === 'string' || typeof part === 'number'),
                message: message,
                code: code
            }
        ];
    });
};
const $b5c19a706a62adb8$var$errorFromResponse = async (response, endpoint)=>{
    const bodyText = await response.text();
    let body = {};
    try {
        const parsed = JSON.parse(bodyText);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) body = parsed;
    } catch  {
    // Some proxies return plain text or HTML while the API is restarting.
    }
    const detail = body.detail;
    const detailRecord = detail && typeof detail === 'object' && !Array.isArray(detail) ? detail : undefined;
    const candidates = [
        body.message,
        detailRecord?.message,
        detail,
        body.error
    ];
    const message = candidates.find((candidate)=>typeof candidate === 'string' && candidate.length > 0) || (response.status >= 502 ? `System unavailable (${response.status}); the service may be restarting.` : `API request failed: ${response.status} ${response.statusText}`);
    const details = $b5c19a706a62adb8$var$normalizeFieldErrors(body.details ?? (Array.isArray(detail) ? detail : []));
    const code = typeof body.code === 'string' ? body.code : response.status === 422 ? 'VALIDATION_ERROR' : `HTTP_${response.status}`;
    const requestId = typeof body.request_id === 'string' ? body.request_id : response.headers.get('X-Request-ID') || undefined;
    return new $b5c19a706a62adb8$export$f2e832acab1bdd79(message, response.status, endpoint, bodyText || body, code, requestId, details);
};
const $b5c19a706a62adb8$var$handleUnauthorized = (error)=>{
    if (error.statusCode !== 401 || error.endpoint.includes('/auth/token')) return;
    try {
        if (typeof localStorage !== 'undefined') localStorage.removeItem('token');
    } catch  {
    // Storage can be disabled by browser privacy settings.
    }
    if (typeof window !== 'undefined' && window.location.pathname !== '/login') window.location.href = '/login';
};
const $b5c19a706a62adb8$var$requestResponse = async (endpoint, options = {})=>{
    const { timeoutMs: timeoutMs, signal: signal, retries: retries, ...requestOptions } = options;
    const headers = new Headers(requestOptions.headers || {});
    const token = $b5c19a706a62adb8$var$getStoredToken();
    if (token && !headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
    if (!headers.has('X-Request-ID')) headers.set('X-Request-ID', $b5c19a706a62adb8$var$createRequestId());
    if (!headers.has('Accept')) headers.set('Accept', 'application/json');
    const maxAttempts = $b5c19a706a62adb8$var$isIdempotentRequest(requestOptions.method) ? Math.max(1, retries ?? 3) : 1;
    let lastError;
    for(let attempt = 1; attempt <= maxAttempts; attempt += 1){
        let timeoutId;
        let controller;
        let abortListener;
        if (timeoutMs && timeoutMs > 0) {
            controller = new AbortController();
            timeoutId = setTimeout(()=>controller?.abort(), timeoutMs);
            if (signal) {
                if (signal.aborted) controller.abort();
                else {
                    abortListener = ()=>controller?.abort();
                    signal.addEventListener('abort', abortListener, {
                        once: true
                    });
                }
            }
        }
        try {
            const response = await fetch(endpoint, {
                ...requestOptions,
                headers: headers,
                signal: controller?.signal ?? signal
            });
            if (!response.ok) throw await $b5c19a706a62adb8$var$errorFromResponse(response, endpoint);
            return response;
        } catch (error) {
            let finalError = error;
            if (error instanceof DOMException && error.name === 'AbortError' && controller?.signal.aborted && !signal?.aborted) finalError = new $b5c19a706a62adb8$export$f2e832acab1bdd79(`Request timed out after ${timeoutMs}ms`, 0, endpoint, undefined, 'TIMEOUT');
            lastError = finalError;
            if (attempt >= maxAttempts || !$b5c19a706a62adb8$var$isTransientError(finalError) || signal?.aborted) {
                if (finalError instanceof $b5c19a706a62adb8$export$f2e832acab1bdd79) $b5c19a706a62adb8$var$handleUnauthorized(finalError);
                throw finalError;
            }
            await $b5c19a706a62adb8$var$delay(250 * attempt);
        } finally{
            if (timeoutId) clearTimeout(timeoutId);
            if (signal && abortListener) signal.removeEventListener('abort', abortListener);
        }
    }
    throw lastError;
};
const $b5c19a706a62adb8$export$52e83573e7782585 = async (endpoint, options = {})=>{
    const response = await $b5c19a706a62adb8$var$requestResponse(endpoint, options);
    if (response.status === 204) return undefined;
    try {
        return await response.json();
    } catch  {
        throw new $b5c19a706a62adb8$export$f2e832acab1bdd79('The server returned an invalid JSON response.', response.status, endpoint, undefined, 'INVALID_RESPONSE');
    }
};
const $b5c19a706a62adb8$export$25b5a7454673d50b = async (endpoint, options = {})=>(await $b5c19a706a62adb8$var$requestResponse(endpoint, options)).blob();

});

parcelRegister("iBebR", function(module, exports) {

$parcel$export(module.exports, "AccountsApiService", () => $61148aa834ac56d2$export$53a5929dfc0786d0);

var $eDW2g = parcelRequire("eDW2g");
class $61148aa834ac56d2$export$53a5929dfc0786d0 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    getPortfolio() {
        return this.request(`${this.baseUrl}/account/portfolio`, {
            timeoutMs: 15000,
            retries: 1
        });
    }
    getPositions() {
        return this.request(`${this.baseUrl}/account/positions`, {
            timeoutMs: 15000,
            retries: 1
        });
    }
    getStrategyDescriptionTags() {
        return this.request(`${this.baseUrl}/account/strategy-tags`, {
            timeoutMs: 8000,
            retries: 1
        });
    }
    createStrategyDescriptionTag(payload) {
        return this.request(`${this.baseUrl}/account/strategy-tags`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }
    updateStrategyDescriptionTag(tagId, payload) {
        return this.request(`${this.baseUrl}/account/strategy-tags/${tagId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }
    deleteStrategyDescriptionTag(tagId) {
        return this.request(`${this.baseUrl}/account/strategy-tags/${tagId}`, {
            method: 'DELETE'
        });
    }
    updatePositionStrategyTags(positionKey, tagIds) {
        return this.request(`${this.baseUrl}/account/position-tags`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                position_key: positionKey,
                tag_ids: tagIds
            })
        });
    }
    updatePositionCustomStrategy(positionKey, strategyName) {
        return this.request(`${this.baseUrl}/account/position-strategy-name`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                position_key: positionKey,
                strategy_name: strategyName
            })
        });
    }
    updatePositionMetadata(positionKey, strategyName, tagIds) {
        return this.request(`${this.baseUrl}/account/position-metadata`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                position_key: positionKey,
                strategy_name: strategyName,
                tag_ids: tagIds
            })
        });
    }
    closePosition(symbol, secType, contract) {
        let endpoint = `${this.baseUrl}/account/positions/${encodeURIComponent(symbol)}/close`;
        const params = new URLSearchParams();
        if (secType) params.set('sec_type', secType);
        if (contract?.con_id !== undefined && contract.con_id !== null) params.set('con_id', String(contract.con_id));
        if (contract?.exchange) params.set('exchange', contract.exchange);
        if (contract?.currency) params.set('currency', contract.currency);
        if (contract?.local_symbol) params.set('local_symbol', contract.local_symbol);
        if (contract?.trading_class) params.set('trading_class', contract.trading_class);
        if (contract?.last_trade_date_or_contract_month) params.set('last_trade_date_or_contract_month', contract.last_trade_date_or_contract_month);
        if (contract?.multiplier) params.set('multiplier', contract.multiplier);
        const query = params.toString();
        if (query) endpoint += `?${query}`;
        return this.request(endpoint, {
            method: 'POST'
        });
    }
}

});

parcelRegister("1D6KC", function(module, exports) {

$parcel$export(module.exports, "AuthApiService", () => $183a95ccd0be2026$export$c3a67766b2b8b815);

var $eDW2g = parcelRequire("eDW2g");
class $183a95ccd0be2026$export$c3a67766b2b8b815 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    async login(username, password) {
        const formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);
        return this.request(`${this.baseUrl}/auth/token`, {
            method: 'POST',
            body: formData
        });
    }
    async signup(email, password, role = 'trader', firstName, lastName, isCompany, companyName) {
        return this.request(`${this.baseUrl}/auth/signup`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: email,
                password: password,
                role: role,
                first_name: firstName,
                last_name: lastName,
                is_company: isCompany,
                company_name: companyName
            })
        });
    }
    getRegistrationStatus() {
        return this.request(`${this.baseUrl}/auth/registration-status`);
    }
    getCurrentUser(signal) {
        return this.request(`${this.baseUrl}/auth/me`, {
            timeoutMs: 8000,
            retries: 1,
            signal: signal
        });
    }
    getCurrentContext() {
        return this.request(`${this.baseUrl}/auth/me/context`, {
            timeoutMs: 2500
        });
    }
    joinWaitlist(email, firstName, lastName) {
        return this.request(`${this.baseUrl}/auth/waitlist`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                first_name: firstName,
                last_name: lastName
            })
        });
    }
    sendInvite(userId) {
        return this.request(`${this.baseUrl}/auth/invite`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                user_id: userId
            })
        });
    }
    activateUser(userId) {
        return this.request(`${this.baseUrl}/auth/users/${userId}/activate`, {
            method: 'POST'
        });
    }
    verifyInvite(token) {
        return this.request(`${this.baseUrl}/auth/verify-invite/${token}`);
    }
    setupAccount(token, password) {
        return this.request(`${this.baseUrl}/auth/setup-account`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token,
                password: password
            })
        });
    }
}

});

parcelRegister("fESFA", function(module, exports) {

$parcel$export(module.exports, "BacktestsApiService", () => $c12d425732870c03$export$213a8fe88a865ad4);

var $eDW2g = parcelRequire("eDW2g");
class $c12d425732870c03$export$213a8fe88a865ad4 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    async submitDurableRun(endpoint, config, onQueued, onProgress) {
        const headers = new Headers({
            'Content-Type': 'application/json'
        });
        headers.set('Idempotency-Key', typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `backtest-${Date.now()}-${Math.random().toString(36).slice(2)}`);
        const response = await this.request(endpoint, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(config)
        });
        if (!response.data?.id) throw new Error('Backtest job response did not include a job ID');
        onQueued?.(response.data.id);
        onProgress?.(response.data);
        let snapshot = response.data;
        while(snapshot.status === 'queued' || snapshot.status === 'running' || snapshot.status === 'cancelling'){
            snapshot = await this.getDurableJob(snapshot.id);
            onProgress?.(snapshot);
            if (snapshot.status === 'queued' || snapshot.status === 'running' || snapshot.status === 'cancelling') await new Promise((resolve)=>setTimeout(resolve, 1000));
        }
        if (snapshot.status === 'completed') {
            if (!snapshot.result) throw new Error('Completed backtest job did not include a result');
            return snapshot.result;
        }
        throw new Error(snapshot.error || snapshot.message || `Backtest job ${snapshot.status}`);
    }
    async getDurableJob(jobId) {
        const response = await this.request(`${this.baseUrl}/backtest/jobs/${encodeURIComponent(jobId)}`);
        if (!response.data) throw new Error('Job status response did not include job data');
        return response.data;
    }
    getStrategies() {
        return this.request(`${this.baseUrl}/backtest/strategies`);
    }
    getNQMMUniverse() {
        return this.request(`${this.baseUrl}/backtest/nqmm/universe`);
    }
    getProgress() {
        return this.request(`${this.baseUrl}/backtest/progress`);
    }
    cancel() {
        return this.request(`${this.baseUrl}/backtest/cancel`, {
            method: 'POST'
        });
    }
    run(config, onQueued, onProgress) {
        return this.submitDurableRun(`${this.baseUrl}/backtest/run`, config, onQueued, onProgress);
    }
    runPortfolio(config, onQueued) {
        return this.submitDurableRun(`${this.baseUrl}/backtest/portfolio/run`, config, onQueued);
    }
    savePortfolio(result) {
        return this.request(`${this.baseUrl}/backtest/portfolio/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(result)
        });
    }
    runOptimization(config, onQueued, onProgress) {
        return this.submitDurableRun(`${this.baseUrl}/backtest/optimize`, config, onQueued, onProgress);
    }
    saveBacktest(result) {
        return this.request(`${this.baseUrl}/backtest/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(result)
        });
    }
    getHistory(page = 1, pageSize = 20, startDate, endDate, scope = 'all') {
        const params = new URLSearchParams({
            skip: String((page - 1) * pageSize),
            limit: String(pageSize)
        });
        if (startDate) params.set('start_date', startDate);
        if (endDate) params.set('end_date', endDate);
        if (scope !== 'all') params.set('scope', scope);
        return this.request(`${this.baseUrl}/backtest/history?${params.toString()}`);
    }
    getDetail(id) {
        return this.request(`${this.baseUrl}/backtest/history/${id}`);
    }
    getShareUsers() {
        return this.request(`${this.baseUrl}/backtest/sharing/users`);
    }
    getSharing(id) {
        return this.request(`${this.baseUrl}/backtest/history/${id}/sharing`);
    }
    updateSharing(id, shareAll, userIds) {
        return this.request(`${this.baseUrl}/backtest/history/${id}/sharing`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                share_all: shareAll,
                user_ids: userIds
            })
        });
    }
    extend(id, config = {}) {
        return this.request(`${this.baseUrl}/backtest/history/${id}/extend`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
        });
    }
    delete(id) {
        return this.request(`${this.baseUrl}/backtest/history/${id}`, {
            method: 'DELETE'
        });
    }
    saveOptimization(result) {
        return this.request(`${this.baseUrl}/backtest/optimization/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(result)
        });
    }
    getOptimizationHistory(skip = 0, limit = 20) {
        const params = new URLSearchParams({
            skip: String(skip),
            limit: String(limit)
        });
        return this.request(`${this.baseUrl}/backtest/optimization/history?${params.toString()}`);
    }
    getOptimizationDetail(id) {
        return this.request(`${this.baseUrl}/backtest/optimization/${id}`);
    }
    deleteOptimization(id) {
        return this.request(`${this.baseUrl}/backtest/optimization/${id}`, {
            method: 'DELETE'
        });
    }
    getPortfolioHistory(skip = 0, limit = 100) {
        const params = new URLSearchParams({
            skip: String(skip),
            limit: String(limit)
        });
        return this.request(`${this.baseUrl}/backtest/portfolio/history?${params.toString()}`);
    }
    deletePortfolio(id) {
        return this.request(`${this.baseUrl}/backtest/portfolio/${id}`, {
            method: 'DELETE'
        });
    }
    getPortfolioById(id) {
        return this.request(`${this.baseUrl}/backtest/portfolio/${id}`);
    }
}

});

parcelRegister("6qqCz", function(module, exports) {

$parcel$export(module.exports, "DataApiService", () => $b55ca08cb76da724$export$45563efabe4a6e08);

var $eDW2g = parcelRequire("eDW2g");
const $b55ca08cb76da724$var$normalizeAutomatedTaskSymbols = (symbols)=>{
    if (Array.isArray(symbols)) return symbols;
    return (symbols || '').split(/[\s,]+/).map((symbol)=>symbol.trim().toUpperCase()).filter(Boolean);
};
const $b55ca08cb76da724$var$normalizeAutomatedTaskDays = (scheduleDays)=>{
    if (Array.isArray(scheduleDays)) return scheduleDays;
    const normalized = (scheduleDays || '').trim().toUpperCase();
    if (normalized === 'MON-FRI') return [
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI'
    ];
    if (normalized === 'ALL') return [
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI',
        'SAT',
        'SUN'
    ];
    return normalized.split(/[\s,]+/).filter(Boolean);
};
const $b55ca08cb76da724$var$automatedTaskPayload = (task)=>{
    const payload = {
        ...task
    };
    if ('symbols' in task && task.symbols) payload.symbols = task.symbols.join(', ');
    if ('schedule_days' in task && task.schedule_days) {
        const days = task.schedule_days;
        const weekdays = [
            'MON',
            'TUE',
            'WED',
            'THU',
            'FRI'
        ];
        payload.schedule_days = days.length === 5 && weekdays.every((day)=>days.includes(day)) ? 'mon-fri' : days.length === 7 && days.every((day)=>[
                'MON',
                'TUE',
                'WED',
                'THU',
                'FRI',
                'SAT',
                'SUN'
            ].includes(day)) ? 'all' : days.join(',');
    }
    return payload;
};
const $b55ca08cb76da724$var$createDataDownloadIdempotencyKey = ()=>{
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
    return `download-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};
const $b55ca08cb76da724$var$normalizeAutomatedTask = (task)=>{
    const normalizedTask = task && typeof task === 'object' ? task : {};
    return {
        ...normalizedTask,
        symbols: $b55ca08cb76da724$var$normalizeAutomatedTaskSymbols(normalizedTask.symbols),
        schedule_days: $b55ca08cb76da724$var$normalizeAutomatedTaskDays(normalizedTask.schedule_days)
    };
};
const $b55ca08cb76da724$var$automatedTaskData = (data)=>data && 'task' in data ? data.task : data;
class $b55ca08cb76da724$export$45563efabe4a6e08 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    getLatestTradingDay() {
        return this.request(`${this.baseUrl}/backtest/data/latest-trading-day`);
    }
    async checkBacktestCache(config) {
        return this.request(`${this.baseUrl}/backtest/cache/check`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
        });
    }
    async getMarketDataInventory(filters = {}, pagination = {}) {
        const params = new URLSearchParams();
        if (filters.symbol) params.set('symbol', filters.symbol);
        if (filters.timeframe) params.set('timeframe', filters.timeframe);
        if (filters.sec_type) params.set('sec_type', filters.sec_type);
        if (filters.data_source) params.set('data_source', filters.data_source);
        if (filters.storage) params.set('storage', filters.storage);
        if (filters.data_type) params.set('data_type', filters.data_type);
        if (pagination.skip !== undefined) params.set('skip', String(pagination.skip));
        if (pagination.limit !== undefined) params.set('limit', String(pagination.limit));
        const query = params.toString();
        const endpoint = `${this.baseUrl}/backtest/data/inventory${query ? `?${query}` : ''}`;
        const response = await this.request(endpoint);
        if (!response.data) throw new Error('Market-data inventory response did not include data');
        return response.data;
    }
    deleteMarketDataSeries(params) {
        const searchParams = new URLSearchParams();
        searchParams.set('symbol', params.symbol);
        searchParams.set('timeframe', params.timeframe);
        if (params.sec_type) searchParams.set('sec_type', params.sec_type);
        if (params.data_source) searchParams.set('data_source', params.data_source);
        if (params.multiplier) searchParams.set('multiplier', String(params.multiplier));
        if (params.data_type) searchParams.set('data_type', params.data_type);
        const endpoint = `${this.baseUrl}/backtest/data/series?${searchParams.toString()}`;
        return this.request(endpoint, {
            method: 'DELETE'
        });
    }
    async getLakeBackupStatus(params) {
        const searchParams = this.marketDataIdentityParams(params);
        const response = await this.request(`${this.baseUrl}/backtest/data/lake-status?${searchParams.toString()}`);
        return response;
    }
    async syncMarketDataToLake(params) {
        const searchParams = this.marketDataIdentityParams(params);
        const response = await this.request(`${this.baseUrl}/backtest/data/sync?${searchParams.toString()}`, {
            method: 'POST'
        });
        return response;
    }
    async getMarketDataSeries(filters) {
        const params = new URLSearchParams();
        params.set('symbol', filters.symbol);
        params.set('timeframe', filters.timeframe);
        if (filters.sec_type) params.set('sec_type', filters.sec_type);
        if (filters.data_source) params.set('data_source', filters.data_source);
        if (filters.storage) params.set('storage', filters.storage);
        if (filters.data_type) params.set('data_type', filters.data_type);
        if (filters.multiplier) params.set('multiplier', String(filters.multiplier));
        if (filters.start_date) params.set('start_date', filters.start_date);
        if (filters.end_date) params.set('end_date', filters.end_date);
        if (filters.limit) params.set('limit', String(filters.limit));
        if (filters.offset !== undefined) params.set('offset', String(filters.offset));
        if (filters.sort_by) params.set('sort_by', filters.sort_by);
        if (filters.sort_dir) params.set('sort_dir', filters.sort_dir);
        if (filters.min_price !== undefined) params.set('min_price', String(filters.min_price));
        if (filters.max_price !== undefined) params.set('max_price', String(filters.max_price));
        if (filters.min_volume !== undefined) params.set('min_volume', String(filters.min_volume));
        const response = await this.request(`${this.baseUrl}/backtest/data/series?${params.toString()}`);
        if (!response.data) throw new Error('Market-data series response did not include data');
        return response.data;
    }
    async getDataDownloadTasks() {
        const response = await this.request(`${this.baseUrl}/backtest/data/tasks`);
        return response.data?.tasks || [];
    }
    async getDataDownloadTask(taskId) {
        const response = await this.request(`${this.baseUrl}/backtest/data/tasks/${encodeURIComponent(taskId)}`);
        if (!response.data) throw new Error('Download task response did not include task data');
        return response.data;
    }
    async createDataDownloadTask(config, idempotencyKey) {
        const headers = new Headers({
            'Content-Type': 'application/json'
        });
        headers.set('Idempotency-Key', idempotencyKey || $b55ca08cb76da724$var$createDataDownloadIdempotencyKey());
        const response = await this.request(`${this.baseUrl}/backtest/data/download`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(config)
        });
        if (!response.data) throw new Error('Download task response did not include task data');
        return response.data;
    }
    cancelDataDownloadTask(taskId) {
        return this.request(`${this.baseUrl}/backtest/data/tasks/${taskId}/cancel`, {
            method: 'POST'
        });
    }
    async getAutomatedDataTasks() {
        const response = await this.request(`${this.baseUrl}/backtest/data/automated-tasks`);
        return (response.data?.tasks || []).map($b55ca08cb76da724$var$normalizeAutomatedTask);
    }
    async createAutomatedDataTask(task) {
        const response = await this.request(`${this.baseUrl}/backtest/data/automated-tasks`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify($b55ca08cb76da724$var$automatedTaskPayload(task))
        });
        const taskRecord = $b55ca08cb76da724$var$automatedTaskData(response.data);
        if (!taskRecord) throw new Error('Automated-task response did not include task data');
        return $b55ca08cb76da724$var$normalizeAutomatedTask(taskRecord);
    }
    async updateAutomatedDataTask(taskId, updates) {
        const response = await this.request(`${this.baseUrl}/backtest/data/automated-tasks/${taskId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify($b55ca08cb76da724$var$automatedTaskPayload(updates))
        });
        const taskRecord = $b55ca08cb76da724$var$automatedTaskData(response.data);
        if (!taskRecord) throw new Error('Automated-task response did not include task data');
        return $b55ca08cb76da724$var$normalizeAutomatedTask(taskRecord);
    }
    deleteAutomatedDataTask(taskId) {
        return this.request(`${this.baseUrl}/backtest/data/automated-tasks/${taskId}`, {
            method: 'DELETE'
        });
    }
    runAutomatedDataTask(taskId, idempotencyKey) {
        const headers = new Headers();
        headers.set('Idempotency-Key', idempotencyKey || $b55ca08cb76da724$var$createDataDownloadIdempotencyKey());
        return this.request(`${this.baseUrl}/backtest/data/automated-tasks/${taskId}/run`, {
            method: 'POST',
            headers: headers
        });
    }
    async getDurableJob(jobId) {
        const response = await this.request(`${this.baseUrl}/backtest/jobs/${encodeURIComponent(jobId)}`);
        if (!response.data) throw new Error('Job status response did not include job data');
        return response.data;
    }
    async cancelDurableJob(jobId) {
        const response = await this.request(`${this.baseUrl}/backtest/jobs/${encodeURIComponent(jobId)}/cancel`, {
            method: 'POST'
        });
        if (!response.data) throw new Error('Job cancellation response did not include job data');
        return response.data;
    }
    marketDataIdentityParams(params) {
        const searchParams = new URLSearchParams();
        searchParams.set('symbol', params.symbol);
        searchParams.set('timeframe', params.timeframe);
        if (params.sec_type) searchParams.set('sec_type', params.sec_type);
        if (params.data_source) searchParams.set('data_source', params.data_source);
        if (params.multiplier) searchParams.set('multiplier', String(params.multiplier));
        if (params.data_type) searchParams.set('data_type', params.data_type);
        return searchParams;
    }
}

});

parcelRegister("g6W1K", function(module, exports) {

$parcel$export(module.exports, "LogsApiService", () => $57d6482e07dc357d$export$7ffe167bded84da5);

var $eDW2g = parcelRequire("eDW2g");
function $57d6482e07dc357d$var$securityEventQuery(filters) {
    const params = new URLSearchParams();
    if (filters.startAt) params.set('start_at', filters.startAt);
    if (filters.endAt) params.set('end_at', filters.endAt);
    if (filters.eventType) params.set('event_type', filters.eventType);
    if (filters.outcome) params.set('outcome', filters.outcome);
    if (filters.sourceIp) params.set('source_ip', filters.sourceIp);
    if (filters.actorUserId) params.set('actor_user_id', String(filters.actorUserId));
    if (filters.subjectUserId) params.set('subject_user_id', String(filters.subjectUserId));
    return params;
}
class $57d6482e07dc357d$export$7ffe167bded84da5 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    getTradeLogs(page = 1, pageSize = 50, filters = {}) {
        const params = new URLSearchParams({
            page: String(page),
            page_size: String(pageSize)
        });
        if (filters.symbol) params.set('symbol', filters.symbol);
        if (filters.strategy) params.set('strategy', filters.strategy);
        if (filters.startDate) params.set('start_date', filters.startDate);
        if (filters.endDate) params.set('end_date', filters.endDate);
        filters.decisionIds?.forEach((decisionId)=>params.append('decision_ids', decisionId));
        return this.request(`${this.baseUrl}/trades/logs?${params.toString()}`);
    }
    getRecentLogs(maxLines = 100, levelFilter, logFile = 'all') {
        const params = new URLSearchParams({
            max_lines: String(maxLines),
            log_file: logFile
        });
        if (levelFilter) params.set('level_filter', levelFilter);
        return this.request(`${this.baseUrl}/logs/recent?${params.toString()}`);
    }
    listLogFiles() {
        return this.request(`${this.baseUrl}/admin/logs/files`);
    }
    getSecurityEvents(filters = {}) {
        const params = new URLSearchParams({
            page: String(filters.page ?? 1),
            page_size: String(filters.pageSize ?? 50)
        });
        $57d6482e07dc357d$var$securityEventQuery(filters).forEach((value, key)=>params.set(key, value));
        return this.request(`${this.baseUrl}/admin/security-events?${params.toString()}`);
    }
    exportSecurityEvents(filters = {}) {
        const params = $57d6482e07dc357d$var$securityEventQuery(filters);
        params.set('format', 'csv');
        return (0, $eDW2g.apiRequestBlob)(`${this.baseUrl}/admin/security-events?${params.toString()}`);
    }
    getSecurityAlertSettings() {
        return this.request(`${this.baseUrl}/admin/security-alert-settings`);
    }
    updateSecurityAlertSettings(settings) {
        return this.request(`${this.baseUrl}/admin/security-alert-settings`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(settings)
        });
    }
    getLoggingSettings() {
        return this.request(`${this.baseUrl}/admin/settings/logging`);
    }
    setDebugLogging(enabled) {
        return this.request(`${this.baseUrl}/admin/settings/logging/debug`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                enabled: enabled
            })
        });
    }
    getLogFileContent(filename, page = 1, pageSize = 100, level, search, startDate, endDate) {
        const params = new URLSearchParams({
            filename: filename,
            page: String(page),
            page_size: String(pageSize)
        });
        if (level && level !== 'ALL') params.set('level', level);
        if (search) params.set('search', search);
        if (startDate) params.set('start_date', startDate);
        if (endDate) params.set('end_date', endDate);
        return this.request(`${this.baseUrl}/admin/logs/content?${params.toString()}`);
    }
    exportLogFile(filename) {
        const params = new URLSearchParams({
            filename: filename
        });
        return (0, $eDW2g.apiRequestBlob)(`${this.baseUrl}/admin/logs/export?${params.toString()}`);
    }
}

});

parcelRegister("1BzxW", function(module, exports) {

$parcel$export(module.exports, "ManagedAccountsApiService", () => $28bafcfe15629ab7$export$7319e3a4f3371493);

var $eDW2g = parcelRequire("eDW2g");
class $28bafcfe15629ab7$export$7319e3a4f3371493 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    getManagedAccounts() {
        return this.request(`${this.baseUrl}/managers/accounts`);
    }
    addManagedAccount(managedUserId) {
        return this.request(`${this.baseUrl}/managers/accounts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                managed_user_id: managedUserId
            })
        });
    }
    removeManagedAccount(managedUserId) {
        return this.request(`${this.baseUrl}/managers/accounts/${managedUserId}`, {
            method: 'DELETE'
        });
    }
    switchToManagedAccount(managedUserId) {
        return this.request(`${this.baseUrl}/managers/switch/${managedUserId}`, {
            method: 'POST'
        });
    }
    switchBackToOwnAccount() {
        return this.request(`${this.baseUrl}/managers/switch-back`, {
            method: 'POST'
        });
    }
}

});

parcelRegister("9RTqT", function(module, exports) {

$parcel$export(module.exports, "MarketApiService", () => $62c64b55ecef66c4$export$96b2f7f1f218d585);

var $eDW2g = parcelRequire("eDW2g");
class $62c64b55ecef66c4$export$96b2f7f1f218d585 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    getHistoricalData(symbol, timeframe, duration, source = 'auto', signal) {
        const params = new URLSearchParams({
            timeframe: timeframe,
            duration: duration,
            source: source
        });
        const endpoint = `${this.baseUrl}/market/history/${encodeURIComponent(symbol)}?${params.toString()}`;
        return this.request(endpoint, {
            timeoutMs: 20000,
            retries: 1,
            signal: signal
        });
    }
    getMarketStatus() {
        return this.request(`${this.baseUrl}/market/status`, {
            timeoutMs: 8000,
            retries: 1
        });
    }
    getQuotes(symbols) {
        const endpoint = `${this.baseUrl}/market/quotes?symbols=${encodeURIComponent(symbols.join(','))}`;
        return this.request(endpoint);
    }
    getContractQuote(contract) {
        return this.request(`${this.baseUrl}/market/quote`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(contract)
        });
    }
}

});

parcelRegister("4XlMV", function(module, exports) {

$parcel$export(module.exports, "NotificationsApiService", () => $bd16f5509f85724a$export$9e61bcd14f6a5469);

var $eDW2g = parcelRequire("eDW2g");
class $bd16f5509f85724a$export$9e61bcd14f6a5469 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    getNotifications(limit = 50, unreadOnly = false) {
        return this.request(`${this.baseUrl}/notifications?limit=${limit}&unread_only=${unreadOnly}`);
    }
    getUnreadCount() {
        return this.request(`${this.baseUrl}/notifications/unread-count`, {
            timeoutMs: 2000
        });
    }
    markNotificationRead(id) {
        return this.request(`${this.baseUrl}/notifications/${id}/read`, {
            method: 'POST'
        });
    }
    markAllRead() {
        return this.request(`${this.baseUrl}/notifications/read-all`, {
            method: 'POST'
        });
    }
    updateNotificationPreferences(preferences) {
        return this.request(`${this.baseUrl}/auth/me/preferences`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(preferences)
        });
    }
}

});

parcelRegister("bGHkr", function(module, exports) {

$parcel$export(module.exports, "OrdersApiService", () => $ef3c800fce8c4be4$export$42a2dbcefd7505b5);

var $eDW2g = parcelRequire("eDW2g");
class $ef3c800fce8c4be4$export$42a2dbcefd7505b5 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    getOpenOrders(page = 1, pageSize = 5, secType) {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('page_size', pageSize.toString());
        if (secType && secType !== 'ALL') params.append('sec_type', secType);
        return this.request(`${this.baseUrl}/account/orders?${params.toString()}`, {
            timeoutMs: 6000,
            retries: 1
        });
    }
    getFilledOrdersToday(page = 1, pageSize = 5, secType) {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('page_size', pageSize.toString());
        if (secType && secType !== 'ALL') params.append('sec_type', secType);
        return this.request(`${this.baseUrl}/account/orders/filled?${params.toString()}`, {
            timeoutMs: 6000,
            retries: 1
        });
    }
    cancelOrder(orderId) {
        return this.request(`${this.baseUrl}/account/orders/${orderId}/cancel`, {
            method: 'POST'
        });
    }
    modifyOrder(orderId, order) {
        return this.request(`${this.baseUrl}/orders/${orderId}/modify`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(order)
        });
    }
    async placeOrder(order) {
        try {
            return await this.request(`${this.baseUrl}/orders`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(order)
            });
        } catch (err) {
            // Re-throw with just the message to prevent stack trace issues.
            throw new Error(err instanceof Error ? err.message : 'Order placement failed');
        }
    }
    lookupOrderContracts(params) {
        const searchParams = new URLSearchParams();
        searchParams.set('symbol', params.symbol);
        searchParams.set('sec_type', params.sec_type || 'FUT');
        if (params.exchange) searchParams.set('exchange', params.exchange);
        return this.request(`${this.baseUrl}/orders/lookup?${searchParams.toString()}`, {
            timeoutMs: 15000,
            retries: 0
        });
    }
}

});

parcelRegister("6N9Dd", function(module, exports) {

$parcel$export(module.exports, "StrategiesApiService", () => $35be49e9c62e494f$export$880b2e655b46b5e7);

var $eDW2g = parcelRequire("eDW2g");
class $35be49e9c62e494f$export$880b2e655b46b5e7 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    getStrategyStatus() {
        return this.request(`${this.baseUrl}/strategy/on/status`);
    }
    getONStrategyStatus() {
        return this.request(`${this.baseUrl}/strategy/on/status`);
    }
    getONPositions() {
        return this.request(`${this.baseUrl}/strategy/on/positions`);
    }
    getORBStrategyStatus() {
        return this.request(`${this.baseUrl}/strategy/orb/status`);
    }
    getORBPositions() {
        return this.request(`${this.baseUrl}/strategy/orb/positions`);
    }
    getAllStrategiesStatus() {
        return this.request(`${this.baseUrl}/strategy/overview`);
    }
    getTradingSignal(symbol) {
        return this.request(`${this.baseUrl}/strategy/on/signals/${symbol}`);
    }
    getMarketAnalysis(symbol) {
        return this.request(`${this.baseUrl}/strategy/on/analysis/${symbol}`);
    }
    getStrategyStatusByName(strategyName) {
        return this.request(`${this.baseUrl}/strategy/status/${strategyName}`);
    }
    getNQMMStrategyStatus() {
        return this.request(`${this.baseUrl}/strategy/nqmm/status`);
    }
    getNQMMPositions() {
        return this.request(`${this.baseUrl}/strategy/nqmm/positions`);
    }
    getNQMMPreviousPositions() {
        return this.request(`${this.baseUrl}/strategy/nqmm/previous-positions`);
    }
    addNQMMPreviousPosition(position) {
        return this.request(`${this.baseUrl}/strategy/nqmm/previous-positions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(position)
        });
    }
    deleteNQMMPreviousPosition(symbol) {
        return this.request(`${this.baseUrl}/strategy/nqmm/previous-positions/${encodeURIComponent(symbol)}`, {
            method: 'DELETE'
        });
    }
    getStrategyDbConfig(strategyName) {
        return this.request(`${this.baseUrl}/strategy/config/${strategyName}`);
    }
    getStrategyDbConfigHistory(strategyName) {
        return this.request(`${this.baseUrl}/strategy/config/${strategyName}/history`);
    }
    getStrategySignals(filters) {
        const query = new URLSearchParams();
        if (filters.strategy) query.append('strategy', filters.strategy);
        if (filters.symbol) query.append('symbol', filters.symbol);
        if (filters.start_date) query.append('start_date', filters.start_date);
        if (filters.end_date) query.append('end_date', filters.end_date);
        if (filters.page) query.append('page', filters.page.toString());
        if (filters.limit) query.append('limit', filters.limit.toString());
        return this.request(`${this.baseUrl}/strategy/signals?${query.toString()}`);
    }
    resetStrategyDbConfig(strategyName) {
        return this.request(`${this.baseUrl}/strategy/config/${strategyName}/reset`, {
            method: 'POST'
        });
    }
    updateStrategyConfig(strategyName, payload) {
        return this.request(`${this.baseUrl}/strategy/config/${strategyName}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }
    updateStrategyDbConfig(strategyName, payload) {
        return this.request(`${this.baseUrl}/strategy/config/${strategyName}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
    }
}

});

parcelRegister("6dP1v", function(module, exports) {

$parcel$export(module.exports, "SystemApiService", () => $a8ab9444c25e4959$export$bbffa564d5e69446);

var $eDW2g = parcelRequire("eDW2g");
class $a8ab9444c25e4959$export$bbffa564d5e69446 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    getSystemStatus() {
        return this.request(`${this.baseUrl}/system/status`);
    }
    getSystemControlState() {
        return this.request(`${this.baseUrl}/system/control`, {
            timeoutMs: 15000
        });
    }
    setSystemEnabled(enabled) {
        return this.request(`${this.baseUrl}/system/enable`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(enabled)
        });
    }
    setStrategyEnabled(strategyName, enabled) {
        return this.request(`${this.baseUrl}/system/strategy/${encodeURIComponent(strategyName)}/enable`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(enabled)
        });
    }
    emergencyLiquidate() {
        return this.request(`${this.baseUrl}/system/liquidate`, {
            method: 'POST'
        });
    }
    resetEmergencyMode() {
        return this.request(`${this.baseUrl}/system/emergency/reset`, {
            method: 'POST'
        });
    }
    connectIB() {
        return this.request(`${this.baseUrl}/system/ib/connect`, {
            method: 'POST'
        });
    }
    disconnectIB() {
        return this.request(`${this.baseUrl}/system/ib/disconnect`, {
            method: 'POST'
        });
    }
    controlIBGateway(action, gatewayId) {
        const params = new URLSearchParams();
        if (gatewayId) params.set('gateway_id', gatewayId);
        const query = params.toString();
        const endpoint = `${this.baseUrl}/system/ib/gateway/${action}${query ? `?${query}` : ''}`;
        return this.request(endpoint, {
            method: 'POST'
        });
    }
    getTradingRuntimeSettings() {
        return this.request(`${this.baseUrl}/admin/settings/trading`);
    }
    updateTradingRuntimeSettings(settings) {
        return this.request(`${this.baseUrl}/admin/settings/trading`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(settings)
        });
    }
    configureIBGateway(username, password, mode = 'paper', gatewayId, publicPort, originalGatewayId) {
        return this.request(`${this.baseUrl}/system/ib/configure`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: username,
                password: password,
                mode: mode,
                gateway_id: gatewayId,
                public_port: publicPort,
                original_gateway_id: originalGatewayId
            })
        });
    }
    deleteIBGatewayConfig(gatewayId) {
        const params = new URLSearchParams({
            gateway_id: gatewayId
        });
        return this.request(`${this.baseUrl}/system/ib/configure?${params.toString()}`, {
            method: 'DELETE'
        });
    }
    activateIBGateway(gatewayId) {
        return this.request(`${this.baseUrl}/system/ib/activate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                gateway_id: gatewayId
            })
        });
    }
}

});

parcelRegister("l26Xf", function(module, exports) {

$parcel$export(module.exports, "UserAdministrationApiService", () => $5d5e0fe4fa4ba6ee$export$2ad4fc3877b7f376);

var $eDW2g = parcelRequire("eDW2g");
class $5d5e0fe4fa4ba6ee$export$2ad4fc3877b7f376 {
    constructor(baseUrl = (0, $eDW2g.API_BASE_URL)){
        this.baseUrl = baseUrl;
    }
    request(endpoint, options = {}) {
        return (0, $eDW2g.apiRequest)(endpoint, options);
    }
    getUsers() {
        return this.request(`${this.baseUrl}/auth/users`);
    }
    adminCreateUser(user) {
        return this.request(`${this.baseUrl}/auth/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(user)
        });
    }
    adminUpdateUser(userId, user) {
        return this.request(`${this.baseUrl}/auth/users/${userId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(user)
        });
    }
    deleteUser(userId) {
        return this.request(`${this.baseUrl}/auth/users/${userId}`, {
            method: 'DELETE'
        });
    }
    getUserDetails(userId) {
        return this.request(`${this.baseUrl}/admin/users/${userId}/details`);
    }
    adminConfigureUserGateway(userId, config) {
        return this.request(`${this.baseUrl}/admin/users/${userId}/gateways`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
        });
    }
    adminControlUserGateway(userId, gatewayId, action) {
        const encodedGatewayId = encodeURIComponent(gatewayId);
        return this.request(`${this.baseUrl}/admin/users/${userId}/gateways/${encodedGatewayId}/control/${action}`, {
            method: 'POST'
        });
    }
    adminActivateUserGateway(userId, gatewayId) {
        const encodedGatewayId = encodeURIComponent(gatewayId);
        return this.request(`${this.baseUrl}/admin/users/${userId}/gateways/${encodedGatewayId}/activate`, {
            method: 'POST'
        });
    }
    adminDeleteUserGateway(userId, gatewayId) {
        const encodedGatewayId = encodeURIComponent(gatewayId);
        return this.request(`${this.baseUrl}/admin/users/${userId}/gateways/${encodedGatewayId}`, {
            method: 'DELETE'
        });
    }
    adminGetUserManagers(userId) {
        return this.request(`${this.baseUrl}/admin/users/${userId}/managers`);
    }
    adminAddUserManager(userId, managerUserId) {
        return this.request(`${this.baseUrl}/admin/users/${userId}/managers`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                manager_user_id: managerUserId
            })
        });
    }
    adminRemoveUserManager(userId, managerUserId) {
        return this.request(`${this.baseUrl}/admin/users/${userId}/managers/${managerUserId}`, {
            method: 'DELETE'
        });
    }
}

});



parcelRegister("2Kpom", function(module, exports) {

$parcel$export(module.exports, "default", () => $200392fae49ddb7e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $200392fae49ddb7e$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Clock", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16 14",
            key: "68esgv"
        }
    ]
]);

});
parcelRegister("b4WUK", function(module, exports) {

$parcel$export(module.exports, "default", () => $810dc495bedb1cb1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");

var $iP6U9 = parcelRequire("iP6U9");

var $i5vAT = parcelRequire("i5vAT");
const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $i5vAT.default), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $iP6U9.mergeClasses)(`lucide-${(0, $iP6U9.toKebabCase)(iconName)}`, className),
            ...props
        }));
    Component.displayName = `${iconName}`;
    return Component;
};

});
parcelRegister("iP6U9", function(module, exports) {

$parcel$export(module.exports, "toKebabCase", () => $db42588f972bc829$export$73bda83cddbc7187);
$parcel$export(module.exports, "mergeClasses", () => $db42588f972bc829$export$3d46f4579dba46e5);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();

});

parcelRegister("i5vAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2b1338ec3fa0df8$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");

var $8Iopr = parcelRequire("8Iopr");

var $iP6U9 = parcelRequire("iP6U9");
const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $8Iopr.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $iP6U9.mergeClasses)("lucide", className),
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});

});
parcelRegister("8Iopr", function(module, exports) {

$parcel$export(module.exports, "default", () => $65855df5fc59b2ec$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

});




parcelRegister("7o8DG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c50e6fb9be7cd366$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $gtsgu = parcelRequire("gtsgu");

var $2wVnk = parcelRequire("2wVnk");
const $c50e6fb9be7cd366$var$SystemControlButton = ({ controlState: controlState, onRefresh: onRefresh, className: className, onError: onError, variant: variant = 'compact', iconSize: iconSizeProp })=>{
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const buttonsTheme = (0, $acw62.useMemo)(()=>({
            // Base styles common to all variants (colors, borders, transitions)
            base: "rounded-xl font-semibold transition-all duration-200 border",
            // Layout styles for Compact (Grid) view
            compact: "col-span-1 w-full px-3 py-3 flex flex-col items-center justify-center gap-1.5 text-xs sm:text-sm",
            // Layout styles for Slim (Row) view
            slim: "flex items-center justify-center gap-1.5 rounded-lg",
            start: "bg-emerald-500/15 text-emerald-400 hover:bg-emerald-500/25 border-emerald-500/20 shadow-sm",
            stop: "bg-rose-500/15 text-rose-400 hover:bg-rose-500/25 border-rose-500/20 shadow-sm",
            unavailable: "bg-white/5 text-muted border-white/10 shadow-none"
        }), []);
    const handleSystemToggle = async ()=>{
        if (!controlState) return;
        setLoading(true);
        try {
            const response = await (0, $2wVnk.tradingApi).setSystemEnabled(!controlState.system_enabled);
            if (response.success) await onRefresh();
            else onError(response.message || "Failed to update system state");
        } catch (err) {
            onError(err instanceof Error ? err.message : "Failed to update system state");
        } finally{
            setLoading(false);
        }
    };
    if (!controlState) return null;
    const layoutClass = variant === 'compact' ? buttonsTheme.compact : buttonsTheme.slim;
    const isConnected = controlState.ib_connected;
    const colorClass = !isConnected ? buttonsTheme.unavailable : controlState.system_enabled ? buttonsTheme.stop : buttonsTheme.start;
    const actionLabel = !isConnected ? "Connect first" : controlState.system_enabled ? "Stop Trading" : "Start Trading";
    const iconSize = iconSizeProp ?? (variant === 'slim' ? 16 : 18);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        onClick: handleSystemToggle,
        disabled: loading || !isConnected,
        className: `${buttonsTheme.base} ${layoutClass} ${colorClass} ${className || ''} ${!isConnected ? 'opacity-50 cursor-not-allowed grayscale' : ''}`,
        title: !isConnected ? "Connect the broker before changing trading state" : controlState.system_enabled ? "Stop new trading activity" : "Start trading activity",
        "aria-label": actionLabel,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtsgu.default), {
                size: iconSize
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: variant === 'slim' ? 'min-w-0 truncate leading-none font-bold' : '',
                children: actionLabel
            })
        ]
    });
};
var $c50e6fb9be7cd366$export$2e2bcd8739ae039 = $c50e6fb9be7cd366$var$SystemControlButton;

});
parcelRegister("gtsgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe54799d1557409$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $bfe54799d1557409$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Power", [
    [
        "path",
        {
            d: "M12 2v10",
            key: "mnfbl"
        }
    ],
    [
        "path",
        {
            d: "M18.4 6.6a9 9 0 1 1-12.77.04",
            key: "obofu9"
        }
    ]
]);

});


parcelRegister("2jex3", function(module, exports) {

$parcel$export(module.exports, "default", () => $90fbc6d25011b2ad$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4Yp7M = parcelRequire("4Yp7M");
var $dkOIy = parcelRequire("dkOIy");
var $iIubC = parcelRequire("iIubC");
var $lsK68 = parcelRequire("lsK68");

var $2wVnk = parcelRequire("2wVnk");
const $90fbc6d25011b2ad$var$GatewayControlButton = ({ controlState: controlState, onRefresh: onRefresh, onConfigureNeeded: onConfigureNeeded, className: className, onError: onError, variant: variant = 'compact', gatewayId: gatewayId, iconSize: iconSizeProp })=>{
    const [loadingAction, setLoadingAction] = (0, $acw62.useState)(null);
    const abortControllerRef = (0, $acw62.useRef)(null);
    const [pendingHint, setPendingHint] = (0, $acw62.useState)(null);
    const hintTimerRef = (0, $acw62.useRef)(null);
    const isFatalConnectionError = (msg)=>{
        if (!msg) return false;
        const lower = msg.toLowerCase();
        return lower.includes("invalid credential") || lower.includes("trading mode mismatch") || lower.includes("returned exit status") || lower.includes("failed to decrypt") || lower.includes("fatal");
    };
    // Keep local hint in sync with control state (e.g., from periodic refreshes)
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // Show hint if gateway is in a pending state (not connected but has hint)
        if (controlState?.gateway_hint && !controlState.ib_connected && controlState.gateway_running) setPendingHint(controlState.gateway_hint);
        // Clear hint if connected or gateway is not running (stopped or not set)
        if (controlState?.ib_connected || !controlState?.gateway_running) setPendingHint(null);
    }, [
        controlState?.gateway_hint,
        controlState?.ib_connected,
        controlState?.gateway_running
    ]);
    const buttonsTheme = (0, $acw62.useMemo)(()=>({
            // Base styles common to all variants (colors, borders, transitions)
            base: "rounded-xl font-semibold transition-all duration-200 border",
            // Layout styles for Compact (Grid) view
            compact: "col-span-1 w-full px-3 py-3 flex flex-col items-center justify-center gap-1.5 text-xs sm:text-sm",
            // Layout styles for Slim (Row) view
            slim: "flex items-center justify-center gap-1.5 rounded-lg",
            start: "bg-emerald-500/15 text-emerald-400 hover:bg-emerald-500/25 border-emerald-500/20 shadow-sm",
            stop: "bg-rose-500/15 text-rose-400 hover:bg-rose-500/25 border-rose-500/20 shadow-sm",
            loading: "bg-warning-500/15 text-warning-400 hover:bg-warning-500/25 border-warning-500/20 shadow-[0_0_15px_rgba(245,158,11,0.05)] cursor-wait"
        }), []);
    const handleGatewayControl = async (action)=>{
        if (!controlState) return;
        const isLiveMode = controlState.ib_mode === 'live';
        // Smart Start Logic: Check if configured before starting
        // If specific gatewayId is provided, we assume it's configured (or we can't check easily without iterating saved_gateways)
        if (action === "start" && !gatewayId && !controlState.gateway_configured) {
            onConfigureNeeded();
            return;
        }
        // Cancel any previous pending request
        if (abortControllerRef.current) abortControllerRef.current.abort();
        const controller = new AbortController();
        abortControllerRef.current = controller;
        setPendingHint(null);
        setLoadingAction(action);
        try {
            const response = await (0, $2wVnk.tradingApi).controlIBGateway(action, gatewayId);
            if (response.success) {
                if (action === "start") {
                    // Show a generic reminder after a short delay in live mode
                    if (isLiveMode && !controlState.ib_connected) {
                        // Show immediately so the user sees it even if backend retries/DNS take time
                        setPendingHint("Gateway is starting. Approve IB Key on your phone if prompted.");
                        if (hintTimerRef.current) clearTimeout(hintTimerRef.current);
                        hintTimerRef.current = setTimeout(()=>{
                            setPendingHint((current)=>current || "Gateway is starting. Approve IB Key on your phone if prompted.");
                        }, 5000);
                    }
                    // Poll for connection status
                    let attempts = 0;
                    const baseMaxAttempts = 30; // 30 seconds timeout
                    let maxAttempts = baseMaxAttempts;
                    let lastConnectionError = null;
                    while(attempts < maxAttempts && abortControllerRef.current === controller){
                        await onRefresh();
                        // We need to check the fresh state, but onRefresh updates the parent's state.
                        // We can't easily access the *new* prop value here immediately inside the loop 
                        // because of closure staleness, unless we trust onRefresh to update the prop 
                        // and we rely on the re-render? No, re-render won't update 'controlState' in this scope.
                        // We need to fetch the state directly or wait for the parent to update.
                        // Better: Fetch state directly here to check.
                        try {
                            const status = await (0, $2wVnk.tradingApi).getSystemControlState();
                            const statusData = status.data;
                            // Update hint state from backend (e.g. 2FA)
                            if (status.success && statusData?.gateway_hint) {
                                setPendingHint(statusData.gateway_hint);
                                // Extend wait window if user action is pending
                                maxAttempts = Math.max(maxAttempts, 180);
                            }
                            // Check for explicit errors from the backend (e.g. invalid credentials)
                            if (status.success && statusData?.connection_error) {
                                lastConnectionError = statusData.connection_error;
                                if (isFatalConnectionError(statusData.connection_error)) {
                                    onError(statusData.connection_error);
                                    // Stop the gateway to clean up
                                    await (0, $2wVnk.tradingApi).controlIBGateway("stop");
                                    break;
                                } else {
                                    // Treat as transient (DNS/startup). Keep waiting but extend window.
                                    setPendingHint(statusData.connection_error);
                                    maxAttempts = Math.max(maxAttempts, 180);
                                }
                            }
                            if (status.success && statusData?.ib_connected) {
                                setPendingHint(null);
                                break;
                            }
                        } catch (e) {
                            console.warn("Failed to poll status", e);
                        }
                        await new Promise((resolve)=>setTimeout(resolve, 1000));
                        attempts++;
                    }
                    if (attempts >= maxAttempts) {
                        if (pendingHint || lastConnectionError) onError(pendingHint || lastConnectionError || "Gateway is waiting for approval/startup. Please check the gateway and IB Key.");
                        else onError("Gateway start is taking longer than expected. Check gateway container status.");
                    }
                    // Final refresh to update UI
                    await onRefresh();
                } else {
                    // For stop, clear hint and refresh
                    setPendingHint(null);
                    await onRefresh();
                }
            } else onError(response.message || `Failed to ${action} gateway`);
        } catch (err) {
            if (err.name === 'AbortError') console.log('Gateway control action cancelled');
            else onError(err instanceof Error ? err.message : `Failed to ${action} gateway`);
        } finally{
            if (abortControllerRef.current === controller) {
                setLoadingAction(null);
                abortControllerRef.current = null;
            }
            if (hintTimerRef.current) {
                clearTimeout(hintTimerRef.current);
                hintTimerRef.current = null;
            }
        }
    };
    const handleCancel = async (e)=>{
        e.stopPropagation();
        const wasStarting = !controlState?.ib_connected;
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
        setLoadingAction(null);
        if (wasStarting) try {
            // Explicitly stop the gateway to ensure cleanup
            await (0, $2wVnk.tradingApi).controlIBGateway("stop", gatewayId);
            await onRefresh();
        } catch (err) {
            console.warn("Failed to stop gateway during cancellation", err);
        }
    };
    if (!controlState) return null;
    const isConnecting = controlState.gateway_hint_code === "connecting";
    const showLoading = loadingAction !== null || isConnecting;
    // Determine gateway active state: prefer gateway_running (container status), fall back to ib_connected
    const isGatewayActive = controlState.gateway_running ?? controlState.ib_connected;
    const layoutClass = variant === 'compact' ? buttonsTheme.compact : buttonsTheme.slim;
    const colorClass = showLoading ? buttonsTheme.loading : isGatewayActive ? buttonsTheme.stop : buttonsTheme.start;
    const isConfigured = controlState.gateway_configured;
    const actionLabel = isGatewayActive ? "Disconnect" : isConfigured ? "Connect" : "Set up broker";
    const iconSize = iconSizeProp ?? (variant === 'slim' ? 16 : 18);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        onClick: ()=>{
            if (showLoading) return;
            handleGatewayControl(isGatewayActive ? "stop" : "start");
        },
        disabled: loadingAction === 'stop',
        className: `${buttonsTheme.base} ${layoutClass} ${colorClass} ${className || ''} relative group disabled:opacity-50 disabled:cursor-not-allowed`,
        title: !isConfigured && !isGatewayActive ? "Set up the broker connection" : isGatewayActive ? "Disconnect the broker gateway" : "Connect to the broker gateway",
        "aria-label": showLoading ? loadingAction === 'stop' ? "Disconnecting from broker" : "Connecting to broker" : actionLabel,
        children: showLoading ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                    size: iconSize,
                    className: "animate-spin"
                }),
                variant === 'slim' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-1 leading-none",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: loadingAction === 'stop' ? "Disconnecting..." : "Connecting..."
                        }),
                        loadingAction !== 'stop' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: handleCancel,
                            className: "text-[9px] text-red-400 hover:text-red-300 underline cursor-pointer ml-1 z-10",
                            children: "(Cancel)"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col items-center leading-none",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: loadingAction === 'stop' ? "Disconnecting..." : loadingAction === 'start' || isConnecting ? "Connecting..." : isGatewayActive ? "Disconnecting..." : "Connecting..."
                        }),
                        loadingAction !== 'stop' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: handleCancel,
                            className: "text-[10px] text-red-400 hover:text-red-300 underline cursor-pointer mt-1 z-10",
                            children: "Cancel"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                !isGatewayActive && !isConfigured ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIubC.default), {
                    size: iconSize
                }) : isGatewayActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsK68.default), {
                    size: iconSize
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dkOIy.default), {
                    size: iconSize
                }),
                variant === 'slim' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "min-w-0 truncate leading-none font-bold",
                    children: actionLabel
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col items-center leading-none",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: isGatewayActive ? "Disconnect" : "Connect to Broker"
                        }),
                        isConfigured && controlState.ib_username && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-[10px] opacity-70 font-normal mt-0.5",
                            children: controlState.ib_username
                        })
                    ]
                })
            ]
        })
    });
};
var $90fbc6d25011b2ad$export$2e2bcd8739ae039 = $90fbc6d25011b2ad$var$GatewayControlButton;

});
parcelRegister("4Yp7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $39f04136db3724b2$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $39f04136db3724b2$export$2e2bcd8739ae039 = (0, $b4WUK.default)("LoaderCircle", [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
]);

});

parcelRegister("dkOIy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b547c0f28739ad4$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $9b547c0f28739ad4$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Play", [
    [
        "polygon",
        {
            points: "6 3 20 12 6 21 6 3",
            key: "1oa8hb"
        }
    ]
]);

});

parcelRegister("iIubC", function(module, exports) {

$parcel$export(module.exports, "default", () => $da03c070d837b197$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $da03c070d837b197$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Settings", [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
]);

});

parcelRegister("lsK68", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9fff898e98b336e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $f9fff898e98b336e$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Square", [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ]
]);

});


parcelRegister("kvv04", function(module, exports) {

$parcel$export(module.exports, "ThemeButton", () => $94357977ecfdea2e$export$91a69db4fc637fd9);
$parcel$export(module.exports, "ThemeToggleButton", () => $94357977ecfdea2e$export$b07618a3a4968298);
$parcel$export(module.exports, "ThemeToggleGroup", () => $94357977ecfdea2e$export$4df28b030a62b86b);
$parcel$export(module.exports, "ThemeTabBar", () => $94357977ecfdea2e$export$8c530cde4853e0b9);
$parcel$export(module.exports, "ThemeSwitch", () => $94357977ecfdea2e$export$720d52add0a18b65);
$parcel$export(module.exports, "ThemeBadge", () => $94357977ecfdea2e$export$160e8347e058d687);
$parcel$export(module.exports, "ThemeAlert", () => $94357977ecfdea2e$export$796e1518ffe69e9b);
$parcel$export(module.exports, "ThemeInput", () => $94357977ecfdea2e$export$14eb500dc537d5b3);
$parcel$export(module.exports, "ThemeSelect", () => $94357977ecfdea2e$export$1b9e02e625a724dc);
$parcel$export(module.exports, "ThemePagination", () => $94357977ecfdea2e$export$3afa71aeff4a8f3b);
$parcel$export(module.exports, "ThemePaginationFooter", () => $94357977ecfdea2e$export$ce9c832269f3ae45);
$parcel$export(module.exports, "themeTableClasses", () => (parcelRequire("alUHf")).themeTableClasses);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $gKB5x = parcelRequire("gKB5x");
var $aqBpg = parcelRequire("aqBpg");

var $alUHf = parcelRequire("alUHf");
const $94357977ecfdea2e$export$91a69db4fc637fd9 = ({ variant: variant = 'ghost', size: size = 'sm', icon: icon, iconOnly: iconOnly = false, children: children, className: className = '', type: type = 'button', ...props })=>{
    const tone = {
        primary: 'border-neon bg-neon text-surface hover:bg-primary-600',
        secondary: 'border-neon/25 bg-neon/10 text-neon hover:bg-neon/20',
        ghost: 'border-white/[0.08] bg-white/[0.025] text-muted hover:bg-white/[0.06] hover:text-foreground',
        danger: `${(0, $alUHf.themeToneClasses).danger} hover:bg-error-500/20`,
        success: `${(0, $alUHf.themeToneClasses).success} hover:bg-success-500/20`
    }[variant];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        ...props,
        type: type,
        className: `${(0, $alUHf.themeButtonBase)} ${(0, $alUHf.themeControlDimensions)(size, iconOnly)} ${tone} ${className}`,
        children: [
            icon,
            iconOnly ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "sr-only",
                children: children
            }) : children
        ]
    });
};
const $94357977ecfdea2e$export$b07618a3a4968298 = ({ label: label, selected: selected, segment: segment, size: size = 'sm', icon: icon, iconOnly: iconOnly = false, children: children, className: className = '', title: title, type: type = 'button', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        ...props,
        type: type,
        "aria-label": label,
        "aria-pressed": selected,
        title: title ?? label,
        className: `${(0, $alUHf.getThemeToggleClassName)(selected, size, segment, iconOnly)} ${className}`,
        children: [
            icon,
            iconOnly ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "sr-only",
                children: children ?? label
            }) : children ?? label
        ]
    });
const $94357977ecfdea2e$export$4df28b030a62b86b = ({ className: className = '', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "group",
        ...props,
        className: `inline-flex items-center rounded-md bg-transparent shadow-[inset_0_0_0_0.5px_rgba(255,255,255,0.08)] ${className}`
    });
const $94357977ecfdea2e$export$8c530cde4853e0b9 = ({ className: className = '', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "group",
        ...props,
        className: `flex flex-wrap gap-2 border-b border-white/10 bg-surface px-4 py-2 ${className}`
    });
const $94357977ecfdea2e$export$720d52add0a18b65 = ({ label: label, checked: checked, onCheckedChange: onCheckedChange, size: size = 'small', disabled: disabled, className: className = '', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        ...props,
        type: "button",
        role: "switch",
        "aria-label": label,
        "aria-checked": checked,
        disabled: disabled,
        onClick: ()=>onCheckedChange(!checked),
        className: `relative shrink-0 rounded-full border-[0.5px] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon/60 disabled:cursor-not-allowed disabled:opacity-40 ${size === 'small' ? 'h-5 w-9' : 'h-6 w-11'} ${checked ? 'border-neon/30 bg-neon/25' : 'border-white/[0.08] bg-white/5'} ${className}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            "aria-hidden": "true",
            className: `absolute left-0.5 top-1/2 -translate-y-1/2 rounded-full transition-transform ${size === 'small' ? 'h-3.5 w-3.5' : 'h-4 w-4'} ${checked ? `${size === 'small' ? 'translate-x-[1.125rem]' : 'translate-x-6'} bg-neon` : 'translate-x-0 bg-white/45'}`
        })
    });
const $94357977ecfdea2e$export$160e8347e058d687 = ({ tone: tone = 'neutral', icon: icon, children: children, className: className = '', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        ...props,
        className: `inline-flex items-center gap-1.5 rounded-full border-[0.5px] px-2.5 py-1 text-[10px] font-semibold ${(0, $alUHf.themeToneClasses)[tone]} ${className}`,
        children: [
            icon,
            children
        ]
    });
const $94357977ecfdea2e$export$796e1518ffe69e9b = ({ tone: tone = 'info', icon: icon, children: children, className: className = '', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        role: tone === 'danger' ? 'alert' : 'status',
        ...props,
        className: `flex items-start gap-2 rounded-lg border-[0.5px] p-3 text-xs ${(0, $alUHf.themeToneClasses)[tone]} ${className}`,
        children: [
            icon,
            children
        ]
    });
const $94357977ecfdea2e$var$inputClass = 'rounded-lg border-[0.5px] border-white/10 bg-surface text-foreground leading-none placeholder:text-muted focus:outline-none focus:border-neon/50 disabled:cursor-not-allowed disabled:opacity-40';
const $94357977ecfdea2e$export$14eb500dc537d5b3 = ({ controlSize: controlSize = 'sm', className: className = '', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("input", {
        ...props,
        className: `${(0, $alUHf.themeControlDimensions)(controlSize)} ${$94357977ecfdea2e$var$inputClass} ${className}`
    });
const $94357977ecfdea2e$export$1b9e02e625a724dc = ({ controlSize: controlSize = 'sm', className: className = '', ...props })=>/*#__PURE__*/ (0, $ayMG0.jsx)("select", {
        ...props,
        className: `${(0, $alUHf.themeControlDimensions)(controlSize)} pr-8 ${$94357977ecfdea2e$var$inputClass} ${className}`
    });
const $94357977ecfdea2e$export$3afa71aeff4a8f3b = ({ label: label = 'Pagination', currentPage: currentPage, totalPages: totalPages, hasNext: hasNext, onPageChange: onPageChange, compact: compact = false, disabled: disabled = false })=>{
    const state = (0, $alUHf.getThemePaginationState)(currentPage, totalPages, hasNext);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
        "aria-label": label,
        className: "flex items-center gap-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($94357977ecfdea2e$export$91a69db4fc637fd9, {
                iconOnly: true,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKB5x.default), {
                    className: "h-3.5 w-3.5"
                }),
                "aria-label": "Previous page",
                title: "Previous page",
                disabled: disabled || !state.canPrevious,
                onClick: ()=>onPageChange(state.page - 1),
                children: "Previous page"
            }),
            compact || state.total === undefined ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "min-w-12 px-1 text-center text-[10px] text-muted",
                "aria-live": "polite",
                children: [
                    state.page,
                    state.total === undefined ? '' : ` / ${state.total}`
                ]
            }) : state.pages.map((page)=>/*#__PURE__*/ (0, $ayMG0.jsx)($94357977ecfdea2e$export$b07618a3a4968298, {
                    label: `Page ${page}`,
                    "aria-current": page === state.page ? 'page' : undefined,
                    selected: page === state.page,
                    disabled: disabled,
                    onClick: ()=>onPageChange(page),
                    children: page
                }, page)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($94357977ecfdea2e$export$91a69db4fc637fd9, {
                iconOnly: true,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aqBpg.default), {
                    className: "h-3.5 w-3.5"
                }),
                "aria-label": "Next page",
                title: "Next page",
                disabled: disabled || !state.canNext,
                onClick: ()=>onPageChange(state.page + 1),
                children: "Next page"
            })
        ]
    });
};
const $94357977ecfdea2e$export$ce9c832269f3ae45 = ({ summary: summary, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mx-5 flex flex-wrap items-center justify-between gap-3 border-t border-white/5 px-4 py-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-xs font-medium text-white/60",
                children: summary
            }),
            children
        ]
    });

});
parcelRegister("gKB5x", function(module, exports) {

$parcel$export(module.exports, "default", () => $c31db635520dc385$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $c31db635520dc385$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ChevronLeft", [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
]);

});

parcelRegister("aqBpg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7979593adeba180b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ChevronRight", [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
]);

});

parcelRegister("alUHf", function(module, exports) {

$parcel$export(module.exports, "themeToneClasses", () => $d357564dcd9e66a4$export$68e61be4563107cf);
$parcel$export(module.exports, "themeToneTextClasses", () => $d357564dcd9e66a4$export$f14fa0b643096c62);
$parcel$export(module.exports, "themeButtonBase", () => $d357564dcd9e66a4$export$20f9a8a6e2d03b3b);
$parcel$export(module.exports, "themeTableClasses", () => $d357564dcd9e66a4$export$a10a27aa955f65fa);
$parcel$export(module.exports, "themeControlDimensions", () => $d357564dcd9e66a4$export$38e02b434fc7483);
$parcel$export(module.exports, "getThemeToggleClassName", () => $d357564dcd9e66a4$export$28ed826f84b20bcc);
$parcel$export(module.exports, "getThemePaginationState", () => $d357564dcd9e66a4$export$ee256d6224abaf3b);
$parcel$export(module.exports, "getLogLevelTone", () => $d357564dcd9e66a4$export$29e8091376238cad);
const $d357564dcd9e66a4$export$68e61be4563107cf = {
    success: 'border-success-500/25 bg-success-50 text-success-500',
    warning: 'border-warning-500/25 bg-warning-50 text-warning-500',
    danger: 'border-error-500/25 bg-error-50 text-error-500',
    info: 'border-info-500/25 bg-info-50 text-info-500',
    neutral: 'border-white/10 bg-white/5 text-muted'
};
const $d357564dcd9e66a4$export$f14fa0b643096c62 = {
    success: 'text-success-500',
    warning: 'text-warning-500',
    danger: 'text-error-500',
    info: 'text-info-500',
    neutral: 'text-muted'
};
const $d357564dcd9e66a4$export$20f9a8a6e2d03b3b = 'inline-flex shrink-0 items-center justify-center gap-1.5 rounded-md border-[0.5px] font-semibold leading-none transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon/60 disabled:cursor-not-allowed disabled:opacity-40';
const $d357564dcd9e66a4$export$a10a27aa955f65fa = {
    table: 'w-full min-w-full border-collapse text-foreground',
    bodyText: 'text-[13px]',
    head: 'bg-white/[0.03] text-[11px] font-semibold text-muted',
    headerCell: 'px-4 py-3 align-middle',
    body: 'divide-y divide-white/5',
    row: 'transition-colors hover:bg-white/[0.03]',
    cell: 'px-4 py-3 align-middle'
};
function $d357564dcd9e66a4$export$38e02b434fc7483(size, iconOnly = false) {
    if (iconOnly) return size === 'xs' ? 'h-7 w-7 px-0 text-[10px] leading-none' : size === 'sm' ? 'h-8 w-8 px-0 text-[11px] leading-none' : size === 'md' ? 'h-9 w-9 px-0 text-xs leading-none' : 'h-11 w-11 px-0 text-sm leading-none';
    return size === 'xs' ? 'h-7 px-2 text-[10px] leading-none' : size === 'sm' ? 'h-8 px-3 text-[11px] leading-none' : size === 'md' ? 'h-9 px-3 text-xs leading-none' : 'h-11 px-4 text-sm leading-none';
}
function $d357564dcd9e66a4$export$28ed826f84b20bcc(selected, size, segment, iconOnly = false) {
    const shape = segment === 'first' ? 'rounded-l-md rounded-r-none' : segment === 'last' ? 'rounded-l-none rounded-r-md' : segment ? 'rounded-none' : '';
    const state = segment ? selected ? 'border-0 bg-neon/15 text-neon' : 'border-0 bg-surface-4 text-muted hover:bg-white/[0.06] hover:text-white' : selected ? 'border-neon/20 bg-neon/15 text-neon' : 'border-white/[0.08] bg-white/[0.025] text-muted hover:border-white/[0.12] hover:bg-white/[0.06] hover:text-white';
    return `${$d357564dcd9e66a4$export$20f9a8a6e2d03b3b} ${$d357564dcd9e66a4$export$38e02b434fc7483(size, iconOnly)}${shape ? ` ${shape}` : ''} ${state}`;
}
function $d357564dcd9e66a4$export$ee256d6224abaf3b(currentPage, totalPages, hasNext = false) {
    const total = totalPages !== undefined && Number.isFinite(totalPages) ? Math.max(1, Math.trunc(totalPages)) : undefined;
    const requested = Number.isFinite(currentPage) ? Math.max(1, Math.trunc(currentPage)) : 1;
    const page = total === undefined ? requested : Math.min(requested, total);
    const start = total === undefined ? page : Math.max(1, Math.min(page - 2, total - 4));
    return {
        page: page,
        total: total,
        canPrevious: page > 1,
        canNext: total === undefined ? hasNext : page < total,
        pages: total === undefined ? [
            page
        ] : Array.from({
            length: Math.min(5, total)
        }, (_, index)=>start + index)
    };
}
function $d357564dcd9e66a4$export$29e8091376238cad(level) {
    if (level === 'WARNING') return 'warning';
    if (level === 'ERROR' || level === 'CRITICAL') return 'danger';
    if (level === 'INFO') return 'info';
    return 'neutral';
}

});


parcelRegister("7dAee", function(module, exports) {

$parcel$export(module.exports, "default", () => $5415d98bde6b29f1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $5415d98bde6b29f1$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CircleAlert", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
]);

});

parcelRegister("jztMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3f86240925e7a9e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $e3f86240925e7a9e$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CircleCheckBig", [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335",
            key: "yps3ct"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
]);

});

parcelRegister("hPAJY", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb3b3013a649f15$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $b4WUK.default)("X", [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
]);

});

parcelRegister("bTepa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a800148d042d893$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $8a800148d042d893$export$2e2bcd8739ae039 = (0, $b4WUK.default)("RefreshCw", [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
]);

});

parcelRegister("di5Ac", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ad14973a512851d$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Search", [
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ],
    [
        "path",
        {
            d: "m21 21-4.3-4.3",
            key: "1qie3q"
        }
    ]
]);

});

parcelRegister("jl3Sp", function(module, exports) {

$parcel$export(module.exports, "CustomSelect", () => (parcelRequire("2zES5")).CustomSelect);
parcelRequire("fSCiq");
var $2zES5 = parcelRequire("2zES5");

});
parcelRegister("fSCiq", function(module, exports) {

$parcel$export(module.exports, "CustomSelect", () => (parcelRequire("2zES5")).CustomSelect);

var $2zES5 = parcelRequire("2zES5");

});
parcelRegister("2zES5", function(module, exports) {

$parcel$export(module.exports, "CustomSelect", () => $350172b9d056ab09$export$90fa2738acf99628);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $alUHf = parcelRequire("alUHf");
const $350172b9d056ab09$export$90fa2738acf99628 = ({ value: value, options: options, onChange: onChange, placeholder: placeholder = 'Select...', disabled: disabled = false, className: className = '', buttonClassName: buttonClassName = '', menuClassName: menuClassName = '', optionClassName: optionClassName = '', align: align = 'left', ariaLabel: ariaLabel, triggerContent: triggerContent, triggerTitle: triggerTitle, hideCaret: hideCaret = false, controlSize: controlSize = 'md' })=>{
    const listboxId = (0, $acw62.useId)();
    const rootRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)(null);
    const selectedOption = (0, $acw62.useMemo)(()=>options.find((option)=>option.value === value), [
        options,
        value
    ]);
    const updateMenuPosition = (0, $acw62.useCallback)(()=>{
        if (!rootRef.current) return;
        const triggerRect = rootRef.current.getBoundingClientRect();
        const menuWidth = menuRef.current?.offsetWidth || triggerRect.width;
        const viewportPadding = 8;
        const spaceBelow = window.innerHeight - triggerRect.bottom - viewportPadding;
        const spaceAbove = triggerRect.top - viewportPadding;
        const placement = spaceBelow < 120 && spaceAbove > spaceBelow ? 'top' : 'bottom';
        const maxHeight = Math.max(96, Math.min(220, placement === 'bottom' ? spaceBelow : spaceAbove));
        const rawLeft = align === 'right' ? triggerRect.right - menuWidth : triggerRect.left;
        const left = Math.max(viewportPadding, Math.min(rawLeft, window.innerWidth - menuWidth - viewportPadding));
        const top = placement === 'bottom' ? triggerRect.bottom - 1 : Math.max(viewportPadding, triggerRect.top - maxHeight + 1);
        const nextPosition = {
            left: left,
            top: top,
            minWidth: triggerRect.width,
            maxHeight: maxHeight,
            placement: placement
        };
        setMenuPosition((current)=>{
            if (current && Math.abs(current.left - nextPosition.left) < 0.5 && Math.abs(current.top - nextPosition.top) < 0.5 && Math.abs(current.minWidth - nextPosition.minWidth) < 0.5 && Math.abs(current.maxHeight - nextPosition.maxHeight) < 0.5 && current.placement === nextPosition.placement) return current;
            return nextPosition;
        });
    }, [
        align
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (!open) {
            setMenuPosition(null);
            return;
        }
        updateMenuPosition();
    }, [
        open,
        updateMenuPosition,
        options.length
    ]);
    const setMenuNode = (0, $acw62.useCallback)((node)=>{
        menuRef.current = node;
        if (node) updateMenuPosition();
    }, [
        updateMenuPosition
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const handlePointerDown = (event)=>{
            const target = event.target;
            if (!rootRef.current?.contains(target) && !menuRef.current?.contains(target)) setOpen(false);
        };
        const handleViewportChange = ()=>updateMenuPosition();
        document.addEventListener('pointerdown', handlePointerDown, true);
        window.addEventListener('resize', handleViewportChange);
        window.addEventListener('scroll', handleViewportChange, true);
        return ()=>{
            document.removeEventListener('pointerdown', handlePointerDown, true);
            window.removeEventListener('resize', handleViewportChange);
            window.removeEventListener('scroll', handleViewportChange, true);
        };
    }, [
        open,
        updateMenuPosition
    ]);
    const selectOption = (option)=>{
        if (option.disabled) return;
        onChange(option.value);
        setOpen(false);
    };
    const moveSelection = (direction)=>{
        const enabledOptions = options.filter((option)=>!option.disabled);
        if (enabledOptions.length === 0) return;
        const currentIndex = enabledOptions.findIndex((option)=>option.value === value);
        const nextIndex = currentIndex === -1 ? 0 : (currentIndex + direction + enabledOptions.length) % enabledOptions.length;
        onChange(enabledOptions[nextIndex].value);
    };
    const menu = open && !disabled && menuPosition ? /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: setMenuNode,
        id: listboxId,
        role: "listbox",
        style: {
            left: menuPosition.left,
            top: menuPosition.top,
            minWidth: menuPosition.minWidth
        },
        className: `fixed z-[9999] bg-[#1a1a2e] border border-white/10 shadow-2xl overflow-hidden backdrop-blur-xl animate-in fade-in slide-in-from-top-1 duration-200 ${menuPosition.placement === 'bottom' ? 'border-t-0 rounded-b-xl' : 'border-b-0 rounded-t-xl'} ${menuClassName}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "py-1 overflow-y-auto ux-scrollbar",
            style: {
                maxHeight: menuPosition.maxHeight
            },
            children: options.map((option)=>{
                const selected = option.value === value;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    type: "button",
                    role: "option",
                    "aria-selected": selected,
                    disabled: option.disabled,
                    onClick: ()=>selectOption(option),
                    className: `w-full px-4 py-2 text-left text-[10px] font-bold text-white/70 hover:text-neon hover:bg-white/5 transition-colors border-b border-white/[0.03] last:border-0 flex items-center justify-between h-8 disabled:opacity-40 disabled:cursor-not-allowed ${optionClassName}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "truncate",
                            children: option.label
                        }),
                        selected && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "w-1 h-1 rounded-full bg-neon shadow-[0_0_8px_rgba(var(--neon-rgb),0.5)]"
                        })
                    ]
                }, option.value);
            })
        })
    }), document.body) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: rootRef,
        className: `relative ${className}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                disabled: disabled,
                "aria-label": ariaLabel,
                title: triggerTitle,
                "aria-haspopup": "listbox",
                "aria-expanded": open,
                "aria-controls": listboxId,
                onClick: ()=>setOpen((current)=>!current),
                onKeyDown: (event)=>{
                    if (event.key === 'Escape') {
                        setOpen(false);
                        return;
                    }
                    if (event.key === 'ArrowDown') {
                        event.preventDefault();
                        if (!open) setOpen(true);
                        moveSelection(1);
                    }
                    if (event.key === 'ArrowUp') {
                        event.preventDefault();
                        if (!open) setOpen(true);
                        moveSelection(-1);
                    }
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        setOpen((current)=>!current);
                    }
                },
                className: `w-full ${(0, $alUHf.themeControlDimensions)(controlSize)} bg-white/[0.03] border border-white/10 text-foreground leading-none text-left flex items-center justify-between focus:border-neon/50 focus:bg-white/[0.05] transition disabled:opacity-50 disabled:cursor-not-allowed ${open ? 'rounded-t-lg border-b-0' : 'rounded-lg'} ${buttonClassName}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "truncate",
                        children: triggerContent ?? selectedOption?.label ?? placeholder
                    }),
                    !hideCaret && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        "aria-hidden": "true",
                        className: `ml-2 w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-t-[4px] transition-transform duration-200 ${open ? 'rotate-180 border-t-neon' : 'border-t-white/40'}`
                    })
                ]
            }),
            menu
        ]
    });
};

});



parcelRegister("b1rqt", function(module, exports) {

$parcel$export(module.exports, "formatCurrency", () => $f94e45ac645ae232$export$3dc27271f5d5c629);
$parcel$export(module.exports, "getCurrencySymbol", () => $f94e45ac645ae232$export$4f7b2ae0c2141b10);
/**
 * Utility for formatting currency values dynamically.
 */ /**
 * Formats a numeric value as currency based on the provided currency code.
 * Falls back to USD if the currency code is invalid or missing.
 */ const $f94e45ac645ae232$export$3dc27271f5d5c629 = (value, currencyCode = 'USD', hideValue = false)=>{
    if (hideValue) return '***';
    if (value === undefined || value === null) return '-';
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode || 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    } catch  {
        // Fallback if currency code is invalid
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }
};
const $f94e45ac645ae232$export$4f7b2ae0c2141b10 = (currencyCode = 'USD')=>{
    switch(currencyCode){
        case 'EUR':
            return "\u20AC";
        case 'GBP':
            return "\xa3";
        case 'JPY':
            return "\xa5";
        default:
            return '$';
    }
};

});

parcelRegister("1fufK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8ea8c31c9fdf2b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $0e8ea8c31c9fdf2b$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Minus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ]
]);

});

parcelRegister("iSlX2", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbde4c3396582d11$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $dbde4c3396582d11$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Plus", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
]);

});

parcelRegister("jtEPT", function(module, exports) {

$parcel$export(module.exports, "tradingApiSlice", () => $d359c264f8aabc92$export$632826e13a29e9c0);
$parcel$export(module.exports, "usePositionsQuery", () => $d359c264f8aabc92$export$7dc1170e859056d5);
$parcel$export(module.exports, "usePortfolioQuery", () => $d359c264f8aabc92$export$25a73db8e658b173);
$parcel$export(module.exports, "useOpenOrdersQuery", () => $d359c264f8aabc92$export$ade3dd8b0ff7c7eb);
$parcel$export(module.exports, "useStrategyStatusQuery", () => $d359c264f8aabc92$export$638cb8dd9792b25b);

var $71qsd = parcelRequire("71qsd");

var $eDW2g = parcelRequire("eDW2g");
const $d359c264f8aabc92$var$apiBaseQuery = async (args, api)=>{
    const request = typeof args === 'string' ? {
        url: args
    } : args;
    const endpoint = `${(0, $eDW2g.API_BASE_URL).replace(/\/$/, '')}/${request.url.replace(/^\/+/, '')}`;
    const headers = new Headers(request.headers);
    let body = request.body;
    if (request.body !== undefined && typeof request.body !== 'string' && !(request.body instanceof FormData) && !(request.body instanceof Blob)) {
        headers.set('Content-Type', 'application/json');
        body = JSON.stringify(request.body);
    }
    try {
        const data = await (0, $eDW2g.apiRequest)(endpoint, {
            method: request.method || 'GET',
            headers: headers,
            body: body,
            signal: api.signal,
            timeoutMs: 15000,
            retries: 1
        });
        return {
            data: data
        };
    } catch (error) {
        if (error instanceof (0, $eDW2g.ApiError)) {
            const data = {
                code: error.code,
                message: error.message,
                request_id: error.requestId,
                details: error.details
            };
            if (error.statusCode === 0) return {
                error: {
                    status: 'CUSTOM_ERROR',
                    error: error.message,
                    data: data
                }
            };
            return {
                error: {
                    status: error.statusCode,
                    data: data
                }
            };
        }
        return {
            error: {
                status: 'FETCH_ERROR',
                error: error instanceof Error ? error.message : String(error)
            }
        };
    }
};
const $d359c264f8aabc92$export$632826e13a29e9c0 = (0, $71qsd.createApi)({
    reducerPath: 'tradingApi',
    refetchOnFocus: true,
    refetchOnReconnect: true,
    // Account endpoints have bounded broker waits and persisted-state fallbacks;
    // keep their previous 15-second budget while sharing auth/error/retry behavior.
    baseQuery: $d359c264f8aabc92$var$apiBaseQuery,
    tagTypes: [
        'Account',
        'Orders',
        'Strategy'
    ],
    endpoints: (builder)=>({
            positions: builder.query({
                query: ()=>'account/positions',
                providesTags: [
                    'Account'
                ]
            }),
            portfolio: builder.query({
                query: ()=>'account/portfolio',
                providesTags: [
                    'Account'
                ]
            }),
            openOrders: builder.query({
                query: ({ page: page = 1, pageSize: pageSize = 100 })=>`account/orders?page=${page}&page_size=${pageSize}`,
                providesTags: [
                    'Orders'
                ]
            }),
            strategyStatus: builder.query({
                query: (name)=>`strategy/status/${name}`,
                providesTags: (_result, _error, name)=>[
                        {
                            type: 'Strategy',
                            id: name
                        }
                    ]
            })
        })
});
const { usePositionsQuery: $d359c264f8aabc92$export$7dc1170e859056d5, usePortfolioQuery: $d359c264f8aabc92$export$25a73db8e658b173, useOpenOrdersQuery: $d359c264f8aabc92$export$ade3dd8b0ff7c7eb, useStrategyStatusQuery: $d359c264f8aabc92$export$638cb8dd9792b25b } = $d359c264f8aabc92$export$632826e13a29e9c0;

});
parcelRegister("71qsd", function(module, exports) {

$parcel$export(module.exports, "createApi", () => $51cd259feff82e55$export$9cdc2b9a8d94c842);

var $8OE6H = parcelRequire("8OE6H");

var $iDqdB = parcelRequire("iDqdB");

var $7jD0c = parcelRequire("7jD0c");

var $4KtEQ = parcelRequire("4KtEQ");

var $acw62 = parcelRequire("acw62");
var $51cd259feff82e55$var$__defProp = Object.defineProperty;
var $51cd259feff82e55$var$__defProps = Object.defineProperties;
var $51cd259feff82e55$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $51cd259feff82e55$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $51cd259feff82e55$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $51cd259feff82e55$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $51cd259feff82e55$var$__defNormalProp = (obj, key, value)=>key in obj ? $51cd259feff82e55$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $51cd259feff82e55$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($51cd259feff82e55$var$__hasOwnProp.call(b, prop)) $51cd259feff82e55$var$__defNormalProp(a, prop, b[prop]);
    if ($51cd259feff82e55$var$__getOwnPropSymbols) {
        for (var prop of $51cd259feff82e55$var$__getOwnPropSymbols(b))if ($51cd259feff82e55$var$__propIsEnum.call(b, prop)) $51cd259feff82e55$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $51cd259feff82e55$var$__spreadProps = (a, b)=>$51cd259feff82e55$var$__defProps(a, $51cd259feff82e55$var$__getOwnPropDescs(b));
var $51cd259feff82e55$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($51cd259feff82e55$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $51cd259feff82e55$var$__getOwnPropSymbols) {
        for (var prop of $51cd259feff82e55$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $51cd259feff82e55$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/query/utils/capitalize.ts
function $51cd259feff82e55$var$capitalize(str) {
    return str.replace(str[0], str[0].toUpperCase());
}
// src/query/utils/countObjectKeys.ts
function $51cd259feff82e55$var$countObjectKeys(obj) {
    let count = 0;
    for(const _key in obj)count++;
    return count;
}
// src/query/endpointDefinitions.ts
var $51cd259feff82e55$var$ENDPOINT_QUERY = "query" /* query */ ;
var $51cd259feff82e55$var$ENDPOINT_MUTATION = "mutation" /* mutation */ ;
var $51cd259feff82e55$var$ENDPOINT_INFINITEQUERY = "infinitequery" /* infinitequery */ ;
function $51cd259feff82e55$var$isQueryDefinition(e) {
    return e.type === $51cd259feff82e55$var$ENDPOINT_QUERY;
}
function $51cd259feff82e55$var$isMutationDefinition(e) {
    return e.type === $51cd259feff82e55$var$ENDPOINT_MUTATION;
}
function $51cd259feff82e55$var$isInfiniteQueryDefinition(e) {
    return e.type === $51cd259feff82e55$var$ENDPOINT_INFINITEQUERY;
}
// src/query/tsHelpers.ts
function $51cd259feff82e55$var$safeAssign(target, ...args) {
    return Object.assign(target, ...args);
}
// src/query/react/constants.ts
var $51cd259feff82e55$export$3e5f293e15ab07c8 = /* @__PURE__ */ Symbol();
// src/query/react/useSerializedStableValue.ts
function $51cd259feff82e55$var$useStableQueryArgs(queryArgs) {
    const cache = (0, $acw62.useRef)(queryArgs);
    const copy = (0, $acw62.useMemo)(()=>(0, $8OE6H.copyWithStructuralSharing)(cache.current, queryArgs), [
        queryArgs
    ]);
    (0, $acw62.useEffect)(()=>{
        if (cache.current !== copy) cache.current = copy;
    }, [
        copy
    ]);
    return copy;
}
// src/query/react/useShallowStableValue.ts
function $51cd259feff82e55$var$useShallowStableValue(value) {
    const cache = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        if (!(0, $7jD0c.shallowEqual)(cache.current, value)) cache.current = value;
    }, [
        value
    ]);
    return (0, $7jD0c.shallowEqual)(cache.current, value) ? cache.current : value;
}
// src/query/react/buildHooks.ts
var $51cd259feff82e55$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $51cd259feff82e55$var$isDOM = /* @__PURE__ */ $51cd259feff82e55$var$canUseDOM();
var $51cd259feff82e55$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $51cd259feff82e55$var$isReactNative = /* @__PURE__ */ $51cd259feff82e55$var$isRunningInReactNative();
var $51cd259feff82e55$var$getUseIsomorphicLayoutEffect = ()=>$51cd259feff82e55$var$isDOM || $51cd259feff82e55$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $51cd259feff82e55$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $51cd259feff82e55$var$getUseIsomorphicLayoutEffect();
var $51cd259feff82e55$var$noPendingQueryStateSelector = (selected)=>{
    if (selected.isUninitialized) return $51cd259feff82e55$var$__spreadProps($51cd259feff82e55$var$__spreadValues({}, selected), {
        isUninitialized: false,
        isFetching: true,
        isLoading: selected.data !== void 0 ? false : true,
        // This is the one place where we still have to use `QueryStatus` as an enum,
        // since it's the only reference in the React package and not in the core.
        status: (0, $8OE6H.QueryStatus).pending
    });
    return selected;
};
function $51cd259feff82e55$var$pick(obj, ...keys) {
    const ret = {};
    keys.forEach((key)=>{
        ret[key] = obj[key];
    });
    return ret;
}
var $51cd259feff82e55$var$COMMON_HOOK_DEBUG_FIELDS = [
    "data",
    "status",
    "isLoading",
    "isSuccess",
    "isError",
    "error"
];
function $51cd259feff82e55$var$buildHooks({ api: api, moduleOptions: { batch: batch, hooks: { useDispatch: useDispatch, useSelector: useSelector, useStore: useStore }, unstable__sideEffectsInRender: unstable__sideEffectsInRender, createSelector: createSelector }, serializeQueryArgs: serializeQueryArgs, context: context }) {
    const usePossiblyImmediateEffect = unstable__sideEffectsInRender ? (cb)=>cb() : (0, $acw62.useEffect);
    const unsubscribePromiseRef = (ref)=>{
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.unsubscribe) == null ? void 0 : _b.call(_a);
    };
    const endpointDefinitions = context.endpointDefinitions;
    return {
        buildQueryHooks: buildQueryHooks,
        buildInfiniteQueryHooks: buildInfiniteQueryHooks,
        buildMutationHook: buildMutationHook,
        usePrefetch: usePrefetch
    };
    function queryStatePreSelector(currentState, lastResult, queryArgs) {
        if ((lastResult == null ? void 0 : lastResult.endpointName) && currentState.isUninitialized) {
            const { endpointName: endpointName } = lastResult;
            const endpointDefinition = endpointDefinitions[endpointName];
            if (queryArgs !== (0, $8OE6H.skipToken) && serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        let data = currentState.isSuccess ? currentState.data : lastResult == null ? void 0 : lastResult.data;
        if (data === void 0) data = currentState.data;
        const hasData = data !== void 0;
        const isFetching = currentState.isLoading;
        const isLoading = (!lastResult || lastResult.isLoading || lastResult.isUninitialized) && !hasData && isFetching;
        const isSuccess = currentState.isSuccess || hasData && (isFetching && !(lastResult == null ? void 0 : lastResult.isError) || currentState.isUninitialized);
        return $51cd259feff82e55$var$__spreadProps($51cd259feff82e55$var$__spreadValues({}, currentState), {
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        });
    }
    function infiniteQueryStatePreSelector(currentState, lastResult, queryArgs) {
        if ((lastResult == null ? void 0 : lastResult.endpointName) && currentState.isUninitialized) {
            const { endpointName: endpointName } = lastResult;
            const endpointDefinition = endpointDefinitions[endpointName];
            if (queryArgs !== (0, $8OE6H.skipToken) && serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        let data = currentState.isSuccess ? currentState.data : lastResult == null ? void 0 : lastResult.data;
        if (data === void 0) data = currentState.data;
        const hasData = data !== void 0;
        const isFetching = currentState.isLoading;
        const isLoading = (!lastResult || lastResult.isLoading || lastResult.isUninitialized) && !hasData && isFetching;
        const isSuccess = currentState.isSuccess || hasData && (isFetching && !(lastResult == null ? void 0 : lastResult.isError) || currentState.isUninitialized);
        return $51cd259feff82e55$var$__spreadProps($51cd259feff82e55$var$__spreadValues({}, currentState), {
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        });
    }
    function usePrefetch(endpointName, defaultOptions) {
        const dispatch = useDispatch();
        const stableDefaultOptions = $51cd259feff82e55$var$useShallowStableValue(defaultOptions);
        return (0, $acw62.useCallback)((arg, options)=>dispatch(api.util.prefetch(endpointName, arg, $51cd259feff82e55$var$__spreadValues($51cd259feff82e55$var$__spreadValues({}, stableDefaultOptions), options))), [
            endpointName,
            dispatch,
            stableDefaultOptions
        ]);
    }
    function useQuerySubscriptionCommonImpl(endpointName, arg, _a = {}) {
        var _b = _a, { refetchOnReconnect: refetchOnReconnect, refetchOnFocus: refetchOnFocus, refetchOnMountOrArgChange: refetchOnMountOrArgChange, skip: skip = false, pollingInterval: pollingInterval = 0, skipPollingIfUnfocused: skipPollingIfUnfocused = false } = _b, rest = $51cd259feff82e55$var$__objRest(_b, [
            "refetchOnReconnect",
            "refetchOnFocus",
            "refetchOnMountOrArgChange",
            "skip",
            "pollingInterval",
            "skipPollingIfUnfocused"
        ]);
        const { initiate: initiate } = api.endpoints[endpointName];
        const dispatch = useDispatch();
        const subscriptionSelectorsRef = (0, $acw62.useRef)(void 0);
        if (!subscriptionSelectorsRef.current) {
            const returnedValue = dispatch(api.internalActions.internal_getRTKQSubscriptions());
            subscriptionSelectorsRef.current = returnedValue;
        }
        const stableArg = $51cd259feff82e55$var$useStableQueryArgs(skip ? (0, $8OE6H.skipToken) : arg);
        const stableSubscriptionOptions = $51cd259feff82e55$var$useShallowStableValue({
            refetchOnReconnect: refetchOnReconnect,
            refetchOnFocus: refetchOnFocus,
            pollingInterval: pollingInterval,
            skipPollingIfUnfocused: skipPollingIfUnfocused
        });
        const initialPageParam = rest.initialPageParam;
        const stableInitialPageParam = $51cd259feff82e55$var$useShallowStableValue(initialPageParam);
        const refetchCachedPages = rest.refetchCachedPages;
        const stableRefetchCachedPages = $51cd259feff82e55$var$useShallowStableValue(refetchCachedPages);
        const promiseRef = (0, $acw62.useRef)(void 0);
        let { queryCacheKey: queryCacheKey, requestId: requestId } = promiseRef.current || {};
        let currentRenderHasSubscription = false;
        if (queryCacheKey && requestId) currentRenderHasSubscription = subscriptionSelectorsRef.current.isRequestSubscribed(queryCacheKey, requestId);
        const subscriptionRemoved = !currentRenderHasSubscription && promiseRef.current !== void 0;
        usePossiblyImmediateEffect(()=>{
            if (subscriptionRemoved) promiseRef.current = void 0;
        }, [
            subscriptionRemoved
        ]);
        usePossiblyImmediateEffect(()=>{
            var _a2;
            const lastPromise = promiseRef.current;
            if (stableArg === (0, $8OE6H.skipToken)) {
                lastPromise == null || lastPromise.unsubscribe();
                promiseRef.current = void 0;
                return;
            }
            const lastSubscriptionOptions = (_a2 = promiseRef.current) == null ? void 0 : _a2.subscriptionOptions;
            if (!lastPromise || lastPromise.arg !== stableArg) {
                lastPromise == null || lastPromise.unsubscribe();
                const promise = dispatch(initiate(stableArg, $51cd259feff82e55$var$__spreadValues({
                    subscriptionOptions: stableSubscriptionOptions,
                    forceRefetch: refetchOnMountOrArgChange
                }, $51cd259feff82e55$var$isInfiniteQueryDefinition(endpointDefinitions[endpointName]) ? {
                    initialPageParam: stableInitialPageParam,
                    refetchCachedPages: stableRefetchCachedPages
                } : {})));
                promiseRef.current = promise;
            } else if (stableSubscriptionOptions !== lastSubscriptionOptions) lastPromise.updateSubscriptionOptions(stableSubscriptionOptions);
        }, [
            dispatch,
            initiate,
            refetchOnMountOrArgChange,
            stableArg,
            stableSubscriptionOptions,
            subscriptionRemoved,
            stableInitialPageParam,
            stableRefetchCachedPages,
            endpointName
        ]);
        return [
            promiseRef,
            dispatch,
            initiate,
            stableSubscriptionOptions
        ];
    }
    function buildUseQueryState(endpointName, preSelector) {
        const useQueryState = (arg, { skip: skip = false, selectFromResult: selectFromResult } = {})=>{
            const { select: select } = api.endpoints[endpointName];
            const stableArg = $51cd259feff82e55$var$useStableQueryArgs(skip ? (0, $8OE6H.skipToken) : arg);
            const lastValue = (0, $acw62.useRef)(void 0);
            const selectDefaultResult = (0, $acw62.useMemo)(()=>// Normally ts-ignores are bad and should be avoided, but we're
                // already casting this selector to be `Selector<any>` anyway,
                // so the inconsistencies don't matter here
                // @ts-ignore
                createSelector([
                    // @ts-ignore
                    select(stableArg),
                    (_, lastResult)=>lastResult,
                    (_)=>stableArg
                ], preSelector, {
                    memoizeOptions: {
                        resultEqualityCheck: (0, $7jD0c.shallowEqual)
                    }
                }), [
                select,
                stableArg
            ]);
            const querySelector = (0, $acw62.useMemo)(()=>selectFromResult ? createSelector([
                    selectDefaultResult
                ], selectFromResult, {
                    devModeChecks: {
                        identityFunctionCheck: "never"
                    }
                }) : selectDefaultResult, [
                selectDefaultResult,
                selectFromResult
            ]);
            const currentState = useSelector((state)=>querySelector(state, lastValue.current), (0, $7jD0c.shallowEqual));
            const store = useStore();
            const newLastValue = selectDefaultResult(store.getState(), lastValue.current);
            $51cd259feff82e55$var$useIsomorphicLayoutEffect(()=>{
                lastValue.current = newLastValue;
            }, [
                newLastValue
            ]);
            return currentState;
        };
        return useQueryState;
    }
    function usePromiseRefUnsubscribeOnUnmount(promiseRef) {
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                unsubscribePromiseRef(promiseRef);
                promiseRef.current = void 0;
            };
        }, [
            promiseRef
        ]);
    }
    function refetchOrErrorIfUnmounted(promiseRef) {
        if (!promiseRef.current) throw new Error((0, $iDqdB.formatProdErrorMessage)(38));
        return promiseRef.current.refetch();
    }
    function buildQueryHooks(endpointName) {
        const useQuerySubscription = (arg, options = {})=>{
            const [promiseRef] = useQuerySubscriptionCommonImpl(endpointName, arg, options);
            usePromiseRefUnsubscribeOnUnmount(promiseRef);
            return (0, $acw62.useMemo)(()=>({
                    /**
         * A method to manually refetch data for the query
         */ refetch: ()=>refetchOrErrorIfUnmounted(promiseRef)
                }), [
                promiseRef
            ]);
        };
        const useLazyQuerySubscription = ({ refetchOnReconnect: refetchOnReconnect, refetchOnFocus: refetchOnFocus, pollingInterval: pollingInterval = 0, skipPollingIfUnfocused: skipPollingIfUnfocused = false } = {})=>{
            const { initiate: initiate } = api.endpoints[endpointName];
            const dispatch = useDispatch();
            const [arg, setArg] = (0, $acw62.useState)($51cd259feff82e55$export$3e5f293e15ab07c8);
            const promiseRef = (0, $acw62.useRef)(void 0);
            const stableSubscriptionOptions = $51cd259feff82e55$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval,
                skipPollingIfUnfocused: skipPollingIfUnfocused
            });
            usePossiblyImmediateEffect(()=>{
                var _a, _b;
                const lastSubscriptionOptions = (_a = promiseRef.current) == null ? void 0 : _a.subscriptionOptions;
                if (stableSubscriptionOptions !== lastSubscriptionOptions) (_b = promiseRef.current) == null || _b.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                stableSubscriptionOptions
            ]);
            const subscriptionOptionsRef = (0, $acw62.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(()=>{
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            const trigger = (0, $acw62.useCallback)(function(arg2, preferCacheValue = false) {
                let promise;
                batch(()=>{
                    unsubscribePromiseRef(promiseRef);
                    promiseRef.current = promise = dispatch(initiate(arg2, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        forceRefetch: !preferCacheValue
                    }));
                    setArg(arg2);
                });
                return promise;
            }, [
                dispatch,
                initiate
            ]);
            const reset = (0, $acw62.useCallback)(()=>{
                var _a, _b;
                if ((_a = promiseRef.current) == null ? void 0 : _a.queryCacheKey) dispatch(api.internalActions.removeQueryResult({
                    queryCacheKey: (_b = promiseRef.current) == null ? void 0 : _b.queryCacheKey
                }));
            }, [
                dispatch
            ]);
            (0, $acw62.useEffect)(()=>{
                return ()=>{
                    unsubscribePromiseRef(promiseRef);
                };
            }, []);
            (0, $acw62.useEffect)(()=>{
                if (arg !== $51cd259feff82e55$export$3e5f293e15ab07c8 && !promiseRef.current) trigger(arg, true);
            }, [
                arg,
                trigger
            ]);
            return (0, $acw62.useMemo)(()=>[
                    trigger,
                    arg,
                    {
                        reset: reset
                    }
                ], [
                trigger,
                arg,
                reset
            ]);
        };
        const useQueryState = buildUseQueryState(endpointName, queryStatePreSelector);
        return {
            useQueryState: useQueryState,
            useQuerySubscription: useQuerySubscription,
            useLazyQuerySubscription: useLazyQuerySubscription,
            useLazyQuery (options) {
                const [trigger, arg, { reset: reset }] = useLazyQuerySubscription(options);
                const queryStateResults = useQueryState(arg, $51cd259feff82e55$var$__spreadProps($51cd259feff82e55$var$__spreadValues({}, options), {
                    skip: arg === $51cd259feff82e55$export$3e5f293e15ab07c8
                }));
                const info = (0, $acw62.useMemo)(()=>({
                        lastArg: arg
                    }), [
                    arg
                ]);
                return (0, $acw62.useMemo)(()=>[
                        trigger,
                        $51cd259feff82e55$var$__spreadProps($51cd259feff82e55$var$__spreadValues({}, queryStateResults), {
                            reset: reset
                        }),
                        info
                    ], [
                    trigger,
                    queryStateResults,
                    reset,
                    info
                ]);
            },
            useQuery (arg, options) {
                const querySubscriptionResults = useQuerySubscription(arg, options);
                const queryStateResults = useQueryState(arg, $51cd259feff82e55$var$__spreadValues({
                    selectFromResult: arg === (0, $8OE6H.skipToken) || (options == null ? void 0 : options.skip) ? void 0 : $51cd259feff82e55$var$noPendingQueryStateSelector
                }, options));
                const debugValue = $51cd259feff82e55$var$pick(queryStateResults, ...$51cd259feff82e55$var$COMMON_HOOK_DEBUG_FIELDS);
                (0, $acw62.useDebugValue)(debugValue);
                return (0, $acw62.useMemo)(()=>$51cd259feff82e55$var$__spreadValues($51cd259feff82e55$var$__spreadValues({}, queryStateResults), querySubscriptionResults), [
                    queryStateResults,
                    querySubscriptionResults
                ]);
            }
        };
    }
    function buildInfiniteQueryHooks(endpointName) {
        const useInfiniteQuerySubscription = (arg, options = {})=>{
            const [promiseRef, dispatch, initiate, stableSubscriptionOptions] = useQuerySubscriptionCommonImpl(endpointName, arg, options);
            const subscriptionOptionsRef = (0, $acw62.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(()=>{
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            const hookRefetchCachedPages = options.refetchCachedPages;
            const stableHookRefetchCachedPages = $51cd259feff82e55$var$useShallowStableValue(hookRefetchCachedPages);
            const trigger = (0, $acw62.useCallback)(function(arg2, direction) {
                let promise;
                batch(()=>{
                    unsubscribePromiseRef(promiseRef);
                    promiseRef.current = promise = dispatch(initiate(arg2, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        direction: direction
                    }));
                });
                return promise;
            }, [
                promiseRef,
                dispatch,
                initiate
            ]);
            usePromiseRefUnsubscribeOnUnmount(promiseRef);
            const stableArg = $51cd259feff82e55$var$useStableQueryArgs(options.skip ? (0, $8OE6H.skipToken) : arg);
            const refetch = (0, $acw62.useCallback)((options2)=>{
                var _a;
                if (!promiseRef.current) throw new Error((0, $iDqdB.formatProdErrorMessage)(38));
                const mergedOptions = {
                    refetchCachedPages: (_a = options2 == null ? void 0 : options2.refetchCachedPages) != null ? _a : stableHookRefetchCachedPages
                };
                return promiseRef.current.refetch(mergedOptions);
            }, [
                promiseRef,
                stableHookRefetchCachedPages
            ]);
            return (0, $acw62.useMemo)(()=>{
                const fetchNextPage = ()=>{
                    return trigger(stableArg, "forward");
                };
                const fetchPreviousPage = ()=>{
                    return trigger(stableArg, "backward");
                };
                return {
                    trigger: trigger,
                    refetch: /**
           * A method to manually refetch data for the query
           */ refetch,
                    fetchNextPage: fetchNextPage,
                    fetchPreviousPage: fetchPreviousPage
                };
            }, [
                refetch,
                trigger,
                stableArg
            ]);
        };
        const useInfiniteQueryState = buildUseQueryState(endpointName, infiniteQueryStatePreSelector);
        return {
            useInfiniteQueryState: useInfiniteQueryState,
            useInfiniteQuerySubscription: useInfiniteQuerySubscription,
            useInfiniteQuery (arg, options) {
                const { refetch: refetch, fetchNextPage: fetchNextPage, fetchPreviousPage: fetchPreviousPage } = useInfiniteQuerySubscription(arg, options);
                const queryStateResults = useInfiniteQueryState(arg, $51cd259feff82e55$var$__spreadValues({
                    selectFromResult: arg === (0, $8OE6H.skipToken) || (options == null ? void 0 : options.skip) ? void 0 : $51cd259feff82e55$var$noPendingQueryStateSelector
                }, options));
                const debugValue = $51cd259feff82e55$var$pick(queryStateResults, ...$51cd259feff82e55$var$COMMON_HOOK_DEBUG_FIELDS, "hasNextPage", "hasPreviousPage");
                (0, $acw62.useDebugValue)(debugValue);
                return (0, $acw62.useMemo)(()=>$51cd259feff82e55$var$__spreadProps($51cd259feff82e55$var$__spreadValues({}, queryStateResults), {
                        fetchNextPage: fetchNextPage,
                        fetchPreviousPage: fetchPreviousPage,
                        refetch: refetch
                    }), [
                    queryStateResults,
                    fetchNextPage,
                    fetchPreviousPage,
                    refetch
                ]);
            }
        };
    }
    function buildMutationHook(name) {
        return ({ selectFromResult: selectFromResult, fixedCacheKey: fixedCacheKey } = {})=>{
            const { select: select, initiate: initiate } = api.endpoints[name];
            const dispatch = useDispatch();
            const [promise, setPromise] = (0, $acw62.useState)();
            (0, $acw62.useEffect)(()=>()=>{
                    if (!(promise == null ? void 0 : promise.arg.fixedCacheKey)) promise == null || promise.reset();
                }, [
                promise
            ]);
            const triggerMutation = (0, $acw62.useCallback)(function(arg) {
                const promise2 = dispatch(initiate(arg, {
                    fixedCacheKey: fixedCacheKey
                }));
                setPromise(promise2);
                return promise2;
            }, [
                dispatch,
                initiate,
                fixedCacheKey
            ]);
            const { requestId: requestId } = promise || {};
            const selectDefaultResult = (0, $acw62.useMemo)(()=>select({
                    fixedCacheKey: fixedCacheKey,
                    requestId: promise == null ? void 0 : promise.requestId
                }), [
                fixedCacheKey,
                promise,
                select
            ]);
            const mutationSelector = (0, $acw62.useMemo)(()=>selectFromResult ? createSelector([
                    selectDefaultResult
                ], selectFromResult) : selectDefaultResult, [
                selectFromResult,
                selectDefaultResult
            ]);
            const currentState = useSelector(mutationSelector, (0, $7jD0c.shallowEqual));
            const originalArgs = fixedCacheKey == null ? promise == null ? void 0 : promise.arg.originalArgs : void 0;
            const reset = (0, $acw62.useCallback)(()=>{
                batch(()=>{
                    if (promise) setPromise(void 0);
                    if (fixedCacheKey) dispatch(api.internalActions.removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                });
            }, [
                dispatch,
                fixedCacheKey,
                promise,
                requestId
            ]);
            const debugValue = $51cd259feff82e55$var$pick(currentState, ...$51cd259feff82e55$var$COMMON_HOOK_DEBUG_FIELDS, "endpointName");
            (0, $acw62.useDebugValue)(debugValue);
            const finalState = (0, $acw62.useMemo)(()=>$51cd259feff82e55$var$__spreadProps($51cd259feff82e55$var$__spreadValues({}, currentState), {
                    originalArgs: originalArgs,
                    reset: reset
                }), [
                currentState,
                originalArgs,
                reset
            ]);
            return (0, $acw62.useMemo)(()=>[
                    triggerMutation,
                    finalState
                ], [
                triggerMutation,
                finalState
            ]);
        };
    }
}
// src/query/react/module.ts
var $51cd259feff82e55$export$fba4c1b64338c09f = /* @__PURE__ */ Symbol();
var $51cd259feff82e55$export$8b98f9e72008ec90 = (_a = {})=>{
    var _b = _a, { batch: batch = (0, $7jD0c.batch), hooks: hooks = {
        useDispatch: (0, $7jD0c.useDispatch),
        useSelector: (0, $7jD0c.useSelector),
        useStore: (0, $7jD0c.useStore)
    }, createSelector: createSelector = (0, $4KtEQ.createSelector), unstable__sideEffectsInRender: unstable__sideEffectsInRender = false } = _b, rest = $51cd259feff82e55$var$__objRest(_b, [
        "batch",
        "hooks",
        "createSelector",
        "unstable__sideEffectsInRender"
    ]);
    return {
        name: $51cd259feff82e55$export$fba4c1b64338c09f,
        init (api, { serializeQueryArgs: serializeQueryArgs }, context) {
            const anyApi = api;
            const { buildQueryHooks: buildQueryHooks, buildInfiniteQueryHooks: buildInfiniteQueryHooks, buildMutationHook: buildMutationHook, usePrefetch: usePrefetch } = $51cd259feff82e55$var$buildHooks({
                api: api,
                moduleOptions: {
                    batch: batch,
                    hooks: hooks,
                    unstable__sideEffectsInRender: unstable__sideEffectsInRender,
                    createSelector: createSelector
                },
                serializeQueryArgs: serializeQueryArgs,
                context: context
            });
            $51cd259feff82e55$var$safeAssign(anyApi, {
                usePrefetch: usePrefetch
            });
            $51cd259feff82e55$var$safeAssign(context, {
                batch: batch
            });
            return {
                injectEndpoint (endpointName, definition) {
                    if ($51cd259feff82e55$var$isQueryDefinition(definition)) {
                        const { useQuery: useQuery, useLazyQuery: useLazyQuery, useLazyQuerySubscription: useLazyQuerySubscription, useQueryState: useQueryState, useQuerySubscription: useQuerySubscription } = buildQueryHooks(endpointName);
                        $51cd259feff82e55$var$safeAssign(anyApi.endpoints[endpointName], {
                            useQuery: useQuery,
                            useLazyQuery: useLazyQuery,
                            useLazyQuerySubscription: useLazyQuerySubscription,
                            useQueryState: useQueryState,
                            useQuerySubscription: useQuerySubscription
                        });
                        api[`use${$51cd259feff82e55$var$capitalize(endpointName)}Query`] = useQuery;
                        api[`useLazy${$51cd259feff82e55$var$capitalize(endpointName)}Query`] = useLazyQuery;
                    }
                    if ($51cd259feff82e55$var$isMutationDefinition(definition)) {
                        const useMutation = buildMutationHook(endpointName);
                        $51cd259feff82e55$var$safeAssign(anyApi.endpoints[endpointName], {
                            useMutation: useMutation
                        });
                        api[`use${$51cd259feff82e55$var$capitalize(endpointName)}Mutation`] = useMutation;
                    } else if ($51cd259feff82e55$var$isInfiniteQueryDefinition(definition)) {
                        const { useInfiniteQuery: useInfiniteQuery, useInfiniteQuerySubscription: useInfiniteQuerySubscription, useInfiniteQueryState: useInfiniteQueryState } = buildInfiniteQueryHooks(endpointName);
                        $51cd259feff82e55$var$safeAssign(anyApi.endpoints[endpointName], {
                            useInfiniteQuery: useInfiniteQuery,
                            useInfiniteQuerySubscription: useInfiniteQuerySubscription,
                            useInfiniteQueryState: useInfiniteQueryState
                        });
                        api[`use${$51cd259feff82e55$var$capitalize(endpointName)}InfiniteQuery`] = useInfiniteQuery;
                    }
                }
            };
        }
    };
};
function $51cd259feff82e55$export$f4e57f6132f56752(props) {
    const context = props.context || (0, $7jD0c.ReactReduxContext);
    const existingContext = (0, $acw62.useContext)(context);
    if (existingContext) throw new Error((0, $iDqdB.formatProdErrorMessage)(35));
    const [store] = $acw62.useState(()=>(0, $iDqdB.configureStore)({
            reducer: {
                [props.api.reducerPath]: props.api.reducer
            },
            middleware: (gDM)=>gDM().concat(props.api.middleware)
        }));
    (0, $acw62.useEffect)(()=>props.setupListeners === false ? void 0 : (0, $8OE6H.setupListeners)(store.dispatch, props.setupListeners), [
        props.setupListeners,
        store.dispatch
    ]);
    return /* @__PURE__ */ $acw62.createElement((0, $7jD0c.Provider), {
        store: store,
        context: context
    }, props.children);
}
// src/query/react/index.ts
var $51cd259feff82e55$export$9cdc2b9a8d94c842 = /* @__PURE__ */ (0, $8OE6H.buildCreateApi)((0, $8OE6H.coreModule)(), $51cd259feff82e55$export$8b98f9e72008ec90());

});
parcelRegister("8OE6H", function(module, exports) {

$parcel$export(module.exports, "QueryStatus", () => $66b21aa7bd8497fc$export$f4258b89f6bad1d6);
$parcel$export(module.exports, "copyWithStructuralSharing", () => $66b21aa7bd8497fc$export$b64d4502a1c929bd);
$parcel$export(module.exports, "setupListeners", () => $66b21aa7bd8497fc$export$120c0dbb0351414c);
$parcel$export(module.exports, "skipToken", () => $66b21aa7bd8497fc$export$1aa5a89531b7670d);
$parcel$export(module.exports, "buildCreateApi", () => $66b21aa7bd8497fc$export$f957748792d43646);
$parcel$export(module.exports, "coreModule", () => $66b21aa7bd8497fc$export$eb718ff92afd6f9b);

var $i5N98 = parcelRequire("i5N98");
var $iDqdB = parcelRequire("iDqdB");
var $fTaOL = parcelRequire("fTaOL");
var $4KtEQ = parcelRequire("4KtEQ");

var $fTaOL = parcelRequire("fTaOL");

var $fKdhF = parcelRequire("fKdhF");

var $4KtEQ = parcelRequire("4KtEQ");
var $66b21aa7bd8497fc$var$__defProp = Object.defineProperty;
var $66b21aa7bd8497fc$var$__defProps = Object.defineProperties;
var $66b21aa7bd8497fc$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $66b21aa7bd8497fc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $66b21aa7bd8497fc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $66b21aa7bd8497fc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $66b21aa7bd8497fc$var$__defNormalProp = (obj, key, value)=>key in obj ? $66b21aa7bd8497fc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $66b21aa7bd8497fc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($66b21aa7bd8497fc$var$__hasOwnProp.call(b, prop)) $66b21aa7bd8497fc$var$__defNormalProp(a, prop, b[prop]);
    if ($66b21aa7bd8497fc$var$__getOwnPropSymbols) {
        for (var prop of $66b21aa7bd8497fc$var$__getOwnPropSymbols(b))if ($66b21aa7bd8497fc$var$__propIsEnum.call(b, prop)) $66b21aa7bd8497fc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $66b21aa7bd8497fc$var$__spreadProps = (a, b)=>$66b21aa7bd8497fc$var$__defProps(a, $66b21aa7bd8497fc$var$__getOwnPropDescs(b));
var $66b21aa7bd8497fc$var$__restKey = (key)=>typeof key === "symbol" ? key : key + "";
var $66b21aa7bd8497fc$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($66b21aa7bd8497fc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $66b21aa7bd8497fc$var$__getOwnPropSymbols) {
        for (var prop of $66b21aa7bd8497fc$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $66b21aa7bd8497fc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $66b21aa7bd8497fc$var$__publicField = (obj, key, value)=>$66b21aa7bd8497fc$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/query/core/apiState.ts
var $66b21aa7bd8497fc$export$f4258b89f6bad1d6 = /* @__PURE__ */ ((QueryStatus7)=>{
    QueryStatus7["uninitialized"] = "uninitialized";
    QueryStatus7["pending"] = "pending";
    QueryStatus7["fulfilled"] = "fulfilled";
    QueryStatus7["rejected"] = "rejected";
    return QueryStatus7;
})($66b21aa7bd8497fc$export$f4258b89f6bad1d6 || {});
var $66b21aa7bd8497fc$var$STATUS_UNINITIALIZED = "uninitialized" /* uninitialized */ ;
var $66b21aa7bd8497fc$var$STATUS_PENDING = "pending" /* pending */ ;
var $66b21aa7bd8497fc$var$STATUS_FULFILLED = "fulfilled" /* fulfilled */ ;
var $66b21aa7bd8497fc$var$STATUS_REJECTED = "rejected" /* rejected */ ;
function $66b21aa7bd8497fc$var$getRequestStatusFlags(status) {
    return {
        status: status,
        isUninitialized: status === $66b21aa7bd8497fc$var$STATUS_UNINITIALIZED,
        isLoading: status === $66b21aa7bd8497fc$var$STATUS_PENDING,
        isSuccess: status === $66b21aa7bd8497fc$var$STATUS_FULFILLED,
        isError: status === $66b21aa7bd8497fc$var$STATUS_REJECTED
    };
}
// src/query/utils/copyWithStructuralSharing.ts
var $66b21aa7bd8497fc$var$isPlainObject2 = (0, $i5N98.isPlainObject);
function $66b21aa7bd8497fc$export$b64d4502a1c929bd(oldObj, newObj) {
    if (oldObj === newObj || !($66b21aa7bd8497fc$var$isPlainObject2(oldObj) && $66b21aa7bd8497fc$var$isPlainObject2(newObj) || Array.isArray(oldObj) && Array.isArray(newObj))) return newObj;
    const newKeys = Object.keys(newObj);
    const oldKeys = Object.keys(oldObj);
    let isSameObject = newKeys.length === oldKeys.length;
    const mergeObj = Array.isArray(newObj) ? [] : {};
    for (const key of newKeys){
        mergeObj[key] = $66b21aa7bd8497fc$export$b64d4502a1c929bd(oldObj[key], newObj[key]);
        if (isSameObject) isSameObject = oldObj[key] === mergeObj[key];
    }
    return isSameObject ? oldObj : mergeObj;
}
// src/query/utils/filterMap.ts
function $66b21aa7bd8497fc$var$filterMap(array, predicate, mapper) {
    return array.reduce((acc, item, i)=>{
        if (predicate(item, i)) acc.push(mapper(item, i));
        return acc;
    }, []).flat();
}
// src/query/utils/isAbsoluteUrl.ts
function $66b21aa7bd8497fc$var$isAbsoluteUrl(url) {
    return new RegExp(`(^|:)//`).test(url);
}
// src/query/utils/isDocumentVisible.ts
function $66b21aa7bd8497fc$var$isDocumentVisible() {
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
}
// src/query/utils/isNotNullish.ts
function $66b21aa7bd8497fc$var$isNotNullish(v) {
    return v != null;
}
function $66b21aa7bd8497fc$var$filterNullishValues(map) {
    var _a;
    return [
        ...(_a = map == null ? void 0 : map.values()) != null ? _a : []
    ].filter($66b21aa7bd8497fc$var$isNotNullish);
}
// src/query/utils/isOnline.ts
function $66b21aa7bd8497fc$var$isOnline() {
    return typeof navigator === "undefined" ? true : navigator.onLine === void 0 ? true : navigator.onLine;
}
// src/query/utils/joinUrls.ts
var $66b21aa7bd8497fc$var$withoutTrailingSlash = (url)=>url.replace(/\/$/, "");
var $66b21aa7bd8497fc$var$withoutLeadingSlash = (url)=>url.replace(/^\//, "");
function $66b21aa7bd8497fc$var$joinUrls(base, url) {
    if (!base) return url;
    if (!url) return base;
    if ($66b21aa7bd8497fc$var$isAbsoluteUrl(url)) return url;
    const delimiter = base.endsWith("/") || !url.startsWith("?") ? "/" : "";
    base = $66b21aa7bd8497fc$var$withoutTrailingSlash(base);
    url = $66b21aa7bd8497fc$var$withoutLeadingSlash(url);
    return `${base}${delimiter}${url}`;
}
// src/query/utils/getOrInsert.ts
function $66b21aa7bd8497fc$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
var $66b21aa7bd8497fc$var$createNewMap = ()=>/* @__PURE__ */ new Map();
// src/query/utils/signals.ts
var $66b21aa7bd8497fc$var$timeoutSignal = (milliseconds)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        const message = "signal timed out";
        const name = "TimeoutError";
        abortController.abort(// some environments (React Native, Node) don't have DOMException
        typeof DOMException !== "undefined" ? new DOMException(message, name) : Object.assign(new Error(message), {
            name: name
        }));
    }, milliseconds);
    return abortController.signal;
};
var $66b21aa7bd8497fc$var$anySignal = (...signals)=>{
    for (const signal of signals)if (signal.aborted) return AbortSignal.abort(signal.reason);
    const abortController = new AbortController();
    for (const signal of signals)signal.addEventListener("abort", ()=>abortController.abort(signal.reason), {
        signal: abortController.signal,
        once: true
    });
    return abortController.signal;
};
// src/query/fetchBaseQuery.ts
var $66b21aa7bd8497fc$var$defaultFetchFn = (...args)=>fetch(...args);
var $66b21aa7bd8497fc$var$defaultValidateStatus = (response)=>response.status >= 200 && response.status <= 299;
var $66b21aa7bd8497fc$var$defaultIsJsonContentType = (headers)=>/*applicat*/ /ion\/(vnd\.api\+)?json/.test(headers.get("content-type") || "");
function $66b21aa7bd8497fc$var$stripUndefined(obj) {
    if (!(0, $i5N98.isPlainObject)(obj)) return obj;
    const copy = $66b21aa7bd8497fc$var$__spreadValues({}, obj);
    for (const [k, v] of Object.entries(copy))if (v === void 0) delete copy[k];
    return copy;
}
var $66b21aa7bd8497fc$var$isJsonifiable = (body)=>typeof body === "object" && ((0, $i5N98.isPlainObject)(body) || Array.isArray(body) || typeof body.toJSON === "function");
function $66b21aa7bd8497fc$export$adcf4c6133c49b4e(_a = {}) {
    var _b = _a, { baseUrl: baseUrl, prepareHeaders: prepareHeaders = (x)=>x, fetchFn: fetchFn = $66b21aa7bd8497fc$var$defaultFetchFn, paramsSerializer: paramsSerializer, isJsonContentType: isJsonContentType = $66b21aa7bd8497fc$var$defaultIsJsonContentType, jsonContentType: jsonContentType = "application/json", jsonReplacer: jsonReplacer, timeout: defaultTimeout, responseHandler: globalResponseHandler, validateStatus: globalValidateStatus } = _b, baseFetchOptions = $66b21aa7bd8497fc$var$__objRest(_b, [
        "baseUrl",
        "prepareHeaders",
        "fetchFn",
        "paramsSerializer",
        "isJsonContentType",
        "jsonContentType",
        "jsonReplacer",
        "timeout",
        "responseHandler",
        "validateStatus"
    ]);
    if (typeof fetch === "undefined" && fetchFn === $66b21aa7bd8497fc$var$defaultFetchFn) console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments.");
    return async (arg, api, extraOptions)=>{
        const { getState: getState, extra: extra, endpoint: endpoint, forced: forced, type: type } = api;
        let meta;
        let _a2 = typeof arg == "string" ? {
            url: arg
        } : arg, { url: url, headers: headers = new Headers(baseFetchOptions.headers), params: params, responseHandler: responseHandler = globalResponseHandler != null ? globalResponseHandler : "json", validateStatus: validateStatus = globalValidateStatus != null ? globalValidateStatus : $66b21aa7bd8497fc$var$defaultValidateStatus, timeout: timeout = defaultTimeout } = _a2, rest = $66b21aa7bd8497fc$var$__objRest(_a2, [
            "url",
            "headers",
            "params",
            "responseHandler",
            "validateStatus",
            "timeout"
        ]);
        let config = $66b21aa7bd8497fc$var$__spreadValues($66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, baseFetchOptions), {
            signal: timeout ? $66b21aa7bd8497fc$var$anySignal(api.signal, $66b21aa7bd8497fc$var$timeoutSignal(timeout)) : api.signal
        }), rest);
        headers = new Headers($66b21aa7bd8497fc$var$stripUndefined(headers));
        config.headers = await prepareHeaders(headers, {
            getState: getState,
            arg: arg,
            extra: extra,
            endpoint: endpoint,
            forced: forced,
            type: type,
            extraOptions: extraOptions
        }) || headers;
        const bodyIsJsonifiable = $66b21aa7bd8497fc$var$isJsonifiable(config.body);
        if (config.body != null && !bodyIsJsonifiable && typeof config.body !== "string") config.headers.delete("content-type");
        if (!config.headers.has("content-type") && bodyIsJsonifiable) config.headers.set("content-type", jsonContentType);
        if (bodyIsJsonifiable && isJsonContentType(config.headers)) config.body = JSON.stringify(config.body, jsonReplacer);
        if (!config.headers.has("accept")) {
            if (responseHandler === "json") config.headers.set("accept", "application/json");
            else if (responseHandler === "text") config.headers.set("accept", "text/plain, text/html, */*");
        }
        if (params) {
            const divider = ~url.indexOf("?") ? "&" : "?";
            const query = paramsSerializer ? paramsSerializer(params) : new URLSearchParams($66b21aa7bd8497fc$var$stripUndefined(params));
            url += divider + query;
        }
        url = $66b21aa7bd8497fc$var$joinUrls(baseUrl, url);
        const request = new Request(url, config);
        const requestClone = new Request(url, config);
        meta = {
            request: requestClone
        };
        let response;
        try {
            response = await fetchFn(request);
        } catch (e) {
            return {
                error: {
                    status: (e instanceof Error || typeof DOMException !== "undefined" && e instanceof DOMException) && e.name === "TimeoutError" ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                    error: String(e)
                },
                meta: meta
            };
        }
        const responseClone = response.clone();
        meta.response = responseClone;
        let resultData;
        let responseText = "";
        try {
            let handleResponseError;
            await Promise.all([
                handleResponse(response, responseHandler).then((r)=>resultData = r, (e)=>handleResponseError = e),
                // see https://github.com/node-fetch/node-fetch/issues/665#issuecomment-538995182
                // we *have* to "use up" both streams at the same time or they will stop running in node-fetch scenarios
                responseClone.text().then((r)=>responseText = r, ()=>{})
            ]);
            if (handleResponseError) throw handleResponseError;
        } catch (e) {
            return {
                error: {
                    status: "PARSING_ERROR",
                    originalStatus: response.status,
                    data: responseText,
                    error: String(e)
                },
                meta: meta
            };
        }
        return validateStatus(response, resultData) ? {
            data: resultData,
            meta: meta
        } : {
            error: {
                status: response.status,
                data: resultData
            },
            meta: meta
        };
    };
    async function handleResponse(response, responseHandler) {
        if (typeof responseHandler === "function") return responseHandler(response);
        if (responseHandler === "content-type") responseHandler = isJsonContentType(response.headers) ? "json" : "text";
        if (responseHandler === "json") {
            const text = await response.text();
            return text.length ? JSON.parse(text) : null;
        }
        return response.text();
    }
}
// src/query/HandledError.ts
var $66b21aa7bd8497fc$var$HandledError = class {
    constructor(value, meta){
        $66b21aa7bd8497fc$var$__publicField(this, "value", value);
        $66b21aa7bd8497fc$var$__publicField(this, "meta", meta);
    }
};
// src/query/retry.ts
async function $66b21aa7bd8497fc$var$defaultBackoff(attempt = 0, maxRetries = 5, signal) {
    const attempts = Math.min(attempt, maxRetries);
    const timeout = ~~((Math.random() + 0.4) * (300 << attempts));
    await new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>resolve(), timeout);
        if (signal) {
            const abortHandler = ()=>{
                clearTimeout(timeoutId);
                reject(new Error("Aborted"));
            };
            if (signal.aborted) {
                clearTimeout(timeoutId);
                reject(new Error("Aborted"));
            } else signal.addEventListener("abort", abortHandler, {
                once: true
            });
        }
    });
}
function $66b21aa7bd8497fc$var$fail(error, meta) {
    throw Object.assign(new $66b21aa7bd8497fc$var$HandledError({
        error: error,
        meta: meta
    }), {
        throwImmediately: true
    });
}
function $66b21aa7bd8497fc$var$failIfAborted(signal) {
    if (signal.aborted) $66b21aa7bd8497fc$var$fail({
        status: "CUSTOM_ERROR",
        error: "Aborted"
    });
}
var $66b21aa7bd8497fc$var$EMPTY_OPTIONS = {};
var $66b21aa7bd8497fc$var$retryWithBackoff = (baseQuery, defaultOptions)=>async (args, api, extraOptions)=>{
        const possibleMaxRetries = [
            5,
            (defaultOptions || $66b21aa7bd8497fc$var$EMPTY_OPTIONS).maxRetries,
            (extraOptions || $66b21aa7bd8497fc$var$EMPTY_OPTIONS).maxRetries
        ].filter((x)=>x !== void 0);
        const [maxRetries] = possibleMaxRetries.slice(-1);
        const defaultRetryCondition = (_, __, { attempt: attempt })=>attempt <= maxRetries;
        const options = $66b21aa7bd8497fc$var$__spreadValues($66b21aa7bd8497fc$var$__spreadValues({
            maxRetries: maxRetries,
            backoff: $66b21aa7bd8497fc$var$defaultBackoff,
            retryCondition: defaultRetryCondition
        }, defaultOptions), extraOptions);
        let retry2 = 0;
        while(true){
            $66b21aa7bd8497fc$var$failIfAborted(api.signal);
            try {
                const result = await baseQuery(args, api, extraOptions);
                if (result.error) throw new $66b21aa7bd8497fc$var$HandledError(result);
                return result;
            } catch (e) {
                retry2++;
                if (e.throwImmediately) {
                    if (e instanceof $66b21aa7bd8497fc$var$HandledError) return e.value;
                    throw e;
                }
                if (e instanceof $66b21aa7bd8497fc$var$HandledError) {
                    if (!options.retryCondition(e.value.error, args, {
                        attempt: retry2,
                        baseQueryApi: api,
                        extraOptions: extraOptions
                    })) return e.value;
                } else {
                    if (retry2 > options.maxRetries) return {
                        error: e
                    };
                }
                $66b21aa7bd8497fc$var$failIfAborted(api.signal);
                try {
                    await options.backoff(retry2, options.maxRetries, api.signal);
                } catch (backoffError) {
                    $66b21aa7bd8497fc$var$failIfAborted(api.signal);
                    throw backoffError;
                }
            }
        }
    };
var $66b21aa7bd8497fc$export$9369b12211e1fce4 = /* @__PURE__ */ Object.assign($66b21aa7bd8497fc$var$retryWithBackoff, {
    fail: $66b21aa7bd8497fc$var$fail
});
// src/query/core/setupListeners.ts
var $66b21aa7bd8497fc$var$INTERNAL_PREFIX = "__rtkq/";
var $66b21aa7bd8497fc$var$ONLINE = "online";
var $66b21aa7bd8497fc$var$OFFLINE = "offline";
var $66b21aa7bd8497fc$var$FOCUS = "focus";
var $66b21aa7bd8497fc$var$FOCUSED = "focused";
var $66b21aa7bd8497fc$var$VISIBILITYCHANGE = "visibilitychange";
var $66b21aa7bd8497fc$var$onFocus = /* @__PURE__ */ (0, $iDqdB.createAction)(`${$66b21aa7bd8497fc$var$INTERNAL_PREFIX}${$66b21aa7bd8497fc$var$FOCUSED}`);
var $66b21aa7bd8497fc$var$onFocusLost = /* @__PURE__ */ (0, $iDqdB.createAction)(`${$66b21aa7bd8497fc$var$INTERNAL_PREFIX}un${$66b21aa7bd8497fc$var$FOCUSED}`);
var $66b21aa7bd8497fc$var$onOnline = /* @__PURE__ */ (0, $iDqdB.createAction)(`${$66b21aa7bd8497fc$var$INTERNAL_PREFIX}${$66b21aa7bd8497fc$var$ONLINE}`);
var $66b21aa7bd8497fc$var$onOffline = /* @__PURE__ */ (0, $iDqdB.createAction)(`${$66b21aa7bd8497fc$var$INTERNAL_PREFIX}${$66b21aa7bd8497fc$var$OFFLINE}`);
var $66b21aa7bd8497fc$var$actions = {
    onFocus: $66b21aa7bd8497fc$var$onFocus,
    onFocusLost: $66b21aa7bd8497fc$var$onFocusLost,
    onOnline: $66b21aa7bd8497fc$var$onOnline,
    onOffline: $66b21aa7bd8497fc$var$onOffline
};
var $66b21aa7bd8497fc$var$initialized = false;
function $66b21aa7bd8497fc$export$120c0dbb0351414c(dispatch, customHandler) {
    function defaultHandler() {
        const [handleFocus, handleFocusLost, handleOnline, handleOffline] = [
            $66b21aa7bd8497fc$var$onFocus,
            $66b21aa7bd8497fc$var$onFocusLost,
            $66b21aa7bd8497fc$var$onOnline,
            $66b21aa7bd8497fc$var$onOffline
        ].map((action)=>()=>dispatch(action()));
        const handleVisibilityChange = ()=>{
            if (window.document.visibilityState === "visible") handleFocus();
            else handleFocusLost();
        };
        let unsubscribe = ()=>{
            $66b21aa7bd8497fc$var$initialized = false;
        };
        if (!$66b21aa7bd8497fc$var$initialized) {
            if (typeof window !== "undefined" && window.addEventListener) {
                let updateListeners2 = function(add) {
                    Object.entries(handlers).forEach(([event, handler])=>{
                        if (add) window.addEventListener(event, handler, false);
                        else window.removeEventListener(event, handler);
                    });
                };
                var updateListeners = updateListeners2;
                const handlers = {
                    [$66b21aa7bd8497fc$var$FOCUS]: handleFocus,
                    [$66b21aa7bd8497fc$var$VISIBILITYCHANGE]: handleVisibilityChange,
                    [$66b21aa7bd8497fc$var$ONLINE]: handleOnline,
                    [$66b21aa7bd8497fc$var$OFFLINE]: handleOffline
                };
                updateListeners2(true);
                $66b21aa7bd8497fc$var$initialized = true;
                unsubscribe = ()=>{
                    updateListeners2(false);
                    $66b21aa7bd8497fc$var$initialized = false;
                };
            }
        }
        return unsubscribe;
    }
    return customHandler ? customHandler(dispatch, $66b21aa7bd8497fc$var$actions) : defaultHandler();
}
// src/query/endpointDefinitions.ts
var $66b21aa7bd8497fc$var$ENDPOINT_QUERY = "query" /* query */ ;
var $66b21aa7bd8497fc$var$ENDPOINT_MUTATION = "mutation" /* mutation */ ;
var $66b21aa7bd8497fc$var$ENDPOINT_INFINITEQUERY = "infinitequery" /* infinitequery */ ;
function $66b21aa7bd8497fc$var$isQueryDefinition(e) {
    return e.type === $66b21aa7bd8497fc$var$ENDPOINT_QUERY;
}
function $66b21aa7bd8497fc$var$isMutationDefinition(e) {
    return e.type === $66b21aa7bd8497fc$var$ENDPOINT_MUTATION;
}
function $66b21aa7bd8497fc$var$isInfiniteQueryDefinition(e) {
    return e.type === $66b21aa7bd8497fc$var$ENDPOINT_INFINITEQUERY;
}
function $66b21aa7bd8497fc$var$isAnyQueryDefinition(e) {
    return $66b21aa7bd8497fc$var$isQueryDefinition(e) || $66b21aa7bd8497fc$var$isInfiniteQueryDefinition(e);
}
function $66b21aa7bd8497fc$var$calculateProvidedBy(description, result, error, queryArg, meta, assertTagTypes) {
    const finalDescription = $66b21aa7bd8497fc$var$isFunction(description) ? description(result, error, queryArg, meta) : description;
    if (finalDescription) return $66b21aa7bd8497fc$var$filterMap(finalDescription, $66b21aa7bd8497fc$var$isNotNullish, (tag)=>assertTagTypes($66b21aa7bd8497fc$var$expandTagDescription(tag)));
    return [];
}
function $66b21aa7bd8497fc$var$isFunction(t) {
    return typeof t === "function";
}
function $66b21aa7bd8497fc$var$expandTagDescription(description) {
    return typeof description === "string" ? {
        type: description
    } : description;
}
// src/tsHelpers.ts
function $66b21aa7bd8497fc$var$asSafePromise(promise, fallback) {
    return promise.catch(fallback);
}
// src/query/apiTypes.ts
var $66b21aa7bd8497fc$var$getEndpointDefinition = (context, endpointName)=>context.endpointDefinitions[endpointName];
// src/query/core/buildInitiate.ts
var $66b21aa7bd8497fc$var$forceQueryFnSymbol = /* @__PURE__ */ Symbol("forceQueryFn");
var $66b21aa7bd8497fc$var$isUpsertQuery = (arg)=>typeof arg[$66b21aa7bd8497fc$var$forceQueryFnSymbol] === "function";
function $66b21aa7bd8497fc$var$buildInitiate({ serializeQueryArgs: serializeQueryArgs, queryThunk: queryThunk, infiniteQueryThunk: infiniteQueryThunk, mutationThunk: mutationThunk, api: api, context: context, getInternalState: getInternalState }) {
    const getRunningQueries = (dispatch)=>{
        var _a;
        return (_a = getInternalState(dispatch)) == null ? void 0 : _a.runningQueries;
    };
    const getRunningMutations = (dispatch)=>{
        var _a;
        return (_a = getInternalState(dispatch)) == null ? void 0 : _a.runningMutations;
    };
    const { unsubscribeQueryResult: unsubscribeQueryResult, removeMutationResult: removeMutationResult, updateSubscriptionOptions: updateSubscriptionOptions } = api.internalActions;
    return {
        buildInitiateQuery: buildInitiateQuery,
        buildInitiateInfiniteQuery: buildInitiateInfiniteQuery,
        buildInitiateMutation: buildInitiateMutation,
        getRunningQueryThunk: getRunningQueryThunk,
        getRunningMutationThunk: getRunningMutationThunk,
        getRunningQueriesThunk: getRunningQueriesThunk,
        getRunningMutationsThunk: getRunningMutationsThunk
    };
    function getRunningQueryThunk(endpointName, queryArgs) {
        return (dispatch)=>{
            var _a;
            const endpointDefinition = $66b21aa7bd8497fc$var$getEndpointDefinition(context, endpointName);
            const queryCacheKey = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            return (_a = getRunningQueries(dispatch)) == null ? void 0 : _a.get(queryCacheKey);
        };
    }
    function getRunningMutationThunk(_endpointName, fixedCacheKeyOrRequestId) {
        return (dispatch)=>{
            var _a;
            return (_a = getRunningMutations(dispatch)) == null ? void 0 : _a.get(fixedCacheKeyOrRequestId);
        };
    }
    function getRunningQueriesThunk() {
        return (dispatch)=>$66b21aa7bd8497fc$var$filterNullishValues(getRunningQueries(dispatch));
    }
    function getRunningMutationsThunk() {
        return (dispatch)=>$66b21aa7bd8497fc$var$filterNullishValues(getRunningMutations(dispatch));
    }
    function middlewareWarning(dispatch) {}
    function buildInitiateAnyQuery(endpointName, endpointDefinition) {
        const queryAction = (arg, _a = {})=>{
            var _b = _a, { subscribe: subscribe = true, forceRefetch: forceRefetch, subscriptionOptions: subscriptionOptions, [$66b21aa7bd8497fc$var$forceQueryFnSymbol]: forceQueryFn } = _b, rest = $66b21aa7bd8497fc$var$__objRest(_b, [
                "subscribe",
                "forceRefetch",
                "subscriptionOptions",
                $66b21aa7bd8497fc$var$__restKey($66b21aa7bd8497fc$var$forceQueryFnSymbol)
            ]);
            return (dispatch, getState)=>{
                var _a2;
                const queryCacheKey = serializeQueryArgs({
                    queryArgs: arg,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                });
                let thunk;
                const commonThunkArgs = $66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, rest), {
                    type: $66b21aa7bd8497fc$var$ENDPOINT_QUERY,
                    subscribe: subscribe,
                    forceRefetch: forceRefetch,
                    subscriptionOptions: subscriptionOptions,
                    endpointName: endpointName,
                    originalArgs: arg,
                    queryCacheKey: queryCacheKey,
                    [$66b21aa7bd8497fc$var$forceQueryFnSymbol]: forceQueryFn
                });
                if ($66b21aa7bd8497fc$var$isQueryDefinition(endpointDefinition)) thunk = queryThunk(commonThunkArgs);
                else {
                    const { direction: direction, initialPageParam: initialPageParam, refetchCachedPages: refetchCachedPages } = rest;
                    thunk = infiniteQueryThunk($66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, commonThunkArgs), {
                        direction: // Supply these even if undefined. This helps with a field existence
                        // check over in `buildSlice.ts`
                        direction,
                        initialPageParam: initialPageParam,
                        refetchCachedPages: refetchCachedPages
                    }));
                }
                const selector = api.endpoints[endpointName].select(arg);
                const thunkResult = dispatch(thunk);
                const stateAfter = selector(getState());
                middlewareWarning(dispatch);
                const { requestId: requestId, abort: abort } = thunkResult;
                const skippedSynchronously = stateAfter.requestId !== requestId;
                const runningQuery = (_a2 = getRunningQueries(dispatch)) == null ? void 0 : _a2.get(queryCacheKey);
                const selectFromState = ()=>selector(getState());
                const statePromise = Object.assign(forceQueryFn ? // a query has been forced (upsertQueryData)
                // -> we want to resolve it once data has been written with the data that will be written
                thunkResult.then(selectFromState) : skippedSynchronously && !runningQuery ? // a query has been skipped due to a condition and we do not have any currently running query
                // -> we want to resolve it immediately with the current data
                Promise.resolve(stateAfter) : // query just started or one is already in flight
                // -> wait for the running query, then resolve with data from after that
                Promise.all([
                    runningQuery,
                    thunkResult
                ]).then(selectFromState), {
                    arg: arg,
                    requestId: requestId,
                    subscriptionOptions: subscriptionOptions,
                    queryCacheKey: queryCacheKey,
                    abort: abort,
                    async unwrap () {
                        const result = await statePromise;
                        if (result.isError) throw result.error;
                        return result.data;
                    },
                    refetch: (options)=>dispatch(queryAction(arg, $66b21aa7bd8497fc$var$__spreadValues({
                            subscribe: false,
                            forceRefetch: true
                        }, options))),
                    unsubscribe () {
                        if (subscribe) dispatch(unsubscribeQueryResult({
                            queryCacheKey: queryCacheKey,
                            requestId: requestId
                        }));
                    },
                    updateSubscriptionOptions (options) {
                        statePromise.subscriptionOptions = options;
                        dispatch(updateSubscriptionOptions({
                            endpointName: endpointName,
                            requestId: requestId,
                            queryCacheKey: queryCacheKey,
                            options: options
                        }));
                    }
                });
                if (!runningQuery && !skippedSynchronously && !forceQueryFn) {
                    const runningQueries = getRunningQueries(dispatch);
                    runningQueries.set(queryCacheKey, statePromise);
                    statePromise.then(()=>{
                        runningQueries.delete(queryCacheKey);
                    });
                }
                return statePromise;
            };
        };
        return queryAction;
    }
    function buildInitiateQuery(endpointName, endpointDefinition) {
        const queryAction = buildInitiateAnyQuery(endpointName, endpointDefinition);
        return queryAction;
    }
    function buildInitiateInfiniteQuery(endpointName, endpointDefinition) {
        const infiniteQueryAction = buildInitiateAnyQuery(endpointName, endpointDefinition);
        return infiniteQueryAction;
    }
    function buildInitiateMutation(endpointName) {
        return (arg, { track: track = true, fixedCacheKey: fixedCacheKey } = {})=>(dispatch, getState)=>{
                const thunk = mutationThunk({
                    type: "mutation",
                    endpointName: endpointName,
                    originalArgs: arg,
                    track: track,
                    fixedCacheKey: fixedCacheKey
                });
                const thunkResult = dispatch(thunk);
                middlewareWarning(dispatch);
                const { requestId: requestId, abort: abort, unwrap: unwrap } = thunkResult;
                const returnValuePromise = $66b21aa7bd8497fc$var$asSafePromise(thunkResult.unwrap().then((data)=>({
                        data: data
                    })), (error)=>({
                        error: error
                    }));
                const reset = ()=>{
                    dispatch(removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                };
                const ret = Object.assign(returnValuePromise, {
                    arg: thunkResult.arg,
                    requestId: requestId,
                    abort: abort,
                    unwrap: unwrap,
                    reset: reset
                });
                const runningMutations = getRunningMutations(dispatch);
                runningMutations.set(requestId, ret);
                ret.then(()=>{
                    runningMutations.delete(requestId);
                });
                if (fixedCacheKey) {
                    runningMutations.set(fixedCacheKey, ret);
                    ret.then(()=>{
                        if (runningMutations.get(fixedCacheKey) === ret) runningMutations.delete(fixedCacheKey);
                    });
                }
                return ret;
            };
    }
}
var $66b21aa7bd8497fc$export$6c822e36c9b9dfb4 = class extends (0, $fKdhF.SchemaError) {
    constructor(issues, value, schemaName, _bqMeta){
        super(issues);
        $66b21aa7bd8497fc$var$__publicField(this, "value", value);
        $66b21aa7bd8497fc$var$__publicField(this, "schemaName", schemaName);
        $66b21aa7bd8497fc$var$__publicField(this, "_bqMeta", _bqMeta);
    }
};
var $66b21aa7bd8497fc$var$shouldSkip = (skipSchemaValidation, schemaName)=>Array.isArray(skipSchemaValidation) ? skipSchemaValidation.includes(schemaName) : !!skipSchemaValidation;
async function $66b21aa7bd8497fc$var$parseWithSchema(schema, data, schemaName, bqMeta) {
    const result = await schema["~standard"].validate(data);
    if (result.issues) throw new $66b21aa7bd8497fc$export$6c822e36c9b9dfb4(result.issues, data, schemaName, bqMeta);
    return result.value;
}
// src/query/core/buildThunks.ts
function $66b21aa7bd8497fc$var$defaultTransformResponse(baseQueryReturnValue) {
    return baseQueryReturnValue;
}
var $66b21aa7bd8497fc$var$addShouldAutoBatch = (arg = {})=>{
    return $66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, arg), {
        [(0, $iDqdB.SHOULD_AUTOBATCH)]: true
    });
};
function $66b21aa7bd8497fc$var$buildThunks({ reducerPath: reducerPath, baseQuery: baseQuery, context: { endpointDefinitions: endpointDefinitions }, serializeQueryArgs: serializeQueryArgs, api: api, assertTagType: assertTagType, selectors: selectors, onSchemaFailure: onSchemaFailure, catchSchemaFailure: globalCatchSchemaFailure, skipSchemaValidation: globalSkipSchemaValidation }) {
    const patchQueryData = (endpointName, arg, patches, updateProvided)=>(dispatch, getState)=>{
            const endpointDefinition = endpointDefinitions[endpointName];
            const queryCacheKey = serializeQueryArgs({
                queryArgs: arg,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            dispatch(api.internalActions.queryResultPatched({
                queryCacheKey: queryCacheKey,
                patches: patches
            }));
            if (!updateProvided) return;
            const newValue = api.endpoints[endpointName].select(arg)(// Work around TS 4.1 mismatch
            getState());
            const providedTags = $66b21aa7bd8497fc$var$calculateProvidedBy(endpointDefinition.providesTags, newValue.data, void 0, arg, {}, assertTagType);
            dispatch(api.internalActions.updateProvidedBy([
                {
                    queryCacheKey: queryCacheKey,
                    providedTags: providedTags
                }
            ]));
        };
    function addToStart(items, item, max = 0) {
        const newItems = [
            item,
            ...items
        ];
        return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
    }
    function addToEnd(items, item, max = 0) {
        const newItems = [
            ...items,
            item
        ];
        return max && newItems.length > max ? newItems.slice(1) : newItems;
    }
    const updateQueryData = (endpointName, arg, updateRecipe, updateProvided = true)=>(dispatch, getState)=>{
            const endpointDefinition = api.endpoints[endpointName];
            const currentState = endpointDefinition.select(arg)(// Work around TS 4.1 mismatch
            getState());
            const ret = {
                patches: [],
                inversePatches: [],
                undo: ()=>dispatch(api.util.patchQueryData(endpointName, arg, ret.inversePatches, updateProvided))
            };
            if (currentState.status === $66b21aa7bd8497fc$var$STATUS_UNINITIALIZED) return ret;
            let newValue;
            if ("data" in currentState) {
                if ((0, $fTaOL.isDraftable)(currentState.data)) {
                    const [value, patches, inversePatches] = (0, $fTaOL.produceWithPatches)(currentState.data, updateRecipe);
                    ret.patches.push(...patches);
                    ret.inversePatches.push(...inversePatches);
                    newValue = value;
                } else {
                    newValue = updateRecipe(currentState.data);
                    ret.patches.push({
                        op: "replace",
                        path: [],
                        value: newValue
                    });
                    ret.inversePatches.push({
                        op: "replace",
                        path: [],
                        value: currentState.data
                    });
                }
            }
            if (ret.patches.length === 0) return ret;
            dispatch(api.util.patchQueryData(endpointName, arg, ret.patches, updateProvided));
            return ret;
        };
    const upsertQueryData = (endpointName, arg, value)=>(dispatch)=>{
            const res = dispatch(api.endpoints[endpointName].initiate(arg, {
                subscribe: false,
                forceRefetch: true,
                [$66b21aa7bd8497fc$var$forceQueryFnSymbol]: ()=>({
                        data: value
                    })
            }));
            return res;
        };
    const getTransformCallbackForEndpoint = (endpointDefinition, transformFieldName)=>{
        return endpointDefinition.query && endpointDefinition[transformFieldName] ? endpointDefinition[transformFieldName] : $66b21aa7bd8497fc$var$defaultTransformResponse;
    };
    const executeEndpoint = async (arg, { signal: signal, abort: abort, rejectWithValue: rejectWithValue, fulfillWithValue: fulfillWithValue, dispatch: dispatch, getState: getState, extra: extra })=>{
        var _a, _b, _c, _d, _e, _f;
        const endpointDefinition = endpointDefinitions[arg.endpointName];
        const { metaSchema: metaSchema, skipSchemaValidation: skipSchemaValidation = globalSkipSchemaValidation } = endpointDefinition;
        const isQuery = arg.type === $66b21aa7bd8497fc$var$ENDPOINT_QUERY;
        try {
            let transformResponse = $66b21aa7bd8497fc$var$defaultTransformResponse;
            const baseQueryApi = {
                signal: signal,
                abort: abort,
                dispatch: dispatch,
                getState: getState,
                extra: extra,
                endpoint: arg.endpointName,
                type: arg.type,
                forced: isQuery ? isForcedQuery(arg, getState()) : void 0,
                queryCacheKey: isQuery ? arg.queryCacheKey : void 0
            };
            const forceQueryFn = isQuery ? arg[$66b21aa7bd8497fc$var$forceQueryFnSymbol] : void 0;
            let finalQueryReturnValue;
            const fetchPage = async (data, param, maxPages, previous)=>{
                if (param == null && data.pages.length) return Promise.resolve({
                    data: data
                });
                const finalQueryArg = {
                    queryArg: arg.originalArgs,
                    pageParam: param
                };
                const pageResponse = await executeRequest(finalQueryArg);
                const addTo = previous ? addToStart : addToEnd;
                return {
                    data: {
                        pages: addTo(data.pages, pageResponse.data, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    },
                    meta: pageResponse.meta
                };
            };
            async function executeRequest(finalQueryArg) {
                let result;
                const { extraOptions: extraOptions, argSchema: argSchema, rawResponseSchema: rawResponseSchema, responseSchema: responseSchema } = endpointDefinition;
                if (argSchema && !$66b21aa7bd8497fc$var$shouldSkip(skipSchemaValidation, "arg")) finalQueryArg = await $66b21aa7bd8497fc$var$parseWithSchema(argSchema, finalQueryArg, "argSchema", {});
                if (forceQueryFn) result = forceQueryFn();
                else if (endpointDefinition.query) {
                    transformResponse = getTransformCallbackForEndpoint(endpointDefinition, "transformResponse");
                    result = await baseQuery(endpointDefinition.query(finalQueryArg), baseQueryApi, extraOptions);
                } else result = await endpointDefinition.queryFn(finalQueryArg, baseQueryApi, extraOptions, (arg2)=>baseQuery(arg2, baseQueryApi, extraOptions));
                if (result.error) throw new $66b21aa7bd8497fc$var$HandledError(result.error, result.meta);
                let { data: data } = result;
                if (rawResponseSchema && !$66b21aa7bd8497fc$var$shouldSkip(skipSchemaValidation, "rawResponse")) data = await $66b21aa7bd8497fc$var$parseWithSchema(rawResponseSchema, result.data, "rawResponseSchema", result.meta);
                let transformedResponse = await transformResponse(data, result.meta, finalQueryArg);
                if (responseSchema && !$66b21aa7bd8497fc$var$shouldSkip(skipSchemaValidation, "response")) transformedResponse = await $66b21aa7bd8497fc$var$parseWithSchema(responseSchema, transformedResponse, "responseSchema", result.meta);
                return $66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, result), {
                    data: transformedResponse
                });
            }
            if (isQuery && "infiniteQueryOptions" in endpointDefinition) {
                const { infiniteQueryOptions: infiniteQueryOptions } = endpointDefinition;
                const { maxPages: maxPages = Infinity } = infiniteQueryOptions;
                const refetchCachedPages = (_b = (_a = arg.refetchCachedPages) != null ? _a : infiniteQueryOptions.refetchCachedPages) != null ? _b : true;
                let result;
                const blankData = {
                    pages: [],
                    pageParams: []
                };
                const cachedData = (_c = selectors.selectQueryEntry(getState(), arg.queryCacheKey)) == null ? void 0 : _c.data;
                const isForcedQueryNeedingRefetch = // arg.forceRefetch
                isForcedQuery(arg, getState()) && !arg.direction;
                const existingData = isForcedQueryNeedingRefetch || !cachedData ? blankData : cachedData;
                if ("direction" in arg && arg.direction && existingData.pages.length) {
                    const previous = arg.direction === "backward";
                    const pageParamFn = previous ? $66b21aa7bd8497fc$var$getPreviousPageParam : $66b21aa7bd8497fc$var$getNextPageParam;
                    const param = pageParamFn(infiniteQueryOptions, existingData, arg.originalArgs);
                    result = await fetchPage(existingData, param, maxPages, previous);
                } else {
                    const { initialPageParam: initialPageParam = infiniteQueryOptions.initialPageParam } = arg;
                    const cachedPageParams = (_d = cachedData == null ? void 0 : cachedData.pageParams) != null ? _d : [];
                    const firstPageParam = (_e = cachedPageParams[0]) != null ? _e : initialPageParam;
                    const totalPages = cachedPageParams.length;
                    result = await fetchPage(existingData, firstPageParam, maxPages);
                    if (forceQueryFn) result = {
                        data: result.data.pages[0]
                    };
                    if (refetchCachedPages) for(let i = 1; i < totalPages; i++){
                        const param = $66b21aa7bd8497fc$var$getNextPageParam(infiniteQueryOptions, result.data, arg.originalArgs);
                        result = await fetchPage(result.data, param, maxPages);
                    }
                }
                finalQueryReturnValue = result;
            } else finalQueryReturnValue = await executeRequest(arg.originalArgs);
            if (metaSchema && !$66b21aa7bd8497fc$var$shouldSkip(skipSchemaValidation, "meta") && finalQueryReturnValue.meta) finalQueryReturnValue.meta = await $66b21aa7bd8497fc$var$parseWithSchema(metaSchema, finalQueryReturnValue.meta, "metaSchema", finalQueryReturnValue.meta);
            return fulfillWithValue(finalQueryReturnValue.data, $66b21aa7bd8497fc$var$addShouldAutoBatch({
                fulfilledTimeStamp: Date.now(),
                baseQueryMeta: finalQueryReturnValue.meta
            }));
        } catch (error) {
            let caughtError = error;
            if (caughtError instanceof $66b21aa7bd8497fc$var$HandledError) {
                let transformErrorResponse = getTransformCallbackForEndpoint(endpointDefinition, "transformErrorResponse");
                const { rawErrorResponseSchema: rawErrorResponseSchema, errorResponseSchema: errorResponseSchema } = endpointDefinition;
                let { value: value, meta: meta } = caughtError;
                try {
                    if (rawErrorResponseSchema && !$66b21aa7bd8497fc$var$shouldSkip(skipSchemaValidation, "rawErrorResponse")) value = await $66b21aa7bd8497fc$var$parseWithSchema(rawErrorResponseSchema, value, "rawErrorResponseSchema", meta);
                    if (metaSchema && !$66b21aa7bd8497fc$var$shouldSkip(skipSchemaValidation, "meta")) meta = await $66b21aa7bd8497fc$var$parseWithSchema(metaSchema, meta, "metaSchema", meta);
                    let transformedErrorResponse = await transformErrorResponse(value, meta, arg.originalArgs);
                    if (errorResponseSchema && !$66b21aa7bd8497fc$var$shouldSkip(skipSchemaValidation, "errorResponse")) transformedErrorResponse = await $66b21aa7bd8497fc$var$parseWithSchema(errorResponseSchema, transformedErrorResponse, "errorResponseSchema", meta);
                    return rejectWithValue(transformedErrorResponse, $66b21aa7bd8497fc$var$addShouldAutoBatch({
                        baseQueryMeta: meta
                    }));
                } catch (e) {
                    caughtError = e;
                }
            }
            try {
                if (caughtError instanceof $66b21aa7bd8497fc$export$6c822e36c9b9dfb4) {
                    const info = {
                        endpoint: arg.endpointName,
                        arg: arg.originalArgs,
                        type: arg.type,
                        queryCacheKey: isQuery ? arg.queryCacheKey : void 0
                    };
                    (_f = endpointDefinition.onSchemaFailure) == null || _f.call(endpointDefinition, caughtError, info);
                    onSchemaFailure == null || onSchemaFailure(caughtError, info);
                    const { catchSchemaFailure: catchSchemaFailure = globalCatchSchemaFailure } = endpointDefinition;
                    if (catchSchemaFailure) return rejectWithValue(catchSchemaFailure(caughtError, info), $66b21aa7bd8497fc$var$addShouldAutoBatch({
                        baseQueryMeta: caughtError._bqMeta
                    }));
                }
            } catch (e) {
                caughtError = e;
            }
            console.error(caughtError);
            throw caughtError;
        }
    };
    function isForcedQuery(arg, state) {
        var _a;
        const requestState = selectors.selectQueryEntry(state, arg.queryCacheKey);
        const baseFetchOnMountOrArgChange = selectors.selectConfig(state).refetchOnMountOrArgChange;
        const fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
        const refetchVal = (_a = arg.forceRefetch) != null ? _a : arg.subscribe && baseFetchOnMountOrArgChange;
        if (refetchVal) return refetchVal === true || (Number(/* @__PURE__ */ new Date()) - Number(fulfilledVal)) / 1e3 >= refetchVal;
        return false;
    }
    const createQueryThunk = ()=>{
        const generatedQueryThunk = (0, $iDqdB.createAsyncThunk)(`${reducerPath}/executeQuery`, executeEndpoint, {
            getPendingMeta ({ arg: arg }) {
                const endpointDefinition = endpointDefinitions[arg.endpointName];
                return $66b21aa7bd8497fc$var$addShouldAutoBatch($66b21aa7bd8497fc$var$__spreadValues({
                    startedTimeStamp: Date.now()
                }, $66b21aa7bd8497fc$var$isInfiniteQueryDefinition(endpointDefinition) ? {
                    direction: arg.direction
                } : {}));
            },
            condition (queryThunkArg, { getState: getState }) {
                var _a;
                const state = getState();
                const requestState = selectors.selectQueryEntry(state, queryThunkArg.queryCacheKey);
                const fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
                const currentArg = queryThunkArg.originalArgs;
                const previousArg = requestState == null ? void 0 : requestState.originalArgs;
                const endpointDefinition = endpointDefinitions[queryThunkArg.endpointName];
                const direction = queryThunkArg.direction;
                if ($66b21aa7bd8497fc$var$isUpsertQuery(queryThunkArg)) return true;
                if ((requestState == null ? void 0 : requestState.status) === "pending") return false;
                if (isForcedQuery(queryThunkArg, state)) return true;
                if ($66b21aa7bd8497fc$var$isQueryDefinition(endpointDefinition) && ((_a = endpointDefinition == null ? void 0 : endpointDefinition.forceRefetch) == null ? void 0 : _a.call(endpointDefinition, {
                    currentArg: currentArg,
                    previousArg: previousArg,
                    endpointState: requestState,
                    state: state
                }))) return true;
                if (fulfilledVal && !direction) return false;
                return true;
            },
            dispatchConditionRejection: true
        });
        return generatedQueryThunk;
    };
    const queryThunk = createQueryThunk();
    const infiniteQueryThunk = createQueryThunk();
    const mutationThunk = (0, $iDqdB.createAsyncThunk)(`${reducerPath}/executeMutation`, executeEndpoint, {
        getPendingMeta () {
            return $66b21aa7bd8497fc$var$addShouldAutoBatch({
                startedTimeStamp: Date.now()
            });
        }
    });
    const hasTheForce = (options)=>"force" in options;
    const hasMaxAge = (options)=>"ifOlderThan" in options;
    const prefetch = (endpointName, arg, options = {})=>(dispatch, getState)=>{
            const force = hasTheForce(options) && options.force;
            const maxAge = hasMaxAge(options) && options.ifOlderThan;
            const queryAction = (force2 = true)=>{
                const options2 = {
                    forceRefetch: force2,
                    subscribe: false
                };
                return api.endpoints[endpointName].initiate(arg, options2);
            };
            const latestStateValue = api.endpoints[endpointName].select(arg)(getState());
            if (force) dispatch(queryAction());
            else if (maxAge) {
                const lastFulfilledTs = latestStateValue == null ? void 0 : latestStateValue.fulfilledTimeStamp;
                if (!lastFulfilledTs) {
                    dispatch(queryAction());
                    return;
                }
                const shouldRetrigger = (Number(/* @__PURE__ */ new Date()) - Number(new Date(lastFulfilledTs))) / 1e3 >= maxAge;
                if (shouldRetrigger) dispatch(queryAction());
            } else dispatch(queryAction(false));
        };
    function matchesEndpoint(endpointName) {
        return (action)=>{
            var _a, _b;
            return ((_b = (_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.arg) == null ? void 0 : _b.endpointName) === endpointName;
        };
    }
    function buildMatchThunkActions(thunk, endpointName) {
        return {
            matchPending: (0, $iDqdB.isAllOf)((0, $iDqdB.isPending)(thunk), matchesEndpoint(endpointName)),
            matchFulfilled: (0, $iDqdB.isAllOf)((0, $iDqdB.isFulfilled)(thunk), matchesEndpoint(endpointName)),
            matchRejected: (0, $iDqdB.isAllOf)((0, $iDqdB.isRejected)(thunk), matchesEndpoint(endpointName))
        };
    }
    return {
        queryThunk: queryThunk,
        mutationThunk: mutationThunk,
        infiniteQueryThunk: infiniteQueryThunk,
        prefetch: prefetch,
        updateQueryData: updateQueryData,
        upsertQueryData: upsertQueryData,
        patchQueryData: patchQueryData,
        buildMatchThunkActions: buildMatchThunkActions
    };
}
function $66b21aa7bd8497fc$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }, queryArg) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams, queryArg);
}
function $66b21aa7bd8497fc$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }, queryArg) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams, queryArg);
}
function $66b21aa7bd8497fc$var$calculateProvidedByThunk(action, type, endpointDefinitions, assertTagType) {
    return $66b21aa7bd8497fc$var$calculateProvidedBy(endpointDefinitions[action.meta.arg.endpointName][type], (0, $iDqdB.isFulfilled)(action) ? action.payload : void 0, (0, $iDqdB.isRejectedWithValue)(action) ? action.payload : void 0, action.meta.arg.originalArgs, "baseQueryMeta" in action.meta ? action.meta.baseQueryMeta : void 0, assertTagType);
}
// src/query/utils/getCurrent.ts
function $66b21aa7bd8497fc$var$getCurrent(value) {
    return (0, $fTaOL.isDraft)(value) ? (0, $fTaOL.current)(value) : value;
}
// src/query/core/buildSlice.ts
function $66b21aa7bd8497fc$var$updateQuerySubstateIfExists(state, queryCacheKey, update) {
    const substate = state[queryCacheKey];
    if (substate) update(substate);
}
function $66b21aa7bd8497fc$var$getMutationCacheKey(id) {
    var _a;
    return (_a = "arg" in id ? id.arg.fixedCacheKey : id.fixedCacheKey) != null ? _a : id.requestId;
}
function $66b21aa7bd8497fc$var$updateMutationSubstateIfExists(state, id, update) {
    const substate = state[$66b21aa7bd8497fc$var$getMutationCacheKey(id)];
    if (substate) update(substate);
}
var $66b21aa7bd8497fc$var$initialState = {};
function $66b21aa7bd8497fc$var$buildSlice({ reducerPath: reducerPath, queryThunk: queryThunk, mutationThunk: mutationThunk, serializeQueryArgs: serializeQueryArgs, context: { endpointDefinitions: definitions, apiUid: apiUid, extractRehydrationInfo: extractRehydrationInfo, hasRehydrationInfo: hasRehydrationInfo }, assertTagType: assertTagType, config: config }) {
    const resetApiState = (0, $iDqdB.createAction)(`${reducerPath}/resetApiState`);
    function writePendingCacheEntry(draft, arg, upserting, meta) {
        var _a, _b;
        (_b = draft[_a = arg.queryCacheKey]) != null ? _b : draft[_a] = {
            status: $66b21aa7bd8497fc$var$STATUS_UNINITIALIZED,
            endpointName: arg.endpointName
        };
        $66b21aa7bd8497fc$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, (substate)=>{
            substate.status = $66b21aa7bd8497fc$var$STATUS_PENDING;
            substate.requestId = upserting && substate.requestId ? // for `upsertQuery` **updates**, keep the current `requestId`
            substate.requestId : // for normal queries or `upsertQuery` **inserts** always update the `requestId`
            meta.requestId;
            if (arg.originalArgs !== void 0) substate.originalArgs = arg.originalArgs;
            substate.startedTimeStamp = meta.startedTimeStamp;
            const endpointDefinition = definitions[meta.arg.endpointName];
            if ($66b21aa7bd8497fc$var$isInfiniteQueryDefinition(endpointDefinition) && "direction" in arg) substate.direction = arg.direction;
        });
    }
    function writeFulfilledCacheEntry(draft, meta, payload, upserting) {
        $66b21aa7bd8497fc$var$updateQuerySubstateIfExists(draft, meta.arg.queryCacheKey, (substate)=>{
            var _a;
            if (substate.requestId !== meta.requestId && !upserting) return;
            const { merge: merge } = definitions[meta.arg.endpointName];
            substate.status = $66b21aa7bd8497fc$var$STATUS_FULFILLED;
            if (merge) {
                if (substate.data !== void 0) {
                    const { fulfilledTimeStamp: fulfilledTimeStamp, arg: arg, baseQueryMeta: baseQueryMeta, requestId: requestId } = meta;
                    let newData = (0, $fTaOL.produce)(substate.data, (draftSubstateData)=>{
                        return merge(draftSubstateData, payload, {
                            arg: arg.originalArgs,
                            baseQueryMeta: baseQueryMeta,
                            fulfilledTimeStamp: fulfilledTimeStamp,
                            requestId: requestId
                        });
                    });
                    substate.data = newData;
                } else substate.data = payload;
            } else substate.data = ((_a = definitions[meta.arg.endpointName].structuralSharing) != null ? _a : true) ? $66b21aa7bd8497fc$export$b64d4502a1c929bd((0, $fTaOL.isDraft)(substate.data) ? (0, $fTaOL.original)(substate.data) : substate.data, payload) : payload;
            delete substate.error;
            substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
        });
    }
    const querySlice = (0, $iDqdB.createSlice)({
        name: `${reducerPath}/queries`,
        initialState: $66b21aa7bd8497fc$var$initialState,
        reducers: {
            removeQueryResult: {
                reducer (draft, { payload: { queryCacheKey: queryCacheKey } }) {
                    delete draft[queryCacheKey];
                },
                prepare: (0, $iDqdB.prepareAutoBatched)()
            },
            cacheEntriesUpserted: {
                reducer (draft, action) {
                    for (const entry of action.payload){
                        const { queryDescription: arg, value: value } = entry;
                        writePendingCacheEntry(draft, arg, true, {
                            arg: arg,
                            requestId: action.meta.requestId,
                            startedTimeStamp: action.meta.timestamp
                        });
                        writeFulfilledCacheEntry(draft, {
                            arg: arg,
                            requestId: action.meta.requestId,
                            fulfilledTimeStamp: action.meta.timestamp,
                            baseQueryMeta: {}
                        }, value, // We know we're upserting here
                        true);
                    }
                },
                prepare: (payload)=>{
                    const queryDescriptions = payload.map((entry)=>{
                        const { endpointName: endpointName, arg: arg, value: value } = entry;
                        const endpointDefinition = definitions[endpointName];
                        const queryDescription = {
                            type: $66b21aa7bd8497fc$var$ENDPOINT_QUERY,
                            endpointName: endpointName,
                            originalArgs: entry.arg,
                            queryCacheKey: serializeQueryArgs({
                                queryArgs: arg,
                                endpointDefinition: endpointDefinition,
                                endpointName: endpointName
                            })
                        };
                        return {
                            queryDescription: queryDescription,
                            value: value
                        };
                    });
                    const result = {
                        payload: queryDescriptions,
                        meta: {
                            [(0, $iDqdB.SHOULD_AUTOBATCH)]: true,
                            requestId: (0, $iDqdB.nanoid)(),
                            timestamp: Date.now()
                        }
                    };
                    return result;
                }
            },
            queryResultPatched: {
                reducer (draft, { payload: { queryCacheKey: queryCacheKey, patches: patches } }) {
                    $66b21aa7bd8497fc$var$updateQuerySubstateIfExists(draft, queryCacheKey, (substate)=>{
                        substate.data = (0, $fTaOL.applyPatches)(substate.data, patches.concat());
                    });
                },
                prepare: (0, $iDqdB.prepareAutoBatched)()
            }
        },
        extraReducers (builder) {
            builder.addCase(queryThunk.pending, (draft, { meta: meta, meta: { arg: arg } })=>{
                const upserting = $66b21aa7bd8497fc$var$isUpsertQuery(arg);
                writePendingCacheEntry(draft, arg, upserting, meta);
            }).addCase(queryThunk.fulfilled, (draft, { meta: meta, payload: payload })=>{
                const upserting = $66b21aa7bd8497fc$var$isUpsertQuery(meta.arg);
                writeFulfilledCacheEntry(draft, meta, payload, upserting);
            }).addCase(queryThunk.rejected, (draft, { meta: { condition: condition, arg: arg, requestId: requestId }, error: error, payload: payload })=>{
                $66b21aa7bd8497fc$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, (substate)=>{
                    if (condition) ;
                    else {
                        if (substate.requestId !== requestId) return;
                        substate.status = $66b21aa7bd8497fc$var$STATUS_REJECTED;
                        substate.error = payload != null ? payload : error;
                    }
                });
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                const { queries: queries } = extractRehydrationInfo(action);
                for (const [key, entry] of Object.entries(queries))if (// do not rehydrate entries that were currently in flight.
                (entry == null ? void 0 : entry.status) === $66b21aa7bd8497fc$var$STATUS_FULFILLED || (entry == null ? void 0 : entry.status) === $66b21aa7bd8497fc$var$STATUS_REJECTED) draft[key] = entry;
            });
        }
    });
    const mutationSlice = (0, $iDqdB.createSlice)({
        name: `${reducerPath}/mutations`,
        initialState: $66b21aa7bd8497fc$var$initialState,
        reducers: {
            removeMutationResult: {
                reducer (draft, { payload: payload }) {
                    const cacheKey = $66b21aa7bd8497fc$var$getMutationCacheKey(payload);
                    if (cacheKey in draft) delete draft[cacheKey];
                },
                prepare: (0, $iDqdB.prepareAutoBatched)()
            }
        },
        extraReducers (builder) {
            builder.addCase(mutationThunk.pending, (draft, { meta: meta, meta: { requestId: requestId, arg: arg, startedTimeStamp: startedTimeStamp } })=>{
                if (!arg.track) return;
                draft[$66b21aa7bd8497fc$var$getMutationCacheKey(meta)] = {
                    requestId: requestId,
                    status: $66b21aa7bd8497fc$var$STATUS_PENDING,
                    endpointName: arg.endpointName,
                    startedTimeStamp: startedTimeStamp
                };
            }).addCase(mutationThunk.fulfilled, (draft, { payload: payload, meta: meta })=>{
                if (!meta.arg.track) return;
                $66b21aa7bd8497fc$var$updateMutationSubstateIfExists(draft, meta, (substate)=>{
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $66b21aa7bd8497fc$var$STATUS_FULFILLED;
                    substate.data = payload;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(mutationThunk.rejected, (draft, { payload: payload, error: error, meta: meta })=>{
                if (!meta.arg.track) return;
                $66b21aa7bd8497fc$var$updateMutationSubstateIfExists(draft, meta, (substate)=>{
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $66b21aa7bd8497fc$var$STATUS_REJECTED;
                    substate.error = payload != null ? payload : error;
                });
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                const { mutations: mutations } = extractRehydrationInfo(action);
                for (const [key, entry] of Object.entries(mutations))if (// do not rehydrate entries that were currently in flight.
                ((entry == null ? void 0 : entry.status) === $66b21aa7bd8497fc$var$STATUS_FULFILLED || (entry == null ? void 0 : entry.status) === $66b21aa7bd8497fc$var$STATUS_REJECTED) && // only rehydrate endpoints that were persisted using a `fixedCacheKey`
                key !== (entry == null ? void 0 : entry.requestId)) draft[key] = entry;
            });
        }
    });
    const initialInvalidationState = {
        tags: {},
        keys: {}
    };
    const invalidationSlice = (0, $iDqdB.createSlice)({
        name: `${reducerPath}/invalidation`,
        initialState: initialInvalidationState,
        reducers: {
            updateProvidedBy: {
                reducer (draft, action) {
                    var _a, _b, _c, _d, _e;
                    for (const { queryCacheKey: queryCacheKey, providedTags: providedTags } of action.payload){
                        removeCacheKeyFromTags(draft, queryCacheKey);
                        for (const { type: type, id: id } of providedTags){
                            const subscribedQueries = (_e = (_c = (_b = (_a = draft.tags)[type]) != null ? _b : _a[type] = {})[_d = id || "__internal_without_id"]) != null ? _e : _c[_d] = [];
                            const alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                            if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                        }
                        draft.keys[queryCacheKey] = providedTags;
                    }
                },
                prepare: (0, $iDqdB.prepareAutoBatched)()
            }
        },
        extraReducers (builder) {
            builder.addCase(querySlice.actions.removeQueryResult, (draft, { payload: { queryCacheKey: queryCacheKey } })=>{
                removeCacheKeyFromTags(draft, queryCacheKey);
            }).addMatcher(hasRehydrationInfo, (draft, action)=>{
                var _a, _b, _c, _d, _e, _f;
                const { provided: provided } = extractRehydrationInfo(action);
                for (const [type, incomingTags] of Object.entries((_a = provided.tags) != null ? _a : {}))for (const [id, cacheKeys] of Object.entries(incomingTags)){
                    const subscribedQueries = (_f = (_d = (_c = (_b = draft.tags)[type]) != null ? _c : _b[type] = {})[_e = id || "__internal_without_id"]) != null ? _f : _d[_e] = [];
                    for (const queryCacheKey of cacheKeys){
                        const alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                        if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                        draft.keys[queryCacheKey] = provided.keys[queryCacheKey];
                    }
                }
            }).addMatcher((0, $iDqdB.isAnyOf)((0, $iDqdB.isFulfilled)(queryThunk), (0, $iDqdB.isRejectedWithValue)(queryThunk)), (draft, action)=>{
                writeProvidedTagsForQueries(draft, [
                    action
                ]);
            }).addMatcher(querySlice.actions.cacheEntriesUpserted.match, (draft, action)=>{
                const mockActions = action.payload.map(({ queryDescription: queryDescription, value: value })=>{
                    return {
                        type: "UNKNOWN",
                        payload: value,
                        meta: {
                            requestStatus: "fulfilled",
                            requestId: "UNKNOWN",
                            arg: queryDescription
                        }
                    };
                });
                writeProvidedTagsForQueries(draft, mockActions);
            });
        }
    });
    function removeCacheKeyFromTags(draft, queryCacheKey) {
        var _a, _b, _c;
        const existingTags = $66b21aa7bd8497fc$var$getCurrent((_a = draft.keys[queryCacheKey]) != null ? _a : []);
        for (const tag of existingTags){
            const tagType = tag.type;
            const tagId = (_b = tag.id) != null ? _b : "__internal_without_id";
            const tagSubscriptions = (_c = draft.tags[tagType]) == null ? void 0 : _c[tagId];
            if (tagSubscriptions) draft.tags[tagType][tagId] = $66b21aa7bd8497fc$var$getCurrent(tagSubscriptions).filter((qc)=>qc !== queryCacheKey);
        }
        delete draft.keys[queryCacheKey];
    }
    function writeProvidedTagsForQueries(draft, actions3) {
        const providedByEntries = actions3.map((action)=>{
            const providedTags = $66b21aa7bd8497fc$var$calculateProvidedByThunk(action, "providesTags", definitions, assertTagType);
            const { queryCacheKey: queryCacheKey } = action.meta.arg;
            return {
                queryCacheKey: queryCacheKey,
                providedTags: providedTags
            };
        });
        invalidationSlice.caseReducers.updateProvidedBy(draft, invalidationSlice.actions.updateProvidedBy(providedByEntries));
    }
    const subscriptionSlice = (0, $iDqdB.createSlice)({
        name: `${reducerPath}/subscriptions`,
        initialState: $66b21aa7bd8497fc$var$initialState,
        reducers: {
            updateSubscriptionOptions (d, a) {},
            unsubscribeQueryResult (d, a) {},
            internal_getRTKQSubscriptions () {}
        }
    });
    const internalSubscriptionsSlice = (0, $iDqdB.createSlice)({
        name: `${reducerPath}/internalSubscriptions`,
        initialState: $66b21aa7bd8497fc$var$initialState,
        reducers: {
            subscriptionsUpdated: {
                reducer (state, action) {
                    return (0, $fTaOL.applyPatches)(state, action.payload);
                },
                prepare: (0, $iDqdB.prepareAutoBatched)()
            }
        }
    });
    const configSlice = (0, $iDqdB.createSlice)({
        name: `${reducerPath}/config`,
        initialState: $66b21aa7bd8497fc$var$__spreadValues({
            online: $66b21aa7bd8497fc$var$isOnline(),
            focused: $66b21aa7bd8497fc$var$isDocumentVisible(),
            middlewareRegistered: false
        }, config),
        reducers: {
            middlewareRegistered (state, { payload: payload }) {
                state.middlewareRegistered = state.middlewareRegistered === "conflict" || apiUid !== payload ? "conflict" : true;
            }
        },
        extraReducers: (builder)=>{
            builder.addCase($66b21aa7bd8497fc$var$onOnline, (state)=>{
                state.online = true;
            }).addCase($66b21aa7bd8497fc$var$onOffline, (state)=>{
                state.online = false;
            }).addCase($66b21aa7bd8497fc$var$onFocus, (state)=>{
                state.focused = true;
            }).addCase($66b21aa7bd8497fc$var$onFocusLost, (state)=>{
                state.focused = false;
            }).addMatcher(hasRehydrationInfo, (draft)=>$66b21aa7bd8497fc$var$__spreadValues({}, draft));
        }
    });
    const combinedReducer = (0, $i5N98.combineReducers)({
        queries: querySlice.reducer,
        mutations: mutationSlice.reducer,
        provided: invalidationSlice.reducer,
        subscriptions: internalSubscriptionsSlice.reducer,
        config: configSlice.reducer
    });
    const reducer = (state, action)=>combinedReducer(resetApiState.match(action) ? void 0 : state, action);
    const actions2 = $66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues($66b21aa7bd8497fc$var$__spreadValues($66b21aa7bd8497fc$var$__spreadValues($66b21aa7bd8497fc$var$__spreadValues($66b21aa7bd8497fc$var$__spreadValues($66b21aa7bd8497fc$var$__spreadValues({}, configSlice.actions), querySlice.actions), subscriptionSlice.actions), internalSubscriptionsSlice.actions), mutationSlice.actions), invalidationSlice.actions), {
        resetApiState: resetApiState
    });
    return {
        reducer: reducer,
        actions: actions2
    };
}
// src/query/core/buildSelectors.ts
var $66b21aa7bd8497fc$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol.for("RTKQ/skipToken");
var $66b21aa7bd8497fc$var$initialSubState = {
    status: $66b21aa7bd8497fc$var$STATUS_UNINITIALIZED
};
var $66b21aa7bd8497fc$var$defaultQuerySubState = /* @__PURE__ */ (0, $fTaOL.produce)($66b21aa7bd8497fc$var$initialSubState, ()=>{});
var $66b21aa7bd8497fc$var$defaultMutationSubState = /* @__PURE__ */ (0, $fTaOL.produce)($66b21aa7bd8497fc$var$initialSubState, ()=>{});
function $66b21aa7bd8497fc$var$buildSelectors({ serializeQueryArgs: serializeQueryArgs, reducerPath: reducerPath, createSelector: createSelector2 }) {
    const selectSkippedQuery = (state)=>$66b21aa7bd8497fc$var$defaultQuerySubState;
    const selectSkippedMutation = (state)=>$66b21aa7bd8497fc$var$defaultMutationSubState;
    return {
        buildQuerySelector: buildQuerySelector,
        buildInfiniteQuerySelector: buildInfiniteQuerySelector,
        buildMutationSelector: buildMutationSelector,
        selectInvalidatedBy: selectInvalidatedBy,
        selectCachedArgsForQuery: selectCachedArgsForQuery,
        selectApiState: selectApiState,
        selectQueries: selectQueries,
        selectMutations: selectMutations,
        selectQueryEntry: selectQueryEntry,
        selectConfig: selectConfig
    };
    function withRequestFlags(substate) {
        return $66b21aa7bd8497fc$var$__spreadValues($66b21aa7bd8497fc$var$__spreadValues({}, substate), $66b21aa7bd8497fc$var$getRequestStatusFlags(substate.status));
    }
    function selectApiState(rootState) {
        const state = rootState[reducerPath];
        return state;
    }
    function selectQueries(rootState) {
        var _a;
        return (_a = selectApiState(rootState)) == null ? void 0 : _a.queries;
    }
    function selectQueryEntry(rootState, cacheKey) {
        var _a;
        return (_a = selectQueries(rootState)) == null ? void 0 : _a[cacheKey];
    }
    function selectMutations(rootState) {
        var _a;
        return (_a = selectApiState(rootState)) == null ? void 0 : _a.mutations;
    }
    function selectConfig(rootState) {
        var _a;
        return (_a = selectApiState(rootState)) == null ? void 0 : _a.config;
    }
    function buildAnyQuerySelector(endpointName, endpointDefinition, combiner) {
        return (queryArgs)=>{
            if (queryArgs === $66b21aa7bd8497fc$export$1aa5a89531b7670d) return createSelector2(selectSkippedQuery, combiner);
            const serializedArgs = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            const selectQuerySubstate = (state)=>{
                var _a;
                return (_a = selectQueryEntry(state, serializedArgs)) != null ? _a : $66b21aa7bd8497fc$var$defaultQuerySubState;
            };
            return createSelector2(selectQuerySubstate, combiner);
        };
    }
    function buildQuerySelector(endpointName, endpointDefinition) {
        return buildAnyQuerySelector(endpointName, endpointDefinition, withRequestFlags);
    }
    function buildInfiniteQuerySelector(endpointName, endpointDefinition) {
        const { infiniteQueryOptions: infiniteQueryOptions } = endpointDefinition;
        function withInfiniteQueryResultFlags(substate) {
            const stateWithRequestFlags = $66b21aa7bd8497fc$var$__spreadValues($66b21aa7bd8497fc$var$__spreadValues({}, substate), $66b21aa7bd8497fc$var$getRequestStatusFlags(substate.status));
            const { isLoading: isLoading, isError: isError, direction: direction } = stateWithRequestFlags;
            const isForward = direction === "forward";
            const isBackward = direction === "backward";
            return $66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, stateWithRequestFlags), {
                hasNextPage: getHasNextPage(infiniteQueryOptions, stateWithRequestFlags.data, stateWithRequestFlags.originalArgs),
                hasPreviousPage: getHasPreviousPage(infiniteQueryOptions, stateWithRequestFlags.data, stateWithRequestFlags.originalArgs),
                isFetchingNextPage: isLoading && isForward,
                isFetchingPreviousPage: isLoading && isBackward,
                isFetchNextPageError: isError && isForward,
                isFetchPreviousPageError: isError && isBackward
            });
        }
        return buildAnyQuerySelector(endpointName, endpointDefinition, withInfiniteQueryResultFlags);
    }
    function buildMutationSelector() {
        return (id)=>{
            var _a;
            let mutationId;
            if (typeof id === "object") mutationId = (_a = $66b21aa7bd8497fc$var$getMutationCacheKey(id)) != null ? _a : $66b21aa7bd8497fc$export$1aa5a89531b7670d;
            else mutationId = id;
            const selectMutationSubstate = (state)=>{
                var _a2, _b, _c;
                return (_c = (_b = (_a2 = selectApiState(state)) == null ? void 0 : _a2.mutations) == null ? void 0 : _b[mutationId]) != null ? _c : $66b21aa7bd8497fc$var$defaultMutationSubState;
            };
            const finalSelectMutationSubstate = mutationId === $66b21aa7bd8497fc$export$1aa5a89531b7670d ? selectSkippedMutation : selectMutationSubstate;
            return createSelector2(finalSelectMutationSubstate, withRequestFlags);
        };
    }
    function selectInvalidatedBy(state, tags) {
        var _a;
        const apiState = state[reducerPath];
        const toInvalidate = /* @__PURE__ */ new Set();
        const finalTags = $66b21aa7bd8497fc$var$filterMap(tags, $66b21aa7bd8497fc$var$isNotNullish, $66b21aa7bd8497fc$var$expandTagDescription);
        for (const tag of finalTags){
            const provided = apiState.provided.tags[tag.type];
            if (!provided) continue;
            let invalidateSubscriptions = (_a = tag.id !== void 0 ? // id given: invalidate all queries that provide this type & id
            provided[tag.id] : // no id: invalidate all queries that provide this type
            Object.values(provided).flat()) != null ? _a : [];
            for (const invalidate of invalidateSubscriptions)toInvalidate.add(invalidate);
        }
        return Array.from(toInvalidate.values()).flatMap((queryCacheKey)=>{
            const querySubState = apiState.queries[queryCacheKey];
            return querySubState ? {
                queryCacheKey: queryCacheKey,
                endpointName: querySubState.endpointName,
                originalArgs: querySubState.originalArgs
            } : [];
        });
    }
    function selectCachedArgsForQuery(state, queryName) {
        return $66b21aa7bd8497fc$var$filterMap(Object.values(selectQueries(state)), (entry)=>(entry == null ? void 0 : entry.endpointName) === queryName && entry.status !== $66b21aa7bd8497fc$var$STATUS_UNINITIALIZED, (entry)=>entry.originalArgs);
    }
    function getHasNextPage(options, data, queryArg) {
        if (!data) return false;
        return $66b21aa7bd8497fc$var$getNextPageParam(options, data, queryArg) != null;
    }
    function getHasPreviousPage(options, data, queryArg) {
        if (!data || !options.getPreviousPageParam) return false;
        return $66b21aa7bd8497fc$var$getPreviousPageParam(options, data, queryArg) != null;
    }
}
// src/query/defaultSerializeQueryArgs.ts
var $66b21aa7bd8497fc$var$cache = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0;
var $66b21aa7bd8497fc$export$db8e4edac9bbb67b = ({ endpointName: endpointName, queryArgs: queryArgs })=>{
    let serialized = "";
    const cached = $66b21aa7bd8497fc$var$cache == null ? void 0 : $66b21aa7bd8497fc$var$cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        const stringified = JSON.stringify(queryArgs, (key, value)=>{
            value = typeof value === "bigint" ? {
                $bigint: value.toString()
            } : value;
            value = (0, $i5N98.isPlainObject)(value) ? Object.keys(value).sort().reduce((acc, key2)=>{
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
            return value;
        });
        if ((0, $i5N98.isPlainObject)(queryArgs)) $66b21aa7bd8497fc$var$cache == null || $66b21aa7bd8497fc$var$cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return `${endpointName}(${serialized})`;
};
// src/query/createApi.ts
function $66b21aa7bd8497fc$export$f957748792d43646(...modules) {
    return function baseCreateApi(options) {
        const extractRehydrationInfo = (0, $4KtEQ.weakMapMemoize)((action)=>{
            var _a, _b;
            return (_b = options.extractRehydrationInfo) == null ? void 0 : _b.call(options, action, {
                reducerPath: (_a = options.reducerPath) != null ? _a : "api"
            });
        });
        const optionsWithDefaults = $66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: false,
            refetchOnFocus: false,
            refetchOnReconnect: false,
            invalidationBehavior: "delayed"
        }, options), {
            extractRehydrationInfo: extractRehydrationInfo,
            serializeQueryArgs (queryArgsApi) {
                let finalSerializeQueryArgs = $66b21aa7bd8497fc$export$db8e4edac9bbb67b;
                if ("serializeQueryArgs" in queryArgsApi.endpointDefinition) {
                    const endpointSQA = queryArgsApi.endpointDefinition.serializeQueryArgs;
                    finalSerializeQueryArgs = (queryArgsApi2)=>{
                        const initialResult = endpointSQA(queryArgsApi2);
                        if (typeof initialResult === "string") return initialResult;
                        else return $66b21aa7bd8497fc$export$db8e4edac9bbb67b($66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, queryArgsApi2), {
                            queryArgs: initialResult
                        }));
                    };
                } else if (options.serializeQueryArgs) finalSerializeQueryArgs = options.serializeQueryArgs;
                return finalSerializeQueryArgs(queryArgsApi);
            },
            tagTypes: [
                ...options.tagTypes || []
            ]
        });
        const context = {
            endpointDefinitions: {},
            batch (fn) {
                fn();
            },
            apiUid: (0, $iDqdB.nanoid)(),
            extractRehydrationInfo: extractRehydrationInfo,
            hasRehydrationInfo: (0, $4KtEQ.weakMapMemoize)((action)=>extractRehydrationInfo(action) != null)
        };
        const api = {
            injectEndpoints: injectEndpoints,
            enhanceEndpoints ({ addTagTypes: addTagTypes, endpoints: endpoints }) {
                if (addTagTypes) {
                    for (const eT of addTagTypes)if (!optionsWithDefaults.tagTypes.includes(eT)) optionsWithDefaults.tagTypes.push(eT);
                }
                if (endpoints) {
                    for (const [endpointName, partialDefinition] of Object.entries(endpoints))if (typeof partialDefinition === "function") partialDefinition($66b21aa7bd8497fc$var$getEndpointDefinition(context, endpointName));
                    else Object.assign($66b21aa7bd8497fc$var$getEndpointDefinition(context, endpointName) || {}, partialDefinition);
                }
                return api;
            }
        };
        const initializedModules = modules.map((m)=>m.init(api, optionsWithDefaults, context));
        function injectEndpoints(inject) {
            const evaluatedEndpoints = inject.endpoints({
                query: (x)=>$66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, x), {
                        type: $66b21aa7bd8497fc$var$ENDPOINT_QUERY
                    }),
                mutation: (x)=>$66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, x), {
                        type: $66b21aa7bd8497fc$var$ENDPOINT_MUTATION
                    }),
                infiniteQuery: (x)=>$66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, x), {
                        type: $66b21aa7bd8497fc$var$ENDPOINT_INFINITEQUERY
                    })
            });
            for (const [endpointName, definition] of Object.entries(evaluatedEndpoints)){
                if (inject.overrideExisting !== true && endpointName in context.endpointDefinitions) {
                    if (inject.overrideExisting === "throw") throw new Error((0, $iDqdB.formatProdErrorMessage)(39));
                    continue;
                }
                context.endpointDefinitions[endpointName] = definition;
                for (const m of initializedModules)m.injectEndpoint(endpointName, definition);
            }
            return api;
        }
        return api.injectEndpoints({
            endpoints: options.endpoints
        });
    };
}
var $66b21aa7bd8497fc$export$b87087b3e686799a = /* @__PURE__ */ Symbol();
function $66b21aa7bd8497fc$export$f72b22d3ac378bae() {
    return function() {
        throw new Error((0, $iDqdB.formatProdErrorMessage)(33));
    };
}
// src/query/tsHelpers.ts
function $66b21aa7bd8497fc$var$assertCast(v) {}
function $66b21aa7bd8497fc$var$safeAssign(target, ...args) {
    return Object.assign(target, ...args);
}
// src/query/core/buildMiddleware/batchActions.ts
var $66b21aa7bd8497fc$var$buildBatchedActionsHandler = ({ api: api, queryThunk: queryThunk, internalState: internalState, mwApi: mwApi })=>{
    const subscriptionsPrefix = `${api.reducerPath}/subscriptions`;
    let previousSubscriptions = null;
    let updateSyncTimer = null;
    const { updateSubscriptionOptions: updateSubscriptionOptions, unsubscribeQueryResult: unsubscribeQueryResult } = api.internalActions;
    const actuallyMutateSubscriptions = (currentSubscriptions, action)=>{
        var _a, _b, _c, _d;
        if (updateSubscriptionOptions.match(action)) {
            const { queryCacheKey: queryCacheKey, requestId: requestId, options: options } = action.payload;
            const sub = currentSubscriptions.get(queryCacheKey);
            if (sub == null ? void 0 : sub.has(requestId)) sub.set(requestId, options);
            return true;
        }
        if (unsubscribeQueryResult.match(action)) {
            const { queryCacheKey: queryCacheKey, requestId: requestId } = action.payload;
            const sub = currentSubscriptions.get(queryCacheKey);
            if (sub) sub.delete(requestId);
            return true;
        }
        if (api.internalActions.removeQueryResult.match(action)) {
            currentSubscriptions.delete(action.payload.queryCacheKey);
            return true;
        }
        if (queryThunk.pending.match(action)) {
            const { meta: { arg: arg, requestId: requestId } } = action;
            const substate = $66b21aa7bd8497fc$var$getOrInsertComputed(currentSubscriptions, arg.queryCacheKey, $66b21aa7bd8497fc$var$createNewMap);
            if (arg.subscribe) substate.set(requestId, (_b = (_a = arg.subscriptionOptions) != null ? _a : substate.get(requestId)) != null ? _b : {});
            return true;
        }
        let mutated = false;
        if (queryThunk.rejected.match(action)) {
            const { meta: { condition: condition, arg: arg, requestId: requestId } } = action;
            if (condition && arg.subscribe) {
                const substate = $66b21aa7bd8497fc$var$getOrInsertComputed(currentSubscriptions, arg.queryCacheKey, $66b21aa7bd8497fc$var$createNewMap);
                substate.set(requestId, (_d = (_c = arg.subscriptionOptions) != null ? _c : substate.get(requestId)) != null ? _d : {});
                mutated = true;
            }
        }
        return mutated;
    };
    const getSubscriptions = ()=>internalState.currentSubscriptions;
    const getSubscriptionCount = (queryCacheKey)=>{
        var _a;
        const subscriptions = getSubscriptions();
        const subscriptionsForQueryArg = subscriptions.get(queryCacheKey);
        return (_a = subscriptionsForQueryArg == null ? void 0 : subscriptionsForQueryArg.size) != null ? _a : 0;
    };
    const isRequestSubscribed = (queryCacheKey, requestId)=>{
        var _a;
        const subscriptions = getSubscriptions();
        return !!((_a = subscriptions == null ? void 0 : subscriptions.get(queryCacheKey)) == null ? void 0 : _a.get(requestId));
    };
    const subscriptionSelectors = {
        getSubscriptions: getSubscriptions,
        getSubscriptionCount: getSubscriptionCount,
        isRequestSubscribed: isRequestSubscribed
    };
    function serializeSubscriptions(currentSubscriptions) {
        return JSON.parse(JSON.stringify(Object.fromEntries([
            ...currentSubscriptions
        ].map(([k, v])=>[
                k,
                Object.fromEntries(v)
            ]))));
    }
    return (action, mwApi2)=>{
        if (!previousSubscriptions) previousSubscriptions = serializeSubscriptions(internalState.currentSubscriptions);
        if (api.util.resetApiState.match(action)) {
            previousSubscriptions = {};
            internalState.currentSubscriptions.clear();
            updateSyncTimer = null;
            return [
                true,
                false
            ];
        }
        if (api.internalActions.internal_getRTKQSubscriptions.match(action)) return [
            false,
            subscriptionSelectors
        ];
        const didMutate = actuallyMutateSubscriptions(internalState.currentSubscriptions, action);
        let actionShouldContinue = true;
        if (didMutate) {
            if (!updateSyncTimer) updateSyncTimer = setTimeout(()=>{
                const newSubscriptions = serializeSubscriptions(internalState.currentSubscriptions);
                const [, patches] = (0, $fTaOL.produceWithPatches)(previousSubscriptions, ()=>newSubscriptions);
                mwApi2.next(api.internalActions.subscriptionsUpdated(patches));
                previousSubscriptions = newSubscriptions;
                updateSyncTimer = null;
            }, 500);
            const isSubscriptionSliceAction = typeof action.type == "string" && !!action.type.startsWith(subscriptionsPrefix);
            const isAdditionalSubscriptionAction = queryThunk.rejected.match(action) && action.meta.condition && !!action.meta.arg.subscribe;
            actionShouldContinue = !isSubscriptionSliceAction && !isAdditionalSubscriptionAction;
        }
        return [
            actionShouldContinue,
            false
        ];
    };
};
// src/query/core/buildMiddleware/cacheCollection.ts
var $66b21aa7bd8497fc$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS = 2147482.647;
var $66b21aa7bd8497fc$var$buildCacheCollectionHandler = ({ reducerPath: reducerPath, api: api, queryThunk: queryThunk, context: context, internalState: internalState, selectors: { selectQueryEntry: selectQueryEntry, selectConfig: selectConfig }, getRunningQueryThunk: getRunningQueryThunk, mwApi: mwApi })=>{
    const { removeQueryResult: removeQueryResult, unsubscribeQueryResult: unsubscribeQueryResult, cacheEntriesUpserted: cacheEntriesUpserted } = api.internalActions;
    const canTriggerUnsubscribe = (0, $iDqdB.isAnyOf)(unsubscribeQueryResult.match, queryThunk.fulfilled, queryThunk.rejected, cacheEntriesUpserted.match);
    function anySubscriptionsRemainingForKey(queryCacheKey) {
        const subscriptions = internalState.currentSubscriptions.get(queryCacheKey);
        if (!subscriptions) return false;
        const hasSubscriptions = subscriptions.size > 0;
        return hasSubscriptions;
    }
    const currentRemovalTimeouts = {};
    function abortAllPromises(promiseMap) {
        var _a;
        for (const promise of promiseMap.values())(_a = promise == null ? void 0 : promise.abort) == null || _a.call(promise);
    }
    const handler = (action, mwApi2)=>{
        const state = mwApi2.getState();
        const config = selectConfig(state);
        if (canTriggerUnsubscribe(action)) {
            let queryCacheKeys;
            if (cacheEntriesUpserted.match(action)) queryCacheKeys = action.payload.map((entry)=>entry.queryDescription.queryCacheKey);
            else {
                const { queryCacheKey: queryCacheKey } = unsubscribeQueryResult.match(action) ? action.payload : action.meta.arg;
                queryCacheKeys = [
                    queryCacheKey
                ];
            }
            handleUnsubscribeMany(queryCacheKeys, mwApi2, config);
        }
        if (api.util.resetApiState.match(action)) {
            for (const [key, timeout] of Object.entries(currentRemovalTimeouts)){
                if (timeout) clearTimeout(timeout);
                delete currentRemovalTimeouts[key];
            }
            abortAllPromises(internalState.runningQueries);
            abortAllPromises(internalState.runningMutations);
        }
        if (context.hasRehydrationInfo(action)) {
            const { queries: queries } = context.extractRehydrationInfo(action);
            handleUnsubscribeMany(Object.keys(queries), mwApi2, config);
        }
    };
    function handleUnsubscribeMany(cacheKeys, api2, config) {
        const state = api2.getState();
        for (const queryCacheKey of cacheKeys){
            const entry = selectQueryEntry(state, queryCacheKey);
            if (entry == null ? void 0 : entry.endpointName) handleUnsubscribe(queryCacheKey, entry.endpointName, api2, config);
        }
    }
    function handleUnsubscribe(queryCacheKey, endpointName, api2, config) {
        var _a;
        const endpointDefinition = $66b21aa7bd8497fc$var$getEndpointDefinition(context, endpointName);
        const keepUnusedDataFor = (_a = endpointDefinition == null ? void 0 : endpointDefinition.keepUnusedDataFor) != null ? _a : config.keepUnusedDataFor;
        if (keepUnusedDataFor === Infinity) return;
        const finalKeepUnusedDataFor = Math.max(0, Math.min(keepUnusedDataFor, $66b21aa7bd8497fc$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS));
        if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
            const currentTimeout = currentRemovalTimeouts[queryCacheKey];
            if (currentTimeout) clearTimeout(currentTimeout);
            currentRemovalTimeouts[queryCacheKey] = setTimeout(()=>{
                if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
                    const entry = selectQueryEntry(api2.getState(), queryCacheKey);
                    if (entry == null ? void 0 : entry.endpointName) {
                        const runningQuery = api2.dispatch(getRunningQueryThunk(entry.endpointName, entry.originalArgs));
                        runningQuery == null || runningQuery.abort();
                    }
                    api2.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                }
                delete currentRemovalTimeouts[queryCacheKey];
            }, finalKeepUnusedDataFor * 1e3);
        }
    }
    return handler;
};
// src/query/core/buildMiddleware/cacheLifecycle.ts
var $66b21aa7bd8497fc$var$neverResolvedError = new Error("Promise never resolved before cacheEntryRemoved.");
var $66b21aa7bd8497fc$var$buildCacheLifecycleHandler = ({ api: api, reducerPath: reducerPath, context: context, queryThunk: queryThunk, mutationThunk: mutationThunk, internalState: internalState, selectors: { selectQueryEntry: selectQueryEntry, selectApiState: selectApiState } })=>{
    const isQueryThunk = (0, $iDqdB.isAsyncThunkAction)(queryThunk);
    const isMutationThunk = (0, $iDqdB.isAsyncThunkAction)(mutationThunk);
    const isFulfilledThunk = (0, $iDqdB.isFulfilled)(queryThunk, mutationThunk);
    const lifecycleMap = {};
    const { removeQueryResult: removeQueryResult, removeMutationResult: removeMutationResult, cacheEntriesUpserted: cacheEntriesUpserted } = api.internalActions;
    function resolveLifecycleEntry(cacheKey, data, meta) {
        const lifecycle = lifecycleMap[cacheKey];
        if (lifecycle == null ? void 0 : lifecycle.valueResolved) {
            lifecycle.valueResolved({
                data: data,
                meta: meta
            });
            delete lifecycle.valueResolved;
        }
    }
    function removeLifecycleEntry(cacheKey) {
        const lifecycle = lifecycleMap[cacheKey];
        if (lifecycle) {
            delete lifecycleMap[cacheKey];
            lifecycle.cacheEntryRemoved();
        }
    }
    function getActionMetaFields(action) {
        const { arg: arg, requestId: requestId } = action.meta;
        const { endpointName: endpointName, originalArgs: originalArgs } = arg;
        return [
            endpointName,
            originalArgs,
            requestId
        ];
    }
    const handler = (action, mwApi, stateBefore)=>{
        const cacheKey = getCacheKey(action);
        function checkForNewCacheKey(endpointName, cacheKey2, requestId, originalArgs) {
            const oldEntry = selectQueryEntry(stateBefore, cacheKey2);
            const newEntry = selectQueryEntry(mwApi.getState(), cacheKey2);
            if (!oldEntry && newEntry) handleNewKey(endpointName, originalArgs, cacheKey2, mwApi, requestId);
        }
        if (queryThunk.pending.match(action)) {
            const [endpointName, originalArgs, requestId] = getActionMetaFields(action);
            checkForNewCacheKey(endpointName, cacheKey, requestId, originalArgs);
        } else if (cacheEntriesUpserted.match(action)) for (const { queryDescription: queryDescription, value: value } of action.payload){
            const { endpointName: endpointName, originalArgs: originalArgs, queryCacheKey: queryCacheKey } = queryDescription;
            checkForNewCacheKey(endpointName, queryCacheKey, action.meta.requestId, originalArgs);
            resolveLifecycleEntry(queryCacheKey, value, {});
        }
        else if (mutationThunk.pending.match(action)) {
            const state = mwApi.getState()[reducerPath].mutations[cacheKey];
            if (state) {
                const [endpointName, originalArgs, requestId] = getActionMetaFields(action);
                handleNewKey(endpointName, originalArgs, cacheKey, mwApi, requestId);
            }
        } else if (isFulfilledThunk(action)) resolveLifecycleEntry(cacheKey, action.payload, action.meta.baseQueryMeta);
        else if (removeQueryResult.match(action) || removeMutationResult.match(action)) removeLifecycleEntry(cacheKey);
        else if (api.util.resetApiState.match(action)) for (const cacheKey2 of Object.keys(lifecycleMap))removeLifecycleEntry(cacheKey2);
    };
    function getCacheKey(action) {
        var _a;
        if (isQueryThunk(action)) return action.meta.arg.queryCacheKey;
        if (isMutationThunk(action)) return (_a = action.meta.arg.fixedCacheKey) != null ? _a : action.meta.requestId;
        if (removeQueryResult.match(action)) return action.payload.queryCacheKey;
        if (removeMutationResult.match(action)) return $66b21aa7bd8497fc$var$getMutationCacheKey(action.payload);
        return "";
    }
    function handleNewKey(endpointName, originalArgs, queryCacheKey, mwApi, requestId) {
        const endpointDefinition = $66b21aa7bd8497fc$var$getEndpointDefinition(context, endpointName);
        const onCacheEntryAdded = endpointDefinition == null ? void 0 : endpointDefinition.onCacheEntryAdded;
        if (!onCacheEntryAdded) return;
        const lifecycle = {};
        const cacheEntryRemoved = new Promise((resolve)=>{
            lifecycle.cacheEntryRemoved = resolve;
        });
        const cacheDataLoaded = Promise.race([
            new Promise((resolve)=>{
                lifecycle.valueResolved = resolve;
            }),
            cacheEntryRemoved.then(()=>{
                throw $66b21aa7bd8497fc$var$neverResolvedError;
            })
        ]);
        cacheDataLoaded.catch(()=>{});
        lifecycleMap[queryCacheKey] = lifecycle;
        const selector = api.endpoints[endpointName].select($66b21aa7bd8497fc$var$isAnyQueryDefinition(endpointDefinition) ? originalArgs : queryCacheKey);
        const extra = mwApi.dispatch((_, __, extra2)=>extra2);
        const lifecycleApi = $66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, mwApi), {
            getCacheEntry: ()=>selector(mwApi.getState()),
            requestId: requestId,
            extra: extra,
            updateCachedData: $66b21aa7bd8497fc$var$isAnyQueryDefinition(endpointDefinition) ? (updateRecipe)=>mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe)) : void 0,
            cacheDataLoaded: cacheDataLoaded,
            cacheEntryRemoved: cacheEntryRemoved
        });
        const runningHandler = onCacheEntryAdded(originalArgs, lifecycleApi);
        Promise.resolve(runningHandler).catch((e)=>{
            if (e === $66b21aa7bd8497fc$var$neverResolvedError) return;
            throw e;
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/devMiddleware.ts
var $66b21aa7bd8497fc$var$buildDevCheckHandler = ({ api: api, context: { apiUid: apiUid }, reducerPath: reducerPath })=>{
    return (action, mwApi)=>{
        var _a, _b;
        if (api.util.resetApiState.match(action)) mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
    };
};
// src/query/core/buildMiddleware/invalidationByTags.ts
var $66b21aa7bd8497fc$var$buildInvalidationByTagsHandler = ({ reducerPath: reducerPath, context: context, context: { endpointDefinitions: endpointDefinitions }, mutationThunk: mutationThunk, queryThunk: queryThunk, api: api, assertTagType: assertTagType, refetchQuery: refetchQuery, internalState: internalState })=>{
    const { removeQueryResult: removeQueryResult } = api.internalActions;
    const isThunkActionWithTags = (0, $iDqdB.isAnyOf)((0, $iDqdB.isFulfilled)(mutationThunk), (0, $iDqdB.isRejectedWithValue)(mutationThunk));
    const isQueryEnd = (0, $iDqdB.isAnyOf)((0, $iDqdB.isFulfilled)(queryThunk, mutationThunk), (0, $iDqdB.isRejected)(queryThunk, mutationThunk));
    let pendingTagInvalidations = [];
    let pendingRequestCount = 0;
    const handler = (action, mwApi)=>{
        if (queryThunk.pending.match(action) || mutationThunk.pending.match(action)) pendingRequestCount++;
        if (isQueryEnd(action)) pendingRequestCount = Math.max(0, pendingRequestCount - 1);
        if (isThunkActionWithTags(action)) invalidateTags($66b21aa7bd8497fc$var$calculateProvidedByThunk(action, "invalidatesTags", endpointDefinitions, assertTagType), mwApi);
        else if (isQueryEnd(action)) invalidateTags([], mwApi);
        else if (api.util.invalidateTags.match(action)) invalidateTags($66b21aa7bd8497fc$var$calculateProvidedBy(action.payload, void 0, void 0, void 0, void 0, assertTagType), mwApi);
    };
    function hasPendingRequests() {
        return pendingRequestCount > 0;
    }
    function invalidateTags(newTags, mwApi) {
        const rootState = mwApi.getState();
        const state = rootState[reducerPath];
        pendingTagInvalidations.push(...newTags);
        if (state.config.invalidationBehavior === "delayed" && hasPendingRequests()) return;
        const tags = pendingTagInvalidations;
        pendingTagInvalidations = [];
        if (tags.length === 0) return;
        const toInvalidate = api.util.selectInvalidatedBy(rootState, tags);
        context.batch(()=>{
            const valuesArray = Array.from(toInvalidate.values());
            for (const { queryCacheKey: queryCacheKey } of valuesArray){
                const querySubState = state.queries[queryCacheKey];
                const subscriptionSubState = $66b21aa7bd8497fc$var$getOrInsertComputed(internalState.currentSubscriptions, queryCacheKey, $66b21aa7bd8497fc$var$createNewMap);
                if (querySubState) {
                    if (subscriptionSubState.size === 0) mwApi.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== $66b21aa7bd8497fc$var$STATUS_UNINITIALIZED) mwApi.dispatch(refetchQuery(querySubState));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/polling.ts
var $66b21aa7bd8497fc$var$buildPollingHandler = ({ reducerPath: reducerPath, queryThunk: queryThunk, api: api, refetchQuery: refetchQuery, internalState: internalState })=>{
    const { currentPolls: currentPolls, currentSubscriptions: currentSubscriptions } = internalState;
    const pendingPollingUpdates = /* @__PURE__ */ new Set();
    let pollingUpdateTimer = null;
    const handler = (action, mwApi)=>{
        if (api.internalActions.updateSubscriptionOptions.match(action) || api.internalActions.unsubscribeQueryResult.match(action)) schedulePollingUpdate(action.payload.queryCacheKey, mwApi);
        if (queryThunk.pending.match(action) || queryThunk.rejected.match(action) && action.meta.condition) schedulePollingUpdate(action.meta.arg.queryCacheKey, mwApi);
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action) && !action.meta.condition) startNextPoll(action.meta.arg, mwApi);
        if (api.util.resetApiState.match(action)) {
            clearPolls();
            if (pollingUpdateTimer) {
                clearTimeout(pollingUpdateTimer);
                pollingUpdateTimer = null;
            }
            pendingPollingUpdates.clear();
        }
    };
    function schedulePollingUpdate(queryCacheKey, api2) {
        pendingPollingUpdates.add(queryCacheKey);
        if (!pollingUpdateTimer) pollingUpdateTimer = setTimeout(()=>{
            for (const key of pendingPollingUpdates)updatePollingInterval({
                queryCacheKey: key
            }, api2);
            pendingPollingUpdates.clear();
            pollingUpdateTimer = null;
        }, 0);
    }
    function startNextPoll({ queryCacheKey: queryCacheKey }, api2) {
        const state = api2.getState()[reducerPath];
        const querySubState = state.queries[queryCacheKey];
        const subscriptions = currentSubscriptions.get(queryCacheKey);
        if (!querySubState || querySubState.status === $66b21aa7bd8497fc$var$STATUS_UNINITIALIZED) return;
        const { lowestPollingInterval: lowestPollingInterval, skipPollingIfUnfocused: skipPollingIfUnfocused } = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) return;
        const currentPoll = currentPolls.get(queryCacheKey);
        if (currentPoll == null ? void 0 : currentPoll.timeout) {
            clearTimeout(currentPoll.timeout);
            currentPoll.timeout = void 0;
        }
        const nextPollTimestamp = Date.now() + lowestPollingInterval;
        currentPolls.set(queryCacheKey, {
            nextPollTimestamp: nextPollTimestamp,
            pollingInterval: lowestPollingInterval,
            timeout: setTimeout(()=>{
                if (state.config.focused || !skipPollingIfUnfocused) api2.dispatch(refetchQuery(querySubState));
                startNextPoll({
                    queryCacheKey: queryCacheKey
                }, api2);
            }, lowestPollingInterval)
        });
    }
    function updatePollingInterval({ queryCacheKey: queryCacheKey }, api2) {
        var _a, _b;
        const state = api2.getState()[reducerPath];
        const querySubState = state.queries[queryCacheKey];
        const subscriptions = currentSubscriptions.get(queryCacheKey);
        if (!querySubState || querySubState.status === $66b21aa7bd8497fc$var$STATUS_UNINITIALIZED) return;
        const { lowestPollingInterval: lowestPollingInterval } = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) {
            cleanupPollForKey(queryCacheKey);
            return;
        }
        const currentPoll = currentPolls.get(queryCacheKey);
        const nextPollTimestamp = Date.now() + lowestPollingInterval;
        if (!currentPoll || nextPollTimestamp < currentPoll.nextPollTimestamp) startNextPoll({
            queryCacheKey: queryCacheKey
        }, api2);
    }
    function cleanupPollForKey(key) {
        const existingPoll = currentPolls.get(key);
        if (existingPoll == null ? void 0 : existingPoll.timeout) clearTimeout(existingPoll.timeout);
        currentPolls.delete(key);
    }
    function clearPolls() {
        for (const key of currentPolls.keys())cleanupPollForKey(key);
    }
    function findLowestPollingInterval(subscribers = /* @__PURE__ */ new Map()) {
        let skipPollingIfUnfocused = false;
        let lowestPollingInterval = Number.POSITIVE_INFINITY;
        for (const entry of subscribers.values())if (!!entry.pollingInterval) {
            lowestPollingInterval = Math.min(entry.pollingInterval, lowestPollingInterval);
            skipPollingIfUnfocused = entry.skipPollingIfUnfocused || skipPollingIfUnfocused;
        }
        return {
            lowestPollingInterval: lowestPollingInterval,
            skipPollingIfUnfocused: skipPollingIfUnfocused
        };
    }
    return handler;
};
// src/query/core/buildMiddleware/queryLifecycle.ts
var $66b21aa7bd8497fc$var$buildQueryLifecycleHandler = ({ api: api, context: context, queryThunk: queryThunk, mutationThunk: mutationThunk })=>{
    const isPendingThunk = (0, $iDqdB.isPending)(queryThunk, mutationThunk);
    const isRejectedThunk = (0, $iDqdB.isRejected)(queryThunk, mutationThunk);
    const isFulfilledThunk = (0, $iDqdB.isFulfilled)(queryThunk, mutationThunk);
    const lifecycleMap = {};
    const handler = (action, mwApi)=>{
        var _a, _b, _c;
        if (isPendingThunk(action)) {
            const { requestId: requestId, arg: { endpointName: endpointName, originalArgs: originalArgs } } = action.meta;
            const endpointDefinition = $66b21aa7bd8497fc$var$getEndpointDefinition(context, endpointName);
            const onQueryStarted = endpointDefinition == null ? void 0 : endpointDefinition.onQueryStarted;
            if (onQueryStarted) {
                const lifecycle = {};
                const queryFulfilled = new Promise((resolve, reject)=>{
                    lifecycle.resolve = resolve;
                    lifecycle.reject = reject;
                });
                queryFulfilled.catch(()=>{});
                lifecycleMap[requestId] = lifecycle;
                const selector = api.endpoints[endpointName].select($66b21aa7bd8497fc$var$isAnyQueryDefinition(endpointDefinition) ? originalArgs : requestId);
                const extra = mwApi.dispatch((_, __, extra2)=>extra2);
                const lifecycleApi = $66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, mwApi), {
                    getCacheEntry: ()=>selector(mwApi.getState()),
                    requestId: requestId,
                    extra: extra,
                    updateCachedData: $66b21aa7bd8497fc$var$isAnyQueryDefinition(endpointDefinition) ? (updateRecipe)=>mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe)) : void 0,
                    queryFulfilled: queryFulfilled
                });
                onQueryStarted(originalArgs, lifecycleApi);
            }
        } else if (isFulfilledThunk(action)) {
            const { requestId: requestId, baseQueryMeta: baseQueryMeta } = action.meta;
            (_a = lifecycleMap[requestId]) == null || _a.resolve({
                data: action.payload,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        } else if (isRejectedThunk(action)) {
            const { requestId: requestId, rejectedWithValue: rejectedWithValue, baseQueryMeta: baseQueryMeta } = action.meta;
            (_c = lifecycleMap[requestId]) == null || _c.reject({
                error: (_b = action.payload) != null ? _b : action.error,
                isUnhandledError: !rejectedWithValue,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        }
    };
    return handler;
};
// src/query/core/buildMiddleware/windowEventHandling.ts
var $66b21aa7bd8497fc$var$buildWindowEventHandler = ({ reducerPath: reducerPath, context: context, api: api, refetchQuery: refetchQuery, internalState: internalState })=>{
    const { removeQueryResult: removeQueryResult } = api.internalActions;
    const handler = (action, mwApi)=>{
        if ($66b21aa7bd8497fc$var$onFocus.match(action)) refetchValidQueries(mwApi, "refetchOnFocus");
        if ($66b21aa7bd8497fc$var$onOnline.match(action)) refetchValidQueries(mwApi, "refetchOnReconnect");
    };
    function refetchValidQueries(api2, type) {
        const state = api2.getState()[reducerPath];
        const queries = state.queries;
        const subscriptions = internalState.currentSubscriptions;
        context.batch(()=>{
            for (const queryCacheKey of subscriptions.keys()){
                const querySubState = queries[queryCacheKey];
                const subscriptionSubState = subscriptions.get(queryCacheKey);
                if (!subscriptionSubState || !querySubState) continue;
                const values = [
                    ...subscriptionSubState.values()
                ];
                const shouldRefetch = values.some((sub)=>sub[type] === true) || values.every((sub)=>sub[type] === void 0) && state.config[type];
                if (shouldRefetch) {
                    if (subscriptionSubState.size === 0) api2.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== $66b21aa7bd8497fc$var$STATUS_UNINITIALIZED) api2.dispatch(refetchQuery(querySubState));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/index.ts
function $66b21aa7bd8497fc$var$buildMiddleware(input) {
    const { reducerPath: reducerPath, queryThunk: queryThunk, api: api, context: context, getInternalState: getInternalState } = input;
    const { apiUid: apiUid } = context;
    const actions2 = {
        invalidateTags: (0, $iDqdB.createAction)(`${reducerPath}/invalidateTags`)
    };
    const isThisApiSliceAction = (action)=>action.type.startsWith(`${reducerPath}/`);
    const handlerBuilders = [
        $66b21aa7bd8497fc$var$buildDevCheckHandler,
        $66b21aa7bd8497fc$var$buildCacheCollectionHandler,
        $66b21aa7bd8497fc$var$buildInvalidationByTagsHandler,
        $66b21aa7bd8497fc$var$buildPollingHandler,
        $66b21aa7bd8497fc$var$buildCacheLifecycleHandler,
        $66b21aa7bd8497fc$var$buildQueryLifecycleHandler
    ];
    const middleware = (mwApi)=>{
        let initialized2 = false;
        const internalState = getInternalState(mwApi.dispatch);
        const builderArgs = $66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, input), {
            internalState: internalState,
            refetchQuery: refetchQuery,
            isThisApiSliceAction: isThisApiSliceAction,
            mwApi: mwApi
        });
        const handlers = handlerBuilders.map((build)=>build(builderArgs));
        const batchedActionsHandler = $66b21aa7bd8497fc$var$buildBatchedActionsHandler(builderArgs);
        const windowEventsHandler = $66b21aa7bd8497fc$var$buildWindowEventHandler(builderArgs);
        return (next)=>{
            return (action)=>{
                if (!(0, $i5N98.isAction)(action)) return next(action);
                if (!initialized2) {
                    initialized2 = true;
                    mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
                }
                const mwApiWithNext = $66b21aa7bd8497fc$var$__spreadProps($66b21aa7bd8497fc$var$__spreadValues({}, mwApi), {
                    next: next
                });
                const stateBefore = mwApi.getState();
                const [actionShouldContinue, internalProbeResult] = batchedActionsHandler(action, mwApiWithNext, stateBefore);
                let res;
                if (actionShouldContinue) res = next(action);
                else res = internalProbeResult;
                if (!!mwApi.getState()[reducerPath]) {
                    windowEventsHandler(action, mwApiWithNext, stateBefore);
                    if (isThisApiSliceAction(action) || context.hasRehydrationInfo(action)) for (const handler of handlers)handler(action, mwApiWithNext, stateBefore);
                }
                return res;
            };
        };
    };
    return {
        middleware: middleware,
        actions: actions2
    };
    function refetchQuery(querySubState) {
        return input.api.endpoints[querySubState.endpointName].initiate(querySubState.originalArgs, {
            subscribe: false,
            forceRefetch: true
        });
    }
}
// src/query/core/module.ts
var $66b21aa7bd8497fc$export$2902d0921e535c0 = /* @__PURE__ */ Symbol();
var $66b21aa7bd8497fc$export$eb718ff92afd6f9b = ({ createSelector: createSelector2 = (0, $4KtEQ.createSelector) } = {})=>({
        name: $66b21aa7bd8497fc$export$2902d0921e535c0,
        init (api, { baseQuery: baseQuery, tagTypes: tagTypes, reducerPath: reducerPath, serializeQueryArgs: serializeQueryArgs, keepUnusedDataFor: keepUnusedDataFor, refetchOnMountOrArgChange: refetchOnMountOrArgChange, refetchOnFocus: refetchOnFocus, refetchOnReconnect: refetchOnReconnect, invalidationBehavior: invalidationBehavior, onSchemaFailure: onSchemaFailure, catchSchemaFailure: catchSchemaFailure, skipSchemaValidation: skipSchemaValidation }, context) {
            (0, $fTaOL.enablePatches)();
            $66b21aa7bd8497fc$var$assertCast(serializeQueryArgs);
            const assertTagType = (tag)=>{
                return tag;
            };
            Object.assign(api, {
                reducerPath: reducerPath,
                endpoints: {},
                internalActions: {
                    onOnline: $66b21aa7bd8497fc$var$onOnline,
                    onOffline: $66b21aa7bd8497fc$var$onOffline,
                    onFocus: $66b21aa7bd8497fc$var$onFocus,
                    onFocusLost: $66b21aa7bd8497fc$var$onFocusLost
                },
                util: {}
            });
            const selectors = $66b21aa7bd8497fc$var$buildSelectors({
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath,
                createSelector: createSelector2
            });
            const { selectInvalidatedBy: selectInvalidatedBy, selectCachedArgsForQuery: selectCachedArgsForQuery, buildQuerySelector: buildQuerySelector, buildInfiniteQuerySelector: buildInfiniteQuerySelector, buildMutationSelector: buildMutationSelector } = selectors;
            $66b21aa7bd8497fc$var$safeAssign(api.util, {
                selectInvalidatedBy: selectInvalidatedBy,
                selectCachedArgsForQuery: selectCachedArgsForQuery
            });
            const { queryThunk: queryThunk, infiniteQueryThunk: infiniteQueryThunk, mutationThunk: mutationThunk, patchQueryData: patchQueryData, updateQueryData: updateQueryData, upsertQueryData: upsertQueryData, prefetch: prefetch, buildMatchThunkActions: buildMatchThunkActions } = $66b21aa7bd8497fc$var$buildThunks({
                baseQuery: baseQuery,
                reducerPath: reducerPath,
                context: context,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                assertTagType: assertTagType,
                selectors: selectors,
                onSchemaFailure: onSchemaFailure,
                catchSchemaFailure: catchSchemaFailure,
                skipSchemaValidation: skipSchemaValidation
            });
            const { reducer: reducer, actions: sliceActions } = $66b21aa7bd8497fc$var$buildSlice({
                context: context,
                queryThunk: queryThunk,
                infiniteQueryThunk: infiniteQueryThunk,
                mutationThunk: mutationThunk,
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath,
                assertTagType: assertTagType,
                config: {
                    refetchOnFocus: refetchOnFocus,
                    refetchOnReconnect: refetchOnReconnect,
                    refetchOnMountOrArgChange: refetchOnMountOrArgChange,
                    keepUnusedDataFor: keepUnusedDataFor,
                    reducerPath: reducerPath,
                    invalidationBehavior: invalidationBehavior
                }
            });
            $66b21aa7bd8497fc$var$safeAssign(api.util, {
                patchQueryData: patchQueryData,
                updateQueryData: updateQueryData,
                upsertQueryData: upsertQueryData,
                prefetch: prefetch,
                resetApiState: sliceActions.resetApiState,
                upsertQueryEntries: sliceActions.cacheEntriesUpserted
            });
            $66b21aa7bd8497fc$var$safeAssign(api.internalActions, sliceActions);
            const internalStateMap = /* @__PURE__ */ new WeakMap();
            const getInternalState = (dispatch)=>{
                const state = $66b21aa7bd8497fc$var$getOrInsertComputed(internalStateMap, dispatch, ()=>({
                        currentSubscriptions: /* @__PURE__ */ new Map(),
                        currentPolls: /* @__PURE__ */ new Map(),
                        runningQueries: /* @__PURE__ */ new Map(),
                        runningMutations: /* @__PURE__ */ new Map()
                    }));
                return state;
            };
            const { buildInitiateQuery: buildInitiateQuery, buildInitiateInfiniteQuery: buildInitiateInfiniteQuery, buildInitiateMutation: buildInitiateMutation, getRunningMutationThunk: getRunningMutationThunk, getRunningMutationsThunk: getRunningMutationsThunk, getRunningQueriesThunk: getRunningQueriesThunk, getRunningQueryThunk: getRunningQueryThunk } = $66b21aa7bd8497fc$var$buildInitiate({
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                infiniteQueryThunk: infiniteQueryThunk,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                context: context,
                getInternalState: getInternalState
            });
            $66b21aa7bd8497fc$var$safeAssign(api.util, {
                getRunningMutationThunk: getRunningMutationThunk,
                getRunningMutationsThunk: getRunningMutationsThunk,
                getRunningQueryThunk: getRunningQueryThunk,
                getRunningQueriesThunk: getRunningQueriesThunk
            });
            const { middleware: middleware, actions: middlewareActions } = $66b21aa7bd8497fc$var$buildMiddleware({
                reducerPath: reducerPath,
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                infiniteQueryThunk: infiniteQueryThunk,
                api: api,
                assertTagType: assertTagType,
                selectors: selectors,
                getRunningQueryThunk: getRunningQueryThunk,
                getInternalState: getInternalState
            });
            $66b21aa7bd8497fc$var$safeAssign(api.util, middlewareActions);
            $66b21aa7bd8497fc$var$safeAssign(api, {
                reducer: reducer,
                middleware: middleware
            });
            return {
                name: $66b21aa7bd8497fc$export$2902d0921e535c0,
                injectEndpoint (endpointName, definition) {
                    var _a, _b;
                    const anyApi = api;
                    const endpoint = (_b = (_a = anyApi.endpoints)[endpointName]) != null ? _b : _a[endpointName] = {};
                    if ($66b21aa7bd8497fc$var$isQueryDefinition(definition)) $66b21aa7bd8497fc$var$safeAssign(endpoint, {
                        name: endpointName,
                        select: buildQuerySelector(endpointName, definition),
                        initiate: buildInitiateQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                    if ($66b21aa7bd8497fc$var$isMutationDefinition(definition)) $66b21aa7bd8497fc$var$safeAssign(endpoint, {
                        name: endpointName,
                        select: buildMutationSelector(),
                        initiate: buildInitiateMutation(endpointName)
                    }, buildMatchThunkActions(mutationThunk, endpointName));
                    if ($66b21aa7bd8497fc$var$isInfiniteQueryDefinition(definition)) $66b21aa7bd8497fc$var$safeAssign(endpoint, {
                        name: endpointName,
                        select: buildInfiniteQuerySelector(endpointName, definition),
                        initiate: buildInitiateInfiniteQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                }
            };
        }
    });
// src/query/core/index.ts
var $66b21aa7bd8497fc$export$9cdc2b9a8d94c842 = /* @__PURE__ */ $66b21aa7bd8497fc$export$f957748792d43646($66b21aa7bd8497fc$export$eb718ff92afd6f9b());

});
parcelRegister("i5N98", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $d2bed10dff9b4968$export$53b83ca8eaab0383);
$parcel$export(module.exports, "createStore", () => $d2bed10dff9b4968$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $d2bed10dff9b4968$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $d2bed10dff9b4968$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $d2bed10dff9b4968$export$9ff26e0402cc7b7);
$parcel$export(module.exports, "isAction", () => $d2bed10dff9b4968$export$b956e38827fca970);
// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("iDqdB", function(module, exports) {

$parcel$export(module.exports, "createAction", () => $d91034f47eb948f2$export$309c7a02b0b0bc62);
$parcel$export(module.exports, "formatProdErrorMessage", () => $d91034f47eb948f2$export$378fa86b259c0280);
$parcel$export(module.exports, "SHOULD_AUTOBATCH", () => $d91034f47eb948f2$export$8fb31c0f05df007b);
$parcel$export(module.exports, "prepareAutoBatched", () => $d91034f47eb948f2$export$39fcd5145ec5e4e2);
$parcel$export(module.exports, "autoBatchEnhancer", () => $d91034f47eb948f2$export$676277d7dca0f396);
$parcel$export(module.exports, "configureStore", () => $d91034f47eb948f2$export$7d8a5b498da695ac);
$parcel$export(module.exports, "isAnyOf", () => $d91034f47eb948f2$export$2c3435c7647f7b0d);
$parcel$export(module.exports, "isAllOf", () => $d91034f47eb948f2$export$9dd1fb32974da385);
$parcel$export(module.exports, "isPending", () => $d91034f47eb948f2$export$872dec21e9a69476);
$parcel$export(module.exports, "isRejected", () => $d91034f47eb948f2$export$a5c5d27e3994c5be);
$parcel$export(module.exports, "isRejectedWithValue", () => $d91034f47eb948f2$export$fcc3388fb56de601);
$parcel$export(module.exports, "isFulfilled", () => $d91034f47eb948f2$export$1da80a6ef1307441);
$parcel$export(module.exports, "isAsyncThunkAction", () => $d91034f47eb948f2$export$6aa4142d99c1abce);
$parcel$export(module.exports, "nanoid", () => $d91034f47eb948f2$export$ac4959f4f1338dfc);
$parcel$export(module.exports, "createAsyncThunk", () => $d91034f47eb948f2$export$6abd22dc03e5063f);
$parcel$export(module.exports, "createSlice", () => $d91034f47eb948f2$export$4d8d9bd83c24ae8b);
$parcel$export(module.exports, "createListenerMiddleware", () => $d91034f47eb948f2$export$1228acebbbcb485b);
$parcel$export(module.exports, "createNextState", () => (parcelRequire("fTaOL")).produce);
$parcel$export(module.exports, "current", () => (parcelRequire("fTaOL")).current);

var $i5N98 = parcelRequire("i5N98");

var $fTaOL = parcelRequire("fTaOL");

var $4KtEQ = parcelRequire("4KtEQ");

var $5RifM = parcelRequire("5RifM");
var $d91034f47eb948f2$var$__defProp = Object.defineProperty;
var $d91034f47eb948f2$var$__defProps = Object.defineProperties;
var $d91034f47eb948f2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d91034f47eb948f2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d91034f47eb948f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d91034f47eb948f2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d91034f47eb948f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $d91034f47eb948f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d91034f47eb948f2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d91034f47eb948f2$var$__hasOwnProp.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    if ($d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(b))if ($d91034f47eb948f2$var$__propIsEnum.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d91034f47eb948f2$var$__spreadProps = (a, b)=>$d91034f47eb948f2$var$__defProps(a, $d91034f47eb948f2$var$__getOwnPropDescs(b));
var $d91034f47eb948f2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d91034f47eb948f2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d91034f47eb948f2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d91034f47eb948f2$var$__publicField = (obj, key, value)=>$d91034f47eb948f2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $4KtEQ.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $fTaOL.isDraft)(value) ? (0, $fTaOL.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $d91034f47eb948f2$export$a5d3c27355e35910 = /* @__PURE__ */ $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $4KtEQ.weakMapMemoize));
// src/devtoolsExtension.ts
var $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $i5N98.compose;
    return (0, $i5N98.compose).apply(null, arguments);
};
var $d91034f47eb948f2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $i5N98.isAction)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $i5N98.isAction)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $fTaOL.isDraftable)(val) ? (0, $fTaOL.produce)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $i5N98.isPlainObject)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d91034f47eb948f2$var$isBoolean(thunk)) middlewareArray.push((0, $5RifM.thunk));
            else middlewareArray.push((0, $5RifM.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
var $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $d91034f47eb948f2$var$createRafWithFallbackTimer = (raf, timeout)=>{
    return (notify)=>{
        let called = false;
        const callback = ()=>{
            if (called) return;
            called = true;
            cancelAnimationFrame(rafId);
            clearTimeout(timerId);
            notify();
        };
        const rafId = raf(callback);
        const timerId = setTimeout(callback, timeout);
    };
};
var $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? $d91034f47eb948f2$var$createRafWithFallbackTimer(window.requestAnimationFrame, 100) : $d91034f47eb948f2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $i5N98.isPlainObject)(reducer)) rootReducer = (0, $i5N98.combineReducers)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $i5N98.compose);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $i5N98.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $i5N98.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $fTaOL.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $fTaOL.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $fTaOL.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        $d91034f47eb948f2$var$__publicField(this, "payload", payload);
        $d91034f47eb948f2$var$__publicField(this, "meta", meta);
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        $d91034f47eb948f2$var$__publicField(this, "payload", payload);
        $d91034f47eb948f2$var$__publicField(this, "meta", meta);
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d91034f47eb948f2$var$externalAbortMessage = "External signal was aborted";
var $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($d91034f47eb948f2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($d91034f47eb948f2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
var $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($d91034f47eb948f2$export$23a094319a4b586 || {});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $d91034f47eb948f2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $d91034f47eb948f2$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, ()=>$d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $d91034f47eb948f2$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop,
        pending: pending || $d91034f47eb948f2$var$noop,
        rejected: rejected || $d91034f47eb948f2$var$noop,
        settled: settled || $d91034f47eb948f2$var$noop
    });
}
function $d91034f47eb948f2$var$noop() {}
// src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $d91034f47eb948f2$var$isDraftTyped = (0, $fTaOL.isDraft);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $fTaOL.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $fTaOL.isDraft)(value) ? (0, $fTaOL.current)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $d91034f47eb948f2$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $d91034f47eb948f2$var$task = "task";
var $d91034f47eb948f2$var$listener = "listener";
var $d91034f47eb948f2$var$completed = "completed";
var $d91034f47eb948f2$var$cancelled = "cancelled";
var $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        $d91034f47eb948f2$var$__publicField(this, "code", code);
        $d91034f47eb948f2$var$__publicField(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$__publicField(this, "message");
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($d91034f47eb948f2$export$378fa86b259c0280(32));
};
var $d91034f47eb948f2$var$noop2 = ()=>{};
var $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason);
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop2;
    });
}
var $d91034f47eb948f2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $d91034f47eb948f2$var$assign } = Object;
var $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
var $d91034f47eb948f2$var$alm = "listenerMiddleware";
var $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($d91034f47eb948f2$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop2));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
var $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
var $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d91034f47eb948f2$var$createListenerEntry = /* @__PURE__ */ $d91034f47eb948f2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
var $d91034f47eb948f2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($d91034f47eb948f2$var$listenerCancelled);
    });
};
var $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$d91034f47eb948f2$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $d91034f47eb948f2$export$f03a6b845d3fb58b = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
var $d91034f47eb948f2$export$b1b8022855fb2b71 = /* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
var $d91034f47eb948f2$export$b03e9483f936dccb = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
var $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
var $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options)) != null ? _a : $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $d91034f47eb948f2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $d91034f47eb948f2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($d91034f47eb948f2$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $i5N98.isAction)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $d91034f47eb948f2$var$getOrInsertComputed(middlewareMap, middleware2, $d91034f47eb948f2$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $i5N98.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $d91034f47eb948f2$var$ORIGINAL_STATE = /* @__PURE__ */ Symbol.for("rtk-state-proxy-original");
var $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
var $d91034f47eb948f2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d91034f47eb948f2$var$createStateProxy = (state, reducerMap, initialStateCache)=>$d91034f47eb948f2$var$getOrInsertComputed($d91034f47eb948f2$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $d91034f47eb948f2$var$original = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
var $d91034f47eb948f2$var$emptyObject = {};
var $d91034f47eb948f2$var$noopReducer = (state = $d91034f47eb948f2$var$emptyObject)=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $i5N98.combineReducers)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("fTaOL", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => $b9146244dc19043a$export$541ac630993a4c84);
$parcel$export(module.exports, "isDraftable", () => $b9146244dc19043a$export$16e3aed3edb85946);
$parcel$export(module.exports, "original", () => $b9146244dc19043a$export$22e8af3f75a010e3);
$parcel$export(module.exports, "current", () => $b9146244dc19043a$export$97aac956da55dae9);
$parcel$export(module.exports, "enablePatches", () => $b9146244dc19043a$export$d3a6659991a0696c);
$parcel$export(module.exports, "produce", () => $b9146244dc19043a$export$b46cabe22e78bc00);
$parcel$export(module.exports, "produceWithPatches", () => $b9146244dc19043a$export$4da66d41c9492c78);
$parcel$export(module.exports, "applyPatches", () => $b9146244dc19043a$export$a8b8e03e6bbe5473);
var $b9146244dc19043a$var$__defProp = Object.defineProperty;
var $b9146244dc19043a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b9146244dc19043a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b9146244dc19043a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b9146244dc19043a$var$__defNormalProp = (obj, key, value)=>key in obj ? $b9146244dc19043a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b9146244dc19043a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b9146244dc19043a$var$__hasOwnProp.call(b, prop)) $b9146244dc19043a$var$__defNormalProp(a, prop, b[prop]);
    if ($b9146244dc19043a$var$__getOwnPropSymbols) {
        for (var prop of $b9146244dc19043a$var$__getOwnPropSymbols(b))if ($b9146244dc19043a$var$__propIsEnum.call(b, prop)) $b9146244dc19043a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $b9146244dc19043a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $b9146244dc19043a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $b9146244dc19043a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $b9146244dc19043a$var$errors = [];
function $b9146244dc19043a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $b9146244dc19043a$var$O = Object;
var $b9146244dc19043a$var$getPrototypeOf = $b9146244dc19043a$var$O.getPrototypeOf;
var $b9146244dc19043a$var$CONSTRUCTOR = "constructor";
var $b9146244dc19043a$var$PROTOTYPE = "prototype";
var $b9146244dc19043a$var$CONFIGURABLE = "configurable";
var $b9146244dc19043a$var$ENUMERABLE = "enumerable";
var $b9146244dc19043a$var$WRITABLE = "writable";
var $b9146244dc19043a$var$VALUE = "value";
var $b9146244dc19043a$export$541ac630993a4c84 = (value)=>!!value && !!value[$b9146244dc19043a$var$DRAFT_STATE];
function $b9146244dc19043a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $b9146244dc19043a$var$isPlainObject(value) || $b9146244dc19043a$var$isArray(value) || !!value[$b9146244dc19043a$export$6ee2082928bcb0ee] || !!((_a = value[$b9146244dc19043a$var$CONSTRUCTOR]) == null ? void 0 : _a[$b9146244dc19043a$export$6ee2082928bcb0ee]) || $b9146244dc19043a$var$isMap(value) || $b9146244dc19043a$var$isSet(value);
}
var $b9146244dc19043a$var$objectCtorString = $b9146244dc19043a$var$O[$b9146244dc19043a$var$PROTOTYPE][$b9146244dc19043a$var$CONSTRUCTOR].toString();
var $b9146244dc19043a$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $b9146244dc19043a$var$isPlainObject(value) {
    if (!value || !$b9146244dc19043a$var$isObjectish(value)) return false;
    const proto = $b9146244dc19043a$var$getPrototypeOf(value);
    if (proto === null || proto === $b9146244dc19043a$var$O[$b9146244dc19043a$var$PROTOTYPE]) return true;
    const Ctor = $b9146244dc19043a$var$O.hasOwnProperty.call(proto, $b9146244dc19043a$var$CONSTRUCTOR) && proto[$b9146244dc19043a$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$b9146244dc19043a$var$isFunction(Ctor)) return false;
    let ctorString = $b9146244dc19043a$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $b9146244dc19043a$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $b9146244dc19043a$var$objectCtorString;
}
function $b9146244dc19043a$export$22e8af3f75a010e3(value) {
    if (!$b9146244dc19043a$export$541ac630993a4c84(value)) $b9146244dc19043a$var$die(15, value);
    return value[$b9146244dc19043a$var$DRAFT_STATE].base_;
}
function $b9146244dc19043a$var$each(obj, iter, strict = true) {
    if ($b9146244dc19043a$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $b9146244dc19043a$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $b9146244dc19043a$var$getArchtype(thing) {
    const state = thing[$b9146244dc19043a$var$DRAFT_STATE];
    return state ? state.type_ : $b9146244dc19043a$var$isArray(thing) ? 1 /* Array */  : $b9146244dc19043a$var$isMap(thing) ? 2 /* Map */  : $b9146244dc19043a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $b9146244dc19043a$var$has = (thing, prop, type = $b9146244dc19043a$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $b9146244dc19043a$var$O[$b9146244dc19043a$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $b9146244dc19043a$var$get = (thing, prop, type = $b9146244dc19043a$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $b9146244dc19043a$var$set = (thing, propOrOldValue, value, type = $b9146244dc19043a$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $b9146244dc19043a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $b9146244dc19043a$var$isArray = Array.isArray;
var $b9146244dc19043a$var$isMap = (target)=>target instanceof Map;
var $b9146244dc19043a$var$isSet = (target)=>target instanceof Set;
var $b9146244dc19043a$var$isObjectish = (target)=>typeof target === "object";
var $b9146244dc19043a$var$isFunction = (target)=>typeof target === "function";
var $b9146244dc19043a$var$isBoolean = (target)=>typeof target === "boolean";
function $b9146244dc19043a$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $b9146244dc19043a$var$getProxyDraft = (value)=>{
    if (!$b9146244dc19043a$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$b9146244dc19043a$var$DRAFT_STATE];
};
var $b9146244dc19043a$var$latest = (state)=>state.copy_ || state.base_;
var $b9146244dc19043a$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $b9146244dc19043a$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $b9146244dc19043a$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $b9146244dc19043a$var$shallowCopy(base, strict) {
    if ($b9146244dc19043a$var$isMap(base)) return new Map(base);
    if ($b9146244dc19043a$var$isSet(base)) return new Set(base);
    if ($b9146244dc19043a$var$isArray(base)) return Array[$b9146244dc19043a$var$PROTOTYPE].slice.call(base);
    const isPlain = $b9146244dc19043a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $b9146244dc19043a$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$b9146244dc19043a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$b9146244dc19043a$var$WRITABLE] === false) {
                desc[$b9146244dc19043a$var$WRITABLE] = true;
                desc[$b9146244dc19043a$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$b9146244dc19043a$var$CONFIGURABLE]: true,
                [$b9146244dc19043a$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$b9146244dc19043a$var$ENUMERABLE]: desc[$b9146244dc19043a$var$ENUMERABLE],
                [$b9146244dc19043a$var$VALUE]: base[key]
            };
        }
        return $b9146244dc19043a$var$O.create($b9146244dc19043a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $b9146244dc19043a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $b9146244dc19043a$var$__spreadValues({}, base);
        const obj = $b9146244dc19043a$var$O.create(proto);
        return $b9146244dc19043a$var$O.assign(obj, base);
    }
}
function $b9146244dc19043a$export$792f3d81ea979f55(obj, deep = false) {
    if ($b9146244dc19043a$var$isFrozen(obj) || $b9146244dc19043a$export$541ac630993a4c84(obj) || !$b9146244dc19043a$export$16e3aed3edb85946(obj)) return obj;
    if ($b9146244dc19043a$var$getArchtype(obj) > 1) $b9146244dc19043a$var$O.defineProperties(obj, {
        set: $b9146244dc19043a$var$dontMutateMethodOverride,
        add: $b9146244dc19043a$var$dontMutateMethodOverride,
        clear: $b9146244dc19043a$var$dontMutateMethodOverride,
        delete: $b9146244dc19043a$var$dontMutateMethodOverride
    });
    $b9146244dc19043a$var$O.freeze(obj);
    if (deep) $b9146244dc19043a$var$each(obj, (_key, value)=>{
        $b9146244dc19043a$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $b9146244dc19043a$var$dontMutateFrozenCollections() {
    $b9146244dc19043a$var$die(2);
}
var $b9146244dc19043a$var$dontMutateMethodOverride = {
    [$b9146244dc19043a$var$VALUE]: $b9146244dc19043a$var$dontMutateFrozenCollections
};
function $b9146244dc19043a$var$isFrozen(obj) {
    if (obj === null || !$b9146244dc19043a$var$isObjectish(obj)) return true;
    return $b9146244dc19043a$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $b9146244dc19043a$var$PluginMapSet = "MapSet";
var $b9146244dc19043a$var$PluginPatches = "Patches";
var $b9146244dc19043a$var$PluginArrayMethods = "ArrayMethods";
var $b9146244dc19043a$var$plugins = {};
function $b9146244dc19043a$var$getPlugin(pluginKey) {
    const plugin = $b9146244dc19043a$var$plugins[pluginKey];
    if (!plugin) $b9146244dc19043a$var$die(0, pluginKey);
    return plugin;
}
var $b9146244dc19043a$var$isPluginLoaded = (pluginKey)=>!!$b9146244dc19043a$var$plugins[pluginKey];
function $b9146244dc19043a$var$loadPlugin(pluginKey, implementation) {
    if (!$b9146244dc19043a$var$plugins[pluginKey]) $b9146244dc19043a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $b9146244dc19043a$var$currentScope;
var $b9146244dc19043a$var$getCurrentScope = ()=>$b9146244dc19043a$var$currentScope;
var $b9146244dc19043a$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $b9146244dc19043a$var$isPluginLoaded($b9146244dc19043a$var$PluginMapSet) ? $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $b9146244dc19043a$var$isPluginLoaded($b9146244dc19043a$var$PluginArrayMethods) ? $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginArrayMethods) : void 0
    });
function $b9146244dc19043a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $b9146244dc19043a$var$revokeScope(scope) {
    $b9146244dc19043a$var$leaveScope(scope);
    scope.drafts_.forEach($b9146244dc19043a$var$revokeDraft);
    scope.drafts_ = null;
}
function $b9146244dc19043a$var$leaveScope(scope) {
    if (scope === $b9146244dc19043a$var$currentScope) $b9146244dc19043a$var$currentScope = scope.parent_;
}
var $b9146244dc19043a$var$enterScope = (immer2)=>$b9146244dc19043a$var$currentScope = $b9146244dc19043a$var$createScope($b9146244dc19043a$var$currentScope, immer2);
function $b9146244dc19043a$var$revokeDraft(draft) {
    const state = draft[$b9146244dc19043a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $b9146244dc19043a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$b9146244dc19043a$var$DRAFT_STATE].modified_) {
            $b9146244dc19043a$var$revokeScope(scope);
            $b9146244dc19043a$var$die(4);
        }
        if ($b9146244dc19043a$export$16e3aed3edb85946(result)) result = $b9146244dc19043a$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$b9146244dc19043a$var$DRAFT_STATE].base_, result, scope);
    } else result = $b9146244dc19043a$var$finalize(scope, baseDraft);
    $b9146244dc19043a$var$maybeFreeze(scope, result, true);
    $b9146244dc19043a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $b9146244dc19043a$export$45b790e32b2810ee ? result : void 0;
}
function $b9146244dc19043a$var$finalize(rootScope, value) {
    if ($b9146244dc19043a$var$isFrozen(value)) return value;
    const state = value[$b9146244dc19043a$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $b9146244dc19043a$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$b9146244dc19043a$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $b9146244dc19043a$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $b9146244dc19043a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $b9146244dc19043a$export$792f3d81ea979f55(value, deep);
}
function $b9146244dc19043a$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $b9146244dc19043a$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $b9146244dc19043a$var$EMPTY_LOCATIONS_RESULT = [];
function $b9146244dc19043a$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $b9146244dc19043a$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $b9146244dc19043a$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $b9146244dc19043a$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $b9146244dc19043a$var$each(parentCopy, (key, value)=>{
            if ($b9146244dc19043a$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $b9146244dc19043a$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$b9146244dc19043a$var$set(parentCopy, location, finalizedValue, parentType);
}
function $b9146244dc19043a$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$b9146244dc19043a$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $b9146244dc19043a$var$getFinalValue(state);
        $b9146244dc19043a$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $b9146244dc19043a$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $b9146244dc19043a$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $b9146244dc19043a$var$markStateFinalized(state);
    }
}
function $b9146244dc19043a$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($b9146244dc19043a$export$541ac630993a4c84(value)) {
        const state = value[$b9146244dc19043a$var$DRAFT_STATE];
        if ($b9146244dc19043a$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $b9146244dc19043a$var$prepareCopy(target);
            const finalizedValue = $b9146244dc19043a$var$getFinalValue(state);
            $b9146244dc19043a$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($b9146244dc19043a$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $b9146244dc19043a$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $b9146244dc19043a$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($b9146244dc19043a$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $b9146244dc19043a$var$handleValue($b9146244dc19043a$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $b9146244dc19043a$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($b9146244dc19043a$export$541ac630993a4c84(target) || handledSet.has(target) || !$b9146244dc19043a$export$16e3aed3edb85946(target) || $b9146244dc19043a$var$isFrozen(target)) return target;
    handledSet.add(target);
    $b9146244dc19043a$var$each(target, (key, value)=>{
        if ($b9146244dc19043a$export$541ac630993a4c84(value)) {
            const state = value[$b9146244dc19043a$var$DRAFT_STATE];
            if ($b9146244dc19043a$var$isSameScope(state, rootScope)) {
                const updatedValue = $b9146244dc19043a$var$getFinalValue(state);
                $b9146244dc19043a$var$set(target, key, updatedValue, target.type_);
                $b9146244dc19043a$var$markStateFinalized(state);
            }
        } else if ($b9146244dc19043a$export$16e3aed3edb85946(value)) $b9146244dc19043a$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $b9146244dc19043a$var$createProxyProxy(base, parent) {
    const baseIsArray = $b9146244dc19043a$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $b9146244dc19043a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $b9146244dc19043a$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $b9146244dc19043a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $b9146244dc19043a$var$objectTraps = {
    get (state, prop) {
        if (prop === $b9146244dc19043a$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $b9146244dc19043a$var$latest(state);
        if (!$b9146244dc19043a$var$has(source, prop, state.type_)) return $b9146244dc19043a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$b9146244dc19043a$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && $b9146244dc19043a$var$isArrayIndex(prop)) return value;
        if (value === $b9146244dc19043a$var$peek(state.base_, prop)) {
            $b9146244dc19043a$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $b9146244dc19043a$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $b9146244dc19043a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($b9146244dc19043a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $b9146244dc19043a$var$getDescriptorFromProto($b9146244dc19043a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $b9146244dc19043a$var$peek($b9146244dc19043a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$b9146244dc19043a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($b9146244dc19043a$var$is(value, current2) && (value !== void 0 || $b9146244dc19043a$var$has(state.base_, prop, state.type_))) return true;
            $b9146244dc19043a$var$prepareCopy(state);
            $b9146244dc19043a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $b9146244dc19043a$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $b9146244dc19043a$var$prepareCopy(state);
        if ($b9146244dc19043a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $b9146244dc19043a$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $b9146244dc19043a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$b9146244dc19043a$var$WRITABLE]: true,
            [$b9146244dc19043a$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$b9146244dc19043a$var$ENUMERABLE]: desc[$b9146244dc19043a$var$ENUMERABLE],
            [$b9146244dc19043a$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $b9146244dc19043a$var$die(11);
    },
    getPrototypeOf (state) {
        return $b9146244dc19043a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $b9146244dc19043a$var$die(12);
    }
};
var $b9146244dc19043a$var$arrayTraps = {};
for(let key in $b9146244dc19043a$var$objectTraps){
    let fn = $b9146244dc19043a$var$objectTraps[key];
    $b9146244dc19043a$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$b9146244dc19043a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $b9146244dc19043a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$b9146244dc19043a$var$arrayTraps.set = function(state, prop, value) {
    return $b9146244dc19043a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $b9146244dc19043a$var$peek(draft, prop) {
    const state = draft[$b9146244dc19043a$var$DRAFT_STATE];
    const source = state ? $b9146244dc19043a$var$latest(state) : draft;
    return source[prop];
}
function $b9146244dc19043a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $b9146244dc19043a$var$getDescriptorFromProto(source, prop);
    return desc ? $b9146244dc19043a$var$VALUE in desc ? desc[$b9146244dc19043a$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $b9146244dc19043a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $b9146244dc19043a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $b9146244dc19043a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $b9146244dc19043a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $b9146244dc19043a$var$markChanged(state.parent_);
    }
}
function $b9146244dc19043a$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $b9146244dc19043a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $b9146244dc19043a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($b9146244dc19043a$var$isFunction(base) && !$b9146244dc19043a$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$b9146244dc19043a$var$isFunction(recipe)) $b9146244dc19043a$var$die(6);
            if (patchListener !== void 0 && !$b9146244dc19043a$var$isFunction(patchListener)) $b9146244dc19043a$var$die(7);
            let result;
            if ($b9146244dc19043a$export$16e3aed3edb85946(base)) {
                const scope = $b9146244dc19043a$var$enterScope(this);
                const proxy = $b9146244dc19043a$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $b9146244dc19043a$var$revokeScope(scope);
                    else $b9146244dc19043a$var$leaveScope(scope);
                }
                $b9146244dc19043a$var$usePatchesInScope(scope, patchListener);
                return $b9146244dc19043a$var$processResult(result, scope);
            } else if (!base || !$b9146244dc19043a$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $b9146244dc19043a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $b9146244dc19043a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $b9146244dc19043a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($b9146244dc19043a$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($b9146244dc19043a$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($b9146244dc19043a$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($b9146244dc19043a$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$b9146244dc19043a$export$16e3aed3edb85946(base)) $b9146244dc19043a$var$die(8);
        if ($b9146244dc19043a$export$541ac630993a4c84(base)) base = $b9146244dc19043a$export$97aac956da55dae9(base);
        const scope = $b9146244dc19043a$var$enterScope(this);
        const proxy = $b9146244dc19043a$var$createProxy(scope, base, void 0);
        proxy[$b9146244dc19043a$var$DRAFT_STATE].isManual_ = true;
        $b9146244dc19043a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$b9146244dc19043a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $b9146244dc19043a$var$die(9);
        const { scope_: scope } = state;
        $b9146244dc19043a$var$usePatchesInScope(scope, patchListener);
        return $b9146244dc19043a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginPatches).applyPatches_;
        if ($b9146244dc19043a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $b9146244dc19043a$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $b9146244dc19043a$var$isMap(value) ? $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginMapSet).proxyMap_(value, parent) : $b9146244dc19043a$var$isSet(value) ? $b9146244dc19043a$var$getPlugin($b9146244dc19043a$var$PluginMapSet).proxySet_(value, parent) : $b9146244dc19043a$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $b9146244dc19043a$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $b9146244dc19043a$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $b9146244dc19043a$export$97aac956da55dae9(value) {
    if (!$b9146244dc19043a$export$541ac630993a4c84(value)) $b9146244dc19043a$var$die(10, value);
    return $b9146244dc19043a$var$currentImpl(value);
}
function $b9146244dc19043a$var$currentImpl(value) {
    if (!$b9146244dc19043a$export$16e3aed3edb85946(value) || $b9146244dc19043a$var$isFrozen(value)) return value;
    const state = value[$b9146244dc19043a$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $b9146244dc19043a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $b9146244dc19043a$var$shallowCopy(value, true);
    $b9146244dc19043a$var$each(copy, (key, childValue)=>{
        $b9146244dc19043a$var$set(copy, key, $b9146244dc19043a$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $b9146244dc19043a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if (state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $b9146244dc19043a$var$getProxyDraft($b9146244dc19043a$var$get(parentCopy, state.key_));
            const valueAtKey = $b9146244dc19043a$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $b9146244dc19043a$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $b9146244dc19043a$var$get(current2, key);
            if (!$b9146244dc19043a$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$b9146244dc19043a$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $b9146244dc19043a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $b9146244dc19043a$var$get(base_, key, type_);
            const value = $b9146244dc19043a$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $b9146244dc19043a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $b9146244dc19043a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $b9146244dc19043a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $b9146244dc19043a$var$CONSTRUCTOR)) $b9146244dc19043a$var$die(errorOffset + 3);
                if ($b9146244dc19043a$var$isFunction(base) && p === $b9146244dc19043a$var$PROTOTYPE) $b9146244dc19043a$var$die(errorOffset + 3);
                base = $b9146244dc19043a$var$get(base, p);
                if (!$b9146244dc19043a$var$isObjectish(base)) $b9146244dc19043a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $b9146244dc19043a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $b9146244dc19043a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $b9146244dc19043a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$b9146244dc19043a$export$16e3aed3edb85946(obj)) return obj;
        if ($b9146244dc19043a$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($b9146244dc19043a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($b9146244dc19043a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($b9146244dc19043a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($b9146244dc19043a$var$has(obj, $b9146244dc19043a$export$6ee2082928bcb0ee)) cloned[$b9146244dc19043a$export$6ee2082928bcb0ee] = obj[$b9146244dc19043a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($b9146244dc19043a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $b9146244dc19043a$var$loadPlugin($b9146244dc19043a$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $b9146244dc19043a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$b9146244dc19043a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b9146244dc19043a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$b9146244dc19043a$var$latest(state).has(key) || $b9146244dc19043a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $b9146244dc19043a$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $b9146244dc19043a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b9146244dc19043a$var$latest(state).size) {
                prepareMapCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $b9146244dc19043a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            $b9146244dc19043a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $b9146244dc19043a$var$latest(state).get(key);
            if (state.finalized_ || !$b9146244dc19043a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $b9146244dc19043a$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($b9146244dc19043a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$b9146244dc19043a$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$b9146244dc19043a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b9146244dc19043a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.copy_.add(value);
                $b9146244dc19043a$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $b9146244dc19043a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b9146244dc19043a$var$latest(state).size) {
                prepareSetCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($b9146244dc19043a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$b9146244dc19043a$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($b9146244dc19043a$export$16e3aed3edb85946(value)) {
                    const draft = $b9146244dc19043a$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $b9146244dc19043a$var$die(3, JSON.stringify($b9146244dc19043a$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($b9146244dc19043a$var$getValue(value));
            });
        }
    }
    $b9146244dc19043a$var$loadPlugin($b9146244dc19043a$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $b9146244dc19043a$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $b9146244dc19043a$var$prepareCopy(state);
        const result = operation();
        $b9146244dc19043a$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $b9146244dc19043a$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            var _a;
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex((_a = args[0]) != null ? _a : 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = $b9146244dc19043a$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $b9146244dc19043a$var$loadPlugin($b9146244dc19043a$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $b9146244dc19043a$var$immer = new $b9146244dc19043a$export$aaadc6ff0f822719();
var $b9146244dc19043a$export$b46cabe22e78bc00 = $b9146244dc19043a$var$immer.produce;
var $b9146244dc19043a$export$4da66d41c9492c78 = /* @__PURE__ */ $b9146244dc19043a$var$immer.produceWithPatches.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$573f26f60825c493 = /* @__PURE__ */ $b9146244dc19043a$var$immer.setAutoFreeze.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$333ce65961cbe047 = /* @__PURE__ */ $b9146244dc19043a$var$immer.setUseStrictShallowCopy.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$1045b3be3904c489 = /* @__PURE__ */ $b9146244dc19043a$var$immer.setUseStrictIteration.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $b9146244dc19043a$var$immer.applyPatches.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$3c3214997190395f = /* @__PURE__ */ $b9146244dc19043a$var$immer.createDraft.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$c60f5e69c521b528 = /* @__PURE__ */ $b9146244dc19043a$var$immer.finishDraft.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$c05b21e3257751e5 = (value)=>value;
var $b9146244dc19043a$export$20f911b3f8cf0b74 = (value)=>value;

});

parcelRegister("4KtEQ", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", () => $375276bea32f9eda$export$8402dc26d96f6902);
$parcel$export(module.exports, "createSelectorCreator", () => $375276bea32f9eda$export$5943f4447f6ef248);
$parcel$export(module.exports, "createSelector", () => $375276bea32f9eda$export$595d22ed68ca2841);
var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});

});

parcelRegister("5RifM", function(module, exports) {

$parcel$export(module.exports, "thunk", () => $44400fc0fe63e7bd$export$dd164f5517779f15);
$parcel$export(module.exports, "withExtraArgument", () => $44400fc0fe63e7bd$export$16d06542a1949d9e);
// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;

});


parcelRegister("fKdhF", function(module, exports) {

$parcel$export(module.exports, "SchemaError", () => $b76574cd862e85bc$export$44dde8d2b17fc96a);
// src/getDotPath/getDotPath.ts
function $b76574cd862e85bc$export$31d66bebc5d58a1(issue) {
    if (issue.path?.length) {
        let dotPath = "";
        for (const item of issue.path){
            const key = typeof item === "object" ? item.key : item;
            if (typeof key === "string" || typeof key === "number") {
                if (dotPath) dotPath += `.${key}`;
                else dotPath += key;
            } else return null;
        }
        return dotPath;
    }
    return null;
}
// src/SchemaError/SchemaError.ts
var $b76574cd862e85bc$export$44dde8d2b17fc96a = class extends Error {
    /**
   * The schema issues.
   */ issues;
    /**
   * Creates a schema error with useful information.
   *
   * @param issues The schema issues.
   */ constructor(issues){
        super(issues[0].message);
        this.name = "SchemaError";
        this.issues = issues;
    }
};

});


parcelRegister("7jD0c", function(module, exports) {

$parcel$export(module.exports, "shallowEqual", () => $55388fc2f116d4d7$export$d36bdfa510afb180);
$parcel$export(module.exports, "ReactReduxContext", () => $55388fc2f116d4d7$export$cc80c08dc91f1c00);
$parcel$export(module.exports, "Provider", () => $55388fc2f116d4d7$export$2881499e37b75b9a);
$parcel$export(module.exports, "useStore", () => $55388fc2f116d4d7$export$6ccbb43953eebf8);
$parcel$export(module.exports, "useDispatch", () => $55388fc2f116d4d7$export$8ad76b76a4c905f8);
$parcel$export(module.exports, "useSelector", () => $55388fc2f116d4d7$export$2105062e25df4afe);
$parcel$export(module.exports, "batch", () => $55388fc2f116d4d7$export$712ea50be43a7858);

var $acw62 = parcelRequire("acw62");

var $9CK6d = parcelRequire("9CK6d");
var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$_connect;
var $55388fc2f116d4d7$export$8807b5ba46f9d0b7 = $55388fc2f116d4d7$var$_connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $9CK6d.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;

});
parcelRegister("9CK6d", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iZZ9K"));

});
parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});





parcelRegister("kfC4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c84e93a6bf6788a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $1c84e93a6bf6788a$var$roleStyles = {
    admin: 'border-purple-500/20 bg-purple-500/10 text-purple-400',
    trader: 'border-emerald-500/20 bg-emerald-500/10 text-emerald-400',
    investor: 'border-cyan-500/20 bg-cyan-500/10 text-cyan-400',
    viewer: 'border-blue-500/20 bg-blue-500/10 text-blue-400'
};
const $1c84e93a6bf6788a$var$roleLabels = {
    admin: 'Admin',
    trader: 'Trader',
    investor: 'Investor',
    viewer: 'Viewer'
};
const $1c84e93a6bf6788a$var$UserTypeBadge = ({ role: role, className: className = '', compact: compact = false })=>{
    const key = role?.trim().toLowerCase() || '';
    const label = $1c84e93a6bf6788a$var$roleLabels[key] || role?.trim() || 'Account';
    const sizeClasses = compact ? 'px-1.5 py-0.5 text-[8px]' : 'px-2.5 py-0.5 text-xs';
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        "aria-label": `User type: ${label}`,
        title: `User type: ${label}`,
        className: `inline-flex shrink-0 items-center rounded-full border font-semibold leading-none ${sizeClasses} ${$1c84e93a6bf6788a$var$roleStyles[key] || 'border-white/10 bg-white/5 text-muted'} ${className}`,
        children: label
    });
};
var $1c84e93a6bf6788a$export$2e2bcd8739ae039 = $1c84e93a6bf6788a$var$UserTypeBadge;

});

parcelRegister("bKJAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $88e75a6fb6edc067$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $88e75a6fb6edc067$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Activity", [
    [
        "path",
        {
            d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
            key: "169zse"
        }
    ]
]);

});

parcelRegister("gjSmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $be189782912469dc$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $be189782912469dc$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ChartColumn", [
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "M18 17V9",
            key: "2bz60n"
        }
    ],
    [
        "path",
        {
            d: "M13 17V5",
            key: "1frdt8"
        }
    ],
    [
        "path",
        {
            d: "M8 17v-3",
            key: "17ska0"
        }
    ]
]);

});

parcelRegister("a5TAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $75957e2fe5dd6cb2$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $75957e2fe5dd6cb2$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Bell", [
    [
        "path",
        {
            d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9",
            key: "1qo2s2"
        }
    ],
    [
        "path",
        {
            d: "M10.3 21a1.94 1.94 0 0 0 3.4 0",
            key: "qgo35s"
        }
    ]
]);

});

parcelRegister("4wROA", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c3e517ec92034a$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $34c3e517ec92034a$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Briefcase", [
    [
        "path",
        {
            d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
            key: "jecpp"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "6",
            rx: "2",
            key: "i6l2r4"
        }
    ]
]);

});

parcelRegister("gn8IX", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb58fc2118025b6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $beb58fc2118025b6$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CalendarDays", [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 18h.01",
            key: "lrp35t"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ],
    [
        "path",
        {
            d: "M16 18h.01",
            key: "kzsmim"
        }
    ]
]);

});

parcelRegister("i9lAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d369d0106125901d$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $d369d0106125901d$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Database", [
    [
        "ellipse",
        {
            cx: "12",
            cy: "5",
            rx: "9",
            ry: "3",
            key: "msslwz"
        }
    ],
    [
        "path",
        {
            d: "M3 5V19A9 3 0 0 0 21 19V5",
            key: "1wlel7"
        }
    ],
    [
        "path",
        {
            d: "M3 12A9 3 0 0 0 21 12",
            key: "mv7ke4"
        }
    ]
]);

});

parcelRegister("eUAhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb270212de20834$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $adb270212de20834$export$2e2bcd8739ae039 = (0, $b4WUK.default)("FileText", [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
]);

});

parcelRegister("kwEKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef166891ec0b7b3f$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $ef166891ec0b7b3f$export$2e2bcd8739ae039 = (0, $b4WUK.default)("List", [
    [
        "path",
        {
            d: "M3 12h.01",
            key: "nlz23k"
        }
    ],
    [
        "path",
        {
            d: "M3 18h.01",
            key: "1tta3j"
        }
    ],
    [
        "path",
        {
            d: "M3 6h.01",
            key: "1rqtza"
        }
    ],
    [
        "path",
        {
            d: "M8 12h13",
            key: "1za7za"
        }
    ],
    [
        "path",
        {
            d: "M8 18h13",
            key: "1lx6n3"
        }
    ],
    [
        "path",
        {
            d: "M8 6h13",
            key: "ik3vkj"
        }
    ]
]);

});

parcelRegister("4mRnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e2a0bac378de78$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $32e2a0bac378de78$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ChartPie", [
    [
        "path",
        {
            d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
            key: "pzmjnu"
        }
    ],
    [
        "path",
        {
            d: "M21.21 15.89A10 10 0 1 1 8 2.83",
            key: "k2fpak"
        }
    ]
]);

});

parcelRegister("cSGqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $960b709ecb4ade55$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $960b709ecb4ade55$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Shield", [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ]
]);

});

parcelRegister("753mY", function(module, exports) {

$parcel$export(module.exports, "default", () => $527b9d2547be6d0a$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $527b9d2547be6d0a$export$2e2bcd8739ae039 = (0, $b4WUK.default)("SlidersHorizontal", [
    [
        "line",
        {
            x1: "21",
            x2: "14",
            y1: "4",
            y2: "4",
            key: "obuewd"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "3",
            y1: "4",
            y2: "4",
            key: "1q6298"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "12",
            y1: "12",
            y2: "12",
            key: "1iu8h1"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "3",
            y1: "12",
            y2: "12",
            key: "ntss68"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "16",
            y1: "20",
            y2: "20",
            key: "14d8ph"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "3",
            y1: "20",
            y2: "20",
            key: "m0wm8r"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "2",
            y2: "6",
            key: "14e1ph"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "8",
            y1: "10",
            y2: "14",
            key: "1i6ji0"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "16",
            y1: "18",
            y2: "22",
            key: "1lctlv"
        }
    ]
]);

});

parcelRegister("bbkWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8240f8fcfc513968$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Check", [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
]);

});

parcelRegister("jFR94", function(module, exports) {

$parcel$export(module.exports, "default", () => $e52b122f04c04d7d$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $e52b122f04c04d7d$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Info", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
]);

});

parcelRegister("hiXj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9921f4f81a419f0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $c9921f4f81a419f0$export$2e2bcd8739ae039 = (0, $b4WUK.default)("TrendingUp", [
    [
        "polyline",
        {
            points: "22 7 13.5 15.5 8.5 10.5 2 17",
            key: "126l90"
        }
    ],
    [
        "polyline",
        {
            points: "16 7 22 7 22 13",
            key: "kwv8wd"
        }
    ]
]);

});

parcelRegister("k8QNV", function(module, exports) {

$parcel$export(module.exports, "formatDateTimeET", () => $76dc77359044b87d$export$da64fb0d6ddc83a);
$parcel$export(module.exports, "formatTimeET", () => $76dc77359044b87d$export$ff5577ee71c12d94);
const $76dc77359044b87d$export$da64fb0d6ddc83a = (value)=>{
    if (!value) return "\u2014";
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
            const [y, m, d] = trimmed.split('-').map(Number);
            const date = new Date(y, m - 1, d, 12, 0, 0);
            return new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/New_York',
                year: 'numeric',
                month: 'short',
                day: '2-digit'
            }).format(date);
        }
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return "\u2014";
    return new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).format(date) + ' ET';
};
const $76dc77359044b87d$export$ff5577ee71c12d94 = (value)=>{
    if (!value) return "\u2014";
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return "\u2014";
    return new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).format(date) + ' ET';
};

});

parcelRegister("8Zl6K", function(module, exports) {

$parcel$export(module.exports, "default", () => $466ae8c59be811a5$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $466ae8c59be811a5$var$LoadingSpinner = ({ size: size = 'md', className: className = '' })=>{
    const sizeClasses = {
        sm: 'w-4 h-4',
        md: 'w-6 h-6',
        lg: 'w-8 h-8'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `flex items-center justify-center ${className}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: `animate-spin rounded-full border-2 border-gray-300 border-t-primary-500 ${sizeClasses[size]}`,
            role: "status",
            "aria-label": "Loading",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "sr-only",
                children: "Loading..."
            })
        })
    });
};
var $466ae8c59be811a5$export$2e2bcd8739ae039 = $466ae8c59be811a5$var$LoadingSpinner;

});

parcelRegister("kTCPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f36710bd138be5d0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $f36710bd138be5d0$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CircleCheck", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
]);

});

parcelRegister("7ZFis", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d1e438e50e1e686$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $5d1e438e50e1e686$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Cloud", [
    [
        "path",
        {
            d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z",
            key: "p7xjir"
        }
    ]
]);

});

parcelRegister("6JulE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e6e7c8f114d04e1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $4e6e7c8f114d04e1$export$2e2bcd8739ae039 = (0, $b4WUK.default)("HardDrive", [
    [
        "line",
        {
            x1: "22",
            x2: "2",
            y1: "12",
            y2: "12",
            key: "1y58io"
        }
    ],
    [
        "path",
        {
            d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
            key: "oot6mr"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6.01",
            y1: "16",
            y2: "16",
            key: "sgf278"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10.01",
            y1: "16",
            y2: "16",
            key: "1l4acy"
        }
    ]
]);

});

parcelRegister("biC54", function(module, exports) {

$parcel$export(module.exports, "default", () => $839eea37a960d2b1$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $839eea37a960d2b1$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CircleX", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
]);

});

parcelRegister("9u0TL", function(module, exports) {

$parcel$export(module.exports, "formatDownloadTaskBarCount", () => $cb458ebb96c52fc7$export$1866770e6904a6f1);
const $cb458ebb96c52fc7$export$1866770e6904a6f1 = (bars, fallback = '')=>typeof bars === 'number' && Number.isFinite(bars) ? bars.toLocaleString() : fallback;

});

parcelRegister("cfqjJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $655c3c44bf834291$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $02HYJ = parcelRequire("02HYJ");
var $jztMd = parcelRequire("jztMd");
var $gtsgu = parcelRequire("gtsgu");
var $gN9hF = parcelRequire("gN9hF");
var $cSGqD = parcelRequire("cSGqD");
var $2w97G = parcelRequire("2w97G");
var $hPAJY = parcelRequire("hPAJY");

var $2wVnk = parcelRequire("2wVnk");

var $lO99W = parcelRequire("lO99W");

var $7eyud = parcelRequire("7eyud");

var $70wbS = parcelRequire("70wbS");
const $655c3c44bf834291$var$GatewayConfigModal = ({ isOpen: isOpen, onClose: onClose, onSuccess: onSuccess, currentUsername: currentUsername, currentMode: currentMode, savedGateways: savedGateways })=>{
    const { user: user } = (0, $70wbS.useAuth)();
    const isInvestor = user?.role === 'investor';
    const [username, setUsername] = (0, $acw62.useState)(currentUsername || '');
    const [password, setPassword] = (0, $acw62.useState)('');
    const [mode, setMode] = (0, $acw62.useState)(isInvestor ? 'live' : currentMode || 'paper');
    // Default gatewayId to the mode name to ensure separation by default
    const [gatewayId, setGatewayId] = (0, $acw62.useState)(isInvestor ? 'live' : currentMode || 'paper');
    const [configStatus, setConfigStatus] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    // Warning Modal State
    const [showWarning, setShowWarning] = (0, $acw62.useState)(false);
    const [activating, setActivating] = (0, $acw62.useState)(false);
    // Helper to find saved config for a mode
    const findSavedConfig = (targetMode)=>{
        if (!savedGateways) return null;
        // First try to find by ID matching mode (e.g. id="paper")
        let found = savedGateways.find((g)=>g.id === targetMode);
        // Fallback to finding by mode
        if (!found) found = savedGateways.find((g)=>g.mode === targetMode);
        return found;
    };
    const savedConfig = findSavedConfig(mode);
    const isActive = savedConfig?.is_active;
    // Reset state when modal opens
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (isOpen) {
            const initialMode = isInvestor ? 'live' : currentMode || 'paper';
            setMode(initialMode);
            setGatewayId(initialMode); // Default ID to mode name
            // Try to pre-fill from saved gateways first
            const saved = findSavedConfig(initialMode);
            if (saved && saved.username) {
                setUsername(saved.username);
                if (saved.id) setGatewayId(saved.id);
            } else setUsername(currentUsername || '');
            setPassword('');
            setConfigStatus(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        isInvestor
    ]);
    if (!isOpen) return null;
    const handleModeSwitch = (newMode)=>{
        setMode(newMode);
        setConfigStatus(null);
        // Try to find saved config for the new mode
        const saved = findSavedConfig(newMode);
        if (saved && saved.username) {
            setUsername(saved.username);
            setGatewayId(saved.id);
        } else {
            // If switching back to initial mode, restore initial props
            if (newMode === currentMode) setUsername(currentUsername || '');
            else setUsername('');
            // Default ID to new mode name if no saved config found
            setGatewayId(newMode);
        }
        setPassword(''); // Always clear password for security
    };
    const handleSaveConfig = async (e)=>{
        e.preventDefault();
        if (!username || !password) {
            setConfigStatus({
                type: 'error',
                message: 'Username and password are required'
            });
            return;
        }
        setLoading(true);
        setConfigStatus({
            type: 'info',
            message: 'Saving configuration...'
        });
        try {
            const response = await (0, $2wVnk.tradingApi).configureIBGateway(username, password, mode, gatewayId || undefined, undefined, undefined // No renaming needed
            );
            if (response.success) {
                setConfigStatus({
                    type: 'success',
                    message: isInvestor ? 'Configuration saved. Preparing broker controls...' : 'Configuration saved. You can now activate this gateway.'
                });
                setPassword('');
                await Promise.resolve(onSuccess());
                if (isInvestor) setTimeout(onClose, 700);
            } else setConfigStatus({
                type: 'error',
                message: response.error || 'Failed to configure gateway'
            });
        } catch (err) {
            setConfigStatus({
                type: 'error',
                message: err.message || 'An error occurred'
            });
        } finally{
            setLoading(false);
        }
    };
    const handleActivateClick = ()=>{
        setShowWarning(true);
    };
    const handleConfirmSwitch = async ()=>{
        setActivating(true);
        try {
            // Use the gatewayId from state (which should match the saved one if we are in this state)
            // Or better, use the ID from the saved config we found
            const targetId = savedConfig?.id || gatewayId;
            const response = await (0, $2wVnk.tradingApi).activateIBGateway(targetId);
            if (response.success) {
                setConfigStatus({
                    type: 'success',
                    message: 'Gateway activated successfully!'
                });
                setTimeout(()=>{
                    onSuccess();
                    onClose();
                }, 1500);
            } else setConfigStatus({
                type: 'error',
                message: response.error || 'Failed to activate gateway'
            });
        } catch (err) {
            setConfigStatus({
                type: 'error',
                message: err.message || 'Failed to activate gateway'
            });
        } finally{
            setActivating(false);
            setShowWarning(false);
        }
    };
    const handleDeleteConfig = async ()=>{
        if (!savedConfig || !savedConfig.id) return;
        if (!window.confirm(`Are you sure you want to delete the configuration for ${savedConfig.mode} mode? This will stop the gateway if running.`)) return;
        setLoading(true);
        setConfigStatus({
            type: 'info',
            message: 'Deleting configuration...'
        });
        try {
            const response = await (0, $2wVnk.tradingApi).deleteIBGatewayConfig(savedConfig.id);
            if (response.success) {
                setConfigStatus({
                    type: 'success',
                    message: 'Configuration deleted.'
                });
                setUsername('');
                setPassword('');
                // If the deleted one was the current one, reset state to empty
                // Delay close/refresh
                setTimeout(()=>{
                    onSuccess();
                // Don't close immediately so user sees message
                }, 1000);
            } else setConfigStatus({
                type: 'error',
                message: response.error || 'Failed to delete configuration'
            });
        } catch (err) {
            setConfigStatus({
                type: 'error',
                message: err.message || 'An error occurred'
            });
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7eyud.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 backdrop-blur-md p-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg-[#121222] border border-white/10 rounded-2xl w-full max-w-lg shadow-[0_0_50px_rgba(0,0,0,0.5)] overflow-hidden animate-in fade-in zoom-in duration-200",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p-6 border-b border-white/10 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-2 rounded-lg bg-neon/10 text-neon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gN9hF.default), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        className: "text-lg font-bold text-white",
                                                        children: "Gateway Settings"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-xs text-muted",
                                                        children: username ? `Currently configured: ${username}` : 'Configure IB credentials'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: onClose,
                                        className: "text-muted hover:text-white transition",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                            className: "w-5 h-5"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "p-6 space-y-6",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                                    onSubmit: handleSaveConfig,
                                    className: "space-y-6",
                                    autoComplete: "off",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "block text-xs font-medium text-muted uppercase tracking-wider mb-2",
                                                    children: "Trading Mode"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: `grid ${isInvestor ? 'grid-cols-1' : 'grid-cols-2'} gap-4`,
                                                    children: [
                                                        !isInvestor && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                            type: "button",
                                                            onClick: ()=>handleModeSwitch('paper'),
                                                            className: `p-3 rounded-xl border transition-all duration-200 flex items-center justify-center gap-2 text-sm font-medium ${mode === 'paper' ? 'bg-neon/10 border-neon text-neon shadow-[0_0_15px_rgba(34,197,94,0.1)]' : 'bg-black/20 border-white/5 text-muted hover:border-white/20 hover:bg-white/5'}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cSGqD.default), {
                                                                    className: "w-4 h-4"
                                                                }),
                                                                "Paper",
                                                                findSavedConfig('paper')?.is_active && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "ml-1 px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-400 text-[10px]",
                                                                    children: "ACTIVE"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                            type: "button",
                                                            onClick: ()=>handleModeSwitch('live'),
                                                            disabled: isInvestor,
                                                            className: `p-3 rounded-xl border transition-all duration-200 flex items-center justify-center gap-2 text-sm font-medium ${mode === 'live' ? 'bg-neon/10 border-neon text-neon shadow-[0_0_15px_rgba(34,197,94,0.1)]' : 'bg-black/20 border-white/5 text-muted hover:border-white/20 hover:bg-white/5'} ${isInvestor ? 'opacity-90 cursor-default' : ''}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02HYJ.default), {
                                                                    className: "w-4 h-4"
                                                                }),
                                                                "Live Production",
                                                                findSavedConfig('live')?.is_active && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "ml-1 px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-400 text-[10px]",
                                                                    children: "ACTIVE"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "block text-xs font-medium text-muted uppercase tracking-wider mb-2",
                                                    children: "TWS Username"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    name: "tws-username",
                                                    id: "tws-username",
                                                    autoComplete: "off",
                                                    value: username,
                                                    onChange: (e)=>setUsername(e.target.value),
                                                    className: "w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/20 focus:outline-none focus:border-neon focus:ring-1 focus:ring-neon/50 transition-all duration-200",
                                                    placeholder: "Enter IB username"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "block text-xs font-medium text-muted uppercase tracking-wider mb-2",
                                                    children: "TWS Password"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "password",
                                                    name: "tws-password",
                                                    id: "tws-password",
                                                    autoComplete: "new-password",
                                                    value: password,
                                                    onChange: (e)=>setPassword(e.target.value),
                                                    className: "w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-white placeholder-white/20 focus:outline-none focus:border-neon focus:ring-1 focus:ring-neon/50 transition-all duration-200",
                                                    placeholder: "Enter IB password"
                                                })
                                            ]
                                        }),
                                        configStatus && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: `p-4 rounded-xl flex items-start gap-3 border ${configStatus.type === 'error' ? 'bg-red-500/5 border-red-500/20 text-red-400' : configStatus.type === 'success' ? 'bg-emerald-500/5 border-emerald-500/20 text-emerald-400' : 'bg-blue-500/5 border-blue-500/20 text-blue-400'}`,
                                            children: [
                                                configStatus.type === 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02HYJ.default), {
                                                    className: "w-5 h-5 shrink-0"
                                                }),
                                                configStatus.type === 'success' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jztMd.default), {
                                                    className: "w-5 h-5 shrink-0"
                                                }),
                                                configStatus.type === 'info' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w-5 h-5 shrink-0 border-2 border-current border-t-transparent rounded-full animate-spin"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "text-sm font-medium",
                                                    children: configStatus.message
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pt-2 flex flex-col gap-3",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "submit",
                                                            disabled: loading,
                                                            className: "flex-1 bg-blue-500/10 hover:bg-blue-500/20 text-blue-300 hover:text-blue-200 font-medium py-3.5 rounded-xl transition-all duration-200 border border-blue-500/20 hover:border-blue-500/40 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                                            children: loading ? 'Saving...' : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jztMd.default), {
                                                                        className: "w-5 h-5"
                                                                    }),
                                                                    "Save"
                                                                ]
                                                            })
                                                        }),
                                                        savedConfig && !isActive && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                            type: "button",
                                                            onClick: handleActivateClick,
                                                            disabled: loading,
                                                            className: "flex-1 bg-neon hover:bg-neon-hover text-black font-bold py-3.5 rounded-xl transition-all duration-200 shadow-lg shadow-neon/20 hover:shadow-neon/40 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transform hover:-translate-y-0.5 active:translate-y-0",
                                                            title: "Activate this gateway",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gtsgu.default), {
                                                                    className: "w-5 h-5"
                                                                }),
                                                                "Activate"
                                                            ]
                                                        }),
                                                        savedConfig && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            onClick: handleDeleteConfig,
                                                            disabled: loading,
                                                            title: "Delete configuration",
                                                            className: "w-14 bg-red-500/10 hover:bg-red-500/20 text-red-400 font-medium py-3.5 rounded-xl transition-all duration-200 border border-red-500/20 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2w97G.default), {
                                                                className: "w-5 h-5"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                isActive && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 font-medium py-3.5 rounded-xl flex items-center justify-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jztMd.default), {
                                                            className: "w-5 h-5"
                                                        }),
                                                        "Currently Active"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lO99W.default), {
                    isOpen: showWarning,
                    onClose: ()=>setShowWarning(false),
                    onConfirm: handleConfirmSwitch,
                    targetGatewayName: `${mode === 'live' ? 'Live' : 'Paper'} (${username})`,
                    isProcessing: activating
                })
            ]
        })
    });
};
var $655c3c44bf834291$export$2e2bcd8739ae039 = $655c3c44bf834291$var$GatewayConfigModal;

});
parcelRegister("02HYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00824d397ec63c04$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $00824d397ec63c04$export$2e2bcd8739ae039 = (0, $b4WUK.default)("TriangleAlert", [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
]);

});

parcelRegister("gN9hF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3986c8917bbd6fd$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $c3986c8917bbd6fd$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Server", [
    [
        "rect",
        {
            width: "20",
            height: "8",
            x: "2",
            y: "2",
            rx: "2",
            ry: "2",
            key: "ngkwjq"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "8",
            x: "2",
            y: "14",
            rx: "2",
            ry: "2",
            key: "iecqi9"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6.01",
            y1: "6",
            y2: "6",
            key: "16zg32"
        }
    ],
    [
        "line",
        {
            x1: "6",
            x2: "6.01",
            y1: "18",
            y2: "18",
            key: "nzw8ys"
        }
    ]
]);

});

parcelRegister("2w97G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d55a58c47e43a5b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Trash2", [
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
            key: "4alrt4"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
            key: "v07s0e"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17",
            key: "1uufr5"
        }
    ],
    [
        "line",
        {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17",
            key: "xtxkd"
        }
    ]
]);

});

parcelRegister("lO99W", function(module, exports) {

$parcel$export(module.exports, "default", () => $67de266df9d1d0f1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $02HYJ = parcelRequire("02HYJ");
var $hPAJY = parcelRequire("hPAJY");

var $7eyud = parcelRequire("7eyud");
const $67de266df9d1d0f1$var$GatewaySwitchWarningModal = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm, targetGatewayName: targetGatewayName, isProcessing: isProcessing })=>{
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7eyud.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "fixed inset-0 z-[1100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in duration-200",
            onClick: (e)=>{
                if (e.target === e.currentTarget && !isProcessing) onClose();
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-[#0e0e10] border border-red-500/30 rounded-2xl w-full max-w-md shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-6 border-b border-white/10 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "p-2 rounded-lg bg-red-500/10 text-red-500",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02HYJ.default), {
                                            className: "w-6 h-6"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "text-lg font-bold text-white",
                                        children: "Switch Account?"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: onClose,
                                disabled: isProcessing,
                                className: "text-muted hover:text-white transition disabled:opacity-50",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-6 space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "text-gray-300",
                                children: [
                                    "You are about to switch the active gateway to ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "font-bold text-white",
                                        children: targetGatewayName
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "bg-red-500/10 border border-red-500/20 rounded-xl p-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-sm text-red-200 font-medium",
                                    children: "\u26A0\uFE0F Warning: This will deactivate and stop your current account's gateway. Any active trading sessions will be disconnected."
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-sm text-muted",
                                children: "Are you sure you want to proceed?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-6 pt-2 flex gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: onClose,
                                disabled: isProcessing,
                                className: "flex-1 px-4 py-3 rounded-xl border border-white/10 text-white hover:bg-white/5 transition font-medium disabled:opacity-50",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: onConfirm,
                                disabled: isProcessing,
                                className: "flex-1 px-4 py-3 rounded-xl bg-red-500 hover:bg-red-600 text-white font-bold transition shadow-lg shadow-red-500/20 disabled:opacity-50 flex items-center justify-center gap-2",
                                children: isProcessing ? 'Switching...' : 'Yes, Switch Account'
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $67de266df9d1d0f1$export$2e2bcd8739ae039 = $67de266df9d1d0f1$var$GatewaySwitchWarningModal;

});
parcelRegister("7eyud", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b4dce13293be63$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
const $70b4dce13293be63$export$abd440bc95a4ebb0 = 'modal-root';
/** Mount every application overlay outside local panel stacking/overflow contexts. */ const $70b4dce13293be63$var$ModalPortal = ({ children: children })=>{
    if (typeof document === 'undefined') return null;
    const target = document.getElementById($70b4dce13293be63$export$abd440bc95a4ebb0) || document.body;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, target);
};
var $70b4dce13293be63$export$2e2bcd8739ae039 = $70b4dce13293be63$var$ModalPortal;

});



parcelRegister("9qjJe", function(module, exports) {

$parcel$export(module.exports, "default", () => $90331d9be87f723f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $hPAJY = parcelRequire("hPAJY");

var $7eyud = parcelRequire("7eyud");
const $90331d9be87f723f$var$Modal = ({ isOpen: isOpen, onClose: onClose, title: title, children: children, width: width = 'max-w-2xl', flush: flush = false })=>{
    const modalRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const handleEscape = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            const previousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            return ()=>{
                document.removeEventListener('keydown', handleEscape);
                document.body.style.overflow = previousOverflow;
            };
        }
        return ()=>{
            document.removeEventListener('keydown', handleEscape);
        };
    }, [
        isOpen,
        onClose
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7eyud.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "fixed inset-0 z-[1000] flex items-center justify-center p-0 bg-black/60 backdrop-blur-sm sm:p-4",
            onClick: (event)=>{
                if (event.target === event.currentTarget) onClose();
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: modalRef,
                className: `max-h-[100dvh] w-full ${width} bg-surface border-0 rounded-none shadow-2xl flex flex-col sm:h-auto sm:max-h-[90vh] sm:rounded-2xl sm:border sm:border-white/10`,
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between border-b border-white/5 p-3 sm:p-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-lg font-bold text-white",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: onClose,
                                className: "p-1 text-muted hover:text-white hover:bg-white/10 rounded-lg transition-colors",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `flex-1 overflow-y-auto scrollbar-thin ${flush ? 'p-0' : 'p-2 sm:p-4'}`,
                        children: children
                    })
                ]
            })
        })
    });
};
var $90331d9be87f723f$export$2e2bcd8739ae039 = $90331d9be87f723f$var$Modal;

});

parcelRegister("cYtEX", function(module, exports) {

$parcel$export(module.exports, "useGlobalError", () => $55918b14addba795$export$a2920187e96944a8);
$parcel$export(module.exports, "GlobalErrorProvider", () => $55918b14addba795$export$42c73b50392fca82);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $02HYJ = parcelRequire("02HYJ");
var $hPAJY = parcelRequire("hPAJY");
const $55918b14addba795$var$GlobalErrorContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $55918b14addba795$export$a2920187e96944a8 = ()=>(0, $acw62.useContext)($55918b14addba795$var$GlobalErrorContext);
const $55918b14addba795$var$GlobalErrorToast = ({ notice: notice, onDismiss: onDismiss })=>{
    if (!notice) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "pointer-events-none fixed inset-x-3 top-20 z-[1200] flex justify-center lg:inset-x-6 lg:top-24",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pointer-events-auto flex w-full max-w-2xl items-start gap-3 border border-rose-400/35 bg-surface px-4 py-3 text-foreground shadow-2xl",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-rose-500/15 text-rose-300",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02HYJ.default), {
                        className: "h-4 w-4"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "min-w-0 flex-1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-xs font-bold uppercase tracking-[0.14em] text-rose-200",
                            children: notice.title
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mt-1 break-words text-xs text-rose-100/80",
                            children: notice.error
                        }),
                        notice.onRetry && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: notice.onRetry,
                            className: "mt-2 inline-flex items-center rounded-lg border border-rose-300/40 bg-rose-500/10 px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider text-rose-100 transition-colors hover:bg-rose-500/20",
                            children: "Try again"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    type: "button",
                    onClick: onDismiss,
                    className: "shrink-0 rounded-lg p-1 text-rose-200/60 transition-colors hover:bg-rose-500/10 hover:text-rose-100",
                    "aria-label": "Dismiss error",
                    title: "Dismiss error",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                        className: "h-4 w-4"
                    })
                })
            ]
        })
    });
};
const $55918b14addba795$export$42c73b50392fca82 = ({ children: children })=>{
    const [notice, setNotice] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!notice) return;
        const timer = window.setTimeout(()=>{
            setNotice(null);
        }, 8000);
        return ()=>window.clearTimeout(timer);
    }, [
        notice
    ]);
    const publishError = (0, $acw62.useCallback)((nextNotice)=>{
        setNotice((current)=>{
            if (current && current.id === nextNotice.id && current.title === nextNotice.title && current.error === nextNotice.error) return current;
            return nextNotice;
        });
    }, []);
    const clearError = (0, $acw62.useCallback)((id)=>{
        setNotice((current)=>current?.id === id ? null : current);
    }, []);
    const value = (0, $acw62.useMemo)(()=>({
            publishError: publishError,
            clearError: clearError
        }), [
        clearError,
        publishError
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($55918b14addba795$var$GlobalErrorContext.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)($55918b14addba795$var$GlobalErrorToast, {
                notice: notice,
                onDismiss: ()=>setNotice(null)
            })
        ]
    });
};

});

parcelRegister("75jMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $52885985d1db6c06$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $52885985d1db6c06$export$2e2bcd8739ae039 = (0, $b4WUK.default)("DollarSign", [
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "2",
            y2: "22",
            key: "7eqyqh"
        }
    ],
    [
        "path",
        {
            d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
            key: "1b0p4s"
        }
    ]
]);

});

parcelRegister("fkh1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $b285ef0f6f9bf8bf$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $b285ef0f6f9bf8bf$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Eye", [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
]);

});

parcelRegister("sUw6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $056e74b7b26d3329$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $056e74b7b26d3329$export$2e2bcd8739ae039 = (0, $b4WUK.default)("EyeOff", [
    [
        "path",
        {
            d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
            key: "ct8e1f"
        }
    ],
    [
        "path",
        {
            d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
            key: "151rxh"
        }
    ],
    [
        "path",
        {
            d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
            key: "13bj9a"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
]);

});

parcelRegister("5ArKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4115d69e99c9f858$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $4115d69e99c9f858$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Gauge", [
    [
        "path",
        {
            d: "m12 14 4-4",
            key: "9kzdfg"
        }
    ],
    [
        "path",
        {
            d: "M3.34 19a10 10 0 1 1 17.32 0",
            key: "19p75a"
        }
    ]
]);

});

parcelRegister("id7Ro", function(module, exports) {

$parcel$export(module.exports, "default", () => $d41f89c0dd165c13$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $d41f89c0dd165c13$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CircleHelp", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
            key: "1u773s"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
]);

});

parcelRegister("jQdKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e71d8988c230db1b$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $e71d8988c230db1b$export$2e2bcd8739ae039 = (0, $b4WUK.default)("TrendingDown", [
    [
        "polyline",
        {
            points: "22 17 13.5 8.5 8.5 13.5 2 7",
            key: "1r2t7k"
        }
    ],
    [
        "polyline",
        {
            points: "16 17 22 17 22 11",
            key: "11uiuu"
        }
    ]
]);

});

parcelRegister("4reVr", function(module, exports) {

$parcel$export(module.exports, "default", () => $33b542e8915cec79$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $33b542e8915cec79$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Wallet", [
    [
        "path",
        {
            d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
            key: "18etb6"
        }
    ],
    [
        "path",
        {
            d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4",
            key: "xoc0q4"
        }
    ]
]);

});

parcelRegister("iqWry", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c002c1942271330$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $cYtEX = parcelRequire("cYtEX");
const $7c002c1942271330$var$ErrorDisplay = ({ error: error, onRetry: onRetry, message: message = 'Failed to load data' })=>{
    const globalError = (0, $cYtEX.useGlobalError)();
    const noticeId = (0, $acw62.useId)();
    const retryRef = (0, $acw62.useRef)(onRetry);
    retryRef.current = onRetry;
    (0, $acw62.useEffect)(()=>{
        if (!globalError) return;
        if (!error) {
            globalError.clearError(noticeId);
            return ()=>globalError.clearError(noticeId);
        }
        // Suppress publishing error toast while document is hidden (user switched away on mobile)
        if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
        // Delay publishing error toast by 1500ms to allow foreground refetches to settle silently
        const publishTimer = window.setTimeout(()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            globalError.publishError({
                id: noticeId,
                title: message,
                error: error,
                onRetry: onRetry ? ()=>retryRef.current?.() : undefined
            });
        }, 1500);
        return ()=>{
            window.clearTimeout(publishTimer);
            globalError.clearError(noticeId);
        };
    }, [
        error,
        globalError,
        message,
        noticeId,
        onRetry
    ]);
    (0, $acw62.useEffect)(()=>{
        // When returning to foreground with an active error, trigger retry automatically
        const handleVisible = ()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'visible' && error) retryRef.current?.();
        };
        document.addEventListener('visibilitychange', handleVisible);
        window.addEventListener('focus', handleVisible);
        return ()=>{
            document.removeEventListener('visibilitychange', handleVisible);
            window.removeEventListener('focus', handleVisible);
        };
    }, [
        error
    ]);
    if (!error) return null;
    if (globalError) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "rounded-xl border border-rose-500/40 bg-rose-500/10 text-foreground px-3 py-2 sm:px-4 sm:py-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex items-start gap-3",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-center justify-center h-7 w-7 rounded-full bg-rose-500/40 text-xs font-bold text-rose-50",
                    children: "!"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex-1 space-y-1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-xs sm:text-sm font-semibold text-rose-100 uppercase tracking-[0.14em]",
                            children: message
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "text-[11px] sm:text-xs text-rose-100/80 break-words",
                            children: error
                        }),
                        onRetry && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: onRetry,
                            className: "mt-2 inline-flex items-center px-3 py-1.5 rounded-lg border border-rose-300/60 bg-rose-500/20 text-[11px] font-semibold uppercase tracking-[0.12em] text-rose-50 hover:bg-rose-500/30 disabled:opacity-50",
                            children: "Try Again"
                        })
                    ]
                })
            ]
        })
    });
};
var $7c002c1942271330$export$2e2bcd8739ae039 = $7c002c1942271330$var$ErrorDisplay;

});

parcelRegister("7s03j", function(module, exports) {

$parcel$export(module.exports, "DataTable", () => $67963b09fdec1ded$export$df30df7ec97b32b5);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $02X9j = parcelRequire("02X9j");
var $6MDCS = parcelRequire("6MDCS");
var $cYPGs = parcelRequire("cYPGs");
var $id7Ro = parcelRequire("id7Ro");
parcelRequire("kvv04");
var $alUHf = parcelRequire("alUHf");
function $67963b09fdec1ded$export$df30df7ec97b32b5({ data: data, columns: columns, className: className = '', loading: loading = false, emptyMessage: emptyMessage = 'No data available', onRowClick: onRowClick, rowClassName: rowClassName, initialSort: initialSort, compact: compact = false, getRowKey: getRowKey, expandedRowKey: expandedRowKey = null, renderExpandedRow: renderExpandedRow }) {
    const [sortConfig, setSortConfig] = (0, $acw62.useState)(initialSort || null);
    const handleSort = (columnId)=>{
        setSortConfig((prev)=>{
            if (prev?.id === columnId) {
                if (prev.direction === 'asc') return {
                    id: columnId,
                    direction: 'desc'
                };
                return null; // Reset sort
            }
            return {
                id: columnId,
                direction: 'asc'
            };
        });
    };
    const sortedData = (0, $acw62.useMemo)(()=>{
        const safeData = data || [];
        if (!sortConfig) return safeData;
        const column = columns.find((c)=>c.id === sortConfig.id);
        if (!column) return safeData;
        return [
            ...safeData
        ].sort((a, b)=>{
            const aValue = typeof column.accessor === 'function' ? column.accessor(a) : a[column.accessor];
            const bValue = typeof column.accessor === 'function' ? column.accessor(b) : b[column.accessor];
            if (aValue === bValue) return 0;
            if (aValue === null || aValue === undefined) return 1;
            if (bValue === null || bValue === undefined) return -1;
            const order = sortConfig.direction === 'asc' ? 1 : -1;
            if (typeof aValue === 'string' && typeof bValue === 'string') return aValue.localeCompare(bValue) * order;
            return (aValue < bValue ? -1 : 1) * order;
        });
    }, [
        data,
        sortConfig,
        columns
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `overflow-x-auto scrollbar-thin rounded-xl border border-white/10 bg-white/5 backdrop-blur-xl ${className}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            className: `${(0, $alUHf.themeTableClasses).table} divide-y divide-white/10 ${compact ? 'text-[11px]' : (0, $alUHf.themeTableClasses).bodyText}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    className: (0, $alUHf.themeTableClasses).head,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                        children: columns.map((column)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                scope: "col",
                                className: `${(0, $alUHf.themeTableClasses).headerCell} ${compact ? 'px-2.5 py-2 text-[10px]' : ''} ${column.align === 'right' ? 'text-right' : column.align === 'center' ? 'text-center' : 'text-left'} ${column.headerClassName || ''} ${column.sortable ? 'cursor-pointer select-none hover:text-white hover:bg-white/5 transition-colors' : ''}`,
                                onClick: ()=>column.sortable && handleSort(column.id),
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `flex items-center gap-1.5 ${column.align === 'right' ? 'justify-end' : column.align === 'center' ? 'justify-center' : 'justify-start'}`,
                                    children: [
                                        column.header,
                                        column.headerInfo && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "inline-flex shrink-0 text-white/35",
                                            title: column.headerInfo,
                                            "aria-label": `${column.header}: ${column.headerInfo}`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $id7Ro.default), {
                                                className: "h-3.5 w-3.5"
                                            })
                                        }),
                                        column.sortable && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-white/40 group-hover:text-white transition-colors",
                                            children: sortConfig?.id === column.id ? sortConfig.direction === 'asc' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6MDCS.default), {
                                                className: "w-3.5 h-3.5 text-neon"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02X9j.default), {
                                                className: "w-3.5 h-3.5 text-neon"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cYPGs.default), {
                                                className: "w-3.5 h-3.5 opacity-30"
                                            })
                                        })
                                    ]
                                })
                            }, column.id))
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    className: `${(0, $alUHf.themeTableClasses).body} bg-transparent`,
                    children: sortedData.length === 0 && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            colSpan: columns.length,
                            className: `${(0, $alUHf.themeTableClasses).cell} py-8 text-center text-muted`,
                            children: emptyMessage
                        })
                    }) : sortedData.length === 0 && loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            colSpan: columns.length,
                            className: `${(0, $alUHf.themeTableClasses).cell} py-12 text-center text-muted`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-col items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w-6 h-6 border-2 border-neon/30 border-t-neon rounded-full animate-spin"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "Loading data..."
                                    })
                                ]
                            })
                        })
                    }) : sortedData.map((item, index)=>{
                        const customClassName = typeof rowClassName === 'function' ? rowClassName(item) : rowClassName;
                        const rowKey = getRowKey ? getRowKey(item, index) : index;
                        const isExpanded = expandedRowKey !== null && expandedRowKey !== undefined && getRowKey && rowKey === expandedRowKey;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                    onClick: ()=>onRowClick?.(item),
                                    className: `${(0, $alUHf.themeTableClasses).row} ${onRowClick ? 'cursor-pointer' : ''} ${customClassName || ''}`,
                                    children: columns.map((column)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: `${(0, $alUHf.themeTableClasses).cell} ${compact ? 'px-2.5 py-2' : ''} whitespace-nowrap ${column.align === 'right' ? 'text-right' : column.align === 'center' ? 'text-center' : 'text-left'} ${column.className || ''}`,
                                            children: column.render ? column.render(item) : typeof column.accessor === 'function' ? column.accessor(item) : item[column.accessor]
                                        }, column.id))
                                }),
                                isExpanded && renderExpandedRow && /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                    className: "bg-black/20",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        colSpan: columns.length,
                                        className: "p-0",
                                        children: renderExpandedRow(item)
                                    })
                                })
                            ]
                        }, rowKey);
                    })
                })
            ]
        })
    });
}

});
parcelRegister("02X9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $008e11cf932a0927$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $008e11cf932a0927$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ArrowDown", [
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ],
    [
        "path",
        {
            d: "m19 12-7 7-7-7",
            key: "1idqje"
        }
    ]
]);

});

parcelRegister("6MDCS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f05f6a77fc593bc$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $4f05f6a77fc593bc$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ArrowUp", [
    [
        "path",
        {
            d: "m5 12 7-7 7 7",
            key: "hav0vg"
        }
    ],
    [
        "path",
        {
            d: "M12 19V5",
            key: "x0mq9r"
        }
    ]
]);

});

parcelRegister("cYPGs", function(module, exports) {

$parcel$export(module.exports, "default", () => $97332defb5de8faa$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $97332defb5de8faa$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ArrowUpDown", [
    [
        "path",
        {
            d: "m21 16-4 4-4-4",
            key: "f6ql7i"
        }
    ],
    [
        "path",
        {
            d: "M17 20V4",
            key: "1ejh1v"
        }
    ],
    [
        "path",
        {
            d: "m3 8 4-4 4 4",
            key: "11wl7u"
        }
    ],
    [
        "path",
        {
            d: "M7 4v16",
            key: "1glfcx"
        }
    ]
]);

});


parcelRegister("2RwSR", function(module, exports) {

$parcel$export(module.exports, "isValidHistoricalBar", () => $b38fc1b8ce711012$export$81b35256266466bf);
const $b38fc1b8ce711012$export$81b35256266466bf = (bar)=>Number.isFinite(bar.time) && [
        bar.open,
        bar.high,
        bar.low,
        bar.close
    ].every((value)=>typeof value === 'number' && Number.isFinite(value));

});

parcelRegister("ip1r2", function(module, exports) {

$parcel$export(module.exports, "default", () => $808174bed2a3cce1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kvv04 = parcelRequire("kvv04");
const $808174bed2a3cce1$var$ChartToolbarButton = ({ label: label, icon: icon, children: children, onClick: onClick, selected: selected, disabled: disabled = false, size: size = 'default', segment: segment, iconOnly: iconOnly = false, title: title })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeToggleButton), {
        label: label,
        icon: icon,
        iconOnly: iconOnly,
        selected: selected,
        size: size === 'compact' ? 'xs' : 'sm',
        segment: segment,
        onClick: onClick,
        disabled: disabled,
        title: title ?? label,
        children: children
    });
var $808174bed2a3cce1$export$2e2bcd8739ae039 = $808174bed2a3cce1$var$ChartToolbarButton;

});

parcelRegister("dghaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6bc2d400276b7d8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5yfjI = parcelRequire("5yfjI");
const $f6bc2d400276b7d8$var$ChartFrame = ({ toolbar: toolbar, children: children, className: className = '' })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `${(0, $5yfjI.chartFrameClassName)} ${className}`,
        children: [
            toolbar,
            children
        ]
    });
var $f6bc2d400276b7d8$export$2e2bcd8739ae039 = $f6bc2d400276b7d8$var$ChartFrame;

});
parcelRegister("5yfjI", function(module, exports) {

$parcel$export(module.exports, "chartToolbarClasses", () => $48d6ae7fe3565378$export$aa13135b8a287cbc);
$parcel$export(module.exports, "chartFrameClassName", () => $48d6ae7fe3565378$export$670e23bc85f9492b);
$parcel$export(module.exports, "chartToolbarSelectClasses", () => $48d6ae7fe3565378$export$c52a412185d085a1);
$parcel$export(module.exports, "getChartStyleToggleSegments", () => $48d6ae7fe3565378$export$10db452810616201);
$parcel$export(module.exports, "getChartToolbarSelectRootClassName", () => $48d6ae7fe3565378$export$b597d26eaa9b671c);
const $48d6ae7fe3565378$export$aa13135b8a287cbc = {
    viewport: 'max-w-full overflow-x-auto border-b border-white/10 bg-black/10',
    row: 'flex w-full min-w-max items-center gap-2 px-3 py-1.5',
    leading: 'flex shrink-0 items-center gap-2 border-r border-white/10 pr-2',
    legend: 'flex shrink-0 items-center gap-2',
    controls: 'flex shrink-0 items-center gap-1',
    actions: 'ml-auto flex shrink-0 items-center gap-1',
    settings: 'ml-0.5 flex shrink-0 items-center gap-1.5 border-l border-white/10 pl-1.5',
    trailing: 'ml-0.5 flex shrink-0 items-center gap-1 border-l border-white/10 pl-1.5'
};
const $48d6ae7fe3565378$export$670e23bc85f9492b = 'flex min-h-0 min-w-0 flex-col overflow-hidden bg-[#0e0e12]';
const $48d6ae7fe3565378$export$c52a412185d085a1 = {
    button: 'w-full rounded-md text-[9px]',
    menu: 'rounded-xl border-t border-white/10'
};
function $48d6ae7fe3565378$export$10db452810616201(showLine) {
    return {
        candles: showLine ? 'first' : undefined,
        line: showLine ? 'last' : undefined
    };
}
function $48d6ae7fe3565378$export$b597d26eaa9b671c(widthClassName) {
    return `shrink-0 ${widthClassName}`;
}

});


parcelRegister("iiQft", function(module, exports) {

$parcel$export(module.exports, "ChartToolbar", () => $81a4cdc24f0b7f56$export$fab13f9ae35bb0e2);
$parcel$export(module.exports, "ChartStyleToggle", () => $81a4cdc24f0b7f56$export$35d7261eace0eb60);
$parcel$export(module.exports, "ChartToolbarSelect", () => $81a4cdc24f0b7f56$export$6fc3c4894fe9e43f);
$parcel$export(module.exports, "ChartToolbarValue", () => $81a4cdc24f0b7f56$export$2446f6397594252e);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $Pru0l = parcelRequire("Pru0l");
var $lqAED = parcelRequire("lqAED");
parcelRequire("jl3Sp");
var $2zES5 = parcelRequire("2zES5");

var $kvv04 = parcelRequire("kvv04");

var $ip1r2 = parcelRequire("ip1r2");

var $5yfjI = parcelRequire("5yfjI");
const $81a4cdc24f0b7f56$export$fab13f9ae35bb0e2 = ({ leading: leading, legend: legend, chartStyle: chartStyle, actions: actions, settings: settings, trailing: trailing, className: className = '' })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `${(0, $5yfjI.chartToolbarClasses).viewport} ${className}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: (0, $5yfjI.chartToolbarClasses).row,
            children: [
                leading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: (0, $5yfjI.chartToolbarClasses).leading,
                    children: leading
                }),
                legend && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-label": "Chart legend",
                    role: "group",
                    className: (0, $5yfjI.chartToolbarClasses).legend,
                    children: legend
                }),
                (chartStyle || settings || trailing) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    role: "group",
                    "aria-label": "Chart selectors",
                    className: (0, $5yfjI.chartToolbarClasses).controls,
                    children: [
                        chartStyle,
                        settings && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: (0, $5yfjI.chartToolbarClasses).settings,
                            children: settings
                        }),
                        trailing && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: (0, $5yfjI.chartToolbarClasses).trailing,
                            children: trailing
                        })
                    ]
                }),
                actions && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    role: "group",
                    "aria-label": "Chart actions",
                    className: (0, $5yfjI.chartToolbarClasses).actions,
                    children: actions
                })
            ]
        })
    });
const $81a4cdc24f0b7f56$export$35d7261eace0eb60 = ({ value: value, onChange: onChange, showLine: showLine = true })=>{
    const segments = (0, $5yfjI.getChartStyleToggleSegments)(showLine);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kvv04.ThemeToggleGroup), {
        "aria-label": "Chart style",
        className: "shrink-0 gap-px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                size: "compact",
                iconOnly: true,
                segment: segments.candles,
                label: "Candlestick chart",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Pru0l.default), {
                    className: "h-3.5 w-3.5"
                }),
                selected: value === 'candles',
                onClick: ()=>onChange('candles')
            }),
            showLine && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                size: "compact",
                iconOnly: true,
                segment: segments.line,
                label: "Line chart",
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lqAED.default), {
                    className: "h-3.5 w-3.5"
                }),
                selected: value === 'line',
                onClick: ()=>onChange('line')
            })
        ]
    });
};
const $81a4cdc24f0b7f56$export$6fc3c4894fe9e43f = ({ value: value, options: options, onChange: onChange, ariaLabel: ariaLabel, title: title, widthClassName: widthClassName })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2zES5.CustomSelect), {
        value: value,
        options: options,
        onChange: onChange,
        ariaLabel: ariaLabel,
        triggerTitle: title,
        controlSize: "xs",
        className: (0, $5yfjI.getChartToolbarSelectRootClassName)(widthClassName),
        buttonClassName: (0, $5yfjI.chartToolbarSelectClasses).button,
        menuClassName: (0, $5yfjI.chartToolbarSelectClasses).menu
    });
const $81a4cdc24f0b7f56$export$2446f6397594252e = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "shrink-0 rounded-md border border-white/10 bg-white/5 px-1.5 py-1 text-[9px] font-black uppercase tracking-wider text-neon",
        children: children
    });

});
parcelRegister("Pru0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $09aa15135abca9a9$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $09aa15135abca9a9$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ChartCandlestick", [
    [
        "path",
        {
            d: "M9 5v4",
            key: "14uxtq"
        }
    ],
    [
        "rect",
        {
            width: "4",
            height: "6",
            x: "7",
            y: "9",
            rx: "1",
            key: "f4fvz0"
        }
    ],
    [
        "path",
        {
            d: "M9 15v2",
            key: "r5rk32"
        }
    ],
    [
        "path",
        {
            d: "M17 3v2",
            key: "1l2re6"
        }
    ],
    [
        "rect",
        {
            width: "4",
            height: "8",
            x: "15",
            y: "5",
            rx: "1",
            key: "z38je5"
        }
    ],
    [
        "path",
        {
            d: "M17 13v3",
            key: "5l0wba"
        }
    ],
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ]
]);

});

parcelRegister("lqAED", function(module, exports) {

$parcel$export(module.exports, "default", () => $f998757746cce0d6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $f998757746cce0d6$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ChartLine", [
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "m19 9-5 5-4-4-3 3",
            key: "2osh9i"
        }
    ]
]);

});


parcelRegister("92f5k", function(module, exports) {

$parcel$export(module.exports, "LightweightChart", () => $c93de58925e93ca3$export$58bd66238470b3e9);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2bl5m = parcelRequire("2bl5m");

var $Pru0l = parcelRequire("Pru0l");
var $kEKEC = parcelRequire("kEKEC");

var $ip1r2 = parcelRequire("ip1r2");

var $a6l6I = parcelRequire("a6l6I");

var $q2qYo = parcelRequire("q2qYo");

var $1MJQA = parcelRequire("1MJQA");
const $c93de58925e93ca3$var$chartRightGutterPx = 56;
const $c93de58925e93ca3$var$EMPTY_CHART_ARRAY = [];
const $c93de58925e93ca3$export$58bd66238470b3e9 = ({ data: data, trades: trades = $c93de58925e93ca3$var$EMPTY_CHART_ARRAY, volumeData: volumeData = $c93de58925e93ca3$var$EMPTY_CHART_ARRAY, lineOverlays: lineOverlays = $c93de58925e93ca3$var$EMPTY_CHART_ARRAY, customMarkers: customMarkers = $c93de58925e93ca3$var$EMPTY_CHART_ARRAY, lowerPaneData: lowerPaneData = $c93de58925e93ca3$var$EMPTY_CHART_ARRAY, type: type, symbolStyle: symbolStyle = 'candles', timeVisible: timeVisible, initialVisibleBars: initialVisibleBars, latestVisibleBars: latestVisibleBars, showMa30: showMa30 = false, showMa200: showMa200 = false, showBuyMarkers: showBuyMarkers = true, showCloseMarkers: showCloseMarkers = true, equityVariant: equityVariant = 'area', height: height = 400, range: range, resetViewToken: resetViewToken = 0, resolution: resolution = 'native', onRangeChange: onRangeChange, hideControls: hideControls = false, showLatestControl: showLatestControl = false, oosStartDate: oosStartDate, lineColor: lineColor = (0, $a6l6I.themeColors).neon, topColor: topColor = (0, $a6l6I.themeColors).neonArea, bottomColor: bottomColor = (0, $a6l6I.themeColors).neonTransparent, candleUpColor: candleUpColor = (0, $a6l6I.themeColors).success, candleDownColor: candleDownColor = (0, $a6l6I.themeColors).danger, lowerPaneLabel: lowerPaneLabel = 'Lower', lowerPaneColor: lowerPaneColor = (0, $a6l6I.themeColors).dangerLight, lowerPaneValueSuffix: lowerPaneValueSuffix = '', lowerPaneValuePrefix: lowerPaneValuePrefix = '', visibleSeriesKeys: visibleSeriesKeys, displayMode: displayMode = 'dollar', showMainSeries: showMainSeries = true, compareGross: compareGross = false, showGrossSeries: showGrossSeries = true, lowerPaneType: lowerPaneType = 'line', showEquityCandles: showEquityCandles = false })=>{
    const chartContainerRef = (0, $acw62.useRef)(null);
    const overlayRef = (0, $acw62.useRef)(null);
    const chartRef = (0, $acw62.useRef)(null);
    const seriesRef = (0, $acw62.useRef)(null);
    const overlaySeriesRef = (0, $acw62.useRef)([]);
    const processedDataRef = (0, $acw62.useRef)(data);
    const resizeObserver = (0, $acw62.useRef)(null);
    const visibleLogicalRangeRef = (0, $acw62.useRef)(null);
    const appliedRangeRef = (0, $acw62.useRef)(null);
    const appliedResetViewTokenRef = (0, $acw62.useRef)(resetViewToken);
    const [internalRange, setInternalRange] = (0, $acw62.useState)('ALL');
    const [hoverPoint, setHoverPoint] = (0, $acw62.useState)(null);
    const [lowerHoverPoint, setLowerHoverPoint] = (0, $acw62.useState)(null);
    const selectedRange = range || internalRange;
    // Stable strategy keys for consistent coloring
    const allStrategyKeys = (0, $acw62.useMemo)(()=>{
        if (!data || data.length === 0) return [];
        const keys = new Set();
        data.forEach((d)=>{
            Object.keys(d).forEach((k)=>{
                if (k.startsWith('equity_') && k !== 'equity_curve') keys.add(k);
            });
        });
        return Array.from(keys).sort(); // Sort to ensure stable order
    }, [
        data
    ]);
    const handleRangeChange = (r)=>{
        if (onRangeChange) onRangeChange(r);
        else setInternalRange(r);
    };
    const processTime = (0, $acw62.useCallback)((dateStr)=>{
        if (resolution === '1D') return (0, $q2qYo.toDayString)(dateStr);
        if (dateStr.includes(':')) {
            const match = dateStr.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
            if (match) {
                const [, year, month, day, hour, min, sec] = match;
                const fakeUtc = Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(min), parseInt(sec));
                return fakeUtc / 1000;
            }
            const safeStr = dateStr.replace(' ', 'T');
            return new Date(safeStr).getTime() / 1000;
        }
        return dateStr;
    }, [
        resolution
    ]);
    const updateOosOverlay = (0, $acw62.useCallback)(()=>{
        if (!overlayRef.current || !chartRef.current || !chartContainerRef.current || !oosStartDate) return;
        const overlay = overlayRef.current;
        const chart = chartRef.current;
        const timeScale = chart.timeScale();
        const width = chartContainerRef.current.clientWidth;
        const rightAxisInset = 64;
        const bottomAxisInset = 22;
        const minOverlayWidth = 36;
        const rangeData = processedDataRef.current || [];
        const toComparableMs = (dateStr)=>{
            if (resolution === '1D') return new Date(`${(0, $q2qYo.toDayString)(dateStr)}T12:00:00`).getTime();
            const safeStr = dateStr.includes('T') ? dateStr : dateStr.replace(' ', 'T');
            return new Date(safeStr).getTime();
        };
        const targetMs = toComparableMs(oosStartDate);
        const anchorPoint = rangeData.find((d)=>toComparableMs(String(d.date)) >= targetMs) || rangeData[rangeData.length - 1];
        const x = anchorPoint ? timeScale.timeToCoordinate(processTime(String(anchorPoint.date))) : null;
        if (x == null || Number.isNaN(x)) {
            overlay.style.display = 'none';
            return;
        }
        const left = Math.max(0, Math.min(width, x));
        const usableRightEdge = Math.max(0, width - rightAxisInset);
        const overlayLeft = Math.min(left, Math.max(0, usableRightEdge - minOverlayWidth));
        const overlayWidth = Math.max(minOverlayWidth, usableRightEdge - overlayLeft);
        overlay.style.display = 'block';
        overlay.style.left = `${overlayLeft}px`;
        overlay.style.width = `${Math.max(0, overlayWidth)}px`;
        overlay.style.bottom = `${bottomAxisInset}px`;
    }, [
        oosStartDate,
        processTime,
        resolution
    ]);
    // Helper to apply the visible range
    const applyRangeLogic = (0, $acw62.useCallback)((showLatest = false)=>{
        const rangeData = processedDataRef.current;
        if (!chartRef.current || !seriesRef.current || rangeData.length === 0) return;
        const chart = chartRef.current;
        const timeScale = chart.timeScale();
        if (selectedRange === 'ALL') {
            const visibleBars = showLatest ? latestVisibleBars : initialVisibleBars;
            if (visibleBars && visibleBars > 0) timeScale.setVisibleLogicalRange({
                from: Math.max(0, rangeData.length - visibleBars),
                to: rangeData.length
            });
            else timeScale.fitContent();
            return;
        }
        const daysMap = {
            '1D': 1,
            '3D': 3,
            '1W': 7,
            '1M': 30,
            '3M': 90,
            '6M': 180,
            '1Y': 365,
            'YTD': 0,
            'ALL': 0
        };
        const lastItem = rangeData[rangeData.length - 1];
        const lastDate = new Date(lastItem.date.includes('T') ? lastItem.date : lastItem.date + 'T12:00:00');
        let targetStartDate;
        if (selectedRange === 'YTD') targetStartDate = new Date(new Date().getFullYear(), 0, 1);
        else {
            targetStartDate = new Date(lastDate);
            targetStartDate.setDate(targetStartDate.getDate() - (daysMap[selectedRange] || 0));
        }
        const startIndex = rangeData.findIndex((d)=>{
            const itemDate = new Date(d.date.includes('T') ? d.date : d.date + 'T12:00:00');
            return itemDate >= targetStartDate;
        });
        timeScale.setVisibleLogicalRange({
            from: startIndex === -1 ? 0 : startIndex,
            to: rangeData.length
        });
        window.requestAnimationFrame(()=>{
            if (chartRef.current !== chart) return;
            const barSpacing = timeScale.options().barSpacing || 6;
            timeScale.scrollToPosition($c93de58925e93ca3$var$chartRightGutterPx / barSpacing, false);
        });
    }, [
        selectedRange,
        initialVisibleBars,
        latestVisibleBars
    ]);
    const formatHoverDate = (dateStr)=>{
        const safeStr = dateStr.includes('T') ? dateStr : dateStr.replace(' ', 'T');
        const dt = new Date(safeStr);
        if (Number.isNaN(dt.getTime())) return dateStr;
        if (resolution === '1D') return dt.toLocaleDateString();
        return dt.toLocaleString([], {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    // Main Chart Creation and Series Update Effect
    (0, $acw62.useEffect)(()=>{
        if (!chartContainerRef.current) return;
        const chart = (0, $2bl5m.createChart)(chartContainerRef.current, (0, $1MJQA.buildThemedChartOptions)({
            width: chartContainerRef.current.clientWidth,
            height: chartContainerRef.current.clientHeight || height,
            timeVisible: timeVisible ?? resolution === 'native',
            rightOffsetPixels: $c93de58925e93ca3$var$chartRightGutterPx,
            includePaneSeparators: true
        }));
        chartRef.current = chart;
        let series;
        const overlaySeries = [];
        const { data: processedData, lowerPaneData: processedLowerPaneData } = (0, $q2qYo.prepareChartData)({
            data: data,
            lowerPaneData: lowerPaneData,
            type: type,
            resolution: resolution,
            showEquityCandles: showEquityCandles,
            displayMode: displayMode
        });
        processedDataRef.current = processedData;
        if (type === 'equity') {
            if (equityVariant === 'line') series = chart.addSeries((0, $2bl5m.LineSeries), {
                color: lineColor,
                lineWidth: 2
            });
            else series = chart.addSeries((0, $2bl5m.AreaSeries), {
                lineColor: lineColor,
                topColor: topColor,
                bottomColor: bottomColor,
                lineWidth: 2
            });
            if (displayMode === 'percent') series.applyOptions({
                priceFormat: {
                    type: 'custom',
                    formatter: (price)=>`${price >= 0 ? '+' : ''}${price.toFixed(2)}%`
                }
            });
            if (showMainSeries) series.setData(processedData.map((d)=>{
                let val = d.equity;
                if (displayMode === 'gross') val = d.equity_gross ?? d.equity;
                return {
                    time: processTime(d.date),
                    value: Number(val || 0)
                };
            }));
            else series.setData([]);
            // Render individual strategy equity curves
            if (allStrategyKeys.length > 0) allStrategyKeys.forEach((key, idx)=>{
                if (visibleSeriesKeys && !visibleSeriesKeys.includes(key)) return;
                const stratSeries = chart.addSeries((0, $2bl5m.LineSeries), {
                    color: (0, $a6l6I.strategySeriesColors)[idx % (0, $a6l6I.strategySeriesColors).length],
                    lineWidth: 1,
                    priceLineVisible: false,
                    lastValueVisible: false
                });
                if (displayMode === 'percent') stratSeries.applyOptions({
                    priceFormat: {
                        type: 'custom',
                        formatter: (price)=>`${price >= 0 ? '+' : ''}${price.toFixed(2)}%`
                    }
                });
                stratSeries.setData(processedData.map((d)=>({
                        time: processTime(d.date),
                        value: d[key]
                    })));
                overlaySeries.push(stratSeries);
            });
            // Render Gross Comparison line if requested
            if (compareGross && showGrossSeries && processedData.some((d)=>d.equity_gross !== undefined)) {
                const grossSeries = chart.addSeries((0, $2bl5m.LineSeries), {
                    color: (0, $a6l6I.themeColors).warningBright,
                    lineWidth: 1,
                    lineStyle: 2,
                    priceLineVisible: false,
                    lastValueVisible: false
                });
                grossSeries.setData(processedData.map((d)=>{
                    const isGrossMode = displayMode === 'gross';
                    const targetVal = isGrossMode ? d.equity : d.equity_gross;
                    return {
                        time: processTime(d.date),
                        value: targetVal
                    };
                }));
                overlaySeries.push(grossSeries);
            }
        } else if (processedData.length > 0 && 'open' in processedData[0]) {
            if (symbolStyle === 'line') {
                series = chart.addSeries((0, $2bl5m.LineSeries), {
                    color: lineColor,
                    lineWidth: 2,
                    crosshairMarkerVisible: true,
                    priceLineVisible: true,
                    lastValueVisible: true
                });
                series.setData(processedData.map((d)=>({
                        time: processTime(d.date),
                        value: d.close
                    })));
            } else {
                series = chart.addSeries((0, $2bl5m.CandlestickSeries), {
                    upColor: candleUpColor,
                    downColor: candleDownColor,
                    borderVisible: false,
                    wickUpColor: candleUpColor,
                    wickDownColor: candleDownColor,
                    priceLineVisible: true,
                    lastValueVisible: true
                });
                series.setData(processedData.map((d)=>({
                        time: processTime(d.date),
                        open: d.open,
                        high: d.high,
                        low: d.low,
                        close: d.close
                    })));
            }
        } else {
            series = chart.addSeries((0, $2bl5m.LineSeries), {
                color: (0, $a6l6I.themeColors).infoDark,
                lineWidth: 2
            });
            series.setData(processedData.map((d)=>({
                    time: processTime(d.date),
                    value: d.price || d.equity
                })));
        }
        seriesRef.current = series;
        if (type === 'symbol') {
            if (showMa30 && processedData.some((d)=>d.ma30 != null)) {
                const ma30Series = chart.addSeries((0, $2bl5m.LineSeries), {
                    color: (0, $a6l6I.themeColors).info,
                    lineWidth: 1,
                    priceLineVisible: false,
                    lastValueVisible: false
                });
                ma30Series.setData(processedData.filter((d)=>d.ma30 != null).map((d)=>({
                        time: processTime(d.date),
                        value: d.ma30
                    })));
                overlaySeries.push(ma30Series);
            }
            if (showMa200 && processedData.some((d)=>d.ma200 != null)) {
                const ma200Series = chart.addSeries((0, $2bl5m.LineSeries), {
                    color: (0, $a6l6I.themeColors).warning,
                    lineWidth: 1,
                    priceLineVisible: false,
                    lastValueVisible: false
                });
                ma200Series.setData(processedData.filter((d)=>d.ma200 != null).map((d)=>({
                        time: processTime(d.date),
                        value: d.ma200
                    })));
                overlaySeries.push(ma200Series);
            }
        }
        lineOverlays.forEach((overlay)=>{
            if (overlay.data.length === 0) return;
            const overlaySeriesItem = chart.addSeries((0, $2bl5m.LineSeries), {
                color: overlay.color,
                lineWidth: overlay.lineWidth ?? 2,
                priceLineVisible: false,
                lastValueVisible: false,
                crosshairMarkerVisible: false,
                title: overlay.title ?? ''
            });
            overlaySeriesItem.setData(overlay.data.map((point)=>({
                    time: processTime(point.date),
                    value: point.value
                })));
            overlaySeries.push(overlaySeriesItem);
        });
        if (volumeData.length > 0) {
            const volumeSeries = chart.addSeries((0, $2bl5m.HistogramSeries), {
                priceFormat: {
                    type: 'volume'
                },
                priceScaleId: '',
                lastValueVisible: false,
                priceLineVisible: false
            });
            volumeSeries.priceScale().applyOptions({
                scaleMargins: {
                    top: 0.82,
                    bottom: 0
                }
            });
            volumeSeries.setData(volumeData.map((point)=>({
                    time: processTime(point.date),
                    value: point.value,
                    ...point.color ? {
                        color: point.color
                    } : {}
                })));
            overlaySeries.push(volumeSeries);
        }
        if (processedLowerPaneData.length > 0) {
            let lowerSeries;
            const lowerPanePriceFormat = lowerPaneValuePrefix || lowerPaneValueSuffix ? {
                type: 'custom',
                formatter: (price)=>`${lowerPaneValuePrefix}${lowerPaneValueSuffix === '%' && price > 0 ? '+' : ''}${price.toFixed(2)}${lowerPaneValueSuffix}`
            } : undefined;
            if (lowerPaneType === 'histogram') {
                lowerSeries = chart.addSeries((0, $2bl5m.HistogramSeries), {
                    color: lowerPaneColor,
                    priceLineVisible: false,
                    priceFormat: lowerPanePriceFormat
                }, 1);
                lowerSeries.setData(processedLowerPaneData.map((point)=>{
                    const val = point.equity;
                    return {
                        time: processTime(point.date),
                        value: val,
                        color: val >= 0 ? (0, $a6l6I.themeColors).success : (0, $a6l6I.themeColors).danger
                    };
                }));
            } else {
                lowerSeries = chart.addSeries((0, $2bl5m.LineSeries), {
                    color: lowerPaneColor,
                    lineWidth: 2,
                    priceLineVisible: false,
                    priceFormat: lowerPanePriceFormat
                }, 1);
                lowerSeries.setData(processedLowerPaneData.map((point)=>({
                        time: processTime(point.date),
                        value: point.equity
                    })));
            }
            overlaySeries.push(lowerSeries);
            const panes = chart.panes();
            if (panes[0]) panes[0].setStretchFactor(3);
            if (panes[1]) panes[1].setStretchFactor(1);
        }
        overlaySeriesRef.current = overlaySeries;
        // Add Markers
        const markers = [];
        if ((type === 'symbol' || type === 'equity') && Array.isArray(trades)) {
            const chartDataTimes = processedData.map((d)=>processTime(d.date));
            const snapToClosest = (targetTime)=>{
                if (chartDataTimes.length === 0) return null;
                if (resolution === '1D') {
                    const tStr = typeof targetTime === 'number' ? new Date(targetTime * 1000).toISOString().split('T')[0] : (0, $q2qYo.toDayString)(String(targetTime));
                    const exact = chartDataTimes.find((time)=>String(time) === tStr);
                    if (exact !== undefined) return exact;
                    return chartDataTimes.find((time)=>String(time) >= tStr) || chartDataTimes[chartDataTimes.length - 1];
                }
                const numericTarget = typeof targetTime === 'number' ? targetTime : Number(processTime(String(targetTime)));
                if (!Number.isFinite(numericTarget)) {
                    const exact = chartDataTimes.find((time)=>String(time) === String(targetTime));
                    return exact ?? null;
                }
                let closest = chartDataTimes[0];
                let minDiff = Math.abs(numericTarget - closest);
                for(let i = 1; i < chartDataTimes.length; i++){
                    const current = chartDataTimes[i];
                    const diff = Math.abs(numericTarget - current);
                    if (diff < minDiff) {
                        minDiff = diff;
                        closest = current;
                    }
                }
                return closest;
            };
            trades.forEach((t)=>{
                const entryTimeRaw = processTime(t.entry_date);
                const exitTimeRaw = t.status !== 'OPEN' && t.exit_date ? processTime(t.exit_date) : null;
                const entryTime = snapToClosest(entryTimeRaw);
                const exitTime = exitTimeRaw ? snapToClosest(exitTimeRaw) : null;
                if (entryTime && showBuyMarkers) {
                    const isLong = t.side === 'LONG';
                    markers.push({
                        time: entryTime,
                        position: isLong ? 'belowBar' : 'aboveBar',
                        color: isLong ? (0, $a6l6I.themeColors).successMarker : (0, $a6l6I.themeColors).dangerMarker,
                        shape: isLong ? 'arrowUp' : 'arrowDown',
                        text: isLong ? 'B' : 'S'
                    });
                }
                if (exitTime && showCloseMarkers) {
                    const isLong = t.side === 'LONG';
                    const exitColor = t.status === 'STOP_LOSS' ? (0, $a6l6I.themeColors).warningMarker : isLong ? (0, $a6l6I.themeColors).dangerMarker : (0, $a6l6I.themeColors).successMarker;
                    markers.push({
                        time: exitTime,
                        position: isLong ? 'aboveBar' : 'belowBar',
                        color: exitColor,
                        shape: isLong ? 'arrowDown' : 'arrowUp',
                        text: t.status === 'STOP_LOSS' ? 'SL' : 'C'
                    });
                }
            });
        }
        if (oosStartDate) markers.push({
            time: processTime(oosStartDate),
            position: 'aboveBar',
            color: (0, $a6l6I.themeColors).warning,
            shape: 'arrowDown',
            text: 'OOS',
            size: 2
        });
        customMarkers.forEach((marker)=>{
            markers.push({
                time: processTime(marker.date),
                position: marker.position,
                color: marker.color,
                shape: marker.shape,
                ...marker.text ? {
                    text: marker.text
                } : {},
                ...marker.size ? {
                    size: marker.size
                } : {}
            });
        });
        if (markers.length > 0) (0, $2bl5m.createSeriesMarkers)(series, markers.sort((a, b)=>String(a.time).localeCompare(String(b.time))));
        const savedVisibleRange = visibleLogicalRangeRef.current;
        if (savedVisibleRange) chart.timeScale().setVisibleLogicalRange(savedVisibleRange);
        else {
            applyRangeLogic();
            appliedRangeRef.current = selectedRange;
        }
        updateOosOverlay();
        const timeScale = chart.timeScale();
        const handleVisibleLogicalRangeChange = ()=>{
            visibleLogicalRangeRef.current = timeScale.getVisibleLogicalRange();
            updateOosOverlay();
        };
        const handleCrosshairMove = (param)=>{
            if (!param?.time || !processedDataRef.current.length) {
                setHoverPoint(null);
                setLowerHoverPoint(null);
                return;
            }
            const targetTime = String(param.time);
            const matchedPoint = processedDataRef.current.find((point)=>String(processTime(String(point.date))) === targetTime);
            const matchedLowerPoint = processedLowerPaneData.find((point)=>String(processTime(String(point.date))) === targetTime);
            setHoverPoint(matchedPoint || null);
            setLowerHoverPoint(matchedLowerPoint || null);
        };
        timeScale.subscribeVisibleTimeRangeChange(updateOosOverlay);
        timeScale.subscribeVisibleLogicalRangeChange(handleVisibleLogicalRangeChange);
        chart.subscribeCrosshairMove(handleCrosshairMove);
        resizeObserver.current = new ResizeObserver((entries)=>{
            const { width: width, height: h } = entries[0].contentRect;
            chart.applyOptions({
                width: width,
                height: h
            });
            updateOosOverlay();
        });
        resizeObserver.current.observe(chartContainerRef.current);
        return ()=>{
            visibleLogicalRangeRef.current = timeScale.getVisibleLogicalRange();
            timeScale.unsubscribeVisibleTimeRangeChange(updateOosOverlay);
            timeScale.unsubscribeVisibleLogicalRangeChange(handleVisibleLogicalRangeChange);
            chart.unsubscribeCrosshairMove(handleCrosshairMove);
            resizeObserver.current?.disconnect();
            chart.remove();
            chartRef.current = null;
            seriesRef.current = null;
            overlaySeriesRef.current = [];
            processedDataRef.current = [];
            setHoverPoint(null);
            setLowerHoverPoint(null);
        };
    // Range changes are applied below without rebuilding the chart instance.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        trades,
        volumeData,
        lineOverlays,
        customMarkers,
        lowerPaneData,
        type,
        symbolStyle,
        showMa30,
        showMa200,
        showBuyMarkers,
        showCloseMarkers,
        equityVariant,
        height,
        resolution,
        timeVisible,
        oosStartDate,
        lineColor,
        topColor,
        bottomColor,
        candleUpColor,
        candleDownColor,
        lowerPaneColor,
        lowerPaneValuePrefix,
        lowerPaneValueSuffix,
        visibleSeriesKeys,
        displayMode,
        showMainSeries,
        compareGross,
        showGrossSeries,
        lowerPaneType,
        showEquityCandles,
        allStrategyKeys,
        processTime,
        updateOosOverlay
    ]);
    // Only toolbar range changes and explicit reset requests should move the
    // user's viewport. Data refreshes and crosshair hover rerenders preserve it.
    (0, $acw62.useEffect)(()=>{
        if (!chartRef.current || !seriesRef.current || data.length === 0) return;
        const resetRequested = appliedResetViewTokenRef.current !== resetViewToken;
        const rangeChanged = appliedRangeRef.current !== selectedRange;
        if (!resetRequested && !rangeChanged) return;
        if (resetRequested) visibleLogicalRangeRef.current = null;
        appliedResetViewTokenRef.current = resetViewToken;
        appliedRangeRef.current = selectedRange;
        applyRangeLogic();
        updateOosOverlay();
    }, [
        selectedRange,
        resetViewToken,
        applyRangeLogic,
        updateOosOverlay
    ]);
    const rangeOptions = [
        '1D',
        '3D',
        '1W',
        '1M',
        '3M',
        '6M',
        'YTD',
        '1Y',
        'ALL'
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "relative w-full h-full",
        children: [
            (showLatestControl || !hideControls) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "absolute bottom-9 right-20 z-20",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                    size: "compact",
                    iconOnly: true,
                    label: "Scroll chart to latest",
                    title: "Scroll chart to latest",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kEKEC.default), {
                        className: "h-4 w-4"
                    }),
                    onClick: ()=>{
                        visibleLogicalRangeRef.current = null;
                        applyRangeLogic(true);
                        updateOosOverlay();
                    }
                })
            }),
            !hideControls && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "absolute top-2 right-2 z-10 flex flex-wrap justify-end gap-1",
                children: [
                    type === 'symbol' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mr-1 flex rounded border border-line bg-surface-2 p-0.5",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "flex h-7 items-center gap-1.5 rounded px-2 text-[10px] font-bold uppercase tracking-wider text-neon",
                            title: "Candlestick chart",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $Pru0l.default), {
                                    className: "h-3.5 w-3.5"
                                }),
                                "Candle"
                            ]
                        })
                    }),
                    rangeOptions.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                            size: "compact",
                            label: r,
                            selected: selectedRange === r,
                            onClick: ()=>handleRangeChange(r),
                            children: r
                        }, r))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: chartContainerRef,
                className: "w-full h-full bg-surface-3"
            }),
            hoverPoint && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pointer-events-none absolute bottom-10 left-3 z-[9] rounded-lg border border-line bg-surface/90 px-3 py-2 text-[11px] text-white shadow-lg backdrop-blur-sm",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-1 font-mono text-white/80",
                        children: formatHoverDate(String(hoverPoint.date))
                    }),
                    type === 'symbol' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-2 gap-x-3 gap-y-1 font-mono",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-white/60",
                                children: "O"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: Number(hoverPoint.open ?? 0).toFixed(2)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-white/60",
                                children: "H"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: Number(hoverPoint.high ?? 0).toFixed(2)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-white/60",
                                children: "L"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: Number(hoverPoint.low ?? 0).toFixed(2)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-white/60",
                                children: "C"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: Number(hoverPoint.close ?? 0).toFixed(2)
                            }),
                            hoverPoint.ma30 != null && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-sky-300",
                                        children: "MA30"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: Number(hoverPoint.ma30).toFixed(2)
                                    })
                                ]
                            }),
                            hoverPoint.ma200 != null && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-warning-500",
                                        children: "MA200"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: Number(hoverPoint.ma200).toFixed(2)
                                    })
                                ]
                            }),
                            lowerHoverPoint && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: lowerPaneLabel === 'Daily P/L' && Number(lowerHoverPoint.equity ?? 0) >= 0 ? 'text-success-500' : 'text-error-500',
                                        children: lowerPaneLabel
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: lowerPaneLabel === 'Daily P/L' && Number(lowerHoverPoint.equity ?? 0) >= 0 ? 'text-success-500' : 'text-error-500',
                                        children: [
                                            lowerPaneValuePrefix,
                                            Number(lowerHoverPoint.equity ?? 0).toFixed(2),
                                            lowerPaneValueSuffix
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-2 gap-x-3 gap-y-1 font-mono",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-white/60",
                                children: displayMode === 'percent' ? 'Return' : 'Total Equity'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: displayMode === 'percent' ? hoverPoint.equity >= 0 ? 'text-neon' : 'text-error-500' : 'text-white',
                                children: [
                                    displayMode === 'percent' ? hoverPoint.equity >= 0 ? '+' : '' : '$',
                                    Number(hoverPoint.equity ?? 0).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }),
                                    displayMode === 'percent' ? '%' : ''
                                ]
                            }),
                            compareGross && showGrossSeries && hoverPoint.equity_gross !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: (()=>{
                                    const isGrossMain = displayMode === 'gross';
                                    const compVal = isGrossMain ? hoverPoint.equity : hoverPoint.equity_gross;
                                    const startVal = data[0]?.equity || 1;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-warning-500/60",
                                                children: isGrossMain ? 'Net' : 'Gross'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "text-warning-500/80",
                                                children: [
                                                    displayMode === 'percent' ? compVal >= 0 ? '+' : '' : '$',
                                                    Number(displayMode === 'percent' ? (compVal / startVal - 1) * 100 : compVal).toLocaleString(undefined, {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    }),
                                                    displayMode === 'percent' ? '%' : ''
                                                ]
                                            })
                                        ]
                                    });
                                })()
                            }),
                            allStrategyKeys.filter((k)=>hoverPoint[k] !== undefined).map((k)=>{
                                const idx = allStrategyKeys.indexOf(k);
                                const color = (0, $a6l6I.strategySeriesColors)[idx % (0, $a6l6I.strategySeriesColors).length];
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w-1.5 h-1.5 rounded-full",
                                                    style: {
                                                        backgroundColor: color
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-white/40",
                                                    children: k.replace('equity_', '').substring(0, 10)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: displayMode === 'percent' ? hoverPoint[k] >= 0 ? 'text-neon/80' : 'text-error-500/80' : 'text-white/60',
                                            children: [
                                                displayMode === 'percent' ? hoverPoint[k] >= 0 ? '+' : '' : '$',
                                                Number(hoverPoint[k] ?? 0).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }),
                                                displayMode === 'percent' ? '%' : ''
                                            ]
                                        })
                                    ]
                                }, k);
                            }),
                            lowerHoverPoint && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: lowerPaneLabel === 'Daily P/L' && Number(lowerHoverPoint.equity ?? 0) >= 0 ? 'text-success-500' : 'text-error-500',
                                        children: lowerPaneLabel
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: lowerPaneLabel === 'Daily P/L' && Number(lowerHoverPoint.equity ?? 0) >= 0 ? 'text-success-500' : 'text-error-500',
                                        children: [
                                            lowerPaneValuePrefix,
                                            Number(lowerHoverPoint.equity ?? 0).toFixed(2),
                                            lowerPaneValueSuffix
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            oosStartDate && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: overlayRef,
                className: "absolute top-0 bottom-0 z-[5] pointer-events-none border-l border-slate-300/50 bg-slate-300/[0.025]",
                style: {
                    display: 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "absolute top-2 right-2 rounded bg-slate-200/70 px-1.5 py-0.5 text-[9px] font-bold tracking-widest text-slate-900",
                    children: "OOS"
                })
            })
        ]
    });
};

});
parcelRegister("2bl5m", function(module, exports) {

$parcel$export(module.exports, "ColorType", () => $a1a4d31e28ce1f0d$export$2cd82751acc0e609);
$parcel$export(module.exports, "createChart", () => $a1a4d31e28ce1f0d$export$c870ec99876cb45c);
$parcel$export(module.exports, "LineSeries", () => $a1a4d31e28ce1f0d$export$29b04ebffc4f4705);
$parcel$export(module.exports, "AreaSeries", () => $a1a4d31e28ce1f0d$export$1d34d22a4e55a2c5);
$parcel$export(module.exports, "CandlestickSeries", () => $a1a4d31e28ce1f0d$export$9bff15f5cdf5e23d);
$parcel$export(module.exports, "HistogramSeries", () => $a1a4d31e28ce1f0d$export$9553650b5f8815ed);
$parcel$export(module.exports, "createSeriesMarkers", () => $a1a4d31e28ce1f0d$export$b954512652d436b9);
/*!
 * @license
 * TradingView Lightweight Charts™ v5.2.0
 * Copyright (c) 2026 TradingView, Inc.
 * Licensed under Apache License 2.0 https://www.apache.org/licenses/LICENSE-2.0
 */ parcelRequire("1vWyb");
var $3F0l6 = parcelRequire("3F0l6");
var $cpKFH = parcelRequire("cpKFH");
var $9fJzN = parcelRequire("9fJzN");
const $a1a4d31e28ce1f0d$var$e = {
    title: "",
    visible: !0,
    hitTestTolerance: 3,
    lastValueVisible: !0,
    priceLineVisible: !0,
    priceLineSource: 0,
    priceLineWidth: 1,
    priceLineColor: "",
    priceLineStyle: 2,
    baseLineVisible: !0,
    baseLineWidth: 1,
    baseLineColor: "#B2B5BE",
    baseLineStyle: 0,
    priceFormat: {
        type: "price",
        precision: 2,
        minMove: .01
    }
};
var $a1a4d31e28ce1f0d$export$aa318e0578993894, $a1a4d31e28ce1f0d$export$5d24e00cfde59887;
function $a1a4d31e28ce1f0d$var$a(t, i) {
    const n = function(t, i) {
        switch(t){
            case 0:
            default:
                return [];
            case 1:
                return [
                    i,
                    i
                ];
            case 2:
                return [
                    2 * i,
                    2 * i
                ];
            case 3:
                return [
                    6 * i,
                    6 * i
                ];
            case 4:
                return [
                    i,
                    4 * i
                ];
        }
    }(i, t.lineWidth);
    return t.setLineDash(n), n;
}
function $a1a4d31e28ce1f0d$var$l(t, i, n, s) {
    t.beginPath();
    const e = t.lineWidth % 2 ? .5 : 0;
    t.moveTo(n, i + e), t.lineTo(s, i + e), t.stroke();
}
function $a1a4d31e28ce1f0d$var$o(t, i) {
    if (!t) throw new Error("Assertion failed" + (i ? ": " + i : ""));
}
function $a1a4d31e28ce1f0d$var$_(t) {
    if (void 0 === t) throw new Error("Value is undefined");
    return t;
}
function $a1a4d31e28ce1f0d$var$u(t) {
    if (null === t) throw new Error("Value is null");
    return t;
}
function $a1a4d31e28ce1f0d$var$c(t) {
    return $a1a4d31e28ce1f0d$var$u($a1a4d31e28ce1f0d$var$_(t));
}
!function(t) {
    t[t.Simple = 0] = "Simple", t[t.WithSteps = 1] = "WithSteps", t[t.Curved = 2] = "Curved";
}($a1a4d31e28ce1f0d$export$aa318e0578993894 || ($a1a4d31e28ce1f0d$export$aa318e0578993894 = {})), function(t) {
    t[t.Solid = 0] = "Solid", t[t.Dotted = 1] = "Dotted", t[t.Dashed = 2] = "Dashed", t[t.LargeDashed = 3] = "LargeDashed", t[t.SparseDotted = 4] = "SparseDotted";
}($a1a4d31e28ce1f0d$export$5d24e00cfde59887 || ($a1a4d31e28ce1f0d$export$5d24e00cfde59887 = {}));
class $a1a4d31e28ce1f0d$var$d {
    constructor(){
        this.t = [];
    }
    i(t, i, n) {
        const s = {
            h: t,
            l: i,
            o: !0 === n
        };
        this.t.push(s);
    }
    _(t) {
        const i = this.t.findIndex((i)=>t === i.h);
        i > -1 && this.t.splice(i, 1);
    }
    u(t) {
        this.t = this.t.filter((i)=>i.l !== t);
    }
    p(t, i, n) {
        const s = [
            ...this.t
        ];
        this.t = this.t.filter((t)=>!t.o), s.forEach((s)=>s.h(t, i, n));
    }
    v() {
        return this.t.length > 0;
    }
    m() {
        this.t = [];
    }
}
function $a1a4d31e28ce1f0d$var$f(t, ...i) {
    for (const n of i)for(const i in n)void 0 !== n[i] && Object.prototype.hasOwnProperty.call(n, i) && ![
        "__proto__",
        "constructor",
        "prototype"
    ].includes(i) && ("object" != typeof n[i] || void 0 === t[i] || Array.isArray(n[i]) ? t[i] = n[i] : $a1a4d31e28ce1f0d$var$f(t[i], n[i]));
    return t;
}
function $a1a4d31e28ce1f0d$var$p(t) {
    return "number" == typeof t && isFinite(t);
}
function $a1a4d31e28ce1f0d$var$v(t) {
    return "number" == typeof t && t % 1 == 0;
}
function $a1a4d31e28ce1f0d$var$m(t) {
    return "string" == typeof t;
}
function $a1a4d31e28ce1f0d$var$w(t) {
    return "boolean" == typeof t;
}
function $a1a4d31e28ce1f0d$var$M(t) {
    const i = t;
    if (!i || "object" != typeof i) return i;
    let n, s, e;
    for(s in n = Array.isArray(i) ? [] : {}, i)i.hasOwnProperty(s) && (e = i[s], n[s] = e && "object" == typeof e ? $a1a4d31e28ce1f0d$var$M(e) : e);
    return n;
}
function $a1a4d31e28ce1f0d$var$g(t) {
    return null !== t;
}
function $a1a4d31e28ce1f0d$var$b(t) {
    return null === t ? void 0 : t;
}
const $a1a4d31e28ce1f0d$var$S = "-apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif";
function $a1a4d31e28ce1f0d$var$x(t, i, n) {
    return void 0 === i && (i = $a1a4d31e28ce1f0d$var$S), `${n = void 0 !== n ? `${n} ` : ""}${t}px ${i}`;
}
class $a1a4d31e28ce1f0d$var$C {
    constructor(t){
        this.M = {
            S: 1,
            C: 5,
            k: NaN,
            P: "",
            T: "",
            R: "",
            D: "",
            I: 0,
            V: 0,
            B: 0,
            A: 0,
            L: 0
        }, this.O = t;
    }
    N() {
        const t = this.M, i = this.F(), n = this.W();
        return t.k === i && t.T === n || (t.k = i, t.T = n, t.P = $a1a4d31e28ce1f0d$var$x(i, n), t.A = 2.5 / 12 * i, t.I = t.A, t.V = i / 12 * t.C, t.B = i / 12 * t.C, t.L = 0), t.R = this.H(), t.D = this.U(), this.M;
    }
    H() {
        return this.O.N().layout.textColor;
    }
    U() {
        return this.O.$();
    }
    F() {
        return this.O.N().layout.fontSize;
    }
    W() {
        return this.O.N().layout.fontFamily;
    }
}
function $a1a4d31e28ce1f0d$var$y(t) {
    return t < 0 ? 0 : t > 255 ? 255 : Math.round(t) || 0;
}
function $a1a4d31e28ce1f0d$var$k(t) {
    return .199 * t[0] + .687 * t[1] + .114 * t[2];
}
class $a1a4d31e28ce1f0d$var$P {
    constructor(t, i){
        this.j = new Map, this.q = t, i && (this.j = i);
    }
    Y(t, i) {
        if ("transparent" === t) return t;
        const n = this.K(t), s = n[3];
        return `rgba(${n[0]}, ${n[1]}, ${n[2]}, ${i * s})`;
    }
    Z(t) {
        const i = this.K(t);
        return {
            G: `rgb(${i[0]}, ${i[1]}, ${i[2]})`,
            X: $a1a4d31e28ce1f0d$var$k(i) > 160 ? "black" : "white"
        };
    }
    J(t) {
        return $a1a4d31e28ce1f0d$var$k(this.K(t));
    }
    tt(t, i, n) {
        const [s, e, r, h] = this.K(t), [a, l, o, _] = this.K(i), u = [
            $a1a4d31e28ce1f0d$var$y(s + n * (a - s)),
            $a1a4d31e28ce1f0d$var$y(e + n * (l - e)),
            $a1a4d31e28ce1f0d$var$y(r + n * (o - r)),
            (c = h + n * (_ - h), c <= 0 || c > 1 ? Math.min(Math.max(c, 0), 1) : Math.round(1e4 * c) / 1e4)
        ];
        var c;
        return `rgba(${u[0]}, ${u[1]}, ${u[2]}, ${u[3]})`;
    }
    K(t) {
        const i = this.j.get(t);
        if (i) return i;
        const n = function(t) {
            const i = document.createElement("div");
            i.style.display = "none", document.body.appendChild(i), i.style.color = t;
            const n = window.getComputedStyle(i).color;
            return document.body.removeChild(i), n;
        }(t), s = n.match(/^rgba?\s*\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d*\.?\d+))?\)$/);
        if (!s) {
            if (this.q.length) for (const i of this.q){
                const n = i(t);
                if (n) return this.j.set(t, n), n;
            }
            throw new Error(`Failed to parse color: ${t}`);
        }
        const e = [
            parseInt(s[1], 10),
            parseInt(s[2], 10),
            parseInt(s[3], 10),
            s[4] ? parseFloat(s[4]) : 1
        ];
        return this.j.set(t, e), e;
    }
}
class $a1a4d31e28ce1f0d$var$T {
    constructor(){
        this.it = [];
    }
    nt(t) {
        this.it = t;
    }
    st(t, i, n) {
        this.it.forEach((s)=>{
            s.st(t, i, n);
        });
    }
}
class $a1a4d31e28ce1f0d$var$R {
    st(t, i, n) {
        t.useBitmapCoordinateSpace((t)=>this.et(t, i, n));
    }
}
class $a1a4d31e28ce1f0d$var$D extends $a1a4d31e28ce1f0d$var$R {
    constructor(){
        super(...arguments), this.rt = null;
    }
    ht(t) {
        this.rt = t;
    }
    et({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null === this.rt || null === this.rt.lt) return;
        const s = this.rt.lt, e = this.rt, r = Math.max(1, Math.floor(i)) % 2 / 2, h = (h)=>{
            t.beginPath();
            for(let a = s.to - 1; a >= s.from; --a){
                const s = e.ot[a], l = Math.round(s._t * i) + r, o = s.ut * n, _ = h * n + r;
                t.moveTo(l, o), t.arc(l, o, _, 0, 2 * Math.PI);
            }
            t.fill();
        };
        e.ct > 0 && (t.fillStyle = e.dt, h(e.ft + e.ct)), t.fillStyle = e.vt, h(e.ft);
    }
}
function $a1a4d31e28ce1f0d$var$I() {
    return {
        ot: [
            {
                _t: 0,
                ut: 0,
                wt: 0,
                Mt: 0
            }
        ],
        vt: "",
        dt: "",
        ft: 0,
        ct: 0,
        lt: null
    };
}
const $a1a4d31e28ce1f0d$var$V = {
    from: 0,
    to: 1
};
class $a1a4d31e28ce1f0d$var$B {
    constructor(t, i, n){
        this.gt = new $a1a4d31e28ce1f0d$var$T, this.bt = [], this.St = [], this.xt = !0, this.O = t, this.Ct = i, this.yt = n, this.gt.nt(this.bt);
    }
    kt(t) {
        this.Pt(), this.xt = !0;
    }
    Tt() {
        return this.xt && (this.Rt(), this.xt = !1), this.gt;
    }
    Pt() {
        const t = this.yt.Dt();
        t.length !== this.bt.length && (this.St = t.map($a1a4d31e28ce1f0d$var$I), this.bt = this.St.map((t)=>{
            const i = new $a1a4d31e28ce1f0d$var$D;
            return i.ht(t), i;
        }), this.gt.nt(this.bt));
    }
    Rt() {
        const t = 2 === this.Ct.N().mode || !this.Ct.It(), i = this.yt.Vt(), n = this.Ct.Bt(), s = this.O.Et();
        this.Pt(), i.forEach((i, e)=>{
            const r = this.St[e], h = i.At(n), a = i.Lt();
            !t && null !== h && i.It() && null !== a ? (r.vt = h.zt, r.ft = h.ft, r.ct = h.Ot, r.ot[0].Mt = h.Mt, r.ot[0].ut = i.Ft().Nt(h.Mt, a.Wt), r.dt = h.Ht ?? this.O.Ut(r.ot[0].ut / i.Ft().$t()), r.ot[0].wt = n, r.ot[0]._t = s.jt(n), r.lt = $a1a4d31e28ce1f0d$var$V) : r.lt = null;
        });
    }
}
class $a1a4d31e28ce1f0d$var$E extends $a1a4d31e28ce1f0d$var$R {
    constructor(t){
        super(), this.qt = t;
    }
    et({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (null === this.qt) return;
        const e = this.qt.Yt.It, r = this.qt.Kt.It;
        if (!e && !r) return;
        const h = Math.round(this.qt._t * n), o = Math.round(this.qt.ut * s);
        t.lineCap = "butt", e && h >= 0 && (t.lineWidth = Math.floor(this.qt.Yt.ct * n), t.strokeStyle = this.qt.Yt.R, t.fillStyle = this.qt.Yt.R, $a1a4d31e28ce1f0d$var$a(t, this.qt.Yt.Zt), function(t, i, n, s) {
            t.beginPath();
            const e = t.lineWidth % 2 ? .5 : 0;
            t.moveTo(i + e, n), t.lineTo(i + e, s), t.stroke();
        }(t, h, 0, i.height)), r && o >= 0 && (t.lineWidth = Math.floor(this.qt.Kt.ct * s), t.strokeStyle = this.qt.Kt.R, t.fillStyle = this.qt.Kt.R, $a1a4d31e28ce1f0d$var$a(t, this.qt.Kt.Zt), $a1a4d31e28ce1f0d$var$l(t, o, 0, i.width));
    }
}
class $a1a4d31e28ce1f0d$var$A {
    constructor(t, i){
        this.xt = !0, this.Gt = {
            Yt: {
                ct: 1,
                Zt: 0,
                R: "",
                It: !1
            },
            Kt: {
                ct: 1,
                Zt: 0,
                R: "",
                It: !1
            },
            _t: 0,
            ut: 0
        }, this.Xt = new $a1a4d31e28ce1f0d$var$E(this.Gt), this.Jt = t, this.yt = i;
    }
    kt() {
        this.xt = !0;
    }
    Tt(t) {
        return this.xt && (this.Rt(), this.xt = !1), this.Xt;
    }
    Rt() {
        const t = this.Jt.It(), i = this.yt.Qt().N().crosshair, n = this.Gt;
        if (2 === i.mode) return n.Kt.It = !1, void (n.Yt.It = !1);
        n.Kt.It = t && this.Jt.ti(this.yt), n.Yt.It = t && this.Jt.ii(), n.Kt.ct = i.horzLine.width, n.Kt.Zt = i.horzLine.style, n.Kt.R = i.horzLine.color, n.Yt.ct = i.vertLine.width, n.Yt.Zt = i.vertLine.style, n.Yt.R = i.vertLine.color, n._t = this.Jt.ni(), n.ut = this.Jt.si();
    }
}
function $a1a4d31e28ce1f0d$var$L(t, i, n, s, e, r) {
    t.fillRect(i + r, n, s - 2 * r, r), t.fillRect(i + r, n + e - r, s - 2 * r, r), t.fillRect(i, n, r, e), t.fillRect(i + s - r, n, r, e);
}
function $a1a4d31e28ce1f0d$var$z(t, i, n, s, e, r) {
    t.save(), t.globalCompositeOperation = "copy", t.fillStyle = r, t.fillRect(i, n, s, e), t.restore();
}
function $a1a4d31e28ce1f0d$var$O(t, i, n, s, e, r) {
    t.beginPath(), t.roundRect ? t.roundRect(i, n, s, e, r) : (t.lineTo(i + s - r[1], n), 0 !== r[1] && t.arcTo(i + s, n, i + s, n + r[1], r[1]), t.lineTo(i + s, n + e - r[2]), 0 !== r[2] && t.arcTo(i + s, n + e, i + s - r[2], n + e, r[2]), t.lineTo(i + r[3], n + e), 0 !== r[3] && t.arcTo(i, n + e, i, n + e - r[3], r[3]), t.lineTo(i, n + r[0]), 0 !== r[0] && t.arcTo(i, n, i + r[0], n, r[0]));
}
function $a1a4d31e28ce1f0d$var$N(t, i, n, s, e, r, h = 0, a = [
    0,
    0,
    0,
    0
], l = "") {
    if (t.save(), !h || !l || l === r) return $a1a4d31e28ce1f0d$var$O(t, i, n, s, e, a), t.fillStyle = r, t.fill(), void t.restore();
    const o = h / 2;
    var _;
    $a1a4d31e28ce1f0d$var$O(t, i + o, n + o, s - h, e - h, (_ = -o, a.map((t)=>0 === t ? t : t + _))), "transparent" !== r && (t.fillStyle = r, t.fill()), "transparent" !== l && (t.lineWidth = h, t.strokeStyle = l, t.closePath(), t.stroke()), t.restore();
}
function $a1a4d31e28ce1f0d$var$F(t, i, n, s, e, r, h) {
    t.save(), t.globalCompositeOperation = "copy";
    const a = t.createLinearGradient(0, 0, 0, e);
    a.addColorStop(0, r), a.addColorStop(1, h), t.fillStyle = a, t.fillRect(i, n, s, e), t.restore();
}
class $a1a4d31e28ce1f0d$var$W {
    constructor(t, i){
        this.ht(t, i);
    }
    ht(t, i) {
        this.qt = t, this.ei = i;
    }
    $t(t, i) {
        return this.qt.It ? t.k + t.A + t.I : 0;
    }
    st(t, i, n, s) {
        if (!this.qt.It || 0 === this.qt.ri.length) return;
        const e = this.qt.R, r = this.ei.G, h = t.useBitmapCoordinateSpace((t)=>{
            const h = t.context;
            h.font = i.P;
            const a = this.hi(t, i, n, s), l = a.ai;
            return a.li ? $a1a4d31e28ce1f0d$var$N(h, l.oi, l._i, l.ui, l.ci, r, l.di, [
                l.ft,
                0,
                0,
                l.ft
            ], r) : $a1a4d31e28ce1f0d$var$N(h, l.fi, l._i, l.ui, l.ci, r, l.di, [
                0,
                l.ft,
                l.ft,
                0
            ], r), this.qt.pi && (h.fillStyle = e, h.fillRect(l.fi, l.mi, l.wi - l.fi, l.Mi)), this.qt.gi && (h.fillStyle = i.D, h.fillRect(a.li ? l.bi - l.di : 0, l._i, l.di, l.Si - l._i)), a;
        });
        t.useMediaCoordinateSpace(({ context: t })=>{
            const n = h.xi;
            t.font = i.P, t.textAlign = h.li ? "right" : "left", t.textBaseline = "middle", t.fillStyle = e, t.fillText(this.qt.ri, n.Ci, (n._i + n.Si) / 2 + n.yi);
        });
    }
    hi(t, i, n, s) {
        const { context: e, bitmapSize: r, mediaSize: h, horizontalPixelRatio: a, verticalPixelRatio: l } = t, o = this.qt.pi || !this.qt.ki ? i.C : 0, _ = this.qt.Pi ? i.S : 0, u = i.A + this.ei.Ti, c = i.I + this.ei.Ri, d = i.V, f = i.B, p = this.qt.ri, v = i.k, m = n.Di(e, p), w = Math.ceil(n.Ii(e, p)), M = v + u + c, g = i.S + d + f + w + o, b = Math.max(1, Math.floor(l));
        let S = Math.round(M * l);
        S % 2 != b % 2 && (S += 1);
        const x = _ > 0 ? Math.max(1, Math.floor(_ * a)) : 0, C = Math.round(g * a), y = Math.round(o * a), k = this.ei.Vi ?? this.ei.Bi ?? this.ei.Ei, P = Math.round(k * l) - Math.floor(.5 * l), T = Math.floor(P + b / 2 - S / 2), R = T + S, D = "right" === s, I = D ? h.width - _ : _, V = D ? r.width - x : x;
        let B, E, A;
        return D ? (B = V - C, E = V - y, A = I - o - d - _) : (B = V + C, E = V + y, A = I + o + d), {
            li: D,
            ai: {
                _i: T,
                mi: P,
                Si: R,
                ui: C,
                ci: S,
                ft: 2 * a,
                di: x,
                oi: B,
                fi: V,
                wi: E,
                Mi: b,
                bi: r.width
            },
            xi: {
                _i: T / l,
                Si: R / l,
                Ci: A,
                yi: m
            }
        };
    }
}
class $a1a4d31e28ce1f0d$var$H {
    constructor(t){
        this.Ai = {
            Ei: 0,
            G: "#000",
            Ri: 0,
            Ti: 0
        }, this.Li = {
            ri: "",
            It: !1,
            pi: !0,
            ki: !1,
            Ht: "",
            R: "#FFF",
            gi: !1,
            Pi: !1
        }, this.zi = {
            ri: "",
            It: !1,
            pi: !1,
            ki: !0,
            Ht: "",
            R: "#FFF",
            gi: !0,
            Pi: !0
        }, this.xt = !0, this.Oi = new (t || $a1a4d31e28ce1f0d$var$W)(this.Li, this.Ai), this.Ni = new (t || $a1a4d31e28ce1f0d$var$W)(this.zi, this.Ai);
    }
    ri() {
        return this.Fi(), this.Li.ri;
    }
    Ei() {
        return this.Fi(), this.Ai.Ei;
    }
    kt() {
        this.xt = !0;
    }
    $t(t, i = !1) {
        return Math.max(this.Oi.$t(t, i), this.Ni.$t(t, i));
    }
    Wi() {
        return this.Ai.Vi ?? null;
    }
    Hi() {
        return this.Ai.Vi ?? this.Ai.Bi ?? this.Ei();
    }
    Ui(t) {
        this.Ai.Bi = t ?? void 0;
    }
    $i() {
        return this.Fi(), this.Li.It || this.zi.It;
    }
    ji() {
        return this.Fi(), this.Li.It;
    }
    Tt(t) {
        return this.Fi(), this.Li.pi = this.Li.pi && t.N().ticksVisible, this.zi.pi = this.zi.pi && t.N().ticksVisible, this.Oi.ht(this.Li, this.Ai), this.Ni.ht(this.zi, this.Ai), this.Oi;
    }
    qi() {
        return this.Fi(), this.Oi.ht(this.Li, this.Ai), this.Ni.ht(this.zi, this.Ai), this.Ni;
    }
    Fi() {
        this.xt && (this.Li.pi = !0, this.zi.pi = !1, this.Yi(this.Li, this.zi, this.Ai));
    }
}
class $a1a4d31e28ce1f0d$var$U extends $a1a4d31e28ce1f0d$var$H {
    constructor(t, i, n){
        super(), this.Jt = t, this.Ki = i, this.Zi = n;
    }
    Yi(t, i, n) {
        if (t.It = !1, 2 === this.Jt.N().mode) return;
        const s = this.Jt.N().horzLine;
        if (!s.labelVisible) return;
        const e = this.Ki.Lt();
        if (!this.Jt.It() || this.Ki.Gi() || null === e) return;
        const r = this.Ki.Xi().Z(s.labelBackgroundColor);
        n.G = r.G, t.R = r.X;
        const h = 2 / 12 * this.Ki.k();
        n.Ti = h, n.Ri = h;
        const a = this.Zi(this.Ki);
        n.Ei = a.Ei, t.ri = this.Ki.Ji(a.Mt, e), t.It = !0;
    }
}
const $a1a4d31e28ce1f0d$var$$ = /[1-9]/g;
class $a1a4d31e28ce1f0d$var$j {
    constructor(){
        this.qt = null;
    }
    ht(t) {
        this.qt = t;
    }
    st(t, i) {
        if (null === this.qt || !1 === this.qt.It || 0 === this.qt.ri.length) return;
        const n = t.useMediaCoordinateSpace(({ context: t })=>(t.font = i.P, Math.round(i.Qi.Ii(t, $a1a4d31e28ce1f0d$var$u(this.qt).ri, $a1a4d31e28ce1f0d$var$$))));
        if (n <= 0) return;
        const s = i.tn, e = n + 2 * s, r = e / 2, h = this.qt.nn;
        let a = this.qt.Ei, l = Math.floor(a - r) + .5;
        l < 0 ? (a += Math.abs(0 - l), l = Math.floor(a - r) + .5) : l + e > h && (a -= Math.abs(h - (l + e)), l = Math.floor(a - r) + .5);
        const o = l + e, _ = Math.ceil(0 + i.S + i.C + i.A + i.k + i.I);
        t.useBitmapCoordinateSpace(({ context: t, horizontalPixelRatio: n, verticalPixelRatio: s })=>{
            const e = $a1a4d31e28ce1f0d$var$u(this.qt);
            t.fillStyle = e.G;
            const r = Math.round(l * n), h = Math.round(0 * s), a = Math.round(o * n), c = Math.round(_ * s), d = Math.round(2 * n);
            if (t.beginPath(), t.moveTo(r, h), t.lineTo(r, c - d), t.arcTo(r, c, r + d, c, d), t.lineTo(a - d, c), t.arcTo(a, c, a, c - d, d), t.lineTo(a, h), t.fill(), e.pi) {
                const r = Math.round(e.Ei * n), a = h, l = Math.round((a + i.C) * s);
                t.fillStyle = e.R;
                const o = Math.max(1, Math.floor(n)), _ = Math.floor(.5 * n);
                t.fillRect(r - _, a, o, l - a);
            }
        }), t.useMediaCoordinateSpace(({ context: t })=>{
            const n = $a1a4d31e28ce1f0d$var$u(this.qt), e = 0 + i.S + i.C + i.A + i.k / 2;
            t.font = i.P, t.textAlign = "left", t.textBaseline = "middle", t.fillStyle = n.R;
            const r = i.Qi.Di(t, "Apr0");
            t.translate(l + s, e + r), t.fillText(n.ri, 0, 0);
        });
    }
}
class $a1a4d31e28ce1f0d$var$q {
    constructor(t, i, n){
        this.xt = !0, this.Xt = new $a1a4d31e28ce1f0d$var$j, this.Gt = {
            It: !1,
            G: "#4c525e",
            R: "white",
            ri: "",
            nn: 0,
            Ei: NaN,
            pi: !0
        }, this.Ct = t, this.sn = i, this.Zi = n;
    }
    kt() {
        this.xt = !0;
    }
    Tt() {
        return this.xt && (this.Rt(), this.xt = !1), this.Xt.ht(this.Gt), this.Xt;
    }
    Rt() {
        const t = this.Gt;
        if (t.It = !1, 2 === this.Ct.N().mode) return;
        const i = this.Ct.N().vertLine;
        if (!i.labelVisible) return;
        const n = this.sn.Et();
        if (n.Gi()) return;
        t.nn = n.nn();
        const s = this.Zi();
        if (null === s) return;
        t.Ei = s.Ei;
        const e = n.en(this.Ct.Bt());
        t.ri = n.rn($a1a4d31e28ce1f0d$var$u(e)), t.It = !0;
        const r = this.sn.Xi().Z(i.labelBackgroundColor);
        t.G = r.G, t.R = r.X, t.pi = n.N().ticksVisible;
    }
}
class $a1a4d31e28ce1f0d$var$Y {
    constructor(){
        this.hn = null, this.an = 0;
    }
    ln() {
        return this.an;
    }
    _n(t) {
        this.an = t;
    }
    Ft() {
        return this.hn;
    }
    un(t) {
        this.hn = t;
    }
    cn(t) {
        return [];
    }
    dn() {
        return [];
    }
    It() {
        return !0;
    }
}
var $a1a4d31e28ce1f0d$export$67315bc29c7dd713;
!function(t) {
    t[t.Normal = 0] = "Normal", t[t.Magnet = 1] = "Magnet", t[t.Hidden = 2] = "Hidden", t[t.MagnetOHLC = 3] = "MagnetOHLC";
}($a1a4d31e28ce1f0d$export$67315bc29c7dd713 || ($a1a4d31e28ce1f0d$export$67315bc29c7dd713 = {}));
class $a1a4d31e28ce1f0d$var$Z extends $a1a4d31e28ce1f0d$var$Y {
    constructor(t, i){
        super(), this.yt = null, this.fn = NaN, this.pn = 0, this.vn = !1, this.mn = new Map, this.wn = !1, this.Mn = new WeakMap, this.gn = new WeakMap, this.bn = NaN, this.Sn = NaN, this.xn = NaN, this.Cn = NaN, this.sn = t, this.yn = i;
        this.kn = ((t, i)=>(n)=>{
                const s = i(), e = t();
                if (n === $a1a4d31e28ce1f0d$var$u(this.yt).Pn()) return {
                    Mt: e,
                    Ei: s
                };
                {
                    const t = $a1a4d31e28ce1f0d$var$u(n.Lt());
                    return {
                        Mt: n.Tn(s, t),
                        Ei: s
                    };
                }
            })(()=>this.fn, ()=>this.Sn);
        const n = ((t, i)=>()=>{
                const n = this.sn.Et().Rn(t()), s = i();
                return n && Number.isFinite(s) ? {
                    wt: n,
                    Ei: s
                } : null;
            })(()=>this.pn, ()=>this.ni());
        this.Dn = new $a1a4d31e28ce1f0d$var$q(this, t, n);
    }
    N() {
        return this.yn;
    }
    In(t, i) {
        this.xn = t, this.Cn = i;
    }
    Vn() {
        this.xn = NaN, this.Cn = NaN;
    }
    Bn() {
        return this.xn;
    }
    En() {
        return this.Cn;
    }
    An(t, i, n) {
        this.wn || (this.wn = !0), this.vn = !0, this.Ln(t, i, n);
    }
    Bt() {
        return this.pn;
    }
    ni() {
        return this.bn;
    }
    si() {
        return this.Sn;
    }
    It() {
        return this.vn;
    }
    zn() {
        this.vn = !1, this.On(), this.fn = NaN, this.bn = NaN, this.Sn = NaN, this.yt = null, this.Vn(), this.Nn();
    }
    Fn(t) {
        if (!this.yn.doNotSnapToHiddenSeriesIndices) return t;
        const i = this.sn, n = i.Et();
        let s = null, e = null;
        for (const n of i.Wn()){
            const i = n.Un().Hn(t, -1);
            if (i) {
                if (i.$n === t) return t;
                (null === s || i.$n > s) && (s = i.$n);
            }
            const r = n.Un().Hn(t, 1);
            if (r) {
                if (r.$n === t) return t;
                (null === e || r.$n < e) && (e = r.$n);
            }
        }
        const r = [
            s,
            e
        ].filter($a1a4d31e28ce1f0d$var$g);
        if (0 === r.length) return t;
        const h = n.jt(t), a = r.map((t)=>Math.abs(h - n.jt(t)));
        return r[a.indexOf(Math.min(...a))];
    }
    jn(t) {
        let i = this.Mn.get(t);
        i || (i = new $a1a4d31e28ce1f0d$var$A(this, t), this.Mn.set(t, i));
        let n = this.gn.get(t);
        return n || (n = new $a1a4d31e28ce1f0d$var$B(this.sn, this, t), this.gn.set(t, n)), [
            i,
            n
        ];
    }
    ti(t) {
        return t === this.yt && this.yn.horzLine.visible;
    }
    ii() {
        return this.yn.vertLine.visible;
    }
    qn(t, i) {
        this.vn && this.yt === t || this.mn.clear();
        const n = [];
        return this.yt === t && n.push(this.Yn(this.mn, i, this.kn)), n;
    }
    dn() {
        return this.vn ? [
            this.Dn
        ] : [];
    }
    Kn() {
        return this.yt;
    }
    Nn() {
        this.sn.Zn().forEach((t)=>{
            this.Mn.get(t)?.kt(), this.gn.get(t)?.kt();
        }), this.mn.forEach((t)=>t.kt()), this.Dn.kt();
    }
    Gn(t) {
        return t && !t.Pn().Gi() ? t.Pn() : null;
    }
    Ln(t, i, n) {
        this.Xn(t, i, n) && this.Nn();
    }
    Xn(t, i, n) {
        const s = this.bn, e = this.Sn, r = this.fn, h = this.pn, a = this.yt, l = this.Gn(n);
        this.pn = t, this.bn = isNaN(t) ? NaN : this.sn.Et().jt(t), this.yt = n;
        const o = null !== l ? l.Lt() : null;
        return null !== l && null !== o ? (this.fn = i, this.Sn = l.Nt(i, o)) : (this.fn = NaN, this.Sn = NaN), s !== this.bn || e !== this.Sn || h !== this.pn || r !== this.fn || a !== this.yt;
    }
    On() {
        const t = this.sn.Jn().map((t)=>t.Un().Qn()).filter($a1a4d31e28ce1f0d$var$g), i = 0 === t.length ? null : Math.max(...t);
        this.pn = null !== i ? i : NaN;
    }
    Yn(t, i, n) {
        let s = t.get(i);
        return void 0 === s && (s = new $a1a4d31e28ce1f0d$var$U(this, i, n), t.set(i, s)), s;
    }
}
function $a1a4d31e28ce1f0d$var$G(t) {
    return "left" === t || "right" === t;
}
class $a1a4d31e28ce1f0d$var$X {
    constructor(t){
        this.ts = new Map, this.ns = [], this.ss = t;
    }
    es(t, i) {
        const n = function(t, i) {
            return void 0 === t ? i : {
                rs: Math.max(t.rs, i.rs),
                hs: t.hs || i.hs
            };
        }(this.ts.get(t), i);
        this.ts.set(t, n);
    }
    ls() {
        return this.ss;
    }
    _s(t) {
        const i = this.ts.get(t);
        return void 0 === i ? {
            rs: this.ss
        } : {
            rs: Math.max(this.ss, i.rs),
            hs: i.hs
        };
    }
    us() {
        this.cs(), this.ns = [
            {
                ds: 0
            }
        ];
    }
    fs(t) {
        this.cs(), this.ns = [
            {
                ds: 1,
                Wt: t
            }
        ];
    }
    ps(t) {
        this.vs(), this.ns.push({
            ds: 5,
            Wt: t
        });
    }
    cs() {
        this.vs(), this.ns.push({
            ds: 6
        });
    }
    ws() {
        this.cs(), this.ns = [
            {
                ds: 4
            }
        ];
    }
    Ms(t) {
        this.cs(), this.ns.push({
            ds: 2,
            Wt: t
        });
    }
    gs(t) {
        this.cs(), this.ns.push({
            ds: 3,
            Wt: t
        });
    }
    bs() {
        return this.ns;
    }
    Ss(t) {
        for (const i of t.ns)this.xs(i);
        this.ss = Math.max(this.ss, t.ss), t.ts.forEach((t, i)=>{
            this.es(i, t);
        });
    }
    static Cs() {
        return new $a1a4d31e28ce1f0d$var$X(2);
    }
    static ys() {
        return new $a1a4d31e28ce1f0d$var$X(3);
    }
    xs(t) {
        switch(t.ds){
            case 0:
                this.us();
                break;
            case 1:
                this.fs(t.Wt);
                break;
            case 2:
                this.Ms(t.Wt);
                break;
            case 3:
                this.gs(t.Wt);
                break;
            case 4:
                this.ws();
                break;
            case 5:
                this.ps(t.Wt);
                break;
            case 6:
                this.vs();
        }
    }
    vs() {
        const t = this.ns.findIndex((t)=>5 === t.ds);
        -1 !== t && this.ns.splice(t, 1);
    }
}
class $a1a4d31e28ce1f0d$var$J {
    formatTickmarks(t) {
        return t.map((t)=>this.format(t));
    }
}
const $a1a4d31e28ce1f0d$var$Q = ".";
function $a1a4d31e28ce1f0d$var$tt(t, i) {
    if (!$a1a4d31e28ce1f0d$var$p(t)) return "n/a";
    if (!$a1a4d31e28ce1f0d$var$v(i)) throw new TypeError("invalid length");
    if (i < 0 || i > 16) throw new TypeError("invalid length");
    if (0 === i) return t.toString();
    return ("0000000000000000" + t.toString()).slice(-i);
}
class $a1a4d31e28ce1f0d$var$it extends $a1a4d31e28ce1f0d$var$J {
    constructor(t, i){
        if (super(), i || (i = 1), $a1a4d31e28ce1f0d$var$p(t) && $a1a4d31e28ce1f0d$var$v(t) || (t = 100), t < 0) throw new TypeError("invalid base");
        this.Ki = t, this.ks = i, this.Ps();
    }
    format(t) {
        const i = t < 0 ? "\u2212" : "";
        return t = Math.abs(t), i + this.Ts(t);
    }
    Ps() {
        if (this.Rs = 0, this.Ki > 0 && this.ks > 0) {
            let t = this.Ki;
            for(; t > 1;)t /= 10, this.Rs++;
        }
    }
    Ts(t) {
        const i = this.Ki / this.ks;
        let n = Math.floor(t), s = "";
        const e = void 0 !== this.Rs ? this.Rs : NaN;
        if (i > 1) {
            let r = +(Math.round(t * i) - n * i).toFixed(this.Rs);
            r >= i && (r -= i, n += 1), s = $a1a4d31e28ce1f0d$var$Q + $a1a4d31e28ce1f0d$var$tt(+r.toFixed(this.Rs) * this.ks, e);
        } else n = Math.round(n * i) / i, e > 0 && (s = $a1a4d31e28ce1f0d$var$Q + $a1a4d31e28ce1f0d$var$tt(0, e));
        return n.toFixed(0) + s;
    }
}
class $a1a4d31e28ce1f0d$var$nt extends $a1a4d31e28ce1f0d$var$it {
    constructor(t = 100){
        super(t);
    }
    format(t) {
        return `${super.format(t)}%`;
    }
}
class $a1a4d31e28ce1f0d$var$st extends $a1a4d31e28ce1f0d$var$J {
    constructor(t){
        super(), this.Ds = t;
    }
    format(t) {
        let i = "";
        return t < 0 && (i = "-", t = -t), t < 995 ? i + this.Is(t) : t < 999995 ? i + this.Is(t / 1e3) + "K" : t < 999999995 ? (t = 1e3 * Math.round(t / 1e3), i + this.Is(t / 1e6) + "M") : (t = 1e6 * Math.round(t / 1e6), i + this.Is(t / 1e9) + "B");
    }
    Is(t) {
        let i;
        const n = Math.pow(10, this.Ds);
        return i = (t = Math.round(t * n) / n) >= 1e-15 && t < 1 ? t.toFixed(this.Ds).replace(/\.?0+$/, "") : String(t), i.replace(/(\.[1-9]*)0+$/, (t, i)=>i);
    }
}
const $a1a4d31e28ce1f0d$var$et = /[2-9]/g;
class $a1a4d31e28ce1f0d$var$rt {
    constructor(t = 50){
        this.Vs = 0, this.Bs = 1, this.Es = 1, this.As = {}, this.Ls = new Map, this.zs = t;
    }
    Os() {
        this.Vs = 0, this.Ls.clear(), this.Bs = 1, this.Es = 1, this.As = {};
    }
    Ii(t, i, n) {
        return this.Ns(t, i, n).width;
    }
    Di(t, i, n) {
        const s = this.Ns(t, i, n);
        return ((s.actualBoundingBoxAscent || 0) - (s.actualBoundingBoxDescent || 0)) / 2;
    }
    Ns(t, i, n) {
        const s = n || $a1a4d31e28ce1f0d$var$et, e = String(i).replace(s, "0");
        if (this.Ls.has(e)) return $a1a4d31e28ce1f0d$var$_(this.Ls.get(e)).Fs;
        if (this.Vs === this.zs) {
            const t = this.As[this.Es];
            delete this.As[this.Es], this.Ls.delete(t), this.Es++, this.Vs--;
        }
        t.save(), t.textBaseline = "middle";
        const r = t.measureText(e);
        return t.restore(), 0 === r.width && i.length || (this.Ls.set(e, {
            Fs: r,
            Ws: this.Bs
        }), this.As[this.Bs] = e, this.Vs++, this.Bs++), r;
    }
}
class $a1a4d31e28ce1f0d$var$ht {
    constructor(t){
        this.Hs = null, this.M = null, this.Us = "right", this.$s = t;
    }
    js(t, i, n) {
        this.Hs = t, this.M = i, this.Us = n;
    }
    st(t) {
        null !== this.M && null !== this.Hs && this.Hs.st(t, this.M, this.$s, this.Us);
    }
}
class $a1a4d31e28ce1f0d$var$at {
    constructor(t, i, n){
        this.qs = t, this.$s = new $a1a4d31e28ce1f0d$var$rt(50), this.Ys = i, this.O = n, this.F = -1, this.Xt = new $a1a4d31e28ce1f0d$var$ht(this.$s);
    }
    Tt() {
        const t = this.O.Ks(this.Ys);
        if (null === t) return null;
        const i = t.Zs(this.Ys) ? t.Gs() : this.Ys.Ft();
        if (null === i) return null;
        const n = t.Xs(i);
        if ("overlay" === n) return null;
        const s = this.O.Js();
        return s.k !== this.F && (this.F = s.k, this.$s.Os()), this.Xt.js(this.qs.qi(), s, n), this.Xt;
    }
}
class $a1a4d31e28ce1f0d$var$lt extends $a1a4d31e28ce1f0d$var$R {
    constructor(){
        super(...arguments), this.qt = null;
    }
    ht(t) {
        this.qt = t;
    }
    Qs(t, i) {
        if (!this.qt?.It) return null;
        const { ut: n, ct: s, te: e } = this.qt;
        return i >= n - s - 7 && i <= n + s + 7 ? {
            ie: this.qt,
            ne: Math.abs(i - n),
            se: 2,
            ee: "price-line",
            te: e
        } : null;
    }
    et({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (null === this.qt) return;
        if (!1 === this.qt.It) return;
        const e = Math.round(this.qt.ut * s);
        e < 0 || e > i.height || (t.lineCap = "butt", t.strokeStyle = this.qt.R, t.lineWidth = Math.floor(this.qt.ct * n), $a1a4d31e28ce1f0d$var$a(t, this.qt.Zt), $a1a4d31e28ce1f0d$var$l(t, e, 0, i.width));
    }
}
class $a1a4d31e28ce1f0d$var$ot {
    constructor(t){
        this.re = {
            ut: 0,
            R: "rgba(0, 0, 0, 0)",
            ct: 1,
            Zt: 0,
            It: !1
        }, this.he = new $a1a4d31e28ce1f0d$var$lt, this.xt = !0, this.ae = t, this.le = t.Qt(), this.he.ht(this.re);
    }
    kt() {
        this.xt = !0;
    }
    Tt() {
        return this.ae.It() ? (this.xt && (this.oe(), this.xt = !1), this.he) : null;
    }
}
class $a1a4d31e28ce1f0d$var$_t extends $a1a4d31e28ce1f0d$var$ot {
    constructor(t){
        super(t);
    }
    oe() {
        this.re.It = !1;
        const t = this.ae.Ft(), i = t._e()._e;
        if (2 !== i && 3 !== i) return;
        const n = this.ae.N();
        if (!n.baseLineVisible || !this.ae.It()) return;
        const s = this.ae.Lt();
        null !== s && (this.re.It = !0, this.re.ut = t.Nt(s.Wt, s.Wt), this.re.R = n.baseLineColor, this.re.ct = n.baseLineWidth, this.re.Zt = n.baseLineStyle);
    }
}
class $a1a4d31e28ce1f0d$var$ut extends $a1a4d31e28ce1f0d$var$R {
    constructor(){
        super(...arguments), this.qt = null;
    }
    ht(t) {
        this.qt = t;
    }
    ue() {
        return this.qt;
    }
    et({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        const s = this.qt;
        if (null === s) return;
        const e = Math.max(1, Math.floor(i)), r = e % 2 / 2, h = Math.round(s.ce.x * i) + r, a = s.ce.y * n;
        t.fillStyle = s.de, t.beginPath();
        const l = Math.max(2, 1.5 * s.fe) * i;
        t.arc(h, a, l, 0, 2 * Math.PI, !1), t.fill(), t.fillStyle = s.pe, t.beginPath(), t.arc(h, a, s.ft * i, 0, 2 * Math.PI, !1), t.fill(), t.lineWidth = e, t.strokeStyle = s.ve, t.beginPath(), t.arc(h, a, s.ft * i + e / 2, 0, 2 * Math.PI, !1), t.stroke();
    }
}
const $a1a4d31e28ce1f0d$var$ct = [
    {
        me: 0,
        we: .25,
        Me: 4,
        ge: 10,
        be: .25,
        Se: 0,
        xe: .4,
        Ce: .8
    },
    {
        me: .25,
        we: .525,
        Me: 10,
        ge: 14,
        be: 0,
        Se: 0,
        xe: .8,
        Ce: 0
    },
    {
        me: .525,
        we: 1,
        Me: 14,
        ge: 14,
        be: 0,
        Se: 0,
        xe: 0,
        Ce: 0
    }
];
class $a1a4d31e28ce1f0d$var$dt {
    constructor(t){
        this.Xt = new $a1a4d31e28ce1f0d$var$ut, this.xt = !0, this.ye = !0, this.ke = performance.now(), this.Pe = this.ke - 1, this.Te = t;
    }
    Re() {
        this.Pe = this.ke - 1, this.kt();
    }
    De() {
        if (this.kt(), 2 === this.Te.N().lastPriceAnimation) {
            const t = performance.now(), i = this.Pe - t;
            if (i > 0) return void (i < 650 && (this.Pe += 2600));
            this.ke = t, this.Pe = t + 2600;
        }
    }
    kt() {
        this.xt = !0;
    }
    Ie() {
        this.ye = !0;
    }
    It() {
        return 0 !== this.Te.N().lastPriceAnimation;
    }
    Ve() {
        switch(this.Te.N().lastPriceAnimation){
            case 0:
                return !1;
            case 1:
                return !0;
            case 2:
                return performance.now() <= this.Pe;
        }
    }
    Tt() {
        return this.xt ? (this.Rt(), this.xt = !1, this.ye = !1) : this.ye && (this.Be(), this.ye = !1), this.Xt;
    }
    Rt() {
        this.Xt.ht(null);
        const t = this.Te.Qt().Et(), i = t.Ee(), n = this.Te.Lt();
        if (null === i || null === n) return;
        const s = this.Te.Ae(!0);
        if (s.Le || !i.ze(s.$n)) return;
        const e = {
            x: t.jt(s.$n),
            y: this.Te.Ft().Nt(s.Mt, n.Wt)
        }, r = s.R, h = this.Te.N().lineWidth, a = this.Oe(this.Ne(), r);
        this.Xt.ht({
            de: r,
            fe: h,
            pe: a.pe,
            ve: a.ve,
            ft: a.ft,
            ce: e
        });
    }
    Be() {
        const t = this.Xt.ue();
        if (null !== t) {
            const i = this.Oe(this.Ne(), t.de);
            t.pe = i.pe, t.ve = i.ve, t.ft = i.ft;
        }
    }
    Ne() {
        return this.Ve() ? performance.now() - this.ke : 2599;
    }
    Fe(t, i, n, s) {
        const e = n + (s - n) * i;
        return this.Te.Qt().Xi().Y(t, e);
    }
    Oe(t, i) {
        const n = t % 2600 / 2600;
        let s;
        for (const t of $a1a4d31e28ce1f0d$var$ct)if (n >= t.me && n <= t.we) {
            s = t;
            break;
        }
        $a1a4d31e28ce1f0d$var$o(void 0 !== s, "Last price animation internal logic error");
        const e = (n - s.me) / (s.we - s.me);
        var r, h, a;
        return {
            pe: this.Fe(i, e, s.be, s.Se),
            ve: this.Fe(i, e, s.xe, s.Ce),
            ft: (r = e, h = s.Me, a = s.ge, h + (a - h) * r)
        };
    }
}
class $a1a4d31e28ce1f0d$var$ft extends $a1a4d31e28ce1f0d$var$ot {
    constructor(t){
        super(t);
    }
    oe() {
        const t = this.re;
        t.It = !1;
        const i = this.ae.N();
        if (!i.priceLineVisible || !this.ae.It()) return;
        const n = this.ae.Ae(0 === i.priceLineSource);
        n.Le || (t.It = !0, t.ut = n.Ei, t.R = this.ae.We(n.R), t.ct = i.priceLineWidth, t.Zt = i.priceLineStyle);
    }
}
class $a1a4d31e28ce1f0d$var$pt extends $a1a4d31e28ce1f0d$var$H {
    constructor(t){
        super(), this.Jt = t;
    }
    Yi(t, i, n) {
        t.It = !1, i.It = !1;
        const s = this.Jt;
        if (!s.It()) return;
        const e = s.N(), r = e.lastValueVisible, h = "" !== s.He(), a = 0 === e.seriesLastValueMode, l = s.Ae(!1);
        if (l.Le) return;
        r && (t.ri = this.Ue(l, r, a), t.It = 0 !== t.ri.length), (h || a) && (i.ri = this.$e(l, r, h, a), i.It = i.ri.length > 0);
        const o = s.We(l.R), _ = this.Jt.Qt().Xi().Z(o);
        n.G = _.G, n.Ei = l.Ei, i.Ht = s.Qt().Ut(l.Ei / s.Ft().$t()), t.Ht = o, t.R = _.X, i.R = _.X;
    }
    $e(t, i, n, s) {
        let e = "";
        const r = this.Jt.He();
        return n && 0 !== r.length && (e += `${r} `), i && s && (e += this.Jt.Ft().je() ? t.qe : t.Ye), e.trim();
    }
    Ue(t, i, n) {
        return i ? n ? this.Jt.Ft().je() ? t.Ye : t.qe : t.ri : "";
    }
}
function $a1a4d31e28ce1f0d$var$vt(t, i, n, s) {
    const e = Number.isFinite(i), r = Number.isFinite(n);
    return e && r ? t(i, n) : e || r ? e ? i : n : s;
}
class $a1a4d31e28ce1f0d$var$mt {
    constructor(t, i){
        this.Ke = t, this.Ze = i;
    }
    Ge(t) {
        return null !== t && this.Ke === t.Ke && this.Ze === t.Ze;
    }
    Xe() {
        return new $a1a4d31e28ce1f0d$var$mt(this.Ke, this.Ze);
    }
    Je() {
        return this.Ke;
    }
    Qe() {
        return this.Ze;
    }
    tr() {
        return this.Ze - this.Ke;
    }
    Gi() {
        return this.Ze === this.Ke || Number.isNaN(this.Ze) || Number.isNaN(this.Ke);
    }
    Ss(t) {
        return null === t ? this : new $a1a4d31e28ce1f0d$var$mt($a1a4d31e28ce1f0d$var$vt(Math.min, this.Je(), t.Je(), -1 / 0), $a1a4d31e28ce1f0d$var$vt(Math.max, this.Qe(), t.Qe(), 1 / 0));
    }
    ir(t) {
        if (!$a1a4d31e28ce1f0d$var$p(t)) return;
        if (0 === this.Ze - this.Ke) return;
        const i = .5 * (this.Ze + this.Ke);
        let n = this.Ze - i, s = this.Ke - i;
        n *= t, s *= t, this.Ze = i + n, this.Ke = i + s;
    }
    nr(t) {
        $a1a4d31e28ce1f0d$var$p(t) && (this.Ze += t, this.Ke += t);
    }
    sr() {
        return {
            minValue: this.Ke,
            maxValue: this.Ze
        };
    }
    static er(t) {
        return null === t ? null : new $a1a4d31e28ce1f0d$var$mt(t.minValue, t.maxValue);
    }
}
class $a1a4d31e28ce1f0d$var$wt {
    constructor(t, i){
        this.rr = t, this.hr = i || null;
    }
    ar() {
        return this.rr;
    }
    lr() {
        return this.hr;
    }
    sr() {
        return {
            priceRange: null === this.rr ? null : this.rr.sr(),
            margins: this.hr || void 0
        };
    }
    static er(t) {
        return null === t ? null : new $a1a4d31e28ce1f0d$var$wt($a1a4d31e28ce1f0d$var$mt.er(t.priceRange), t.margins);
    }
}
const $a1a4d31e28ce1f0d$var$Mt = [
    2,
    4,
    8,
    16,
    32,
    64,
    128,
    256,
    512
], $a1a4d31e28ce1f0d$var$gt = "Custom series with conflation reducer must have a priceValueBuilder method";
class $a1a4d31e28ce1f0d$var$bt extends $a1a4d31e28ce1f0d$var$ot {
    constructor(t, i){
        super(t), this._r = i;
    }
    oe() {
        const t = this.re;
        t.It = !1;
        const i = this._r.N();
        if (!this.ae.It() || !i.lineVisible) return;
        const n = this._r.ur();
        null !== n && (t.It = !0, t.ut = n, t.R = i.color, t.ct = i.lineWidth, t.Zt = i.lineStyle, t.te = this._r.N().id);
    }
}
class $a1a4d31e28ce1f0d$var$St extends $a1a4d31e28ce1f0d$var$H {
    constructor(t, i){
        super(), this.Te = t, this._r = i;
    }
    Yi(t, i, n) {
        t.It = !1, i.It = !1;
        const s = this._r.N(), e = s.axisLabelVisible, r = "" !== s.title, h = this.Te;
        if (!e || !h.It()) return;
        const a = this._r.ur();
        if (null === a) return;
        r && (i.ri = s.title, i.It = !0), i.Ht = h.Qt().Ut(a / h.Ft().$t()), t.ri = this.cr(s.price), t.It = !0;
        const l = this.Te.Qt().Xi().Z(s.axisLabelColor || s.color);
        n.G = l.G;
        const o = s.axisLabelTextColor || l.X;
        t.R = o, i.R = o, n.Ei = a;
    }
    cr(t) {
        const i = this.Te.Lt();
        return null === i ? "" : this.Te.Ft().Ji(t, i.Wt);
    }
}
class $a1a4d31e28ce1f0d$var$xt {
    constructor(t, i){
        this.Te = t, this.yn = i, this.dr = new $a1a4d31e28ce1f0d$var$bt(t, this), this.qs = new $a1a4d31e28ce1f0d$var$St(t, this), this.pr = new $a1a4d31e28ce1f0d$var$at(this.qs, t, t.Qt());
    }
    vr(t) {
        $a1a4d31e28ce1f0d$var$f(this.yn, t), this.kt(), this.Te.Qt().mr();
    }
    N() {
        return this.yn;
    }
    wr() {
        return this.dr;
    }
    Mr() {
        return this.pr;
    }
    gr() {
        return this.qs;
    }
    kt() {
        this.dr.kt(), this.qs.kt();
    }
    ur() {
        const t = this.Te, i = t.Ft();
        if (t.Qt().Et().Gi() || i.Gi()) return null;
        const n = t.Lt();
        return null === n ? null : i.Nt(this.yn.price, n.Wt);
    }
}
class $a1a4d31e28ce1f0d$var$Ct {
    constructor(){
        this.br = new WeakMap;
    }
    Sr(t, i, n) {
        const s = 1 / i * n;
        if (t >= s) return 1;
        const e = s / t, r = Math.pow(2, Math.floor(Math.log2(e)));
        return Math.min(r, 512);
    }
    Cr(t, i, n, s = !1, e) {
        if (0 === t.length || i <= 1) return t;
        const r = this.yr(i);
        if (r <= 1) return t;
        const h = this.kr(t);
        let a = h.Pr.get(r);
        return void 0 !== a || (a = this.Tr(t, r, n, s, e, h.Pr), h.Pr.set(r, a)), a;
    }
    Rr(t, i, n, s, e = !1, r) {
        if (n < 1 || 0 === t.length) return t;
        const h = this.kr(t), a = h.Pr.get(n);
        if (!a) return this.Cr(t, n, s, e, r);
        const l = this.Dr(t, i, n, a, e, s, r);
        return h.Pr.set(n, l), l;
    }
    yr(t) {
        if (t <= 2) return 2;
        for (const i of $a1a4d31e28ce1f0d$var$Mt)if (t <= i) return i;
        return 512;
    }
    Ir(t) {
        if (0 === t.length) return 0;
        const i = t[0], n = t[t.length - 1];
        return 31 * t.length + 17 * i.$n + 13 * n.$n;
    }
    Tr(t, i, n, s = !1, e, r = new Map) {
        if (2 === i) return this.Vr(t, 2, n, s, e);
        const h = i / 2;
        let a = r.get(h);
        return a || (a = this.Tr(t, h, n, s, e, r), r.set(h, a)), this.Br(a, n, s, e);
    }
    Vr(t, i, n, s = !1, e) {
        const r = this.Er(t, i, n, s, e);
        return this.Ar(r, s);
    }
    Br(t, i, n = !1, s) {
        const e = this.Er(t, 2, i, n, s);
        return this.Ar(e, n);
    }
    Er(t, i, n, s = !1, e) {
        const r = [];
        for(let h = 0; h < t.length; h += i){
            if (t.length - h >= i) {
                const i = this.Lr(t[h], t[h + 1], n, s, e);
                i.zr = !1, r.push(i);
            } else if (0 === r.length) r.push(this.Or(t[h], !0));
            else {
                const i = r[r.length - 1];
                r[r.length - 1] = this.Nr(i, t[h], n, s, e);
            }
        }
        return r;
    }
    Fr(t, i) {
        return (t ?? 1) + (i ?? 1);
    }
    Lr(t, i, n, s = !1, e) {
        if (!s || !n || !e) {
            const n = t.Wt[1] > i.Wt[1] ? t.Wt[1] : i.Wt[1], s = t.Wt[2] < i.Wt[2] ? t.Wt[2] : i.Wt[2];
            return {
                Wr: t.$n,
                Hr: i.$n,
                Ur: t.wt,
                $r: i.wt,
                jr: t.Wt[0],
                qr: n,
                Yr: s,
                Kr: i.Wt[3],
                Zr: this.Fr(t.Zr, i.Zr),
                Gr: void 0,
                zr: !1
            };
        }
        const r = n(this.Xr(t, e), this.Xr(i, e)), h = e(r), a = h.length ? h[h.length - 1] : 0;
        return {
            Wr: t.$n,
            Hr: i.$n,
            Ur: t.wt,
            $r: i.wt,
            jr: t.Wt[0],
            qr: Math.max(t.Wt[1], a),
            Yr: Math.min(t.Wt[2], a),
            Kr: a,
            Zr: this.Fr(t.Zr, i.Zr),
            Gr: r,
            zr: !1
        };
    }
    Nr(t, i, n, s = !1, e) {
        if (!s || !n || !e) return {
            Wr: t.Wr,
            Hr: i.$n,
            Ur: t.Ur,
            $r: i.wt,
            jr: t.jr,
            qr: t.qr > i.Wt[1] ? t.qr : i.Wt[1],
            Yr: t.Yr < i.Wt[2] ? t.Yr : i.Wt[2],
            Kr: i.Wt[3],
            Zr: t.Zr + (i.Zr ?? 1),
            Gr: t.Gr,
            zr: !1
        };
        const r = t.Gr, h = this.Xr(i, e), a = r ? {
            data: r,
            index: t.Wr,
            originalTime: t.Ur,
            time: t.Ur,
            priceValues: e(r)
        } : null, l = a ? n(a, h) : h.data, o = a ? e(l) : h.priceValues, _ = o.length ? o[o.length - 1] : 0;
        return {
            Wr: t.Wr,
            Hr: i.$n,
            Ur: t.Ur,
            $r: i.wt,
            jr: t.jr,
            qr: Math.max(t.qr, _),
            Yr: Math.min(t.Yr, _),
            Kr: _,
            Zr: t.Zr + (i.Zr ?? 1),
            Gr: l,
            zr: !1
        };
    }
    Jr(t, i, n, s, e, r, h = !1, a) {
        const l = i === s ? e : t[i];
        if (n - i == 1) return this.Or(l, !0);
        const o = i + 1 === s ? e : t[i + 1];
        let _ = this.Lr(l, o, r, h, a);
        for(let l = i + 2; l < n; l++){
            const i = l === s ? e : t[l];
            _ = this.Nr(_, i, r, h, a);
        }
        return _;
    }
    Xr(t, i) {
        const n = t.ue ?? {};
        return {
            data: t.ue,
            index: t.$n,
            originalTime: t.Qr,
            time: t.wt,
            priceValues: i(n)
        };
    }
    th(t, i = !1) {
        const n = !0 === i, s = !!t.Gr;
        return {
            $n: t.Wr,
            wt: t.Ur,
            Qr: t.Ur,
            Wt: [
                n ? t.Kr : t.jr,
                t.qr,
                t.Yr,
                t.Kr
            ],
            Zr: t.Zr,
            ue: n ? s ? t.Gr : {
                wt: t.Ur
            } : void 0
        };
    }
    Ar(t, i = !1) {
        return t.map((t)=>this.th(t, i));
    }
    Dr(t, i, n, s, e = !1, r, h) {
        if (0 === s.length) return s;
        const a = t.length - 1, l = Math.floor(a / n) * n;
        if (Math.min(l + n, t.length) - l < n && t.length > n) {
            const s = t.slice();
            return s[s.length - 1] = i, this.Cr(s, n, r, e, h);
        }
        if (Math.floor((a - 1) / n) === Math.floor(a / n) || 1 === s.length) {
            const o = Math.min(l + n, t.length), _ = o - l;
            if (_ <= 0) return s;
            const u = 1 === _ ? this.Or(l === a ? i : t[l], !0) : this.Jr(t, l, o, a, i, r, e, h);
            return s[s.length - 1] = this.th(u, e), s;
        }
        {
            const s = t.slice();
            return s[s.length - 1] = i, this.Cr(s, n, r, e, h);
        }
    }
    Or(t, i = !1) {
        return {
            Wr: t.$n,
            Hr: t.$n,
            Ur: t.wt,
            $r: t.wt,
            jr: t.Wt[0],
            qr: t.Wt[1],
            Yr: t.Wt[2],
            Kr: t.Wt[3],
            Zr: t.Zr ?? 1,
            Gr: t.ue,
            zr: i
        };
    }
    kr(t) {
        const i = this.ih(t), n = this.Ir(t);
        return i.nh !== n && (i.Pr.clear(), i.nh = n), i;
    }
    ih(t) {
        let i = this.br.get(t);
        return void 0 === i && (i = {
            nh: this.Ir(t),
            Pr: new Map
        }, this.br.set(t, i)), i;
    }
}
class $a1a4d31e28ce1f0d$var$yt extends $a1a4d31e28ce1f0d$var$Y {
    constructor(t){
        super(), this.sn = t;
    }
    Qt() {
        return this.sn;
    }
}
const $a1a4d31e28ce1f0d$var$kt = {
    Bar: (t, i, n, s)=>{
        const e = i.upColor, r = i.downColor, h = $a1a4d31e28ce1f0d$var$u(t(n, s)), a = $a1a4d31e28ce1f0d$var$c(h.Wt[0]) <= $a1a4d31e28ce1f0d$var$c(h.Wt[3]);
        return {
            sh: h.R ?? (a ? e : r)
        };
    },
    Candlestick: (t, i, n, s)=>{
        const e = i.upColor, r = i.downColor, h = i.borderUpColor, a = i.borderDownColor, l = i.wickUpColor, o = i.wickDownColor, _ = $a1a4d31e28ce1f0d$var$u(t(n, s)), d = $a1a4d31e28ce1f0d$var$c(_.Wt[0]) <= $a1a4d31e28ce1f0d$var$c(_.Wt[3]);
        return {
            sh: _.R ?? (d ? e : r),
            eh: _.Ht ?? (d ? h : a),
            rh: _.hh ?? (d ? l : o)
        };
    },
    Custom: (t, i, n, s)=>({
            sh: $a1a4d31e28ce1f0d$var$u(t(n, s)).R ?? i.color
        }),
    Area: (t, i, n, s)=>{
        const e = $a1a4d31e28ce1f0d$var$u(t(n, s));
        return {
            sh: e.vt ?? i.lineColor,
            vt: e.vt ?? i.lineColor,
            ah: e.ah ?? i.topColor,
            oh: e.oh ?? i.bottomColor
        };
    },
    Baseline: (t, i, n, s)=>{
        const e = $a1a4d31e28ce1f0d$var$u(t(n, s));
        return {
            sh: e.Wt[3] >= i.baseValue.price ? i.topLineColor : i.bottomLineColor,
            _h: e._h ?? i.topLineColor,
            uh: e.uh ?? i.bottomLineColor,
            dh: e.dh ?? i.topFillColor1,
            fh: e.fh ?? i.topFillColor2,
            ph: e.ph ?? i.bottomFillColor1,
            mh: e.mh ?? i.bottomFillColor2
        };
    },
    Line: (t, i, n, s)=>{
        const e = $a1a4d31e28ce1f0d$var$u(t(n, s));
        return {
            sh: e.R ?? i.color,
            vt: e.R ?? i.color
        };
    },
    Histogram: (t, i, n, s)=>({
            sh: $a1a4d31e28ce1f0d$var$u(t(n, s)).R ?? i.color
        })
};
class $a1a4d31e28ce1f0d$var$Pt {
    constructor(t){
        this.wh = (t, i)=>void 0 !== i ? i.Wt : this.Te.Un().Mh(t), this.Te = t, this.gh = $a1a4d31e28ce1f0d$var$kt[t.bh()];
    }
    Sh(t, i) {
        return this.gh(this.wh, this.Te.N(), t, i);
    }
}
function $a1a4d31e28ce1f0d$var$Tt(t, i, n, s, e = 0, r = i.length) {
    let h = r - e;
    for(; 0 < h;){
        const r = h >> 1, a = e + r;
        s(i[a], n) === t ? (e = a + 1, h -= r + 1) : h = r;
    }
    return e;
}
const $a1a4d31e28ce1f0d$var$Rt = $a1a4d31e28ce1f0d$var$Tt.bind(null, !0), $a1a4d31e28ce1f0d$var$Dt = $a1a4d31e28ce1f0d$var$Tt.bind(null, !1);
var $a1a4d31e28ce1f0d$export$452387148ad6f8a7;
!function(t) {
    t[t.NearestLeft = -1] = "NearestLeft", t[t.None = 0] = "None", t[t.NearestRight = 1] = "NearestRight";
}($a1a4d31e28ce1f0d$export$452387148ad6f8a7 || ($a1a4d31e28ce1f0d$export$452387148ad6f8a7 = {}));
const $a1a4d31e28ce1f0d$var$Vt = 30;
class $a1a4d31e28ce1f0d$var$Bt {
    constructor(){
        this.xh = [], this.Ch = new Map, this.yh = new Map, this.kh = [];
    }
    Ph() {
        return this.Th() > 0 ? this.xh[this.xh.length - 1] : null;
    }
    Rh() {
        return this.Th() > 0 ? this.Dh(0) : null;
    }
    Qn() {
        return this.Th() > 0 ? this.Dh(this.xh.length - 1) : null;
    }
    Th() {
        return this.xh.length;
    }
    Gi() {
        return 0 === this.Th();
    }
    ze(t) {
        return null !== this.Ih(t, 0);
    }
    Mh(t) {
        return this.Hn(t);
    }
    Hn(t, i = 0) {
        const n = this.Ih(t, i);
        return null === n ? null : {
            ...this.Vh(n),
            $n: this.Dh(n)
        };
    }
    Bh() {
        return this.xh;
    }
    Eh(t, i, n) {
        if (this.Gi()) return null;
        let s = null;
        for (const e of n)s = $a1a4d31e28ce1f0d$var$Et(s, this.Ah(t, i, e));
        return s;
    }
    ht(t) {
        this.yh.clear(), this.Ch.clear(), this.xh = t, this.kh = t.map((t)=>t.$n);
    }
    Lh() {
        return this.kh;
    }
    Dh(t) {
        return this.xh[t].$n;
    }
    Vh(t) {
        return this.xh[t];
    }
    Ih(t, i) {
        const n = this.zh(t);
        if (null === n && 0 !== i) switch(i){
            case -1:
                return this.Oh(t);
            case 1:
                return this.Nh(t);
            default:
                throw new TypeError("Unknown search mode");
        }
        return n;
    }
    Oh(t) {
        let i = this.Fh(t);
        return i > 0 && (i -= 1), i !== this.xh.length && this.Dh(i) < t ? i : null;
    }
    Nh(t) {
        const i = this.Wh(t);
        return i !== this.xh.length && t < this.Dh(i) ? i : null;
    }
    zh(t) {
        const i = this.Fh(t);
        return i === this.xh.length || t < this.xh[i].$n ? null : i;
    }
    Fh(t) {
        return $a1a4d31e28ce1f0d$var$Rt(this.xh, t, (t, i)=>t.$n < i);
    }
    Wh(t) {
        return $a1a4d31e28ce1f0d$var$Dt(this.xh, t, (t, i)=>t.$n > i);
    }
    Hh(t, i, n) {
        let s = null;
        for(let e = t; e < i; e++){
            const t = this.xh[e].Wt[n];
            Number.isNaN(t) || (null === s ? s = {
                Uh: t,
                $h: t
            } : (t < s.Uh && (s.Uh = t), t > s.$h && (s.$h = t)));
        }
        return s;
    }
    Ah(t, i, n) {
        if (this.Gi()) return null;
        let s = null;
        const e = $a1a4d31e28ce1f0d$var$u(this.Rh()), r = $a1a4d31e28ce1f0d$var$u(this.Qn()), h = Math.max(t, e), a = Math.min(i, r), l = Math.ceil(h / $a1a4d31e28ce1f0d$var$Vt) * $a1a4d31e28ce1f0d$var$Vt, o = Math.max(l, Math.floor(a / $a1a4d31e28ce1f0d$var$Vt) * $a1a4d31e28ce1f0d$var$Vt);
        {
            const t = this.Fh(h), e = this.Wh(Math.min(a, l, i));
            s = $a1a4d31e28ce1f0d$var$Et(s, this.Hh(t, e, n));
        }
        let _ = this.Ch.get(n);
        void 0 === _ && (_ = new Map, this.Ch.set(n, _));
        for(let t = Math.max(l + 1, h); t < o; t += $a1a4d31e28ce1f0d$var$Vt){
            const i = Math.floor(t / $a1a4d31e28ce1f0d$var$Vt);
            let e = _.get(i);
            if (void 0 === e) {
                const t = this.Fh(i * $a1a4d31e28ce1f0d$var$Vt), s = this.Wh((i + 1) * $a1a4d31e28ce1f0d$var$Vt - 1);
                e = this.Hh(t, s, n), _.set(i, e);
            }
            s = $a1a4d31e28ce1f0d$var$Et(s, e);
        }
        {
            const t = this.Fh(o), i = this.Wh(a);
            s = $a1a4d31e28ce1f0d$var$Et(s, this.Hh(t, i, n));
        }
        return s;
    }
}
function $a1a4d31e28ce1f0d$var$Et(t, i) {
    if (null === t) return i;
    if (null === i) return t;
    return {
        Uh: Math.min(t.Uh, i.Uh),
        $h: Math.max(t.$h, i.$h)
    };
}
function $a1a4d31e28ce1f0d$var$At() {
    return new $a1a4d31e28ce1f0d$var$Bt;
}
const $a1a4d31e28ce1f0d$var$Lt = {
    setLineStyle: $a1a4d31e28ce1f0d$var$a
};
class $a1a4d31e28ce1f0d$var$zt {
    constructor(t){
        this.jh = t;
    }
    st(t, i, n) {
        this.jh.draw(t, $a1a4d31e28ce1f0d$var$Lt);
    }
    qh(t, i, n) {
        this.jh.drawBackground?.(t, $a1a4d31e28ce1f0d$var$Lt);
    }
}
class $a1a4d31e28ce1f0d$var$Ot {
    constructor(t){
        this.Ls = null, this.Yh = t;
    }
    Tt() {
        const t = this.Yh.renderer();
        if (null === t) return null;
        if (this.Ls?.Kh === t) return this.Ls.Zh;
        const i = new $a1a4d31e28ce1f0d$var$zt(t);
        return this.Ls = {
            Kh: t,
            Zh: i
        }, i;
    }
    Gh() {
        return this.Yh.zOrder?.() ?? "normal";
    }
}
class $a1a4d31e28ce1f0d$var$Nt {
    constructor(t){
        this.Xh = null, this.Jh = t;
    }
    Qh() {
        return this.Jh;
    }
    Nn() {
        this.Jh.updateAllViews?.();
    }
    jn() {
        const t = this.Jh.paneViews?.() ?? [];
        if (this.Xh?.Kh === t) return this.Xh.Zh;
        const i = t.map((t)=>new $a1a4d31e28ce1f0d$var$Ot(t));
        return this.Xh = {
            Kh: t,
            Zh: i
        }, i;
    }
    Qs(t, i) {
        return this.Jh.hitTest?.(t, i) ?? null;
    }
}
let $a1a4d31e28ce1f0d$var$Ft = class extends $a1a4d31e28ce1f0d$var$Nt {
    cn() {
        return [];
    }
};
class $a1a4d31e28ce1f0d$var$Wt {
    constructor(t){
        this.jh = t;
    }
    st(t, i, n) {
        this.jh.draw(t, $a1a4d31e28ce1f0d$var$Lt);
    }
    qh(t, i, n) {
        this.jh.drawBackground?.(t, $a1a4d31e28ce1f0d$var$Lt);
    }
}
class $a1a4d31e28ce1f0d$var$Ht {
    constructor(t){
        this.Ls = null, this.Yh = t;
    }
    Tt() {
        const t = this.Yh.renderer();
        if (null === t) return null;
        if (this.Ls?.Kh === t) return this.Ls.Zh;
        const i = new $a1a4d31e28ce1f0d$var$Wt(t);
        return this.Ls = {
            Kh: t,
            Zh: i
        }, i;
    }
    Gh() {
        return this.Yh.zOrder?.() ?? "normal";
    }
}
function $a1a4d31e28ce1f0d$var$Ut(t) {
    return {
        ri: t.text(),
        Ei: t.coordinate(),
        Vi: t.fixedCoordinate?.(),
        R: t.textColor(),
        G: t.backColor(),
        It: t.visible?.() ?? !0,
        pi: t.tickVisible?.() ?? !0
    };
}
class $a1a4d31e28ce1f0d$var$$t {
    constructor(t, i){
        this.Xt = new $a1a4d31e28ce1f0d$var$j, this.ta = t, this.ia = i;
    }
    Tt() {
        return this.Xt.ht({
            nn: this.ia.nn(),
            ...$a1a4d31e28ce1f0d$var$Ut(this.ta)
        }), this.Xt;
    }
}
class $a1a4d31e28ce1f0d$var$jt extends $a1a4d31e28ce1f0d$var$H {
    constructor(t, i){
        super(), this.ta = t, this.Ki = i;
    }
    Yi(t, i, n) {
        const s = $a1a4d31e28ce1f0d$var$Ut(this.ta);
        n.G = s.G, t.R = s.R;
        const e = 2 / 12 * this.Ki.k();
        n.Ti = e, n.Ri = e, n.Ei = s.Ei, n.Vi = s.Vi, t.ri = s.ri, t.It = s.It, t.pi = s.pi;
    }
}
class $a1a4d31e28ce1f0d$var$qt extends $a1a4d31e28ce1f0d$var$Nt {
    constructor(t, i){
        super(t), this.na = null, this.sa = null, this.ea = null, this.ra = null, this.Te = i;
    }
    dn() {
        const t = this.Jh.timeAxisViews?.() ?? [];
        if (this.na?.Kh === t) return this.na.Zh;
        const i = this.Te.Qt().Et(), n = t.map((t)=>new $a1a4d31e28ce1f0d$var$$t(t, i));
        return this.na = {
            Kh: t,
            Zh: n
        }, n;
    }
    qn() {
        const t = this.Jh.priceAxisViews?.() ?? [];
        if (this.sa?.Kh === t) return this.sa.Zh;
        const i = this.Te.Ft(), n = t.map((t)=>new $a1a4d31e28ce1f0d$var$jt(t, i));
        return this.sa = {
            Kh: t,
            Zh: n
        }, n;
    }
    ha() {
        const t = this.Jh.priceAxisPaneViews?.() ?? [];
        if (this.ea?.Kh === t) return this.ea.Zh;
        const i = t.map((t)=>new $a1a4d31e28ce1f0d$var$Ht(t));
        return this.ea = {
            Kh: t,
            Zh: i
        }, i;
    }
    aa() {
        const t = this.Jh.timeAxisPaneViews?.() ?? [];
        if (this.ra?.Kh === t) return this.ra.Zh;
        const i = t.map((t)=>new $a1a4d31e28ce1f0d$var$Ht(t));
        return this.ra = {
            Kh: t,
            Zh: i
        }, i;
    }
    la(t, i) {
        return this.Jh.autoscaleInfo?.(t, i) ?? null;
    }
}
function $a1a4d31e28ce1f0d$var$Yt(t, i, n, s) {
    t.forEach((t)=>{
        i(t).forEach((t)=>{
            t.Gh() === n && s.push(t);
        });
    });
}
function $a1a4d31e28ce1f0d$var$Kt(t) {
    return t.jn();
}
function $a1a4d31e28ce1f0d$var$Zt(t) {
    return t.ha();
}
function $a1a4d31e28ce1f0d$var$Gt(t) {
    return t.aa();
}
const $a1a4d31e28ce1f0d$var$Xt = [
    "Area",
    "Line",
    "Baseline"
];
class $a1a4d31e28ce1f0d$var$Jt extends $a1a4d31e28ce1f0d$var$yt {
    constructor(t, i, n, s, e){
        super(t), this.qt = $a1a4d31e28ce1f0d$var$At(), this.dr = new $a1a4d31e28ce1f0d$var$ft(this), this.oa = [], this._a = new $a1a4d31e28ce1f0d$var$_t(this), this.ua = null, this.ca = null, this.da = null, this.fa = [], this.pa = new $a1a4d31e28ce1f0d$var$Ct, this.va = new Map, this.ma = null, this.yn = n, this.wa = i;
        const r = new $a1a4d31e28ce1f0d$var$pt(this);
        if (this.mn = [
            r
        ], this.pr = new $a1a4d31e28ce1f0d$var$at(r, this, t), $a1a4d31e28ce1f0d$var$Xt.includes(this.wa) && (this.ua = new $a1a4d31e28ce1f0d$var$dt(this)), this.Ma(), this.Yh = s(this, this.Qt(), e), "Custom" === this.wa) {
            const t = this.Yh;
            t.ga && this.ba(t.ga);
        }
    }
    m() {
        null !== this.da && clearTimeout(this.da);
    }
    We(t) {
        return this.yn.priceLineColor || t;
    }
    Ae(t) {
        const i = {
            Le: !0
        }, n = this.Ft();
        if (this.Qt().Et().Gi() || n.Gi() || this.qt.Gi()) return i;
        const s = this.Qt().Et().Ee(), e = this.Lt();
        if (null === s || null === e) return i;
        let r, h;
        if (t) {
            const t = this.qt.Ph();
            if (null === t) return i;
            r = t, h = t.$n;
        } else {
            const t = this.qt.Hn(s.bi(), -1);
            if (null === t) return i;
            if (r = this.qt.Mh(t.$n), null === r) return i;
            h = t.$n;
        }
        const a = r.Wt[3], l = this.Sa().Sh(h, {
            Wt: r
        }), o = n.Nt(a, e.Wt);
        return {
            Le: !1,
            Mt: a,
            ri: n.Ji(a, e.Wt),
            qe: n.xa(a),
            Ye: n.Ca(a, e.Wt),
            R: l.sh,
            Ei: o,
            $n: h
        };
    }
    Sa() {
        return null !== this.ca || (this.ca = new $a1a4d31e28ce1f0d$var$Pt(this)), this.ca;
    }
    N() {
        return this.yn;
    }
    vr(t) {
        const i = this.Qt(), { priceScaleId: n, visible: s, priceFormat: e } = t;
        void 0 !== n && n !== this.yn.priceScaleId && i.ya(this, n), void 0 !== s && s !== this.yn.visible && i.ka();
        const r = void 0 !== t.conflationThresholdFactor;
        $a1a4d31e28ce1f0d$var$f(this.yn, t), r && (this.va.clear(), this.Qt().mr()), void 0 !== e && (this.Ma(), i.Pa()), i.Ta(this), i.Ra(), this.Yh.kt("options");
    }
    ht(t, i) {
        this.qt.ht(t), this.va.clear();
        const n = this.Qt().Et().N();
        n.enableConflation && n.precomputeConflationOnInit && this.Da(n.precomputeConflationPriority), this.Yh.kt("data"), null !== this.ua && (i && i.Ia ? this.ua.De() : 0 === t.length && this.ua.Re());
        const s = this.Qt().Ks(this);
        this.Qt().Va(s), this.Qt().Ta(this), this.Qt().Ra(), this.Qt().mr();
    }
    Ba(t) {
        const i = new $a1a4d31e28ce1f0d$var$xt(this, t);
        return this.oa.push(i), this.Qt().Ta(this), i;
    }
    Ea(t) {
        const i = this.oa.indexOf(t);
        -1 !== i && this.oa.splice(i, 1), this.Qt().Ta(this);
    }
    Aa() {
        return this.oa;
    }
    bh() {
        return this.wa;
    }
    Lt() {
        const t = this.La();
        return null === t ? null : {
            Wt: t.Wt[3],
            za: t.wt
        };
    }
    La() {
        const t = this.Qt().Et().Ee();
        if (null === t) return null;
        const i = t.Oa();
        return this.qt.Hn(i, 1);
    }
    Un() {
        return this.qt;
    }
    ba(t) {
        this.ma = t, this.va.clear();
    }
    Na() {
        return !!this.Qt().Et().N().enableConflation && this.Fa() > 1;
    }
    Rr(t) {
        if (!this.Na()) return;
        const i = this.Fa();
        if (!this.va.has(i)) return;
        const n = "Custom" === this.wa, s = n && this.ma || void 0, e = n && this.Yh.Wa ? (t)=>{
            const i = t, n = this.Yh.Wa(i);
            return Array.isArray(n) ? n : [
                "number" == typeof n ? n : 0
            ];
        } : void 0, r = this.pa.Rr(this.qt.Bh(), t, i, s, n, e), h = $a1a4d31e28ce1f0d$var$At();
        h.ht(r), this.va.set(i, h);
    }
    Ha() {
        const t = this.Qt().Et().N().enableConflation;
        if ("Custom" === this.wa && null === this.ma) return this.qt;
        if (!t) return this.qt;
        const i = this.Fa(), n = this.va.get(i);
        if (n) return n;
        this.Ua(i);
        return this.va.get(i) ?? this.qt;
    }
    $a(t) {
        const i = this.qt.Mh(t);
        return null === i ? null : "Bar" === this.wa || "Candlestick" === this.wa || "Custom" === this.wa ? {
            jr: i.Wt[0],
            qr: i.Wt[1],
            Yr: i.Wt[2],
            Kr: i.Wt[3]
        } : i.Wt[3];
    }
    ja(t) {
        const i = [];
        $a1a4d31e28ce1f0d$var$Yt(this.fa, $a1a4d31e28ce1f0d$var$Kt, "top", i);
        const n = this.ua;
        return null !== n && n.It() ? (null === this.da && n.Ve() && (this.da = setTimeout(()=>{
            this.da = null, this.Qt().qa();
        }, 0)), n.Ie(), i.unshift(n), i) : i;
    }
    jn() {
        const t = [];
        this.Ya() || t.push(this._a), t.push(this.Yh, this.dr);
        const i = this.oa.map((t)=>t.wr());
        return t.push(...i), $a1a4d31e28ce1f0d$var$Yt(this.fa, $a1a4d31e28ce1f0d$var$Kt, "normal", t), t;
    }
    Ka() {
        return this.Za($a1a4d31e28ce1f0d$var$Kt, "bottom");
    }
    Ga(t) {
        return this.Za($a1a4d31e28ce1f0d$var$Zt, t);
    }
    Xa(t) {
        return this.Za($a1a4d31e28ce1f0d$var$Gt, t);
    }
    Ja(t, i) {
        return this.fa.map((n)=>n.Qs(t, i)).filter((t)=>null !== t);
    }
    cn() {
        return [
            this.pr,
            ...this.oa.map((t)=>t.Mr())
        ];
    }
    qn(t, i) {
        if (i !== this.hn && !this.Ya()) return [];
        const n = [
            ...this.mn
        ];
        for (const t of this.oa)n.push(t.gr());
        return this.fa.forEach((t)=>{
            n.push(...t.qn());
        }), n;
    }
    dn() {
        const t = [];
        return this.fa.forEach((i)=>{
            t.push(...i.dn());
        }), t;
    }
    la(t, i) {
        if (void 0 !== this.yn.autoscaleInfoProvider) {
            const n = this.yn.autoscaleInfoProvider(()=>{
                const n = this.Qa(t, i);
                return null === n ? null : n.sr();
            });
            return $a1a4d31e28ce1f0d$var$wt.er(n);
        }
        return this.Qa(t, i);
    }
    Kh() {
        const t = this.yn.priceFormat;
        return t.base ?? 1 / t.minMove;
    }
    tl() {
        return this.il;
    }
    Nn() {
        this.Yh.kt();
        for (const t of this.mn)t.kt();
        for (const t of this.oa)t.kt();
        this.dr.kt(), this._a.kt(), this.ua?.kt(), this.fa.forEach((t)=>t.Nn());
    }
    Ft() {
        return $a1a4d31e28ce1f0d$var$u(super.Ft());
    }
    At(t) {
        if (!(("Line" === this.wa || "Area" === this.wa || "Baseline" === this.wa) && this.yn.crosshairMarkerVisible)) return null;
        const i = this.qt.Mh(t);
        if (null === i) return null;
        return {
            Mt: i.Wt[3],
            ft: this.nl(),
            Ht: this.sl(),
            Ot: this.el(),
            zt: this.rl(t)
        };
    }
    He() {
        return this.yn.title;
    }
    It() {
        return this.yn.visible;
    }
    hl(t) {
        this.fa.push(new $a1a4d31e28ce1f0d$var$qt(t, this));
    }
    al(t) {
        this.fa = this.fa.filter((i)=>i.Qh() !== t);
    }
    ll() {
        if ("Custom" === this.wa) return (t)=>this.Yh.Wa(t);
    }
    ol() {
        if ("Custom" === this.wa) return (t)=>this.Yh._l(t);
    }
    ul() {
        return this.qt.Lh();
    }
    Ya() {
        return !$a1a4d31e28ce1f0d$var$G(this.Ft().cl());
    }
    Qa(t, i) {
        if (!$a1a4d31e28ce1f0d$var$v(t) || !$a1a4d31e28ce1f0d$var$v(i) || this.qt.Gi()) return null;
        const n = "Line" === this.wa || "Area" === this.wa || "Baseline" === this.wa || "Histogram" === this.wa ? [
            3
        ] : [
            2,
            1
        ], s = this.qt.Eh(t, i, n);
        let e = null !== s ? new $a1a4d31e28ce1f0d$var$mt(s.Uh, s.$h) : null, r = null;
        if ("Histogram" === this.bh()) {
            const t = this.yn.base, i = new $a1a4d31e28ce1f0d$var$mt(t, t);
            e = null !== e ? e.Ss(i) : i;
        }
        return this.fa.forEach((n)=>{
            const s = n.la(t, i);
            if (s?.priceRange) {
                const t = new $a1a4d31e28ce1f0d$var$mt(s.priceRange.minValue, s.priceRange.maxValue);
                e = null !== e ? e.Ss(t) : t;
            }
            s?.margins && (r = s.margins);
        }), new $a1a4d31e28ce1f0d$var$wt(e, r);
    }
    nl() {
        switch(this.wa){
            case "Line":
            case "Area":
            case "Baseline":
                return this.yn.crosshairMarkerRadius;
        }
        return 0;
    }
    sl() {
        switch(this.wa){
            case "Line":
            case "Area":
            case "Baseline":
                {
                    const t = this.yn.crosshairMarkerBorderColor;
                    if (0 !== t.length) return t;
                }
        }
        return null;
    }
    el() {
        switch(this.wa){
            case "Line":
            case "Area":
            case "Baseline":
                return this.yn.crosshairMarkerBorderWidth;
        }
        return 0;
    }
    rl(t) {
        switch(this.wa){
            case "Line":
            case "Area":
            case "Baseline":
                {
                    const t = this.yn.crosshairMarkerBackgroundColor;
                    if (0 !== t.length) return t;
                }
        }
        return this.Sa().Sh(t).sh;
    }
    Ma() {
        switch(this.yn.priceFormat.type){
            case "custom":
                {
                    const t = this.yn.priceFormat.formatter;
                    this.il = {
                        format: t,
                        formatTickmarks: this.yn.priceFormat.tickmarksFormatter ?? ((i)=>i.map(t))
                    };
                    break;
                }
            case "volume":
                this.il = new $a1a4d31e28ce1f0d$var$st(this.yn.priceFormat.precision);
                break;
            case "percent":
                this.il = new $a1a4d31e28ce1f0d$var$nt(this.yn.priceFormat.precision);
                break;
            default:
                {
                    const t = Math.pow(10, this.yn.priceFormat.precision);
                    this.il = new $a1a4d31e28ce1f0d$var$it(t, this.yn.priceFormat.minMove * t);
                }
        }
        null !== this.hn && this.hn.dl();
    }
    Za(t, i) {
        const n = [];
        return $a1a4d31e28ce1f0d$var$Yt(this.fa, t, i, n), n;
    }
    Fa() {
        const { fl: t, pl: i, vl: n } = this.ml();
        return this.pa.Sr(t, i, n);
    }
    ml() {
        const t = this.Qt().Et(), i = t.fl(), n = window.devicePixelRatio || 1, s = t.N().conflationThresholdFactor;
        return {
            fl: i,
            pl: n,
            vl: this.yn.conflationThresholdFactor ?? s ?? 1
        };
    }
    wl(t) {
        const i = this.qt.Bh();
        let n;
        if ("Custom" === this.wa && null !== this.ma) {
            const s = this.ll();
            if (!s) throw new Error($a1a4d31e28ce1f0d$var$gt);
            n = this.pa.Cr(i, t, this.ma, !0, (t)=>s(t));
        } else n = this.pa.Cr(i, t);
        const s = $a1a4d31e28ce1f0d$var$At();
        return s.ht(n), s;
    }
    Ua(t) {
        const i = this.wl(t);
        this.va.set(t, i);
    }
    Da(t) {
        if ("Custom" === this.wa && (null === this.ma || !this.ll())) return;
        this.va.clear();
        const i = this.Qt().Et().Ml();
        for (const n of i){
            const i = ()=>{
                this.gl(n);
            }, s = "object" == typeof window && window || "object" == typeof self && self;
            s?.Sl?.bl ? s.Sl.bl(()=>{
                i();
            }, {
                se: t
            }) : Promise.resolve().then(()=>i());
        }
    }
    gl(t) {
        if (this.va.has(t)) return;
        if (0 === this.qt.Bh().length) return;
        const i = this.wl(t);
        this.va.set(t, i);
    }
}
const $a1a4d31e28ce1f0d$var$Qt = [
    3
], $a1a4d31e28ce1f0d$var$ti = [
    0,
    1,
    2,
    3
];
class $a1a4d31e28ce1f0d$var$ii {
    constructor(t){
        this.yn = t;
    }
    xl(t, i, n) {
        let s = t;
        if (0 === this.yn.mode) return s;
        const e = n.Pn(), r = e.Lt();
        if (null === r) return s;
        const h = e.Nt(t, r), a = n.Cl().filter((t)=>t instanceof $a1a4d31e28ce1f0d$var$Jt).reduce((t, s)=>{
            if (n.Zs(s) || !s.It()) return t;
            const e = s.Ft(), r = s.Un();
            if (e.Gi() || !r.ze(i)) return t;
            const h = r.Mh(i);
            if (null === h) return t;
            const a = $a1a4d31e28ce1f0d$var$c(s.Lt()), l = 3 === this.yn.mode ? $a1a4d31e28ce1f0d$var$ti : $a1a4d31e28ce1f0d$var$Qt;
            return t.concat(l.map((t)=>e.Nt(h.Wt[t], a.Wt)));
        }, []);
        if (0 === a.length) return s;
        a.sort((t, i)=>Math.abs(t - h) - Math.abs(i - h));
        const l = a[0];
        return s = e.Tn(l, r), s;
    }
}
function $a1a4d31e28ce1f0d$var$ni(t, i, n) {
    return Math.min(Math.max(t, i), n);
}
function $a1a4d31e28ce1f0d$var$si(t, i, n) {
    return i - t <= n;
}
function $a1a4d31e28ce1f0d$var$ei(t) {
    const i = Math.ceil(t);
    return i % 2 == 0 ? i - 1 : i;
}
class $a1a4d31e28ce1f0d$var$ri extends $a1a4d31e28ce1f0d$var$R {
    constructor(){
        super(...arguments), this.qt = null;
    }
    ht(t) {
        this.qt = t;
    }
    et({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (null === this.qt) return;
        const e = Math.max(1, Math.floor(n));
        t.lineWidth = e, function(t, i) {
            t.save(), t.lineWidth % 2 && t.translate(.5, .5), i(), t.restore();
        }(t, ()=>{
            const r = $a1a4d31e28ce1f0d$var$u(this.qt);
            if (r.yl) {
                t.strokeStyle = r.kl, $a1a4d31e28ce1f0d$var$a(t, r.Pl), t.beginPath();
                for (const s of r.Tl){
                    const r = Math.round(s.Rl * n);
                    t.moveTo(r, -e), t.lineTo(r, i.height + e);
                }
                t.stroke();
            }
            if (r.Dl) {
                t.strokeStyle = r.Il, $a1a4d31e28ce1f0d$var$a(t, r.Vl), t.beginPath();
                for (const n of r.Bl){
                    const r = Math.round(n.Rl * s);
                    t.moveTo(-e, r), t.lineTo(i.width + e, r);
                }
                t.stroke();
            }
        });
    }
}
class $a1a4d31e28ce1f0d$var$hi {
    constructor(t){
        this.Xt = new $a1a4d31e28ce1f0d$var$ri, this.xt = !0, this.yt = t;
    }
    kt() {
        this.xt = !0;
    }
    Tt() {
        if (this.xt) {
            const t = this.yt.Qt().N().grid, i = {
                Dl: t.horzLines.visible,
                yl: t.vertLines.visible,
                Il: t.horzLines.color,
                kl: t.vertLines.color,
                Vl: t.horzLines.style,
                Pl: t.vertLines.style,
                Bl: this.yt.Pn().El(),
                Tl: (this.yt.Qt().Et().El() || []).map((t)=>({
                        Rl: t.coord
                    }))
            };
            this.Xt.ht(i), this.xt = !1;
        }
        return this.Xt;
    }
}
class $a1a4d31e28ce1f0d$var$ai {
    constructor(t){
        this.Yh = new $a1a4d31e28ce1f0d$var$hi(t);
    }
    wr() {
        return this.Yh;
    }
}
const $a1a4d31e28ce1f0d$var$li = {
    Al: 4,
    Ll: 1e-4
};
function $a1a4d31e28ce1f0d$var$oi(t, i) {
    const n = 100 * (t - i) / i;
    return i < 0 ? -n : n;
}
function $a1a4d31e28ce1f0d$var$_i(t, i) {
    const n = $a1a4d31e28ce1f0d$var$oi(t.Je(), i), s = $a1a4d31e28ce1f0d$var$oi(t.Qe(), i);
    return new $a1a4d31e28ce1f0d$var$mt(n, s);
}
function $a1a4d31e28ce1f0d$var$ui(t, i) {
    const n = 100 * (t - i) / i + 100;
    return i < 0 ? -n : n;
}
function $a1a4d31e28ce1f0d$var$ci(t, i) {
    const n = $a1a4d31e28ce1f0d$var$ui(t.Je(), i), s = $a1a4d31e28ce1f0d$var$ui(t.Qe(), i);
    return new $a1a4d31e28ce1f0d$var$mt(n, s);
}
function $a1a4d31e28ce1f0d$var$di(t, i) {
    const n = Math.abs(t);
    if (n < 1e-15) return 0;
    const s = Math.log10(n + i.Ll) + i.Al;
    return t < 0 ? -s : s;
}
function $a1a4d31e28ce1f0d$var$fi(t, i) {
    const n = Math.abs(t);
    if (n < 1e-15) return 0;
    const s = Math.pow(10, n - i.Al) - i.Ll;
    return t < 0 ? -s : s;
}
function $a1a4d31e28ce1f0d$var$pi(t, i) {
    if (null === t) return null;
    const n = $a1a4d31e28ce1f0d$var$di(t.Je(), i), s = $a1a4d31e28ce1f0d$var$di(t.Qe(), i);
    return new $a1a4d31e28ce1f0d$var$mt(n, s);
}
function $a1a4d31e28ce1f0d$var$vi(t, i) {
    if (null === t) return null;
    const n = $a1a4d31e28ce1f0d$var$fi(t.Je(), i), s = $a1a4d31e28ce1f0d$var$fi(t.Qe(), i);
    return new $a1a4d31e28ce1f0d$var$mt(n, s);
}
function $a1a4d31e28ce1f0d$var$mi(t) {
    if (null === t) return $a1a4d31e28ce1f0d$var$li;
    const i = Math.abs(t.Qe() - t.Je());
    if (i >= 1 || i < 1e-15) return $a1a4d31e28ce1f0d$var$li;
    const n = Math.ceil(Math.abs(Math.log10(i))), s = $a1a4d31e28ce1f0d$var$li.Al + n;
    return {
        Al: s,
        Ll: 1 / Math.pow(10, s)
    };
}
class $a1a4d31e28ce1f0d$var$wi {
    constructor(t, i){
        if (this.zl = t, this.Ol = i, function(t) {
            if (t < 0) return !1;
            if (t > 1e18) return !0;
            for(let i = t; i > 1; i /= 10)if (i % 10 != 0) return !1;
            return !0;
        }(this.zl)) this.Nl = [
            2,
            2.5,
            2
        ];
        else {
            this.Nl = [];
            for(let t = this.zl; 1 !== t;){
                if (t % 2 == 0) this.Nl.push(2), t /= 2;
                else {
                    if (t % 5 != 0) throw new Error("unexpected base");
                    this.Nl.push(2, 2.5), t /= 5;
                }
                if (this.Nl.length > 100) throw new Error("something wrong with base");
            }
        }
    }
    Fl(t, i, n) {
        const s = 0 === this.zl ? 0 : 1 / this.zl;
        let e = Math.pow(10, Math.max(0, Math.ceil(Math.log10(t - i)))), r = 0, h = this.Ol[0];
        for(;;){
            const t = $a1a4d31e28ce1f0d$var$si(e, s, 1e-14) && e > s + 1e-14, i = $a1a4d31e28ce1f0d$var$si(e, n * h, 1e-14), a = $a1a4d31e28ce1f0d$var$si(e, 1, 1e-14);
            if (!(t && i && a)) break;
            e /= h, h = this.Ol[++r % this.Ol.length];
        }
        if (e <= s + 1e-14 && (e = s), e = Math.max(1, e), this.Nl.length > 0 && (a = e, l = 1, o = 1e-14, Math.abs(a - l) < o)) for(r = 0, h = this.Nl[0]; $a1a4d31e28ce1f0d$var$si(e, n * h, 1e-14) && e > s + 1e-14;)e /= h, h = this.Nl[++r % this.Nl.length];
        var a, l, o;
        return e;
    }
}
class $a1a4d31e28ce1f0d$var$Mi {
    constructor(t, i, n, s){
        this.Wl = [], this.Ki = t, this.zl = i, this.Hl = n, this.Ul = s;
    }
    Fl(t, i) {
        if (t < i) throw new Error("high < low");
        const n = this.Ki.$t(), s = (t - i) * this.$l() / n, e = new $a1a4d31e28ce1f0d$var$wi(this.zl, [
            2,
            2.5,
            2
        ]), r = new $a1a4d31e28ce1f0d$var$wi(this.zl, [
            2,
            2,
            2.5
        ]), h = new $a1a4d31e28ce1f0d$var$wi(this.zl, [
            2.5,
            2,
            2
        ]), a = [];
        return a.push(e.Fl(t, i, s), r.Fl(t, i, s), h.Fl(t, i, s)), function(t) {
            if (t.length < 1) throw Error("array is empty");
            let i = t[0];
            for(let n = 1; n < t.length; ++n)t[n] < i && (i = t[n]);
            return i;
        }(a);
    }
    jl() {
        const t = this.Ki, i = t.Lt();
        if (null === i) return void (this.Wl = []);
        const n = t.$t(), s = this.Hl(n - 1, i), e = this.Hl(0, i), r = this.Ki.N().entireTextOnly ? this.ql() / 2 : 0, h = r, a = n - 1 - r, l = Math.max(s, e), o = Math.min(s, e);
        if (l === o) return void (this.Wl = []);
        const _ = this.Fl(l, o);
        if (this.Yl(i, _, l, o, h, a), t.Kl() && this.Zl(_, o, l)) {
            const t = this.Ki.Gl();
            this.Xl(i, _, h, a, t, 2 * t);
        }
        const u = this.Wl.map((t)=>t.Jl), c = this.Ki.Ql(u);
        for(let t = 0; t < this.Wl.length; t++)this.Wl[t].io = c[t];
    }
    El() {
        return this.Wl;
    }
    ql() {
        return this.Ki.k();
    }
    $l() {
        return Math.ceil(this.ql() * this.Ki.N().tickMarkDensity);
    }
    Yl(t, i, n, s, e, r) {
        const h = this.Wl, a = this.Ki;
        let l = n % i;
        l += l < 0 ? i : 0;
        const o = n >= s ? 1 : -1;
        let _ = null, u = 0;
        for(let c = n - l; c > s; c -= i){
            const n = this.Ul(c, t, !0);
            null !== _ && Math.abs(n - _) < this.$l() || n < e || n > r || (u < h.length ? (h[u].Rl = n, h[u].io = a.no(c), h[u].Jl = c) : h.push({
                Rl: n,
                io: a.no(c),
                Jl: c
            }), u++, _ = n, a.so() && (i = this.Fl(c * o, s)));
        }
        h.length = u;
    }
    Xl(t, i, n, s, e, r) {
        const h = this.Wl, a = this.eo(t, n, e, r), l = this.eo(t, s, -r, -e), o = this.Ul(0, t, !0) - this.Ul(i, t, !0);
        h.length > 0 && h[0].Rl - a.Rl < o / 2 && h.shift(), h.length > 0 && l.Rl - h[h.length - 1].Rl < o / 2 && h.pop(), h.unshift(a), h.push(l);
    }
    eo(t, i, n, s) {
        const e = (n + s) / 2, r = this.Hl(i + n, t), h = this.Hl(i + s, t), a = Math.min(r, h), l = Math.max(r, h), o = Math.max(.1, this.Fl(l, a)), _ = this.Hl(i + e, t), u = _ - _ % o, c = this.Ul(u, t, !0);
        return {
            io: this.Ki.no(u),
            Rl: c,
            Jl: u
        };
    }
    Zl(t, i, n) {
        let s = $a1a4d31e28ce1f0d$var$c(this.Ki.ar());
        return this.Ki.so() && (s = $a1a4d31e28ce1f0d$var$vi(s, this.Ki.ro())), s.Je() - i < t && n - s.Qe() < t;
    }
}
function $a1a4d31e28ce1f0d$var$gi(t) {
    return t.slice().sort((t, i)=>$a1a4d31e28ce1f0d$var$u(t.ln()) - $a1a4d31e28ce1f0d$var$u(i.ln()));
}
var $a1a4d31e28ce1f0d$export$6b4fbb6217f8a7c2;
!function(t) {
    t[t.Normal = 0] = "Normal", t[t.Logarithmic = 1] = "Logarithmic", t[t.Percentage = 2] = "Percentage", t[t.IndexedTo100 = 3] = "IndexedTo100";
}($a1a4d31e28ce1f0d$export$6b4fbb6217f8a7c2 || ($a1a4d31e28ce1f0d$export$6b4fbb6217f8a7c2 = {}));
const $a1a4d31e28ce1f0d$var$Si = new $a1a4d31e28ce1f0d$var$nt, $a1a4d31e28ce1f0d$var$xi = new $a1a4d31e28ce1f0d$var$it(100, 1);
class $a1a4d31e28ce1f0d$var$Ci {
    constructor(t, i, n, s, e){
        this.ho = 0, this.ao = null, this.rr = null, this.lo = null, this.oo = {
            _o: !1,
            uo: null
        }, this.co = !1, this.do = 0, this.fo = 0, this.po = new $a1a4d31e28ce1f0d$var$d, this.vo = new $a1a4d31e28ce1f0d$var$d, this.mo = [], this.wo = null, this.Mo = null, this.bo = null, this.So = null, this.xo = null, this.il = $a1a4d31e28ce1f0d$var$xi, this.Co = $a1a4d31e28ce1f0d$var$mi(null), this.yo = t, this.yn = i, this.ko = n, this.Po = s, this.To = e, this.Ro = new $a1a4d31e28ce1f0d$var$Mi(this, 100, this.Do.bind(this), this.Io.bind(this));
    }
    cl() {
        return this.yo;
    }
    N() {
        return this.yn;
    }
    vr(t) {
        if ($a1a4d31e28ce1f0d$var$f(this.yn, t), this.dl(), void 0 !== t.mode && this.Vo({
            _e: t.mode
        }), void 0 !== t.scaleMargins) {
            const i = $a1a4d31e28ce1f0d$var$_(t.scaleMargins.top), n = $a1a4d31e28ce1f0d$var$_(t.scaleMargins.bottom);
            if (i < 0 || i > 1) throw new Error(`Invalid top margin - expect value between 0 and 1, given=${i}`);
            if (n < 0 || n > 1) throw new Error(`Invalid bottom margin - expect value between 0 and 1, given=${n}`);
            if (i + n > 1) throw new Error(`Invalid margins - sum of margins must be less than 1, given=${i + n}`);
            this.Bo(), this.bo = null;
        }
    }
    Eo() {
        return this.yn.autoScale;
    }
    Ao() {
        return this.co;
    }
    so() {
        return 1 === this.yn.mode;
    }
    je() {
        return 2 === this.yn.mode;
    }
    Lo() {
        return 3 === this.yn.mode;
    }
    ro() {
        return this.Co;
    }
    _e() {
        return {
            hs: this.yn.autoScale,
            zo: this.yn.invertScale,
            _e: this.yn.mode
        };
    }
    Vo(t) {
        const i = this._e();
        let n = null;
        void 0 !== t.hs && (this.yn.autoScale = t.hs), void 0 !== t._e && (this.yn.mode = t._e, 2 !== t._e && 3 !== t._e || (this.yn.autoScale = !0), this.oo._o = !1), 1 === i._e && t._e !== i._e && (!function(t, i) {
            if (null === t) return !1;
            const n = $a1a4d31e28ce1f0d$var$fi(t.Je(), i), s = $a1a4d31e28ce1f0d$var$fi(t.Qe(), i);
            return isFinite(n) && isFinite(s);
        }(this.rr, this.Co) ? this.yn.autoScale = !0 : (n = $a1a4d31e28ce1f0d$var$vi(this.rr, this.Co), null !== n && this.Oo(n))), 1 === t._e && t._e !== i._e && (n = $a1a4d31e28ce1f0d$var$pi(this.rr, this.Co), null !== n && this.Oo(n));
        const s = i._e !== this.yn.mode;
        s && (2 === i._e || this.je()) && this.dl(), s && (3 === i._e || this.Lo()) && this.dl(), void 0 !== t.zo && i.zo !== t.zo && (this.yn.invertScale = t.zo, this.No()), this.vo.p(i, this._e());
    }
    Fo() {
        return this.vo;
    }
    k() {
        return this.ko.fontSize;
    }
    $t() {
        return this.ho;
    }
    Wo(t) {
        this.ho !== t && (this.ho = t, this.Bo(), this.bo = null);
    }
    Ho() {
        if (this.ao) return this.ao;
        const t = this.$t() - this.Uo() - this.$o();
        return this.ao = t, t;
    }
    ar() {
        return this.jo(), this.rr;
    }
    Oo(t, i) {
        const n = this.rr;
        (i || null === n && null !== t || null !== n && !n.Ge(t)) && (this.bo = null, this.rr = t);
    }
    qo(t) {
        this.Oo(t), this.Yo(null !== t);
    }
    Gi() {
        return this.jo(), 0 === this.ho || !this.rr || this.rr.Gi();
    }
    Ko(t) {
        return this.zo() ? t : this.$t() - 1 - t;
    }
    Nt(t, i) {
        return this.je() ? t = $a1a4d31e28ce1f0d$var$oi(t, i) : this.Lo() && (t = $a1a4d31e28ce1f0d$var$ui(t, i)), this.Io(t, i);
    }
    Zo(t, i, n) {
        this.jo();
        const s = this.$o(), e = $a1a4d31e28ce1f0d$var$u(this.ar()), r = e.Je(), h = e.Qe(), a = this.Ho() - 1, l = this.zo(), o = a / (h - r), _ = void 0 === n ? 0 : n.from, c = void 0 === n ? t.length : n.to, d = this.Go();
        for(let n = _; n < c; n++){
            const e = t[n], h = e.Mt;
            if (isNaN(h)) continue;
            let a = h;
            null !== d && (a = d(e.Mt, i));
            const _ = s + o * (a - r), u = l ? _ : this.ho - 1 - _;
            e.ut = u;
        }
    }
    Xo(t, i, n) {
        this.jo();
        const s = this.$o(), e = $a1a4d31e28ce1f0d$var$u(this.ar()), r = e.Je(), h = e.Qe(), a = this.Ho() - 1, l = this.zo(), o = a / (h - r), _ = void 0 === n ? 0 : n.from, c = void 0 === n ? t.length : n.to, d = this.Go();
        for(let n = _; n < c; n++){
            const e = t[n];
            let h = e.jr, a = e.qr, _ = e.Yr, u = e.Kr;
            null !== d && (h = d(e.jr, i), a = d(e.qr, i), _ = d(e.Yr, i), u = d(e.Kr, i));
            let c = s + o * (h - r), f = l ? c : this.ho - 1 - c;
            e.Jo = f, c = s + o * (a - r), f = l ? c : this.ho - 1 - c, e.Qo = f, c = s + o * (_ - r), f = l ? c : this.ho - 1 - c, e.t_ = f, c = s + o * (u - r), f = l ? c : this.ho - 1 - c, e.i_ = f;
        }
    }
    Tn(t, i) {
        const n = this.Do(t, i);
        return this.n_(n, i);
    }
    n_(t, i) {
        let n = t;
        return this.je() ? n = function(t, i) {
            return i < 0 && (t = -t), t / 100 * i + i;
        }(n, i) : this.Lo() && (n = function(t, i) {
            return t -= 100, i < 0 && (t = -t), t / 100 * i + i;
        }(n, i)), n;
    }
    Cl() {
        return this.mo;
    }
    Dt() {
        return this.Mo || (this.Mo = $a1a4d31e28ce1f0d$var$gi(this.mo)), this.Mo;
    }
    s_(t) {
        -1 === this.mo.indexOf(t) && (this.mo.push(t), this.dl(), this.e_());
    }
    r_(t) {
        const i = this.mo.indexOf(t);
        if (-1 === i) throw new Error("source is not attached to scale");
        this.mo.splice(i, 1), 0 === this.mo.length && (this.Vo({
            hs: !0
        }), this.Oo(null)), this.dl(), this.e_();
    }
    Lt() {
        let t = null;
        for (const i of this.mo){
            const n = i.Lt();
            null !== n && (null === t || n.za < t.za) && (t = n);
        }
        return null === t ? null : t.Wt;
    }
    zo() {
        return this.yn.invertScale;
    }
    El() {
        const t = null === this.Lt();
        if (null !== this.bo && (t || this.bo.h_ === t)) return this.bo.El;
        this.Ro.jl();
        const i = this.Ro.El();
        return this.bo = {
            El: i,
            h_: t
        }, this.po.p(), i;
    }
    a_() {
        return this.po;
    }
    l_(t) {
        this.je() || this.Lo() || null === this.So && null === this.lo && (this.Gi() || (this.So = this.ho - t, this.lo = $a1a4d31e28ce1f0d$var$u(this.ar()).Xe()));
    }
    o_(t) {
        if (this.je() || this.Lo()) return;
        if (null === this.So) return;
        this.Vo({
            hs: !1
        }), (t = this.ho - t) < 0 && (t = 0);
        let i = (this.So + .2 * (this.ho - 1)) / (t + .2 * (this.ho - 1));
        const n = $a1a4d31e28ce1f0d$var$u(this.lo).Xe();
        i = Math.max(i, .1), n.ir(i), this.Oo(n);
    }
    __() {
        this.je() || this.Lo() || (this.So = null, this.lo = null);
    }
    u_(t) {
        this.Eo() || null === this.xo && null === this.lo && (this.Gi() || (this.xo = t, this.lo = $a1a4d31e28ce1f0d$var$u(this.ar()).Xe()));
    }
    c_(t) {
        if (this.Eo()) return;
        if (null === this.xo) return;
        const i = $a1a4d31e28ce1f0d$var$u(this.ar()).tr() / (this.Ho() - 1);
        let n = t - this.xo;
        this.zo() && (n *= -1);
        const s = n * i, e = $a1a4d31e28ce1f0d$var$u(this.lo).Xe();
        e.nr(s), this.Oo(e, !0), this.bo = null;
    }
    d_() {
        this.Eo() || null !== this.xo && (this.xo = null, this.lo = null);
    }
    tl() {
        return this.il || this.dl(), this.il;
    }
    Ji(t, i) {
        switch(this.yn.mode){
            case 2:
                return this.f_($a1a4d31e28ce1f0d$var$oi(t, i));
            case 3:
                return this.tl().format($a1a4d31e28ce1f0d$var$ui(t, i));
            default:
                return this.cr(t);
        }
    }
    no(t) {
        switch(this.yn.mode){
            case 2:
                return this.f_(t);
            case 3:
                return this.tl().format(t);
            default:
                return this.cr(t);
        }
    }
    Ql(t) {
        switch(this.yn.mode){
            case 2:
                return this.p_(t);
            case 3:
                return this.tl().formatTickmarks(t);
            default:
                return this.v_(t);
        }
    }
    xa(t) {
        return this.cr(t, $a1a4d31e28ce1f0d$var$u(this.wo).tl());
    }
    Ca(t, i) {
        return t = $a1a4d31e28ce1f0d$var$oi(t, i), this.f_(t, $a1a4d31e28ce1f0d$var$Si);
    }
    m_() {
        return this.mo;
    }
    w_(t) {
        this.oo = {
            uo: t,
            _o: !1
        };
    }
    Nn() {
        this.mo.forEach((t)=>t.Nn());
    }
    Kl() {
        return this.yn.ensureEdgeTickMarksVisible && this.Eo();
    }
    Gl() {
        return this.k() / 2;
    }
    dl() {
        this.bo = null;
        let t = 1 / 0;
        this.wo = null;
        for (const i of this.mo)i.ln() < t && (t = i.ln(), this.wo = i);
        let i = 100;
        null !== this.wo && (i = Math.round(this.wo.Kh())), this.il = $a1a4d31e28ce1f0d$var$xi, this.je() ? (this.il = $a1a4d31e28ce1f0d$var$Si, i = 100) : this.Lo() ? (this.il = new $a1a4d31e28ce1f0d$var$it(100, 1), i = 100) : null !== this.wo && (this.il = this.wo.tl()), this.Ro = new $a1a4d31e28ce1f0d$var$Mi(this, i, this.Do.bind(this), this.Io.bind(this)), this.Ro.jl();
    }
    e_() {
        this.Mo = null;
    }
    M_() {
        return null === this.wo || this.je() || this.Lo() ? 1 : 1 / this.wo.Kh();
    }
    Xi() {
        return this.To;
    }
    Yo(t) {
        this.co = t;
    }
    Uo() {
        return this.zo() ? this.yn.scaleMargins.bottom * this.$t() + this.fo : this.yn.scaleMargins.top * this.$t() + this.do;
    }
    $o() {
        return this.zo() ? this.yn.scaleMargins.top * this.$t() + this.do : this.yn.scaleMargins.bottom * this.$t() + this.fo;
    }
    jo() {
        this.oo._o || (this.oo._o = !0, this.g_());
    }
    Bo() {
        this.ao = null;
    }
    Io(t, i) {
        if (this.jo(), this.Gi()) return 0;
        t = this.so() && t ? $a1a4d31e28ce1f0d$var$di(t, this.Co) : t;
        const n = $a1a4d31e28ce1f0d$var$u(this.ar()), s = this.$o() + (this.Ho() - 1) * (t - n.Je()) / n.tr();
        return this.Ko(s);
    }
    Do(t, i) {
        if (this.jo(), this.Gi()) return 0;
        const n = this.Ko(t), s = $a1a4d31e28ce1f0d$var$u(this.ar()), e = s.Je() + s.tr() * ((n - this.$o()) / (this.Ho() - 1));
        return this.so() ? $a1a4d31e28ce1f0d$var$fi(e, this.Co) : e;
    }
    No() {
        this.bo = null, this.Ro.jl();
    }
    g_() {
        if (this.Ao() && !this.Eo()) return;
        const t = this.oo.uo;
        if (null === t) return;
        let i = null;
        const n = this.m_();
        let s = 0, e = 0;
        for (const r of n){
            if (!r.It()) continue;
            const n = r.Lt();
            if (null === n) continue;
            const h = r.la(t.Oa(), t.bi());
            let a = h && h.ar();
            if (null !== a) {
                switch(this.yn.mode){
                    case 1:
                        a = $a1a4d31e28ce1f0d$var$pi(a, this.Co);
                        break;
                    case 2:
                        a = $a1a4d31e28ce1f0d$var$_i(a, n.Wt);
                        break;
                    case 3:
                        a = $a1a4d31e28ce1f0d$var$ci(a, n.Wt);
                }
                if (i = null === i ? a : i.Ss($a1a4d31e28ce1f0d$var$u(a)), null !== h) {
                    const t = h.lr();
                    null !== t && (s = Math.max(s, t.above), e = Math.max(e, t.below));
                }
            }
        }
        if (this.Kl() && (s = Math.max(s, this.Gl()), e = Math.max(e, this.Gl())), s === this.do && e === this.fo || (this.do = s, this.fo = e, this.bo = null, this.Bo()), null !== i) {
            if (i.Je() === i.Qe()) {
                const t = 5 * this.M_();
                this.so() && (i = $a1a4d31e28ce1f0d$var$vi(i, this.Co)), i = new $a1a4d31e28ce1f0d$var$mt(i.Je() - t, i.Qe() + t), this.so() && (i = $a1a4d31e28ce1f0d$var$pi(i, this.Co));
            }
            if (this.so()) {
                const t = $a1a4d31e28ce1f0d$var$vi(i, this.Co), n = $a1a4d31e28ce1f0d$var$mi(t);
                if (r = n, h = this.Co, r.Al !== h.Al || r.Ll !== h.Ll) {
                    const s = null !== this.lo ? $a1a4d31e28ce1f0d$var$vi(this.lo, this.Co) : null;
                    this.Co = n, i = $a1a4d31e28ce1f0d$var$pi(t, n), null !== s && (this.lo = $a1a4d31e28ce1f0d$var$pi(s, n));
                }
            }
            this.Oo(i);
        } else null === this.rr && (this.Oo(new $a1a4d31e28ce1f0d$var$mt(-0.5, .5)), this.Co = $a1a4d31e28ce1f0d$var$mi(null));
        var r, h;
    }
    Go() {
        return this.je() ? $a1a4d31e28ce1f0d$var$oi : this.Lo() ? $a1a4d31e28ce1f0d$var$ui : this.so() ? (t)=>$a1a4d31e28ce1f0d$var$di(t, this.Co) : null;
    }
    b_(t, i, n) {
        return void 0 === i ? (void 0 === n && (n = this.tl()), n.format(t)) : i(t);
    }
    S_(t, i, n) {
        return void 0 === i ? (void 0 === n && (n = this.tl()), n.formatTickmarks(t)) : i(t);
    }
    cr(t, i) {
        return this.b_(t, this.Po.priceFormatter, i);
    }
    v_(t, i) {
        const n = this.Po.priceFormatter;
        return this.S_(t, this.Po.tickmarksPriceFormatter ?? (n ? (t)=>t.map(n) : void 0), i);
    }
    f_(t, i) {
        return this.b_(t, this.Po.percentageFormatter, i);
    }
    p_(t, i) {
        const n = this.Po.percentageFormatter;
        return this.S_(t, this.Po.tickmarksPercentageFormatter ?? (n ? (t)=>t.map(n) : void 0), i);
    }
}
function $a1a4d31e28ce1f0d$var$yi(t) {
    return t instanceof $a1a4d31e28ce1f0d$var$Jt;
}
class $a1a4d31e28ce1f0d$var$ki {
    constructor(t, i){
        this.mo = [], this.x_ = new Map, this.ho = 0, this.C_ = 0, this.y_ = 1, this.Mo = null, this.k_ = null, this.P_ = !1, this.T_ = new $a1a4d31e28ce1f0d$var$d, this.fa = [], this.ia = t, this.sn = i, this.R_ = new $a1a4d31e28ce1f0d$var$ai(this);
        const n = i.N();
        this.D_ = this.I_("left", n.leftPriceScale), this.V_ = this.I_("right", n.rightPriceScale), this.D_.Fo().i(this.B_.bind(this, this.D_), this), this.V_.Fo().i(this.B_.bind(this, this.V_), this), this.E_(n);
    }
    E_(t) {
        if (t.leftPriceScale && this.D_.vr(t.leftPriceScale), t.rightPriceScale && this.V_.vr(t.rightPriceScale), t.localization && (this.D_.dl(), this.V_.dl()), t.overlayPriceScales) {
            const i = Array.from(this.x_.values());
            for (const n of i){
                const i = $a1a4d31e28ce1f0d$var$u(n[0].Ft());
                i.vr(t.overlayPriceScales), t.localization && i.dl();
            }
        }
    }
    A_(t) {
        switch(t){
            case "left":
                return this.D_;
            case "right":
                return this.V_;
        }
        return this.x_.has(t) ? $a1a4d31e28ce1f0d$var$_(this.x_.get(t))[0].Ft() : null;
    }
    m() {
        this.Qt().L_().u(this), this.D_.Fo().u(this), this.V_.Fo().u(this), this.mo.forEach((t)=>{
            t.m && t.m();
        }), this.fa = this.fa.filter((t)=>{
            const i = t.Qh();
            return i.detached && i.detached(), !1;
        }), this.T_.p();
    }
    z_() {
        return this.y_;
    }
    O_(t) {
        this.y_ = t;
    }
    Qt() {
        return this.sn;
    }
    nn() {
        return this.C_;
    }
    $t() {
        return this.ho;
    }
    N_(t) {
        this.C_ = t, this.F_();
    }
    Wo(t) {
        this.ho = t, this.D_.Wo(t), this.V_.Wo(t), this.mo.forEach((i)=>{
            if (this.Zs(i)) {
                const n = i.Ft();
                null !== n && n.Wo(t);
            }
        }), this.F_();
    }
    W_(t) {
        this.P_ = t;
    }
    H_() {
        return this.P_;
    }
    U_() {
        return this.mo.filter($a1a4d31e28ce1f0d$var$yi);
    }
    Cl() {
        return this.mo;
    }
    Zs(t) {
        const i = t.Ft();
        return null === i || this.D_ !== i && this.V_ !== i;
    }
    s_(t, i, n) {
        this.j_(t, i, n ? t.ln() : this.mo.length);
    }
    r_(t, i) {
        const n = this.mo.indexOf(t);
        $a1a4d31e28ce1f0d$var$o(-1 !== n, "removeDataSource: invalid data source"), this.mo.splice(n, 1), i || this.mo.forEach((t, i)=>t._n(i));
        const s = $a1a4d31e28ce1f0d$var$u(t.Ft()).cl();
        if (this.x_.has(s)) {
            const i = $a1a4d31e28ce1f0d$var$_(this.x_.get(s)), n = i.indexOf(t);
            -1 !== n && (i.splice(n, 1), 0 === i.length && this.x_.delete(s));
        }
        const e = t.Ft();
        e && e.Cl().indexOf(t) >= 0 && (e.r_(t), this.q_(e)), this.Y_();
    }
    Xs(t) {
        return t === this.D_ ? "left" : t === this.V_ ? "right" : "overlay";
    }
    K_() {
        return this.D_;
    }
    Z_() {
        return this.V_;
    }
    G_(t, i) {
        t.l_(i);
    }
    X_(t, i) {
        t.o_(i), this.F_();
    }
    J_(t) {
        t.__();
    }
    Q_(t, i) {
        t.u_(i);
    }
    tu(t, i) {
        t.c_(i), this.F_();
    }
    iu(t) {
        t.d_();
    }
    F_() {
        this.mo.forEach((t)=>{
            t.Nn();
        });
    }
    Pn() {
        const [t, i] = this.nu();
        let n = null;
        return t.N().visible && 0 !== t.Cl().length ? n = t : i.N().visible && 0 !== i.Cl().length ? n = i : 0 !== this.mo.length && (n = this.mo[0].Ft()), null === n && (n = this.Gs() ?? t), n;
    }
    Gs() {
        const [t, i] = this.nu();
        return t.N().visible ? t : i.N().visible ? i : null;
    }
    q_(t) {
        null !== t && t.Eo() && this.su(t);
    }
    eu(t) {
        const i = this.ia.Ee();
        t.Vo({
            hs: !0
        }), null !== i && t.w_(i), this.F_();
    }
    ru() {
        this.su(this.D_), this.su(this.V_);
    }
    hu() {
        this.q_(this.D_), this.q_(this.V_), this.mo.forEach((t)=>{
            this.Zs(t) && this.q_(t.Ft());
        }), this.F_(), this.sn.mr();
    }
    Dt() {
        return null === this.Mo && (this.Mo = $a1a4d31e28ce1f0d$var$gi(this.mo)), this.Mo;
    }
    au() {
        const t = this.Dt(), i = this.sn.ou()?.lu, n = this.sn.N().hoveredSeriesOnTop, s = this.k_;
        if (null !== s && s.Kh === t && s._u === i && s.uu === n) return s.cu;
        const e = function(t, i, n) {
            if (!n) return t;
            const s = t.indexOf(i);
            if (-1 === s || s === t.length - 1) return t;
            const e = [];
            for(let i = 0; i < t.length; i++)i !== s && e.push(t[i]);
            return e.push(t[s]), e;
        }(t, i, n);
        return this.k_ = {
            Kh: t,
            _u: i,
            uu: n,
            cu: e
        }, e;
    }
    du(t, i) {
        i = $a1a4d31e28ce1f0d$var$ni(i, 0, this.mo.length - 1);
        const n = this.mo.indexOf(t);
        $a1a4d31e28ce1f0d$var$o(-1 !== n, "setSeriesOrder: invalid data source"), this.mo.splice(n, 1), this.mo.splice(i, 0, t), this.mo.forEach((t, i)=>t._n(i)), this.Y_();
        for (const t of [
            this.D_,
            this.V_
        ])t.e_(), t.dl();
        this.sn.mr();
    }
    Vt() {
        return this.Dt().filter($a1a4d31e28ce1f0d$var$yi);
    }
    fu() {
        return this.T_;
    }
    pu() {
        return this.R_;
    }
    hl(t) {
        this.fa.push(new $a1a4d31e28ce1f0d$var$Ft(t));
    }
    al(t) {
        this.fa = this.fa.filter((i)=>i.Qh() !== t), t.detached && t.detached(), this.sn.mr();
    }
    vu() {
        return this.fa;
    }
    Ja(t, i) {
        return this.fa.map((n)=>n.Qs(t, i)).filter((t)=>null !== t);
    }
    su(t) {
        const i = t.m_();
        if (i && i.length > 0 && !this.ia.Gi()) {
            const i = this.ia.Ee();
            null !== i && t.w_(i);
        }
        t.Nn();
    }
    j_(t, i, n) {
        let s = this.A_(i);
        if (null === s && (s = this.I_(i, this.sn.N().overlayPriceScales)), this.mo.splice(n, 0, t), !$a1a4d31e28ce1f0d$var$G(i)) {
            const n = this.x_.get(i) || [];
            n.push(t), this.x_.set(i, n);
        }
        t._n(n), s.s_(t), t.un(s), this.q_(s), this.Y_();
    }
    Y_() {
        this.Mo = null, this.k_ = null;
    }
    nu() {
        return "left" === this.sn.N().defaultVisiblePriceScaleId ? [
            this.D_,
            this.V_
        ] : [
            this.V_,
            this.D_
        ];
    }
    B_(t, i, n) {
        i._e !== n._e && this.su(t);
    }
    I_(t, i) {
        const n = {
            visible: !0,
            autoScale: !0,
            ...$a1a4d31e28ce1f0d$var$M(i)
        }, s = new $a1a4d31e28ce1f0d$var$Ci(t, n, this.sn.N().layout, this.sn.N().localization, this.sn.Xi());
        return s.Wo(this.$t()), s;
    }
}
function $a1a4d31e28ce1f0d$var$Pi(t, i) {
    return null === i || 2 === t.se && 2 !== i.se || (2 !== i.se || 2 === t.se) && t.ne !== i.ne && t.ne < i.ne;
}
function $a1a4d31e28ce1f0d$var$Ti(t) {
    return {
        te: t.te,
        ie: t.ie
    };
}
function $a1a4d31e28ce1f0d$var$Ri(t) {
    return {
        ne: t.distance ?? 0,
        se: t.hitTestPriority ?? ("marker" === t.itemType ? 2 : 0),
        ee: t.itemType ?? "primitive",
        mu: t.cursorStyle,
        te: t.externalId
    };
}
function $a1a4d31e28ce1f0d$var$Di(t) {
    return {
        lu: t.lu,
        wu: $a1a4d31e28ce1f0d$var$Ti(t.Mu),
        mu: t.Mu.mu,
        ee: t.Mu.ee ?? "primitive"
    };
}
function $a1a4d31e28ce1f0d$var$Ii(t, i, n, s) {
    let e = null;
    for (const r of t){
        let t = r.Qs?.(i, n, s) ?? null;
        if (null === t) {
            const e = r.Tt(s);
            t = null !== e && e.Qs ? e.Qs(i, n) : null;
        }
        if (null !== t) {
            const i = {
                gu: r,
                Mu: t
            };
            (null === e || $a1a4d31e28ce1f0d$var$Pi(i.Mu, e.Mu)) && (e = i);
        }
    }
    return e;
}
function $a1a4d31e28ce1f0d$var$Vi(t) {
    return void 0 !== t.jn;
}
function $a1a4d31e28ce1f0d$var$Bi(t, i, n) {
    const s = [
        t,
        ...t.Dt()
    ].reverse(), e = function(t, i, n) {
        let s, e, r;
        for (const l of t){
            const t = l.Ja?.(i, n) ?? [];
            for (const i of t){
                const t = $a1a4d31e28ce1f0d$var$Ri(i);
                h = i.zOrder, a = s?.zOrder, (!a || "top" === h && "top" !== a || "normal" === h && "bottom" === a || i.zOrder === s?.zOrder && void 0 !== e && $a1a4d31e28ce1f0d$var$Pi(t, e) || i.zOrder === s?.zOrder && void 0 === e) && (s = i, e = t, r = l);
            }
        }
        var h, a;
        return s && r && e ? {
            Mu: e,
            bu: s,
            lu: r
        } : null;
    }(s, i, n);
    if ("top" === e?.bu.zOrder) return $a1a4d31e28ce1f0d$var$Di(e);
    let r = null, h = null;
    for (const a of s){
        if (e && e.lu === a && "bottom" !== e.bu.zOrder && !e.bu.isBackground) return r ?? $a1a4d31e28ce1f0d$var$Di(e);
        if ($a1a4d31e28ce1f0d$var$Vi(a)) {
            const s = $a1a4d31e28ce1f0d$var$Ii(a.jn(t), i, n, t);
            if (null !== s) {
                const t = {
                    lu: a,
                    gu: s.gu,
                    wu: $a1a4d31e28ce1f0d$var$Ti(s.Mu),
                    mu: s.Mu.mu,
                    ee: s.Mu.ee ?? "primitive"
                };
                (null === r || $a1a4d31e28ce1f0d$var$Pi(s.Mu, h)) && (r = t, h = s.Mu);
            }
        }
        if (e && e.lu === a && "bottom" !== e.bu.zOrder && e.bu.isBackground) return r ?? $a1a4d31e28ce1f0d$var$Di(e);
    }
    return null !== r ? r : e?.bu ? $a1a4d31e28ce1f0d$var$Di(e) : null;
}
class $a1a4d31e28ce1f0d$var$Ei {
    constructor(t, i, n = 50){
        this.Vs = 0, this.Bs = 1, this.Es = 1, this.Ls = new Map, this.As = new Map, this.Su = t, this.xu = i, this.zs = n;
    }
    Cu(t) {
        const i = t.time, n = this.xu.cacheKey(i), s = this.Ls.get(n);
        if (void 0 !== s) return s.yu;
        if (this.Vs === this.zs) {
            const t = this.As.get(this.Es);
            this.As.delete(this.Es), this.Ls.delete($a1a4d31e28ce1f0d$var$_(t)), this.Es++, this.Vs--;
        }
        const e = this.Su(t);
        return this.Ls.set(n, {
            yu: e,
            Ws: this.Bs
        }), this.As.set(this.Bs, n), this.Vs++, this.Bs++, e;
    }
}
class $a1a4d31e28ce1f0d$var$Ai {
    constructor(t, i){
        $a1a4d31e28ce1f0d$var$o(t <= i, "right should be >= left"), this.ku = t, this.Pu = i;
    }
    Oa() {
        return this.ku;
    }
    bi() {
        return this.Pu;
    }
    Tu() {
        return this.Pu - this.ku + 1;
    }
    ze(t) {
        return this.ku <= t && t <= this.Pu;
    }
    Ge(t) {
        return this.ku === t.Oa() && this.Pu === t.bi();
    }
}
function $a1a4d31e28ce1f0d$var$Li(t, i) {
    return null === t || null === i ? t === i : t.Ge(i);
}
class $a1a4d31e28ce1f0d$var$zi {
    constructor(){
        this.Ru = new Map, this.Ls = null, this.Du = !1;
    }
    Iu(t) {
        this.Du = t, this.Ls = null;
    }
    Vu(t, i) {
        this.Bu(i), this.Ls = null;
        for(let n = i; n < t.length; ++n){
            const i = t[n];
            let s = this.Ru.get(i.timeWeight);
            void 0 === s && (s = [], this.Ru.set(i.timeWeight, s)), s.push({
                index: n,
                time: i.time,
                weight: i.timeWeight,
                originalTime: i.originalTime
            });
        }
    }
    Eu(t, i, n, s, e) {
        const r = Math.ceil(i / t);
        return null !== this.Ls && this.Ls.Au === r && e === this.Ls.Lu && n === this.Ls.zu || (this.Ls = {
            Lu: e,
            zu: n,
            El: this.Ou(r, n, s),
            Au: r
        }), this.Ls.El;
    }
    Bu(t) {
        if (0 === t) return void this.Ru.clear();
        const i = [];
        this.Ru.forEach((n, s)=>{
            t <= n[0].index ? i.push(s) : n.splice($a1a4d31e28ce1f0d$var$Rt(n, t, (i)=>i.index < t), 1 / 0);
        });
        for (const t of i)this.Ru.delete(t);
    }
    Ou(t, i, n) {
        let s = [];
        const e = (t)=>!i || n.has(t.index);
        for (const i of Array.from(this.Ru.keys()).sort((t, i)=>i - t)){
            if (!this.Ru.get(i)) continue;
            const n = s;
            s = [];
            const r = n.length;
            let h = 0;
            const a = $a1a4d31e28ce1f0d$var$_(this.Ru.get(i)), l = a.length;
            let o = 1 / 0, u = -1 / 0;
            for(let i = 0; i < l; i++){
                const l = a[i], _ = l.index;
                for(; h < r;){
                    const t = n[h], i = t.index;
                    if (!(i < _ && e(t))) {
                        o = i;
                        break;
                    }
                    h++, s.push(t), u = i, o = 1 / 0;
                }
                if (o - _ >= t && _ - u >= t && e(l)) s.push(l), u = _;
                else if (this.Du) return n;
            }
            for(; h < r; h++)e(n[h]) && s.push(n[h]);
        }
        return s;
    }
}
class $a1a4d31e28ce1f0d$var$Oi {
    constructor(t){
        this.Nu = t;
    }
    Fu() {
        return null === this.Nu ? null : new $a1a4d31e28ce1f0d$var$Ai(Math.floor(this.Nu.Oa()), Math.ceil(this.Nu.bi()));
    }
    Wu() {
        return this.Nu;
    }
    static Hu() {
        return new $a1a4d31e28ce1f0d$var$Oi(null);
    }
}
function $a1a4d31e28ce1f0d$var$Ni(t, i) {
    return t.weight > i.weight ? t : i;
}
class $a1a4d31e28ce1f0d$var$Fi {
    constructor(t, i, n, s){
        this.C_ = 0, this.Uu = null, this.$u = [], this.xo = null, this.So = null, this.ju = new $a1a4d31e28ce1f0d$var$zi, this.qu = new Map, this.Yu = $a1a4d31e28ce1f0d$var$Oi.Hu(), this.Ku = !0, this.Zu = new $a1a4d31e28ce1f0d$var$d, this.Gu = new $a1a4d31e28ce1f0d$var$d, this.Xu = new $a1a4d31e28ce1f0d$var$d, this.Ju = null, this.Qu = null, this.tc = new Map, this.nc = -1, this.sc = [], this.ec = 1, this.yn = i, this.Po = n, this.rc = i.rightOffset, this.hc = i.barSpacing, this.sn = t, this.ac(i), this.xu = s, this.lc(), this.ju.Iu(i.uniformDistribution), this.oc(), this._c();
    }
    N() {
        return this.yn;
    }
    uc(t) {
        $a1a4d31e28ce1f0d$var$f(this.Po, t), this.cc(), this.lc();
    }
    vr(t, i) {
        $a1a4d31e28ce1f0d$var$f(this.yn, t), this.yn.fixLeftEdge && this.dc(), this.yn.fixRightEdge && this.fc(), void 0 !== t.barSpacing && this.sn.Ms(t.barSpacing), void 0 !== t.rightOffset && this.sn.gs(t.rightOffset), this.ac(t), void 0 === t.minBarSpacing && void 0 === t.maxBarSpacing || this.sn.Ms(t.barSpacing ?? this.hc), void 0 !== t.ignoreWhitespaceIndices && t.ignoreWhitespaceIndices !== this.yn.ignoreWhitespaceIndices && this._c(), this.cc(), this.lc(), void 0 === t.enableConflation && void 0 === t.conflationThresholdFactor || this.oc(), this.Xu.p();
    }
    Rn(t) {
        return this.$u[t]?.time ?? null;
    }
    en(t) {
        return this.$u[t] ?? null;
    }
    vc(t, i) {
        if (this.$u.length < 1) return null;
        if (this.xu.key(t) > this.xu.key(this.$u[this.$u.length - 1].time)) return i ? this.$u.length - 1 : null;
        const n = $a1a4d31e28ce1f0d$var$Rt(this.$u, this.xu.key(t), (t, i)=>this.xu.key(t.time) < i);
        return this.xu.key(t) < this.xu.key(this.$u[n].time) ? i ? n : null : n;
    }
    Gi() {
        return 0 === this.C_ || 0 === this.$u.length || null === this.Uu;
    }
    mc() {
        return this.$u.length > 0;
    }
    Ee() {
        return this.wc(), this.Yu.Fu();
    }
    Mc() {
        return this.wc(), this.Yu.Wu();
    }
    gc() {
        const t = this.Ee();
        if (null === t) return null;
        const i = {
            from: t.Oa(),
            to: t.bi()
        };
        return this.bc(i);
    }
    bc(t) {
        const i = Math.round(t.from), n = Math.round(t.to), s = $a1a4d31e28ce1f0d$var$u(this.Sc()), e = $a1a4d31e28ce1f0d$var$u(this.xc());
        return {
            from: $a1a4d31e28ce1f0d$var$u(this.en(Math.max(s, i))),
            to: $a1a4d31e28ce1f0d$var$u(this.en(Math.min(e, n)))
        };
    }
    Cc(t) {
        return {
            from: $a1a4d31e28ce1f0d$var$u(this.vc(t.from, !0)),
            to: $a1a4d31e28ce1f0d$var$u(this.vc(t.to, !0))
        };
    }
    nn() {
        return this.C_;
    }
    N_(t) {
        if (!isFinite(t) || t <= 0) return;
        if (this.C_ === t) return;
        const i = this.Mc(), n = this.C_;
        if (this.C_ = t, this.Ku = !0, this.yn.lockVisibleTimeRangeOnResize && 0 !== n) {
            const i = this.hc * t / n;
            this.hc = i;
        }
        if (this.yn.fixLeftEdge && null !== i && i.Oa() <= 0) {
            const i = n - t;
            this.rc -= Math.round(i / this.hc) + 1, this.Ku = !0;
        }
        this.yc(), this.kc();
    }
    jt(t) {
        if (this.Gi() || !$a1a4d31e28ce1f0d$var$v(t)) return 0;
        const i = this.Pc() + this.rc - t;
        return this.C_ - (i + .5) * this.hc - 1;
    }
    Tc(t, i) {
        const n = this.Pc(), s = void 0 === i ? 0 : i.from, e = void 0 === i ? t.length : i.to;
        for(let i = s; i < e; i++){
            const s = t[i].wt, e = n + this.rc - s, r = this.C_ - (e + .5) * this.hc - 1;
            t[i]._t = r;
        }
    }
    Rc(t, i) {
        const n = Math.ceil(this.Dc(t));
        return i && this.yn.ignoreWhitespaceIndices && !this.Ic(n) ? this.Vc(n) : n;
    }
    gs(t) {
        this.Ku = !0, this.rc = t, this.kc(), this.sn.Bc(), this.sn.mr();
    }
    fl() {
        return this.hc;
    }
    Ms(t) {
        const i = this.hc;
        if (this.Ec(t), void 0 !== this.yn.rightOffsetPixels && 0 !== i) {
            const t = this.rc * i / this.hc;
            this.rc = t;
        }
        this.kc(), this.sn.Bc(), this.sn.mr();
    }
    Ac() {
        return this.rc;
    }
    El() {
        if (this.Gi()) return null;
        if (null !== this.Qu) return this.Qu;
        const t = this.hc, i = 5 * (this.sn.N().layout.fontSize + 4) / 8 * (this.yn.tickMarkMaxCharacterLength || 8), n = Math.round(i / t), s = $a1a4d31e28ce1f0d$var$u(this.Ee()), e = Math.max(s.Oa(), s.Oa() - n), r = Math.max(s.bi(), s.bi() - n), h = this.ju.Eu(t, i, this.yn.ignoreWhitespaceIndices, this.tc, this.nc), a = this.Sc() + n, l = this.xc() - n, o = this.Lc(), _ = this.yn.fixLeftEdge || o, c = this.yn.fixRightEdge || o;
        let d = 0;
        for (const t of h){
            if (!(e <= t.index && t.index <= r)) continue;
            let n;
            d < this.sc.length ? (n = this.sc[d], n.coord = this.jt(t.index), n.label = this.zc(t), n.weight = t.weight) : (n = {
                needAlignCoordinate: !1,
                coord: this.jt(t.index),
                label: this.zc(t),
                weight: t.weight
            }, this.sc.push(n)), this.hc > i / 2 && !o ? n.needAlignCoordinate = !1 : n.needAlignCoordinate = _ && t.index <= a || c && t.index >= l, d++;
        }
        return this.sc.length = d, this.Qu = this.sc, this.sc;
    }
    Oc() {
        let t;
        this.Ku = !0, this.Ms(this.yn.barSpacing), t = void 0 !== this.yn.rightOffsetPixels ? this.yn.rightOffsetPixels / this.fl() : this.yn.rightOffset, this.gs(t);
    }
    Nc(t) {
        this.Ku = !0, this.Uu = t, this.kc(), this.dc();
    }
    Fc(t, i) {
        const n = this.Dc(t), s = this.fl(), e = s + i * (s / 10);
        this.Ms(e), this.yn.rightBarStaysOnScroll || this.gs(this.Ac() + (n - this.Dc(t)));
    }
    l_(t) {
        this.xo && this.d_(), null === this.So && null === this.Ju && (this.Gi() || (this.So = t, this.Wc()));
    }
    o_(t) {
        if (null === this.Ju) return;
        const i = $a1a4d31e28ce1f0d$var$ni(this.C_ - t, 0, this.C_), n = $a1a4d31e28ce1f0d$var$ni(this.C_ - $a1a4d31e28ce1f0d$var$u(this.So), 0, this.C_);
        0 !== i && 0 !== n && this.Ms(this.Ju.fl * i / n);
    }
    __() {
        null !== this.So && (this.So = null, this.Hc());
    }
    u_(t) {
        null === this.xo && null === this.Ju && (this.Gi() || (this.xo = t, this.Wc()));
    }
    c_(t) {
        if (null === this.xo) return;
        const i = (this.xo - t) / this.fl();
        this.rc = $a1a4d31e28ce1f0d$var$u(this.Ju).Ac + i, this.Ku = !0, this.kc();
    }
    d_() {
        null !== this.xo && (this.xo = null, this.Hc());
    }
    Uc() {
        this.$c(this.yn.rightOffset);
    }
    $c(t, i = 400) {
        if (!isFinite(t)) throw new RangeError("offset is required and must be finite number");
        if (!isFinite(i) || i <= 0) throw new RangeError("animationDuration (optional) must be finite positive number");
        const n = this.rc, s = performance.now();
        this.sn.ps({
            jc: (t)=>(t - s) / i >= 1,
            qc: (e)=>{
                const r = (e - s) / i;
                return r >= 1 ? t : n + (t - n) * r;
            }
        });
    }
    kt(t, i) {
        this.Ku = !0, this.$u = t, this.ju.Vu(t, i), this.kc();
    }
    Yc() {
        return this.Zu;
    }
    Kc() {
        return this.Gu;
    }
    Zc() {
        return this.Xu;
    }
    Pc() {
        return this.Uu || 0;
    }
    Gc(t, i) {
        const n = t.Tu(), s = i && this.yn.rightOffsetPixels || 0;
        this.Ec((this.C_ - s) / n), this.rc = t.bi() - this.Pc(), i && (this.rc = s ? s / this.fl() : this.yn.rightOffset), this.kc(), this.Ku = !0, this.sn.Bc(), this.sn.mr();
    }
    Xc() {
        const t = this.Sc(), i = this.xc();
        if (null === t || null === i) return;
        const n = !this.yn.rightOffsetPixels && this.yn.rightOffset || 0;
        this.Gc(new $a1a4d31e28ce1f0d$var$Ai(t, i + n), !0);
    }
    Jc(t) {
        const i = new $a1a4d31e28ce1f0d$var$Ai(t.from, t.to);
        this.Gc(i);
    }
    rn(t) {
        return void 0 !== this.Po.timeFormatter ? this.Po.timeFormatter(t.originalTime) : this.xu.formatHorzItem(t.time);
    }
    _c() {
        if (!this.yn.ignoreWhitespaceIndices) return;
        this.tc.clear();
        const t = this.sn.Jn();
        for (const i of t)for (const t of i.ul())this.tc.set(t, !0);
        this.nc++;
    }
    Qc() {
        return this.ec;
    }
    Ml() {
        const t = 1 / (window.devicePixelRatio || 1), i = this.yn.minBarSpacing;
        if (i >= t) return [
            1
        ];
        const n = [
            1
        ];
        let s = 2;
        for(; s <= 512;)i < t / s && n.push(s), s *= 2;
        return n;
    }
    Lc() {
        const t = this.sn.N().handleScroll, i = this.sn.N().handleScale;
        return !(t.horzTouchDrag || t.mouseWheel || t.pressedMouseMove || t.vertTouchDrag || i.axisDoubleClickReset.time || i.axisPressedMouseMove.time || i.mouseWheel || i.pinch);
    }
    Sc() {
        return 0 === this.$u.length ? null : 0;
    }
    xc() {
        return 0 === this.$u.length ? null : this.$u.length - 1;
    }
    td(t) {
        return (this.C_ - 1 - t) / this.hc;
    }
    Dc(t) {
        const i = this.td(t), n = this.Pc() + this.rc - i;
        return Math.round(1e6 * n) / 1e6;
    }
    Ec(t) {
        const i = this.hc;
        this.hc = t, this.yc(), i !== this.hc && (this.Ku = !0, this.nd(), this.oc());
    }
    wc() {
        if (!this.Ku) return;
        if (this.Ku = !1, this.Gi()) return void this.sd($a1a4d31e28ce1f0d$var$Oi.Hu());
        const t = this.Pc(), i = this.C_ / this.hc, n = this.rc + t, s = new $a1a4d31e28ce1f0d$var$Ai(n - i + 1, n);
        this.sd(new $a1a4d31e28ce1f0d$var$Oi(s));
    }
    yc() {
        const t = $a1a4d31e28ce1f0d$var$ni(this.hc, this.ed(), this.rd());
        this.hc !== t && (this.hc = t, this.Ku = !0);
    }
    rd() {
        return this.yn.maxBarSpacing > 0 ? this.yn.maxBarSpacing : .5 * this.C_;
    }
    ed() {
        return this.yn.fixLeftEdge && this.yn.fixRightEdge && 0 !== this.$u.length ? this.C_ / this.$u.length : this.yn.minBarSpacing;
    }
    oc() {
        if (!this.yn.enableConflation) return void (this.ec = 1);
        const t = 1 / (window.devicePixelRatio || 1) * (this.yn.conflationThresholdFactor ?? 1);
        if (this.hc >= t) return void (this.ec = 1);
        const i = t / this.hc, n = Math.pow(2, Math.floor(Math.log2(i)));
        this.ec = Math.min(n, 512);
    }
    kc() {
        const t = this.hd();
        null !== t && this.rc < t && (this.rc = t, this.Ku = !0);
        const i = this.ad();
        this.rc > i && (this.rc = i, this.Ku = !0);
    }
    hd() {
        const t = this.Sc(), i = this.Uu;
        if (null === t || null === i) return null;
        return t - i - 1 + (this.yn.fixLeftEdge ? this.C_ / this.hc : Math.min(2, this.$u.length));
    }
    ad() {
        return this.yn.fixRightEdge ? 0 : this.C_ / this.hc - Math.min(2, this.$u.length);
    }
    Wc() {
        this.Ju = {
            fl: this.fl(),
            Ac: this.Ac()
        };
    }
    Hc() {
        this.Ju = null;
    }
    zc(t) {
        let i = this.qu.get(t.weight);
        return void 0 === i && (i = new $a1a4d31e28ce1f0d$var$Ei((t)=>this.ld(t), this.xu), this.qu.set(t.weight, i)), i.Cu(t);
    }
    ld(t) {
        return this.xu.formatTickmark(t, this.Po);
    }
    sd(t) {
        const i = this.Yu;
        this.Yu = t, $a1a4d31e28ce1f0d$var$Li(i.Fu(), this.Yu.Fu()) || this.Zu.p(), $a1a4d31e28ce1f0d$var$Li(i.Wu(), this.Yu.Wu()) || this.Gu.p(), this.nd();
    }
    nd() {
        this.Qu = null;
    }
    cc() {
        this.nd(), this.qu.clear();
    }
    lc() {
        this.xu.updateFormatter(this.Po);
    }
    dc() {
        if (!this.yn.fixLeftEdge) return;
        const t = this.Sc();
        if (null === t) return;
        const i = this.Ee();
        if (null === i) return;
        const n = i.Oa() - t;
        if (n < 0) {
            const t = this.rc - n - 1;
            this.gs(t);
        }
        this.yc();
    }
    fc() {
        this.kc(), this.yc();
    }
    Ic(t) {
        return !this.yn.ignoreWhitespaceIndices || this.tc.get(t) || !1;
    }
    Vc(t) {
        const i = function*(t) {
            const i = Math.round(t), n = i < t;
            let s = 1;
            for(;;)n ? (yield i + s, yield i - s) : (yield i - s, yield i + s), s++;
        }(t), n = this.xc();
        for(; n;){
            const t = i.next().value;
            if (this.tc.get(t)) return t;
            if (t < 0 || t > n) break;
        }
        return t;
    }
    ac(t) {
        if (void 0 !== t.rightOffsetPixels) {
            const i = t.rightOffsetPixels / (t.barSpacing || this.hc);
            this.sn.gs(i);
        }
    }
}
var $a1a4d31e28ce1f0d$export$8515895ecde62c70, $a1a4d31e28ce1f0d$export$cac7f40581f5d090, $a1a4d31e28ce1f0d$export$10777445820939da, $a1a4d31e28ce1f0d$export$2cd82751acc0e609, $a1a4d31e28ce1f0d$export$2f85f4e66fc865ef;
!function(t) {
    t[t.OnTouchEnd = 0] = "OnTouchEnd", t[t.OnNextTap = 1] = "OnNextTap";
}($a1a4d31e28ce1f0d$export$8515895ecde62c70 || ($a1a4d31e28ce1f0d$export$8515895ecde62c70 = {}));
class $a1a4d31e28ce1f0d$var$qi {
    constructor(t, i, n){
        this.od = [], this._d = [], this.ud = null, this.C_ = 0, this.dd = null, this.fd = new $a1a4d31e28ce1f0d$var$d, this.pd = new $a1a4d31e28ce1f0d$var$d, this.vd = null, this.md = t, this.yn = i, this.xu = n, this.To = new $a1a4d31e28ce1f0d$var$P(this.yn.layout.colorParsers), this.wd = new $a1a4d31e28ce1f0d$var$C(this), this.ia = new $a1a4d31e28ce1f0d$var$Fi(this, i.timeScale, this.yn.localization, n), this.Ct = new $a1a4d31e28ce1f0d$var$Z(this, i.crosshair), this.Md = new $a1a4d31e28ce1f0d$var$ii(i.crosshair), i.addDefaultPane && (this.gd(0), this.od[0].O_(2)), this.bd = this.Sd(0), this.xd = this.Sd(1);
    }
    Pa() {
        this.Cd($a1a4d31e28ce1f0d$var$X.ys());
    }
    mr() {
        this.Cd($a1a4d31e28ce1f0d$var$X.Cs());
    }
    qa() {
        this.Cd(new $a1a4d31e28ce1f0d$var$X(1));
    }
    Ta(t) {
        const i = this.yd(t);
        this.Cd(i);
    }
    ou() {
        return this.dd;
    }
    kd(t) {
        if (this.dd?.lu === t?.lu && this.dd?.wu?.te === t?.wu?.te && this.dd?.wu?.ie === t?.wu?.ie && this.dd?.mu === t?.mu && this.dd?.ee === t?.ee) return;
        const i = this.dd;
        this.dd = t, null !== i && this.Ta(i.lu), null !== t && t.lu !== i?.lu && this.Ta(t.lu);
    }
    N() {
        return this.yn;
    }
    vr(t) {
        $a1a4d31e28ce1f0d$var$f(this.yn, t), this.od.forEach((i)=>i.E_(t)), void 0 !== t.timeScale && this.ia.vr(t.timeScale), void 0 !== t.localization && this.ia.uc(t.localization), (t.leftPriceScale || t.rightPriceScale) && this.fd.p(), this.bd = this.Sd(0), this.xd = this.Sd(1), this.Pa();
    }
    Pd(t, i, n = 0) {
        const s = this.od[n];
        if (void 0 === s) return;
        if ("left" === t) return $a1a4d31e28ce1f0d$var$f(this.yn, {
            leftPriceScale: i
        }), s.E_({
            leftPriceScale: i
        }), this.fd.p(), void this.Pa();
        if ("right" === t) return $a1a4d31e28ce1f0d$var$f(this.yn, {
            rightPriceScale: i
        }), s.E_({
            rightPriceScale: i
        }), this.fd.p(), void this.Pa();
        const e = this.Td(t, n);
        null !== e && (e.Ft.vr(i), this.fd.p());
    }
    Td(t, i) {
        const n = this.od[i];
        if (void 0 === n) return null;
        const s = n.A_(t);
        return null !== s ? {
            Kn: n,
            Ft: s
        } : null;
    }
    Et() {
        return this.ia;
    }
    Zn() {
        return this.od;
    }
    Rd() {
        return this.Ct;
    }
    Dd() {
        return this.pd;
    }
    Id(t, i) {
        t.Wo(i), this.Bc();
    }
    N_(t) {
        this.C_ = t, this.ia.N_(this.C_), this.od.forEach((i)=>i.N_(t)), this.Bc();
    }
    Vd(t) {
        1 !== this.od.length && ($a1a4d31e28ce1f0d$var$o(t >= 0 && t < this.od.length, "Invalid pane index"), this.od.splice(t, 1), this.Pa());
    }
    Bd(t, i) {
        if (this.od.length < 2) return;
        $a1a4d31e28ce1f0d$var$o(t >= 0 && t < this.od.length, "Invalid pane index");
        const n = this.od[t], s = this.od.reduce((t, i)=>t + i.z_(), 0), e = this.od.reduce((t, i)=>t + i.$t(), 0), r = e - 30 * (this.od.length - 1);
        i = Math.min(r, Math.max(30, i));
        const h = s / e, a = n.$t();
        n.O_(i * h);
        let l = i - a, _ = this.od.length - 1;
        for (const t of this.od)if (t !== n) {
            const i = Math.min(r, Math.max(30, t.$t() - l / _));
            l -= t.$t() - i, _ -= 1;
            const n = i * h;
            t.O_(n);
        }
        this.Pa();
    }
    Ed(t, i) {
        $a1a4d31e28ce1f0d$var$o(t >= 0 && t < this.od.length && i >= 0 && i < this.od.length, "Invalid pane index");
        const n = this.od[t], s = this.od[i];
        this.od[t] = s, this.od[i] = n, this.Pa();
    }
    Ad(t, i) {
        if ($a1a4d31e28ce1f0d$var$o(t >= 0 && t < this.od.length && i >= 0 && i < this.od.length, "Invalid pane index"), t === i) return;
        const [n] = this.od.splice(t, 1);
        this.od.splice(i, 0, n), this.Pa();
    }
    G_(t, i, n) {
        t.G_(i, n);
    }
    X_(t, i, n) {
        t.X_(i, n), this.Ra(), this.Cd(this.Ld(t, 2));
    }
    J_(t, i) {
        t.J_(i), this.Cd(this.Ld(t, 2));
    }
    Q_(t, i, n) {
        i.Eo() || t.Q_(i, n);
    }
    tu(t, i, n) {
        i.Eo() || (t.tu(i, n), this.Ra(), this.Cd(this.Ld(t, 2)));
    }
    iu(t, i) {
        i.Eo() || (t.iu(i), this.Cd(this.Ld(t, 2)));
    }
    eu(t, i) {
        t.eu(i), this.Cd(this.Ld(t, 2));
    }
    zd(t) {
        this.ia.l_(t);
    }
    Od(t, i) {
        const n = this.Et();
        if (n.Gi() || 0 === i) return;
        const s = n.nn();
        t = Math.max(1, Math.min(t, s)), n.Fc(t, i), this.Bc();
    }
    Nd(t) {
        this.Fd(0), this.Wd(t), this.Hd();
    }
    Ud(t) {
        this.ia.o_(t), this.Bc();
    }
    $d() {
        this.ia.__(), this.mr();
    }
    Fd(t) {
        this.ia.u_(t);
    }
    Wd(t) {
        this.ia.c_(t), this.Bc();
    }
    Hd() {
        this.ia.d_(), this.mr();
    }
    Jn() {
        return this._d;
    }
    Wn() {
        return null === this.ud && (this.ud = this._d.filter((t)=>t.It())), this.ud;
    }
    ka() {
        this.ud = null;
    }
    jd(t, i, n, s, e) {
        this.Ct.In(t, i);
        let r = NaN, h = this.ia.Rc(t, !0);
        const a = this.ia.Ee();
        null !== a && (h = Math.min(Math.max(a.Oa(), h), a.bi())), h = this.Ct.Fn(h);
        const l = s.Pn(), o = l.Lt();
        if (null !== o && (r = l.Tn(i, o)), r = this.Md.xl(r, h, s), this.Ct.An(h, r, s), this.qa(), !e) {
            const e = $a1a4d31e28ce1f0d$var$Bi(s, t, i);
            this.kd(e && {
                lu: e.lu,
                wu: e.wu,
                mu: e.mu || null,
                ee: e.ee
            }), this.pd.p(this.Ct.Bt(), {
                x: t,
                y: i
            }, n);
        }
    }
    qd(t, i, n) {
        const s = n.Pn(), e = s.Lt(), r = s.Nt(t, $a1a4d31e28ce1f0d$var$u(e)), h = this.ia.vc(i, !0), a = this.ia.jt($a1a4d31e28ce1f0d$var$u(h));
        this.jd(a, r, null, n, !0);
    }
    Yd(t) {
        this.Rd().zn(), this.qa(), t || this.pd.p(null, null, null);
    }
    Ra() {
        const t = this.Ct.Kn();
        if (null !== t) {
            const i = this.Ct.Bn(), n = this.Ct.En();
            this.jd(i, n, null, t);
        }
        this.Ct.Nn();
    }
    Kd(t, i, n) {
        const s = this.ia.Rn(0);
        void 0 !== i && void 0 !== n && this.ia.kt(i, n);
        const e = this.ia.Rn(0), r = this.ia.Pc(), h = this.ia.Ee();
        if (null !== h && null !== s && null !== e) {
            const i = h.ze(r), a = this.xu.key(s) > this.xu.key(e), l = null !== t && t > r && !a, o = this.ia.N().allowShiftVisibleRangeOnWhitespaceReplacement, _ = i && (!(void 0 === n) || o) && this.ia.N().shiftVisibleRangeOnNewBar;
            if (l && !_) {
                const i = t - r;
                this.ia.gs(this.ia.Ac() - i);
            }
        }
        this.ia.Nc(t);
    }
    Va(t) {
        null !== t && t.hu();
    }
    Ks(t) {
        if (function(t) {
            return t instanceof $a1a4d31e28ce1f0d$var$ki;
        }(t)) return t;
        const i = this.od.find((i)=>i.Dt().includes(t));
        return void 0 === i ? null : i;
    }
    Bc() {
        this.od.forEach((t)=>t.hu()), this.Ra();
    }
    m() {
        this.od.forEach((t)=>t.m()), this.od.length = 0, this.yn.localization.priceFormatter = void 0, this.yn.localization.percentageFormatter = void 0, this.yn.localization.timeFormatter = void 0;
    }
    Zd() {
        return this.wd;
    }
    Js() {
        return this.wd.N();
    }
    L_() {
        return this.fd;
    }
    Gd(t, i) {
        const n = this.gd(i);
        this.Xd(t, n), this._d.push(t), this.ka(), 1 === this._d.length ? this.Pa() : this.mr();
    }
    Jd(t) {
        const i = this.Ks(t), n = this._d.indexOf(t);
        $a1a4d31e28ce1f0d$var$o(-1 !== n, "Series not found");
        const s = $a1a4d31e28ce1f0d$var$u(i);
        this._d.splice(n, 1), s.r_(t), t.m && t.m(), this.ka(), this.ia._c(), this.Qd(s);
    }
    ya(t, i) {
        const n = $a1a4d31e28ce1f0d$var$u(this.Ks(t));
        n.r_(t, !0), n.s_(t, i, !0);
    }
    Xc() {
        const t = $a1a4d31e28ce1f0d$var$X.Cs();
        t.us(), this.Cd(t);
    }
    tf(t) {
        const i = $a1a4d31e28ce1f0d$var$X.Cs();
        i.fs(t), this.Cd(i);
    }
    ws() {
        const t = $a1a4d31e28ce1f0d$var$X.Cs();
        t.ws(), this.Cd(t);
    }
    Ms(t) {
        const i = $a1a4d31e28ce1f0d$var$X.Cs();
        i.Ms(t), this.Cd(i);
    }
    gs(t) {
        const i = $a1a4d31e28ce1f0d$var$X.Cs();
        i.gs(t), this.Cd(i);
    }
    ps(t) {
        const i = $a1a4d31e28ce1f0d$var$X.Cs();
        i.ps(t), this.Cd(i);
    }
    cs() {
        const t = $a1a4d31e28ce1f0d$var$X.Cs();
        t.cs(), this.Cd(t);
    }
    if() {
        const t = this.yn.defaultVisiblePriceScaleId, i = this.yn.leftPriceScale.visible;
        return i !== this.yn.rightPriceScale.visible ? i ? "left" : "right" : t;
    }
    nf(t, i) {
        $a1a4d31e28ce1f0d$var$o(i >= 0, "Index should be greater or equal to 0");
        if (i === this.sf(t)) return;
        const n = $a1a4d31e28ce1f0d$var$u(this.Ks(t));
        n.r_(t);
        const s = this.gd(i);
        this.Xd(t, s);
        let e = !1;
        0 === n.Cl().length && (e = this.Qd(n)), e || this.Pa();
    }
    ef() {
        return this.xd;
    }
    $() {
        return this.bd;
    }
    Ut(t) {
        const i = this.xd, n = this.bd;
        if (i === n) return i;
        if (t = Math.max(0, Math.min(100, Math.round(100 * t))), null === this.vd || this.vd.ah !== n || this.vd.oh !== i) this.vd = {
            ah: n,
            oh: i,
            rf: new Map
        };
        else {
            const i = this.vd.rf.get(t);
            if (void 0 !== i) return i;
        }
        const s = this.To.tt(n, i, t / 100);
        return this.vd.rf.set(t, s), s;
    }
    hf(t) {
        return this.od.indexOf(t);
    }
    Xi() {
        return this.To;
    }
    af() {
        return this.lf();
    }
    lf(t) {
        const i = new $a1a4d31e28ce1f0d$var$ki(this.ia, this);
        this.od.push(i);
        const n = t ?? this.od.length - 1, s = $a1a4d31e28ce1f0d$var$X.ys();
        return s.es(n, {
            rs: 0,
            hs: !0
        }), this.Cd(s), i;
    }
    gd(t) {
        return $a1a4d31e28ce1f0d$var$o(t >= 0, "Index should be greater or equal to 0"), (t = Math.min(this.od.length, t)) < this.od.length ? this.od[t] : this.lf(t);
    }
    sf(t) {
        return this.od.findIndex((i)=>i.U_().includes(t));
    }
    Ld(t, i) {
        const n = new $a1a4d31e28ce1f0d$var$X(i);
        if (null !== t) {
            const s = this.od.indexOf(t);
            n.es(s, {
                rs: i
            });
        }
        return n;
    }
    yd(t, i) {
        return void 0 === i && (i = 2), this.Ld(this.Ks(t), i);
    }
    Cd(t) {
        this.md && this.md(t), this.od.forEach((t)=>t.pu().wr().kt());
    }
    Xd(t, i) {
        const n = t.N().priceScaleId, s = void 0 !== n ? n : this.if();
        i.s_(t, s), $a1a4d31e28ce1f0d$var$G(s) || t.vr(t.N());
    }
    Sd(t) {
        const i = this.yn.layout;
        return "gradient" === i.background.type ? 0 === t ? i.background.topColor : i.background.bottomColor : i.background.color;
    }
    Qd(t) {
        return !t.H_() && 0 === t.Cl().length && this.od.length > 1 && (this.od.splice(this.hf(t), 1), this.Pa(), !0);
    }
}
function $a1a4d31e28ce1f0d$var$Yi(t) {
    if (t >= 1) return 0;
    let i = 0;
    for(; i < 8; i++){
        const n = Math.round(t);
        if (Math.abs(n - t) < 1e-8) return i;
        t *= 10;
    }
    return i;
}
function $a1a4d31e28ce1f0d$export$45e4facdeecbf8d7(t) {
    return !$a1a4d31e28ce1f0d$var$p(t) && !$a1a4d31e28ce1f0d$var$m(t);
}
function $a1a4d31e28ce1f0d$export$d45648b9f1f4eae6(t) {
    return $a1a4d31e28ce1f0d$var$p(t);
}
!function(t) {
    t[t.Disabled = 0] = "Disabled", t[t.Continuous = 1] = "Continuous", t[t.OnDataUpdate = 2] = "OnDataUpdate";
}($a1a4d31e28ce1f0d$export$cac7f40581f5d090 || ($a1a4d31e28ce1f0d$export$cac7f40581f5d090 = {})), function(t) {
    t[t.LastBar = 0] = "LastBar", t[t.LastVisible = 1] = "LastVisible";
}($a1a4d31e28ce1f0d$export$10777445820939da || ($a1a4d31e28ce1f0d$export$10777445820939da = {})), function(t) {
    t.Solid = "solid", t.VerticalGradient = "gradient";
}($a1a4d31e28ce1f0d$export$2cd82751acc0e609 || ($a1a4d31e28ce1f0d$export$2cd82751acc0e609 = {})), function(t) {
    t[t.Year = 0] = "Year", t[t.Month = 1] = "Month", t[t.DayOfMonth = 2] = "DayOfMonth", t[t.Time = 3] = "Time", t[t.TimeWithSeconds = 4] = "TimeWithSeconds";
}($a1a4d31e28ce1f0d$export$2f85f4e66fc865ef || ($a1a4d31e28ce1f0d$export$2f85f4e66fc865ef = {}));
const $a1a4d31e28ce1f0d$var$Gi = (t)=>t.getUTCFullYear();
function $a1a4d31e28ce1f0d$var$Xi(t, i, n) {
    return i.replace(/yyyy/g, ((t)=>$a1a4d31e28ce1f0d$var$tt($a1a4d31e28ce1f0d$var$Gi(t), 4))(t)).replace(/yy/g, ((t)=>$a1a4d31e28ce1f0d$var$tt($a1a4d31e28ce1f0d$var$Gi(t) % 100, 2))(t)).replace(/MMMM/g, ((t, i)=>new Date(t.getUTCFullYear(), t.getUTCMonth(), 1).toLocaleString(i, {
            month: "long"
        }))(t, n)).replace(/MMM/g, ((t, i)=>new Date(t.getUTCFullYear(), t.getUTCMonth(), 1).toLocaleString(i, {
            month: "short"
        }))(t, n)).replace(/MM/g, ((t)=>$a1a4d31e28ce1f0d$var$tt(((t)=>t.getUTCMonth() + 1)(t), 2))(t)).replace(/dd/g, ((t)=>$a1a4d31e28ce1f0d$var$tt(((t)=>t.getUTCDate())(t), 2))(t));
}
class $a1a4d31e28ce1f0d$var$Ji {
    constructor(t = "yyyy-MM-dd", i = "default"){
        this._f = t, this.uf = i;
    }
    Cu(t) {
        return $a1a4d31e28ce1f0d$var$Xi(t, this._f, this.uf);
    }
}
class $a1a4d31e28ce1f0d$var$Qi {
    constructor(t){
        this.cf = t || "%h:%m:%s";
    }
    Cu(t) {
        return this.cf.replace("%h", $a1a4d31e28ce1f0d$var$tt(t.getUTCHours(), 2)).replace("%m", $a1a4d31e28ce1f0d$var$tt(t.getUTCMinutes(), 2)).replace("%s", $a1a4d31e28ce1f0d$var$tt(t.getUTCSeconds(), 2));
    }
}
const $a1a4d31e28ce1f0d$var$tn = {
    df: "yyyy-MM-dd",
    ff: "%h:%m:%s",
    pf: " ",
    vf: "default"
};
class $a1a4d31e28ce1f0d$var$nn {
    constructor(t = {}){
        const i = {
            ...$a1a4d31e28ce1f0d$var$tn,
            ...t
        };
        this.mf = new $a1a4d31e28ce1f0d$var$Ji(i.df, i.vf), this.wf = new $a1a4d31e28ce1f0d$var$Qi(i.ff), this.Mf = i.pf;
    }
    Cu(t) {
        return `${this.mf.Cu(t)}${this.Mf}${this.wf.Cu(t)}`;
    }
}
function $a1a4d31e28ce1f0d$var$sn(t) {
    return 60 * t * 60000;
}
function $a1a4d31e28ce1f0d$var$en(t) {
    return 60 * t * 1e3;
}
const $a1a4d31e28ce1f0d$var$rn = [
    {
        gf: ($a1a4d31e28ce1f0d$var$hn = 1, 1e3 * $a1a4d31e28ce1f0d$var$hn),
        bf: 10
    },
    {
        gf: $a1a4d31e28ce1f0d$var$en(1),
        bf: 20
    },
    {
        gf: $a1a4d31e28ce1f0d$var$en(5),
        bf: 21
    },
    {
        gf: $a1a4d31e28ce1f0d$var$en(30),
        bf: 22
    },
    {
        gf: $a1a4d31e28ce1f0d$var$sn(1),
        bf: 30
    },
    {
        gf: $a1a4d31e28ce1f0d$var$sn(3),
        bf: 31
    },
    {
        gf: $a1a4d31e28ce1f0d$var$sn(6),
        bf: 32
    },
    {
        gf: $a1a4d31e28ce1f0d$var$sn(12),
        bf: 33
    }
];
var $a1a4d31e28ce1f0d$var$hn;
function $a1a4d31e28ce1f0d$var$an(t, i) {
    if (t.getUTCFullYear() !== i.getUTCFullYear()) return 70;
    if (t.getUTCMonth() !== i.getUTCMonth()) return 60;
    if (t.getUTCDate() !== i.getUTCDate()) return 50;
    for(let n = $a1a4d31e28ce1f0d$var$rn.length - 1; n >= 0; --n)if (Math.floor(i.getTime() / $a1a4d31e28ce1f0d$var$rn[n].gf) !== Math.floor(t.getTime() / $a1a4d31e28ce1f0d$var$rn[n].gf)) return $a1a4d31e28ce1f0d$var$rn[n].bf;
    return 0;
}
function $a1a4d31e28ce1f0d$var$ln(t) {
    let i = t;
    if ($a1a4d31e28ce1f0d$var$m(t) && (i = $a1a4d31e28ce1f0d$var$_n(t)), !$a1a4d31e28ce1f0d$export$45e4facdeecbf8d7(i)) throw new Error("time must be of type BusinessDay");
    const n = new Date(Date.UTC(i.year, i.month - 1, i.day, 0, 0, 0, 0));
    return {
        Sf: Math.round(n.getTime() / 1e3),
        xf: i
    };
}
function $a1a4d31e28ce1f0d$var$on(t) {
    if (!$a1a4d31e28ce1f0d$export$d45648b9f1f4eae6(t)) throw new Error("time must be of type isUTCTimestamp");
    return {
        Sf: t
    };
}
function $a1a4d31e28ce1f0d$var$_n(t) {
    const i = new Date(t);
    if (isNaN(i.getTime())) throw new Error(`Invalid date string=${t}, expected format=yyyy-mm-dd`);
    return {
        day: i.getUTCDate(),
        month: i.getUTCMonth() + 1,
        year: i.getUTCFullYear()
    };
}
function $a1a4d31e28ce1f0d$var$un(t) {
    $a1a4d31e28ce1f0d$var$m(t.time) && (t.time = $a1a4d31e28ce1f0d$var$_n(t.time));
}
class $a1a4d31e28ce1f0d$var$cn {
    options() {
        return this.yn;
    }
    setOptions(t) {
        this.yn = t, this.updateFormatter(t.localization);
    }
    preprocessData(t) {
        Array.isArray(t) ? function(t) {
            t.forEach($a1a4d31e28ce1f0d$var$un);
        }(t) : $a1a4d31e28ce1f0d$var$un(t);
    }
    createConverterToInternalObj(t) {
        return $a1a4d31e28ce1f0d$var$u(function(t) {
            return 0 === t.length ? null : $a1a4d31e28ce1f0d$export$45e4facdeecbf8d7(t[0].time) || $a1a4d31e28ce1f0d$var$m(t[0].time) ? $a1a4d31e28ce1f0d$var$ln : $a1a4d31e28ce1f0d$var$on;
        }(t));
    }
    key(t) {
        return "object" == typeof t && "Sf" in t ? t.Sf : this.key(this.convertHorzItemToInternal(t));
    }
    cacheKey(t) {
        const i = t;
        return void 0 === i.xf ? new Date(1e3 * i.Sf).getTime() : new Date(Date.UTC(i.xf.year, i.xf.month - 1, i.xf.day)).getTime();
    }
    convertHorzItemToInternal(t) {
        var i;
        return $a1a4d31e28ce1f0d$export$d45648b9f1f4eae6(i = t) ? $a1a4d31e28ce1f0d$var$on(i) : $a1a4d31e28ce1f0d$export$45e4facdeecbf8d7(i) ? $a1a4d31e28ce1f0d$var$ln(i) : $a1a4d31e28ce1f0d$var$ln($a1a4d31e28ce1f0d$var$_n(i));
    }
    updateFormatter(t) {
        if (!this.yn) return;
        const i = t.dateFormat;
        this.yn.timeScale.timeVisible ? this.Cf = new $a1a4d31e28ce1f0d$var$nn({
            df: i,
            ff: this.yn.timeScale.secondsVisible ? "%h:%m:%s" : "%h:%m",
            pf: "   ",
            vf: t.locale
        }) : this.Cf = new $a1a4d31e28ce1f0d$var$Ji(i, t.locale);
    }
    formatHorzItem(t) {
        const i = t;
        return this.Cf.Cu(new Date(1e3 * i.Sf));
    }
    formatTickmark(t, i) {
        const n = function(t, i, n) {
            switch(t){
                case 0:
                case 10:
                    return i ? n ? 4 : 3 : 2;
                case 20:
                case 21:
                case 22:
                case 30:
                case 31:
                case 32:
                case 33:
                    return i ? 3 : 2;
                case 50:
                    return 2;
                case 60:
                    return 1;
                case 70:
                    return 0;
            }
        }(t.weight, this.yn.timeScale.timeVisible, this.yn.timeScale.secondsVisible), s = this.yn.timeScale;
        if (void 0 !== s.tickMarkFormatter) {
            const e = s.tickMarkFormatter(t.originalTime, n, i.locale);
            if (null !== e) return e;
        }
        return function(t, i, n) {
            const s = {};
            switch(i){
                case 0:
                    s.year = "numeric";
                    break;
                case 1:
                    s.month = "short";
                    break;
                case 2:
                    s.day = "numeric";
                    break;
                case 3:
                    s.hour12 = !1, s.hour = "2-digit", s.minute = "2-digit";
                    break;
                case 4:
                    s.hour12 = !1, s.hour = "2-digit", s.minute = "2-digit", s.second = "2-digit";
            }
            const e = void 0 === t.xf ? new Date(1e3 * t.Sf) : new Date(Date.UTC(t.xf.year, t.xf.month - 1, t.xf.day));
            return new Date(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()).toLocaleString(n, s);
        }(t.time, n, i.locale);
    }
    maxTickMarkWeight(t) {
        let i = t.reduce($a1a4d31e28ce1f0d$var$Ni, t[0]).weight;
        return i > 30 && i < 50 && (i = 30), i;
    }
    fillWeightsForPoints(t, i) {
        !function(t, i = 0) {
            if (0 === t.length) return;
            let n = 0 === i ? null : t[i - 1].time.Sf, s = null !== n ? new Date(1e3 * n) : null, e = 0;
            for(let r = i; r < t.length; ++r){
                const i = t[r], h = new Date(1e3 * i.time.Sf);
                null !== s && (i.timeWeight = $a1a4d31e28ce1f0d$var$an(h, s)), e += i.time.Sf - (n || i.time.Sf), n = i.time.Sf, s = h;
            }
            if (0 === i && t.length > 1) {
                const i = Math.ceil(e / (t.length - 1)), n = new Date(1e3 * (t[0].time.Sf - i));
                t[0].timeWeight = $a1a4d31e28ce1f0d$var$an(new Date(1e3 * t[0].time.Sf), n);
            }
        }(t, i);
    }
    static yf(t) {
        return $a1a4d31e28ce1f0d$var$f({
            localization: {
                dateFormat: "dd MMM 'yy"
            }
        }, t ?? {});
    }
}
const $a1a4d31e28ce1f0d$var$dn = "undefined" != typeof window;
function $a1a4d31e28ce1f0d$var$fn() {
    return !!$a1a4d31e28ce1f0d$var$dn && window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
}
function $a1a4d31e28ce1f0d$var$pn() {
    return !!$a1a4d31e28ce1f0d$var$dn && /iPhone|iPad|iPod/.test(window.navigator.platform);
}
function $a1a4d31e28ce1f0d$var$vn(t, i) {
    switch(t){
        case "custom":
            return void 0 !== i ? "custom-object" : "series";
        case "price-line":
            return "custom-price-line";
        case "marker":
            return "series-marker";
        case "primitive":
            return "primitive";
        default:
            return "series";
    }
}
function $a1a4d31e28ce1f0d$var$mn(t) {
    return t + t % 2;
}
function $a1a4d31e28ce1f0d$var$wn(t) {
    $a1a4d31e28ce1f0d$var$dn && void 0 !== window.chrome && t.addEventListener("mousedown", (t)=>{
        if (1 === t.button) return t.preventDefault(), !1;
    });
}
class $a1a4d31e28ce1f0d$var$Mn {
    constructor(t, i, n){
        this.kf = 0, this.Pf = null, this.Tf = {
            _t: Number.NEGATIVE_INFINITY,
            ut: Number.POSITIVE_INFINITY
        }, this.Rf = 0, this.Df = null, this.If = {
            _t: Number.NEGATIVE_INFINITY,
            ut: Number.POSITIVE_INFINITY
        }, this.Vf = null, this.Bf = !1, this.Ef = null, this.Af = null, this.Lf = !1, this.zf = !1, this.Of = !1, this.Nf = null, this.Ff = null, this.Wf = null, this.Hf = null, this.Uf = null, this.$f = null, this.jf = null, this.qf = 0, this.Yf = !1, this.Kf = !1, this.Zf = !1, this.Gf = 0, this.Xf = null, this.Jf = !$a1a4d31e28ce1f0d$var$pn(), this.Qf = (t)=>{
            this.tp(t);
        }, this.ip = (t)=>{
            if (this.np(t)) {
                const i = this.sp(t);
                if (++this.Rf, this.Df && this.Rf > 1) {
                    const { ep: n } = this.rp($a1a4d31e28ce1f0d$var$Sn(t), this.If);
                    n < 30 && !this.Of && this.hp(i, this.lp.ap), this.op();
                }
            } else {
                const i = this.sp(t);
                if (++this.kf, this.Pf && this.kf > 1) {
                    const { ep: n } = this.rp($a1a4d31e28ce1f0d$var$Sn(t), this.Tf);
                    n < 5 && !this.zf && this._p(i, this.lp.up), this.cp();
                }
            }
        }, this.dp = t, this.lp = i, this.yn = n, this.fp();
    }
    m() {
        null !== this.Nf && (this.Nf(), this.Nf = null), null !== this.Ff && (this.Ff(), this.Ff = null), null !== this.Hf && (this.Hf(), this.Hf = null), null !== this.Uf && (this.Uf(), this.Uf = null), null !== this.$f && (this.$f(), this.$f = null), null !== this.Wf && (this.Wf(), this.Wf = null), this.pp(), this.cp();
    }
    vp(t) {
        this.Hf && this.Hf();
        const i = this.mp.bind(this);
        if (this.Hf = ()=>{
            this.dp.removeEventListener("mousemove", i);
        }, this.dp.addEventListener("mousemove", i), this.np(t)) return;
        const n = this.sp(t);
        this._p(n, this.lp.wp), this.Jf = !0;
    }
    cp() {
        null !== this.Pf && clearTimeout(this.Pf), this.kf = 0, this.Pf = null, this.Tf = {
            _t: Number.NEGATIVE_INFINITY,
            ut: Number.POSITIVE_INFINITY
        };
    }
    op() {
        null !== this.Df && clearTimeout(this.Df), this.Rf = 0, this.Df = null, this.If = {
            _t: Number.NEGATIVE_INFINITY,
            ut: Number.POSITIVE_INFINITY
        };
    }
    mp(t) {
        if (this.Zf || null !== this.Af) return;
        if (this.np(t)) return;
        const i = this.sp(t);
        this._p(i, this.lp.Mp), this.Jf = !0;
    }
    gp(t) {
        const i = $a1a4d31e28ce1f0d$var$Cn(t.changedTouches, $a1a4d31e28ce1f0d$var$u(this.Xf));
        if (null === i) return;
        if (this.Gf = $a1a4d31e28ce1f0d$var$xn(t), null !== this.jf) return;
        if (this.Kf) return;
        this.Yf = !0;
        const n = this.rp($a1a4d31e28ce1f0d$var$Sn(i), $a1a4d31e28ce1f0d$var$u(this.Af)), { bp: s, Sp: e, ep: r } = n;
        if (this.Lf || !(r < 5)) {
            if (!this.Lf) {
                const t = .5 * s, i = e >= t && !this.yn.xp(), n = t > e && !this.yn.Cp();
                i || n || (this.Kf = !0), this.Lf = !0, this.Of = !0, this.pp(), this.op();
            }
            if (!this.Kf) {
                const n = this.sp(t, i);
                this.hp(n, this.lp.yp), $a1a4d31e28ce1f0d$var$bn(t);
            }
        }
    }
    kp(t) {
        if (0 !== t.button) return;
        const i = this.rp($a1a4d31e28ce1f0d$var$Sn(t), $a1a4d31e28ce1f0d$var$u(this.Ef)), { ep: n } = i;
        if (n >= 5 && (this.zf = !0, this.cp()), this.zf) {
            const i = this.sp(t);
            this._p(i, this.lp.Pp);
        }
    }
    rp(t, i) {
        const n = Math.abs(i._t - t._t), s = Math.abs(i.ut - t.ut);
        return {
            bp: n,
            Sp: s,
            ep: n + s
        };
    }
    Tp(t) {
        let i = $a1a4d31e28ce1f0d$var$Cn(t.changedTouches, $a1a4d31e28ce1f0d$var$u(this.Xf));
        if (null === i && 0 === t.touches.length && (i = t.changedTouches[0]), null === i) return;
        this.Xf = null, this.Gf = $a1a4d31e28ce1f0d$var$xn(t), this.pp(), this.Af = null, this.$f && (this.$f(), this.$f = null);
        const n = this.sp(t, i);
        if (this.hp(n, this.lp.Rp), ++this.Rf, this.Df && this.Rf > 1) {
            const { ep: t } = this.rp($a1a4d31e28ce1f0d$var$Sn(i), this.If);
            t < 30 && !this.Of && this.hp(n, this.lp.ap), this.op();
        } else this.Of || (this.hp(n, this.lp.Dp), this.lp.Dp && $a1a4d31e28ce1f0d$var$bn(t));
        0 === this.Rf && $a1a4d31e28ce1f0d$var$bn(t), 0 === t.touches.length && this.Bf && (this.Bf = !1, $a1a4d31e28ce1f0d$var$bn(t));
    }
    tp(t) {
        if (0 !== t.button) return;
        const i = this.sp(t);
        if (this.Ef = null, this.Zf = !1, this.Uf && (this.Uf(), this.Uf = null), $a1a4d31e28ce1f0d$var$fn()) this.dp.ownerDocument.documentElement.removeEventListener("mouseleave", this.Qf);
        if (!this.np(t)) {
            if (this._p(i, this.lp.Ip), ++this.kf, this.Pf && this.kf > 1) {
                const { ep: n } = this.rp($a1a4d31e28ce1f0d$var$Sn(t), this.Tf);
                n < 5 && !this.zf && this._p(i, this.lp.up), this.cp();
            } else this.zf || this._p(i, this.lp.Vp);
        }
    }
    pp() {
        null !== this.Vf && (clearTimeout(this.Vf), this.Vf = null);
    }
    Bp(t) {
        if (null !== this.Xf) return;
        const i = t.changedTouches[0];
        this.Xf = i.identifier, this.Gf = $a1a4d31e28ce1f0d$var$xn(t);
        const n = this.dp.ownerDocument.documentElement;
        this.Of = !1, this.Lf = !1, this.Kf = !1, this.Af = $a1a4d31e28ce1f0d$var$Sn(i), this.$f && (this.$f(), this.$f = null);
        {
            const i = this.gp.bind(this), s = this.Tp.bind(this);
            this.$f = ()=>{
                n.removeEventListener("touchmove", i), n.removeEventListener("touchend", s);
            }, n.addEventListener("touchmove", i, {
                passive: !1
            }), n.addEventListener("touchend", s, {
                passive: !1
            }), this.pp(), this.Vf = setTimeout(this.Ep.bind(this, t), 240);
        }
        const s = this.sp(t, i);
        this.hp(s, this.lp.Ap), this.Df || (this.Rf = 0, this.Df = setTimeout(this.op.bind(this), 500), this.If = $a1a4d31e28ce1f0d$var$Sn(i));
    }
    Lp(t) {
        if (0 !== t.button) return;
        const i = this.dp.ownerDocument.documentElement;
        $a1a4d31e28ce1f0d$var$fn() && i.addEventListener("mouseleave", this.Qf), this.zf = !1, this.Ef = $a1a4d31e28ce1f0d$var$Sn(t), this.Uf && (this.Uf(), this.Uf = null);
        {
            const t = this.kp.bind(this), n = this.tp.bind(this);
            this.Uf = ()=>{
                i.removeEventListener("mousemove", t), i.removeEventListener("mouseup", n);
            }, i.addEventListener("mousemove", t), i.addEventListener("mouseup", n);
        }
        if (this.Zf = !0, this.np(t)) return;
        const n = this.sp(t);
        this._p(n, this.lp.zp), this.Pf || (this.kf = 0, this.Pf = setTimeout(this.cp.bind(this), 500), this.Tf = $a1a4d31e28ce1f0d$var$Sn(t));
    }
    fp() {
        this.dp.addEventListener("mouseenter", this.vp.bind(this)), this.dp.addEventListener("touchcancel", this.pp.bind(this));
        {
            const t = this.dp.ownerDocument, i = (t)=>{
                this.lp.Op && (t.composed && this.dp.contains(t.composedPath()[0]) || t.target && this.dp.contains(t.target) || this.lp.Op());
            };
            this.Ff = ()=>{
                t.removeEventListener("touchstart", i);
            }, this.Nf = ()=>{
                t.removeEventListener("mousedown", i);
            }, t.addEventListener("mousedown", i), t.addEventListener("touchstart", i, {
                passive: !0
            });
        }
        $a1a4d31e28ce1f0d$var$pn() && (this.Wf = ()=>{
            this.dp.removeEventListener("dblclick", this.ip);
        }, this.dp.addEventListener("dblclick", this.ip)), this.dp.addEventListener("mouseleave", this.Np.bind(this)), this.dp.addEventListener("touchstart", this.Bp.bind(this), {
            passive: !0
        }), $a1a4d31e28ce1f0d$var$wn(this.dp), this.dp.addEventListener("mousedown", this.Lp.bind(this)), this.Fp(), this.dp.addEventListener("touchmove", ()=>{}, {
            passive: !1
        });
    }
    Fp() {
        void 0 === this.lp.Wp && void 0 === this.lp.Hp && void 0 === this.lp.Up || (this.dp.addEventListener("touchstart", (t)=>this.$p(t.touches), {
            passive: !0
        }), this.dp.addEventListener("touchmove", (t)=>{
            if (2 === t.touches.length && null !== this.jf && void 0 !== this.lp.Hp) {
                const i = $a1a4d31e28ce1f0d$var$gn(t.touches[0], t.touches[1]) / this.qf;
                this.lp.Hp(this.jf, i), $a1a4d31e28ce1f0d$var$bn(t);
            }
        }, {
            passive: !1
        }), this.dp.addEventListener("touchend", (t)=>{
            this.$p(t.touches);
        }));
    }
    $p(t) {
        1 === t.length && (this.Yf = !1), 2 !== t.length || this.Yf || this.Bf ? this.jp() : this.qp(t);
    }
    qp(t) {
        const i = this.dp.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        this.jf = {
            _t: (t[0].clientX - i.left + (t[1].clientX - i.left)) / 2,
            ut: (t[0].clientY - i.top + (t[1].clientY - i.top)) / 2
        }, this.qf = $a1a4d31e28ce1f0d$var$gn(t[0], t[1]), void 0 !== this.lp.Wp && this.lp.Wp(), this.pp();
    }
    jp() {
        null !== this.jf && (this.jf = null, void 0 !== this.lp.Up && this.lp.Up());
    }
    Np(t) {
        if (this.Hf && this.Hf(), this.np(t)) return;
        if (!this.Jf) return;
        const i = this.sp(t);
        this._p(i, this.lp.Yp), this.Jf = !$a1a4d31e28ce1f0d$var$pn();
    }
    Ep(t) {
        const i = $a1a4d31e28ce1f0d$var$Cn(t.touches, $a1a4d31e28ce1f0d$var$u(this.Xf));
        if (null === i) return;
        const n = this.sp(t, i);
        this.hp(n, this.lp.Kp), this.Of = !0, this.Bf = !0;
    }
    np(t) {
        return t.sourceCapabilities && void 0 !== t.sourceCapabilities.firesTouchEvents ? t.sourceCapabilities.firesTouchEvents : $a1a4d31e28ce1f0d$var$xn(t) < this.Gf + 500;
    }
    hp(t, i) {
        i && i.call(this.lp, t);
    }
    _p(t, i) {
        i && i.call(this.lp, t);
    }
    sp(t, i) {
        const n = i || t, s = this.dp.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        return {
            clientX: n.clientX,
            clientY: n.clientY,
            pageX: n.pageX,
            pageY: n.pageY,
            screenX: n.screenX,
            screenY: n.screenY,
            localX: n.clientX - s.left,
            localY: n.clientY - s.top,
            ctrlKey: t.ctrlKey,
            altKey: t.altKey,
            shiftKey: t.shiftKey,
            metaKey: t.metaKey,
            Zp: !t.type.startsWith("mouse") && "contextmenu" !== t.type && "click" !== t.type,
            Gp: t.type,
            Xp: n.target,
            gu: t.view,
            Jp: ()=>{
                "touchstart" !== t.type && $a1a4d31e28ce1f0d$var$bn(t);
            }
        };
    }
}
function $a1a4d31e28ce1f0d$var$gn(t, i) {
    const n = t.clientX - i.clientX, s = t.clientY - i.clientY;
    return Math.sqrt(n * n + s * s);
}
function $a1a4d31e28ce1f0d$var$bn(t) {
    t.cancelable && t.preventDefault();
}
function $a1a4d31e28ce1f0d$var$Sn(t) {
    return {
        _t: t.pageX,
        ut: t.pageY
    };
}
function $a1a4d31e28ce1f0d$var$xn(t) {
    return t.timeStamp || performance.now();
}
function $a1a4d31e28ce1f0d$var$Cn(t, i) {
    for(let n = 0; n < t.length; ++n)if (t[n].identifier === i) return t[n];
    return null;
}
class $a1a4d31e28ce1f0d$var$yn {
    constructor(t, i, n){
        this.Qp = null, this.tv = null, this.iv = !0, this.nv = null, this.sv = t, this.ev = t.rv()[i], this.hv = t.rv()[n], this.av = document.createElement("tr"), this.av.style.height = "1px", this.lv = document.createElement("td"), this.lv.style.position = "relative", this.lv.style.padding = "0", this.lv.style.margin = "0", this.lv.setAttribute("colspan", "3"), this.ov(), this.av.appendChild(this.lv), this.iv = this.sv.N().layout.panes.enableResize, this.iv ? this._v() : (this.Qp = null, this.tv = null);
    }
    m() {
        null !== this.tv && this.tv.m();
    }
    uv() {
        return this.av;
    }
    cv() {
        return (0, $cpKFH.size)({
            width: this.ev.cv().width,
            height: 1
        });
    }
    dv() {
        return (0, $cpKFH.size)({
            width: this.ev.dv().width,
            height: 1 * window.devicePixelRatio
        });
    }
    fv(t, i, n) {
        const s = this.dv();
        t.fillStyle = this.sv.N().layout.panes.separatorColor, t.fillRect(i, n, s.width, s.height);
    }
    kt() {
        this.ov(), this.sv.N().layout.panes.enableResize !== this.iv && (this.iv = this.sv.N().layout.panes.enableResize, this.iv ? this._v() : (null !== this.Qp && (this.lv.removeChild(this.Qp.pv), this.lv.removeChild(this.Qp.vv), this.Qp = null), null !== this.tv && (this.tv.m(), this.tv = null)));
    }
    _v() {
        const t = document.createElement("div"), i = t.style;
        i.position = "fixed", i.display = "none", i.zIndex = "49", i.top = "0", i.left = "0", i.width = "100%", i.height = "100%", i.cursor = "row-resize", this.lv.appendChild(t);
        const n = document.createElement("div"), s = n.style;
        s.position = "absolute", s.zIndex = "50", s.top = "-4px", s.height = "9px", s.width = "100%", s.backgroundColor = "", s.cursor = "row-resize", this.lv.appendChild(n);
        const e = {
            wp: this.mv.bind(this),
            Yp: this.wv.bind(this),
            zp: this.Mv.bind(this),
            Ap: this.Mv.bind(this),
            Pp: this.gv.bind(this),
            yp: this.gv.bind(this),
            Ip: this.bv.bind(this),
            Rp: this.bv.bind(this)
        };
        this.tv = new $a1a4d31e28ce1f0d$var$Mn(n, e, {
            xp: ()=>!1,
            Cp: ()=>!0
        }), this.Qp = {
            vv: n,
            pv: t
        };
    }
    ov() {
        this.lv.style.background = this.sv.N().layout.panes.separatorColor;
    }
    mv(t) {
        null !== this.Qp && (this.Qp.vv.style.backgroundColor = this.sv.N().layout.panes.separatorHoverColor);
    }
    wv(t) {
        null !== this.Qp && null === this.nv && (this.Qp.vv.style.backgroundColor = "");
    }
    Mv(t) {
        if (null === this.Qp) return;
        const i = this.ev.Sv().z_() + this.hv.Sv().z_(), n = i / (this.ev.cv().height + this.hv.cv().height), s = 30 * n;
        i <= 2 * s || (this.nv = {
            xv: t.pageY,
            Cv: this.ev.Sv().z_(),
            yv: i - s,
            kv: i,
            Pv: n,
            Tv: s
        }, this.Qp.pv.style.display = "block");
    }
    gv(t) {
        const i = this.nv;
        if (null === i) return;
        const n = (t.pageY - i.xv) * i.Pv, s = $a1a4d31e28ce1f0d$var$ni(i.Cv + n, i.Tv, i.yv);
        this.ev.Sv().O_(s), this.hv.Sv().O_(i.kv - s), this.sv.Qt().Pa();
    }
    bv(t) {
        null !== this.nv && null !== this.Qp && (this.nv = null, this.Qp.pv.style.display = "none");
    }
}
function $a1a4d31e28ce1f0d$var$kn(t, i) {
    return t.Rv - i.Rv;
}
function $a1a4d31e28ce1f0d$var$Pn(t, i, n) {
    const s = (t.Rv - i.Rv) / (t.wt - i.wt);
    return Math.sign(s) * Math.min(Math.abs(s), n);
}
class $a1a4d31e28ce1f0d$var$Tn {
    constructor(t, i, n, s){
        this.Dv = null, this.Iv = null, this.Vv = null, this.Bv = null, this.Ev = null, this.Av = 0, this.Lv = 0, this.zv = t, this.Ov = i, this.Nv = n, this.ks = s;
    }
    Fv(t, i) {
        if (null !== this.Dv) {
            if (this.Dv.wt === i) return void (this.Dv.Rv = t);
            if (Math.abs(this.Dv.Rv - t) < this.ks) return;
        }
        this.Bv = this.Vv, this.Vv = this.Iv, this.Iv = this.Dv, this.Dv = {
            wt: i,
            Rv: t
        };
    }
    me(t, i) {
        if (null === this.Dv || null === this.Iv) return;
        if (i - this.Dv.wt > 50) return;
        let n = 0;
        const s = $a1a4d31e28ce1f0d$var$Pn(this.Dv, this.Iv, this.Ov), e = $a1a4d31e28ce1f0d$var$kn(this.Dv, this.Iv), r = [
            s
        ], h = [
            e
        ];
        if (n += e, null !== this.Vv) {
            const t = $a1a4d31e28ce1f0d$var$Pn(this.Iv, this.Vv, this.Ov);
            if (Math.sign(t) === Math.sign(s)) {
                const i = $a1a4d31e28ce1f0d$var$kn(this.Iv, this.Vv);
                if (r.push(t), h.push(i), n += i, null !== this.Bv) {
                    const t = $a1a4d31e28ce1f0d$var$Pn(this.Vv, this.Bv, this.Ov);
                    if (Math.sign(t) === Math.sign(s)) {
                        const i = $a1a4d31e28ce1f0d$var$kn(this.Vv, this.Bv);
                        r.push(t), h.push(i), n += i;
                    }
                }
            }
        }
        let a = 0;
        for(let t = 0; t < r.length; ++t)a += h[t] / n * r[t];
        Math.abs(a) < this.zv || (this.Ev = {
            Rv: t,
            wt: i
        }, this.Lv = a, this.Av = function(t, i) {
            const n = Math.log(i);
            return Math.log(1 * n / -t) / n;
        }(Math.abs(a), this.Nv));
    }
    qc(t) {
        const i = $a1a4d31e28ce1f0d$var$u(this.Ev), n = t - i.wt;
        return i.Rv + this.Lv * (Math.pow(this.Nv, n) - 1) / Math.log(this.Nv);
    }
    jc(t) {
        return null === this.Ev || this.Wv(t) === this.Av;
    }
    Wv(t) {
        const i = t - $a1a4d31e28ce1f0d$var$u(this.Ev).wt;
        return Math.min(i, this.Av);
    }
}
class $a1a4d31e28ce1f0d$var$Rn {
    constructor(t, i){
        this.Hv = void 0, this.Uv = void 0, this.$v = void 0, this.vn = !1, this.jv = t, this.qv = i, this.Yv();
    }
    kt() {
        this.Yv();
    }
    Kv() {
        this.Hv && this.jv.removeChild(this.Hv), this.Uv && this.jv.removeChild(this.Uv), this.Hv = void 0, this.Uv = void 0;
    }
    Zv() {
        return this.vn !== this.Gv() || this.$v !== this.Xv();
    }
    Xv() {
        return this.qv.Qt().Xi().J(this.qv.N().layout.textColor) > 160 ? "dark" : "light";
    }
    Gv() {
        return this.qv.N().layout.attributionLogo;
    }
    Jv() {
        const t = new URL(location.href);
        return t.hostname ? "&utm_source=" + t.hostname + t.pathname : "";
    }
    Yv() {
        this.Zv() && (this.Kv(), this.vn = this.Gv(), this.vn && (this.$v = this.Xv(), this.Uv = document.createElement("style"), this.Uv.innerText = "a#tv-attr-logo{--fill:#131722;--stroke:#fff;position:absolute;left:10px;bottom:10px;height:19px;width:35px;margin:0;padding:0;border:0;z-index:3;}a#tv-attr-logo[data-dark]{--fill:#D1D4DC;--stroke:#131722;}", this.Hv = document.createElement("a"), this.Hv.href = `https://www.tradingview.com/?utm_medium=lwc-link&utm_campaign=lwc-chart${this.Jv()}`, this.Hv.title = "Charting by TradingView", this.Hv.id = "tv-attr-logo", this.Hv.target = "_blank", this.Hv.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="19" fill="none"><g fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd"><path fill="var(--stroke)" d="M2 0H0v10h6v9h21.4l.5-1.3 6-15 1-2.7H23.7l-.5 1.3-.2.6a5 5 0 0 0-7-.9V0H2Zm20 17h4l5.2-13 .8-2h-7l-1 2.5-.2.5-1.5 3.8-.3.7V17Zm-.8-10a3 3 0 0 0 .7-2.7A3 3 0 1 0 16.8 7h4.4ZM14 7V2H2v6h6v9h4V7h2Z"/><path fill="var(--fill)" d="M14 2H2v6h6v9h6V2Zm12 15h-7l6-15h7l-6 15Zm-7-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/></g><defs><clipPath id="a"><path fill="var(--stroke)" d="M0 0h35v19H0z"/></clipPath></defs></svg>', this.Hv.toggleAttribute("data-dark", "dark" === this.$v), this.jv.appendChild(this.Uv), this.jv.appendChild(this.Hv)));
    }
}
function $a1a4d31e28ce1f0d$var$Dn(t, n) {
    const s = $a1a4d31e28ce1f0d$var$u(t.ownerDocument).createElement("canvas");
    t.appendChild(s);
    const e = (0, $3F0l6.bindTo)(s, {
        type: "device-pixel-content-box",
        options: {
            allowResizeObserver: !0
        },
        transform: (t, i)=>({
                width: Math.max(t.width, i.width),
                height: Math.max(t.height, i.height)
            })
    });
    return e.resizeCanvasElement(n), e;
}
function $a1a4d31e28ce1f0d$var$In(t) {
    t.width = 1, t.height = 1, t.getContext("2d")?.clearRect(0, 0, 1, 1);
}
function $a1a4d31e28ce1f0d$var$Vn(t, i, n, s) {
    t.qh && t.qh(i, n, s);
}
function $a1a4d31e28ce1f0d$var$Bn(t, i, n, s) {
    t.st(i, n, s);
}
function $a1a4d31e28ce1f0d$var$En(t, i, n, s) {
    const e = t(n, s);
    for (const t of e){
        const n = t.Tt(s);
        null !== n && i(n);
    }
}
function $a1a4d31e28ce1f0d$var$An(t, i) {
    return (n)=>{
        if (!function(t) {
            return void 0 !== t.Ft;
        }(n)) return [];
        return (n.Ft()?.cl() ?? "") !== i ? [] : n.Ga?.(t) ?? [];
    };
}
function $a1a4d31e28ce1f0d$var$Ln(t, i, n, s) {
    if (!t.length) return;
    let e = 0;
    const r = t[0].$t(s, !0);
    let h = 1 === i ? n / 2 - (t[0].Hi() - r / 2) : t[0].Hi() - r / 2 - n / 2;
    h = Math.max(0, h);
    for(let r = 1; r < t.length; r++){
        const a = t[r], l = t[r - 1], o = l.$t(s, !1), _ = a.Hi(), u = l.Hi();
        if (1 === i ? _ > u - o : _ < u + o) {
            const s = u - o * i;
            a.Ui(s);
            const r = s - i * o / 2;
            if ((1 === i ? r < 0 : r > n) && h > 0) {
                const s = 1 === i ? -1 - r : r - n, a = Math.min(s, h);
                for(let n = e; n < t.length; n++)t[n].Ui(t[n].Hi() + i * a);
                h -= a;
            }
        } else e = r, h = 1 === i ? u - o - _ : _ - (u + o);
    }
}
class $a1a4d31e28ce1f0d$var$zn {
    constructor(i, n, s, e){
        this.Ki = null, this.Qv = null, this.tm = !1, this.im = new $a1a4d31e28ce1f0d$var$rt(200), this.nm = null, this.sm = 0, this.rm = !1, this.hm = ()=>{
            this.rm || this.yt.am().Qt().mr();
        }, this.lm = ()=>{
            this.rm || this.yt.am().Qt().mr();
        }, this.yt = i, this.yn = n, this.ko = n.layout, this.wd = s, this.om = "left" === e, this._m = $a1a4d31e28ce1f0d$var$An("normal", e), this.um = $a1a4d31e28ce1f0d$var$An("top", e), this.dm = $a1a4d31e28ce1f0d$var$An("bottom", e), this.lv = document.createElement("div"), this.lv.style.height = "100%", this.lv.style.overflow = "hidden", this.lv.style.width = "25px", this.lv.style.left = "0", this.lv.style.position = "relative", this.fm = $a1a4d31e28ce1f0d$var$Dn(this.lv, (0, $cpKFH.size)({
            width: 16,
            height: 16
        })), this.fm.subscribeSuggestedBitmapSizeChanged(this.hm);
        const r = this.fm.canvasElement;
        r.style.position = "absolute", r.style.zIndex = "1", r.style.left = "0", r.style.top = "0", this.pm = $a1a4d31e28ce1f0d$var$Dn(this.lv, (0, $cpKFH.size)({
            width: 16,
            height: 16
        })), this.pm.subscribeSuggestedBitmapSizeChanged(this.lm);
        const h = this.pm.canvasElement;
        h.style.position = "absolute", h.style.zIndex = "2", h.style.left = "0", h.style.top = "0";
        const a = {
            zp: this.Mv.bind(this),
            Ap: this.Mv.bind(this),
            Pp: this.gv.bind(this),
            yp: this.gv.bind(this),
            Op: this.vm.bind(this),
            Ip: this.bv.bind(this),
            Rp: this.bv.bind(this),
            up: this.wm.bind(this),
            ap: this.wm.bind(this),
            wp: this.Mm.bind(this),
            Yp: this.wv.bind(this)
        };
        this.tv = new $a1a4d31e28ce1f0d$var$Mn(this.pm.canvasElement, a, {
            xp: ()=>!this.yn.handleScroll.vertTouchDrag,
            Cp: ()=>!0
        });
    }
    m() {
        this.tv.m(), this.pm.unsubscribeSuggestedBitmapSizeChanged(this.lm), $a1a4d31e28ce1f0d$var$In(this.pm.canvasElement), this.pm.dispose(), this.fm.unsubscribeSuggestedBitmapSizeChanged(this.hm), $a1a4d31e28ce1f0d$var$In(this.fm.canvasElement), this.fm.dispose(), null !== this.Ki && this.Ki.a_().u(this), this.Ki = null;
    }
    uv() {
        return this.lv;
    }
    k() {
        return this.ko.fontSize;
    }
    gm() {
        const t = this.wd.N();
        return this.nm !== t.P && (this.im.Os(), this.nm = t.P), t;
    }
    bm() {
        if (null === this.Ki) return 0;
        let t = 0;
        const i = this.gm(), n = $a1a4d31e28ce1f0d$var$u(this.fm.canvasElement.getContext("2d", {
            colorSpace: this.yt.am().N().layout.colorSpace
        }));
        n.save();
        const s = this.Ki.El();
        n.font = this.Sm(), s.length > 0 && (t = Math.max(this.im.Ii(n, s[0].io), this.im.Ii(n, s[s.length - 1].io)));
        const e = this.xm();
        for(let i = e.length; i--;){
            const s = this.im.Ii(n, e[i].ri());
            s > t && (t = s);
        }
        const r = this.Ki.Lt();
        if (null !== r && null !== this.Qv && 2 !== (h = this.yn.crosshair).mode && h.horzLine.visible && h.horzLine.labelVisible) {
            const i = this.Ki.Tn(1, r), s = this.Ki.Tn(this.Qv.height - 2, r);
            t = Math.max(t, this.im.Ii(n, this.Ki.Ji(Math.floor(Math.min(i, s)) + .11111111111111, r)), this.im.Ii(n, this.Ki.Ji(Math.ceil(Math.max(i, s)) - .11111111111111, r)));
        }
        var h;
        n.restore();
        const a = t || 34;
        return $a1a4d31e28ce1f0d$var$mn(Math.ceil(i.S + i.C + i.V + i.B + 5 + a));
    }
    Cm(t) {
        null !== this.Qv && (0, $cpKFH.equalSizes)(this.Qv, t) || (this.Qv = t, this.rm = !0, this.fm.resizeCanvasElement(t), this.pm.resizeCanvasElement(t), this.rm = !1, this.lv.style.width = `${t.width}px`, this.lv.style.height = `${t.height}px`);
    }
    ym() {
        return $a1a4d31e28ce1f0d$var$u(this.Qv).width;
    }
    un(t) {
        this.Ki !== t && (null !== this.Ki && this.Ki.a_().u(this), this.Ki = t, t.a_().i(this.po.bind(this), this));
    }
    Ft() {
        return this.Ki;
    }
    Os() {
        const t = this.yt.Sv();
        this.yt.am().Qt().eu(t, $a1a4d31e28ce1f0d$var$u(this.Ft()));
    }
    km(t) {
        if (null === this.Qv) return;
        const i = {
            colorSpace: this.yt.am().N().layout.colorSpace
        };
        if (1 !== t) {
            this.Pm(), this.fm.applySuggestedBitmapSize();
            const t = (0, $9fJzN.tryCreateCanvasRenderingTarget2D)(this.fm, i);
            null !== t && (t.useBitmapCoordinateSpace((t)=>{
                this.Tm(t), this.Rm(t);
            }), this.yt.Dm(t, this.dm), this.Im(t), this.yt.Dm(t, this._m), this.Vm(t));
        }
        this.pm.applySuggestedBitmapSize();
        const n = (0, $9fJzN.tryCreateCanvasRenderingTarget2D)(this.pm, i);
        null !== n && (n.useBitmapCoordinateSpace(({ context: t, bitmapSize: i })=>{
            t.clearRect(0, 0, i.width, i.height);
        }), this.Bm(n), this.yt.Dm(n, this.um));
    }
    dv() {
        return this.fm.bitmapSize;
    }
    fv(t, i, n, s) {
        const e = this.dv();
        if (e.width > 0 && e.height > 0 && (t.drawImage(this.fm.canvasElement, i, n), s)) {
            const s = this.pm.canvasElement;
            t.drawImage(s, i, n);
        }
    }
    kt() {
        this.Ki?.El();
    }
    Mv(t) {
        if (null === this.Ki || this.Ki.Gi() || !this.yn.handleScale.axisPressedMouseMove.price) return;
        const i = this.yt.am().Qt(), n = this.yt.Sv();
        this.tm = !0, i.G_(n, this.Ki, t.localY);
    }
    gv(t) {
        if (null === this.Ki || !this.yn.handleScale.axisPressedMouseMove.price) return;
        const i = this.yt.am().Qt(), n = this.yt.Sv(), s = this.Ki;
        i.X_(n, s, t.localY);
    }
    vm() {
        if (null === this.Ki || !this.yn.handleScale.axisPressedMouseMove.price) return;
        const t = this.yt.am().Qt(), i = this.yt.Sv(), n = this.Ki;
        this.tm && (this.tm = !1, t.J_(i, n));
    }
    bv(t) {
        if (null === this.Ki || !this.yn.handleScale.axisPressedMouseMove.price) return;
        const i = this.yt.am().Qt(), n = this.yt.Sv();
        this.tm = !1, i.J_(n, this.Ki);
    }
    wm(t) {
        this.yn.handleScale.axisDoubleClickReset.price && this.Os();
    }
    Mm(t) {
        if (null === this.Ki) return;
        !this.yt.am().Qt().N().handleScale.axisPressedMouseMove.price || this.Ki.je() || this.Ki.Lo() || this.Em(1);
    }
    wv(t) {
        this.Em(0);
    }
    xm() {
        const t = [], i = null === this.Ki ? void 0 : this.Ki;
        return ((n)=>{
            for(let s = 0; s < n.length; ++s){
                const e = n[s].qn(this.yt.Sv(), i);
                for(let i = 0; i < e.length; i++)t.push(e[i]);
            }
        })(this.yt.Sv().Dt()), t;
    }
    Tm({ context: t, bitmapSize: i }) {
        const { width: n, height: s } = i, e = this.yt.Sv().Qt(), r = e.$(), h = e.ef();
        r === h ? $a1a4d31e28ce1f0d$var$z(t, 0, 0, n, s, r) : $a1a4d31e28ce1f0d$var$F(t, 0, 0, n, s, r, h);
    }
    Rm({ context: t, bitmapSize: i, horizontalPixelRatio: n }) {
        if (null === this.Qv || null === this.Ki || !this.Ki.N().borderVisible) return;
        t.fillStyle = this.Ki.N().borderColor;
        const s = Math.max(1, Math.floor(this.gm().S * n));
        let e;
        e = this.om ? i.width - s : 0, t.fillRect(e, 0, s, i.height);
    }
    Im(t) {
        if (null === this.Qv || null === this.Ki) return;
        const i = this.Ki.El(), n = this.Ki.N(), s = this.gm(), e = this.om ? this.Qv.width - s.C : 0;
        n.borderVisible && n.ticksVisible && t.useBitmapCoordinateSpace(({ context: t, horizontalPixelRatio: r, verticalPixelRatio: h })=>{
            t.fillStyle = n.borderColor;
            const a = Math.max(1, Math.floor(h)), l = Math.floor(.5 * h), o = Math.round(s.C * r);
            t.beginPath();
            for (const n of i)t.rect(Math.floor(e * r), Math.round(n.Rl * h) - l, o, a);
            t.fill();
        }), t.useMediaCoordinateSpace(({ context: t })=>{
            t.font = this.Sm(), t.fillStyle = n.textColor ?? this.ko.textColor, t.textAlign = this.om ? "right" : "left", t.textBaseline = "middle";
            const r = this.om ? Math.round(e - s.V) : Math.round(e + s.C + s.V), h = i.map((i)=>this.im.Di(t, i.io));
            for(let n = i.length; n--;){
                const s = i[n];
                t.fillText(s.io, r, s.Rl + h[n]);
            }
        });
    }
    Pm() {
        if (null === this.Qv || null === this.Ki) return;
        let t = this.Qv.height / 2;
        const i = [], n = this.Ki.Dt().slice(), s = this.yt.Sv(), e = this.gm();
        this.Ki === s.Gs() && this.yt.Sv().Dt().forEach((t)=>{
            s.Zs(t) && n.push(t);
        });
        const r = this.Ki.Cl()[0], h = this.Ki;
        n.forEach((n)=>{
            const e = n.qn(s, h);
            e.forEach((t)=>{
                t.$i() && null === t.Wi() && (t.Ui(null), i.push(t));
            }), r === n && e.length > 0 && (t = e[0].Ei());
        });
        this.Ki.N().alignLabels && this.Am(i, e, t);
    }
    Am(t, i, n) {
        if (null === this.Qv) return;
        const s = t.filter((t)=>t.Ei() <= n), e = t.filter((t)=>t.Ei() > n);
        s.sort((t, i)=>i.Ei() - t.Ei()), s.length && e.length && e.push(s[0]), e.sort((t, i)=>t.Ei() - i.Ei());
        for (const n of t){
            const t = Math.floor(n.$t(i) / 2), s = n.Ei();
            s > -t && s < t && n.Ui(t), s > this.Qv.height - t && s < this.Qv.height + t && n.Ui(this.Qv.height - t);
        }
        $a1a4d31e28ce1f0d$var$Ln(s, 1, this.Qv.height, i), $a1a4d31e28ce1f0d$var$Ln(e, -1, this.Qv.height, i);
    }
    Vm(t) {
        if (null === this.Qv) return;
        const i = this.xm(), n = this.gm(), s = this.om ? "right" : "left";
        i.forEach((i)=>{
            if (i.ji()) i.Tt($a1a4d31e28ce1f0d$var$u(this.Ki)).st(t, n, this.im, s);
        });
    }
    Bm(t) {
        if (null === this.Qv || null === this.Ki) return;
        const i = this.yt.am().Qt(), n = [], s = this.yt.Sv(), e = i.Rd().qn(s, this.Ki);
        e.length && n.push(e);
        const r = this.gm(), h = this.om ? "right" : "left";
        n.forEach((i)=>{
            i.forEach((i)=>{
                i.Tt($a1a4d31e28ce1f0d$var$u(this.Ki)).st(t, r, this.im, h);
            });
        });
    }
    Em(t) {
        this.lv.style.cursor = 1 === t ? "ns-resize" : "default";
    }
    po() {
        const t = this.bm();
        this.sm < t && this.yt.am().Qt().Pa(), this.sm = t;
    }
    Sm() {
        return $a1a4d31e28ce1f0d$var$x(this.ko.fontSize, this.ko.fontFamily);
    }
}
function $a1a4d31e28ce1f0d$var$On(t, i) {
    return t.Ka?.(i) ?? [];
}
function $a1a4d31e28ce1f0d$var$Nn(t, i) {
    return t.jn?.(i) ?? [];
}
function $a1a4d31e28ce1f0d$var$Fn(t, i) {
    return t.cn?.(i) ?? [];
}
function $a1a4d31e28ce1f0d$var$Wn(t, i) {
    return t.ja?.(i) ?? [];
}
class $a1a4d31e28ce1f0d$var$Hn {
    constructor(i, n){
        this.Qv = (0, $cpKFH.size)({
            width: 0,
            height: 0
        }), this.Lm = null, this.zm = null, this.Om = null, this.Nm = null, this.Fm = !1, this.Wm = new $a1a4d31e28ce1f0d$var$d, this.Hm = new $a1a4d31e28ce1f0d$var$d, this.Um = 0, this.$m = !1, this.jm = null, this.qm = !1, this.Ym = null, this.Km = null, this.rm = !1, this.hm = ()=>{
            this.rm || null === this.Zm || this.sn().mr();
        }, this.lm = ()=>{
            this.rm || null === this.Zm || this.sn().mr();
        }, this.qv = i, this.Zm = n, this.Zm.fu().i(this.Gm.bind(this), this, !0), this.Xm = document.createElement("td"), this.Xm.style.padding = "0", this.Xm.style.position = "relative";
        const s = document.createElement("div");
        s.style.width = "100%", s.style.height = "100%", s.style.position = "relative", s.style.overflow = "hidden", this.Jm = document.createElement("td"), this.Jm.style.padding = "0", this.Qm = document.createElement("td"), this.Qm.style.padding = "0", this.Xm.appendChild(s), this.fm = $a1a4d31e28ce1f0d$var$Dn(s, (0, $cpKFH.size)({
            width: 16,
            height: 16
        })), this.fm.subscribeSuggestedBitmapSizeChanged(this.hm);
        const e = this.fm.canvasElement;
        e.style.position = "absolute", e.style.zIndex = "1", e.style.left = "0", e.style.top = "0", this.pm = $a1a4d31e28ce1f0d$var$Dn(s, (0, $cpKFH.size)({
            width: 16,
            height: 16
        })), this.pm.subscribeSuggestedBitmapSizeChanged(this.lm);
        const r = this.pm.canvasElement;
        r.style.position = "absolute", r.style.zIndex = "2", r.style.left = "0", r.style.top = "0", this.av = document.createElement("tr"), this.av.appendChild(this.Jm), this.av.appendChild(this.Xm), this.av.appendChild(this.Qm), this.tw(), this.tv = new $a1a4d31e28ce1f0d$var$Mn(this.pm.canvasElement, this, {
            xp: ()=>null === this.jm && !this.qv.N().handleScroll.vertTouchDrag,
            Cp: ()=>null === this.jm && !this.qv.N().handleScroll.horzTouchDrag
        });
    }
    m() {
        null !== this.Lm && this.Lm.m(), null !== this.zm && this.zm.m(), this.Om = null, this.pm.unsubscribeSuggestedBitmapSizeChanged(this.lm), $a1a4d31e28ce1f0d$var$In(this.pm.canvasElement), this.pm.dispose(), this.fm.unsubscribeSuggestedBitmapSizeChanged(this.hm), $a1a4d31e28ce1f0d$var$In(this.fm.canvasElement), this.fm.dispose(), null !== this.Zm && (this.Zm.fu().u(this), this.Zm.m()), this.tv.m();
    }
    Sv() {
        return $a1a4d31e28ce1f0d$var$u(this.Zm);
    }
    iw(t) {
        null !== this.Zm && this.Zm.fu().u(this), this.Zm = t, null !== this.Zm && this.Zm.fu().i($a1a4d31e28ce1f0d$var$Hn.prototype.Gm.bind(this), this, !0), this.tw(), this.qv.rv().indexOf(this) === this.qv.rv().length - 1 ? (this.Om = this.Om ?? new $a1a4d31e28ce1f0d$var$Rn(this.Xm, this.qv), this.Om.kt()) : (this.Om?.Kv(), this.Om = null);
    }
    am() {
        return this.qv;
    }
    uv() {
        return this.av;
    }
    tw() {
        if (null !== this.Zm && (this.nw(), 0 !== this.sn().Jn().length)) {
            if (null !== this.Lm) {
                const t = this.Zm.K_();
                this.Lm.un($a1a4d31e28ce1f0d$var$u(t));
            }
            if (null !== this.zm) {
                const t = this.Zm.Z_();
                this.zm.un($a1a4d31e28ce1f0d$var$u(t));
            }
        }
    }
    sw() {
        null !== this.Lm && this.Lm.kt(), null !== this.zm && this.zm.kt();
    }
    z_() {
        return null !== this.Zm ? this.Zm.z_() : 0;
    }
    O_(t) {
        this.Zm && this.Zm.O_(t);
    }
    wp(t) {
        if (!this.Zm) return;
        this.ew();
        const i = t.localX, n = t.localY;
        this.rw(i, n, t);
    }
    zp(t) {
        this.ew(), this.hw(), this.rw(t.localX, t.localY, t);
    }
    Mp(t) {
        if (!this.Zm) return;
        this.ew();
        const i = t.localX, n = t.localY;
        this.rw(i, n, t);
    }
    Vp(t) {
        null !== this.Zm && (this.ew(), this.rw(t.localX, t.localY, t), this.aw(t));
    }
    up(t) {
        null !== this.Zm && this.lw(this.Hm, t);
    }
    ap(t) {
        this.up(t);
    }
    Pp(t) {
        this.ew(), this.ow(t), this.rw(t.localX, t.localY, t);
    }
    Ip(t) {
        null !== this.Zm && (this.ew(), this.$m = !1, this._w(t));
    }
    Dp(t) {
        null !== this.Zm && this.aw(t);
    }
    Kp(t) {
        if (this.$m = !0, null === this.jm) {
            const i = {
                x: t.localX,
                y: t.localY
            };
            this.uw(i, i, t);
        }
    }
    Yp(t) {
        null !== this.Zm && (this.ew(), this.Zm.Qt().kd(null), this.cw());
    }
    dw() {
        return this.Wm;
    }
    fw() {
        return this.Hm;
    }
    Wp() {
        this.Um = 1, this.sn().cs();
    }
    Hp(t, i) {
        if (!this.qv.N().handleScale.pinch) return;
        const n = 5 * (i - this.Um);
        this.Um = i, this.sn().Od(t._t, n);
    }
    Ap(t) {
        this.$m = !1, this.qm = null !== this.jm, this.hw();
        const i = this.sn().Rd();
        null !== this.jm && i.It() && (this.Ym = {
            x: i.ni(),
            y: i.si()
        }, this.jm = {
            x: t.localX,
            y: t.localY
        });
    }
    yp(t) {
        if (null === this.Zm) return;
        const i = t.localX, n = t.localY;
        if (null === this.jm) this.ow(t);
        else {
            this.qm = !1;
            const s = $a1a4d31e28ce1f0d$var$u(this.Ym), e = s.x + (i - this.jm.x), r = s.y + (n - this.jm.y);
            this.rw(e, r, t);
        }
    }
    Rp(t) {
        0 === this.am().N().trackingMode.exitMode && (this.qm = !0), this.pw(), this._w(t);
    }
    Qs(t, i) {
        const n = this.Zm;
        return null === n ? null : $a1a4d31e28ce1f0d$var$Bi(n, t, i);
    }
    mw(i, n) {
        $a1a4d31e28ce1f0d$var$u("left" === n ? this.Lm : this.zm).Cm((0, $cpKFH.size)({
            width: i,
            height: this.Qv.height
        }));
    }
    cv() {
        return this.Qv;
    }
    Cm(t) {
        (0, $cpKFH.equalSizes)(this.Qv, t) || (this.Qv = t, this.rm = !0, this.fm.resizeCanvasElement(t), this.pm.resizeCanvasElement(t), this.rm = !1, this.Xm.style.width = t.width + "px", this.Xm.style.height = t.height + "px");
    }
    ww() {
        const t = $a1a4d31e28ce1f0d$var$u(this.Zm);
        t.q_(t.K_()), t.q_(t.Z_());
        for (const i of t.Cl())if (t.Zs(i)) {
            const n = i.Ft();
            null !== n && t.q_(n), i.Nn();
        }
        for (const i of t.vu())i.Nn();
    }
    dv() {
        return this.fm.bitmapSize;
    }
    fv(t, i, n, s) {
        const e = this.dv();
        if (e.width > 0 && e.height > 0 && (t.drawImage(this.fm.canvasElement, i, n), s)) {
            const s = this.pm.canvasElement;
            null !== t && t.drawImage(s, i, n);
        }
    }
    km(t) {
        if (0 === t) return;
        if (null === this.Zm) return;
        t > 1 && this.ww(), null !== this.Lm && this.Lm.km(t), null !== this.zm && this.zm.km(t);
        const i = {
            colorSpace: this.qv.N().layout.colorSpace
        };
        if (1 !== t) {
            this.fm.applySuggestedBitmapSize();
            const t = (0, $9fJzN.tryCreateCanvasRenderingTarget2D)(this.fm, i);
            null !== t && (t.useBitmapCoordinateSpace((t)=>{
                this.Tm(t);
            }), this.Zm && (this.Mw(t, $a1a4d31e28ce1f0d$var$On), this.gw(t), this.Mw(t, $a1a4d31e28ce1f0d$var$Nn), this.Mw(t, $a1a4d31e28ce1f0d$var$Fn)));
        }
        this.pm.applySuggestedBitmapSize();
        const n = (0, $9fJzN.tryCreateCanvasRenderingTarget2D)(this.pm, i);
        null !== n && (n.useBitmapCoordinateSpace(({ context: t, bitmapSize: i })=>{
            t.clearRect(0, 0, i.width, i.height);
        }), this.bw(n), this.Mw(n, $a1a4d31e28ce1f0d$var$Wn), this.Mw(n, $a1a4d31e28ce1f0d$var$Fn));
    }
    Sw() {
        return this.Lm;
    }
    xw() {
        return this.zm;
    }
    Dm(t, i) {
        this.Mw(t, i);
    }
    Gm() {
        null !== this.Zm && this.Zm.fu().u(this), this.Zm = null;
    }
    aw(t) {
        this.lw(this.Wm, t);
    }
    lw(t, i) {
        const n = i.localX, s = i.localY;
        t.v() && t.p(this.sn().Et().Rc(n), {
            x: n,
            y: s
        }, i);
    }
    Tm({ context: t, bitmapSize: i }) {
        const { width: n, height: s } = i, e = this.sn(), r = e.$(), h = e.ef();
        r === h ? $a1a4d31e28ce1f0d$var$z(t, 0, 0, n, s, h) : $a1a4d31e28ce1f0d$var$F(t, 0, 0, n, s, r, h);
    }
    gw(t) {
        const i = $a1a4d31e28ce1f0d$var$u(this.Zm), n = i.pu().wr().Tt(i);
        null !== n && n.st(t, !1);
    }
    bw(t) {
        this.Cw(t, $a1a4d31e28ce1f0d$var$Nn, $a1a4d31e28ce1f0d$var$Bn, this.sn().Rd());
    }
    Mw(t, i) {
        const n = $a1a4d31e28ce1f0d$var$u(this.Zm), s = n.au(), e = n.vu();
        for (const n of e)this.Cw(t, i, $a1a4d31e28ce1f0d$var$Vn, n);
        for (const n of s)this.Cw(t, i, $a1a4d31e28ce1f0d$var$Vn, n);
        for (const n of e)this.Cw(t, i, $a1a4d31e28ce1f0d$var$Bn, n);
        for (const n of s)this.Cw(t, i, $a1a4d31e28ce1f0d$var$Bn, n);
    }
    Cw(t, i, n, s) {
        const e = $a1a4d31e28ce1f0d$var$u(this.Zm), r = e.Qt().ou(), h = null !== r && r.lu === s, a = null !== r && h && void 0 !== r.wu ? r.wu.ie : void 0;
        $a1a4d31e28ce1f0d$var$En(i, (i)=>n(i, t, h, a), s, e);
    }
    nw() {
        if (null === this.Zm) return;
        const t = this.qv, i = this.Zm.K_().N().visible, n = this.Zm.Z_().N().visible;
        i || null === this.Lm || (this.Jm.removeChild(this.Lm.uv()), this.Lm.m(), this.Lm = null), n || null === this.zm || (this.Qm.removeChild(this.zm.uv()), this.zm.m(), this.zm = null);
        const s = t.Qt().Zd();
        i && null === this.Lm && (this.Lm = new $a1a4d31e28ce1f0d$var$zn(this, t.N(), s, "left"), this.Jm.appendChild(this.Lm.uv())), n && null === this.zm && (this.zm = new $a1a4d31e28ce1f0d$var$zn(this, t.N(), s, "right"), this.Qm.appendChild(this.zm.uv()));
    }
    yw(t) {
        return t.Zp && this.$m || null !== this.jm;
    }
    rw(t, i, n) {
        t = Math.max(0, Math.min(t, this.Qv.width - 1)), i = Math.max(0, Math.min(i, this.Qv.height - 1)), this.sn().jd(t, i, n, $a1a4d31e28ce1f0d$var$u(this.Zm));
    }
    cw() {
        this.sn().Yd();
    }
    pw() {
        this.qm && (this.jm = null, this.cw());
    }
    uw(t, i, n) {
        this.jm = t, this.qm = !1, this.rw(i.x, i.y, n);
        const s = this.sn().Rd();
        this.Ym = {
            x: s.ni(),
            y: s.si()
        };
    }
    sn() {
        return this.qv.Qt();
    }
    _w(t) {
        if (!this.Fm) return;
        const i = this.sn(), n = this.Sv();
        if (i.iu(n, n.Pn()), this.Nm = null, this.Fm = !1, i.Hd(), null !== this.Km) {
            const t = performance.now(), n = i.Et();
            this.Km.me(n.Ac(), t), this.Km.jc(t) || i.ps(this.Km);
        }
    }
    ew() {
        this.jm = null;
    }
    hw() {
        if (!this.Zm) return;
        if (this.sn().cs(), document.activeElement !== document.body && document.activeElement !== document.documentElement) $a1a4d31e28ce1f0d$var$u(document.activeElement).blur();
        else {
            const t = document.getSelection();
            null !== t && t.removeAllRanges();
        }
        !this.Zm.Pn().Gi() && this.sn().Et().Gi();
    }
    ow(t) {
        if (null === this.Zm) return;
        const i = this.sn(), n = i.Et();
        if (n.Gi()) return;
        const s = this.qv.N(), e = s.handleScroll, r = s.kineticScroll;
        if ((!e.pressedMouseMove || t.Zp) && (!e.horzTouchDrag && !e.vertTouchDrag || !t.Zp)) return;
        const h = this.Zm.Pn(), a = performance.now();
        if (null !== this.Nm || this.yw(t) || (this.Nm = {
            x: t.clientX,
            y: t.clientY,
            Sf: a,
            kw: t.localX,
            Pw: t.localY
        }), null !== this.Nm && !this.Fm && (this.Nm.x !== t.clientX || this.Nm.y !== t.clientY)) {
            if (t.Zp && r.touch || !t.Zp && r.mouse) {
                const t = n.fl();
                this.Km = new $a1a4d31e28ce1f0d$var$Tn(.2 / t, 7 / t, .997, 15 / t), this.Km.Fv(n.Ac(), this.Nm.Sf);
            } else this.Km = null;
            h.Gi() || i.Q_(this.Zm, h, t.localY), i.Fd(t.localX), this.Fm = !0;
        }
        this.Fm && (h.Gi() || i.tu(this.Zm, h, t.localY), i.Wd(t.localX), null !== this.Km && this.Km.Fv(n.Ac(), a));
    }
}
class $a1a4d31e28ce1f0d$var$Un {
    constructor(i, n, s, e, r){
        this.xt = !0, this.Qv = (0, $cpKFH.size)({
            width: 0,
            height: 0
        }), this.hm = ()=>this.km(3), this.om = "left" === i, this.wd = s.Zd, this.yn = n, this.Tw = e, this.Rw = r, this.lv = document.createElement("div"), this.lv.style.width = "25px", this.lv.style.height = "100%", this.lv.style.overflow = "hidden", this.fm = $a1a4d31e28ce1f0d$var$Dn(this.lv, (0, $cpKFH.size)({
            width: 16,
            height: 16
        })), this.fm.subscribeSuggestedBitmapSizeChanged(this.hm);
    }
    m() {
        this.fm.unsubscribeSuggestedBitmapSizeChanged(this.hm), $a1a4d31e28ce1f0d$var$In(this.fm.canvasElement), this.fm.dispose();
    }
    uv() {
        return this.lv;
    }
    cv() {
        return this.Qv;
    }
    Cm(t) {
        (0, $cpKFH.equalSizes)(this.Qv, t) || (this.Qv = t, this.fm.resizeCanvasElement(t), this.lv.style.width = `${t.width}px`, this.lv.style.height = `${t.height}px`, this.xt = !0);
    }
    km(t) {
        if (t < 3 && !this.xt) return;
        if (0 === this.Qv.width || 0 === this.Qv.height) return;
        this.xt = !1, this.fm.applySuggestedBitmapSize();
        const i = (0, $9fJzN.tryCreateCanvasRenderingTarget2D)(this.fm, {
            colorSpace: this.yn.layout.colorSpace
        });
        null !== i && i.useBitmapCoordinateSpace((t)=>{
            this.Tm(t), this.Rm(t);
        });
    }
    dv() {
        return this.fm.bitmapSize;
    }
    fv(t, i, n) {
        const s = this.dv();
        s.width > 0 && s.height > 0 && t.drawImage(this.fm.canvasElement, i, n);
    }
    Rm({ context: t, bitmapSize: i, horizontalPixelRatio: n, verticalPixelRatio: s }) {
        if (!this.Tw()) return;
        t.fillStyle = this.yn.timeScale.borderColor;
        const e = Math.floor(this.wd.N().S * n), r = Math.floor(this.wd.N().S * s), h = this.om ? i.width - e : 0;
        t.fillRect(h, 0, e, r);
    }
    Tm({ context: t, bitmapSize: i }) {
        $a1a4d31e28ce1f0d$var$z(t, 0, 0, i.width, i.height, this.Rw());
    }
}
function $a1a4d31e28ce1f0d$var$$n(t) {
    return (i)=>i.Xa?.(t) ?? [];
}
const $a1a4d31e28ce1f0d$var$jn = $a1a4d31e28ce1f0d$var$$n("normal"), $a1a4d31e28ce1f0d$var$qn = $a1a4d31e28ce1f0d$var$$n("top"), $a1a4d31e28ce1f0d$var$Yn = $a1a4d31e28ce1f0d$var$$n("bottom");
class $a1a4d31e28ce1f0d$var$Kn {
    constructor(i, n){
        this.Dw = null, this.Iw = null, this.M = null, this.Vw = !1, this.Qv = (0, $cpKFH.size)({
            width: 0,
            height: 0
        }), this.Bw = new $a1a4d31e28ce1f0d$var$d, this.im = new $a1a4d31e28ce1f0d$var$rt(5), this.rm = !1, this.hm = ()=>{
            this.rm || this.qv.Qt().mr();
        }, this.lm = ()=>{
            this.rm || this.qv.Qt().mr();
        }, this.qv = i, this.xu = n, this.yn = i.N().layout, this.Hv = document.createElement("tr"), this.Ew = document.createElement("td"), this.Ew.style.padding = "0", this.Aw = document.createElement("td"), this.Aw.style.padding = "0", this.lv = document.createElement("td"), this.lv.style.height = "25px", this.lv.style.padding = "0", this.Lw = document.createElement("div"), this.Lw.style.width = "100%", this.Lw.style.height = "100%", this.Lw.style.position = "relative", this.Lw.style.overflow = "hidden", this.lv.appendChild(this.Lw), this.fm = $a1a4d31e28ce1f0d$var$Dn(this.Lw, (0, $cpKFH.size)({
            width: 16,
            height: 16
        })), this.fm.subscribeSuggestedBitmapSizeChanged(this.hm);
        const s = this.fm.canvasElement;
        s.style.position = "absolute", s.style.zIndex = "1", s.style.left = "0", s.style.top = "0", this.pm = $a1a4d31e28ce1f0d$var$Dn(this.Lw, (0, $cpKFH.size)({
            width: 16,
            height: 16
        })), this.pm.subscribeSuggestedBitmapSizeChanged(this.lm);
        const e = this.pm.canvasElement;
        e.style.position = "absolute", e.style.zIndex = "2", e.style.left = "0", e.style.top = "0", this.Hv.appendChild(this.Ew), this.Hv.appendChild(this.lv), this.Hv.appendChild(this.Aw), this.zw(), this.qv.Qt().L_().i(this.zw.bind(this), this), this.tv = new $a1a4d31e28ce1f0d$var$Mn(this.pm.canvasElement, this, {
            xp: ()=>!0,
            Cp: ()=>!this.qv.N().handleScroll.horzTouchDrag
        });
    }
    m() {
        this.tv.m(), null !== this.Dw && this.Dw.m(), null !== this.Iw && this.Iw.m(), this.pm.unsubscribeSuggestedBitmapSizeChanged(this.lm), $a1a4d31e28ce1f0d$var$In(this.pm.canvasElement), this.pm.dispose(), this.fm.unsubscribeSuggestedBitmapSizeChanged(this.hm), $a1a4d31e28ce1f0d$var$In(this.fm.canvasElement), this.fm.dispose();
    }
    uv() {
        return this.Hv;
    }
    Ow() {
        return this.Dw;
    }
    Nw() {
        return this.Iw;
    }
    zp(t) {
        if (this.Vw) return;
        this.Vw = !0;
        const i = this.qv.Qt();
        !i.Et().Gi() && this.qv.N().handleScale.axisPressedMouseMove.time && i.zd(t.localX);
    }
    Ap(t) {
        this.zp(t);
    }
    Op() {
        const t = this.qv.Qt();
        !t.Et().Gi() && this.Vw && (this.Vw = !1, this.qv.N().handleScale.axisPressedMouseMove.time && t.$d());
    }
    Pp(t) {
        const i = this.qv.Qt();
        !i.Et().Gi() && this.qv.N().handleScale.axisPressedMouseMove.time && i.Ud(t.localX);
    }
    yp(t) {
        this.Pp(t);
    }
    Ip() {
        this.Vw = !1;
        const t = this.qv.Qt();
        t.Et().Gi() && !this.qv.N().handleScale.axisPressedMouseMove.time || t.$d();
    }
    Rp() {
        this.Ip();
    }
    up() {
        this.qv.N().handleScale.axisDoubleClickReset.time && this.qv.Qt().ws();
    }
    ap() {
        this.up();
    }
    wp() {
        this.qv.Qt().N().handleScale.axisPressedMouseMove.time && this.Em(1);
    }
    Yp() {
        this.Em(0);
    }
    cv() {
        return this.Qv;
    }
    Fw() {
        return this.Bw;
    }
    Ww(i, s, e) {
        (0, $cpKFH.equalSizes)(this.Qv, i) || (this.Qv = i, this.rm = !0, this.fm.resizeCanvasElement(i), this.pm.resizeCanvasElement(i), this.rm = !1, this.lv.style.width = `${i.width}px`, this.lv.style.height = `${i.height}px`, this.Bw.p(i)), null !== this.Dw && this.Dw.Cm((0, $cpKFH.size)({
            width: s,
            height: i.height
        })), null !== this.Iw && this.Iw.Cm((0, $cpKFH.size)({
            width: e,
            height: i.height
        }));
    }
    Hw() {
        const t = this.Uw();
        return Math.ceil(t.S + t.C + t.k + t.A + t.I + t.$w);
    }
    kt() {
        this.qv.Qt().Et().El();
    }
    dv() {
        return this.fm.bitmapSize;
    }
    fv(t, i, n, s) {
        const e = this.dv();
        if (e.width > 0 && e.height > 0 && (t.drawImage(this.fm.canvasElement, i, n), s)) {
            const s = this.pm.canvasElement;
            t.drawImage(s, i, n);
        }
    }
    km(t) {
        if (0 === t) return;
        const i = {
            colorSpace: this.yn.colorSpace
        };
        if (1 !== t) {
            this.fm.applySuggestedBitmapSize();
            const n = (0, $9fJzN.tryCreateCanvasRenderingTarget2D)(this.fm, i);
            null !== n && (n.useBitmapCoordinateSpace((t)=>{
                this.Tm(t), this.Rm(t), this.jw(n, $a1a4d31e28ce1f0d$var$Yn);
            }), this.Im(n), this.jw(n, $a1a4d31e28ce1f0d$var$jn)), null !== this.Dw && this.Dw.km(t), null !== this.Iw && this.Iw.km(t);
        }
        this.pm.applySuggestedBitmapSize();
        const n = (0, $9fJzN.tryCreateCanvasRenderingTarget2D)(this.pm, i);
        null !== n && (n.useBitmapCoordinateSpace(({ context: t, bitmapSize: i })=>{
            t.clearRect(0, 0, i.width, i.height);
        }), this.qw([
            ...this.qv.Qt().Jn(),
            this.qv.Qt().Rd()
        ], n), this.jw(n, $a1a4d31e28ce1f0d$var$qn));
    }
    jw(t, i) {
        const n = this.qv.Qt().Jn();
        for (const s of n)$a1a4d31e28ce1f0d$var$En(i, (i)=>$a1a4d31e28ce1f0d$var$Vn(i, t, !1, void 0), s, void 0);
        for (const s of n)$a1a4d31e28ce1f0d$var$En(i, (i)=>$a1a4d31e28ce1f0d$var$Bn(i, t, !1, void 0), s, void 0);
    }
    Tm({ context: t, bitmapSize: i }) {
        $a1a4d31e28ce1f0d$var$z(t, 0, 0, i.width, i.height, this.qv.Qt().ef());
    }
    Rm({ context: t, bitmapSize: i, verticalPixelRatio: n }) {
        if (this.qv.N().timeScale.borderVisible) {
            t.fillStyle = this.Yw();
            const s = Math.max(1, Math.floor(this.Uw().S * n));
            t.fillRect(0, 0, i.width, s);
        }
    }
    Im(t) {
        const i = this.qv.Qt().Et(), n = i.El();
        if (!n || 0 === n.length) return;
        const s = this.xu.maxTickMarkWeight(n), e = this.Uw(), r = i.N();
        r.borderVisible && r.ticksVisible && t.useBitmapCoordinateSpace(({ context: t, horizontalPixelRatio: i, verticalPixelRatio: s })=>{
            t.strokeStyle = this.Yw(), t.fillStyle = this.Yw();
            const r = Math.max(1, Math.floor(i)), h = Math.floor(.5 * i);
            t.beginPath();
            const a = Math.round(e.C * s);
            for(let s = n.length; s--;){
                const e = Math.round(n[s].coord * i);
                t.rect(e - h, 0, r, a);
            }
            t.fill();
        }), t.useMediaCoordinateSpace(({ context: t })=>{
            const i = e.S + e.C + e.A + e.k / 2;
            t.textAlign = "center", t.textBaseline = "middle", t.fillStyle = this.H(), t.font = this.Sm();
            for (const e of n)if (e.weight < s) {
                const n = e.needAlignCoordinate ? this.Kw(t, e.coord, e.label) : e.coord;
                t.fillText(e.label, n, i);
            }
            this.qv.N().timeScale.allowBoldLabels && (t.font = this.Zw());
            for (const e of n)if (e.weight >= s) {
                const n = e.needAlignCoordinate ? this.Kw(t, e.coord, e.label) : e.coord;
                t.fillText(e.label, n, i);
            }
        });
    }
    Kw(t, i, n) {
        const s = this.im.Ii(t, n), e = s / 2, r = Math.floor(i - e) + .5;
        return r < 0 ? i += Math.abs(0 - r) : r + s > this.Qv.width && (i -= Math.abs(this.Qv.width - (r + s))), i;
    }
    qw(t, i) {
        const n = this.Uw();
        for (const s of t)for (const t of s.dn())t.Tt().st(i, n);
    }
    Yw() {
        return this.qv.N().timeScale.borderColor;
    }
    H() {
        return this.yn.textColor;
    }
    F() {
        return this.yn.fontSize;
    }
    Sm() {
        return $a1a4d31e28ce1f0d$var$x(this.F(), this.yn.fontFamily);
    }
    Zw() {
        return $a1a4d31e28ce1f0d$var$x(this.F(), this.yn.fontFamily, "bold");
    }
    Uw() {
        null === this.M && (this.M = {
            S: 1,
            L: NaN,
            A: NaN,
            I: NaN,
            tn: NaN,
            C: 5,
            k: NaN,
            P: "",
            Qi: new $a1a4d31e28ce1f0d$var$rt,
            $w: 0
        });
        const t = this.M, i = this.Sm();
        if (t.P !== i) {
            const n = this.F();
            t.k = n, t.P = i, t.A = 3 * n / 12, t.I = 3 * n / 12, t.tn = 9 * n / 12, t.L = 0, t.$w = 4 * n / 12, t.Qi.Os();
        }
        return this.M;
    }
    Em(t) {
        this.lv.style.cursor = 1 === t ? "ew-resize" : "default";
    }
    zw() {
        const t = this.qv.Qt(), i = t.N();
        i.leftPriceScale.visible || null === this.Dw || (this.Ew.removeChild(this.Dw.uv()), this.Dw.m(), this.Dw = null), i.rightPriceScale.visible || null === this.Iw || (this.Aw.removeChild(this.Iw.uv()), this.Iw.m(), this.Iw = null);
        const n = {
            Zd: this.qv.Qt().Zd()
        }, s = ()=>i.leftPriceScale.borderVisible && t.Et().N().borderVisible, e = ()=>t.ef();
        i.leftPriceScale.visible && null === this.Dw && (this.Dw = new $a1a4d31e28ce1f0d$var$Un("left", i, n, s, e), this.Ew.appendChild(this.Dw.uv())), i.rightPriceScale.visible && null === this.Iw && (this.Iw = new $a1a4d31e28ce1f0d$var$Un("right", i, n, s, e), this.Aw.appendChild(this.Iw.uv()));
    }
}
const $a1a4d31e28ce1f0d$var$Zn = !!$a1a4d31e28ce1f0d$var$dn && !!navigator.userAgentData && navigator.userAgentData.brands.some((t)=>t.brand.includes("Chromium")) && !!$a1a4d31e28ce1f0d$var$dn && (navigator?.userAgentData?.platform ? "Windows" === navigator.userAgentData.platform : navigator.userAgent.toLowerCase().indexOf("win") >= 0);
class $a1a4d31e28ce1f0d$var$Gn {
    constructor(t, i, n){
        var s;
        this.Gw = [], this.Xw = [], this.Jw = 0, this.ho = 0, this.C_ = 0, this.Qw = 0, this.tM = 0, this.iM = null, this.nM = !1, this.Wm = new $a1a4d31e28ce1f0d$var$d, this.Hm = new $a1a4d31e28ce1f0d$var$d, this.pd = new $a1a4d31e28ce1f0d$var$d, this.sM = null, this.eM = null, this.jv = t, this.yn = i, this.xu = n, this.Hv = document.createElement("div"), this.Hv.classList.add("tv-lightweight-charts"), this.Hv.style.overflow = "hidden", this.Hv.style.direction = "ltr", this.Hv.style.width = "100%", this.Hv.style.height = "100%", (s = this.Hv).style.userSelect = "none", s.style.webkitUserSelect = "none", s.style.msUserSelect = "none", s.style.MozUserSelect = "none", s.style.webkitTapHighlightColor = "transparent", this.rM = document.createElement("table"), this.rM.setAttribute("cellspacing", "0"), this.Hv.appendChild(this.rM), this.hM = this.aM.bind(this), $a1a4d31e28ce1f0d$var$Xn(this.yn) && this.lM(!0), this.sn = new $a1a4d31e28ce1f0d$var$qi(this.md.bind(this), this.yn, n), this.Qt().Dd().i(this.oM.bind(this), this), this._M = new $a1a4d31e28ce1f0d$var$Kn(this, this.xu), this.rM.appendChild(this._M.uv());
        const e = i.autoSize && this.uM();
        let r = this.yn.width, h = this.yn.height;
        if (e || 0 === r || 0 === h) {
            const i = t.getBoundingClientRect();
            r = r || i.width, h = h || i.height;
        }
        this.cM(r, h), this.dM(), t.appendChild(this.Hv), this.fM(), this.sn.Et().Zc().i(this.sn.Pa.bind(this.sn), this), this.sn.L_().i(this.sn.Pa.bind(this.sn), this);
    }
    Qt() {
        return this.sn;
    }
    N() {
        return this.yn;
    }
    rv() {
        return this.Gw;
    }
    pM() {
        return this._M;
    }
    m() {
        this.lM(!1), 0 !== this.Jw && window.cancelAnimationFrame(this.Jw), this.sn.Dd().u(this), this.sn.Et().Zc().u(this), this.sn.L_().u(this), this.sn.m();
        for (const t of this.Gw)this.rM.removeChild(t.uv()), t.dw().u(this), t.fw().u(this), t.m();
        this.Gw = [];
        for (const t of this.Xw)this.vM(t);
        this.Xw = [], $a1a4d31e28ce1f0d$var$u(this._M).m(), null !== this.Hv.parentElement && this.Hv.parentElement.removeChild(this.Hv), this.pd.m(), this.Wm.m(), this.Hm.m(), this.mM();
    }
    cM(i, n, s = !1) {
        if (this.ho === n && this.C_ === i) return;
        const e = function(i) {
            const n = Math.floor(i.width), s = Math.floor(i.height);
            return (0, $cpKFH.size)({
                width: n - n % 2,
                height: s - s % 2
            });
        }((0, $cpKFH.size)({
            width: i,
            height: n
        }));
        this.ho = e.height, this.C_ = e.width;
        const r = this.ho + "px", h = this.C_ + "px";
        if (this.wM() || ($a1a4d31e28ce1f0d$var$u(this.Hv).style.height = r, $a1a4d31e28ce1f0d$var$u(this.Hv).style.width = h), this.rM.style.height = r, this.rM.style.width = h, s) {
            0 !== this.Jw && (window.cancelAnimationFrame(this.Jw), this.Jw = 0), this.nM = !1;
            const t = $a1a4d31e28ce1f0d$var$X.ys();
            null !== this.iM && (t.Ss(this.iM), this.iM = null), this.MM(t, performance.now());
        } else this.sn.Pa();
    }
    km(t) {
        void 0 === t && (t = $a1a4d31e28ce1f0d$var$X.ys());
        for(let i = 0; i < this.Gw.length; i++)this.Gw[i].km(t._s(i).rs);
        this.yn.timeScale.visible && this._M.km(t.ls());
    }
    vr(t) {
        const i = $a1a4d31e28ce1f0d$var$Xn(this.yn);
        this.sn.vr(t);
        const n = $a1a4d31e28ce1f0d$var$Xn(this.yn);
        n !== i && this.lM(n), t.layout?.panes && this.gM(), this.fM(), this.bM(t);
    }
    dw() {
        return this.Wm;
    }
    fw() {
        return this.Hm;
    }
    Dd() {
        return this.pd;
    }
    SM(t = !1) {
        null !== this.iM && (this.MM(this.iM, performance.now()), this.iM = null);
        const i = this.xM(null), n = document.createElement("canvas");
        n.width = i.width, n.height = i.height;
        const s = $a1a4d31e28ce1f0d$var$u(n.getContext("2d"));
        return this.xM(s, t), n;
    }
    CM(t) {
        if ("left" === t && !this.yM()) return 0;
        if ("right" === t && !this.kM()) return 0;
        if (0 === this.Gw.length) return 0;
        return $a1a4d31e28ce1f0d$var$u("left" === t ? this.Gw[0].Sw() : this.Gw[0].xw()).ym();
    }
    wM() {
        return this.yn.autoSize && null !== this.sM;
    }
    vv() {
        return this.Hv;
    }
    PM(t) {
        this.eM = t, this.eM ? this.vv().style.setProperty("cursor", t) : this.vv().style.removeProperty("cursor");
    }
    TM() {
        return this.eM;
    }
    RM(t) {
        return $a1a4d31e28ce1f0d$var$_(this.Gw[t]).cv();
    }
    gM() {
        this.Xw.forEach((t)=>{
            t.kt();
        });
    }
    bM(t) {
        (void 0 !== t.autoSize || !this.sM || void 0 === t.width && void 0 === t.height) && (t.autoSize && !this.sM && this.uM(), !1 === t.autoSize && null !== this.sM && this.mM(), t.autoSize || void 0 === t.width && void 0 === t.height || this.cM(t.width || this.C_, t.height || this.ho));
    }
    xM(i, n) {
        let s = 0, e = 0;
        const r = this.Gw[0], h = (t, s)=>{
            let e = 0;
            for(let r = 0; r < this.Gw.length; r++){
                const h = this.Gw[r], a = $a1a4d31e28ce1f0d$var$u("left" === t ? h.Sw() : h.xw()), l = a.dv();
                if (null !== i && a.fv(i, s, e, n), e += l.height, r < this.Gw.length - 1) {
                    const t = this.Xw[r], n = t.dv();
                    null !== i && t.fv(i, s, e), e += n.height;
                }
            }
        };
        if (this.yM()) {
            h("left", 0);
            s += $a1a4d31e28ce1f0d$var$u(r.Sw()).dv().width;
        }
        for(let t = 0; t < this.Gw.length; t++){
            const r = this.Gw[t], h = r.dv();
            if (null !== i && r.fv(i, s, e, n), e += h.height, t < this.Gw.length - 1) {
                const n = this.Xw[t], r = n.dv();
                null !== i && n.fv(i, s, e), e += r.height;
            }
        }
        if (s += r.dv().width, this.kM()) {
            h("right", s);
            s += $a1a4d31e28ce1f0d$var$u(r.xw()).dv().width;
        }
        const a = (t, n, s)=>{
            $a1a4d31e28ce1f0d$var$u("left" === t ? this._M.Ow() : this._M.Nw()).fv($a1a4d31e28ce1f0d$var$u(i), n, s);
        };
        if (this.yn.timeScale.visible) {
            const t = this._M.dv();
            if (null !== i) {
                let s = 0;
                this.yM() && (a("left", s, e), s = $a1a4d31e28ce1f0d$var$u(r.Sw()).dv().width), this._M.fv(i, s, e, n), s += t.width, this.kM() && a("right", s, e);
            }
            e += t.height;
        }
        return (0, $cpKFH.size)({
            width: s,
            height: e
        });
    }
    DM() {
        let i = 0, n = 0, s = 0;
        for (const t of this.Gw)this.yM() && (n = Math.max(n, $a1a4d31e28ce1f0d$var$u(t.Sw()).bm(), this.yn.leftPriceScale.minimumWidth)), this.kM() && (s = Math.max(s, $a1a4d31e28ce1f0d$var$u(t.xw()).bm(), this.yn.rightPriceScale.minimumWidth)), i += t.z_();
        n = $a1a4d31e28ce1f0d$var$mn(n), s = $a1a4d31e28ce1f0d$var$mn(s);
        const e = this.C_, r = this.ho, h = Math.max(e - n - s, 0), a = 1 * this.Xw.length, l = this.yn.timeScale.visible;
        let o = l ? Math.max(this._M.Hw(), this.yn.timeScale.minimumHeight) : 0;
        var _;
        o = (_ = o) + _ % 2;
        const c = a + o, d = r < c ? 0 : r - c, f = d / i;
        let p = 0;
        const v = window.devicePixelRatio || 1;
        for(let i = 0; i < this.Gw.length; ++i){
            const e = this.Gw[i];
            e.iw(this.sn.Zn()[i]);
            let r = 0, a = 0;
            a = i === this.Gw.length - 1 ? Math.ceil((d - p) * v) / v : Math.round(e.z_() * f * v) / v, r = Math.max(a, 2), p += r, e.Cm((0, $cpKFH.size)({
                width: h,
                height: r
            })), this.yM() && e.mw(n, "left"), this.kM() && e.mw(s, "right"), e.Sv() && this.sn.Id(e.Sv(), r);
        }
        this._M.Ww((0, $cpKFH.size)({
            width: l ? h : 0,
            height: o
        }), l ? n : 0, l ? s : 0), this.sn.N_(h), this.Qw !== n && (this.Qw = n), this.tM !== s && (this.tM = s);
    }
    lM(t) {
        t ? this.Hv.addEventListener("wheel", this.hM, {
            passive: !1
        }) : this.Hv.removeEventListener("wheel", this.hM);
    }
    IM(t) {
        switch(t.deltaMode){
            case t.DOM_DELTA_PAGE:
                return 120;
            case t.DOM_DELTA_LINE:
                return 32;
        }
        return $a1a4d31e28ce1f0d$var$Zn ? 1 / window.devicePixelRatio : 1;
    }
    aM(t) {
        if (!(0 !== t.deltaX && this.yn.handleScroll.mouseWheel || 0 !== t.deltaY && this.yn.handleScale.mouseWheel)) return;
        const i = this.IM(t), n = i * t.deltaX / 100, s = -i * t.deltaY / 100;
        if (t.cancelable && t.preventDefault(), 0 !== s && this.yn.handleScale.mouseWheel) {
            const i = Math.sign(s) * Math.min(1, Math.abs(s)), n = t.clientX - this.Hv.getBoundingClientRect().left;
            this.Qt().Od(n, i);
        }
        0 !== n && this.yn.handleScroll.mouseWheel && this.Qt().Nd(-80 * n);
    }
    MM(t, i) {
        const n = t.ls();
        3 === n && this.VM(), 3 !== n && 2 !== n || (this.BM(t), this.EM(t, i), this._M.kt(), this.Gw.forEach((t)=>{
            t.sw();
        }), 3 === this.iM?.ls() && (this.iM.Ss(t), this.VM(), this.BM(this.iM), this.EM(this.iM, i), t = this.iM, this.iM = null)), this.km(t);
    }
    EM(t, i) {
        for (const n of t.bs())this.xs(n, i);
    }
    BM(t) {
        const i = this.sn.Zn();
        for(let n = 0; n < i.length; n++)t._s(n).hs && i[n].ru();
    }
    xs(t, i) {
        const n = this.sn.Et();
        switch(t.ds){
            case 0:
                n.Xc();
                break;
            case 1:
                n.Jc(t.Wt);
                break;
            case 2:
                n.Ms(t.Wt);
                break;
            case 3:
                n.gs(t.Wt);
                break;
            case 4:
                n.Oc();
                break;
            case 5:
                t.Wt.jc(i) || n.gs(t.Wt.qc(i));
        }
    }
    md(t) {
        null !== this.iM ? this.iM.Ss(t) : this.iM = t, this.nM || (this.nM = !0, this.Jw = window.requestAnimationFrame((t)=>{
            if (this.nM = !1, this.Jw = 0, null !== this.iM) {
                const i = this.iM;
                this.iM = null, this.MM(i, t);
                for (const n of i.bs())if (5 === n.ds && !n.Wt.jc(t)) {
                    this.Qt().ps(n.Wt);
                    break;
                }
            }
        }));
    }
    VM() {
        this.dM();
    }
    vM(t) {
        this.rM.removeChild(t.uv()), t.m();
    }
    dM() {
        const t = this.sn.Zn(), i = t.length, n = this.Gw.length;
        for(let t = i; t < n; t++){
            const t = $a1a4d31e28ce1f0d$var$_(this.Gw.pop());
            this.rM.removeChild(t.uv()), t.dw().u(this), t.fw().u(this), t.m();
            const i = this.Xw.pop();
            void 0 !== i && this.vM(i);
        }
        for(let s = n; s < i; s++){
            const i = new $a1a4d31e28ce1f0d$var$Hn(this, t[s]);
            if (i.dw().i(this.AM.bind(this, i), this), i.fw().i(this.LM.bind(this, i), this), this.Gw.push(i), s > 0) {
                const t = new $a1a4d31e28ce1f0d$var$yn(this, s - 1, s);
                this.Xw.push(t), this.rM.insertBefore(t.uv(), this._M.uv());
            }
            this.rM.insertBefore(i.uv(), this._M.uv());
        }
        for(let n = 0; n < i; n++){
            const i = t[n], s = this.Gw[n];
            s.Sv() !== i ? s.iw(i) : s.tw();
        }
        this.fM(), this.DM();
    }
    zM(t, i, n, s) {
        const e = new Map;
        if (null !== t) this.sn.Jn().forEach((i)=>{
            const n = i.Un().Hn(t);
            null !== n && e.set(i, n);
        });
        let r;
        if (null !== t) {
            const i = this.sn.Et().en(t)?.originalTime;
            void 0 !== i && (r = i);
        }
        const h = this.Qt().ou(), a = this.OM(s), l = function(t, i) {
            const n = null !== t && t.lu instanceof $a1a4d31e28ce1f0d$var$Jt ? t.lu : void 0, s = t?.wu?.te, e = void 0 !== i && -1 !== i ? i : void 0;
            var r, h;
            return null === t || void 0 === t.ee ? {
                NM: n,
                FM: s
            } : {
                NM: n,
                FM: s,
                WM: {
                    ds: t.ee,
                    HM: (r = t.lu, h = t.ee, r instanceof $a1a4d31e28ce1f0d$var$ki ? "pane-primitive" : "marker" === h || "primitive" === h ? "series-primitive" : "series"),
                    UM: $a1a4d31e28ce1f0d$var$vn(t.ee, s),
                    U_: n,
                    $M: s,
                    jM: e
                }
            };
        }(h, a);
        return {
            Qr: r,
            $n: t ?? void 0,
            qM: i ?? void 0,
            jM: -1 !== a ? a : void 0,
            NM: l.NM,
            YM: e,
            FM: l.FM,
            WM: l.WM,
            KM: n ?? void 0
        };
    }
    OM(t) {
        let i = -1;
        if (t) i = this.Gw.indexOf(t);
        else {
            const t = this.Qt().Rd().Kn();
            null !== t && (i = this.Qt().Zn().indexOf(t));
        }
        return i;
    }
    AM(t, i, n, s) {
        this.Wm.p(()=>this.zM(i, n, s, t));
    }
    LM(t, i, n, s) {
        this.Hm.p(()=>this.zM(i, n, s, t));
    }
    oM(t, i, n) {
        this.PM(this.Qt().ou()?.mu ?? null), this.pd.p(()=>this.zM(t, i, n));
    }
    fM() {
        const t = this.yn.timeScale.visible ? "" : "none";
        this._M.uv().style.display = t;
    }
    yM() {
        return this.Gw[0].Sv().K_().N().visible;
    }
    kM() {
        return this.Gw[0].Sv().Z_().N().visible;
    }
    uM() {
        return "ResizeObserver" in window && (this.sM = new ResizeObserver((t)=>{
            const i = t[t.length - 1];
            if (!i) return;
            const n = i.contentRect.width, s = i.contentRect.height;
            this.cM(n, s, !0);
        }), this.sM.observe(this.jv, {
            box: "border-box"
        }), !0);
    }
    mM() {
        null !== this.sM && this.sM.disconnect(), this.sM = null;
    }
}
function $a1a4d31e28ce1f0d$var$Xn(t) {
    return Boolean(t.handleScroll.mouseWheel || t.handleScale.mouseWheel);
}
function $a1a4d31e28ce1f0d$var$Jn(t) {
    return void 0 === t.open && void 0 === t.value;
}
function $a1a4d31e28ce1f0d$var$Qn(t) {
    return function(t) {
        return void 0 !== t.open;
    }(t) || function(t) {
        return void 0 !== t.value;
    }(t);
}
function $a1a4d31e28ce1f0d$var$ts(t, i, n, s) {
    const e = n.value, r = {
        $n: i,
        wt: t,
        Wt: [
            e,
            e,
            e,
            e
        ],
        Qr: s
    };
    return void 0 !== n.color && (r.R = n.color), r;
}
function $a1a4d31e28ce1f0d$var$is(t, i, n, s) {
    const e = n.value, r = {
        $n: i,
        wt: t,
        Wt: [
            e,
            e,
            e,
            e
        ],
        Qr: s
    };
    return void 0 !== n.lineColor && (r.vt = n.lineColor), void 0 !== n.topColor && (r.ah = n.topColor), void 0 !== n.bottomColor && (r.oh = n.bottomColor), r;
}
function $a1a4d31e28ce1f0d$var$ns(t, i, n, s) {
    const e = n.value, r = {
        $n: i,
        wt: t,
        Wt: [
            e,
            e,
            e,
            e
        ],
        Qr: s
    };
    return void 0 !== n.topLineColor && (r._h = n.topLineColor), void 0 !== n.bottomLineColor && (r.uh = n.bottomLineColor), void 0 !== n.topFillColor1 && (r.dh = n.topFillColor1), void 0 !== n.topFillColor2 && (r.fh = n.topFillColor2), void 0 !== n.bottomFillColor1 && (r.ph = n.bottomFillColor1), void 0 !== n.bottomFillColor2 && (r.mh = n.bottomFillColor2), r;
}
function $a1a4d31e28ce1f0d$var$ss(t, i, n, s) {
    const e = {
        $n: i,
        wt: t,
        Wt: [
            n.open,
            n.high,
            n.low,
            n.close
        ],
        Qr: s
    };
    return void 0 !== n.color && (e.R = n.color), e;
}
function $a1a4d31e28ce1f0d$var$es(t, i, n, s) {
    const e = {
        $n: i,
        wt: t,
        Wt: [
            n.open,
            n.high,
            n.low,
            n.close
        ],
        Qr: s
    };
    return void 0 !== n.color && (e.R = n.color), void 0 !== n.borderColor && (e.Ht = n.borderColor), void 0 !== n.wickColor && (e.hh = n.wickColor), e;
}
function $a1a4d31e28ce1f0d$var$rs(t, i, n, s, e) {
    const r = $a1a4d31e28ce1f0d$var$_(e)(n), h = Math.max(...r), a = Math.min(...r), l = r[r.length - 1], o = [
        l,
        h,
        a,
        l
    ], { time: u, color: c, ...d } = n;
    return {
        $n: i,
        wt: t,
        Wt: o,
        Qr: s,
        ue: d,
        R: c
    };
}
function $a1a4d31e28ce1f0d$var$hs(t) {
    return void 0 !== t.Wt;
}
function $a1a4d31e28ce1f0d$var$as(t, i) {
    return void 0 !== i.customValues && (t.ZM = i.customValues), t;
}
function $a1a4d31e28ce1f0d$var$ls(t) {
    return (i, n, s, e, r, h)=>(function(t, i) {
            return i ? i(t) : $a1a4d31e28ce1f0d$var$Jn(t);
        })(s, h) ? $a1a4d31e28ce1f0d$var$as({
            wt: i,
            $n: n,
            Qr: e
        }, s) : $a1a4d31e28ce1f0d$var$as(t(i, n, s, e, r), s);
}
function $a1a4d31e28ce1f0d$var$os(t) {
    return ({
        Candlestick: $a1a4d31e28ce1f0d$var$ls($a1a4d31e28ce1f0d$var$es),
        Bar: $a1a4d31e28ce1f0d$var$ls($a1a4d31e28ce1f0d$var$ss),
        Area: $a1a4d31e28ce1f0d$var$ls($a1a4d31e28ce1f0d$var$is),
        Baseline: $a1a4d31e28ce1f0d$var$ls($a1a4d31e28ce1f0d$var$ns),
        Histogram: $a1a4d31e28ce1f0d$var$ls($a1a4d31e28ce1f0d$var$ts),
        Line: $a1a4d31e28ce1f0d$var$ls($a1a4d31e28ce1f0d$var$ts),
        Custom: $a1a4d31e28ce1f0d$var$ls($a1a4d31e28ce1f0d$var$rs)
    })[t];
}
function $a1a4d31e28ce1f0d$var$_s(t) {
    return {
        $n: 0,
        GM: new Map,
        za: t
    };
}
function $a1a4d31e28ce1f0d$var$us(t, i) {
    if (void 0 !== t && 0 !== t.length) return {
        XM: i.key(t[0].wt),
        JM: i.key(t[t.length - 1].wt)
    };
}
function $a1a4d31e28ce1f0d$var$cs(t) {
    let i;
    return t.forEach((t)=>{
        void 0 === i && (i = t.Qr);
    }), $a1a4d31e28ce1f0d$var$_(i);
}
class $a1a4d31e28ce1f0d$var$ds {
    constructor(t){
        this.QM = new Map, this.tg = new Map, this.ig = new Map, this.ng = [], this.xu = t;
    }
    m() {
        this.QM.clear(), this.tg.clear(), this.ig.clear(), this.ng = [];
    }
    sg(t, i) {
        let n = 0 !== this.QM.size, s = !1;
        const e = this.tg.get(t);
        if (void 0 !== e) {
            if (1 === this.tg.size) n = !1, s = !0, this.QM.clear();
            else for (const i of this.ng)i.pointData.GM.delete(t) && (s = !0);
        }
        let r = [];
        if (0 !== i.length) {
            const n = i.map((t)=>t.time), e = this.xu.createConverterToInternalObj(i), h = $a1a4d31e28ce1f0d$var$os(t.bh()), a = t.ll(), l = t.ol();
            r = i.map((i, r)=>{
                const o = e(i.time), _ = this.xu.key(o);
                let u = this.QM.get(_);
                void 0 === u && (u = $a1a4d31e28ce1f0d$var$_s(o), this.QM.set(_, u), s = !0);
                const c = h(o, u.$n, i, n[r], a, l);
                return u.GM.set(t, c), c;
            });
        }
        n && this.eg(), this.rg(t, r);
        let h = -1;
        if (s) {
            const t = [];
            this.QM.forEach((i)=>{
                t.push({
                    timeWeight: 0,
                    time: i.za,
                    pointData: i,
                    originalTime: $a1a4d31e28ce1f0d$var$cs(i.GM)
                });
            }), t.sort((t, i)=>this.xu.key(t.time) - this.xu.key(i.time)), h = this.hg(t);
        }
        return this.ag(t, h, function(t, i, n) {
            const s = $a1a4d31e28ce1f0d$var$us(t, n), e = $a1a4d31e28ce1f0d$var$us(i, n);
            if (void 0 !== s && void 0 !== e) return {
                lg: !1,
                Ia: s.JM >= e.JM && s.XM >= e.XM
            };
        }(this.tg.get(t), e, this.xu));
    }
    Jd(t) {
        return this.sg(t, []);
    }
    og(t, i, n) {
        if (n && t.Na()) throw new Error("Historical updates are not supported when conflation is enabled. Conflation requires data to be processed in order.");
        const s = i;
        !function(t) {
            void 0 === t.Qr && (t.Qr = t.time);
        }(s), this.xu.preprocessData(i);
        const e = this.xu.createConverterToInternalObj([
            i
        ])(i.time), r = this.ig.get(t);
        if (!n && void 0 !== r && this.xu.key(e) < this.xu.key(r)) throw new Error(`Cannot update oldest data, last time=${r}, new time=${e}`);
        let h = this.QM.get(this.xu.key(e));
        if (n && void 0 === h) throw new Error("Cannot update non-existing data point when historicalUpdate is true");
        const a = void 0 === h;
        void 0 === h && (h = $a1a4d31e28ce1f0d$var$_s(e), this.QM.set(this.xu.key(e), h));
        const l = $a1a4d31e28ce1f0d$var$os(t.bh()), o = t.ll(), _ = t.ol(), u = l(e, h.$n, i, s.Qr, o, _), c = !n && !a && void 0 !== r && this.xu.key(e) === this.xu.key(r);
        h.GM.set(t, u), n ? this._g(t, u, h.$n) : c && t.Na() && $a1a4d31e28ce1f0d$var$hs(u) ? (t.Rr(u), this.ug(t, u)) : this.ug(t, u);
        const d = {
            Ia: $a1a4d31e28ce1f0d$var$hs(u),
            lg: n
        };
        if (!a) return this.ag(t, -1, d);
        const f = {
            timeWeight: 0,
            time: h.za,
            pointData: h,
            originalTime: $a1a4d31e28ce1f0d$var$cs(h.GM)
        }, p = $a1a4d31e28ce1f0d$var$Rt(this.ng, this.xu.key(f.time), (t, i)=>this.xu.key(t.time) < i);
        this.ng.splice(p, 0, f);
        for(let t = p; t < this.ng.length; ++t)$a1a4d31e28ce1f0d$var$fs(this.ng[t].pointData, t);
        return this.xu.fillWeightsForPoints(this.ng, p), this.ag(t, p, d);
    }
    cg(t, i) {
        const n = this.tg.get(t);
        if (void 0 === n || i <= 0) return [
            [],
            this.dg()
        ];
        i = Math.min(i, n.length);
        const s = n.splice(-i).reverse();
        0 === n.length ? this.ig.delete(t) : this.ig.set(t, n[n.length - 1].wt);
        for (const i of s){
            const n = this.QM.get(this.xu.key(i.wt));
            if (n && (n.GM.delete(t), 0 === n.GM.size)) {
                this.QM.delete(this.xu.key(n.za)), this.ng.splice(n.$n, 1);
                for(let t = n.$n; t < this.ng.length; ++t)$a1a4d31e28ce1f0d$var$fs(this.ng[t].pointData, t);
            }
        }
        return [
            s,
            this.ag(t, this.ng.length - 1, {
                lg: !1,
                Ia: !1
            })
        ];
    }
    ug(t, i) {
        let n = this.tg.get(t);
        void 0 === n && (n = [], this.tg.set(t, n));
        const s = 0 !== n.length ? n[n.length - 1] : null;
        null === s || this.xu.key(i.wt) > this.xu.key(s.wt) ? $a1a4d31e28ce1f0d$var$hs(i) && n.push(i) : $a1a4d31e28ce1f0d$var$hs(i) ? n[n.length - 1] = i : n.splice(-1, 1), this.ig.set(t, i.wt);
    }
    _g(t, i, n) {
        const s = this.tg.get(t);
        if (void 0 === s) return;
        const e = $a1a4d31e28ce1f0d$var$Rt(s, n, (t, i)=>t.$n < i);
        $a1a4d31e28ce1f0d$var$hs(i) ? s[e] = i : s.splice(e, 1);
    }
    rg(t, i) {
        0 !== i.length ? (this.tg.set(t, i.filter($a1a4d31e28ce1f0d$var$hs)), this.ig.set(t, i[i.length - 1].wt)) : (this.tg.delete(t), this.ig.delete(t));
    }
    eg() {
        for (const t of this.ng)0 === t.pointData.GM.size && this.QM.delete(this.xu.key(t.time));
    }
    hg(t) {
        let i = -1;
        for(let n = 0; n < this.ng.length && n < t.length; ++n){
            const s = this.ng[n], e = t[n];
            if (this.xu.key(s.time) !== this.xu.key(e.time)) {
                i = n;
                break;
            }
            e.timeWeight = s.timeWeight, $a1a4d31e28ce1f0d$var$fs(e.pointData, n);
        }
        if (-1 === i && this.ng.length !== t.length && (i = Math.min(this.ng.length, t.length)), -1 === i) return -1;
        for(let n = i; n < t.length; ++n)$a1a4d31e28ce1f0d$var$fs(t[n].pointData, n);
        return this.xu.fillWeightsForPoints(t, i), this.ng = t, i;
    }
    fg() {
        if (0 === this.tg.size) return null;
        let t = 0;
        return this.tg.forEach((i)=>{
            0 !== i.length && (t = Math.max(t, i[i.length - 1].$n));
        }), t;
    }
    ag(t, i, n) {
        const s = this.dg();
        if (-1 !== i) this.tg.forEach((i, e)=>{
            s.U_.set(e, {
                ue: i,
                pg: e === t ? n : void 0
            });
        }), this.tg.has(t) || s.U_.set(t, {
            ue: [],
            pg: n
        }), s.Et.vg = this.ng, s.Et.mg = i;
        else {
            const i = this.tg.get(t);
            s.U_.set(t, {
                ue: i || [],
                pg: n
            });
        }
        return s;
    }
    dg() {
        return {
            U_: new Map,
            Et: {
                Pc: this.fg()
            }
        };
    }
}
function $a1a4d31e28ce1f0d$var$fs(t, i) {
    t.$n = i, t.GM.forEach((t)=>{
        t.$n = i;
    });
}
function $a1a4d31e28ce1f0d$var$ps(t, i) {
    return t._t < i;
}
function $a1a4d31e28ce1f0d$var$vs(t, i) {
    return i < t._t;
}
function $a1a4d31e28ce1f0d$var$ms(t, i, n, s) {
    return $a1a4d31e28ce1f0d$var$Rt(t, i, $a1a4d31e28ce1f0d$var$ps, n, s);
}
function $a1a4d31e28ce1f0d$var$ws(t, i, n, s) {
    return $a1a4d31e28ce1f0d$var$Dt(t, i, $a1a4d31e28ce1f0d$var$vs, n, s);
}
function $a1a4d31e28ce1f0d$var$Ms(t, i, n) {
    return {
        ne: t,
        se: i,
        ee: n
    };
}
function $a1a4d31e28ce1f0d$var$gs(t, i, n, s) {
    return t >= i - s && t <= n + s;
}
function $a1a4d31e28ce1f0d$var$bs(t, i, n, s, e, r) {
    const h = e - n, a = r - s;
    if (0 === h && 0 === a) return Math.hypot(t - n, i - s);
    const l = ((t - n) * h + (i - s) * a) / (h * h + a * a), o = Math.max(0, Math.min(1, l)), _ = n + h * o, u = s + a * o;
    return Math.hypot(t - _, i - u);
}
const $a1a4d31e28ce1f0d$var$Ss = [
    0,
    0
];
function $a1a4d31e28ce1f0d$var$xs(t, i, n) {
    return void 0 === i || i.wt !== t.wt - 1 ? t._t - n / 2 : (i._t + t._t) / 2;
}
function $a1a4d31e28ce1f0d$var$Cs(t, i, n) {
    return void 0 === i || i.wt !== t.wt + 1 ? t._t + n / 2 : (t._t + i._t) / 2;
}
function $a1a4d31e28ce1f0d$var$ys(t, i, n, s, e, r, h) {
    if (null === i || i.from >= i.to || 0 === t.length) return null;
    const a = e / 2 + r, l = $a1a4d31e28ce1f0d$var$ms(t, n - a, i.from, i.to), o = $a1a4d31e28ce1f0d$var$ws(t, n + a, l, i.to);
    if (l >= o) return null;
    let _ = Number.POSITIVE_INFINITY;
    for(let a = l; a < o; a++){
        const l = t[a], o = a > i.from ? t[a - 1] : void 0, u = a < i.to - 1 ? t[a + 1] : void 0, c = $a1a4d31e28ce1f0d$var$xs(l, o, e) - r, d = $a1a4d31e28ce1f0d$var$Cs(l, u, e) + r;
        if (n < c || n > d) continue;
        h(l, $a1a4d31e28ce1f0d$var$Ss);
        const f = $a1a4d31e28ce1f0d$var$Ss[0], p = $a1a4d31e28ce1f0d$var$Ss[1], v = Math.min(f, p), m = Math.max(f, p), w = v - r, M = m + r;
        if (s >= v && s <= m) _ = Math.min(_, 0);
        else if (s >= w && s <= M) {
            const t = Math.min(Math.abs(s - v), Math.abs(m - s));
            _ = Math.min(_, t);
        }
    }
    return Number.isFinite(_) ? $a1a4d31e28ce1f0d$var$Ms(_, 0, "series-range") : null;
}
function $a1a4d31e28ce1f0d$var$ks(t, i) {
    return t.wt < i;
}
function $a1a4d31e28ce1f0d$var$Ps(t, i) {
    return i < t.wt;
}
function $a1a4d31e28ce1f0d$var$Ts(t, i, n) {
    const s = i.Oa(), e = i.bi(), r = $a1a4d31e28ce1f0d$var$Rt(t, s, $a1a4d31e28ce1f0d$var$ks), h = $a1a4d31e28ce1f0d$var$Dt(t, e, $a1a4d31e28ce1f0d$var$Ps);
    if (!n) return {
        from: r,
        to: h
    };
    let a = r, l = h;
    return r > 0 && r < t.length && t[r].wt >= s && (a = r - 1), h > 0 && h < t.length && t[h - 1].wt <= e && (l = h + 1), {
        from: a,
        to: l
    };
}
class $a1a4d31e28ce1f0d$var$Rs {
    constructor(t, i, n){
        this.wg = !0, this.Mg = !0, this.gg = !0, this.bg = [], this.Sg = null, this.xg = -1, this.ae = t, this.le = i, this.Cg = n;
    }
    kt(t) {
        this.wg = !0, "data" === t && (this.Mg = !0), "options" === t && (this.gg = !0);
    }
    Tt() {
        return this.ae.It() ? (this.yg(), null === this.Sg ? null : this.kg) : null;
    }
    Qs(t, i) {
        return this.ae.It() ? (this.yg(), null === this.Sg ? null : this.Pg(t, i)) : null;
    }
    Pg(t, i) {
        return null;
    }
    Tg() {
        this.bg = this.bg.map((t)=>({
                ...t,
                ...this.ae.Sa().Sh(t.wt)
            }));
    }
    Rg() {
        this.Sg = null;
    }
    yg() {
        const t = this.le.Et(), i = t.N().enableConflation ? t.Qc() : 0;
        i !== this.xg && (this.Mg = !0, this.xg = i), this.Mg && (this.Dg(), this.Mg = !1), this.gg && (this.Tg(), this.gg = !1), this.wg && (this.Ig(), this.wg = !1);
    }
    Ig() {
        const t = this.ae.Ft(), i = this.le.Et();
        if (this.Rg(), i.Gi() || t.Gi()) return;
        const n = i.Ee();
        if (null === n) return;
        if (0 === this.ae.Un().Th()) return;
        const s = this.ae.Lt();
        null !== s && (this.Sg = $a1a4d31e28ce1f0d$var$Ts(this.bg, n, this.Cg), this.Vg(t, i, s.Wt), this.Bg());
    }
}
class $a1a4d31e28ce1f0d$var$Ds {
    constructor(t, i){
        this.Eg = t, this.Ki = i;
    }
    st(t, i, n) {
        this.Eg.draw(t, this.Ki, i, n);
    }
}
function $a1a4d31e28ce1f0d$var$Is(t) {
    switch(t){
        case "point":
            return 2;
        case "range":
            return 0;
        default:
            return 1;
    }
}
class $a1a4d31e28ce1f0d$var$Vs extends $a1a4d31e28ce1f0d$var$Rs {
    constructor(t, i, n){
        super(t, i, !1), this.Yh = n, this.Eg = this.Yh.renderer(), this.kg = new $a1a4d31e28ce1f0d$var$Ds(this.Eg, (t)=>this.Ag(t));
    }
    get ga() {
        return this.Yh.conflationReducer;
    }
    Wa(t) {
        return this.Yh.priceValueBuilder(t);
    }
    _l(t) {
        return this.Yh.isWhitespace(t);
    }
    Pg(t, i) {
        const n = this.Eg.hitTest?.(t, i, (t)=>this.Ag(t));
        if (null != n) return {
            ne: (s = n).distance,
            se: $a1a4d31e28ce1f0d$var$Is(s.type),
            ee: "custom",
            mu: s.cursorStyle,
            te: s.objectId,
            ie: s.hitTestData
        };
        var s;
        const e = $a1a4d31e28ce1f0d$var$ys(this.bg, this.Sg, t, i, this.le.Et().fl(), this.ae.N().hitTestTolerance, (t, i)=>{
            const n = t.Lg;
            let s = NaN, e = NaN;
            if (void 0 !== n && !this.Yh.isWhitespace(n)) for (const t of this.Yh.priceValueBuilder(n)){
                const i = this.Ag(t);
                null !== i && (s = Number.isNaN(s) ? i : Math.min(s, i), e = Number.isNaN(e) ? i : Math.max(e, i));
            }
            i[0] = s, i[1] = e;
        });
        return null === e ? null : {
            ...e,
            ee: "custom"
        };
    }
    Dg() {
        const t = this.ae.Sa();
        this.bg = this.ae.Ha().Bh().map((i)=>({
                wt: i.$n,
                _t: NaN,
                ...t.Sh(i.$n),
                Lg: i.ue
            }));
    }
    Vg(t, i) {
        i.Tc(this.bg, $a1a4d31e28ce1f0d$var$b(this.Sg));
    }
    Bg() {
        this.Yh.update({
            bars: this.bg.map($a1a4d31e28ce1f0d$var$Bs),
            barSpacing: this.le.Et().fl(),
            visibleRange: this.Sg,
            conflationFactor: this.le.Et().Qc()
        }, this.ae.N());
    }
    Ag(t) {
        const i = this.ae.Lt();
        return null === i ? null : this.ae.Ft().Nt(t, i.Wt);
    }
}
function $a1a4d31e28ce1f0d$var$Bs(t) {
    return {
        x: t._t,
        time: t.wt,
        originalData: t.Lg,
        barColor: t.sh
    };
}
const $a1a4d31e28ce1f0d$var$Es = {
    color: "#2196f3"
}, $a1a4d31e28ce1f0d$var$As = (t, i, n)=>{
    const s = $a1a4d31e28ce1f0d$var$c(n);
    return new $a1a4d31e28ce1f0d$var$Vs(t, i, s);
};
function $a1a4d31e28ce1f0d$var$Ls(t) {
    const i = {
        value: t.Wt[3],
        time: t.Qr
    };
    return void 0 !== t.ZM && (i.customValues = t.ZM), i;
}
function $a1a4d31e28ce1f0d$var$zs(t) {
    const i = $a1a4d31e28ce1f0d$var$Ls(t);
    return void 0 !== t.R && (i.color = t.R), i;
}
function $a1a4d31e28ce1f0d$var$Os(t) {
    const i = $a1a4d31e28ce1f0d$var$Ls(t);
    return void 0 !== t.vt && (i.lineColor = t.vt), void 0 !== t.ah && (i.topColor = t.ah), void 0 !== t.oh && (i.bottomColor = t.oh), i;
}
function $a1a4d31e28ce1f0d$var$Ns(t) {
    const i = $a1a4d31e28ce1f0d$var$Ls(t);
    return void 0 !== t._h && (i.topLineColor = t._h), void 0 !== t.uh && (i.bottomLineColor = t.uh), void 0 !== t.dh && (i.topFillColor1 = t.dh), void 0 !== t.fh && (i.topFillColor2 = t.fh), void 0 !== t.ph && (i.bottomFillColor1 = t.ph), void 0 !== t.mh && (i.bottomFillColor2 = t.mh), i;
}
function $a1a4d31e28ce1f0d$var$Fs(t) {
    const i = {
        open: t.Wt[0],
        high: t.Wt[1],
        low: t.Wt[2],
        close: t.Wt[3],
        time: t.Qr
    };
    return void 0 !== t.ZM && (i.customValues = t.ZM), i;
}
function $a1a4d31e28ce1f0d$var$Ws(t) {
    const i = $a1a4d31e28ce1f0d$var$Fs(t);
    return void 0 !== t.R && (i.color = t.R), i;
}
function $a1a4d31e28ce1f0d$var$Hs(t) {
    const i = $a1a4d31e28ce1f0d$var$Fs(t), { R: n, Ht: s, hh: e } = t;
    return void 0 !== n && (i.color = n), void 0 !== s && (i.borderColor = s), void 0 !== e && (i.wickColor = e), i;
}
function $a1a4d31e28ce1f0d$var$Us(t) {
    return ({
        Area: $a1a4d31e28ce1f0d$var$Os,
        Line: $a1a4d31e28ce1f0d$var$zs,
        Baseline: $a1a4d31e28ce1f0d$var$Ns,
        Histogram: $a1a4d31e28ce1f0d$var$zs,
        Bar: $a1a4d31e28ce1f0d$var$Ws,
        Candlestick: $a1a4d31e28ce1f0d$var$Hs,
        Custom: $a1a4d31e28ce1f0d$var$$s
    })[t];
}
function $a1a4d31e28ce1f0d$var$$s(t) {
    const i = t.Qr;
    return {
        ...t.ue,
        time: i
    };
}
const $a1a4d31e28ce1f0d$var$js = {
    vertLine: {
        color: "#9598A1",
        width: 1,
        style: 3,
        visible: !0,
        labelVisible: !0,
        labelBackgroundColor: "#131722"
    },
    horzLine: {
        color: "#9598A1",
        width: 1,
        style: 3,
        visible: !0,
        labelVisible: !0,
        labelBackgroundColor: "#131722"
    },
    mode: 1,
    doNotSnapToHiddenSeriesIndices: !1
}, $a1a4d31e28ce1f0d$var$qs = {
    vertLines: {
        color: "#D6DCDE",
        style: 0,
        visible: !0
    },
    horzLines: {
        color: "#D6DCDE",
        style: 0,
        visible: !0
    }
}, $a1a4d31e28ce1f0d$var$Ys = {
    background: {
        type: "solid",
        color: "#FFFFFF"
    },
    textColor: "#191919",
    fontSize: 12,
    fontFamily: $a1a4d31e28ce1f0d$var$S,
    panes: {
        enableResize: !0,
        separatorColor: "#E0E3EB",
        separatorHoverColor: "rgba(178, 181, 189, 0.2)"
    },
    attributionLogo: !0,
    colorSpace: "srgb",
    colorParsers: []
}, $a1a4d31e28ce1f0d$var$Ks = {
    autoScale: !0,
    mode: 0,
    invertScale: !1,
    alignLabels: !0,
    borderVisible: !0,
    borderColor: "#2B2B43",
    entireTextOnly: !1,
    visible: !1,
    ticksVisible: !1,
    scaleMargins: {
        bottom: .1,
        top: .2
    },
    minimumWidth: 0,
    ensureEdgeTickMarksVisible: !1,
    tickMarkDensity: 2.5
}, $a1a4d31e28ce1f0d$var$Zs = {
    rightOffset: 0,
    barSpacing: 6,
    minBarSpacing: .5,
    maxBarSpacing: 0,
    fixLeftEdge: !1,
    fixRightEdge: !1,
    lockVisibleTimeRangeOnResize: !1,
    rightBarStaysOnScroll: !1,
    borderVisible: !0,
    borderColor: "#2B2B43",
    visible: !0,
    timeVisible: !1,
    secondsVisible: !0,
    shiftVisibleRangeOnNewBar: !0,
    allowShiftVisibleRangeOnWhitespaceReplacement: !1,
    ticksVisible: !1,
    uniformDistribution: !1,
    minimumHeight: 0,
    allowBoldLabels: !0,
    ignoreWhitespaceIndices: !1,
    enableConflation: !1,
    conflationThresholdFactor: 1,
    precomputeConflationOnInit: !1,
    precomputeConflationPriority: "background"
};
function $a1a4d31e28ce1f0d$var$Gs() {
    return {
        addDefaultPane: !0,
        hoveredSeriesOnTop: !0,
        width: 0,
        height: 0,
        autoSize: !1,
        layout: $a1a4d31e28ce1f0d$var$Ys,
        crosshair: $a1a4d31e28ce1f0d$var$js,
        grid: $a1a4d31e28ce1f0d$var$qs,
        overlayPriceScales: {
            ...$a1a4d31e28ce1f0d$var$Ks
        },
        leftPriceScale: {
            ...$a1a4d31e28ce1f0d$var$Ks,
            visible: !1
        },
        rightPriceScale: {
            ...$a1a4d31e28ce1f0d$var$Ks,
            visible: !0
        },
        defaultVisiblePriceScaleId: "right",
        timeScale: $a1a4d31e28ce1f0d$var$Zs,
        localization: {
            locale: $a1a4d31e28ce1f0d$var$dn ? navigator.language : "",
            dateFormat: "dd MMM 'yy"
        },
        handleScroll: {
            mouseWheel: !0,
            pressedMouseMove: !0,
            horzTouchDrag: !0,
            vertTouchDrag: !0
        },
        handleScale: {
            axisPressedMouseMove: {
                time: !0,
                price: !0
            },
            axisDoubleClickReset: {
                time: !0,
                price: !0
            },
            mouseWheel: !0,
            pinch: !0
        },
        kineticScroll: {
            mouse: !1,
            touch: !0
        },
        trackingMode: {
            exitMode: 1
        }
    };
}
class $a1a4d31e28ce1f0d$var$Xs {
    constructor(t, i, n){
        this.sv = t, this.zg = i, this.Og = n ?? 0;
    }
    applyOptions(t) {
        this.sv.Qt().Pd(this.zg, t, this.Og);
    }
    options() {
        return this.Ki().N();
    }
    width() {
        return $a1a4d31e28ce1f0d$var$G(this.zg) ? this.sv.CM(this.zg) : 0;
    }
    setVisibleRange(t) {
        this.setAutoScale(!1), this.Ki().qo(new $a1a4d31e28ce1f0d$var$mt(t.from, t.to));
    }
    getVisibleRange() {
        let t, i, n = this.Ki().ar();
        if (null === n) return null;
        if (this.Ki().so()) {
            const s = this.Ki().M_(), e = $a1a4d31e28ce1f0d$var$Yi(s);
            n = $a1a4d31e28ce1f0d$var$vi(n, this.Ki().ro()), t = Number((Math.round(n.Je() / s) * s).toFixed(e)), i = Number((Math.round(n.Qe() / s) * s).toFixed(e));
        } else t = n.Je(), i = n.Qe();
        return {
            from: t,
            to: i
        };
    }
    setAutoScale(t) {
        this.applyOptions({
            autoScale: t
        });
    }
    Ki() {
        return $a1a4d31e28ce1f0d$var$u(this.sv.Qt().Td(this.zg, this.Og)).Ft;
    }
}
class $a1a4d31e28ce1f0d$var$Js {
    constructor(t, i, n, s){
        this.sv = t, this.yt = n, this.Ng = i, this.Fg = s;
    }
    getHeight() {
        return this.yt.$t();
    }
    setHeight(t) {
        const i = this.sv.Qt(), n = i.hf(this.yt);
        i.Bd(n, t);
    }
    getStretchFactor() {
        return this.yt.z_();
    }
    setStretchFactor(t) {
        this.yt.O_(t), this.sv.Qt().Pa();
    }
    paneIndex() {
        return this.sv.Qt().hf(this.yt);
    }
    moveTo(t) {
        const i = this.paneIndex();
        i !== t && ($a1a4d31e28ce1f0d$var$o(t >= 0 && t < this.sv.rv().length, "Invalid pane index"), this.sv.Qt().Ad(i, t));
    }
    getSeries() {
        return this.yt.U_().map((t)=>this.Ng(t)) ?? [];
    }
    getHTMLElement() {
        const t = this.sv.rv();
        return t && 0 !== t.length && t[this.paneIndex()] ? t[this.paneIndex()].uv() : null;
    }
    attachPrimitive(t) {
        this.yt.hl(t), t.attached && t.attached({
            chart: this.Fg,
            requestUpdate: ()=>this.yt.Qt().Pa()
        });
    }
    detachPrimitive(t) {
        this.yt.al(t);
    }
    priceScale(t) {
        if (null === this.yt.A_(t)) throw new Error(`Cannot find price scale with id: ${t}`);
        return new $a1a4d31e28ce1f0d$var$Xs(this.sv, t, this.paneIndex());
    }
    setPreserveEmptyPane(t) {
        this.yt.W_(t);
    }
    preserveEmptyPane() {
        return this.yt.H_();
    }
    addCustomSeries(t, i = {}, n = 0) {
        return this.Fg.addCustomSeries(t, i, n);
    }
    addSeries(t, i = {}) {
        return this.Fg.addSeries(t, i, this.paneIndex());
    }
}
const $a1a4d31e28ce1f0d$var$Qs = {
    color: "#FF0000",
    price: 0,
    lineStyle: 2,
    lineWidth: 1,
    lineVisible: !0,
    axisLabelVisible: !0,
    title: "",
    axisLabelColor: "",
    axisLabelTextColor: ""
};
class $a1a4d31e28ce1f0d$var$te {
    constructor(t){
        this._r = t;
    }
    applyOptions(t) {
        this._r.vr(t);
    }
    options() {
        return this._r.N();
    }
    Wg() {
        return this._r;
    }
}
class $a1a4d31e28ce1f0d$var$ie {
    constructor(t, i, n, s, e, r){
        this.Hg = new $a1a4d31e28ce1f0d$var$d, this.ae = t, this.Ug = i, this.$g = n, this.xu = e, this.Fg = s, this.jg = r;
    }
    m() {
        this.Hg.m();
    }
    priceFormatter() {
        return this.ae.tl();
    }
    priceToCoordinate(t) {
        const i = this.ae.Lt();
        return null === i ? null : this.ae.Ft().Nt(t, i.Wt);
    }
    coordinateToPrice(t) {
        const i = this.ae.Lt();
        return null === i ? null : this.ae.Ft().Tn(t, i.Wt);
    }
    barsInLogicalRange(t) {
        if (null === t) return null;
        const i = new $a1a4d31e28ce1f0d$var$Oi(new $a1a4d31e28ce1f0d$var$Ai(t.from, t.to)).Fu(), n = this.ae.Un();
        if (n.Gi()) return null;
        const s = n.Hn(i.Oa(), 1), e = n.Hn(i.bi(), -1), r = $a1a4d31e28ce1f0d$var$u(n.Rh()), h = $a1a4d31e28ce1f0d$var$u(n.Qn());
        if (null !== s && null !== e && s.$n > e.$n) return {
            barsBefore: t.from - r,
            barsAfter: h - t.to
        };
        const a = {
            barsBefore: null === s || s.$n === r ? t.from - r : s.$n - r,
            barsAfter: null === e || e.$n === h ? h - t.to : h - e.$n
        };
        return null !== s && null !== e && (a.from = s.Qr, a.to = e.Qr), a;
    }
    setData(t) {
        this.xu, this.ae.bh(), this.Ug.qg(this.ae, t), this.Yg("full");
    }
    update(t, i = !1) {
        this.ae.bh(), this.Ug.Kg(this.ae, t, i), this.Yg("update");
    }
    pop(t = 1) {
        const i = this.Ug.Zg(this.ae, t);
        0 !== i.length && this.Yg("update");
        const n = $a1a4d31e28ce1f0d$var$Us(this.seriesType());
        return i.map((t)=>n(t));
    }
    dataByIndex(t, i) {
        const n = this.ae.Un().Hn(t, i);
        if (null === n) return null;
        return $a1a4d31e28ce1f0d$var$Us(this.seriesType())(n);
    }
    data() {
        const t = $a1a4d31e28ce1f0d$var$Us(this.seriesType());
        return this.ae.Un().Bh().map((i)=>t(i));
    }
    subscribeDataChanged(t) {
        this.Hg.i(t);
    }
    unsubscribeDataChanged(t) {
        this.Hg._(t);
    }
    applyOptions(t) {
        this.ae.vr(t);
    }
    options() {
        return $a1a4d31e28ce1f0d$var$M(this.ae.N());
    }
    priceScale() {
        return this.$g.priceScale(this.ae.Ft().cl(), this.getPane().paneIndex());
    }
    createPriceLine(t) {
        const i = $a1a4d31e28ce1f0d$var$f($a1a4d31e28ce1f0d$var$M($a1a4d31e28ce1f0d$var$Qs), t), n = this.ae.Ba(i);
        return new $a1a4d31e28ce1f0d$var$te(n);
    }
    removePriceLine(t) {
        this.ae.Ea(t.Wg());
    }
    priceLines() {
        return this.ae.Aa().map((t)=>new $a1a4d31e28ce1f0d$var$te(t));
    }
    seriesType() {
        return this.ae.bh();
    }
    lastValueData(t) {
        const i = this.ae.Ae(t);
        return i.Le ? {
            noData: !0
        } : {
            noData: !1,
            price: i.Mt,
            color: i.R
        };
    }
    attachPrimitive(t) {
        this.ae.hl(t), t.attached && t.attached({
            chart: this.Fg,
            series: this,
            requestUpdate: ()=>this.ae.Qt().Pa(),
            horzScaleBehavior: this.xu
        });
    }
    detachPrimitive(t) {
        this.ae.al(t), t.detached && t.detached(), this.ae.Qt().Pa();
    }
    getPane() {
        const t = this.ae, i = $a1a4d31e28ce1f0d$var$u(this.ae.Qt().Ks(t));
        return this.jg(i);
    }
    moveToPane(t) {
        this.ae.Qt().nf(this.ae, t);
    }
    seriesOrder() {
        const t = this.ae.Qt().Ks(this.ae);
        return null === t ? -1 : t.U_().indexOf(this.ae);
    }
    setSeriesOrder(t) {
        const i = this.ae.Qt().Ks(this.ae);
        null !== i && i.du(this.ae, t);
    }
    Yg(t) {
        this.Hg.v() && this.Hg.p(t);
    }
}
class $a1a4d31e28ce1f0d$var$ne {
    constructor(t, i, n){
        this.Gg = new $a1a4d31e28ce1f0d$var$d, this.Gu = new $a1a4d31e28ce1f0d$var$d, this.Bw = new $a1a4d31e28ce1f0d$var$d, this.sn = t, this.ia = t.Et(), this._M = i, this.ia.Yc().i(this.Xg.bind(this)), this.ia.Kc().i(this.Jg.bind(this)), this._M.Fw().i(this.Qg.bind(this)), this.xu = n;
    }
    m() {
        this.ia.Yc().u(this), this.ia.Kc().u(this), this._M.Fw().u(this), this.Gg.m(), this.Gu.m(), this.Bw.m();
    }
    scrollPosition() {
        return this.ia.Ac();
    }
    scrollToPosition(t, i) {
        i ? this.ia.$c(t, 1e3) : this.sn.gs(t);
    }
    scrollToRealTime() {
        this.ia.Uc();
    }
    getVisibleRange() {
        const t = this.ia.gc();
        return null === t ? null : {
            from: t.from.originalTime,
            to: t.to.originalTime
        };
    }
    setVisibleRange(t) {
        const i = {
            from: this.xu.convertHorzItemToInternal(t.from),
            to: this.xu.convertHorzItemToInternal(t.to)
        }, n = this.ia.Cc(i);
        this.sn.tf(n);
    }
    getVisibleLogicalRange() {
        const t = this.ia.Mc();
        return null === t ? null : {
            from: t.Oa(),
            to: t.bi()
        };
    }
    setVisibleLogicalRange(t) {
        $a1a4d31e28ce1f0d$var$o(t.from <= t.to, "The from index cannot be after the to index."), this.sn.tf(t);
    }
    resetTimeScale() {
        this.sn.ws();
    }
    fitContent() {
        this.sn.Xc();
    }
    logicalToCoordinate(t) {
        const i = this.sn.Et();
        return i.Gi() ? null : i.jt(t);
    }
    coordinateToLogical(t) {
        return this.ia.Gi() ? null : this.ia.Rc(t);
    }
    timeToIndex(t, i) {
        const n = this.xu.convertHorzItemToInternal(t);
        return this.ia.vc(n, i);
    }
    timeToCoordinate(t) {
        const i = this.timeToIndex(t, !1);
        return null === i ? null : this.ia.jt(i);
    }
    coordinateToTime(t) {
        const i = this.sn.Et(), n = i.Rc(t), s = i.en(n);
        return null === s ? null : s.originalTime;
    }
    width() {
        return this._M.cv().width;
    }
    height() {
        return this._M.cv().height;
    }
    subscribeVisibleTimeRangeChange(t) {
        this.Gg.i(t);
    }
    unsubscribeVisibleTimeRangeChange(t) {
        this.Gg._(t);
    }
    subscribeVisibleLogicalRangeChange(t) {
        this.Gu.i(t);
    }
    unsubscribeVisibleLogicalRangeChange(t) {
        this.Gu._(t);
    }
    subscribeSizeChange(t) {
        this.Bw.i(t);
    }
    unsubscribeSizeChange(t) {
        this.Bw._(t);
    }
    applyOptions(t) {
        this.ia.vr(t);
    }
    options() {
        return {
            ...$a1a4d31e28ce1f0d$var$M(this.ia.N()),
            barSpacing: this.ia.fl()
        };
    }
    Xg() {
        this.Gg.v() && this.Gg.p(this.getVisibleRange());
    }
    Jg() {
        this.Gu.v() && this.Gu.p(this.getVisibleLogicalRange());
    }
    Qg(t) {
        this.Bw.p(t.width, t.height);
    }
}
function $a1a4d31e28ce1f0d$var$se(t) {
    return function(t) {
        if ($a1a4d31e28ce1f0d$var$w(t.handleScale)) {
            const i = t.handleScale;
            t.handleScale = {
                axisDoubleClickReset: {
                    time: i,
                    price: i
                },
                axisPressedMouseMove: {
                    time: i,
                    price: i
                },
                mouseWheel: i,
                pinch: i
            };
        } else if (void 0 !== t.handleScale) {
            const { axisPressedMouseMove: i, axisDoubleClickReset: n } = t.handleScale;
            $a1a4d31e28ce1f0d$var$w(i) && (t.handleScale.axisPressedMouseMove = {
                time: i,
                price: i
            }), $a1a4d31e28ce1f0d$var$w(n) && (t.handleScale.axisDoubleClickReset = {
                time: n,
                price: n
            });
        }
        const i = t.handleScroll;
        $a1a4d31e28ce1f0d$var$w(i) && (t.handleScroll = {
            horzTouchDrag: i,
            vertTouchDrag: i,
            mouseWheel: i,
            pressedMouseMove: i
        });
    }(t), t;
}
class $a1a4d31e28ce1f0d$var$ee {
    constructor(t, i, n){
        this.tb = new Map, this.ib = new Map, this.nb = new $a1a4d31e28ce1f0d$var$d, this.sb = new $a1a4d31e28ce1f0d$var$d, this.eb = new $a1a4d31e28ce1f0d$var$d, this.od = new WeakMap, this.rb = new $a1a4d31e28ce1f0d$var$ds(i);
        const s = void 0 === n ? $a1a4d31e28ce1f0d$var$M($a1a4d31e28ce1f0d$var$Gs()) : $a1a4d31e28ce1f0d$var$f($a1a4d31e28ce1f0d$var$M($a1a4d31e28ce1f0d$var$Gs()), $a1a4d31e28ce1f0d$var$se(n));
        this.hb = i, this.sv = new $a1a4d31e28ce1f0d$var$Gn(t, s, i), this.sv.dw().i((t)=>{
            this.nb.v() && this.nb.p(this.ab(t()));
        }, this), this.sv.fw().i((t)=>{
            this.sb.v() && this.sb.p(this.ab(t()));
        }, this), this.sv.Dd().i((t)=>{
            this.eb.v() && this.eb.p(this.ab(t()));
        }, this);
        const e = this.sv.Qt();
        this.lb = new $a1a4d31e28ce1f0d$var$ne(e, this.sv.pM(), this.hb);
    }
    remove() {
        this.sv.dw().u(this), this.sv.fw().u(this), this.sv.Dd().u(this), this.lb.m(), this.sv.m(), this.tb.clear(), this.ib.clear(), this.nb.m(), this.sb.m(), this.eb.m(), this.rb.m();
    }
    resize(t, i, n) {
        this.autoSizeActive() || this.sv.cM(t, i, n);
    }
    addCustomSeries(t, i = {}, n = 0) {
        const s = ((t)=>({
                type: "Custom",
                isBuiltIn: !1,
                defaultOptions: {
                    ...$a1a4d31e28ce1f0d$var$Es,
                    ...t.defaultOptions()
                },
                ob: $a1a4d31e28ce1f0d$var$As,
                _b: t
            }))($a1a4d31e28ce1f0d$var$c(t));
        return this.ub(s, i, n);
    }
    addSeries(t, i = {}, n = 0) {
        return this.ub(t, i, n);
    }
    removeSeries(t) {
        const i = $a1a4d31e28ce1f0d$var$_(this.tb.get(t)), n = this.rb.Jd(i);
        this.sv.Qt().Jd(i), this.cb(n), this.tb.delete(t), this.ib.delete(i);
    }
    qg(t, i) {
        this.cb(this.rb.sg(t, i));
    }
    Kg(t, i, n) {
        this.cb(this.rb.og(t, i, n));
    }
    Zg(t, i) {
        const [n, s] = this.rb.cg(t, i);
        return 0 !== n.length && this.cb(s), n;
    }
    subscribeClick(t) {
        this.nb.i(t);
    }
    unsubscribeClick(t) {
        this.nb._(t);
    }
    subscribeCrosshairMove(t) {
        this.eb.i(t);
    }
    unsubscribeCrosshairMove(t) {
        this.eb._(t);
    }
    subscribeDblClick(t) {
        this.sb.i(t);
    }
    unsubscribeDblClick(t) {
        this.sb._(t);
    }
    priceScale(t, i = 0) {
        return new $a1a4d31e28ce1f0d$var$Xs(this.sv, t, i);
    }
    timeScale() {
        return this.lb;
    }
    applyOptions(t) {
        this.sv.vr($a1a4d31e28ce1f0d$var$se(t));
    }
    options() {
        return this.sv.N();
    }
    takeScreenshot(t = !1, i = !1) {
        let n, s;
        try {
            i || (n = this.sv.Qt().N().crosshair.mode, this.sv.vr({
                crosshair: {
                    mode: 2
                }
            })), s = this.sv.SM(t);
        } finally{
            i || void 0 === n || this.sv.Qt().vr({
                crosshair: {
                    mode: n
                }
            });
        }
        return s;
    }
    addPane(t = !1) {
        const i = this.sv.Qt().af();
        return i.W_(t), this.fb(i);
    }
    removePane(t) {
        this.sv.Qt().Vd(t);
    }
    swapPanes(t, i) {
        this.sv.Qt().Ed(t, i);
    }
    autoSizeActive() {
        return this.sv.wM();
    }
    chartElement() {
        return this.sv.vv();
    }
    panes() {
        return this.sv.Qt().Zn().map((t)=>this.fb(t));
    }
    paneSize(t = 0) {
        const i = this.sv.RM(t);
        return {
            height: i.height,
            width: i.width
        };
    }
    setCrosshairPosition(t, i, n) {
        const s = this.tb.get(n);
        if (void 0 === s) return;
        const e = this.sv.Qt().Ks(s);
        null !== e && this.sv.Qt().qd(t, i, e);
    }
    clearCrosshairPosition() {
        this.sv.Qt().Yd(!0);
    }
    horzBehaviour() {
        return this.hb;
    }
    ub(t, i = {}, n = 0) {
        $a1a4d31e28ce1f0d$var$o(void 0 !== t.ob), function(t) {
            if (void 0 === t || "custom" === t.type) return;
            const i = t;
            void 0 !== i.minMove && void 0 === i.precision && (i.precision = $a1a4d31e28ce1f0d$var$Yi(i.minMove));
        }(i.priceFormat), "Candlestick" === t.type && function(t) {
            void 0 !== t.borderColor && (t.borderUpColor = t.borderColor, t.borderDownColor = t.borderColor), void 0 !== t.wickColor && (t.wickUpColor = t.wickColor, t.wickDownColor = t.wickColor);
        }(i);
        const s = $a1a4d31e28ce1f0d$var$f($a1a4d31e28ce1f0d$var$M($a1a4d31e28ce1f0d$var$e), $a1a4d31e28ce1f0d$var$M(t.defaultOptions), i), r = t.ob, h = new $a1a4d31e28ce1f0d$var$Jt(this.sv.Qt(), t.type, s, r, t._b);
        this.sv.Qt().Gd(h, n);
        const a = new $a1a4d31e28ce1f0d$var$ie(h, this, this, this, this.hb, (t)=>this.fb(t));
        return this.tb.set(a, h), this.ib.set(h, a), a;
    }
    cb(t) {
        const i = this.sv.Qt();
        i.Kd(t.Et.Pc, t.Et.vg, t.Et.mg), t.U_.forEach((t, i)=>i.ht(t.ue, t.pg)), i.Et()._c(), i.Bc();
    }
    pb(t) {
        return $a1a4d31e28ce1f0d$var$_(this.ib.get(t));
    }
    mb(t) {
        return void 0 !== t && this.ib.has(t) ? this.pb(t) : void 0;
    }
    ab(t) {
        const i = new Map;
        t.YM.forEach((t, n)=>{
            const s = n.bh(), e = $a1a4d31e28ce1f0d$var$Us(s)(t);
            if ("Custom" !== s) $a1a4d31e28ce1f0d$var$o($a1a4d31e28ce1f0d$var$Qn(e));
            else {
                const t = n.ol();
                $a1a4d31e28ce1f0d$var$o(!t || !1 === t(e));
            }
            i.set(this.pb(n), e);
        });
        const n = this.mb(t.NM), s = void 0 === t.WM ? void 0 : {
            type: t.WM.ds,
            sourceKind: t.WM.HM,
            objectKind: t.WM.UM,
            series: this.mb(t.WM.U_),
            objectId: t.WM.$M,
            paneIndex: t.WM.jM
        };
        return {
            time: t.Qr,
            logical: t.$n,
            point: t.qM,
            paneIndex: t.jM,
            hoveredInfo: s,
            hoveredSeries: n,
            hoveredObjectId: t.FM,
            seriesData: i,
            sourceEvent: t.KM
        };
    }
    fb(t) {
        let i = this.od.get(t);
        return i || (i = new $a1a4d31e28ce1f0d$var$Js(this.sv, (t)=>this.pb(t), t, this), this.od.set(t, i)), i;
    }
}
function $a1a4d31e28ce1f0d$var$re(t) {
    if ($a1a4d31e28ce1f0d$var$m(t)) {
        const i = document.getElementById(t);
        return $a1a4d31e28ce1f0d$var$o(null !== i, `Cannot find element in DOM with id=${t}`), i;
    }
    return t;
}
function $a1a4d31e28ce1f0d$export$8982e77ac5c107b4(t, i, n) {
    const s = $a1a4d31e28ce1f0d$var$re(t), e = new $a1a4d31e28ce1f0d$var$ee(s, i, n);
    return i.setOptions(e.options()), e;
}
function $a1a4d31e28ce1f0d$export$c870ec99876cb45c(t, i) {
    return $a1a4d31e28ce1f0d$export$8982e77ac5c107b4(t, new $a1a4d31e28ce1f0d$var$cn, $a1a4d31e28ce1f0d$var$cn.yf(i));
}
function $a1a4d31e28ce1f0d$export$cb3a039e5379c857() {
    return $a1a4d31e28ce1f0d$var$cn;
}
function $a1a4d31e28ce1f0d$var$oe(t, i, n, s) {
    return Math.hypot(n - t, s - i);
}
function $a1a4d31e28ce1f0d$var$_e(t, i, n, s, e, r, h, a = 0) {
    if (0 === i.length || s.from >= i.length || s.to <= 0) return;
    const { context: l, horizontalPixelRatio: o, verticalPixelRatio: _ } = t, u = i[s.from];
    let c = r(t, u), d = u;
    if (s.to - s.from < 2) {
        const i = e / 2;
        l.beginPath();
        const n = {
            _t: u._t - i,
            ut: u.ut
        }, s = {
            _t: u._t + i,
            ut: u.ut
        };
        l.moveTo(n._t * o, n.ut * _), l.lineTo(s._t * o, s.ut * _), h(t, c, n, s);
    } else {
        const e = a > 0;
        let f = 0;
        const p = (i, n)=>{
            if (h(t, c, d, n), l.beginPath(), c = i, d = n, e) {
                const t = f % a;
                l.lineDashOffset = t, f = t;
            }
        };
        let v = d;
        l.beginPath(), l.moveTo(u._t * o, u.ut * _);
        for(let h = s.from + 1; h < s.to; ++h){
            v = i[h];
            const s = v._t * o, a = v.ut * _, u = r(t, v);
            switch(n){
                case 0:
                    if (l.lineTo(s, a), e) {
                        const t = i[h - 1], n = t._t * o, e = t.ut * _;
                        f += $a1a4d31e28ce1f0d$var$oe(n, e, s, a);
                    }
                    break;
                case 1:
                    {
                        const t = i[h - 1], n = t.ut * _;
                        l.lineTo(s, n), e && (f += Math.abs(v._t - t._t) * o), u !== c && (p(u, v), l.lineTo(s, n)), l.lineTo(s, a), e && (f += Math.abs(v.ut - t.ut) * _);
                        break;
                    }
                case 2:
                    {
                        const [t, n] = $a1a4d31e28ce1f0d$var$fe(i, h - 1, h), r = t._t * o, u = t.ut * _, c = n._t * o, d = n.ut * _;
                        if (l.bezierCurveTo(r, u, c, d, s, a), e) {
                            const t = i[h - 1], n = t._t * o, e = t.ut * _, l = $a1a4d31e28ce1f0d$var$oe(n, e, s, a), p = $a1a4d31e28ce1f0d$var$oe(n, e, r, u) + $a1a4d31e28ce1f0d$var$oe(r, u, c, d) + $a1a4d31e28ce1f0d$var$oe(c, d, s, a);
                            f += (l + p) / 2;
                        }
                        break;
                    }
            }
            1 !== n && u !== c && (p(u, v), l.moveTo(s, a));
        }
        (d !== v || d === v && 1 === n) && h(t, c, d, v), e && (l.lineDashOffset = 0);
    }
}
const $a1a4d31e28ce1f0d$var$ue = 6;
function $a1a4d31e28ce1f0d$var$ce(t, i) {
    return {
        _t: t._t - i._t,
        ut: t.ut - i.ut
    };
}
function $a1a4d31e28ce1f0d$var$de(t, i) {
    return {
        _t: t._t / i,
        ut: t.ut / i
    };
}
function $a1a4d31e28ce1f0d$var$fe(t, i, n) {
    const s = Math.max(0, i - 1), e = Math.min(t.length - 1, n + 1);
    var r, h;
    return [
        (r = t[i], h = $a1a4d31e28ce1f0d$var$de($a1a4d31e28ce1f0d$var$ce(t[n], t[s]), $a1a4d31e28ce1f0d$var$ue), {
            _t: r._t + h._t,
            ut: r.ut + h.ut
        }),
        $a1a4d31e28ce1f0d$var$ce(t[n], $a1a4d31e28ce1f0d$var$de($a1a4d31e28ce1f0d$var$ce(t[e], t[i]), $a1a4d31e28ce1f0d$var$ue))
    ];
}
function $a1a4d31e28ce1f0d$var$pe(t, i) {
    const n = t.context;
    n.strokeStyle = i, n.stroke();
}
class $a1a4d31e28ce1f0d$var$ve extends $a1a4d31e28ce1f0d$var$R {
    constructor(){
        super(...arguments), this.rt = null;
    }
    ht(t) {
        this.rt = t;
    }
    et(t) {
        if (null === this.rt) return;
        const { ot: i, lt: n, wb: s, Mb: e, ct: r, Zt: h, gb: l } = this.rt;
        if (null === n) return;
        const o = t.context;
        o.lineCap = "butt", o.lineWidth = r * t.verticalPixelRatio;
        const _ = $a1a4d31e28ce1f0d$var$a(o, h);
        o.lineJoin = "round";
        const u = this.bb.bind(this), c = function(t) {
            return t.reduce((t, i)=>t + i, 0);
        }(_);
        void 0 !== e && $a1a4d31e28ce1f0d$var$_e(t, i, e, n, s, u, $a1a4d31e28ce1f0d$var$pe, c), l && function(t, i, n, s, e) {
            if (s.to - s.from <= 0) return;
            const { horizontalPixelRatio: r, verticalPixelRatio: h, context: a } = t;
            let l = null;
            const o = Math.max(1, Math.floor(r)) % 2 / 2, _ = n * h + o;
            for(let n = s.to - 1; n >= s.from; --n){
                const s = i[n];
                if (s) {
                    const i = e(t, s);
                    i !== l && (null !== l && a.fill(), a.beginPath(), a.fillStyle = i, l = i);
                    const n = Math.round(s._t * r) + o, u = s.ut * h;
                    a.moveTo(n, u), a.arc(n, u, _, 0, 2 * Math.PI);
                }
            }
            a.fill();
        }(t, i, l, n, u);
    }
}
class $a1a4d31e28ce1f0d$var$me extends $a1a4d31e28ce1f0d$var$ve {
    bb(t, i) {
        return i.vt;
    }
}
function $a1a4d31e28ce1f0d$var$we(t, i, n, s, e) {
    const r = 1 - e;
    return r * r * r * t + 3 * r * r * e * i + 3 * r * e * e * n + e * e * e * s;
}
function $a1a4d31e28ce1f0d$var$Me(t, i, n, s, e) {
    if (2 === n) {
        const [n, r] = $a1a4d31e28ce1f0d$var$fe(s, e - 1, e);
        return [
            Math.min(t._t, i._t, n._t, r._t),
            Math.max(t._t, i._t, n._t, r._t)
        ];
    }
    return [
        Math.min(t._t, i._t),
        Math.max(t._t, i._t)
    ];
}
function $a1a4d31e28ce1f0d$var$ge(t, i, n, s, e, r, h, a) {
    switch(e){
        case 1:
            {
                const e = $a1a4d31e28ce1f0d$var$bs(t, i, n._t, n.ut, s._t, n.ut), r = $a1a4d31e28ce1f0d$var$bs(t, i, s._t, n.ut, s._t, s.ut), h = Math.min(e, r);
                return h <= a ? h : null;
            }
        case 2:
            {
                const [e, l] = $a1a4d31e28ce1f0d$var$fe(r, h - 1, h), o = function(t, i, n) {
                    let s = Number.POSITIVE_INFINITY, e = n[0];
                    for(let r = 1; r <= 12; r++){
                        const h = r / 12, a = {
                            _t: $a1a4d31e28ce1f0d$var$we(n[0]._t, n[1]._t, n[2]._t, n[3]._t, h),
                            ut: $a1a4d31e28ce1f0d$var$we(n[0].ut, n[1].ut, n[2].ut, n[3].ut, h)
                        };
                        s = Math.min(s, $a1a4d31e28ce1f0d$var$bs(t, i, e._t, e.ut, a._t, a.ut)), e = a;
                    }
                    return s;
                }(t, i, [
                    n,
                    e,
                    l,
                    s
                ]);
                return o <= a ? o : null;
            }
        default:
            {
                const e = $a1a4d31e28ce1f0d$var$bs(t, i, n._t, n.ut, s._t, s.ut);
                return e <= a ? e : null;
            }
    }
}
class $a1a4d31e28ce1f0d$var$be extends $a1a4d31e28ce1f0d$var$Rs {
    constructor(t, i){
        super(t, i, !0);
    }
    Vg(t, i, n) {
        i.Tc(this.bg, $a1a4d31e28ce1f0d$var$b(this.Sg)), t.Zo(this.bg, n, $a1a4d31e28ce1f0d$var$b(this.Sg));
    }
    Sb(t, i) {
        return {
            wt: t,
            Mt: i,
            _t: NaN,
            ut: NaN
        };
    }
    Dg() {
        const t = this.ae.Sa();
        this.bg = this.ae.Ha().Bh().map((i)=>{
            let n;
            if ((i.Zr ?? 1) > 1) {
                const t = i.Wt[1], s = i.Wt[2], e = i.Wt[3];
                n = Math.abs(t - e) > Math.abs(s - e) ? t : s;
            } else n = i.Wt[3];
            return this.xb(i.$n, n, t);
        });
    }
}
class $a1a4d31e28ce1f0d$var$Se extends $a1a4d31e28ce1f0d$var$be {
    Pg(t, i) {
        const n = this.ae.N();
        return function(t, i, n, s, e, r, h, a = 0, l = 0) {
            if (null === i || i.from >= i.to || 0 === t.length) return null;
            const o = Math.max(r / 2, h ?? 0) + l;
            let _ = Number.POSITIVE_INFINITY;
            if (void 0 !== h) {
                const e = h + l, r = $a1a4d31e28ce1f0d$var$ms(t, n - e, i.from, i.to), a = $a1a4d31e28ce1f0d$var$ws(t, n + e, r, i.to);
                for(let i = r; i < a; i++){
                    const e = t[i];
                    if (!$a1a4d31e28ce1f0d$var$gs(n, e._t, e._t, h + l)) continue;
                    const r = Math.hypot(n - e._t, s - e.ut);
                    r <= h + l && (_ = Math.min(_, r));
                }
            }
            if (i.to - i.from < 2) {
                const e = t[i.from], r = Math.max(a / 2, o), h = $a1a4d31e28ce1f0d$var$bs(n, s, e._t - r, e.ut, e._t + r, e.ut);
                return h <= o && (_ = Math.min(_, h)), Number.isFinite(_) ? $a1a4d31e28ce1f0d$var$Ms(_, 2, "series-point") : null;
            }
            let u = Number.POSITIVE_INFINITY;
            const c = $a1a4d31e28ce1f0d$var$ms(t, n - o, i.from, i.to), d = $a1a4d31e28ce1f0d$var$ws(t, n + o, c, i.to), f = Math.max(i.from + 1, c), p = Math.min(i.to, d + 1);
            for(let i = f; i < p; i++){
                const r = t[i - 1], h = t[i], [a, l] = $a1a4d31e28ce1f0d$var$Me(r, h, e, t, i);
                if (!$a1a4d31e28ce1f0d$var$gs(n, a, l, o)) continue;
                const _ = $a1a4d31e28ce1f0d$var$ge(n, s, r, h, e, t, i, o);
                null !== _ && (u = Math.min(u, _));
            }
            return Number.isFinite(_) ? $a1a4d31e28ce1f0d$var$Ms(_, 2, "series-point") : Number.isFinite(u) ? $a1a4d31e28ce1f0d$var$Ms(u, 1, "series-line") : null;
        }(this.bg, this.Sg, t, i, n.lineType, n.lineVisible ? n.lineWidth : 1, n.pointMarkersVisible ? n.pointMarkersRadius || n.lineWidth / 2 + 2 : void 0, this.le.Et().fl(), n.hitTestTolerance);
    }
}
class $a1a4d31e28ce1f0d$var$xe extends $a1a4d31e28ce1f0d$var$Se {
    constructor(){
        super(...arguments), this.kg = new $a1a4d31e28ce1f0d$var$me;
    }
    xb(t, i, n) {
        return {
            ...this.Sb(t, i),
            ...n.Sh(t)
        };
    }
    Bg() {
        const t = this.ae.N(), i = {
            ot: this.bg,
            Zt: t.lineStyle,
            Mb: t.lineVisible ? t.lineType : void 0,
            ct: t.lineWidth,
            gb: t.pointMarkersVisible ? t.pointMarkersRadius || t.lineWidth / 2 + 2 : void 0,
            lt: this.Sg,
            wb: this.le.Et().fl()
        };
        this.kg.ht(i);
    }
}
const $a1a4d31e28ce1f0d$export$29b04ebffc4f4705 = {
    type: "Line",
    isBuiltIn: !0,
    defaultOptions: {
        color: "#2196f3",
        lineStyle: 0,
        lineWidth: 3,
        lineType: 0,
        lineVisible: !0,
        crosshairMarkerVisible: !0,
        crosshairMarkerRadius: 4,
        crosshairMarkerBorderColor: "",
        crosshairMarkerBorderWidth: 2,
        crosshairMarkerBackgroundColor: "",
        lastPriceAnimation: 0,
        pointMarkersVisible: !1
    },
    ob: (t, i)=>new $a1a4d31e28ce1f0d$var$xe(t, i)
};
function $a1a4d31e28ce1f0d$var$ye(t, i) {
    return t.weight > i.weight ? t : i;
}
class $a1a4d31e28ce1f0d$var$ke {
    constructor(){
        this.Cb = new $a1a4d31e28ce1f0d$var$d, this.yb = function(t) {
            let i = !1;
            return function(...n) {
                i || (i = !0, queueMicrotask(()=>{
                    t(...n), i = !1;
                }));
            };
        }(()=>this.Cb.p(this.kb)), this.kb = 0;
    }
    Pb() {
        return this.Cb;
    }
    m() {
        this.Cb.m();
    }
    options() {
        return this.yn;
    }
    setOptions(t) {
        this.yn = t;
    }
    preprocessData(t) {}
    updateFormatter(t) {
        this.yn && (this.yn.localization = t);
    }
    createConverterToInternalObj(t) {
        return this.yb(), (t)=>(t > this.kb && (this.kb = t), t);
    }
    key(t) {
        return t;
    }
    cacheKey(t) {
        return t;
    }
    convertHorzItemToInternal(t) {
        return t;
    }
    formatHorzItem(t) {
        return this.Tb(t);
    }
    formatTickmark(t) {
        return this.Tb(t.time);
    }
    maxTickMarkWeight(t) {
        return t.reduce($a1a4d31e28ce1f0d$var$ye, t[0]).weight;
    }
    fillWeightsForPoints(t, i) {
        for(let s = i; s < t.length; ++s)t[s].timeWeight = (n = t[s].time) % 120 == 0 ? 10 : n % 60 == 0 ? 9 : n % 36 == 0 ? 8 : n % 12 == 0 ? 7 : n % 6 == 0 ? 6 : n % 3 == 0 ? 5 : n % 1 == 0 ? 4 : 0;
        var n;
        this.kb = t[t.length - 1].time, this.yb();
    }
    Tb(t) {
        if (this.yn.localization?.timeFormatter) return this.yn.localization.timeFormatter(t);
        if (t < 12) return `${t}M`;
        const i = Math.floor(t / 12), n = t % 12;
        return 0 === n ? `${i}Y` : `${i}Y${n}M`;
    }
}
const $a1a4d31e28ce1f0d$var$Pe = {
    yieldCurve: {
        baseResolution: 1,
        minimumTimeRange: 120,
        startTimeRange: 0
    },
    timeScale: {
        ignoreWhitespaceIndices: !0
    },
    leftPriceScale: {
        visible: !0
    },
    rightPriceScale: {
        visible: !1
    },
    localization: {
        priceFormatter: (t)=>t.toFixed(3) + "%"
    }
}, $a1a4d31e28ce1f0d$var$Te = {
    lastValueVisible: !1,
    priceLineVisible: !1
};
class $a1a4d31e28ce1f0d$var$Re extends $a1a4d31e28ce1f0d$var$ee {
    constructor(t, i){
        const n = $a1a4d31e28ce1f0d$var$f($a1a4d31e28ce1f0d$var$Pe, i || {}), s = new $a1a4d31e28ce1f0d$var$ke;
        super(t, s, n), s.setOptions(this.options()), this._initWhitespaceSeries();
    }
    addSeries(t, i = {}, n = 0) {
        if (t.isBuiltIn && !1 === [
            "Area",
            "Line"
        ].includes(t.type)) throw new Error("Yield curve only support Area and Line series");
        const s = {
            ...$a1a4d31e28ce1f0d$var$Te,
            ...i
        };
        return super.addSeries(t, s, n);
    }
    _initWhitespaceSeries() {
        const t = this.horzBehaviour(), i = this.addSeries($a1a4d31e28ce1f0d$export$29b04ebffc4f4705);
        let n;
        function s(s) {
            const e = function(t, i) {
                return {
                    me: Math.max(0, t.startTimeRange),
                    we: Math.max(0, t.minimumTimeRange, i || 0),
                    Rb: Math.max(1, t.baseResolution)
                };
            }(t.options().yieldCurve, s), r = (({ me: t, we: i, Rb: n })=>`${t}~${i}~${n}`)(e);
            r !== n && (n = r, i.setData(function({ me: t, we: i, Rb: n }) {
                return Array.from({
                    length: Math.floor((i - t) / n) + 1
                }, (i, s)=>({
                        time: t + s * n
                    }));
            }(e)));
        }
        s(0), t.Pb().i(s);
    }
}
function $a1a4d31e28ce1f0d$export$2ac108d26dcfda4e(t, i) {
    const n = $a1a4d31e28ce1f0d$var$re(t);
    return new $a1a4d31e28ce1f0d$var$Re(n, i);
}
function $a1a4d31e28ce1f0d$var$Ie(t, i) {
    return t.weight > i.weight ? t : i;
}
class $a1a4d31e28ce1f0d$var$Ve {
    options() {
        return this.yn;
    }
    setOptions(t) {
        this.yn = t;
    }
    preprocessData(t) {}
    updateFormatter(t) {
        this.yn && (this.yn.localization = t);
    }
    createConverterToInternalObj(t) {
        return (t)=>t;
    }
    key(t) {
        return t;
    }
    cacheKey(t) {
        return t;
    }
    convertHorzItemToInternal(t) {
        return t;
    }
    formatHorzItem(t) {
        return t.toFixed(this.Ds());
    }
    formatTickmark(t, i) {
        return t.time.toFixed(this.Ds());
    }
    maxTickMarkWeight(t) {
        return t.reduce($a1a4d31e28ce1f0d$var$Ie, t[0]).weight;
    }
    fillWeightsForPoints(t, i) {
        for(let s = i; s < t.length; ++s)t[s].timeWeight = (n = t[s].time) === 100 * Math.ceil(n / 100) ? 8 : n === 50 * Math.ceil(n / 50) ? 7 : n === 25 * Math.ceil(n / 25) ? 6 : n === 10 * Math.ceil(n / 10) ? 5 : n === 5 * Math.ceil(n / 5) ? 4 : n === Math.ceil(n) ? 3 : 2 * n === Math.ceil(2 * n) ? 1 : 0;
        var n;
    }
    Ds() {
        return this.yn.localization.precision;
    }
}
function $a1a4d31e28ce1f0d$export$e0948170eca90879(t, i) {
    return $a1a4d31e28ce1f0d$export$8982e77ac5c107b4(t, new $a1a4d31e28ce1f0d$var$Ve, i);
}
function $a1a4d31e28ce1f0d$var$Ee(t, i, n, s, e) {
    const { context: r, horizontalPixelRatio: h, verticalPixelRatio: a } = i;
    r.lineTo(e._t * h, t * a), r.lineTo(s._t * h, t * a), r.closePath(), r.fillStyle = n, r.fill();
}
class $a1a4d31e28ce1f0d$var$Ae extends $a1a4d31e28ce1f0d$var$R {
    constructor(){
        super(...arguments), this.rt = null;
    }
    ht(t) {
        this.rt = t;
    }
    et(t) {
        if (null === this.rt) return;
        const { ot: i, lt: n, wb: s, ct: e, Zt: r, Mb: h } = this.rt, l = this.rt.Db ?? (this.rt.Ib ? 0 : t.mediaSize.height);
        if (null === n) return;
        const o = t.context;
        o.lineCap = "butt", o.lineJoin = "round", o.lineWidth = e, $a1a4d31e28ce1f0d$var$a(o, r), o.lineWidth = 1, $a1a4d31e28ce1f0d$var$_e(t, i, h, n, s, this.Vb.bind(this), $a1a4d31e28ce1f0d$var$Ee.bind(null, l));
    }
}
class $a1a4d31e28ce1f0d$var$Le {
    Bb(t, i) {
        const n = this.Eb, { Ab: s, Lb: e, zb: r, Ob: h, Db: a, Nb: l, Fb: o } = i;
        if (void 0 === this.Wb || void 0 === n || n.Ab !== s || n.Lb !== e || n.zb !== r || n.Ob !== h || n.Db !== a || n.Nb !== l || n.Fb !== o) {
            const { verticalPixelRatio: n } = t, _ = a || l > 0 ? n : 1, u = l * _, c = o === t.bitmapSize.height ? o : o * _, d = (a ?? 0) * _, f = t.context.createLinearGradient(0, u, 0, c);
            if (f.addColorStop(0, s), null != a) {
                const t = $a1a4d31e28ce1f0d$var$ni((d - u) / (c - u), 0, 1);
                f.addColorStop(t, e), f.addColorStop(t, r);
            }
            f.addColorStop(1, h), this.Wb = f, this.Eb = i;
        }
        return this.Wb;
    }
}
class $a1a4d31e28ce1f0d$var$ze extends $a1a4d31e28ce1f0d$var$Ae {
    constructor(){
        super(...arguments), this.Hb = new $a1a4d31e28ce1f0d$var$Le;
    }
    Vb(t, i) {
        const n = this.rt;
        return this.Hb.Bb(t, {
            Ab: i.dh,
            Lb: i.fh,
            zb: i.ph,
            Ob: i.mh,
            Db: n.Db,
            Nb: n.Nb ?? 0,
            Fb: n.Fb ?? t.bitmapSize.height
        });
    }
}
class $a1a4d31e28ce1f0d$var$Oe extends $a1a4d31e28ce1f0d$var$ve {
    constructor(){
        super(...arguments), this.Ub = new $a1a4d31e28ce1f0d$var$Le;
    }
    bb(t, i) {
        const n = this.rt;
        return this.Ub.Bb(t, {
            Ab: i._h,
            Lb: i._h,
            zb: i.uh,
            Ob: i.uh,
            Db: n.Db,
            Nb: n.Nb ?? 0,
            Fb: n.Fb ?? t.bitmapSize.height
        });
    }
}
class $a1a4d31e28ce1f0d$var$Ne extends $a1a4d31e28ce1f0d$var$Se {
    constructor(t, i){
        super(t, i), this.kg = new $a1a4d31e28ce1f0d$var$T, this.$b = new $a1a4d31e28ce1f0d$var$ze, this.jb = new $a1a4d31e28ce1f0d$var$Oe, this.kg.nt([
            this.$b,
            this.jb
        ]);
    }
    xb(t, i, n) {
        return {
            ...this.Sb(t, i),
            ...n.Sh(t)
        };
    }
    Bg() {
        const t = this.ae.Lt();
        if (null === t) return;
        const i = this.ae.N(), n = this.ae.Ft().Nt(i.baseValue.price, t.Wt), s = this.le.Et().fl();
        if (null === this.Sg || 0 === this.bg.length) return;
        let e, r;
        if (i.relativeGradient) {
            e = this.bg[this.Sg.from].ut, r = this.bg[this.Sg.from].ut;
            for(let t = this.Sg.from; t < this.Sg.to; t++){
                const i = this.bg[t];
                i.ut < e && (e = i.ut), i.ut > r && (r = i.ut);
            }
        }
        this.$b.ht({
            ot: this.bg,
            ct: i.lineWidth,
            Zt: i.lineStyle,
            Mb: i.lineType,
            Db: n,
            Nb: e,
            Fb: r,
            Ib: !1,
            lt: this.Sg,
            wb: s
        }), this.jb.ht({
            ot: this.bg,
            ct: i.lineWidth,
            Zt: i.lineStyle,
            Mb: i.lineVisible ? i.lineType : void 0,
            gb: i.pointMarkersVisible ? i.pointMarkersRadius || i.lineWidth / 2 + 2 : void 0,
            Db: n,
            Nb: e,
            Fb: r,
            lt: this.Sg,
            wb: s
        });
    }
}
const $a1a4d31e28ce1f0d$export$7280a543172f8f3a = {
    type: "Baseline",
    isBuiltIn: !0,
    defaultOptions: {
        baseValue: {
            type: "price",
            price: 0
        },
        relativeGradient: !1,
        topFillColor1: "rgba(38, 166, 154, 0.28)",
        topFillColor2: "rgba(38, 166, 154, 0.05)",
        topLineColor: "rgba(38, 166, 154, 1)",
        bottomFillColor1: "rgba(239, 83, 80, 0.05)",
        bottomFillColor2: "rgba(239, 83, 80, 0.28)",
        bottomLineColor: "rgba(239, 83, 80, 1)",
        lineWidth: 3,
        lineStyle: 0,
        lineType: 0,
        lineVisible: !0,
        crosshairMarkerVisible: !0,
        crosshairMarkerRadius: 4,
        crosshairMarkerBorderColor: "",
        crosshairMarkerBorderWidth: 2,
        crosshairMarkerBackgroundColor: "",
        lastPriceAnimation: 0,
        pointMarkersVisible: !1
    },
    ob: (t, i)=>new $a1a4d31e28ce1f0d$var$Ne(t, i)
};
class $a1a4d31e28ce1f0d$var$We extends $a1a4d31e28ce1f0d$var$Ae {
    constructor(){
        super(...arguments), this.Hb = new $a1a4d31e28ce1f0d$var$Le;
    }
    Vb(t, i) {
        return this.Hb.Bb(t, {
            Ab: i.ah,
            Lb: "",
            zb: "",
            Ob: i.oh,
            Nb: this.rt?.Nb ?? 0,
            Fb: t.bitmapSize.height
        });
    }
}
class $a1a4d31e28ce1f0d$var$He extends $a1a4d31e28ce1f0d$var$Se {
    constructor(t, i){
        super(t, i), this.kg = new $a1a4d31e28ce1f0d$var$T, this.qb = new $a1a4d31e28ce1f0d$var$We, this.Yb = new $a1a4d31e28ce1f0d$var$me, this.kg.nt([
            this.qb,
            this.Yb
        ]);
    }
    xb(t, i, n) {
        return {
            ...this.Sb(t, i),
            ...n.Sh(t)
        };
    }
    Bg() {
        const t = this.ae.N();
        if (null === this.Sg || 0 === this.bg.length) return;
        let i;
        if (t.relativeGradient) {
            i = this.bg[this.Sg.from].ut;
            for(let t = this.Sg.from; t < this.Sg.to; t++){
                const n = this.bg[t];
                n.ut < i && (i = n.ut);
            }
        }
        this.qb.ht({
            Mb: t.lineType,
            ot: this.bg,
            Zt: t.lineStyle,
            ct: t.lineWidth,
            Db: null,
            Nb: i,
            Ib: t.invertFilledArea,
            lt: this.Sg,
            wb: this.le.Et().fl()
        }), this.Yb.ht({
            Mb: t.lineVisible ? t.lineType : void 0,
            ot: this.bg,
            Zt: t.lineStyle,
            ct: t.lineWidth,
            lt: this.Sg,
            wb: this.le.Et().fl(),
            gb: t.pointMarkersVisible ? t.pointMarkersRadius || t.lineWidth / 2 + 2 : void 0
        });
    }
}
const $a1a4d31e28ce1f0d$export$1d34d22a4e55a2c5 = {
    type: "Area",
    isBuiltIn: !0,
    defaultOptions: {
        topColor: "rgba( 46, 220, 135, 0.4)",
        bottomColor: "rgba( 40, 221, 100, 0)",
        invertFilledArea: !1,
        relativeGradient: !1,
        lineColor: "#33D778",
        lineStyle: 0,
        lineWidth: 3,
        lineType: 0,
        lineVisible: !0,
        crosshairMarkerVisible: !0,
        crosshairMarkerRadius: 4,
        crosshairMarkerBorderColor: "",
        crosshairMarkerBorderWidth: 2,
        crosshairMarkerBackgroundColor: "",
        lastPriceAnimation: 0,
        pointMarkersVisible: !1
    },
    ob: (t, i)=>new $a1a4d31e28ce1f0d$var$He(t, i)
};
class $a1a4d31e28ce1f0d$var$$e extends $a1a4d31e28ce1f0d$var$R {
    constructor(){
        super(...arguments), this.qt = null, this.Kb = 0, this.Zb = 0;
    }
    ht(t) {
        this.qt = t;
    }
    et({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null === this.qt || 0 === this.qt.Un.length || null === this.qt.lt) return;
        if (this.Kb = this.Gb(i), this.Kb >= 2) Math.max(1, Math.floor(i)) % 2 != this.Kb % 2 && this.Kb--;
        this.Zb = this.qt.Xb ? Math.min(this.Kb, Math.floor(i)) : this.Kb;
        let s = null;
        const e = this.Zb <= this.Kb && this.qt.fl >= Math.floor(1.5 * i);
        for(let r = this.qt.lt.from; r < this.qt.lt.to; ++r){
            const h = this.qt.Un[r];
            s !== h.sh && (t.fillStyle = h.sh, s = h.sh);
            const a = Math.floor(.5 * this.Zb), l = Math.round(h._t * i), o = l - a, _ = this.Zb, u = o + _ - 1, c = Math.min(h.Qo, h.t_), d = Math.max(h.Qo, h.t_), f = Math.round(c * n) - a, p = Math.round(d * n) + a, v = Math.max(p - f, this.Zb);
            t.fillRect(o, f, _, v);
            const m = Math.ceil(1.5 * this.Kb);
            if (e) {
                if (this.qt.Jb) {
                    const i = l - m;
                    let s = Math.max(f, Math.round(h.Jo * n) - a), e = s + _ - 1;
                    e > f + v - 1 && (e = f + v - 1, s = e - _ + 1), t.fillRect(i, s, o - i, e - s + 1);
                }
                const i = l + m;
                let s = Math.max(f, Math.round(h.i_ * n) - a), e = s + _ - 1;
                e > f + v - 1 && (e = f + v - 1, s = e - _ + 1), t.fillRect(u + 1, s, i - u, e - s + 1);
            }
        }
    }
    Gb(t) {
        const i = Math.floor(t);
        return Math.max(i, Math.floor(function(t, i) {
            return Math.floor(.3 * t * i);
        }($a1a4d31e28ce1f0d$var$u(this.qt).fl, t)));
    }
}
class $a1a4d31e28ce1f0d$var$je extends $a1a4d31e28ce1f0d$var$Rs {
    constructor(t, i){
        super(t, i, !1);
    }
    Pg(t, i) {
        return $a1a4d31e28ce1f0d$var$ys(this.bg, this.Sg, t, i, this.le.Et().fl(), this.ae.N().hitTestTolerance, (t, i)=>{
            i[0] = t.Qo, i[1] = t.t_;
        });
    }
    Vg(t, i, n) {
        i.Tc(this.bg, $a1a4d31e28ce1f0d$var$b(this.Sg)), t.Xo(this.bg, n, $a1a4d31e28ce1f0d$var$b(this.Sg));
    }
    Qb(t, i, n) {
        return {
            wt: t,
            jr: i.Wt[0],
            qr: i.Wt[1],
            Yr: i.Wt[2],
            Kr: i.Wt[3],
            _t: NaN,
            Jo: NaN,
            Qo: NaN,
            t_: NaN,
            i_: NaN
        };
    }
    Dg() {
        const t = this.ae.Sa();
        this.bg = this.ae.Ha().Bh().map((i)=>this.xb(i.$n, i, t));
    }
}
class $a1a4d31e28ce1f0d$var$qe extends $a1a4d31e28ce1f0d$var$je {
    constructor(){
        super(...arguments), this.kg = new $a1a4d31e28ce1f0d$var$$e;
    }
    xb(t, i, n) {
        return {
            ...this.Qb(t, i, n),
            ...n.Sh(t)
        };
    }
    Bg() {
        const t = this.ae.N();
        this.kg.ht({
            Un: this.bg,
            fl: this.le.Et().fl(),
            Jb: t.openVisible,
            Xb: t.thinBars,
            lt: this.Sg
        });
    }
}
const $a1a4d31e28ce1f0d$export$2db55af16212ab81 = {
    type: "Bar",
    isBuiltIn: !0,
    defaultOptions: {
        upColor: "#26a69a",
        downColor: "#ef5350",
        openVisible: !0,
        thinBars: !0
    },
    ob: (t, i)=>new $a1a4d31e28ce1f0d$var$qe(t, i)
};
class $a1a4d31e28ce1f0d$var$Ke extends $a1a4d31e28ce1f0d$var$R {
    constructor(){
        super(...arguments), this.qt = null, this.Kb = 0;
    }
    ht(t) {
        this.qt = t;
    }
    et(t) {
        if (null === this.qt || 0 === this.qt.Un.length || null === this.qt.lt) return;
        const { horizontalPixelRatio: i } = t;
        if (this.Kb = function(t, i) {
            if (t >= 2.5 && t <= 4) return Math.floor(3 * i);
            const n = 1 - .2 * Math.atan(Math.max(4, t) - 4) / (.5 * Math.PI), s = Math.floor(t * n * i), e = Math.floor(t * i), r = Math.min(s, e);
            return Math.max(Math.floor(i), r);
        }(this.qt.fl, i), this.Kb >= 2) Math.floor(i) % 2 != this.Kb % 2 && this.Kb--;
        const n = this.qt.Un;
        this.qt.tS && this.iS(t, n, this.qt.lt), this.qt.gi && this.Rm(t, n, this.qt.lt);
        const s = this.nS(i);
        (!this.qt.gi || this.Kb > 2 * s) && this.sS(t, n, this.qt.lt);
    }
    iS(t, i, n) {
        if (null === this.qt) return;
        const { context: s, horizontalPixelRatio: e, verticalPixelRatio: r } = t;
        let h = "", a = Math.min(Math.floor(e), Math.floor(this.qt.fl * e));
        a = Math.max(Math.floor(e), Math.min(a, this.Kb));
        const l = Math.floor(.5 * a);
        let o = null;
        for(let t = n.from; t < n.to; t++){
            const n = i[t];
            n.rh !== h && (s.fillStyle = n.rh, h = n.rh);
            const _ = Math.round(Math.min(n.Jo, n.i_) * r), u = Math.round(Math.max(n.Jo, n.i_) * r), c = Math.round(n.Qo * r), d = Math.round(n.t_ * r);
            let f = Math.round(e * n._t) - l;
            const p = f + a - 1;
            null !== o && (f = Math.max(o + 1, f), f = Math.min(f, p));
            const v = p - f + 1;
            s.fillRect(f, c, v, _ - c), s.fillRect(f, u + 1, v, d - u), o = p;
        }
    }
    nS(t) {
        let i = Math.floor(1 * t);
        this.Kb <= 2 * i && (i = Math.floor(.5 * (this.Kb - 1)));
        const n = Math.max(Math.floor(t), i);
        return this.Kb <= 2 * n ? Math.max(Math.floor(t), Math.floor(1 * t)) : n;
    }
    Rm(t, i, n) {
        if (null === this.qt) return;
        const { context: s, horizontalPixelRatio: e, verticalPixelRatio: r } = t;
        let h = "";
        const a = this.nS(e);
        let l = null;
        for(let t = n.from; t < n.to; t++){
            const n = i[t];
            n.eh !== h && (s.fillStyle = n.eh, h = n.eh);
            let o = Math.round(n._t * e) - Math.floor(.5 * this.Kb);
            const _ = o + this.Kb - 1, u = Math.round(Math.min(n.Jo, n.i_) * r), c = Math.round(Math.max(n.Jo, n.i_) * r);
            if (null !== l && (o = Math.max(l + 1, o), o = Math.min(o, _)), this.qt.fl * e > 2 * a) $a1a4d31e28ce1f0d$var$L(s, o, u, _ - o + 1, c - u + 1, a);
            else {
                const t = _ - o + 1;
                s.fillRect(o, u, t, c - u + 1);
            }
            l = _;
        }
    }
    sS(t, i, n) {
        if (null === this.qt) return;
        const { context: s, horizontalPixelRatio: e, verticalPixelRatio: r } = t;
        let h = "";
        const a = this.nS(e);
        for(let t = n.from; t < n.to; t++){
            const n = i[t];
            let l = Math.round(Math.min(n.Jo, n.i_) * r), o = Math.round(Math.max(n.Jo, n.i_) * r), _ = Math.round(n._t * e) - Math.floor(.5 * this.Kb), u = _ + this.Kb - 1;
            if (n.sh !== h) {
                const t = n.sh;
                s.fillStyle = t, h = t;
            }
            this.qt.gi && (_ += a, l += a, u -= a, o -= a), l > o || s.fillRect(_, l, u - _ + 1, o - l + 1);
        }
    }
}
class $a1a4d31e28ce1f0d$var$Ze extends $a1a4d31e28ce1f0d$var$je {
    constructor(){
        super(...arguments), this.kg = new $a1a4d31e28ce1f0d$var$Ke;
    }
    xb(t, i, n) {
        return {
            ...this.Qb(t, i, n),
            ...n.Sh(t)
        };
    }
    Bg() {
        const t = this.ae.N();
        this.kg.ht({
            Un: this.bg,
            fl: this.le.Et().fl(),
            tS: t.wickVisible,
            gi: t.borderVisible,
            lt: this.Sg
        });
    }
}
const $a1a4d31e28ce1f0d$export$9bff15f5cdf5e23d = {
    type: "Candlestick",
    isBuiltIn: !0,
    defaultOptions: {
        upColor: "#26a69a",
        downColor: "#ef5350",
        wickVisible: !0,
        borderVisible: !0,
        borderColor: "#378658",
        borderUpColor: "#26a69a",
        borderDownColor: "#ef5350",
        wickColor: "#737375",
        wickUpColor: "#26a69a",
        wickDownColor: "#ef5350"
    },
    ob: (t, i)=>new $a1a4d31e28ce1f0d$var$Ze(t, i)
};
class $a1a4d31e28ce1f0d$var$Xe extends $a1a4d31e28ce1f0d$var$R {
    constructor(){
        super(...arguments), this.qt = null, this.eS = [];
    }
    ht(t) {
        this.qt = t, this.eS = [];
    }
    et({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null === this.qt || 0 === this.qt.ot.length || null === this.qt.lt) return;
        this.eS.length || this.rS(i);
        const s = Math.max(1, Math.floor(n)), e = Math.round(this.qt.hS * n) - Math.floor(s / 2), r = e + s;
        for(let i = this.qt.lt.from; i < this.qt.lt.to; i++){
            const h = this.qt.ot[i], a = this.eS[i - this.qt.lt.from], l = Math.round(h.ut * n);
            let o, _;
            t.fillStyle = h.sh, l <= e ? (o = l, _ = r) : (o = e, _ = l - Math.floor(s / 2) + s), t.fillRect(a.Oa, o, a.bi - a.Oa + 1, _ - o);
        }
    }
    rS(t) {
        if (null === this.qt || 0 === this.qt.ot.length || null === this.qt.lt) return void (this.eS = []);
        const i = Math.ceil(this.qt.fl * t) <= 1 ? 0 : Math.max(1, Math.floor(t)), n = Math.round(this.qt.fl * t) - i;
        this.eS = new Array(this.qt.lt.to - this.qt.lt.from);
        for(let i = this.qt.lt.from; i < this.qt.lt.to; i++){
            const s = this.qt.ot[i], e = Math.round(s._t * t);
            let r, h;
            if (n % 2) {
                const t = (n - 1) / 2;
                r = e - t, h = e + t;
            } else {
                const t = n / 2;
                r = e - t, h = e + t - 1;
            }
            this.eS[i - this.qt.lt.from] = {
                Oa: r,
                bi: h,
                aS: e,
                ce: s._t * t,
                wt: s.wt
            };
        }
        for(let t = this.qt.lt.from + 1; t < this.qt.lt.to; t++){
            const n = this.eS[t - this.qt.lt.from], s = this.eS[t - this.qt.lt.from - 1];
            n.wt === s.wt + 1 && n.Oa - s.bi !== i + 1 && (s.aS > s.ce ? s.bi = n.Oa - i - 1 : n.Oa = s.bi + i + 1);
        }
        let s = Math.ceil(this.qt.fl * t);
        for(let t = this.qt.lt.from; t < this.qt.lt.to; t++){
            const i = this.eS[t - this.qt.lt.from];
            i.bi < i.Oa && (i.bi = i.Oa);
            const n = i.bi - i.Oa + 1;
            s = Math.min(n, s);
        }
        if (i > 0 && s < 4) for(let t = this.qt.lt.from; t < this.qt.lt.to; t++){
            const i = this.eS[t - this.qt.lt.from];
            i.bi - i.Oa + 1 > s && (i.aS > i.ce ? i.bi -= 1 : i.Oa += 1);
        }
    }
}
class $a1a4d31e28ce1f0d$var$Je extends $a1a4d31e28ce1f0d$var$be {
    constructor(){
        super(...arguments), this.kg = new $a1a4d31e28ce1f0d$var$Xe;
    }
    Pg(t, i) {
        const n = this.ae.Ft().Nt(this.ae.N().base, $a1a4d31e28ce1f0d$var$u(this.ae.Lt()).Wt);
        return null === n ? null : $a1a4d31e28ce1f0d$var$ys(this.bg, this.Sg, t, i, this.le.Et().fl(), this.ae.N().hitTestTolerance, (t, i)=>{
            i[0] = t.ut, i[1] = n;
        });
    }
    xb(t, i, n) {
        return {
            ...this.Sb(t, i),
            ...n.Sh(t)
        };
    }
    Bg() {
        const t = {
            ot: this.bg,
            fl: this.le.Et().fl(),
            lt: this.Sg,
            hS: this.ae.Ft().Nt(this.ae.N().base, $a1a4d31e28ce1f0d$var$u(this.ae.Lt()).Wt)
        };
        this.kg.ht(t);
    }
}
const $a1a4d31e28ce1f0d$export$9553650b5f8815ed = {
    type: "Histogram",
    isBuiltIn: !0,
    defaultOptions: {
        color: "#26a69a",
        base: 0
    },
    ob: (t, i)=>new $a1a4d31e28ce1f0d$var$Je(t, i)
};
class $a1a4d31e28ce1f0d$var$tr {
    constructor(t, i){
        this.yt = t, this.lS = i, this.oS();
    }
    detach() {
        this.yt.detachPrimitive(this.lS);
    }
    getPane() {
        return this.yt;
    }
    applyOptions(t) {
        this.lS.vr?.(t);
    }
    oS() {
        this.yt.attachPrimitive(this.lS);
    }
}
const $a1a4d31e28ce1f0d$var$ir = {
    visible: !0,
    horzAlign: "center",
    vertAlign: "center",
    lines: []
}, $a1a4d31e28ce1f0d$var$nr = {
    color: "rgba(0, 0, 0, 0.5)",
    fontSize: 48,
    fontFamily: $a1a4d31e28ce1f0d$var$S,
    fontStyle: "",
    text: ""
};
class $a1a4d31e28ce1f0d$var$sr {
    constructor(t){
        this._S = new Map, this.qt = t;
    }
    draw(t) {
        t.useMediaCoordinateSpace((t)=>{
            if (!this.qt.visible) return;
            const { context: i, mediaSize: n } = t;
            let s = 0;
            for (const t of this.qt.lines){
                if (0 === t.text.length) continue;
                i.font = t.P;
                const e = this.uS(i, t.text);
                e > n.width ? t.Fc = n.width / e : t.Fc = 1, s += t.lineHeight * t.Fc;
            }
            let e = 0;
            switch(this.qt.vertAlign){
                case "top":
                    e = 0;
                    break;
                case "center":
                    e = Math.max((n.height - s) / 2, 0);
                    break;
                case "bottom":
                    e = Math.max(n.height - s, 0);
            }
            for (const t of this.qt.lines){
                i.save(), i.fillStyle = t.color;
                let s = 0;
                switch(this.qt.horzAlign){
                    case "left":
                        i.textAlign = "left", s = t.lineHeight / 2;
                        break;
                    case "center":
                        i.textAlign = "center", s = n.width / 2;
                        break;
                    case "right":
                        i.textAlign = "right", s = n.width - 1 - t.lineHeight / 2;
                }
                i.translate(s, e), i.textBaseline = "top", i.font = t.P, i.scale(t.Fc, t.Fc), i.fillText(t.text, 0, t.cS), i.restore(), e += t.lineHeight * t.Fc;
            }
        });
    }
    uS(t, i) {
        const n = this.dS(t.font);
        let s = n.get(i);
        return void 0 === s && (s = t.measureText(i).width, n.set(i, s)), s;
    }
    dS(t) {
        let i = this._S.get(t);
        return void 0 === i && (i = new Map, this._S.set(t, i)), i;
    }
}
class $a1a4d31e28ce1f0d$var$er {
    constructor(t){
        this.yn = $a1a4d31e28ce1f0d$var$hr(t);
    }
    kt(t) {
        this.yn = $a1a4d31e28ce1f0d$var$hr(t);
    }
    renderer() {
        return new $a1a4d31e28ce1f0d$var$sr(this.yn);
    }
}
function $a1a4d31e28ce1f0d$var$rr(t) {
    return {
        ...t,
        P: $a1a4d31e28ce1f0d$var$x(t.fontSize, t.fontFamily, t.fontStyle),
        lineHeight: t.lineHeight || 1.2 * t.fontSize,
        cS: 0,
        Fc: 0
    };
}
function $a1a4d31e28ce1f0d$var$hr(t) {
    return {
        ...t,
        lines: t.lines.map($a1a4d31e28ce1f0d$var$rr)
    };
}
function $a1a4d31e28ce1f0d$var$ar(t) {
    return {
        ...$a1a4d31e28ce1f0d$var$nr,
        ...t
    };
}
function $a1a4d31e28ce1f0d$var$lr(t) {
    return {
        ...$a1a4d31e28ce1f0d$var$ir,
        ...t,
        lines: t.lines?.map($a1a4d31e28ce1f0d$var$ar) ?? []
    };
}
class $a1a4d31e28ce1f0d$var$or {
    constructor(t){
        this.yn = $a1a4d31e28ce1f0d$var$lr(t), this.fS = [
            new $a1a4d31e28ce1f0d$var$er(this.yn)
        ];
    }
    updateAllViews() {
        this.fS.forEach((t)=>t.kt(this.yn));
    }
    paneViews() {
        return this.fS;
    }
    attached({ requestUpdate: t }) {
        this.pS = t;
    }
    detached() {
        this.pS = void 0;
    }
    vr(t) {
        this.yn = $a1a4d31e28ce1f0d$var$lr({
            ...this.yn,
            ...t
        }), this.pS && this.pS();
    }
}
function $a1a4d31e28ce1f0d$export$50cefd0ddd654f76(t, i) {
    return new $a1a4d31e28ce1f0d$var$tr(t, new $a1a4d31e28ce1f0d$var$or(i));
}
const $a1a4d31e28ce1f0d$var$ur = {
    alpha: 1,
    padding: 0
};
class $a1a4d31e28ce1f0d$var$cr {
    constructor(t){
        this.qt = t;
    }
    draw(t) {
        t.useMediaCoordinateSpace((t)=>{
            const i = t.context, n = this.vS(this.qt, t.mediaSize);
            n && this.qt.mS && (i.globalAlpha = this.qt.alpha ?? 1, i.drawImage(this.qt.mS, n._t, n.ut, n.nn, n.$t));
        });
    }
    vS(t, i) {
        const { maxHeight: n, maxWidth: s, wS: e, MS: r, padding: h } = t, a = Math.round(i.width / 2), l = Math.round(i.height / 2), o = h ?? 0;
        let _ = i.width - 2 * o, u = i.height - 2 * o;
        n && (u = Math.min(u, n)), s && (_ = Math.min(_, s));
        const c = _ / r, d = u / e, f = Math.min(c, d), p = r * f, v = e * f;
        return {
            _t: a - .5 * p,
            ut: l - .5 * v,
            $t: v,
            nn: p
        };
    }
}
class $a1a4d31e28ce1f0d$var$dr {
    constructor(t){
        this.gS = null, this.bS = 0, this.SS = 0, this.yn = t, this.M = $a1a4d31e28ce1f0d$var$fr(this.yn, this.gS, this.bS, this.SS);
    }
    xS(t) {
        void 0 !== t.CS && (this.bS = t.CS), void 0 !== t.yS && (this.SS = t.yS), void 0 !== t.kS && (this.gS = t.kS), this.kt();
    }
    PS(t) {
        this.yn = t, this.kt();
    }
    zOrder() {
        return "bottom";
    }
    kt() {
        this.M = $a1a4d31e28ce1f0d$var$fr(this.yn, this.gS, this.bS, this.SS);
    }
    renderer() {
        return new $a1a4d31e28ce1f0d$var$cr(this.M);
    }
}
function $a1a4d31e28ce1f0d$var$fr(t, i, n, s) {
    return {
        ...t,
        mS: i,
        MS: n,
        wS: s
    };
}
function $a1a4d31e28ce1f0d$var$pr(t) {
    return {
        ...$a1a4d31e28ce1f0d$var$ur,
        ...t
    };
}
class $a1a4d31e28ce1f0d$var$vr {
    constructor(t, i){
        this.TS = null, this.RS = t, this.yn = $a1a4d31e28ce1f0d$var$pr(i), this.fS = [
            new $a1a4d31e28ce1f0d$var$dr(this.yn)
        ];
    }
    updateAllViews() {
        this.fS.forEach((t)=>t.kt());
    }
    paneViews() {
        return this.fS;
    }
    attached(t) {
        const { requestUpdate: i } = t;
        this.DS = i, this.TS = new Image, this.TS.onload = ()=>{
            const t = this.TS?.naturalHeight ?? 1, i = this.TS?.naturalWidth ?? 1;
            this.fS.forEach((n)=>n.xS({
                    yS: t,
                    CS: i,
                    kS: this.TS
                })), this.DS && this.DS();
        }, this.TS.src = this.RS;
    }
    detached() {
        this.DS = void 0, this.TS = null;
    }
    vr(t) {
        this.yn = $a1a4d31e28ce1f0d$var$pr({
            ...this.yn,
            ...t
        }), this.IS(), this.pS && this.pS();
    }
    pS() {
        this.DS && this.DS();
    }
    IS() {
        this.fS.forEach((t)=>t.PS(this.yn));
    }
}
function $a1a4d31e28ce1f0d$export$58be2ae7527a8029(t, i, n) {
    return new $a1a4d31e28ce1f0d$var$tr(t, new $a1a4d31e28ce1f0d$var$vr(i, n));
}
class $a1a4d31e28ce1f0d$var$wr {
    constructor(t, i){
        this.ae = t, this.Jh = i, this.oS();
    }
    detach() {
        this.ae.detachPrimitive(this.Jh);
    }
    getSeries() {
        return this.ae;
    }
    applyOptions(t) {
        this.Jh && this.Jh.vr && this.Jh.vr(t);
    }
    oS() {
        this.ae.attachPrimitive(this.Jh);
    }
}
const $a1a4d31e28ce1f0d$var$Mr = {
    autoScale: !0,
    zOrder: "normal"
};
function $a1a4d31e28ce1f0d$var$gr(t, i) {
    return $a1a4d31e28ce1f0d$var$ei(Math.min(Math.max(t, 12), 30) * i);
}
function $a1a4d31e28ce1f0d$var$br(t, i) {
    switch(t){
        case "arrowDown":
        case "arrowUp":
            return $a1a4d31e28ce1f0d$var$gr(i, 1);
        case "circle":
            return $a1a4d31e28ce1f0d$var$gr(i, .8);
        case "square":
            return $a1a4d31e28ce1f0d$var$gr(i, .7);
    }
}
function $a1a4d31e28ce1f0d$var$Sr(t) {
    return function(t) {
        const i = Math.ceil(t);
        return i % 2 != 0 ? i - 1 : i;
    }($a1a4d31e28ce1f0d$var$gr(t, 1));
}
function $a1a4d31e28ce1f0d$var$xr(t) {
    return Math.max($a1a4d31e28ce1f0d$var$gr(t, .1), 3);
}
function $a1a4d31e28ce1f0d$var$Cr(t, i, n) {
    return i ? t : n ? Math.ceil(t / 2) : 0;
}
function $a1a4d31e28ce1f0d$var$yr(t, i, n, s) {
    const e = ($a1a4d31e28ce1f0d$var$br("arrowUp", s) - 1) / 2 * n.VS, r = ($a1a4d31e28ce1f0d$var$ei(s / 2) - 1) / 2 * n.VS;
    i.beginPath(), t ? (i.moveTo(n._t - e, n.ut), i.lineTo(n._t, n.ut - e), i.lineTo(n._t + e, n.ut), i.lineTo(n._t + r, n.ut), i.lineTo(n._t + r, n.ut + e), i.lineTo(n._t - r, n.ut + e), i.lineTo(n._t - r, n.ut)) : (i.moveTo(n._t - e, n.ut), i.lineTo(n._t, n.ut + e), i.lineTo(n._t + e, n.ut), i.lineTo(n._t + r, n.ut), i.lineTo(n._t + r, n.ut - e), i.lineTo(n._t - r, n.ut - e), i.lineTo(n._t - r, n.ut)), i.fill();
}
function $a1a4d31e28ce1f0d$var$kr(t, i, n, s, e, r) {
    const h = ($a1a4d31e28ce1f0d$var$br("arrowUp", s) - 1) / 2, a = ($a1a4d31e28ce1f0d$var$ei(s / 2) - 1) / 2;
    if (e >= i - a - 2 && e <= i + a + 2 && r >= (t ? n : n - h) - 2 && r <= (t ? n + h : n) + 2) return !0;
    return (()=>{
        if (e < i - h - 3 || e > i + h + 3 || r < (t ? n - h - 3 : n) || r > (t ? n : n + h + 3)) return !1;
        const s = Math.abs(e - i);
        return Math.abs(r - n) + 3 >= s / 2;
    })();
}
class $a1a4d31e28ce1f0d$var$Pr {
    constructor(){
        this.qt = null, this.$s = new $a1a4d31e28ce1f0d$var$rt, this.F = -1, this.W = "", this.nm = "", this.BS = "normal";
    }
    ht(t) {
        this.qt = t;
    }
    js(t, i, n) {
        this.F === t && this.W === i || (this.F = t, this.W = i, this.nm = $a1a4d31e28ce1f0d$var$x(t, i), this.$s.Os()), this.BS = n;
    }
    Qs(t, i) {
        if (null === this.qt || null === this.qt.lt) return null;
        for(let n = this.qt.lt.from; n < this.qt.lt.to; n++){
            const s = this.qt.ot[n];
            if (s && $a1a4d31e28ce1f0d$var$Rr(s, t, i)) return {
                zOrder: "normal",
                externalId: s.te ?? "",
                itemType: "marker"
            };
        }
        return null;
    }
    draw(t) {
        "aboveSeries" !== this.BS && t.useBitmapCoordinateSpace((t)=>{
            this.et(t);
        });
    }
    drawBackground(t) {
        "aboveSeries" === this.BS && t.useBitmapCoordinateSpace((t)=>{
            this.et(t);
        });
    }
    et({ context: t, horizontalPixelRatio: i, verticalPixelRatio: n }) {
        if (null !== this.qt && null !== this.qt.lt) {
            t.textBaseline = "middle", t.font = this.nm;
            for(let s = this.qt.lt.from; s < this.qt.lt.to; s++){
                const e = this.qt.ot[s];
                void 0 !== e.ri && (e.ri.nn = this.$s.Ii(t, e.ri.ES), e.ri.$t = this.F, e.ri._t = e._t - e.ri.nn / 2), $a1a4d31e28ce1f0d$var$Tr(e, t, i, n);
            }
        }
    }
}
function $a1a4d31e28ce1f0d$var$Tr(t, i, n, s) {
    i.fillStyle = t.R, void 0 !== t.ri && function(t, i, n, s, e, r) {
        t.save(), t.scale(e, r), t.fillText(i, n, s), t.restore();
    }(i, t.ri.ES, t.ri._t, t.ri.ut, n, s), function(t, i, n) {
        if (0 === t.Th) return;
        switch(t.AS){
            case "arrowDown":
                return void $a1a4d31e28ce1f0d$var$yr(!1, i, n, t.Th);
            case "arrowUp":
                return void $a1a4d31e28ce1f0d$var$yr(!0, i, n, t.Th);
            case "circle":
                return void function(t, i, n) {
                    const s = ($a1a4d31e28ce1f0d$var$br("circle", n) - 1) / 2;
                    t.beginPath(), t.arc(i._t, i.ut, s * i.VS, 0, 2 * Math.PI, !1), t.fill();
                }(i, n, t.Th);
            case "square":
                return void function(t, i, n) {
                    const s = $a1a4d31e28ce1f0d$var$br("square", n), e = (s - 1) * i.VS / 2, r = i._t - e, h = i.ut - e;
                    t.fillRect(r, h, s * i.VS, s * i.VS);
                }(i, n, t.Th);
        }
        t.AS;
    }(t, i, function(t, i, n) {
        const s = Math.max(1, Math.floor(i)) % 2 / 2;
        return {
            _t: Math.round(t._t * i) + s,
            ut: t.ut * n,
            VS: i
        };
    }(t, n, s));
}
function $a1a4d31e28ce1f0d$var$Rr(t, i, n) {
    return !(void 0 === t.ri || !function(t, i, n, s, e, r) {
        const h = s / 2;
        return e >= t && e <= t + n && r >= i - h && r <= i + h;
    }(t.ri._t, t.ri.ut, t.ri.nn, t.ri.$t, i, n)) || function(t, i, n) {
        if (0 === t.Th) return !1;
        switch(t.AS){
            case "arrowDown":
                return $a1a4d31e28ce1f0d$var$kr(!0, t._t, t.ut, t.Th, i, n);
            case "arrowUp":
                return $a1a4d31e28ce1f0d$var$kr(!1, t._t, t.ut, t.Th, i, n);
            case "circle":
                return function(t, i, n, s, e) {
                    const r = 2 + $a1a4d31e28ce1f0d$var$br("circle", n) / 2, h = t - s, a = i - e;
                    return Math.sqrt(h * h + a * a) <= r;
                }(t._t, t.ut, t.Th, i, n);
            case "square":
                return function(t, i, n, s, e) {
                    const r = $a1a4d31e28ce1f0d$var$br("square", n), h = (r - 1) / 2, a = t - h, l = i - h;
                    return s >= a && s <= a + r && e >= l && e <= l + r;
                }(t._t, t.ut, t.Th, i, n);
        }
    }(t, i, n);
}
function $a1a4d31e28ce1f0d$var$Dr(t) {
    return "atPriceTop" === t || "atPriceBottom" === t || "atPriceMiddle" === t;
}
function $a1a4d31e28ce1f0d$var$Ir(t, i, n, s, e, r, h, a) {
    const l = function(t, i, n) {
        if ($a1a4d31e28ce1f0d$var$Dr(i.position) && void 0 !== i.price) return i.price;
        if ("value" in (s = t) && "number" == typeof s.value) return t.value;
        var s;
        if (function(t) {
            return "open" in t && "high" in t && "low" in t && "close" in t;
        }(t)) {
            if ("inBar" === i.position) return t.close;
            if ("aboveBar" === i.position) return n ? t.low : t.high;
            if ("belowBar" === i.position) return n ? t.high : t.low;
        }
    }(n, i, h.priceScale().options().invertScale);
    if (void 0 === l) return;
    const o = $a1a4d31e28ce1f0d$var$Dr(i.position), _ = a.timeScale(), c = $a1a4d31e28ce1f0d$var$p(i.size) ? Math.max(i.size, 0) : 1, d = $a1a4d31e28ce1f0d$var$Sr(_.options().barSpacing) * c, f = d / 2;
    t.Th = d;
    switch(i.position){
        case "inBar":
        case "atPriceMiddle":
            return t.ut = $a1a4d31e28ce1f0d$var$u(h.priceToCoordinate(l)), void (void 0 !== t.ri && (t.ri.ut = t.ut + f + r + .6 * e));
        case "aboveBar":
        case "atPriceTop":
            {
                const i = o ? 0 : s.LS;
                return t.ut = $a1a4d31e28ce1f0d$var$u(h.priceToCoordinate(l)) - f - i, void 0 !== t.ri && (t.ri.ut = t.ut - f - .6 * e, s.LS += 1.2 * e), void (o || (s.LS += d + r));
            }
        case "belowBar":
        case "atPriceBottom":
            {
                const i = o ? 0 : s.zS;
                return t.ut = $a1a4d31e28ce1f0d$var$u(h.priceToCoordinate(l)) + f + i, void 0 !== t.ri && (t.ri.ut = t.ut + f + r + .6 * e, s.zS += 1.2 * e), void (o || (s.zS += d + r));
            }
    }
}
class $a1a4d31e28ce1f0d$var$Vr {
    constructor(t, i, n){
        this.OS = [], this.xt = !0, this.NS = !0, this.Xt = new $a1a4d31e28ce1f0d$var$Pr, this.Te = t, this.qv = i, this.qt = {
            ot: [],
            lt: null
        }, this.yn = n;
    }
    renderer() {
        if (!this.Te.options().visible) return null;
        this.xt && this.yg();
        const t = this.qv.options().layout;
        return this.Xt.js(t.fontSize, t.fontFamily, this.yn.zOrder), this.Xt.ht(this.qt), this.Xt;
    }
    FS(t) {
        this.OS = t, this.kt("data");
    }
    kt(t) {
        this.xt = !0, "data" === t && (this.NS = !0);
    }
    WS(t) {
        this.xt = !0, this.yn = t;
    }
    zOrder() {
        return "aboveSeries" === this.yn.zOrder ? "top" : this.yn.zOrder;
    }
    yg() {
        const t = this.qv.timeScale(), i = this.OS;
        this.NS && (this.qt.ot = i.map((t)=>({
                wt: t.time,
                _t: 0,
                ut: 0,
                Th: 0,
                AS: t.shape,
                R: t.color,
                te: t.id,
                HS: t.HS,
                ri: void 0
            })), this.NS = !1);
        const n = this.qv.options().layout;
        this.qt.lt = null;
        const s = t.getVisibleLogicalRange();
        if (null === s) return;
        const e = new $a1a4d31e28ce1f0d$var$Ai(Math.floor(s.from), Math.ceil(s.to));
        if (null === this.Te.data()[0]) return;
        if (0 === this.qt.ot.length) return;
        let r = NaN;
        const h = $a1a4d31e28ce1f0d$var$xr(t.options().barSpacing), a = {
            LS: h,
            zS: h
        };
        this.qt.lt = $a1a4d31e28ce1f0d$var$Ts(this.qt.ot, e, !0);
        for(let s = this.qt.lt.from; s < this.qt.lt.to; s++){
            const e = i[s];
            e.time !== r && (a.LS = h, a.zS = h, r = e.time);
            const l = this.qt.ot[s];
            l._t = $a1a4d31e28ce1f0d$var$u(t.logicalToCoordinate(e.time)), void 0 !== e.text && e.text.length > 0 && (l.ri = {
                ES: e.text,
                _t: 0,
                ut: 0,
                nn: 0,
                $t: 0
            });
            const o = this.Te.dataByIndex(e.time, 0);
            null !== o && $a1a4d31e28ce1f0d$var$Ir(l, e, o, a, n.fontSize, h, this.Te, this.qv);
        }
        this.xt = !1;
    }
}
function $a1a4d31e28ce1f0d$var$Br(t) {
    return {
        ...$a1a4d31e28ce1f0d$var$Mr,
        ...t
    };
}
class $a1a4d31e28ce1f0d$var$Er {
    constructor(t){
        this.Yh = null, this.OS = [], this.US = [], this.$S = null, this.Te = null, this.qv = null, this.jS = !0, this.qS = null, this.YS = null, this.KS = null, this.ZS = !0, this.yn = $a1a4d31e28ce1f0d$var$Br(t);
    }
    attached(t) {
        this.GS(), this.qv = t.chart, this.Te = t.series, this.Yh = new $a1a4d31e28ce1f0d$var$Vr(this.Te, $a1a4d31e28ce1f0d$var$u(this.qv), this.yn), this.DS = t.requestUpdate, this.Te.subscribeDataChanged((t)=>this.Yg(t)), this.ZS = !0, this.pS();
    }
    pS() {
        this.DS && this.DS();
    }
    detached() {
        this.Te && this.$S && this.Te.unsubscribeDataChanged(this.$S), this.qv = null, this.Te = null, this.Yh = null, this.$S = null;
    }
    FS(t) {
        this.ZS = !0, this.OS = t, this.GS(), this.jS = !0, this.YS = null, this.pS();
    }
    XS() {
        return this.OS;
    }
    paneViews() {
        return this.Yh ? [
            this.Yh
        ] : [];
    }
    updateAllViews() {
        this.JS();
    }
    hitTest(t, i) {
        return this.Yh ? this.Yh.renderer()?.Qs(t, i) ?? null : null;
    }
    autoscaleInfo(t, i) {
        if (this.yn.autoScale && this.Yh) {
            const t = this.QS();
            if (t) return {
                priceRange: null,
                margins: t
            };
        }
        return null;
    }
    vr(t) {
        this.yn = $a1a4d31e28ce1f0d$var$Br({
            ...this.yn,
            ...t
        }), this.pS && this.pS();
    }
    QS() {
        const t = $a1a4d31e28ce1f0d$var$u(this.qv).timeScale().options().barSpacing;
        if (this.jS || t !== this.KS) {
            if (this.KS = t, this.OS.length > 0) {
                const i = $a1a4d31e28ce1f0d$var$xr(t), n = 1.5 * $a1a4d31e28ce1f0d$var$Sr(t) + 2 * i, s = this.tx();
                this.qS = {
                    above: $a1a4d31e28ce1f0d$var$Cr(n, s.aboveBar, s.inBar),
                    below: $a1a4d31e28ce1f0d$var$Cr(n, s.belowBar, s.inBar)
                };
            } else this.qS = null;
            this.jS = !1;
        }
        return this.qS;
    }
    tx() {
        return null === this.YS && (this.YS = this.OS.reduce((t, i)=>(t[i.position] || (t[i.position] = !0), t), {
            inBar: !1,
            aboveBar: !1,
            belowBar: !1,
            atPriceTop: !1,
            atPriceBottom: !1,
            atPriceMiddle: !1
        })), this.YS;
    }
    GS() {
        if (!this.ZS || !this.qv || !this.Te) return;
        const t = this.qv.timeScale(), i = this.Te?.data();
        if (null == t.getVisibleLogicalRange() || !this.Te || 0 === i.length) return void (this.US = []);
        const n = t.timeToIndex($a1a4d31e28ce1f0d$var$u(i[0].time), !0);
        this.US = this.OS.map((i, s)=>{
            const e = t.timeToIndex(i.time, !0), r = e < n ? 1 : -1, h = $a1a4d31e28ce1f0d$var$u(this.Te).dataByIndex(e, r), a = {
                time: t.timeToIndex($a1a4d31e28ce1f0d$var$u(h).time, !1),
                position: i.position,
                shape: i.shape,
                color: i.color,
                id: i.id,
                HS: s,
                text: i.text,
                size: i.size,
                price: i.price,
                Qr: i.time
            };
            if ("atPriceTop" === i.position || "atPriceBottom" === i.position || "atPriceMiddle" === i.position) {
                if (void 0 === i.price) throw new Error(`Price is required for position ${i.position}`);
                return {
                    ...a,
                    position: i.position,
                    price: i.price
                };
            }
            return {
                ...a,
                position: i.position,
                price: i.price
            };
        }), this.ZS = !1;
    }
    JS(t) {
        this.Yh && (this.GS(), this.Yh.FS(this.US), this.Yh.WS(this.yn), this.Yh.kt(t));
    }
    Yg(t) {
        this.ZS = !0, this.pS();
    }
}
class $a1a4d31e28ce1f0d$var$Ar extends $a1a4d31e28ce1f0d$var$wr {
    constructor(t, i, n){
        super(t, i), n && this.setMarkers(n);
    }
    setMarkers(t) {
        this.Jh.FS(t);
    }
    markers() {
        return this.Jh.XS();
    }
}
function $a1a4d31e28ce1f0d$export$b954512652d436b9(t, i, n) {
    const s = new $a1a4d31e28ce1f0d$var$Ar(t, new $a1a4d31e28ce1f0d$var$Er(n ?? {}));
    return i && s.setMarkers(i), s;
}
class $a1a4d31e28ce1f0d$var$zr {
    constructor(t){
        this.OS = new Map, this.ix = t;
    }
    nx(t, i, n) {
        if (this.sx(i), void 0 !== n) {
            const s = window.setTimeout(()=>{
                this.OS.delete(i), this.hx();
            }, n), e = {
                ...t,
                lx: s,
                ox: Date.now() + n
            };
            this.OS.set(i, e);
        } else this.OS.set(i, {
            ...t,
            lx: void 0,
            ox: void 0
        });
        this.hx();
    }
    sx(t) {
        const i = this.OS.get(t);
        i && void 0 !== i.lx && window.clearTimeout(i.lx), this.OS.delete(t), this.hx();
    }
    _x() {
        for (const [t] of this.OS)this.sx(t);
    }
    ux() {
        const t = Date.now(), i = [];
        for (const [n, s] of this.OS)!s.ox || s.ox > t ? i.push({
            time: s.time,
            sign: s.sign,
            value: s.value
        }) : this.sx(n);
        return i;
    }
    vx(t) {
        this.ix = t;
    }
    hx() {
        this.ix && this.ix();
    }
}
const $a1a4d31e28ce1f0d$var$Or = {
    positiveColor: "#22AB94",
    negativeColor: "#F7525F",
    updateVisibilityDuration: 5e3
};
class $a1a4d31e28ce1f0d$var$Nr {
    constructor(t, i, n, s){
        this.qt = t, this.mx = i, this.wx = n, this.Mx = s;
    }
    draw(t) {
        t.useBitmapCoordinateSpace((t)=>{
            const i = t.context, n = Math.max(1, Math.floor(t.horizontalPixelRatio)) % 2 / 2, s = 4 * t.verticalPixelRatio + n;
            this.qt.forEach((e)=>{
                const r = Math.round(e._t * t.horizontalPixelRatio) + n;
                i.beginPath();
                const h = this.gx(e.bx);
                i.fillStyle = h, i.arc(r, e.ut * t.verticalPixelRatio, s, 0, 2 * Math.PI, !1), i.fill(), e.bx && (i.strokeStyle = h, i.lineWidth = Math.floor(2 * t.horizontalPixelRatio), i.beginPath(), i.moveTo((e._t - 4.7) * t.horizontalPixelRatio + n, (e.ut - 7 * e.bx) * t.verticalPixelRatio), i.lineTo(e._t * t.horizontalPixelRatio + n, (e.ut - 7 * e.bx - 7 * e.bx * .5) * t.verticalPixelRatio), i.lineTo((e._t + 4.7) * t.horizontalPixelRatio + n, (e.ut - 7 * e.bx) * t.verticalPixelRatio), i.stroke());
            });
        });
    }
    gx(t) {
        return 0 === t ? this.mx : t > 0 ? this.Mx : this.wx;
    }
}
class $a1a4d31e28ce1f0d$var$Fr {
    constructor(t, i, n){
        this.qt = [], this.Te = t, this.ia = i, this.yn = n;
    }
    kt(t) {
        this.qt = t.map((t)=>{
            const i = this.Te.priceToCoordinate(t.value);
            if (null === i) return null;
            return {
                _t: $a1a4d31e28ce1f0d$var$u(this.ia.timeToCoordinate(t.time)),
                ut: i,
                bx: t.sign
            };
        }).filter($a1a4d31e28ce1f0d$var$g);
    }
    renderer() {
        const t = function(t, i) {
            return function(t, i) {
                return "Area" === i;
            }(0, i) ? t.lineColor : t.color;
        }(this.Te.options(), this.Te.seriesType());
        return new $a1a4d31e28ce1f0d$var$Nr(this.qt, t, this.yn.negativeColor, this.yn.positiveColor);
    }
}
function $a1a4d31e28ce1f0d$var$Wr(t, i) {
    return "Line" === i || "Area" === i;
}
class $a1a4d31e28ce1f0d$var$Hr {
    constructor(t){
        this.qv = void 0, this.Te = void 0, this.fS = [], this.xu = null, this.Sx = new Map, this.xx = new $a1a4d31e28ce1f0d$var$zr(()=>this.pS()), this.yn = {
            ...$a1a4d31e28ce1f0d$var$Or,
            ...t
        };
    }
    vr(t) {
        this.yn = {
            ...this.yn,
            ...t
        }, this.pS();
    }
    FS(t) {
        this.xx._x();
        const i = this.xu;
        i && t.forEach((t)=>{
            this.xx.nx(t, i.key(t.time));
        });
    }
    XS() {
        return this.xx.ux();
    }
    pS() {
        this.DS?.();
    }
    attached(t) {
        const { chart: i, series: n, requestUpdate: s, horzScaleBehavior: e } = t;
        this.qv = i, this.Te = n, this.xu = e;
        const r = this.Te.seriesType();
        if ("Area" !== r && "Line" !== r) throw new Error("UpDownMarkersPrimitive is only supported for Area and Line series types");
        this.fS = [
            new $a1a4d31e28ce1f0d$var$Fr(this.Te, this.qv.timeScale(), this.yn)
        ], this.DS = s, this.pS();
    }
    detached() {
        this.qv = void 0, this.Te = void 0, this.DS = void 0;
    }
    am() {
        return $a1a4d31e28ce1f0d$var$_(this.qv);
    }
    U_() {
        return $a1a4d31e28ce1f0d$var$_(this.Te);
    }
    updateAllViews() {
        this.fS.forEach((t)=>t.kt(this.XS()));
    }
    paneViews() {
        return this.fS;
    }
    ht(t) {
        if (!this.Te) throw new Error("Primitive not attached to series");
        const i = this.Te.seriesType();
        this.Sx.clear();
        const n = this.xu;
        n && t.forEach((t)=>{
            $a1a4d31e28ce1f0d$var$Qn(t) && $a1a4d31e28ce1f0d$var$Wr(0, i) && this.Sx.set(n.key(t.time), t.value);
        }), $a1a4d31e28ce1f0d$var$_(this.Te).setData(t);
    }
    kt(t, i) {
        if (!this.Te || !this.xu) throw new Error("Primitive not attached to series");
        const n = this.Te.seriesType(), s = this.xu.key(t.time);
        if ($a1a4d31e28ce1f0d$var$Jn(t) && this.Sx.delete(s), $a1a4d31e28ce1f0d$var$Qn(t) && $a1a4d31e28ce1f0d$var$Wr(0, n)) {
            const i = this.Sx.get(s);
            i && this.xx.nx({
                time: t.time,
                value: t.value,
                sign: $a1a4d31e28ce1f0d$var$Ur(t.value, i)
            }, s, this.yn.updateVisibilityDuration);
        }
        $a1a4d31e28ce1f0d$var$_(this.Te).update(t, i);
    }
    Cx() {
        this.xx._x();
    }
}
function $a1a4d31e28ce1f0d$var$Ur(t, i) {
    return t === i ? 0 : t - i > 0 ? 1 : -1;
}
class $a1a4d31e28ce1f0d$var$$r extends $a1a4d31e28ce1f0d$var$wr {
    setData(t) {
        return this.Jh.ht(t);
    }
    update(t, i) {
        return this.Jh.kt(t, i);
    }
    markers() {
        return this.Jh.XS();
    }
    setMarkers(t) {
        return this.Jh.FS(t);
    }
    clearMarkers() {
        return this.Jh.Cx();
    }
}
function $a1a4d31e28ce1f0d$export$25a504258c8e63a9(t, i = {}) {
    return new $a1a4d31e28ce1f0d$var$$r(t, new $a1a4d31e28ce1f0d$var$Hr(i));
}
const $a1a4d31e28ce1f0d$export$fa49a2a1caf269cf = {
    ...$a1a4d31e28ce1f0d$var$e,
    color: "#2196f3"
};
function $a1a4d31e28ce1f0d$export$83d89fbfd8236492() {
    return "5.2.0";
}

});
parcelRegister("1vWyb", function(module, exports) {

$parcel$export(module.exports, "size", () => (parcelRequire("cpKFH")).size);
$parcel$export(module.exports, "equalSizes", () => (parcelRequire("cpKFH")).equalSizes);
$parcel$export(module.exports, "bindCanvasElementBitmapSizeTo", () => (parcelRequire("3F0l6")).bindTo);
$parcel$export(module.exports, "tryCreateCanvasRenderingTarget2D", () => (parcelRequire("9fJzN")).tryCreateCanvasRenderingTarget2D);

var $cpKFH = parcelRequire("cpKFH");

var $3F0l6 = parcelRequire("3F0l6");

var $9fJzN = parcelRequire("9fJzN");

});
parcelRegister("cpKFH", function(module, exports) {

$parcel$export(module.exports, "size", () => $4150ff0128b161d2$export$346677f925de839c);
$parcel$export(module.exports, "equalSizes", () => $4150ff0128b161d2$export$dfcfeaf16c0e44ed);
function $4150ff0128b161d2$export$346677f925de839c(_a) {
    var width = _a.width, height = _a.height;
    if (width < 0) throw new Error('Negative width is not allowed for Size');
    if (height < 0) throw new Error('Negative height is not allowed for Size');
    return {
        width: width,
        height: height
    };
}
function $4150ff0128b161d2$export$dfcfeaf16c0e44ed(first, second) {
    return first.width === second.width && first.height === second.height;
}

});

parcelRegister("3F0l6", function(module, exports) {

$parcel$export(module.exports, "bindTo", () => $02a7dfaff38a9eef$export$7c052ae73f8acff0);

var $cpKFH = parcelRequire("cpKFH");

var $imYtG = parcelRequire("imYtG");
var $02a7dfaff38a9eef$var$DevicePixelContentBoxBinding = /** @class */ function() {
    function DevicePixelContentBoxBinding(canvasElement, transformBitmapSize, options) {
        var _a;
        this._canvasElement = null;
        this._bitmapSizeChangedListeners = [];
        this._suggestedBitmapSize = null;
        this._suggestedBitmapSizeChangedListeners = [];
        // devicePixelRatio approach
        this._devicePixelRatioObservable = null;
        // ResizeObserver approach
        this._canvasElementResizeObserver = null;
        this._canvasElement = canvasElement;
        this._canvasElementClientSize = (0, $cpKFH.size)({
            width: this._canvasElement.clientWidth,
            height: this._canvasElement.clientHeight
        });
        this._transformBitmapSize = transformBitmapSize !== null && transformBitmapSize !== void 0 ? transformBitmapSize : function(size) {
            return size;
        };
        this._allowResizeObserver = (_a = options === null || options === void 0 ? void 0 : options.allowResizeObserver) !== null && _a !== void 0 ? _a : true;
        this._chooseAndInitObserver();
    // we MAY leave the constuctor without any bitmap size observation mechanics initialized
    }
    DevicePixelContentBoxBinding.prototype.dispose = function() {
        var _a, _b;
        if (this._canvasElement === null) throw new Error('Object is disposed');
        (_a = this._canvasElementResizeObserver) === null || _a === void 0 || _a.disconnect();
        this._canvasElementResizeObserver = null;
        (_b = this._devicePixelRatioObservable) === null || _b === void 0 || _b.dispose();
        this._devicePixelRatioObservable = null;
        this._suggestedBitmapSizeChangedListeners.length = 0;
        this._bitmapSizeChangedListeners.length = 0;
        this._canvasElement = null;
    };
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "canvasElement", {
        get: function() {
            if (this._canvasElement === null) throw new Error('Object is disposed');
            return this._canvasElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "canvasElementClientSize", {
        get: function() {
            return this._canvasElementClientSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "bitmapSize", {
        get: function() {
            return (0, $cpKFH.size)({
                width: this.canvasElement.width,
                height: this.canvasElement.height
            });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Use this function to change canvas element client size until binding is disposed
     * @param clientSize New client size for bound HTMLCanvasElement
     */ DevicePixelContentBoxBinding.prototype.resizeCanvasElement = function(clientSize) {
        this._canvasElementClientSize = (0, $cpKFH.size)(clientSize);
        this.canvasElement.style.width = "".concat(this._canvasElementClientSize.width, "px");
        this.canvasElement.style.height = "".concat(this._canvasElementClientSize.height, "px");
        this._invalidateBitmapSize();
    };
    DevicePixelContentBoxBinding.prototype.subscribeBitmapSizeChanged = function(listener) {
        this._bitmapSizeChangedListeners.push(listener);
    };
    DevicePixelContentBoxBinding.prototype.unsubscribeBitmapSizeChanged = function(listener) {
        this._bitmapSizeChangedListeners = this._bitmapSizeChangedListeners.filter(function(l) {
            return l !== listener;
        });
    };
    Object.defineProperty(DevicePixelContentBoxBinding.prototype, "suggestedBitmapSize", {
        get: function() {
            return this._suggestedBitmapSize;
        },
        enumerable: false,
        configurable: true
    });
    DevicePixelContentBoxBinding.prototype.subscribeSuggestedBitmapSizeChanged = function(listener) {
        this._suggestedBitmapSizeChangedListeners.push(listener);
    };
    DevicePixelContentBoxBinding.prototype.unsubscribeSuggestedBitmapSizeChanged = function(listener) {
        this._suggestedBitmapSizeChangedListeners = this._suggestedBitmapSizeChangedListeners.filter(function(l) {
            return l !== listener;
        });
    };
    DevicePixelContentBoxBinding.prototype.applySuggestedBitmapSize = function() {
        if (this._suggestedBitmapSize === null) // nothing to apply
        return;
        var oldSuggestedSize = this._suggestedBitmapSize;
        this._suggestedBitmapSize = null;
        this._resizeBitmap(oldSuggestedSize);
        this._emitSuggestedBitmapSizeChanged(oldSuggestedSize, this._suggestedBitmapSize);
    };
    DevicePixelContentBoxBinding.prototype._resizeBitmap = function(newSize) {
        var oldSize = this.bitmapSize;
        if ((0, $cpKFH.equalSizes)(oldSize, newSize)) return;
        this.canvasElement.width = newSize.width;
        this.canvasElement.height = newSize.height;
        this._emitBitmapSizeChanged(oldSize, newSize);
    };
    DevicePixelContentBoxBinding.prototype._emitBitmapSizeChanged = function(oldSize, newSize) {
        var _this = this;
        this._bitmapSizeChangedListeners.forEach(function(listener) {
            return listener.call(_this, oldSize, newSize);
        });
    };
    DevicePixelContentBoxBinding.prototype._suggestNewBitmapSize = function(newSize) {
        var oldSuggestedSize = this._suggestedBitmapSize;
        var finalNewSize = (0, $cpKFH.size)(this._transformBitmapSize(newSize, this._canvasElementClientSize));
        var newSuggestedSize = (0, $cpKFH.equalSizes)(this.bitmapSize, finalNewSize) ? null : finalNewSize;
        if (oldSuggestedSize === null && newSuggestedSize === null) return;
        if (oldSuggestedSize !== null && newSuggestedSize !== null && (0, $cpKFH.equalSizes)(oldSuggestedSize, newSuggestedSize)) return;
        this._suggestedBitmapSize = newSuggestedSize;
        this._emitSuggestedBitmapSizeChanged(oldSuggestedSize, newSuggestedSize);
    };
    DevicePixelContentBoxBinding.prototype._emitSuggestedBitmapSizeChanged = function(oldSize, newSize) {
        var _this = this;
        this._suggestedBitmapSizeChangedListeners.forEach(function(listener) {
            return listener.call(_this, oldSize, newSize);
        });
    };
    DevicePixelContentBoxBinding.prototype._chooseAndInitObserver = function() {
        var _this = this;
        if (!this._allowResizeObserver) {
            this._initDevicePixelRatioObservable();
            return;
        }
        $02a7dfaff38a9eef$var$isDevicePixelContentBoxSupported().then(function(isSupported) {
            return isSupported ? _this._initResizeObserver() : _this._initDevicePixelRatioObservable();
        });
    };
    // devicePixelRatio approach
    DevicePixelContentBoxBinding.prototype._initDevicePixelRatioObservable = function() {
        var _this = this;
        if (this._canvasElement === null) // it looks like we are already dead
        return;
        var win = $02a7dfaff38a9eef$var$canvasElementWindow(this._canvasElement);
        if (win === null) throw new Error('No window is associated with the canvas');
        this._devicePixelRatioObservable = (0, $imYtG.createObservable)(win);
        this._devicePixelRatioObservable.subscribe(function() {
            return _this._invalidateBitmapSize();
        });
        this._invalidateBitmapSize();
    };
    DevicePixelContentBoxBinding.prototype._invalidateBitmapSize = function() {
        var _a, _b;
        if (this._canvasElement === null) // it looks like we are already dead
        return;
        var win = $02a7dfaff38a9eef$var$canvasElementWindow(this._canvasElement);
        if (win === null) return;
        var ratio = (_b = (_a = this._devicePixelRatioObservable) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : win.devicePixelRatio;
        var canvasRects = this._canvasElement.getClientRects();
        var newSize = // eslint-disable-next-line no-negated-condition
        canvasRects[0] !== undefined ? $02a7dfaff38a9eef$var$predictedBitmapSize(canvasRects[0], ratio) : (0, $cpKFH.size)({
            width: this._canvasElementClientSize.width * ratio,
            height: this._canvasElementClientSize.height * ratio
        });
        this._suggestNewBitmapSize(newSize);
    };
    // ResizeObserver approach
    DevicePixelContentBoxBinding.prototype._initResizeObserver = function() {
        var _this = this;
        if (this._canvasElement === null) // it looks like we are already dead
        return;
        this._canvasElementResizeObserver = new ResizeObserver(function(entries) {
            var entry = entries.find(function(entry) {
                return entry.target === _this._canvasElement;
            });
            if (!entry || !entry.devicePixelContentBoxSize || !entry.devicePixelContentBoxSize[0]) return;
            var entrySize = entry.devicePixelContentBoxSize[0];
            var newSize = (0, $cpKFH.size)({
                width: entrySize.inlineSize,
                height: entrySize.blockSize
            });
            _this._suggestNewBitmapSize(newSize);
        });
        this._canvasElementResizeObserver.observe(this._canvasElement, {
            box: 'device-pixel-content-box'
        });
    };
    return DevicePixelContentBoxBinding;
}();
function $02a7dfaff38a9eef$export$7c052ae73f8acff0(canvasElement, target) {
    if (target.type === 'device-pixel-content-box') return new $02a7dfaff38a9eef$var$DevicePixelContentBoxBinding(canvasElement, target.transform, target.options);
    throw new Error('Unsupported binding target');
}
function $02a7dfaff38a9eef$var$canvasElementWindow(canvasElement) {
    // According to DOM Level 2 Core specification, ownerDocument should never be null for HTMLCanvasElement
    // see https://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#node-ownerDoc
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return canvasElement.ownerDocument.defaultView;
}
function $02a7dfaff38a9eef$var$isDevicePixelContentBoxSupported() {
    return new Promise(function(resolve) {
        var ro = new ResizeObserver(function(entries) {
            resolve(entries.every(function(entry) {
                return 'devicePixelContentBoxSize' in entry;
            }));
            ro.disconnect();
        });
        ro.observe(document.body, {
            box: 'device-pixel-content-box'
        });
    }).catch(function() {
        return false;
    });
}
function $02a7dfaff38a9eef$var$predictedBitmapSize(canvasRect, ratio) {
    return (0, $cpKFH.size)({
        width: Math.round(canvasRect.left * ratio + canvasRect.width * ratio) - Math.round(canvasRect.left * ratio),
        height: Math.round(canvasRect.top * ratio + canvasRect.height * ratio) - Math.round(canvasRect.top * ratio)
    });
}

});
parcelRegister("imYtG", function(module, exports) {

$parcel$export(module.exports, "createObservable", () => $4efde66edb34976e$export$5e7f1682f65b2ce4);
var $4efde66edb34976e$var$Observable = /** @class */ function() {
    function Observable(win) {
        var _this = this;
        this._resolutionListener = function() {
            return _this._onResolutionChanged();
        };
        this._resolutionMediaQueryList = null;
        this._observers = [];
        this._window = win;
        this._installResolutionListener();
    }
    Observable.prototype.dispose = function() {
        this._uninstallResolutionListener();
        this._window = null;
    };
    Object.defineProperty(Observable.prototype, "value", {
        get: function() {
            return this._window.devicePixelRatio;
        },
        enumerable: false,
        configurable: true
    });
    Observable.prototype.subscribe = function(next) {
        var _this = this;
        var observer = {
            next: next
        };
        this._observers.push(observer);
        return {
            unsubscribe: function() {
                _this._observers = _this._observers.filter(function(o) {
                    return o !== observer;
                });
            }
        };
    };
    Observable.prototype._installResolutionListener = function() {
        if (this._resolutionMediaQueryList !== null) throw new Error('Resolution listener is already installed');
        var dppx = this._window.devicePixelRatio;
        this._resolutionMediaQueryList = this._window.matchMedia("all and (resolution: ".concat(dppx, "dppx)"));
        // IE and some versions of Edge do not support addEventListener/removeEventListener, and we are going to use the deprecated addListener/removeListener
        this._resolutionMediaQueryList.addListener(this._resolutionListener);
    };
    Observable.prototype._uninstallResolutionListener = function() {
        if (this._resolutionMediaQueryList !== null) {
            // IE and some versions of Edge do not support addEventListener/removeEventListener, and we are going to use the deprecated addListener/removeListener
            this._resolutionMediaQueryList.removeListener(this._resolutionListener);
            this._resolutionMediaQueryList = null;
        }
    };
    Observable.prototype._reinstallResolutionListener = function() {
        this._uninstallResolutionListener();
        this._installResolutionListener();
    };
    Observable.prototype._onResolutionChanged = function() {
        var _this = this;
        this._observers.forEach(function(observer) {
            return observer.next(_this._window.devicePixelRatio);
        });
        this._reinstallResolutionListener();
    };
    return Observable;
}();
function $4efde66edb34976e$export$5e7f1682f65b2ce4(win) {
    return new $4efde66edb34976e$var$Observable(win);
}

});


parcelRegister("9fJzN", function(module, exports) {

$parcel$export(module.exports, "tryCreateCanvasRenderingTarget2D", () => $d9fd08faf8e542f8$export$7130a2243f9306b6);
/**
 * @experimental
 */ var $d9fd08faf8e542f8$export$d9009780fa8cf0a4 = /** @class */ function() {
    function CanvasRenderingTarget2D(context, mediaSize, bitmapSize) {
        if (mediaSize.width === 0 || mediaSize.height === 0) throw new TypeError('Rendering target could only be created on a media with positive width and height');
        this._mediaSize = mediaSize;
        // !Number.isInteger(bitmapSize.width) || !Number.isInteger(bitmapSize.height)
        if (bitmapSize.width === 0 || bitmapSize.height === 0) throw new TypeError('Rendering target could only be created using a bitmap with positive integer width and height');
        this._bitmapSize = bitmapSize;
        this._context = context;
    }
    CanvasRenderingTarget2D.prototype.useMediaCoordinateSpace = function(f) {
        try {
            this._context.save();
            // do not use resetTransform to support old versions of Edge
            this._context.setTransform(1, 0, 0, 1, 0, 0);
            this._context.scale(this._horizontalPixelRatio, this._verticalPixelRatio);
            return f({
                context: this._context,
                mediaSize: this._mediaSize
            });
        } finally{
            this._context.restore();
        }
    };
    CanvasRenderingTarget2D.prototype.useBitmapCoordinateSpace = function(f) {
        try {
            this._context.save();
            // do not use resetTransform to support old versions of Edge
            this._context.setTransform(1, 0, 0, 1, 0, 0);
            return f({
                context: this._context,
                mediaSize: this._mediaSize,
                bitmapSize: this._bitmapSize,
                horizontalPixelRatio: this._horizontalPixelRatio,
                verticalPixelRatio: this._verticalPixelRatio
            });
        } finally{
            this._context.restore();
        }
    };
    Object.defineProperty(CanvasRenderingTarget2D.prototype, "_horizontalPixelRatio", {
        get: function() {
            return this._bitmapSize.width / this._mediaSize.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasRenderingTarget2D.prototype, "_verticalPixelRatio", {
        get: function() {
            return this._bitmapSize.height / this._mediaSize.height;
        },
        enumerable: false,
        configurable: true
    });
    return CanvasRenderingTarget2D;
}();
function $d9fd08faf8e542f8$export$279ad88fbb07063a(binding, contextOptions) {
    var mediaSize = binding.canvasElementClientSize;
    var bitmapSize = binding.bitmapSize;
    var context = binding.canvasElement.getContext('2d', contextOptions);
    if (context === null) throw new Error('Could not get 2d drawing context from bound canvas element. Has the canvas already been set to a different context mode?');
    return new $d9fd08faf8e542f8$export$d9009780fa8cf0a4(context, mediaSize, bitmapSize);
}
function $d9fd08faf8e542f8$export$7130a2243f9306b6(binding, contextOptions) {
    var mediaSize = binding.canvasElementClientSize;
    if (mediaSize.width === 0 || mediaSize.height === 0) return null;
    var bitmapSize = binding.bitmapSize;
    if (bitmapSize.width === 0 || bitmapSize.height === 0) return null;
    var context = binding.canvasElement.getContext('2d', contextOptions);
    if (context === null) return null;
    return new $d9fd08faf8e542f8$export$d9009780fa8cf0a4(context, mediaSize, bitmapSize);
}

});



parcelRegister("kEKEC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f09bbb993f3fef38$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $f09bbb993f3fef38$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ChevronsRight", [
    [
        "path",
        {
            d: "m6 17 5-5-5-5",
            key: "xnjwq"
        }
    ],
    [
        "path",
        {
            d: "m13 17 5-5-5-5",
            key: "17xmmf"
        }
    ]
]);

});

parcelRegister("a6l6I", function(module, exports) {

$parcel$export(module.exports, "themeColors", () => $03a00b3f2dafba8b$export$4aa0a1b480cdb1b6);
$parcel$export(module.exports, "themeTokenDefinitions", () => $03a00b3f2dafba8b$export$b92716a937ca4e2c);
$parcel$export(module.exports, "strategySeriesColors", () => $03a00b3f2dafba8b$export$c6b1cac1a36a183);
const $03a00b3f2dafba8b$export$4aa0a1b480cdb1b6 = {
    background: "#131321",
    surface: "#131321",
    surface2: "#191930",
    surface3: "#121222",
    surface4: "#0f0f27",
    surfaceHover: "#32384a",
    foreground: "#f4f4f5",
    textStrong: "#ffffff",
    muted: "#a1a1aa",
    mutedDark: "#6b7280",
    line: "#1a1f2b",
    lineSoft: "#151924",
    lineStrong: "#262c39",
    lineChartVert: "#202536",
    lineChartHorz: "#191d2a",
    linePane: "#1f2430",
    neon: "#6bdcc0",
    neonArea: "#6bdcc020",
    neonTransparent: "#6bdcc000",
    success: "#75cc97",
    successDark: "#059669",
    successMarker: "rgba(117,204,151,0.65)",
    danger: "#e98188",
    dangerDark: "#dc2626",
    dangerLight: "#e98188",
    dangerArea: "#e9818820",
    dangerTransparent: "#e9818800",
    dangerMarker: "rgba(233,129,136,0.65)",
    warning: "#e8bd58",
    warningBright: "#f0ce7e",
    warningMarker: "rgba(232,189,88,0.7)",
    info: "#7eaee6",
    infoDark: "#6297d3",
    transparent: "rgba(0,0,0,0)",
    gridSoft: "#ffffff05",
    gridStrong: "#ffffff10",
    gridScene: "#333333",
    hoverSurface: "#1a1a2e",
    hoverBorder: "#ffffff20"
};
const $03a00b3f2dafba8b$export$b92716a937ca4e2c = [
    {
        name: "Canvas",
        value: $03a00b3f2dafba8b$export$4aa0a1b480cdb1b6.background,
        variable: "--background",
        description: "The deep trading workspace background."
    },
    {
        name: "Surface",
        value: $03a00b3f2dafba8b$export$4aa0a1b480cdb1b6.surface,
        variable: "--surface",
        description: "Opaque navigation, modal, and panel surfaces."
    },
    {
        name: "Foreground",
        value: $03a00b3f2dafba8b$export$4aa0a1b480cdb1b6.foreground,
        variable: "--foreground",
        description: "Primary text and high-emphasis content."
    },
    {
        name: "Neon",
        value: $03a00b3f2dafba8b$export$4aa0a1b480cdb1b6.neon,
        variable: "--neon",
        description: "Interactive focus, selected state, and brand accent."
    },
    {
        name: "Success",
        value: $03a00b3f2dafba8b$export$4aa0a1b480cdb1b6.success,
        variable: "--success",
        description: "Connected, active, and profitable states."
    },
    {
        name: "Warning",
        value: $03a00b3f2dafba8b$export$4aa0a1b480cdb1b6.warning,
        variable: "--warning",
        description: "Attention, acting-as, and degraded states."
    },
    {
        name: "Danger",
        value: $03a00b3f2dafba8b$export$4aa0a1b480cdb1b6.danger,
        variable: "--danger",
        description: "Errors, losses, and destructive actions."
    },
    {
        name: "Info",
        value: $03a00b3f2dafba8b$export$4aa0a1b480cdb1b6.info,
        variable: "--info",
        description: "Transport and informational status."
    }
];
const $03a00b3f2dafba8b$export$c6b1cac1a36a183 = [
    "#f472b6",
    "#818cf8",
    "#34d399",
    "#fbbf24",
    "#a78bfa",
    "#60a5fa"
];

});

parcelRegister("q2qYo", function(module, exports) {

$parcel$export(module.exports, "isIntradayTimeframe", () => $350a554195db6c68$export$4ae652e5f2b09e59);
$parcel$export(module.exports, "shouldShowBacktestTradeMarkers", () => $350a554195db6c68$export$8b7e037833eaa655);
$parcel$export(module.exports, "toDayString", () => $350a554195db6c68$export$ef778d3dcf2cb3db);
$parcel$export(module.exports, "prepareChartData", () => $350a554195db6c68$export$cf1a640e9db67d4b);
const $350a554195db6c68$export$4ae652e5f2b09e59 = (timeframe)=>{
    const normalized = String(timeframe ?? '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
    if (normalized === 'minute' || normalized === 'hour') return true;
    return /^\d+\s*(?:m|min|mins|minute|minutes|h|hr|hrs|hour|hours)$/.test(normalized);
};
const $350a554195db6c68$export$8b7e037833eaa655 = (resolution, timeframe)=>resolution === 'native' && $350a554195db6c68$export$4ae652e5f2b09e59(timeframe);
const $350a554195db6c68$export$ef778d3dcf2cb3db = (value)=>{
    if (!value) return '';
    if (value.includes('T')) return value.split('T')[0];
    if (value.includes(' ')) return value.split(' ')[0];
    return value;
};
const $350a554195db6c68$export$cf1a640e9db67d4b = ({ data: data, lowerPaneData: lowerPaneData, type: type, resolution: resolution, showEquityCandles: showEquityCandles, displayMode: displayMode })=>{
    let processedData = [
        ...data
    ];
    let processedLowerPaneData = [
        ...lowerPaneData
    ];
    if (resolution === '1D') {
        const dailyMap = {};
        data.forEach((item)=>{
            const day = $350a554195db6c68$export$ef778d3dcf2cb3db(item.date);
            if (!dailyMap[day]) {
                dailyMap[day] = {
                    ...item,
                    date: day
                };
                dailyMap[day].equity_open = item.equity;
                dailyMap[day].equity_high = item.equity;
                dailyMap[day].equity_low = item.equity;
                dailyMap[day].equity_close = item.equity;
                if (type === 'symbol') {
                    dailyMap[day].high = item.high;
                    dailyMap[day].low = item.low;
                    dailyMap[day].open = item.open;
                    dailyMap[day].close = item.close;
                    dailyMap[day].ma30 = item.ma30 ?? null;
                    dailyMap[day].ma200 = item.ma200 ?? null;
                }
            } else {
                const aggregate = dailyMap[day];
                aggregate.equity = item.equity;
                aggregate.equity_high = Math.max(aggregate.equity_high !== undefined ? aggregate.equity_high : aggregate.equity, item.equity);
                aggregate.equity_low = Math.min(aggregate.equity_low !== undefined ? aggregate.equity_low : aggregate.equity, item.equity);
                aggregate.equity_close = item.equity;
                if (type === 'equity') Object.keys(item).forEach((key)=>{
                    if (key.startsWith('equity_')) aggregate[key] = item[key];
                });
                else if (type === 'symbol') {
                    aggregate.high = Math.max(aggregate.high, item.high);
                    aggregate.low = Math.min(aggregate.low, item.low);
                    aggregate.close = item.close;
                    if (item.ma30 != null) aggregate.ma30 = item.ma30;
                    if (item.ma200 != null) aggregate.ma200 = item.ma200;
                }
            }
        });
        processedData = Object.values(dailyMap).sort((left, right)=>left.date.localeCompare(right.date));
        if (type === 'symbol') processedData = processedData.map((point, index, points)=>{
            const closes = points.slice(0, index + 1).map((item)=>Number(item.close)).filter(Number.isFinite);
            const average = (period)=>closes.length < period ? null : closes.slice(-period).reduce((sum, value)=>sum + value, 0) / period;
            return {
                ...point,
                ma30: average(30),
                ma200: average(200)
            };
        });
        if (lowerPaneData.length > 0) {
            const dailyLowerMap = {};
            lowerPaneData.forEach((item)=>{
                const day = $350a554195db6c68$export$ef778d3dcf2cb3db(item.date);
                dailyLowerMap[day] = {
                    ...item,
                    date: day
                };
            });
            processedLowerPaneData = Object.values(dailyLowerMap).sort((left, right)=>left.date.localeCompare(right.date));
        }
    }
    if (showEquityCandles) processedData = processedData.map((point)=>({
            ...point,
            open: point.equity_open !== undefined ? point.equity_open : point.equity,
            high: point.equity_high !== undefined ? point.equity_high : point.equity,
            low: point.equity_low !== undefined ? point.equity_low : point.equity,
            close: point.equity_close !== undefined ? point.equity_close : point.equity
        }));
    if (type === 'equity' && displayMode === 'percent' && processedData.length > 0) {
        const startEquity = processedData[0].equity || 1;
        const strategyStarts = {};
        processedData.forEach((point)=>{
            Object.keys(point).forEach((key)=>{
                if (key.startsWith('equity_') && key !== 'equity_curve') {
                    if (!strategyStarts[key] && point[key] && point[key] !== 0) strategyStarts[key] = point[key];
                }
            });
        });
        processedData = processedData.map((point)=>{
            const normalized = {
                ...point
            };
            normalized.equity = (point.equity / startEquity - 1) * 100;
            Object.keys(point).forEach((key)=>{
                if (key.startsWith('equity_') && key !== 'equity_curve') {
                    const start = strategyStarts[key] || 1;
                    normalized[key] = (point[key] / start - 1) * 100;
                }
            });
            return normalized;
        });
    }
    return {
        data: processedData,
        lowerPaneData: processedLowerPaneData
    };
};

});

parcelRegister("1MJQA", function(module, exports) {

$parcel$export(module.exports, "buildThemedChartOptions", () => $47df9c888697e15a$export$fc8bedd5586bdcbb);

var $2bl5m = parcelRequire("2bl5m");

var $a6l6I = parcelRequire("a6l6I");
const $47df9c888697e15a$export$fc8bedd5586bdcbb = ({ width: width, height: height, timeVisible: timeVisible = true, rightOffset: rightOffset, rightOffsetPixels: rightOffsetPixels, shiftVisibleRangeOnNewBar: shiftVisibleRangeOnNewBar, includePaneSeparators: includePaneSeparators = false })=>({
        layout: {
            background: {
                type: (0, $2bl5m.ColorType).Solid,
                color: (0, $a6l6I.themeColors).surface3
            },
            textColor: (0, $a6l6I.themeColors).muted,
            ...includePaneSeparators ? {
                panes: {
                    separatorColor: (0, $a6l6I.themeColors).linePane,
                    separatorHoverColor: (0, $a6l6I.themeColors).surfaceHover
                }
            } : {}
        },
        grid: {
            vertLines: {
                color: (0, $a6l6I.themeColors).lineChartVert
            },
            horzLines: {
                color: (0, $a6l6I.themeColors).lineChartHorz
            }
        },
        width: width,
        height: height,
        rightPriceScale: {
            borderColor: (0, $a6l6I.themeColors).lineStrong
        },
        timeScale: {
            timeVisible: timeVisible,
            secondsVisible: false,
            borderColor: (0, $a6l6I.themeColors).lineStrong,
            ...rightOffset === undefined ? {} : {
                rightOffset: rightOffset
            },
            ...rightOffsetPixels === undefined ? {} : {
                rightOffsetPixels: rightOffsetPixels
            },
            ...shiftVisibleRangeOnNewBar === undefined ? {} : {
                shiftVisibleRangeOnNewBar: shiftVisibleRangeOnNewBar
            }
        },
        crosshair: {
            vertLine: {
                color: (0, $a6l6I.themeColors).mutedDark,
                width: 1,
                style: 3
            },
            horzLine: {
                color: (0, $a6l6I.themeColors).mutedDark,
                width: 1,
                style: 3
            }
        }
    });

});


parcelRegister("d7aJR", function(module, exports) {

$parcel$export(module.exports, "securityTypeOptions", () => $c7a9592a436f9945$export$bcbfc4ede93d1d11);
$parcel$export(module.exports, "getPositionDisplaySymbol", () => $c7a9592a436f9945$export$622bfa79801e4cb8);
$parcel$export(module.exports, "getPositionStrategies", () => $c7a9592a436f9945$export$54a7d64bb352b58b);
$parcel$export(module.exports, "getPositionDisplayStrategies", () => $c7a9592a436f9945$export$cbd42a5f90889aa7);
$parcel$export(module.exports, "getNQMMPortfolioPositions", () => $c7a9592a436f9945$export$ce9c686c07132513);
$parcel$export(module.exports, "getPositionMetadataKey", () => $c7a9592a436f9945$export$b30029e0af7bcf4e);
$parcel$export(module.exports, "getPositionRowKey", () => $c7a9592a436f9945$export$9c28eaf9f60ab534);
$parcel$export(module.exports, "getSecurityType", () => $c7a9592a436f9945$export$8cbcd8185451f411);
$parcel$export(module.exports, "formatPlainNumber", () => $c7a9592a436f9945$export$446726de196e5af1);
$parcel$export(module.exports, "getStrategyTagColor", () => $c7a9592a436f9945$export$a7eb173f79c3c8a1);
$parcel$export(module.exports, "getPositionQuoteIdentifiers", () => $c7a9592a436f9945$export$800b9dc39dc23b9d);
$parcel$export(module.exports, "addLiveQuoteToPosition", () => $c7a9592a436f9945$export$8015fdbe4ffe9420);
$parcel$export(module.exports, "getPositionStrategyOptions", () => $c7a9592a436f9945$export$29debdfaf727af90);
$parcel$export(module.exports, "getPositionStrategyNameOptions", () => $c7a9592a436f9945$export$cb9132a73d9c734);
$parcel$export(module.exports, "filterPositions", () => $c7a9592a436f9945$export$8b7d5776eaeacaab);

var $77e7m = parcelRequire("77e7m");
const $c7a9592a436f9945$export$bcbfc4ede93d1d11 = [
    {
        value: 'ALL',
        label: 'All assets'
    },
    {
        value: 'STK',
        label: 'Stocks'
    },
    {
        value: 'CFD',
        label: 'CFDs'
    },
    {
        value: 'FUT',
        label: 'Futures'
    },
    {
        value: 'OPT',
        label: 'Options'
    }
];
const $c7a9592a436f9945$export$622bfa79801e4cb8 = (position)=>{
    if (position.display_symbol) return position.display_symbol;
    if (position.local_symbol) return position.local_symbol;
    if (position.secType === 'FUT' && position.last_trade_date_or_contract_month) return `${position.symbol} ${position.last_trade_date_or_contract_month}`;
    return position.symbol;
};
const $c7a9592a436f9945$export$54a7d64bb352b58b = (position)=>{
    if (position.strategies?.length) return position.strategies;
    if (position.strategy) return position.strategy.split(' + ').filter(Boolean);
    return [
        'UNASSIGNED'
    ];
};
const $c7a9592a436f9945$export$cbd42a5f90889aa7 = (position)=>{
    const displayName = position.custom_strategy_name?.trim();
    return displayName ? [
        displayName
    ] : $c7a9592a436f9945$export$54a7d64bb352b58b(position);
};
const $c7a9592a436f9945$export$ce9c686c07132513 = (positions)=>{
    const result = {};
    for (const position of positions){
        const symbol = position.symbol?.trim().toUpperCase();
        const quantity = Number(position.quantity);
        if (!symbol || !Number.isFinite(quantity) || quantity === 0 || String(position.secType || 'STK').toUpperCase() !== 'STK' || !$c7a9592a436f9945$export$cbd42a5f90889aa7(position).some((name)=>name.trim().toUpperCase() === 'NQMM')) continue;
        result[symbol] = (result[symbol] || 0) + quantity;
    }
    return result;
};
const $c7a9592a436f9945$export$b30029e0af7bcf4e = (position)=>{
    if (position.position_key) return position.position_key;
    if (position.contract_key) return position.contract_key;
    if (Number(position.con_id) > 0) return `conid:${Number(position.con_id)}`;
    return `contract:${[
        position.secType,
        position.symbol,
        position.local_symbol,
        position.last_trade_date_or_contract_month,
        position.exchange,
        position.currency,
        position.trading_class,
        position.multiplier
    ].map((value)=>String(value || '').toUpperCase()).join('|')}`;
};
const $c7a9592a436f9945$export$9c28eaf9f60ab534 = (position)=>$c7a9592a436f9945$export$b30029e0af7bcf4e(position);
const $c7a9592a436f9945$export$8cbcd8185451f411 = (item)=>String(item.secType || 'STK').toUpperCase();
const $c7a9592a436f9945$export$446726de196e5af1 = (value)=>{
    if (value === undefined || value === null || !Number.isFinite(Number(value))) return '-';
    return Number(value).toLocaleString(undefined, {
        maximumFractionDigits: 2
    });
};
const $c7a9592a436f9945$export$a7eb173f79c3c8a1 = (tag)=>tag.color && /^#[0-9A-F]{6}$/i.test(tag.color) ? tag.color : '#14B8A6';
const $c7a9592a436f9945$export$800b9dc39dc23b9d = (positions)=>positions.map((position)=>(0, $77e7m.quoteSubscriptionIdentifier)(position.symbol, {
            sec_type: position.secType,
            local_symbol: position.local_symbol
        }));
const $c7a9592a436f9945$export$8015fdbe4ffe9420 = (position, quote, connectionStatus, positionsStale)=>{
    if (quote) {
        const presentation = (0, $77e7m.getPricePresentation)({
            quote: quote,
            connectionStatus: connectionStatus,
            hasPrice: Number.isFinite(Number(quote.price)),
            streamed: true
        });
        return {
            ...position,
            current_price: quote.price,
            price_source: 'MARKET_DATA_HUB',
            quote_stale: presentation.stale,
            quote_status: presentation.status
        };
    }
    return positionsStale ? {
        ...position,
        quote_stale: true
    } : position;
};
const $c7a9592a436f9945$export$29debdfaf727af90 = (positions)=>Array.from(new Set(positions.flatMap((position)=>$c7a9592a436f9945$export$cbd42a5f90889aa7(position)))).sort();
const $c7a9592a436f9945$export$cb9132a73d9c734 = (positions)=>Array.from(new Set([
        // Keep core strategy labels available for manual correction even when the
        // current open positions have not yet been attributed to that strategy.
        'ON',
        'ORB',
        'DT',
        'NQMM',
        'MORB',
        ...positions.flatMap((position)=>[
                ...$c7a9592a436f9945$export$54a7d64bb352b58b(position),
                position.custom_strategy_name || ''
            ])
    ])).map((name)=>name.trim()).filter((name)=>name && name !== 'UNASSIGNED').sort((left, right)=>left.localeCompare(right));
const $c7a9592a436f9945$export$8b7d5776eaeacaab = (positions, strategyFilter, securityTypeFilter)=>positions.filter((position)=>{
        const matchesStrategy = strategyFilter === 'ALL' || $c7a9592a436f9945$export$cbd42a5f90889aa7(position).includes(strategyFilter);
        const matchesSecurityType = securityTypeFilter === 'ALL' || $c7a9592a436f9945$export$8cbcd8185451f411(position) === securityTypeFilter;
        return matchesStrategy && matchesSecurityType;
    });

});
parcelRegister("77e7m", function(module, exports) {

$parcel$export(module.exports, "quoteSubscriptionIdentifier", () => $dd0dfad817be40d5$export$58cfaa433673b2cf);
$parcel$export(module.exports, "getPricePresentation", () => $dd0dfad817be40d5$export$4425ea2f78ae1f58);
const $dd0dfad817be40d5$export$58cfaa433673b2cf = (symbol, quote)=>String(quote?.sec_type || '').toUpperCase() === 'FUT' ? quote?.local_symbol || symbol : symbol;
const $dd0dfad817be40d5$export$6a168eb6e934dc5c = (quote, now = Date.now(), defaultStaleAfterSeconds = 90)=>{
    if (!quote) return false;
    if (quote.stale) return true;
    const timestamp = quote.exchange_time || quote.received_at;
    const observedAt = timestamp ? Date.parse(timestamp) : Number.NaN;
    return !Number.isFinite(observedAt) || (now - observedAt) / 1000 > (quote.stale_after_seconds ?? defaultStaleAfterSeconds);
};
const $dd0dfad817be40d5$export$4425ea2f78ae1f58 = ({ quote: quote, connectionStatus: connectionStatus, hasPrice: hasPrice = quote?.price != null, streamed: streamed = false, now: now = Date.now(), defaultStaleAfterSeconds: defaultStaleAfterSeconds = 90 })=>{
    const disconnected = connectionStatus !== 'CONNECTED';
    const stale = hasPrice && (disconnected || $dd0dfad817be40d5$export$6a168eb6e934dc5c(quote, now, defaultStaleAfterSeconds));
    const normalizedStatus = String(quote?.data_status || '').toUpperCase();
    const frozen = Boolean(quote?.frozen) || normalizedStatus === 'FROZEN';
    const delayed = Boolean(quote?.delayed) || normalizedStatus === 'DELAYED';
    const status = stale ? 'STALE' : frozen ? 'FROZEN' : delayed ? 'DELAYED' : streamed ? 'LIVE' : 'MARK';
    const caution = status === 'STALE' || status === 'DELAYED' || status === 'FROZEN';
    return {
        status: status,
        stale: stale,
        // Frozen snapshots and stale values are reference-only; never use them to
        // populate an executable price or derive a trailing stop estimate.
        usableForPricing: hasPrice && status !== 'STALE' && status !== 'FROZEN',
        badgeClassName: caution ? 'border-amber-400/25 bg-amber-400/10 text-amber-300' : 'border-emerald-400/25 bg-emerald-400/10 text-emerald-300',
        priceClassName: caution ? 'text-amber-300' : 'text-emerald-400'
    };
};

});


parcelRegister("6Plhc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f88028b3cc726f6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $4f88028b3cc726f6$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ChevronDown", [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
]);

});

parcelRegister("fpYe5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b397e876e35a9277$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $b397e876e35a9277$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ChevronUp", [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
]);

});

parcelRegister("jmfXa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e17c725e7c863883$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $e17c725e7c863883$export$2e2bcd8739ae039 = (0, $b4WUK.default)("History", [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ],
    [
        "path",
        {
            d: "M12 7v5l4 2",
            key: "1fdv2h"
        }
    ]
]);

});

parcelRegister("h4JTL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6e669e1fd7e7ff8$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $c6e669e1fd7e7ff8$export$2e2bcd8739ae039 = (0, $b4WUK.default)("RotateCcw", [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ]
]);

});

parcelRegister("iPuRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $db54edda7e508228$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $db54edda7e508228$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Save", [
    [
        "path",
        {
            d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
            key: "1c8476"
        }
    ],
    [
        "path",
        {
            d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
            key: "1ydtos"
        }
    ],
    [
        "path",
        {
            d: "M7 3v4a1 1 0 0 0 1 1h7",
            key: "t51u73"
        }
    ]
]);

});

parcelRegister("gsAgU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfbb65af5bdc7218$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $bfbb65af5bdc7218$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Pause", [
    [
        "rect",
        {
            x: "14",
            y: "4",
            width: "4",
            height: "16",
            rx: "1",
            key: "zuxfzm"
        }
    ],
    [
        "rect",
        {
            x: "6",
            y: "4",
            width: "4",
            height: "16",
            rx: "1",
            key: "1okwgv"
        }
    ]
]);

});

parcelRegister("jv5sm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e325251f2797f6cf$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $e325251f2797f6cf$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ShieldCheck", [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
]);

});

parcelRegister("1rBba", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6d16e1f07599ed4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4Yp7M = parcelRequire("4Yp7M");

var $70wbS = parcelRequire("70wbS");

var $a6l6I = parcelRequire("a6l6I");

var $35Xbi = parcelRequire("35Xbi");

var $2wVnk = parcelRequire("2wVnk");

var $2RwSR = parcelRequire("2RwSR");

var $ehunE = parcelRequire("ehunE");

var $fJHlV = parcelRequire("fJHlV");

var $dghaF = parcelRequire("dghaF");

var $92f5k = parcelRequire("92f5k");

var $48P5m = parcelRequire("48P5m");
const $b6d16e1f07599ed4$var$isoDateForTime = (time)=>new Date(time * 1000).toISOString();
const $b6d16e1f07599ed4$var$isoDateForChartTime = (time)=>{
    if (typeof time === 'number') return $b6d16e1f07599ed4$var$isoDateForTime(time);
    if (typeof time === 'string') return time;
    const month = String(time.month).padStart(2, '0');
    const day = String(time.day).padStart(2, '0');
    return `${time.year}-${month}-${day}`;
};
const $b6d16e1f07599ed4$var$createStrategyOverlays = (bars, timeframe, strategy, status)=>{
    const overlays = [];
    const addSegment = (from, to, value, color)=>{
        if (!Number.isFinite(value) || from >= to) return;
        overlays.push({
            color: color,
            lineWidth: 2,
            data: [
                {
                    date: $b6d16e1f07599ed4$var$isoDateForTime(from),
                    value: value
                },
                {
                    date: $b6d16e1f07599ed4$var$isoDateForTime(to),
                    value: value
                }
            ]
        });
    };
    const addLine = (data, color, lineWidth = 2)=>{
        if (!data.length) return;
        overlays.push({
            color: color,
            lineWidth: lineWidth,
            data: data.map((point)=>({
                    date: $b6d16e1f07599ed4$var$isoDateForChartTime(point.time),
                    value: point.value
                }))
        });
    };
    if (strategy === 'ORB') {
        (0, $48P5m.groupByNyDay)(bars).forEach(({ bars: dayBars })=>{
            const sessionBars = (0, $48P5m.regularSessionBars)(dayBars);
            if (sessionBars.length < 2) return;
            const openingBar = sessionBars[0];
            const { from: from, to: to } = (0, $48P5m.sessionSegmentBounds)(sessionBars, timeframe);
            addSegment(from, to, openingBar.high, (0, $a6l6I.themeColors).success);
            addSegment(from, to, openingBar.low, (0, $a6l6I.themeColors).dangerLight);
        });
        const dayGroups = (0, $48P5m.groupByNyDay)(bars);
        const latestDay = dayGroups[dayGroups.length - 1];
        const latestSessionBars = latestDay ? (0, $48P5m.regularSessionBars)(latestDay.bars) : [];
        if (latestSessionBars.length > 1 && (0, $35Xbi.hasFreshLevels)(status) && (0, $35Xbi.isCurrentNySessionDate)(status) && (0, $35Xbi.isValidPriceLevel)(status?.resistance) && (0, $35Xbi.isValidPriceLevel)(status?.support)) {
            const { from: from, to: to } = (0, $48P5m.sessionSegmentBounds)(latestSessionBars, timeframe);
            addSegment(from, to, Number(status.resistance), (0, $a6l6I.themeColors).neon);
            addSegment(from, to, Number(status.support), (0, $a6l6I.themeColors).warningBright);
        }
    }
    if (strategy === 'DT') {
        const dayGroups = (0, $48P5m.groupByNyDay)(bars);
        const dailyTrueRanges = [];
        let previousClose = null;
        const thresholdFactor = Number(status?.threshold_factor || 0.5);
        dayGroups.forEach(({ bars: dayBars }, dayIndex)=>{
            const sessionBars = (0, $48P5m.regularSessionBars)(dayBars);
            if (sessionBars.length < 2) return;
            const high = Math.max(...sessionBars.map((bar)=>bar.high));
            const low = Math.min(...sessionBars.map((bar)=>bar.low));
            const close = sessionBars[sessionBars.length - 1].close;
            const trueRange = previousClose == null ? high - low : Math.max(high - low, Math.abs(high - previousClose), Math.abs(low - previousClose));
            const historicalAtr = (0, $48P5m.average)(dailyTrueRanges.slice(-14));
            dailyTrueRanges.push(trueRange);
            previousClose = close;
            const { from: from, to: to } = (0, $48P5m.sessionSegmentBounds)(sessionBars, timeframe);
            const isLatestDay = dayIndex === dayGroups.length - 1;
            const hasFreshStatusLevels = isLatestDay && (0, $35Xbi.hasFreshLevels)(status) && (0, $35Xbi.isCurrentNySessionDate)(status);
            const dailyOpen = hasFreshStatusLevels && (0, $35Xbi.isValidPriceLevel)(status?.daily_open) ? Number(status.daily_open) : sessionBars[0].open;
            const threshold = hasFreshStatusLevels && Number.isFinite(Number(status?.intraday_threshold)) && Number(status?.intraday_threshold) > 0 ? Number(status.intraday_threshold) : historicalAtr == null ? null : historicalAtr * thresholdFactor;
            addSegment(from, to, dailyOpen, (0, $a6l6I.themeColors).info);
            if (threshold != null && Number.isFinite(threshold)) {
                addSegment(from, to, dailyOpen + threshold, (0, $a6l6I.themeColors).success);
                addSegment(from, to, dailyOpen - threshold, (0, $a6l6I.themeColors).dangerLight);
            }
        });
    }
    if (strategy === 'ON') {
        addLine((0, $48P5m.smaData)(bars, 30), (0, $a6l6I.themeColors).success, 1);
        addLine((0, $48P5m.smaData)(bars, 200), (0, $a6l6I.themeColors).warningBright, 1);
    }
    if (strategy === 'MORB') {
        if (timeframe === '1d') {
            addLine((0, $48P5m.smaData)(bars, Number(status?.entry_sma_period || 50), timeframe), (0, $a6l6I.themeColors).warning, 1);
            addLine((0, $48P5m.smaData)(bars, Number(status?.sma_period || 10), timeframe), (0, $a6l6I.themeColors).warningBright, 1);
        } else {
            const entryMinutes = Number(status?.entry_minutes || 10);
            const atrMultiple = Number(status?.atr_multiple || 0.5);
            const direction = String(status?.direction || 'LONG').toUpperCase();
            const rangeBars = Math.max(1, Math.ceil(entryMinutes / Math.max(1, (0, $48P5m.timeframeSeconds)(timeframe) / 60)));
            const dayGroups = (0, $48P5m.groupByNyDay)(bars);
            let previousClose = null;
            const trueRanges = [];
            dayGroups.forEach(({ bars: dayBars }, dayIndex)=>{
                const sessionBars = (0, $48P5m.regularSessionBars)(dayBars);
                if (sessionBars.length <= rangeBars) return;
                const openingBars = sessionBars.slice(0, rangeBars);
                const high = Math.max(...openingBars.map((bar)=>bar.high));
                const low = Math.min(...openingBars.map((bar)=>bar.low));
                const dayHigh = Math.max(...sessionBars.map((bar)=>bar.high));
                const dayLow = Math.min(...sessionBars.map((bar)=>bar.low));
                const dayClose = sessionBars[sessionBars.length - 1].close;
                const trueRange = previousClose == null ? dayHigh - dayLow : Math.max(dayHigh - dayLow, Math.abs(dayHigh - previousClose), Math.abs(dayLow - previousClose));
                const historicalAtr = (0, $48P5m.average)(trueRanges.slice(-14));
                trueRanges.push(trueRange);
                previousClose = dayClose;
                const configuredAtr = Number(status?.atr);
                const atr = dayIndex === dayGroups.length - 1 && Number.isFinite(configuredAtr) && configuredAtr > 0 ? configuredAtr : historicalAtr ?? trueRange;
                const { from: from, to: to } = (0, $48P5m.sessionSegmentBounds)(sessionBars, timeframe);
                addSegment(from, to, openingBars[0].open, (0, $a6l6I.themeColors).info);
                addSegment(from, to, high, (0, $a6l6I.themeColors).success);
                addSegment(from, to, low, (0, $a6l6I.themeColors).dangerLight);
                if (Number.isFinite(atr) && atr > 0) {
                    const trigger = direction === 'SHORT' ? low - atr * atrMultiple : high + atr * atrMultiple;
                    addSegment(from, to, trigger, (0, $a6l6I.themeColors).warningBright);
                }
            });
            const latestDay = dayGroups[dayGroups.length - 1];
            const latestSession = latestDay ? (0, $48P5m.regularSessionBars)(latestDay.bars) : [];
            if (latestSession.length > 1) {
                const { from: from, to: to } = (0, $48P5m.sessionSegmentBounds)(latestSession, timeframe);
                const addStatusLevel = (value, color)=>{
                    if ((0, $35Xbi.isValidPriceLevel)(value)) addSegment(from, to, Number(value), color);
                };
                addStatusLevel(status?.daily_open, (0, $a6l6I.themeColors).info);
                addStatusLevel(status?.entry_level, (0, $a6l6I.themeColors).neon);
                addStatusLevel(status?.entry_sma, (0, $a6l6I.themeColors).warning);
                addStatusLevel(status?.ten_sma, (0, $a6l6I.themeColors).warningBright);
                (Array.isArray(status?.simulated_stop_levels) ? status.simulated_stop_levels : []).forEach((value)=>addStatusLevel(value, (0, $a6l6I.themeColors).danger));
            }
        }
    }
    return overlays;
};
const $b6d16e1f07599ed4$var$StrategySymbolChart = ({ symbol: symbol, timeframe: timeframe, onTimeframeChange: onTimeframeChange, label: label, strategy: strategy, status: status, historicalSignals: historicalSignals = [] })=>{
    const { token: token } = (0, $70wbS.useAuth)();
    const [bars, setBars] = (0, $acw62.useState)([]);
    const [chartStyle, setChartStyle] = (0, $acw62.useState)('candles');
    const [showMarkers, setShowMarkers] = (0, $acw62.useState)(false);
    const [showExtendedHours, setShowExtendedHours] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (timeframe === '1d' && chartStyle !== 'candles') setChartStyle('candles');
    }, [
        timeframe,
        chartStyle
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!token) return undefined;
        const controller = new AbortController();
        const fetchHistory = async ()=>{
            setBars([]);
            setLoading(true);
            setError(null);
            try {
                const result = await (0, $2wVnk.tradingApi).getHistoricalData(symbol, timeframe, (0, $48P5m.durationForStrategy)(timeframe, strategy), 'auto', controller.signal);
                if (!result.success || !Array.isArray(result.data)) throw new Error(result.error || 'No chart data returned');
                const loadedBars = result.data.filter((0, $2RwSR.isValidHistoricalBar)).map((bar)=>({
                        time: bar.time,
                        open: bar.open,
                        high: bar.high,
                        low: bar.low,
                        close: bar.close,
                        volume: bar.volume ?? 0
                    })).sort((left, right)=>left.time - right.time);
                setBars(timeframe === '1d' ? (0, $48P5m.consolidateDailyBars)(loadedBars) : loadedBars);
            } catch (err) {
                if (!controller.signal.aborted) {
                    setBars([]);
                    setError(err instanceof Error ? err.message : 'Failed to load chart');
                }
            } finally{
                if (!controller.signal.aborted) setLoading(false);
            }
        };
        fetchHistory();
        return ()=>controller.abort();
    }, [
        symbol,
        timeframe,
        token,
        strategy
    ]);
    const displayBars = (0, $acw62.useMemo)(()=>timeframe === '1d' || showExtendedHours ? bars : (0, $48P5m.regularSessionBars)(bars), [
        bars,
        timeframe,
        showExtendedHours
    ]);
    const chartData = (0, $acw62.useMemo)(()=>displayBars.map((bar)=>({
                date: $b6d16e1f07599ed4$var$isoDateForTime(bar.time),
                open: bar.open,
                high: bar.high,
                low: bar.low,
                close: bar.close,
                volume: bar.volume
            })), [
        displayBars
    ]);
    const lineOverlays = (0, $acw62.useMemo)(()=>$b6d16e1f07599ed4$var$createStrategyOverlays(displayBars, timeframe, strategy, status), [
        displayBars,
        timeframe,
        strategy,
        status
    ]);
    const volumeData = (0, $acw62.useMemo)(()=>{
        const values = strategy === 'MORB' ? (0, $48P5m.managedOrbVolumeData)(displayBars, status, (0, $a6l6I.themeColors)) : displayBars.map((bar)=>({
                time: (0, $48P5m.chartTimeFor)(bar.time, timeframe),
                value: Number(bar.volume || 0),
                color: Number(bar.close) >= Number(bar.open) ? (0, $a6l6I.themeColors).success : (0, $a6l6I.themeColors).danger
            }));
        return timeframe === '1d' ? [] : values.map((point)=>({
                date: $b6d16e1f07599ed4$var$isoDateForChartTime(point.time),
                value: point.value,
                color: point.color
            }));
    }, [
        displayBars,
        timeframe,
        strategy,
        status
    ]);
    const customMarkers = (0, $acw62.useMemo)(()=>{
        if (strategy !== 'MORB' || !showMarkers) return [];
        const markers = timeframe === '1d' ? (0, $48P5m.dailyManagedOrbMarkers)(displayBars, status, (0, $a6l6I.themeColors), historicalSignals) : (0, $48P5m.potentialManagedOrbMarkers)(displayBars, status, timeframe, (0, $a6l6I.themeColors));
        return markers.map((marker)=>({
                ...marker,
                date: $b6d16e1f07599ed4$var$isoDateForChartTime(marker.time)
            }));
    }, [
        displayBars,
        timeframe,
        strategy,
        status,
        historicalSignals,
        showMarkers
    ]);
    const legend = (0, $fJHlV.strategyChartLegend)(strategy, timeframe, status, (0, $a6l6I.themeColors));
    const latestBars = (0, $48P5m.latestWindowBars)(timeframe);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dghaF.default), {
        className: "w-full border-t border-white/10",
        toolbar: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ehunE.default), {
            symbol: symbol,
            label: label,
            strategy: strategy,
            timeframe: timeframe,
            onTimeframeChange: onTimeframeChange,
            chartStyle: chartStyle,
            showMarkers: showMarkers,
            showExtendedHours: showExtendedHours,
            legend: legend,
            onChartStyleChange: setChartStyle,
            onToggleMarkers: ()=>setShowMarkers((current)=>!current),
            onToggleExtendedHours: ()=>setShowExtendedHours((current)=>!current)
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "relative h-[320px]",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92f5k.LightweightChart), {
                    data: chartData,
                    volumeData: volumeData,
                    lineOverlays: lineOverlays,
                    customMarkers: customMarkers,
                    type: "symbol",
                    symbolStyle: chartStyle,
                    lineColor: (0, $a6l6I.themeColors).neon,
                    resolution: timeframe === '1d' ? '1D' : 'native',
                    timeVisible: timeframe !== '1d',
                    initialVisibleBars: latestBars,
                    latestVisibleBars: latestBars,
                    showLatestControl: true,
                    hideControls: true
                }, `${symbol}:${timeframe}:${strategy}`),
                loading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "absolute inset-0 flex items-center justify-center bg-[#0e0e12]/65",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                        className: "h-5 w-5 animate-spin text-neon"
                    })
                }),
                error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "absolute inset-0 flex items-center justify-center bg-[#0e0e12]/90 px-4 text-center text-sm text-rose-300",
                    children: error
                })
            ]
        })
    });
};
var $b6d16e1f07599ed4$export$2e2bcd8739ae039 = $b6d16e1f07599ed4$var$StrategySymbolChart;

});
parcelRegister("35Xbi", function(module, exports) {

$parcel$export(module.exports, "isValidPriceLevel", () => $b7a3f1df43d159e7$export$4263979d9f95518b);
$parcel$export(module.exports, "isCurrentNySessionDate", () => $b7a3f1df43d159e7$export$6a3991af0461b924);
$parcel$export(module.exports, "isEarlyRegularSession", () => $b7a3f1df43d159e7$export$e0ff425efbf512a5);
$parcel$export(module.exports, "isRegularMarketOpen", () => $b7a3f1df43d159e7$export$22ca8658b33d8bb9);
$parcel$export(module.exports, "getAdaptiveLevelTone", () => $b7a3f1df43d159e7$export$15d699cb2e4cb05b);
$parcel$export(module.exports, "hasFreshLevels", () => $b7a3f1df43d159e7$export$53b972cfb77fd720);
const $b7a3f1df43d159e7$var$nyDateFormatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
});
const $b7a3f1df43d159e7$export$4263979d9f95518b = (value)=>{
    const numberValue = Number(value);
    return Number.isFinite(numberValue) && numberValue > 0;
};
const $b7a3f1df43d159e7$export$fe8acb51cb0a1c4b = (value)=>{
    if (!value) return null;
    if (typeof value === "string") {
        const trimmed = value.trim();
        // Date-only ISO string (e.g. "2026-09-21") represents a specific session date.
        // Avoid parsing as UTC midnight which rolls back to previous day in New York timezone.
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
    }
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return $b7a3f1df43d159e7$var$nyDateFormatter.format(date);
};
const $b7a3f1df43d159e7$var$nyTimeFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
});
const $b7a3f1df43d159e7$var$nySessionFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
});
const $b7a3f1df43d159e7$export$6a3991af0461b924 = (status, fallbackDate)=>{
    const sourceDate = status?.levels_date || status?.timestamp || fallbackDate;
    const levelDate = $b7a3f1df43d159e7$export$fe8acb51cb0a1c4b(sourceDate);
    return !!levelDate && levelDate === $b7a3f1df43d159e7$export$fe8acb51cb0a1c4b(new Date());
};
const $b7a3f1df43d159e7$export$e0ff425efbf512a5 = ()=>{
    const parts = $b7a3f1df43d159e7$var$nyTimeFormatter.formatToParts(new Date());
    const value = (type)=>Number(parts.find((part)=>part.type === type)?.value || 0);
    const minutes = value("hour") * 60 + value("minute");
    return minutes >= 570 && minutes < 600;
};
const $b7a3f1df43d159e7$export$22ca8658b33d8bb9 = (date = new Date())=>{
    const parts = $b7a3f1df43d159e7$var$nySessionFormatter.formatToParts(date);
    const value = (type)=>parts.find((part)=>part.type === type)?.value || "";
    const weekday = value("weekday");
    const minutes = Number(value("hour")) * 60 + Number(value("minute"));
    return weekday !== "Sat" && weekday !== "Sun" && minutes >= 570 && minutes < 960;
};
const $b7a3f1df43d159e7$var$clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
const $b7a3f1df43d159e7$export$15d699cb2e4cb05b = ({ price: price, lowerLevel: lowerLevel, upperLevel: upperLevel, levelsReady: levelsReady, earlySession: earlySession = false, marketOpen: marketOpen = true })=>{
    if (!marketOpen) {
        const hasFixedLevels = levelsReady && Number.isFinite(lowerLevel) && Number.isFinite(upperLevel) && upperLevel > lowerLevel;
        return {
            label: hasFixedLevels ? "Market closed \xb7 levels fixed" : "Market closed \xb7 awaiting session",
            bias: hasFixedLevels ? "neutral" : "forming",
            rowStyle: {
                backgroundColor: hasFixedLevels ? "rgba(148, 163, 184, 0.035)" : "rgba(245, 158, 11, 0.035)"
            },
            priceClass: hasFixedLevels ? "text-white/70" : "text-amber-100/60",
            lowerClass: "text-rose-300/50",
            upperClass: "text-emerald-300/50"
        };
    }
    const neutral = {
        label: levelsReady ? "Inside levels" : "Levels forming",
        bias: levelsReady ? "neutral" : "forming",
        rowStyle: {
            backgroundColor: levelsReady ? "rgba(148, 163, 184, 0.025)" : "rgba(245, 158, 11, 0.045)"
        },
        priceClass: levelsReady ? "text-white/85" : "text-amber-100/70",
        lowerClass: "text-rose-300/65",
        upperClass: "text-emerald-300/65"
    };
    if (!levelsReady || !Number.isFinite(price) || !Number.isFinite(lowerLevel) || !Number.isFinite(upperLevel) || upperLevel <= lowerLevel) return neutral;
    const span = Math.max(upperLevel - lowerLevel, Math.abs(upperLevel) * 0.001, 0.01);
    const position = (price - lowerLevel) / span;
    const muted = earlySession ? 0.62 : 1;
    const edgeAlpha = (value)=>$b7a3f1df43d159e7$var$clamp(value * muted, 0.035, earlySession ? 0.18 : 0.3);
    if (position >= 1) {
        const alpha = edgeAlpha(0.12 + (position - 1) * 0.16);
        return {
            label: "Above long level",
            bias: "long",
            rowStyle: {
                backgroundColor: `rgba(16, 185, 129, ${alpha})`,
                boxShadow: `inset 3px 0 rgba(52, 211, 153, ${$b7a3f1df43d159e7$var$clamp(alpha + 0.14, 0.2, 0.48)})`
            },
            priceClass: "text-emerald-200",
            lowerClass: "text-rose-300/55",
            upperClass: "text-emerald-300 font-bold"
        };
    }
    if (position <= 0) {
        const alpha = edgeAlpha(0.12 + Math.abs(position) * 0.16);
        return {
            label: "Below short level",
            bias: "short",
            rowStyle: {
                backgroundColor: `rgba(244, 63, 94, ${alpha})`,
                boxShadow: `inset 3px 0 rgba(251, 113, 133, ${$b7a3f1df43d159e7$var$clamp(alpha + 0.14, 0.2, 0.48)})`
            },
            priceClass: "text-rose-200",
            lowerClass: "text-rose-300 font-bold",
            upperClass: "text-emerald-300/55"
        };
    }
    if (position >= 0.72) {
        const alpha = edgeAlpha(0.04 + (position - 0.72) / 0.28 * 0.07);
        return {
            label: "Near long level",
            bias: "long",
            rowStyle: {
                backgroundColor: `rgba(16, 185, 129, ${alpha})`
            },
            priceClass: "text-emerald-200/90",
            lowerClass: "text-rose-300/55",
            upperClass: "text-emerald-300 font-semibold"
        };
    }
    if (position <= 0.28) {
        const alpha = edgeAlpha(0.04 + (0.28 - position) / 0.28 * 0.07);
        return {
            label: "Near short level",
            bias: "short",
            rowStyle: {
                backgroundColor: `rgba(244, 63, 94, ${alpha})`
            },
            priceClass: "text-rose-200/90",
            lowerClass: "text-rose-300 font-semibold",
            upperClass: "text-emerald-300/55"
        };
    }
    return neutral;
};
const $b7a3f1df43d159e7$export$53b972cfb77fd720 = (status, fallbackDate)=>{
    const sourceDate = status?.levels_date || status?.timestamp || fallbackDate;
    const levelDate = $b7a3f1df43d159e7$export$fe8acb51cb0a1c4b(sourceDate);
    return !!levelDate;
};

});

parcelRegister("ehunE", function(module, exports) {

$parcel$export(module.exports, "default", () => $df89c7e8cafa5b37$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ki04U = parcelRequire("ki04U");
var $8gCXb = parcelRequire("8gCXb");

var $ip1r2 = parcelRequire("ip1r2");

var $iiQft = parcelRequire("iiQft");

var $kvv04 = parcelRequire("kvv04");
const $df89c7e8cafa5b37$var$StrategySymbolChartControls = ({ symbol: symbol, label: label, strategy: strategy, timeframe: timeframe, onTimeframeChange: onTimeframeChange, chartStyle: chartStyle, showMarkers: showMarkers, showExtendedHours: showExtendedHours, legend: legend, onChartStyleChange: onChartStyleChange, onToggleMarkers: onToggleMarkers, onToggleExtendedHours: onToggleExtendedHours })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iiQft.ChartToolbar), {
        leading: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex shrink-0 items-baseline gap-1.5",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-xs font-bold text-white",
                    children: symbol
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-[9px] uppercase tracking-wider text-muted",
                    children: label
                })
            ]
        }),
        legend: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: legend.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "inline-flex shrink-0 items-center gap-1 text-[9px] uppercase tracking-wide text-muted",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "w-4 h-0.5 rounded-full",
                            style: {
                                backgroundColor: item.color
                            }
                        }),
                        item.label
                    ]
                }, item.label))
        }),
        chartStyle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iiQft.ChartStyleToggle), {
            value: chartStyle,
            onChange: onChartStyleChange,
            showLine: timeframe !== '1d'
        }),
        actions: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                strategy === 'MORB' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                    size: "compact",
                    iconOnly: true,
                    onClick: onToggleMarkers,
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8gCXb.default), {
                        className: "h-3.5 w-3.5"
                    }),
                    selected: showMarkers,
                    label: timeframe === '1d' ? showMarkers ? 'Hide buy/close signals' : 'Show buy/close signals' : showMarkers ? 'Hide potential signal markers' : 'Show potential signal markers',
                    title: timeframe === '1d' ? showMarkers ? 'Hide buy/close signals' : 'Show buy/close signals' : showMarkers ? 'Hide potential signal markers' : 'Show potential signal markers'
                }),
                timeframe !== '1d' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                    size: "compact",
                    onClick: onToggleExtendedHours,
                    selected: showExtendedHours,
                    label: showExtendedHours ? 'Show regular market hours only' : 'Show extended hours',
                    title: showExtendedHours ? 'Show regular market hours only' : 'Show extended hours',
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ki04U.default), {
                        className: "h-3.5 w-3.5"
                    }),
                    children: showExtendedHours ? 'EXT' : 'RTH'
                })
            ]
        }),
        trailing: onTimeframeChange ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kvv04.ThemeToggleGroup), {
            "aria-label": "Chart timeframe",
            className: "shrink-0 gap-px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                    size: "compact",
                    segment: "first",
                    label: "5 minute bars",
                    selected: timeframe === '5min',
                    onClick: ()=>onTimeframeChange('5min'),
                    children: "5m"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                    size: "compact",
                    segment: "last",
                    label: "Daily candles",
                    selected: timeframe === '1d',
                    onClick: ()=>onTimeframeChange('1d'),
                    children: "1D"
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iiQft.ChartToolbarValue), {
            children: timeframe
        })
    });
var $df89c7e8cafa5b37$export$2e2bcd8739ae039 = $df89c7e8cafa5b37$var$StrategySymbolChartControls;

});
parcelRegister("ki04U", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec558c98a508af21$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $ec558c98a508af21$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Clock3", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16.5 12",
            key: "1aq6pp"
        }
    ]
]);

});

parcelRegister("8gCXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $604e08b57548a73d$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $604e08b57548a73d$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Flag", [
    [
        "path",
        {
            d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z",
            key: "i9b6wo"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "4",
            y1: "22",
            y2: "15",
            key: "1cm3nv"
        }
    ]
]);

});


parcelRegister("fJHlV", function(module, exports) {

$parcel$export(module.exports, "strategyChartLegend", () => $1344a866762b06a5$export$405d6434ed617e02);
const $1344a866762b06a5$export$405d6434ed617e02 = (strategy, timeframe, status, colors)=>{
    if (strategy === 'MORB' && timeframe === '1d') return [
        {
            label: `${status?.entry_sma_period || 50} SMA`,
            color: colors.warning
        },
        {
            label: `${status?.sma_period || 10} SMA`,
            color: colors.warningBright
        },
        {
            label: 'Buy / close signals',
            color: colors.neon
        }
    ];
    if (strategy === 'MORB') return [
        {
            label: 'Market open',
            color: colors.info
        },
        {
            label: 'ORB high / low',
            color: colors.success
        },
        {
            label: 'ATR entry trigger',
            color: colors.warningBright
        }
    ];
    if (strategy === 'ORB') return [
        {
            label: 'Open range',
            color: colors.success
        },
        {
            label: 'Live support/resistance',
            color: colors.neon
        }
    ];
    if (strategy === 'DT') return [
        {
            label: 'Daily open',
            color: colors.info
        },
        {
            label: 'ATR thresholds',
            color: colors.success
        }
    ];
    return [
        {
            label: 'SMA 30',
            color: colors.success
        },
        {
            label: 'SMA 200',
            color: colors.warningBright
        }
    ];
};

});

parcelRegister("48P5m", function(module, exports) {

$parcel$export(module.exports, "durationForStrategy", () => $bee49d807911cd75$export$c5eec21590f59459);
$parcel$export(module.exports, "chartTimeFor", () => $bee49d807911cd75$export$91c701c0111963f6);
$parcel$export(module.exports, "regularSessionBars", () => $bee49d807911cd75$export$bddd759d272a4ed9);
$parcel$export(module.exports, "timeframeSeconds", () => $bee49d807911cd75$export$7b93452404e28154);
$parcel$export(module.exports, "sessionSegmentBounds", () => $bee49d807911cd75$export$5d0da53669563cd2);
$parcel$export(module.exports, "groupByNyDay", () => $bee49d807911cd75$export$700871a7cae9b44);
$parcel$export(module.exports, "consolidateDailyBars", () => $bee49d807911cd75$export$c36a2603d98abe74);
$parcel$export(module.exports, "smaData", () => $bee49d807911cd75$export$b34148a8bb227faa);
$parcel$export(module.exports, "average", () => $bee49d807911cd75$export$cc6710ee5f037d57);
$parcel$export(module.exports, "latestWindowBars", () => $bee49d807911cd75$export$f231c38f5dd1ef1b);
$parcel$export(module.exports, "potentialManagedOrbMarkers", () => $bee49d807911cd75$export$29e05362fa428c71);
$parcel$export(module.exports, "managedOrbVolumeData", () => $bee49d807911cd75$export$e05b4e467f178bf2);
$parcel$export(module.exports, "dailyManagedOrbMarkers", () => $bee49d807911cd75$export$7be82669d46b07a3);
const $bee49d807911cd75$export$ad2adee0f25741f9 = (timeframe)=>{
    if (timeframe === '5min') return '2 D';
    if (timeframe === '30min') return '1 M';
    return '1 Y';
};
const $bee49d807911cd75$export$c5eec21590f59459 = (timeframe, strategy)=>strategy === 'MORB' && timeframe === '5min' ? '1 M' : $bee49d807911cd75$export$ad2adee0f25741f9(timeframe);
const $bee49d807911cd75$var$nyFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
});
const $bee49d807911cd75$var$getNyParts = (timestampSeconds)=>{
    const parts = $bee49d807911cd75$var$nyFormatter.formatToParts(new Date(timestampSeconds * 1000));
    const value = (type)=>parts.find((part)=>part.type === type)?.value || '00';
    const hour = Number(value('hour'));
    const minute = Number(value('minute'));
    return {
        key: `${value('year')}-${value('month')}-${value('day')}`,
        minutes: hour * 60 + minute
    };
};
const $bee49d807911cd75$var$getCalendarDay = (timestampSeconds)=>new Date(timestampSeconds * 1000).toISOString().slice(0, 10);
const $bee49d807911cd75$export$91c701c0111963f6 = (timestampSeconds, timeframe)=>{
    if (timeframe !== '1d') return timestampSeconds;
    const key = $bee49d807911cd75$var$getCalendarDay(timestampSeconds);
    const [year, month, day] = key.split('-').map(Number);
    return {
        year: year,
        month: month,
        day: day
    };
};
const $bee49d807911cd75$export$bddd759d272a4ed9 = (bars)=>bars.filter((bar)=>{
        const { minutes: minutes } = $bee49d807911cd75$var$getNyParts(bar.time);
        return minutes >= 570 && minutes <= 960;
    });
const $bee49d807911cd75$export$7b93452404e28154 = (timeframe)=>{
    if (timeframe === '5min') return 300;
    if (timeframe === '30min') return 1800;
    return 86400;
};
const $bee49d807911cd75$export$5d0da53669563cd2 = (sessionBars, timeframe)=>{
    const firstBar = sessionBars[0];
    const lastBar = sessionBars[sessionBars.length - 1];
    const interval = $bee49d807911cd75$export$7b93452404e28154(timeframe);
    const firstMinutes = $bee49d807911cd75$var$getNyParts(firstBar.time).minutes;
    const timestampsLookLikeBarClose = timeframe !== '1d' && firstMinutes > 570;
    return {
        from: timestampsLookLikeBarClose ? firstBar.time - interval : firstBar.time,
        to: timestampsLookLikeBarClose ? lastBar.time : lastBar.time + interval
    };
};
const $bee49d807911cd75$export$700871a7cae9b44 = (bars)=>{
    const groups = new Map();
    bars.forEach((bar)=>{
        const { key: key } = $bee49d807911cd75$var$getNyParts(bar.time);
        const dayBars = groups.get(key) || [];
        dayBars.push(bar);
        groups.set(key, dayBars);
    });
    return Array.from(groups.entries()).map(([key, dayBars])=>({
            key: key,
            bars: [
                ...dayBars
            ].sort((a, b)=>a.time - b.time)
        }));
};
const $bee49d807911cd75$var$groupByCalendarDay = (bars)=>{
    const groups = new Map();
    bars.forEach((bar)=>{
        const key = $bee49d807911cd75$var$getCalendarDay(bar.time);
        const dayBars = groups.get(key) || [];
        dayBars.push(bar);
        groups.set(key, dayBars);
    });
    return Array.from(groups.entries()).map(([key, dayBars])=>({
            key: key,
            bars: [
                ...dayBars
            ].sort((a, b)=>a.time - b.time)
        }));
};
const $bee49d807911cd75$export$c36a2603d98abe74 = (bars)=>$bee49d807911cd75$var$groupByCalendarDay(bars).map(({ bars: dayBars })=>{
        const sorted = [
            ...dayBars
        ].sort((a, b)=>a.time - b.time);
        return {
            time: sorted[0].time,
            open: sorted[0].open,
            high: Math.max(...sorted.map((bar)=>bar.high)),
            low: Math.min(...sorted.map((bar)=>bar.low)),
            close: sorted[sorted.length - 1].close,
            volume: sorted.reduce((sum, bar)=>sum + (Number.isFinite(bar.volume) ? bar.volume : 0), 0)
        };
    });
const $bee49d807911cd75$export$b34148a8bb227faa = (bars, period, timeframe = '5min')=>{
    const values = [];
    let sum = 0;
    bars.forEach((bar, index)=>{
        sum += bar.close;
        if (index >= period) sum -= bars[index - period].close;
        if (index >= period - 1) values.push({
            time: $bee49d807911cd75$export$91c701c0111963f6(bar.time, timeframe),
            value: sum / period
        });
    });
    return values;
};
const $bee49d807911cd75$export$cc6710ee5f037d57 = (values)=>values.length ? values.reduce((sum, value)=>sum + value, 0) / values.length : null;
const $bee49d807911cd75$export$f231c38f5dd1ef1b = (timeframe)=>{
    if (timeframe === '5min') return 78;
    if (timeframe === '30min') return 26;
    return 90;
};
const $bee49d807911cd75$export$29e05362fa428c71 = (bars, status, timeframe, colors)=>{
    const direction = String(status?.direction || 'LONG').toUpperCase();
    const entryMinutes = Number(status?.entry_minutes || 10);
    const atrMultiple = Number(status?.atr_multiple || 0.5);
    const volumeThreshold = Number(status?.relative_volume_threshold || 1.5);
    const rangeBars = Math.max(1, Math.ceil(entryMinutes / Math.max(1, $bee49d807911cd75$export$7b93452404e28154(timeframe) / 60)));
    const markers = [];
    let previousClose = null;
    const trueRanges = [];
    const openingVolumes = [];
    $bee49d807911cd75$export$700871a7cae9b44(bars).forEach(({ bars: dayBars }, dayIndex, dayGroups)=>{
        const sessionBars = $bee49d807911cd75$export$bddd759d272a4ed9(dayBars);
        if (sessionBars.length <= rangeBars) return;
        const openingBars = sessionBars.slice(0, rangeBars);
        const openingVolume = openingBars.reduce((sum, bar)=>sum + Math.max(0, Number(bar.volume) || 0), 0);
        const openingBaseline = $bee49d807911cd75$export$cc6710ee5f037d57(openingVolumes.slice(-20));
        const openingRvol = openingBaseline != null && openingBaseline > 0 ? openingVolume / openingBaseline : null;
        const high = Math.max(...openingBars.map((bar)=>bar.high));
        const low = Math.min(...openingBars.map((bar)=>bar.low));
        const dayHigh = Math.max(...sessionBars.map((bar)=>bar.high));
        const dayLow = Math.min(...sessionBars.map((bar)=>bar.low));
        const dayClose = sessionBars[sessionBars.length - 1].close;
        const trueRange = previousClose == null ? dayHigh - dayLow : Math.max(dayHigh - dayLow, Math.abs(dayHigh - previousClose), Math.abs(dayLow - previousClose));
        const historicalAtr = $bee49d807911cd75$export$cc6710ee5f037d57(trueRanges.slice(-14));
        trueRanges.push(trueRange);
        previousClose = dayClose;
        const configuredAtr = Number(status?.atr);
        const atr = dayIndex === dayGroups.length - 1 && Number.isFinite(configuredAtr) && configuredAtr > 0 ? configuredAtr : historicalAtr ?? trueRange;
        const trigger = direction === 'SHORT' ? low - atr * atrMultiple : high + atr * atrMultiple;
        const breakout = sessionBars.slice(rangeBars).find((bar)=>{
            const priceBreak = direction === 'SHORT' ? bar.low <= trigger : bar.high >= trigger;
            return priceBreak && openingRvol != null && openingRvol >= volumeThreshold;
        });
        openingVolumes.push(openingVolume);
        if (breakout) markers.push({
            time: breakout.time,
            position: direction === 'SHORT' ? 'aboveBar' : 'belowBar',
            color: status?.simulation_mode ? colors.warningBright : colors.neon,
            shape: direction === 'SHORT' ? 'arrowDown' : 'arrowUp',
            text: status?.simulation_mode ? 'SIM' : 'POT'
        });
    });
    return markers;
};
const $bee49d807911cd75$export$e05b4e467f178bf2 = (bars, status, colors)=>{
    const threshold = Number(status?.relative_volume_threshold || 1.5);
    const priorBuckets = new Map();
    return bars.map((bar)=>{
        const { minutes: minutes } = $bee49d807911cd75$var$getNyParts(bar.time);
        const regularSession = minutes >= 570 && minutes <= 960;
        const baseline = regularSession ? $bee49d807911cd75$export$cc6710ee5f037d57(priorBuckets.get(minutes) || []) : null;
        const highRvol = baseline != null && baseline > 0 && bar.volume >= baseline * threshold;
        const priceUp = Number(bar.close) > Number(bar.open);
        const priceDown = Number(bar.close) < Number(bar.open);
        const result = {
            time: bar.time,
            value: Number(bar.volume || 0),
            color: !regularSession ? colors.mutedDark : highRvol ? priceUp ? colors.success : priceDown ? colors.danger : colors.muted : colors.mutedDark
        };
        if (regularSession) {
            const values = priorBuckets.get(minutes) || [];
            values.push(Math.max(0, Number(bar.volume) || 0));
            priorBuckets.set(minutes, values);
        }
        return result;
    });
};
const $bee49d807911cd75$export$7be82669d46b07a3 = (bars, status, colors, historicalSignals = [])=>{
    const markers = [];
    const barsByDate = new Map();
    bars.forEach((bar)=>barsByDate.set($bee49d807911cd75$var$getCalendarDay(bar.time), bar));
    const addMarker = (date, position, color, shape, text)=>{
        const bar = date ? barsByDate.get(String(date).slice(0, 10)) : undefined;
        if (bar) markers.push({
            time: $bee49d807911cd75$export$91c701c0111963f6(bar.time, '1d'),
            position: position,
            color: color,
            shape: shape,
            text: text
        });
    };
    const trades = Array.isArray(status?.simulated_trades) ? status.simulated_trades : [];
    const seen = new Set();
    const addSignal = (signal)=>{
        const side = String(signal?.side || status?.direction || 'LONG').toUpperCase();
        const isShort = side.includes('SELL') || side === 'SHORT';
        const date = signal?.date || signal?.entry_date;
        const key = `${String(date || '').slice(0, 10)}:BUY`;
        if (date && !seen.has(key)) {
            addMarker(date, isShort ? 'aboveBar' : 'belowBar', colors.neon, isShort ? 'arrowDown' : 'arrowUp', isShort ? 'SELL' : 'BUY');
            seen.add(key);
        }
        if (signal?.exit_date || signal?.close_date) {
            const closeDate = signal.exit_date || signal.close_date;
            const closeKey = `${String(closeDate).slice(0, 10)}:CLOSE`;
            if (!seen.has(closeKey)) {
                addMarker(closeDate, isShort ? 'belowBar' : 'aboveBar', colors.danger, isShort ? 'arrowUp' : 'arrowDown', 'CLOSE');
                seen.add(closeKey);
            }
        }
    };
    historicalSignals.forEach(addSignal);
    trades.forEach((trade)=>addSignal(trade));
    if (!trades.length && status?.entry_date) {
        const isShort = String(status?.direction || 'LONG').toUpperCase() === 'SHORT';
        addMarker(status.entry_date, isShort ? 'aboveBar' : 'belowBar', colors.neon, isShort ? 'arrowDown' : 'arrowUp', isShort ? 'SELL' : 'BUY');
    }
    if (!trades.length && status?.simulated_exit?.date) addMarker(status.simulated_exit.date, 'aboveBar', colors.danger, 'arrowDown', 'CLOSE');
    return markers;
};

});


parcelRegister("hwNGq", function(module, exports) {

$parcel$export(module.exports, "getStrategyDescription", () => $76fbe388c9f8a89d$export$8363ce2bd0f62649);
const $76fbe388c9f8a89d$export$8a8f68c015d6cc38 = {
    ON: {
        label: 'Overnight',
        description: 'Overnight trend and carry strategy using the configured ETF signals.',
        overview: 'Uses the overnight session windows and longer-term moving-average context to manage the configured ETF positions.'
    },
    ORB: {
        label: 'Opening Range Breakout',
        description: 'Intraday opening-range breakout strategy with ATR and momentum checks.',
        overview: 'Evaluates the opening range, ATR-based momentum, and configured exit rules before managing an intraday breakout position.'
    },
    DT: {
        label: 'ATR Day Trade',
        description: 'Multi-symbol intraday strategy driven by ATR thresholds and entry windows.',
        overview: 'Uses configured intraday ATR thresholds and entry windows across the selected symbols, with risk controls and end-of-day exits.'
    },
    NQMM: {
        label: 'Nasdaq-100 Monthly Momentum',
        description: 'Long-only monthly momentum sleeve for the current Nasdaq-100 universe.',
        overview: 'Ranks the current Nasdaq-100 universe, sizes the selected holdings using the configured method, and prepares monthly rebalance actions.'
    },
    MORB: {
        label: 'Managed ORB',
        description: 'Semi-automatic, user-selected opening-range breakout manager.',
        overview: 'Tracks selected stocks, checks volume and ATR quality gates, and manages entries, staged stops, and T+3 reductions.'
    },
    MANUAL: {
        label: 'Manual',
        description: 'Position placed manually outside an automated strategy.',
        overview: 'This position is not currently owned by an automated strategy.'
    },
    UNASSIGNED: {
        label: 'Unassigned',
        description: 'No strategy attribution is available for this position.',
        overview: 'No strategy description is available for this position.'
    }
};
const $76fbe388c9f8a89d$export$8363ce2bd0f62649 = (strategy)=>{
    const key = String(strategy || '').trim().toUpperCase();
    return $76fbe388c9f8a89d$export$8a8f68c015d6cc38[key] || {
        label: key || 'Unassigned',
        description: 'Strategy attribution is not documented.',
        overview: 'No strategy description is available for this strategy.'
    };
};

});

parcelRegister("itzRU", function(module, exports) {
module.exports = import("4ZKvb").then(()=>parcelRequire('eFZ05'));

});

parcelRegister("rViNl", function(module, exports) {
module.exports = import("2DD9i").then(()=>parcelRequire('jq3pN'));

});

parcelRegister("k2dSa", function(module, exports) {
module.exports = Promise.all([
    import("5SHmi"),
    import("cc3Pc"),
    import("jbc2k"),
    import("e6dPn"),
    import("138Js")
]).then(()=>parcelRequire('5tEJ6'));

});

parcelRegister("g2DAj", function(module, exports) {
module.exports = Promise.all([
    import("e6dPn"),
    import("bjwzS")
]).then(()=>parcelRequire('ffn1c'));

});

parcelRegister("1JNaZ", function(module, exports) {
module.exports = Promise.all([
    import("5wZRm"),
    import("5SHmi"),
    import("jbc2k"),
    import("d3XN9")
]).then(()=>parcelRequire('aowNL'));

});

parcelRegister("e9VH6", function(module, exports) {
module.exports = Promise.all([
    import("5wZRm"),
    import("5SHmi"),
    import("jbc2k"),
    import("8ObSs")
]).then(()=>parcelRequire('1f0qo'));

});

parcelRegister("9SjZD", function(module, exports) {
module.exports = import("aCGAc").then(()=>parcelRequire('4jgVg'));

});

parcelRegister("2Bjzh", function(module, exports) {
module.exports = import("820f9").then(()=>parcelRequire('992ZV'));

});

parcelRegister("6fN4Y", function(module, exports) {
module.exports = import("5EVbK").then(()=>parcelRequire('3DVGz'));

});

parcelRegister("8EkpO", function(module, exports) {
module.exports = Promise.all([
    import("5SHmi"),
    import("cc3Pc"),
    import("cK5Ac")
]).then(()=>parcelRequire('38TTn'));

});

parcelRegister("e83Ha", function(module, exports) {
module.exports = import("i12ys").then(()=>parcelRequire('4WCXr'));

});

parcelRegister("9ONAt", function(module, exports) {
module.exports = import("5ghO0").then(()=>parcelRequire('bqjUV'));

});

parcelRegister("f0rfV", function(module, exports) {
module.exports = import("9UPqm").then(()=>parcelRequire('e46gf'));

});

parcelRegister("7dI3I", function(module, exports) {
module.exports = import("hzHAf").then(()=>parcelRequire('g70Ov'));

});

parcelRegister("8UJ0B", function(module, exports) {

$parcel$export(module.exports, "default", () => $67d677781d2c6f6a$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $67d677781d2c6f6a$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Layers3", [
    [
        "path",
        {
            d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
            key: "8b97xw"
        }
    ],
    [
        "path",
        {
            d: "m6.08 9.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
            key: "1e5n1m"
        }
    ],
    [
        "path",
        {
            d: "m6.08 14.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
            key: "1iwflc"
        }
    ]
]);

});

parcelRegister("1A3et", function(module, exports) {

$parcel$export(module.exports, "default", () => $126ba921a4c40132$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $126ba921a4c40132$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Palette", [
    [
        "circle",
        {
            cx: "13.5",
            cy: "6.5",
            r: ".5",
            fill: "currentColor",
            key: "1okk4w"
        }
    ],
    [
        "circle",
        {
            cx: "17.5",
            cy: "10.5",
            r: ".5",
            fill: "currentColor",
            key: "f64h9f"
        }
    ],
    [
        "circle",
        {
            cx: "8.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "fotxhn"
        }
    ],
    [
        "circle",
        {
            cx: "6.5",
            cy: "12.5",
            r: ".5",
            fill: "currentColor",
            key: "qy21gx"
        }
    ],
    [
        "path",
        {
            d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
            key: "12rzf8"
        }
    ]
]);

});

parcelRegister("7J9BS", function(module, exports) {
module.exports = import("7KmWG").then(()=>parcelRequire('eA1j0'));

});

parcelRegister("1pkT4", function(module, exports) {
module.exports = import("e6rAt").then(()=>parcelRequire('5qvGt'));

});

parcelRegister("2vhh3", function(module, exports) {
module.exports = import("7veJ2").then(()=>parcelRequire('iTmC6'));

});

parcelRegister("eiFyw", function(module, exports) {
module.exports = import.meta.resolve("1VDmn");

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $70wbS = parcelRequire("70wbS");

var $2wVnk = parcelRequire("2wVnk");

var $2Kpom = parcelRequire("2Kpom");
const $5b0fd0c87ae8709d$export$361f331cf51c8057 = ()=>{
    const { token: token } = (0, $70wbS.useAuth)();
    const [marketStatus, setMarketStatus] = (0, $acw62.useState)("");
    const [statusColor, setStatusColor] = (0, $acw62.useState)("text-muted");
    const [tomorrowStatus, setTomorrowStatus] = (0, $acw62.useState)("");
    const fetchMarketStatus = (0, $acw62.useCallback)(async ()=>{
        if (!token) return;
        try {
            const result = await (0, $2wVnk.tradingApi).getMarketStatus();
            const liquidHours = result.data?.liquid_hours;
            if (result.success && liquidHours) {
                const now = new Date();
                const nyOptions = {
                    timeZone: "America/New_York",
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                };
                const formatter = new Intl.DateTimeFormat('en-US', nyOptions);
                // --- Tomorrow Logic ---
                const tomorrow = new Date(now);
                tomorrow.setDate(tomorrow.getDate() + 1);
                const tParts = formatter.formatToParts(tomorrow);
                const ty = tParts.find((p)=>p.type === 'year')?.value;
                const tm = tParts.find((p)=>p.type === 'month')?.value;
                const td = tParts.find((p)=>p.type === 'day')?.value;
                const tomorrowStr = `${ty}${tm}${td}`;
                const segments = liquidHours.split(';');
                const tomorrowSegment = segments.find((s)=>s.startsWith(tomorrowStr));
                if (tomorrowSegment) {
                    if (tomorrowSegment.includes("CLOSED")) setTomorrowStatus("Tomorrow: Closed");
                    else setTomorrowStatus("Tomorrow: Regular");
                } else {
                    const day = tomorrow.getDay();
                    if (day === 0 || day === 6) setTomorrowStatus("Tomorrow: Closed");
                    else setTomorrowStatus("Tomorrow: Regular");
                }
                // --- Today Logic ---
                const parts = formatter.formatToParts(now);
                const y = parts.find((p)=>p.type === 'year')?.value;
                const m = parts.find((p)=>p.type === 'month')?.value;
                const d = parts.find((p)=>p.type === 'day')?.value;
                const todayStr = `${y}${m}${d}`; // YYYYMMDD
                const todaySegment = segments.find((s)=>s.startsWith(todayStr));
                if (todaySegment) {
                    if (todaySegment.includes("CLOSED")) {
                        setMarketStatus("US Market: Closed (Holiday)");
                        setStatusColor("text-red-400");
                        return;
                    }
                    const [start, end] = todaySegment.split('-');
                    const [, startTime] = start.split(':');
                    const [, endTime] = end.split(':');
                    const getSeconds = (timeStr)=>{
                        const h = parseInt(timeStr.substring(0, 2));
                        const m = parseInt(timeStr.substring(2, 4));
                        return h * 3600 + m * 60;
                    };
                    const openSeconds = getSeconds(startTime);
                    const closeSeconds = getSeconds(endTime);
                    const nyTimeOptions = {
                        timeZone: "America/New_York",
                        hour12: false,
                        hour: 'numeric',
                        minute: 'numeric',
                        second: 'numeric'
                    };
                    const timeFormatter = new Intl.DateTimeFormat('en-US', nyTimeOptions);
                    const timeParts = timeFormatter.formatToParts(now);
                    const curH = parseInt(timeParts.find((p)=>p.type === 'hour')?.value || '0');
                    const curM = parseInt(timeParts.find((p)=>p.type === 'minute')?.value || '0');
                    const curS = parseInt(timeParts.find((p)=>p.type === 'second')?.value || '0');
                    const totalSeconds = curH * 3600 + curM * 60 + curS;
                    if (totalSeconds < openSeconds) {
                        const diff = openSeconds - totalSeconds;
                        const h = Math.floor(diff / 3600);
                        const m = Math.floor(diff % 3600 / 60);
                        const s = diff % 60;
                        setMarketStatus(`US Market: Opens in ${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
                        setStatusColor("text-yellow-400");
                    } else if (totalSeconds >= openSeconds && totalSeconds < closeSeconds) {
                        const diff = closeSeconds - totalSeconds;
                        const h = Math.floor(diff / 3600);
                        const m = Math.floor(diff % 3600 / 60);
                        const s = diff % 60;
                        setMarketStatus(`US Market: Open \u{2022} Closes in ${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
                        setStatusColor("text-neon");
                    } else {
                        setMarketStatus("US Market: Closed");
                        setStatusColor("text-red-400");
                    }
                    return;
                }
            }
        } catch (err) {
            console.warn("Failed to fetch market status", err);
        }
        updateMarketStatusLocal();
    }, [
        token
    ]);
    const updateMarketStatusLocal = ()=>{
        const now = new Date();
        const nyOptions = {
            timeZone: "America/New_York",
            hour12: false,
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            weekday: 'short'
        };
        const formatter = new Intl.DateTimeFormat('en-US', nyOptions);
        const parts = formatter.formatToParts(now);
        const getPart = (type)=>parts.find((p)=>p.type === type)?.value;
        const hour = parseInt(getPart('hour') || '0');
        const minute = parseInt(getPart('minute') || '0');
        const second = parseInt(getPart('second') || '0');
        const weekday = getPart('weekday');
        const dayIdx = now.getDay();
        if (dayIdx === 5 || dayIdx === 6) setTomorrowStatus("Tomorrow: Closed (Weekend)");
        else setTomorrowStatus("Tomorrow: Regular");
        const totalSeconds = hour * 3600 + minute * 60 + second;
        const openSeconds = 34200;
        const closeSeconds = 57600;
        const isWeekend = weekday === 'Sat' || weekday === 'Sun';
        if (isWeekend) {
            setMarketStatus("US Market: Closed (Weekend)");
            setStatusColor("text-red-400");
        } else if (totalSeconds < openSeconds) {
            const diff = openSeconds - totalSeconds;
            const h = Math.floor(diff / 3600);
            const m = Math.floor(diff % 3600 / 60);
            const s = diff % 60;
            setMarketStatus(`US Market: Opens in ${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
            setStatusColor("text-yellow-400");
        } else if (totalSeconds >= openSeconds && totalSeconds < closeSeconds) {
            const diff = closeSeconds - totalSeconds;
            const h = Math.floor(diff / 3600);
            const m = Math.floor(diff % 3600 / 60);
            const s = diff % 60;
            setMarketStatus(`US Market: Open \u{2022} Closes in ${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
            setStatusColor("text-neon");
        } else {
            setMarketStatus("US Market: Closed");
            setStatusColor("text-red-400");
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchMarketStatus();
        // Market hours do not change every second. Avoid a global API/Intl parsing
        // loop while keeping the countdown responsive enough for the header.
        const statusInterval = setInterval(fetchMarketStatus, 5000);
        return ()=>{
            clearInterval(statusInterval);
        };
    }, [
        fetchMarketStatus
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "w-full overflow-hidden flex items-center justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Kpom.default), {
                    size: 14,
                    className: statusColor
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: `text-xs font-bold uppercase tracking-wider ${statusColor} whitespace-nowrap`,
                    children: marketStatus
                }),
                tomorrowStatus && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-white/20 mx-1",
                            children: "\u2022"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-[10px] sm:text-xs font-medium text-muted uppercase tracking-wider whitespace-nowrap",
                            children: tomorrowStatus
                        })
                    ]
                })
            ]
        })
    });
};



var $7o8DG = parcelRequire("7o8DG");

var $2jex3 = parcelRequire("2jex3");

var $ayMG0 = parcelRequire("ayMG0");

var $kvv04 = parcelRequire("kvv04");

var $acw62 = parcelRequire("acw62");

var $7dAee = parcelRequire("7dAee");
var $jztMd = parcelRequire("jztMd");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $6c2a827dd5c2d433$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Pencil", [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
]);

/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $84e37213187279fb$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Send", [
    [
        "path",
        {
            d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
            key: "1ffxy3"
        }
    ],
    [
        "path",
        {
            d: "m21.854 2.147-10.94 10.939",
            key: "12cjpa"
        }
    ]
]);


var $hPAJY = parcelRequire("hPAJY");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $00b4789eeda33397$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Zap", [
    [
        "path",
        {
            d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
            key: "1xq2db"
        }
    ]
]);



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bTepa = parcelRequire("bTepa");
var $di5Ac = parcelRequire("di5Ac");
parcelRequire("jl3Sp");
var $2zES5 = parcelRequire("2zES5");
const $6408cf3508cbf4a0$export$70d034a749d428df = (contract)=>Boolean(contract && (contract.sec_type === 'FUT' || contract.con_id || contract.last_trade_date_or_contract_month || contract.local_symbol));
const $6408cf3508cbf4a0$export$4aaaaf2ad7363269 = (contract)=>String(contract?.sec_type || '').toUpperCase() === 'FUT';
const $6408cf3508cbf4a0$export$2c5c4ae02dc830fb = (contract)=>{
    if (contract.display_symbol) return contract.display_symbol;
    if (contract.local_symbol) return contract.local_symbol;
    if (contract.sec_type === 'FUT' && contract.last_trade_date_or_contract_month) return `${contract.symbol} ${contract.last_trade_date_or_contract_month}`;
    return contract.symbol;
};
const $6408cf3508cbf4a0$export$c9b619662d734331 = (positions, symbol, limit = 8)=>{
    const normalizedSymbol = symbol.toUpperCase();
    return positions.filter((item)=>{
        if (!normalizedSymbol) return true;
        return [
            item.symbol,
            item.local_symbol,
            item.trading_class
        ].filter(Boolean).some((value)=>String(value).toUpperCase().includes(normalizedSymbol));
    }).slice(0, limit);
};


const $30c45b9c908c726d$var$SEC_TYPE_OPTIONS = [
    'STK',
    'FUT',
    'OPT',
    'CFD',
    'CASH'
].map((value)=>({
        value: value,
        label: value
    }));
const $30c45b9c908c726d$var$ContractPicker = ({ symbol: symbol, secType: secType, isEditing: isEditing, positionSuggestions: positionSuggestions, lookupResults: lookupResults, lookupLoading: lookupLoading, showDropdown: showDropdown, selectedContract: selectedContract, marketPrice: marketPrice, fetchingPrice: fetchingPrice, pricePresentation: pricePresentation, onSymbolChange: onSymbolChange, onSymbolFocus: onSymbolFocus, onSymbolBlur: onSymbolBlur, onSecTypeChange: onSecTypeChange, onLookup: onLookup, onSelectContract: onSelectContract, onRefreshQuote: onRefreshQuote })=>{
    const suggestions = (0, $6408cf3508cbf4a0$export$c9b619662d734331)(positionSuggestions, symbol);
    const hasDropdown = showDropdown && (suggestions.length > 0 || lookupResults.length > 0 || lookupLoading);
    const hasLatestPriceRow = marketPrice !== null || fetchingPrice;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-[2] relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "Symbol"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                value: symbol,
                                onFocus: onSymbolFocus,
                                onChange: (event)=>onSymbolChange(event.target.value.toUpperCase()),
                                disabled: isEditing,
                                onKeyDown: (event)=>{
                                    if (event.key === 'Enter') {
                                        event.preventDefault();
                                        onLookup();
                                    }
                                },
                                onBlur: onSymbolBlur,
                                placeholder: positionSuggestions[0] ? (0, $6408cf3508cbf4a0$export$2c5c4ae02dc830fb)(positionSuggestions[0]) : 'SPY',
                                className: `w-full bg-white/[0.03] border border-white/10 px-3 pr-9 py-2 text-foreground placeholder-muted/30 focus:outline-none focus:border-neon/50 focus:bg-white/[0.05] transition h-9 text-xs ${hasDropdown ? 'rounded-t-lg border-b-0' : 'rounded-lg'}`,
                                required: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onMouseDown: (event)=>event.preventDefault(),
                                onClick: onLookup,
                                disabled: isEditing || lookupLoading || !symbol,
                                className: "absolute right-1.5 top-1/2 -translate-y-1/2 h-6 w-6 rounded-md text-muted hover:text-neon hover:bg-white/5 disabled:opacity-30 disabled:cursor-not-allowed transition flex items-center justify-center",
                                title: "Lookup qualified IB contracts",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $di5Ac.default), {
                                    className: `w-3.5 h-3.5 ${lookupLoading ? 'animate-pulse' : ''}`
                                })
                            })
                        ]
                    }),
                    hasLatestPriceRow && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-1 flex h-5 items-center justify-between rounded-md border border-white/5 bg-white/[0.025] px-2 text-[10px]",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-bold uppercase tracking-wider text-muted/60",
                                children: "Latest"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                onClick: onRefreshQuote,
                                disabled: fetchingPrice,
                                title: (0, $6408cf3508cbf4a0$export$4aaaaf2ad7363269)(selectedContract) ? 'Refresh futures live snapshot' : 'Refresh latest price',
                                className: `flex items-center gap-1 font-mono font-bold transition hover:text-neon disabled:opacity-50 ${pricePresentation.priceClassName}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                                        className: `h-2.5 w-2.5 ${fetchingPrice ? 'animate-spin' : ''}`
                                    }),
                                    marketPrice !== null ? `$${marketPrice.toFixed(2)}` : 'Loading',
                                    marketPrice !== null && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `ml-1 rounded border px-1 text-[8px] uppercase ${pricePresentation.badgeClassName}`,
                                        children: pricePresentation.status
                                    })
                                ]
                            })
                        ]
                    }),
                    hasDropdown && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `absolute z-[60] left-0 ${hasLatestPriceRow ? 'top-[calc(100%+1.25rem)]' : 'top-[calc(100%-1px)]'} min-w-full w-[min(32rem,calc(100vw-2rem))] bg-[#1a1a2e] border border-white/10 rounded-xl shadow-2xl overflow-hidden backdrop-blur-xl animate-in fade-in slide-in-from-top-1 duration-200`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "py-1 max-h-64 overflow-y-auto ux-scrollbar",
                            children: [
                                suggestions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "px-3 py-1.5 text-[9px] font-bold uppercase tracking-wider text-muted/60",
                                    children: "Open positions"
                                }),
                                suggestions.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onMouseDown: (event)=>event.preventDefault(),
                                        onClick: ()=>onSelectContract(item),
                                        className: "w-full px-4 py-2.5 text-left text-xs font-bold text-white/70 hover:text-neon hover:bg-white/5 transition-colors border-b border-white/[0.03] last:border-0 flex items-center justify-between gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "truncate",
                                                children: (0, $6408cf3508cbf4a0$export$2c5c4ae02dc830fb)(item)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "text-[10px] text-muted font-mono whitespace-nowrap",
                                                children: [
                                                    item.sec_type,
                                                    item.last_trade_date_or_contract_month ? ` ${item.last_trade_date_or_contract_month}` : ''
                                                ]
                                            })
                                        ]
                                    }, `position-${item.symbol}-${item.sec_type}-${item.con_id || item.local_symbol || ''}`)),
                                lookupLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "px-4 py-2.5 text-xs text-muted flex items-center gap-2 border-t border-white/[0.04]",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                                            className: "w-3 h-3 animate-spin"
                                        }),
                                        "Looking up contracts..."
                                    ]
                                }),
                                lookupResults.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "px-3 py-1.5 text-[9px] font-bold uppercase tracking-wider text-muted/60 border-t border-white/[0.04]",
                                    children: "Lookup results"
                                }),
                                lookupResults.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onMouseDown: (event)=>event.preventDefault(),
                                        onClick: ()=>onSelectContract(item),
                                        className: "w-full px-4 py-2.5 text-left text-xs text-white/75 hover:bg-white/5 hover:text-neon transition border-b border-white/[0.04] last:border-0 flex items-center justify-between gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "block font-bold truncate",
                                                        children: item.local_symbol || item.symbol
                                                    }),
                                                    item.long_name && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "block text-[10px] text-muted truncate font-normal",
                                                        children: item.long_name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "text-[10px] text-muted font-mono whitespace-nowrap",
                                                children: [
                                                    item.sec_type,
                                                    " ",
                                                    item.last_trade_date_or_contract_month || '',
                                                    " ",
                                                    item.exchange || ''
                                                ]
                                            })
                                        ]
                                    }, `lookup-${item.con_id || item.local_symbol}-${item.exchange}`))
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1 relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "Sec Type"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2zES5.CustomSelect), {
                        value: secType,
                        onChange: onSecTypeChange,
                        options: $30c45b9c908c726d$var$SEC_TYPE_OPTIONS,
                        ariaLabel: "Security type",
                        disabled: isEditing
                    })
                ]
            })
        ]
    });
};
var $30c45b9c908c726d$export$2e2bcd8739ae039 = $30c45b9c908c726d$var$ContractPicker;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jl3Sp");
var $2zES5 = parcelRequire("2zES5");
const $3492ac59acd2adcc$var$TIME_IN_FORCE_OPTIONS = [
    {
        value: 'DAY',
        label: 'DAY'
    },
    {
        value: 'GTC',
        label: 'GTC'
    }
];
const $3492ac59acd2adcc$var$OrderExecutionOptionsFields = ({ timeInForce: timeInForce, outsideRegularHours: outsideRegularHours, orderType: orderType, onTimeInForceChange: onTimeInForceChange, onOutsideRegularHoursChange: onOutsideRegularHoursChange })=>{
    const outsideRegularHoursDisabled = orderType === 'MARKET' || orderType === 'MIDPRICE';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex gap-3 items-end",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "TIF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2zES5.CustomSelect), {
                        value: timeInForce,
                        onChange: (value)=>onTimeInForceChange(value),
                        options: $3492ac59acd2adcc$var$TIME_IN_FORCE_OPTIONS,
                        ariaLabel: "Time in force"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: `flex flex-[2] h-9 rounded-lg border px-3 items-center justify-between gap-3 transition ${outsideRegularHoursDisabled ? 'border-white/5 bg-white/[0.02] opacity-40' : 'border-white/10 bg-white/[0.03] hover:bg-white/[0.05]'}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-[10px] font-bold text-muted uppercase tracking-wider leading-none",
                        children: "Outside RTH"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "checkbox",
                        checked: outsideRegularHours,
                        disabled: outsideRegularHoursDisabled,
                        onChange: (event)=>onOutsideRegularHoursChange(event.target.checked),
                        className: "h-4 w-4 shrink-0 accent-emerald-400"
                    })
                ]
            })
        ]
    });
};
var $3492ac59acd2adcc$export$2e2bcd8739ae039 = $3492ac59acd2adcc$var$OrderExecutionOptionsFields;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bTepa = parcelRequire("bTepa");
parcelRequire("jl3Sp");
var $2zES5 = parcelRequire("2zES5");

var $b1rqt = parcelRequire("b1rqt");
const $eb20553c6c616bbe$var$ORDER_TYPE_OPTIONS = [
    {
        value: 'MARKET',
        label: 'MKT'
    },
    {
        value: 'LIMIT',
        label: 'LMT'
    },
    {
        value: 'MIDPRICE',
        label: 'MID'
    },
    {
        value: 'STOP',
        label: 'STP'
    },
    {
        value: 'TRAIL',
        label: 'TRAIL'
    }
];
const $eb20553c6c616bbe$var$OrderPricingFields = ({ orderType: orderType, price: price, trailingAmount: trailingAmount, trailType: trailType, action: action, marketPrice: marketPrice, fetchingPrice: fetchingPrice, pricePresentation: pricePresentation, currency: currency, onOrderTypeChange: onOrderTypeChange, onPriceChange: onPriceChange, onTrailingAmountChange: onTrailingAmountChange, onTrailTypeChange: onTrailTypeChange, onRefreshQuote: onRefreshQuote, onSnapToMarket: onSnapToMarket })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex gap-3 items-end",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "Type"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2zES5.CustomSelect), {
                        value: orderType,
                        onChange: onOrderTypeChange,
                        options: $eb20553c6c616bbe$var$ORDER_TYPE_OPTIONS,
                        ariaLabel: "Order type"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-[1.5]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-between items-end mb-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: `block text-[10px] font-bold uppercase tracking-wider ${orderType !== 'MARKET' ? 'text-neon opacity-90' : 'text-muted opacity-40'}`,
                                children: orderType === 'STOP' ? 'Stop' : orderType === 'TRAIL' ? 'Trailing Amt' : orderType === 'MIDPRICE' ? 'Midpoint Cap' : 'Price'
                            }),
                            marketPrice !== null ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-1.5 px-1.5 py-0.5 rounded bg-white/[0.03] border border-white/5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: onRefreshQuote,
                                        disabled: fetchingPrice,
                                        className: `transition-all ${fetchingPrice ? 'animate-spin opacity-50' : 'hover:text-neon text-muted/60'}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                                            className: "w-2.5 h-2.5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-[9px] font-bold text-muted/60 uppercase tracking-tighter",
                                        children: "Mkt"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `text-[10px] font-mono font-bold ${fetchingPrice ? 'opacity-40' : pricePresentation.priceClassName}`,
                                        children: marketPrice.toFixed(2)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `rounded border px-1 text-[8px] font-bold uppercase ${pricePresentation.badgeClassName}`,
                                        children: pricePresentation.status
                                    }),
                                    orderType !== 'MARKET' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: onSnapToMarket,
                                        disabled: !pricePresentation.usableForPricing,
                                        title: pricePresentation.usableForPricing ? 'Snap to Market' : 'Stale or frozen prices cannot populate an order',
                                        className: "ml-0.5 text-muted hover:text-neon transition-colors disabled:cursor-not-allowed disabled:opacity-25",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00b4789eeda33397$export$2e2bcd8739ae039), {
                                            className: "w-2.5 h-2.5 fill-current"
                                        })
                                    })
                                ]
                            }) : fetchingPrice && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                                className: "w-2.5 h-2.5 text-muted animate-spin mb-0.5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "relative",
                        children: orderType === 'TRAIL' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex gap-2 w-full",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "number",
                                    value: trailingAmount,
                                    onChange: (event)=>onTrailingAmountChange(event.target.value),
                                    onBlur: ()=>trailingAmount && onTrailingAmountChange(parseFloat(trailingAmount).toFixed(2)),
                                    placeholder: "0.00",
                                    step: "0.01",
                                    className: "flex-1 bg-white/[0.03] border border-white/10 focus:border-neon/50 rounded-lg px-3 py-2 text-foreground transition h-9 text-xs focus:outline-none font-mono",
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex-shrink-0 flex rounded-lg bg-white/5 p-0.5 border border-white/10 h-9",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>onTrailTypeChange('amount'),
                                            className: `px-2.5 rounded-md text-[10px] font-black transition-all ${trailType === 'amount' ? 'bg-neon text-black shadow-[0_0_10px_rgba(0,255,153,0.3)]' : 'text-white/50 hover:text-white'}`,
                                            children: "$"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>onTrailTypeChange('percent'),
                                            className: `px-2.5 rounded-md text-[10px] font-black transition-all ${trailType === 'percent' ? 'bg-neon text-black shadow-[0_0_10px_rgba(0,255,153,0.3)]' : 'text-white/50 hover:text-white'}`,
                                            children: "%"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "number",
                                    value: price,
                                    onChange: (event)=>onPriceChange(event.target.value),
                                    onBlur: ()=>price && onPriceChange(parseFloat(price).toFixed(2)),
                                    placeholder: orderType !== 'MARKET' ? orderType === 'MIDPRICE' ? 'Max buy / min sell' : '0.00' : pricePresentation.usableForPricing && marketPrice ? marketPrice.toFixed(2) : 'Market',
                                    disabled: orderType === 'MARKET',
                                    step: "0.01",
                                    className: `w-full bg-white/[0.03] border rounded-lg px-3 py-2 text-foreground transition h-9 text-xs focus:outline-none ${orderType !== 'MARKET' ? 'border-white/10 focus:border-neon/50' : 'border-transparent opacity-30 cursor-not-allowed placeholder-muted/50 font-bold'}`,
                                    required: orderType !== 'MARKET'
                                }),
                                orderType === 'MARKET' && marketPrice && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1 opacity-40",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `text-[10px] font-bold ${pricePresentation.priceClassName}`,
                                        children: pricePresentation.status
                                    })
                                })
                            ]
                        })
                    }),
                    orderType === 'TRAIL' && pricePresentation.usableForPricing && marketPrice && trailingAmount && !isNaN(parseFloat(trailingAmount)) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-1.5 text-[11px] font-bold text-white/50 flex justify-between items-center bg-white/[0.02] border border-white/5 rounded-md px-2 py-1 select-none",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "uppercase tracking-wider text-[9px] text-muted",
                                children: "Est. Stop Price:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-mono text-rose-400 font-black",
                                children: (0, $b1rqt.formatCurrency)(trailType === 'amount' ? action === 'BUY' ? marketPrice + parseFloat(trailingAmount) : marketPrice - parseFloat(trailingAmount) : action === 'BUY' ? marketPrice * (1 + parseFloat(trailingAmount) / 100) : marketPrice - parseFloat(trailingAmount) / 100, currency)
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $eb20553c6c616bbe$export$2e2bcd8739ae039 = $eb20553c6c616bbe$var$OrderPricingFields;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1fufK = parcelRequire("1fufK");
var $iSlX2 = parcelRequire("iSlX2");
const $556904b36e690e02$var$OrderSideQuantityFields = ({ action: action, quantity: quantity, onActionChange: onActionChange, onQuantityChange: onQuantityChange })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex gap-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "Side"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex rounded-lg bg-white/[0.03] p-1 border border-white/10 h-9 items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>onActionChange('BUY'),
                                className: `flex-1 h-full text-[11px] font-bold rounded-md transition flex items-center justify-center ${action === 'BUY' ? 'bg-emerald-500/20 text-emerald-400 shadow-sm' : 'text-muted hover:text-foreground'}`,
                                children: "BUY"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>onActionChange('SELL'),
                                className: `flex-1 h-full text-[11px] font-bold rounded-md transition flex items-center justify-center ${action === 'SELL' ? 'bg-red-500/20 text-red-400 shadow-sm' : 'text-muted hover:text-foreground'}`,
                                children: "SELL"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70",
                        children: "Qty"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center h-9 bg-white/[0.03] border border-white/10 rounded-lg overflow-hidden focus-within:border-neon/50 transition",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    const current = parseInt(quantity, 10) || 0;
                                    onQuantityChange(String(Math.max(1, current - 1)));
                                },
                                className: "px-2.5 h-full hover:bg-white/5 text-muted hover:text-neon transition-colors border-r border-white/5",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1fufK.default), {
                                    className: "w-3 h-3"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "number",
                                value: quantity,
                                onChange: (event)=>onQuantityChange(event.target.value),
                                onBlur: ()=>{
                                    if (quantity === '' || parseInt(quantity, 10) <= 0) onQuantityChange('1');
                                },
                                min: "1",
                                className: "w-full bg-transparent px-2 text-center text-foreground focus:outline-none h-full text-xs [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    const current = parseInt(quantity, 10) || 0;
                                    onQuantityChange(String(current + 1));
                                },
                                className: "px-2.5 h-full hover:bg-white/5 text-muted hover:text-neon transition-colors border-l border-white/5",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSlX2.default), {
                                    className: "w-3 h-3"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $556904b36e690e02$export$2e2bcd8739ae039 = $556904b36e690e02$var$OrderSideQuantityFields;



const $dd32f7c191d7a5c5$var$ORDER_TYPE_ALIASES = {
    MKT: 'MARKET',
    MARKET: 'MARKET',
    LMT: 'LIMIT',
    LIMIT: 'LIMIT',
    MIDPRICE: 'MIDPRICE',
    STP: 'STOP',
    STOP: 'STOP',
    TRAIL: 'TRAIL'
};
const $dd32f7c191d7a5c5$export$50b86ba32e7259b5 = (order, isEditing)=>{
    const rootSymbol = order.rootSymbol || order.symbol || '';
    const normalizedSymbol = rootSymbol.toUpperCase();
    const rawOrderType = String(order.order_type || '').toUpperCase();
    const orderType = $dd32f7c191d7a5c5$var$ORDER_TYPE_ALIASES[rawOrderType] || 'MARKET';
    const unsupportedOrderType = orderType === 'MARKET' && ![
        'MKT',
        'MARKET'
    ].includes(rawOrderType) ? rawOrderType || 'UNKNOWN' : null;
    const isTrailingPercent = order.trailing_percent !== undefined && order.trailing_percent !== null;
    const secType = String(order.secType || 'STK').toUpperCase();
    return {
        symbol: normalizedSymbol,
        secType: secType,
        action: String(order.side || 'BUY').toUpperCase() === 'SELL' ? 'SELL' : 'BUY',
        strategyName: String(order.strategy || '').toUpperCase() === 'NQMM' ? 'NQMM' : 'MANUAL',
        orderType: orderType,
        unsupportedOrderType: isEditing ? unsupportedOrderType : null,
        tif: order.tif === 'GTC' ? 'GTC' : 'DAY',
        outsideRth: Boolean(order.outside_rth),
        quantity: String(order.quantity || 1),
        price: orderType === 'LIMIT' || orderType === 'MIDPRICE' ? String(order.limit_price ?? '') : orderType === 'STOP' ? String(order.stop_price ?? '') : '',
        trailType: isTrailingPercent ? 'percent' : 'amount',
        trailingAmount: orderType === 'TRAIL' ? String(isTrailingPercent ? order.trailing_percent ?? '' : order.trailing_amount ?? order.stop_price ?? '') : '',
        selectedContract: {
            symbol: normalizedSymbol,
            display_symbol: order.symbol ?? undefined,
            sec_type: secType,
            con_id: order.con_id,
            exchange: order.exchange,
            local_symbol: order.localSymbol,
            trading_class: order.tradingClass,
            last_trade_date_or_contract_month: order.lastTradeDateOrContractMonth,
            currency: order.currency ?? undefined,
            multiplier: order.multiplier
        },
        error: isEditing && unsupportedOrderType ? `IB order type ${unsupportedOrderType} cannot be edited safely from this form.` : null
    };
};



var $acw62 = parcelRequire("acw62");

var $jtEPT = parcelRequire("jtEPT");
const $14f179b2e6a21f03$export$2138299cfd7e961a = (positions, responseStale = false, responseTimestamp)=>{
    const suggestions = positions.filter((position)=>position.symbol && Number(position.quantity || 0) !== 0).map((position)=>({
            symbol: String(position.symbol).toUpperCase(),
            display_symbol: position.display_symbol,
            sec_type: position.secType || 'STK',
            con_id: position.con_id,
            exchange: position.exchange,
            currency: position.currency,
            local_symbol: position.local_symbol,
            trading_class: position.trading_class,
            last_trade_date_or_contract_month: position.last_trade_date_or_contract_month,
            multiplier: position.multiplier,
            current_price: position.current_price,
            current_price_stale: Boolean(position.quote_stale || responseStale),
            current_price_delayed: position.quote_status === 'DELAYED',
            current_price_received_at: position.quote_received_at || responseTimestamp
        }));
    return Array.from(new Map(suggestions.map((suggestion)=>[
            `${suggestion.symbol}-${suggestion.sec_type}-${suggestion.con_id || suggestion.local_symbol || ''}`,
            suggestion
        ])).values());
};


const $ffade179fa6c9e7c$export$3d7e5f9788c3a86e = ()=>{
    const { data: positionsResponse, refetch: refetch } = (0, $jtEPT.usePositionsQuery)();
    (0, $acw62.useEffect)(()=>{
        const refreshPositions = ()=>{
            refetch();
        };
        window.addEventListener('trading-data-refresh', refreshPositions);
        return ()=>window.removeEventListener('trading-data-refresh', refreshPositions);
    }, [
        refetch
    ]);
    return (0, $acw62.useMemo)(()=>(0, $14f179b2e6a21f03$export$2138299cfd7e961a)(positionsResponse?.data?.positions || [], Boolean(positionsResponse?.data?.stale), positionsResponse?.timestamp), [
        positionsResponse
    ]);
};



var $acw62 = parcelRequire("acw62");
const $33d0b97b7d1aebeb$export$6d11c9454f4c762b = (detail)=>{
    const quantity = Math.floor(Number(detail?.quantity));
    if (!detail?.symbol || detail.action !== 'BUY' && detail.action !== 'SELL' || !Number.isFinite(quantity) || quantity <= 0) return null;
    const symbol = detail.symbol.toUpperCase();
    const secType = (detail.secType || 'STK').toUpperCase();
    const price = Number(detail.price);
    return {
        symbol: symbol,
        secType: secType,
        action: detail.action,
        quantity: String(quantity),
        orderType: detail.orderType || 'MIDPRICE',
        price: Number.isFinite(price) && price > 0 ? price.toFixed(2) : '',
        selectedContract: {
            symbol: symbol,
            sec_type: secType,
            display_symbol: symbol
        }
    };
};


const $7115b704ec70e694$export$864d48651a61907e = ({ onCancelEditing: onCancelEditing, onPreparedOrder: onPreparedOrder })=>{
    (0, $acw62.useEffect)(()=>{
        const handlePreparedNQMMOrder = (event)=>{
            const detail = event.detail;
            if (detail?.openInModal) return;
            const order = (0, $33d0b97b7d1aebeb$export$6d11c9454f4c762b)(detail);
            if (!order) return;
            onCancelEditing?.();
            onPreparedOrder(order);
            window.setTimeout(()=>{
                document.getElementById('manual-order-entry')?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }, 0);
        };
        window.addEventListener('nqmm-prepare-order', handlePreparedNQMMOrder);
        return ()=>window.removeEventListener('nqmm-prepare-order', handlePreparedNQMMOrder);
    }, [
        onCancelEditing,
        onPreparedOrder
    ]);
};



var $acw62 = parcelRequire("acw62");
const $e28d0e2932a9c448$export$38f61b046952d08 = async (symbol, secType, lookup)=>{
    try {
        const response = await lookup({
            symbol: symbol.trim().toUpperCase(),
            sec_type: secType
        });
        const contracts = response?.data?.contracts || [];
        return {
            contracts: contracts,
            error: contracts.length === 0 ? `No ${secType} contracts found for ${symbol.toUpperCase()}.` : null
        };
    } catch (error) {
        const message = error && typeof error === 'object' && 'message' in error ? String(error.message || '') : '';
        return {
            contracts: [],
            error: message || 'Contract lookup failed.'
        };
    }
};



var $2wVnk = parcelRequire("2wVnk");
const $ff613c1f5ccda583$export$650e809fb8b3bf1e = ({ symbol: symbol, secType: secType, setError: setError, setShowDropdown: setShowDropdown })=>{
    const [lookupResults, setLookupResults] = (0, $acw62.useState)([]);
    const [lookupLoading, setLookupLoading] = (0, $acw62.useState)(false);
    const handleLookup = (0, $acw62.useCallback)(async ()=>{
        if (!symbol.trim()) {
            setError('Enter a symbol before lookup.');
            return;
        }
        setLookupLoading(true);
        setError(null);
        setLookupResults([]);
        setShowDropdown(true);
        try {
            const result = await (0, $e28d0e2932a9c448$export$38f61b046952d08)(symbol, secType, (request)=>(0, $2wVnk.tradingApi).lookupOrderContracts(request));
            setLookupResults(result.contracts);
            if (result.error) setError(result.error);
        } finally{
            setLookupLoading(false);
        }
    }, [
        secType,
        setError,
        setShowDropdown,
        symbol
    ]);
    return {
        lookupResults: lookupResults,
        setLookupResults: setLookupResults,
        lookupLoading: lookupLoading,
        handleLookup: handleLookup
    };
};



var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");

var $acw62 = parcelRequire("acw62");
const $ee10d9a55e84bc57$var$normalize = (identifier)=>identifier.trim().toUpperCase();
class $ee10d9a55e84bc57$var$QuoteStore {
    constructor(){
        this.socket = null;
        this.token = null;
        this.sessionKey = null;
        this.reconnectTimer = null;
        this.reconnectAttempts = 0;
        this.disposed = true;
        this.quotes = new Map();
        this.aliasToKey = new Map();
        this.listeners = new Map();
        this.references = new Map();
        this.statusListeners = new Set();
        this.status = 'DISCONNECTED';
        this.brokerConnected = false;
        this.version = 0;
        this.pendingListeners = new Set();
        this.notificationTimer = null;
        this.lastMessageAt = 0;
        this.getStatus = ()=>this.status;
        this.getVersion = ()=>this.version;
        if (typeof window !== 'undefined') {
            const handleWake = ()=>this.handleWakeup();
            document.addEventListener('visibilitychange', handleWake);
            window.addEventListener('focus', handleWake);
            window.addEventListener('online', handleWake);
        }
    }
    handleWakeup() {
        if (this.disposed || !this.token) return;
        if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
        const now = Date.now();
        // A socket claiming to be OPEN with no messages for > 15s is likely a dead zombie connection frozen by the mobile OS.
        const isZombie = this.socket?.readyState === WebSocket.OPEN && this.lastMessageAt > 0 && now - this.lastMessageAt > 15000;
        const isSocketDown = !this.socket || this.socket.readyState === WebSocket.CLOSING || this.socket.readyState === WebSocket.CLOSED || isZombie;
        if (isSocketDown) {
            if (this.reconnectTimer !== null) {
                window.clearTimeout(this.reconnectTimer);
                this.reconnectTimer = null;
            }
            this.reconnectAttempts = 0;
            if (this.socket) {
                try {
                    this.socket.onclose = null;
                    this.socket.onerror = null;
                    this.socket.onmessage = null;
                    this.socket.close();
                } catch  {
                // ignore
                }
                this.socket = null;
            }
            this.connect();
        } else if (this.socket?.readyState === WebSocket.OPEN) {
            if (this.references.size > 0) this.send('subscribe', [
                ...this.references.keys()
            ]);
            this.refreshStaleness();
        }
    }
    configure(token, sessionKey) {
        if (this.token === token && this.sessionKey === sessionKey) return;
        this.disconnect(true);
        this.token = token;
        this.sessionKey = sessionKey;
        if (token && sessionKey) {
            this.disposed = false;
            this.connect();
        }
    }
    subscribe(identifier, listener) {
        const alias = $ee10d9a55e84bc57$var$normalize(identifier);
        if (!alias) return ()=>undefined;
        const listeners = this.listeners.get(alias) ?? new Set();
        listeners.add(listener);
        this.listeners.set(alias, listeners);
        const count = (this.references.get(alias) ?? 0) + 1;
        this.references.set(alias, count);
        if (count === 1 && this.socket?.readyState === WebSocket.OPEN) this.send('subscribe', [
            identifier
        ]);
        return ()=>{
            const current = this.listeners.get(alias);
            current?.delete(listener);
            if (current?.size === 0) this.listeners.delete(alias);
            const nextCount = Math.max(0, (this.references.get(alias) ?? 1) - 1);
            if (nextCount === 0) {
                this.references.delete(alias);
                if (this.socket?.readyState === WebSocket.OPEN) this.send('unsubscribe', [
                    identifier
                ]);
            } else this.references.set(alias, nextCount);
        };
    }
    getQuote(identifier) {
        const alias = $ee10d9a55e84bc57$var$normalize(identifier);
        const key = this.aliasToKey.get(alias) ?? alias.toLowerCase();
        return this.quotes.get(key) ?? this.quotes.get(alias) ?? null;
    }
    subscribeStatus(listener) {
        this.statusListeners.add(listener);
        return ()=>this.statusListeners.delete(listener);
    }
    clear() {
        if (this.notificationTimer !== null) window.clearTimeout(this.notificationTimer);
        this.notificationTimer = null;
        this.pendingListeners.clear();
        this.quotes.clear();
        this.aliasToKey.clear();
        this.version += 1;
        this.emitAll();
    }
    connect() {
        if (this.disposed || !this.token) return;
        this.setStatus('CONNECTING');
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        this.socket = new WebSocket(`${protocol}//${window.location.host}/api/v1/market/ws`, [
            'access_token',
            this.token
        ]);
        this.socket.onopen = ()=>{
            this.reconnectAttempts = 0;
            this.lastMessageAt = Date.now();
            // The browser socket is only the transport. Wait for the server's broker
            // status before presenting retained quotes as live market data.
            this.brokerConnected = false;
            this.setStatus('CONNECTING');
            this.send('subscribe', [
                ...this.references.keys()
            ]);
        };
        this.socket.onmessage = (event)=>this.handleMessage(event.data);
        this.socket.onclose = (event)=>{
            this.socket = null;
            this.brokerConnected = false;
            this.setStatus('DISCONNECTED');
            this.refreshStaleness();
            if (this.disposed || event.code === 4401 || event.code === 4403) return;
            this.reconnectAttempts += 1;
            const isHidden = typeof document !== 'undefined' && document.visibilityState === 'hidden';
            const delay = isHidden ? 30000 : Math.min(15000, 500 * 2 ** Math.min(this.reconnectAttempts, 5));
            this.reconnectTimer = window.setTimeout(()=>this.connect(), delay);
        };
    }
    handleMessage(raw) {
        this.lastMessageAt = Date.now();
        let message;
        try {
            message = JSON.parse(raw);
        } catch  {
            return;
        }
        if (message.type === 'connection.status' || message.type === 'heartbeat') {
            const connected = message.status === 'CONNECTED';
            if (connected && !this.brokerConnected) this.send('subscribe', [
                ...this.references.keys()
            ]);
            this.brokerConnected = connected;
            this.setStatus(connected ? 'CONNECTED' : 'DISCONNECTED');
            this.refreshStaleness();
            return;
        }
        if (message.type !== 'quote.updated' || !message.quote?.contract_key) return;
        const incomingQuote = message.quote;
        const quote = this.brokerConnected ? incomingQuote : {
            ...incomingQuote,
            stale: true
        };
        const previous = this.quotes.get(quote.contract_key);
        if (previous && previous.sequence >= quote.sequence) return;
        this.quotes.set(quote.contract_key, quote);
        this.version += 1;
        const aliases = [
            quote.contract_key,
            quote.symbol,
            quote.local_symbol,
            quote.con_id ? `conid:${quote.con_id}` : null
        ].filter(Boolean).map((value)=>$ee10d9a55e84bc57$var$normalize(String(value)));
        for (const alias of aliases)this.aliasToKey.set(alias, quote.contract_key);
        const notified = new Set();
        for (const alias of aliases)for (const listener of this.listeners.get(alias) ?? [])notified.add(listener);
        this.scheduleListeners(notified);
    }
    send(action, contracts) {
        if (contracts.length && this.socket?.readyState === WebSocket.OPEN) this.socket.send(JSON.stringify({
            action: action,
            contracts: contracts
        }));
    }
    refreshStaleness() {
        let changed = false;
        const now = Date.now();
        for (const [key, quote] of this.quotes){
            const timestamp = quote.exchange_time || quote.received_at;
            const observedAt = timestamp ? Date.parse(timestamp) : Number.NaN;
            const stale = !this.brokerConnected || quote.stale || !Number.isFinite(observedAt) || (now - observedAt) / 1000 > (quote.stale_after_seconds ?? 60);
            if (stale !== quote.stale) {
                this.quotes.set(key, {
                    ...quote,
                    stale: stale
                });
                changed = true;
            }
        }
        if (changed) {
            this.version += 1;
            this.emitAll();
        }
    }
    disconnect(clearQuotes) {
        this.disposed = true;
        if (this.reconnectTimer !== null) window.clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
        if (this.socket) {
            // Prevent a late close/message from an old tenant socket scheduling a
            // reconnect after a managed-user switch.
            this.socket.onclose = null;
            this.socket.onmessage = null;
            this.socket.close();
        }
        this.socket = null;
        this.brokerConnected = false;
        this.setStatus('DISCONNECTED');
        if (clearQuotes) this.clear();
    }
    setStatus(status) {
        if (this.status === status) return;
        this.status = status;
        for (const listener of this.statusListeners)listener();
    }
    emitAll() {
        const listeners = new Set([
            ...this.listeners.values()
        ].flatMap((set)=>[
                ...set
            ]));
        for (const listener of listeners)listener();
    }
    scheduleListeners(listeners) {
        for (const listener of listeners)this.pendingListeners.add(listener);
        if (this.notificationTimer !== null) return;
        const delay = document.visibilityState === 'hidden' ? 500 : 100;
        this.notificationTimer = window.setTimeout(()=>{
            this.notificationTimer = null;
            const pending = [
                ...this.pendingListeners
            ];
            this.pendingListeners.clear();
            for (const listener of pending)listener();
        }, delay);
    }
}
const $ee10d9a55e84bc57$export$51b87650e98265a6 = new $ee10d9a55e84bc57$var$QuoteStore();
const $ee10d9a55e84bc57$export$79ae38ef14e32131 = (identifier)=>{
    const target = identifier ? $ee10d9a55e84bc57$var$normalize(identifier) : '';
    const subscribe = (0, $acw62.useCallback)((listener)=>target ? $ee10d9a55e84bc57$export$51b87650e98265a6.subscribe(target, listener) : ()=>undefined, [
        target
    ]);
    const getSnapshot = (0, $acw62.useCallback)(()=>target ? $ee10d9a55e84bc57$export$51b87650e98265a6.getQuote(target) : null, [
        target
    ]);
    return (0, $acw62.useSyncExternalStore)(subscribe, getSnapshot, ()=>null);
};
const $ee10d9a55e84bc57$export$2341ff61511dbf4b = ()=>(0, $acw62.useSyncExternalStore)((listener)=>$ee10d9a55e84bc57$export$51b87650e98265a6.subscribeStatus(listener), $ee10d9a55e84bc57$export$51b87650e98265a6.getStatus, ()=>'DISCONNECTED');
const $ee10d9a55e84bc57$export$d969c99f03d34b97 = (identifiers)=>{
    const subscriptionKey = identifiers.filter(Boolean).map((value)=>$ee10d9a55e84bc57$var$normalize(String(value))).sort().join('\u0000');
    const targets = (0, $acw62.useMemo)(()=>subscriptionKey ? subscriptionKey.split('\u0000') : [], [
        subscriptionKey
    ]);
    const subscribe = (0, $acw62.useCallback)((listener)=>{
        const unsubscribe = targets.map((target)=>$ee10d9a55e84bc57$export$51b87650e98265a6.subscribe(target, listener));
        return ()=>unsubscribe.forEach((dispose)=>dispose());
    }, [
        targets
    ]);
    (0, $acw62.useSyncExternalStore)(subscribe, $ee10d9a55e84bc57$export$51b87650e98265a6.getVersion, ()=>0);
    return Object.fromEntries(targets.map((target)=>[
            target,
            $ee10d9a55e84bc57$export$51b87650e98265a6.getQuote(target)
        ]));
};



var $77e7m = parcelRequire("77e7m");

const $ba37f960dfb9eb65$export$bea0108ed1159fea = (input)=>{
    if (input.editingOrder && input.unsupportedOrderType) return `IB order type ${input.unsupportedOrderType} cannot be edited safely from this form.`;
    const quantity = parseInt(input.quantity);
    if (!input.symbol || isNaN(quantity) || quantity <= 0) return 'Valid quantity (minimum 1) is required';
    if ([
        'LIMIT',
        'MIDPRICE',
        'STOP'
    ].includes(input.orderType) && (!input.price || parseFloat(input.price) <= 0)) return input.orderType === 'MIDPRICE' ? 'A positive price cap is required for MIDPRICE orders' : `Valid price is required for ${input.orderType} orders`;
    if (input.orderType === 'MARKET' && input.tif === 'GTC') return 'GTC is only available for limit and stop orders.';
    if (input.orderType === 'MARKET' && input.outsideRth) return 'Outside RTH is only available for limit and stop orders.';
    if (input.orderType === 'TRAIL' && (!input.trailingAmount || parseFloat(input.trailingAmount) <= 0)) return 'A valid trailing amount or percent is required for TRAIL orders.';
    return null;
};
const $ba37f960dfb9eb65$export$540f99b4ded10cc = (contract, inputSymbol)=>{
    if (!contract || !inputSymbol) return false;
    const normalizedInput = inputSymbol.toUpperCase();
    return [
        contract.symbol,
        contract.local_symbol,
        contract.display_symbol
    ].filter(Boolean).some((value)=>String(value).toUpperCase() === normalizedInput);
};
const $ba37f960dfb9eb65$export$23c8c83a87ff6bb9 = (orderType, price, trailingAmount, trailType)=>({
        price: [
            'LIMIT',
            'MIDPRICE',
            'STOP'
        ].includes(orderType) ? parseFloat(parseFloat(price).toFixed(2)) : undefined,
        trailing_amount: orderType === 'TRAIL' && trailType === 'amount' ? parseFloat(parseFloat(trailingAmount).toFixed(2)) : undefined,
        trailing_percent: orderType === 'TRAIL' && trailType === 'percent' ? parseFloat(parseFloat(trailingAmount).toFixed(2)) : undefined
    });
const $ba37f960dfb9eb65$export$6faa45e965c294d8 = (input, selectedContract)=>{
    const activeContract = $ba37f960dfb9eb65$export$540f99b4ded10cc(selectedContract, input.symbol) ? selectedContract : null;
    const orderSymbol = activeContract?.symbol.toUpperCase() ?? input.symbol.toUpperCase();
    return {
        symbol: orderSymbol,
        action: input.action,
        quantity: input.quantity,
        order_type: input.orderType,
        ...input.priceFields,
        sec_type: input.secType,
        strategy_name: input.strategyName,
        tif: input.tif,
        outside_rth: input.outsideRth,
        ...activeContract ? {
            con_id: activeContract.con_id ?? undefined,
            exchange: activeContract.exchange ?? undefined,
            currency: activeContract.currency ?? undefined,
            last_trade_date_or_contract_month: activeContract.last_trade_date_or_contract_month ?? undefined,
            local_symbol: activeContract.local_symbol ?? undefined,
            trading_class: activeContract.trading_class ?? undefined,
            multiplier: activeContract.multiplier ?? undefined
        } : {}
    };
};


const $2eee7ed1648bd500$export$8907da9d2a74bdf7 = (quote)=>{
    if (!quote) return null;
    const value = quote.price ?? quote.last ?? quote.close;
    return value !== undefined && value !== null && !Number.isNaN(Number(value)) ? Number(value) : null;
};


const $ad549e6a5a2c9401$export$9b9361be1628b06 = ({ symbol: symbol, secType: secType, selectedContract: selectedContract })=>{
    const [marketPrice, setMarketPrice] = (0, $acw62.useState)(null);
    const [marketPriceQuote, setMarketPriceQuote] = (0, $acw62.useState)(null);
    const [fetchingPrice, setFetchingPrice] = (0, $acw62.useState)(false);
    const liveQuoteIdentifier = selectedContract?.con_id ? `conid:${selectedContract.con_id}` : selectedContract?.symbol || symbol || null;
    const liveQuote = (0, $ee10d9a55e84bc57$export$79ae38ef14e32131)(liveQuoteIdentifier);
    const quoteConnectionStatus = (0, $ee10d9a55e84bc57$export$2341ff61511dbf4b)();
    const displayedMarketQuote = liveQuote || marketPriceQuote;
    const marketPricePresentation = (0, $77e7m.getPricePresentation)({
        quote: displayedMarketQuote,
        connectionStatus: quoteConnectionStatus,
        hasPrice: marketPrice !== null,
        streamed: Boolean(liveQuote)
    });
    const clearQuote = (0, $acw62.useCallback)(()=>{
        setMarketPrice(null);
        setMarketPriceQuote(null);
    }, []);
    const setQuoteSnapshot = (0, $acw62.useCallback)((price, quote)=>{
        setMarketPrice(price);
        setMarketPriceQuote(quote);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!liveQuote || !Number.isFinite(Number(liveQuote.price))) return;
        setMarketPrice(Number(liveQuote.price));
        setMarketPriceQuote(liveQuote);
        setFetchingPrice(false);
    }, [
        liveQuote
    ]);
    const fetchQuote = (0, $acw62.useCallback)(async (targetSymbols)=>{
        const symbols = (Array.isArray(targetSymbols) ? targetSymbols : [
            targetSymbols
        ]).map((value)=>String(value || '').trim().toUpperCase()).filter(Boolean);
        const uniqueSymbols = Array.from(new Set(symbols));
        if (uniqueSymbols.length === 0) {
            clearQuote();
            return;
        }
        setFetchingPrice(true);
        try {
            const response = await (0, $2wVnk.tradingApi).getQuotes(uniqueSymbols);
            const quotes = response.data;
            if (response.success && quotes) {
                const quote = uniqueSymbols.map((candidate)=>quotes[candidate]).find(Boolean);
                const quotePrice = (0, $2eee7ed1648bd500$export$8907da9d2a74bdf7)(quote);
                if (quotePrice !== null) setQuoteSnapshot(quotePrice, quote);
            }
        } catch (error) {
            console.warn('Failed to fetch quote:', error);
        } finally{
            setFetchingPrice(false);
        }
    }, [
        clearQuote,
        setQuoteSnapshot
    ]);
    const fetchContractQuote = (0, $acw62.useCallback)(async (contract, preferLive = false)=>{
        if (!contract.symbol) return;
        setFetchingPrice(true);
        try {
            const response = await (0, $2wVnk.tradingApi).getContractQuote({
                symbol: contract.symbol.toUpperCase(),
                sec_type: contract.sec_type || secType,
                con_id: contract.con_id ?? undefined,
                exchange: contract.exchange ?? undefined,
                currency: contract.currency ?? undefined,
                last_trade_date_or_contract_month: contract.last_trade_date_or_contract_month ?? undefined,
                local_symbol: contract.local_symbol ?? undefined,
                trading_class: contract.trading_class ?? undefined,
                multiplier: contract.multiplier ?? undefined,
                prefer_live: preferLive
            });
            if (response.success && response.data) {
                const quotePrice = (0, $2eee7ed1648bd500$export$8907da9d2a74bdf7)(response.data);
                if (quotePrice !== null) setQuoteSnapshot(quotePrice, response.data);
            }
        } catch (error) {
            console.warn('Failed to fetch contract quote:', error);
        } finally{
            setFetchingPrice(false);
        }
    }, [
        secType,
        setQuoteSnapshot
    ]);
    (0, $acw62.useEffect)(()=>{
        const timer = window.setTimeout(()=>{
            if (!symbol) return;
            const quoteSymbol = (0, $ba37f960dfb9eb65$export$540f99b4ded10cc)(selectedContract, symbol) ? selectedContract : symbol;
            if (!quoteSymbol) return;
            if (typeof quoteSymbol === 'string') {
                if (secType === 'FUT') return;
                fetchQuote(quoteSymbol);
            } else if ((0, $6408cf3508cbf4a0$export$70d034a749d428df)(quoteSymbol)) fetchContractQuote(quoteSymbol, (0, $6408cf3508cbf4a0$export$4aaaaf2ad7363269)(quoteSymbol));
            else fetchQuote(quoteSymbol.symbol || '');
        }, 800);
        return ()=>window.clearTimeout(timer);
    }, [
        symbol,
        secType,
        selectedContract,
        fetchContractQuote,
        fetchQuote
    ]);
    const refreshSelectedQuote = (0, $acw62.useCallback)(()=>{
        if ((0, $ba37f960dfb9eb65$export$540f99b4ded10cc)(selectedContract, symbol) && selectedContract) {
            if ((0, $6408cf3508cbf4a0$export$70d034a749d428df)(selectedContract)) {
                fetchContractQuote(selectedContract, (0, $6408cf3508cbf4a0$export$4aaaaf2ad7363269)(selectedContract));
                return;
            }
        }
        if (secType === 'FUT') return;
        fetchQuote(symbol);
    }, [
        selectedContract,
        symbol,
        fetchContractQuote,
        secType,
        fetchQuote
    ]);
    return {
        marketPrice: marketPrice,
        setMarketPrice: setMarketPrice,
        fetchingPrice: fetchingPrice,
        marketPricePresentation: marketPricePresentation,
        clearQuote: clearQuote,
        setQuoteSnapshot: setQuoteSnapshot,
        fetchQuote: fetchQuote,
        fetchContractQuote: fetchContractQuote,
        refreshSelectedQuote: refreshSelectedQuote
    };
};



var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");

function $4eada04359c34249$export$1b44b7b960ace4db({ editingOrder: editingOrder, unsupportedOrderType: unsupportedOrderType, symbol: symbol, action: action, quantity: quantity, orderType: orderType, price: price, trailingAmount: trailingAmount, trailType: trailType, tif: tif, outsideRth: outsideRth, secType: secType, strategyName: strategyName, selectedContract: selectedContract, setLoading: setLoading, setError: setError, setSuccess: setSuccess, resetForm: resetForm, onOrderModified: onOrderModified, onOrderSubmitted: onOrderSubmitted }) {
    return (0, $acw62.useCallback)(async ()=>{
        const validationError = (0, $ba37f960dfb9eb65$export$bea0108ed1159fea)({
            editingOrder: Boolean(editingOrder),
            unsupportedOrderType: unsupportedOrderType,
            symbol: symbol,
            quantity: quantity,
            orderType: orderType,
            price: price,
            tif: tif,
            outsideRth: outsideRth,
            trailingAmount: trailingAmount
        });
        if (validationError) {
            setError(validationError);
            return;
        }
        const qtyNum = parseInt(quantity);
        setLoading(true);
        setError(null);
        setSuccess(null);
        try {
            const priceFields = (0, $ba37f960dfb9eb65$export$23c8c83a87ff6bb9)(orderType, price, trailingAmount, trailType);
            if (editingOrder) {
                const res = await (0, $2wVnk.tradingApi).modifyOrder(editingOrder.order_id, {
                    action: action,
                    quantity: qtyNum,
                    order_type: orderType,
                    ...priceFields,
                    tif: tif,
                    outside_rth: outsideRth
                });
                setSuccess(res.message || `Order ${editingOrder.order_id} modification submitted.`);
                window.dispatchEvent(new CustomEvent('trading-data-refresh'));
                resetForm();
                onOrderModified?.();
                return;
            }
            const orderPayload = (0, $ba37f960dfb9eb65$export$6faa45e965c294d8)({
                symbol: symbol,
                action: action,
                quantity: qtyNum,
                orderType: orderType,
                priceFields: priceFields,
                secType: secType,
                strategyName: strategyName,
                tif: tif,
                outsideRth: outsideRth
            }, selectedContract);
            const res = await (0, $2wVnk.tradingApi).placeOrder(orderPayload);
            setSuccess(res.message || `${action} order for ${quantity} ${orderPayload.symbol} placed successfully.`);
            window.dispatchEvent(new CustomEvent('trading-data-refresh'));
            resetForm();
            onOrderSubmitted?.();
        } catch (err) {
            console.warn(err);
            setError(err.message || 'Failed to place order.');
        } finally{
            setLoading(false);
        }
    }, [
        action,
        editingOrder,
        onOrderModified,
        onOrderSubmitted,
        outsideRth,
        orderType,
        price,
        quantity,
        resetForm,
        secType,
        selectedContract,
        setError,
        setLoading,
        setSuccess,
        strategyName,
        tif,
        trailingAmount,
        trailType,
        symbol,
        unsupportedOrderType
    ]);
}


const $1b6f36562471e94f$var$ManualOrderEntry = ({ editingOrder: editingOrder = null, prefillOrder: prefillOrder = null, preparedNQMMOrder: preparedNQMMOrder = null, onCancelEditing: onCancelEditing, onCancel: onCancel, onOrderModified: onOrderModified, onOrderSubmitted: onOrderSubmitted, showCancelButton: showCancelButton = false, inModal: inModal = false })=>{
    const [symbol, setSymbol] = (0, $acw62.useState)('');
    const [secType, setSecType] = (0, $acw62.useState)('STK');
    const [strategyName, setStrategyName] = (0, $acw62.useState)('MANUAL');
    const [action, setAction] = (0, $acw62.useState)('BUY');
    const [orderType, setOrderType] = (0, $acw62.useState)('MARKET');
    const [tif, setTif] = (0, $acw62.useState)('DAY');
    const [outsideRth, setOutsideRth] = (0, $acw62.useState)(false);
    const [price, setPrice] = (0, $acw62.useState)('');
    const [trailingAmount, setTrailingAmount] = (0, $acw62.useState)('');
    const [trailType, setTrailType] = (0, $acw62.useState)('amount');
    const [quantity, setQuantity] = (0, $acw62.useState)('1');
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [success, setSuccess] = (0, $acw62.useState)(null);
    const [unsupportedOrderType, setUnsupportedOrderType] = (0, $acw62.useState)(null);
    const [showDropdown, setShowDropdown] = (0, $acw62.useState)(false);
    const [selectedContract, setSelectedContract] = (0, $acw62.useState)(null);
    const initialOrderTypeEffect = (0, $acw62.useRef)(true);
    const { lookupResults: lookupResults, setLookupResults: setLookupResults, lookupLoading: lookupLoading, handleLookup: handleLookup } = (0, $ff613c1f5ccda583$export$650e809fb8b3bf1e)({
        symbol: symbol,
        secType: secType,
        setError: setError,
        setShowDropdown: setShowDropdown
    });
    const { marketPrice: marketPrice, fetchingPrice: fetchingPrice, marketPricePresentation: marketPricePresentation, clearQuote: clearQuote, setQuoteSnapshot: setQuoteSnapshot, fetchQuote: fetchQuote, fetchContractQuote: fetchContractQuote, refreshSelectedQuote: refreshSelectedQuote } = (0, $ad549e6a5a2c9401$export$9b9361be1628b06)({
        symbol: symbol,
        secType: secType,
        selectedContract: selectedContract
    });
    const positionSuggestions = (0, $ffade179fa6c9e7c$export$3d7e5f9788c3a86e)();
    const resetForm = (0, $acw62.useCallback)(()=>{
        setSymbol('');
        setSecType('STK');
        setStrategyName('MANUAL');
        setAction('BUY');
        setOrderType('MARKET');
        setTif('DAY');
        setOutsideRth(false);
        setQuantity('1');
        setPrice('');
        setTrailingAmount('');
        setTrailType('amount');
        setUnsupportedOrderType(null);
        clearQuote();
        setSelectedContract(null);
        setLookupResults([]);
        setShowDropdown(false);
    }, [
        clearQuote,
        setLookupResults
    ]);
    (0, $acw62.useEffect)(()=>{
        const orderToPrefill = editingOrder || prefillOrder;
        if (!orderToPrefill) {
            setUnsupportedOrderType(null);
            return;
        }
        const prefillState = (0, $dd32f7c191d7a5c5$export$50b86ba32e7259b5)(orderToPrefill, Boolean(editingOrder));
        setSymbol(prefillState.symbol);
        setSecType(prefillState.secType);
        setAction(prefillState.action);
        setStrategyName(prefillState.strategyName);
        setOrderType(prefillState.orderType);
        setUnsupportedOrderType(prefillState.unsupportedOrderType);
        setTif(prefillState.tif);
        setOutsideRth(prefillState.outsideRth);
        setQuantity(prefillState.quantity);
        setPrice(prefillState.price);
        setTrailType(prefillState.trailType);
        setTrailingAmount(prefillState.trailingAmount);
        clearQuote();
        setSelectedContract(prefillState.selectedContract);
        setLookupResults([]);
        setShowDropdown(false);
        setError(prefillState.error);
        setSuccess(null);
    }, [
        editingOrder,
        prefillOrder,
        clearQuote,
        setLookupResults
    ]);
    const applyPreparedNQMMOrder = (0, $acw62.useCallback)((prepared)=>{
        setSymbol(prepared.symbol);
        setSecType(prepared.secType);
        setStrategyName('NQMM');
        setAction(prepared.action);
        setOrderType(prepared.orderType);
        setTif('DAY');
        setOutsideRth(false);
        setQuantity(prepared.quantity);
        setPrice(prepared.price);
        setTrailingAmount('');
        setUnsupportedOrderType(null);
        setSelectedContract(prepared.selectedContract);
        setLookupResults([]);
        setShowDropdown(false);
        setError(null);
        setSuccess(null);
    }, [
        setLookupResults
    ]);
    (0, $acw62.useEffect)(()=>{
        if (preparedNQMMOrder) applyPreparedNQMMOrder(preparedNQMMOrder);
    }, [
        applyPreparedNQMMOrder,
        preparedNQMMOrder
    ]);
    (0, $7115b704ec70e694$export$864d48651a61907e)({
        onCancelEditing: onCancelEditing,
        onPreparedOrder: applyPreparedNQMMOrder
    });
    (0, $acw62.useEffect)(()=>{
        if (initialOrderTypeEffect.current) {
            initialOrderTypeEffect.current = false;
            return;
        }
        if (orderType === 'MARKET') {
            setPrice('');
            setTrailingAmount('');
        } else if (orderType !== 'TRAIL') setTrailingAmount('');
        else setPrice('');
    }, [
        orderType
    ]);
    // Use the latest usable quote as a starting price for price-based orders.
    // The field remains editable, so this is only a convenience default.
    (0, $acw62.useEffect)(()=>{
        if (![
            'LIMIT',
            'MIDPRICE',
            'STOP'
        ].includes(orderType)) return;
        if (price || marketPrice === null || !marketPricePresentation.usableForPricing) return;
        setPrice(marketPrice.toFixed(2));
    }, [
        marketPrice,
        marketPricePresentation.usableForPricing,
        orderType,
        price
    ]);
    // Auto-clear error messages after 8 seconds
    (0, $acw62.useEffect)(()=>{
        if (error) {
            const timer = setTimeout(()=>setError(null), 8000);
            return ()=>clearTimeout(timer);
        }
    }, [
        error
    ]);
    // Auto-clear success messages after 5 seconds
    (0, $acw62.useEffect)(()=>{
        if (success) {
            const timer = setTimeout(()=>setSuccess(null), 5000);
            return ()=>clearTimeout(timer);
        }
    }, [
        success
    ]);
    const applyContractSelection = (0, $acw62.useCallback)((contract)=>{
        setSymbol((contract.local_symbol || contract.symbol || '').toUpperCase());
        if (contract.sec_type) setSecType(contract.sec_type.toUpperCase());
        setPrice('');
        setSelectedContract(contract);
        setLookupResults([]);
        setShowDropdown(false);
        clearQuote();
        if (contract.current_price !== undefined && contract.current_price !== null) setQuoteSnapshot(Number(contract.current_price), {
            price: Number(contract.current_price),
            stale: Boolean(contract.current_price_stale),
            delayed: Boolean(contract.current_price_delayed) || (0, $6408cf3508cbf4a0$export$4aaaaf2ad7363269)(contract),
            received_at: contract.current_price_received_at
        });
        if ((0, $6408cf3508cbf4a0$export$70d034a749d428df)(contract)) fetchContractQuote(contract, (0, $6408cf3508cbf4a0$export$4aaaaf2ad7363269)(contract));
        else fetchQuote(contract.symbol || '');
    }, [
        clearQuote,
        fetchContractQuote,
        fetchQuote,
        setLookupResults,
        setQuoteSnapshot
    ]);
    const handleSnap = ()=>{
        if (marketPrice !== null && marketPricePresentation.usableForPricing) setPrice(marketPrice.toFixed(2));
    };
    const handleFormSubmit = (e)=>{
        e.preventDefault();
    };
    const handlePlaceOrderClick = (0, $4eada04359c34249$export$1b44b7b960ace4db)({
        editingOrder: editingOrder,
        unsupportedOrderType: unsupportedOrderType,
        symbol: symbol,
        action: action,
        quantity: quantity,
        orderType: orderType,
        price: price,
        trailingAmount: trailingAmount,
        trailType: trailType,
        tif: tif,
        outsideRth: outsideRth,
        secType: secType,
        strategyName: strategyName,
        selectedContract: selectedContract,
        setLoading: setLoading,
        setError: setError,
        setSuccess: setSuccess,
        resetForm: resetForm,
        onOrderModified: onOrderModified,
        onOrderSubmitted: onOrderSubmitted
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: inModal ? undefined : 'manual-order-entry',
        className: `panel w-full ${inModal ? 'modal-form-shell' : 'full-bleed-panel lg:h-full'}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px-6 py-5 border-b border-white/10",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `p-2 rounded-lg ${editingOrder ? 'bg-warning-500/10 text-warning-500' : 'bg-neon/10 text-neon'}`,
                                children: editingOrder ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00b4789eeda33397$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 fill-current"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "space-y-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "text-lg font-bold text-white tracking-tight",
                                        children: editingOrder ? 'Modify Order' : prefillOrder ? 'Close Position' : 'Manual Order'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-xs text-muted",
                                        children: editingOrder ? `Editing open order #${editingOrder.order_id}` : prefillOrder ? 'Review the closing order before sending it to IB' : 'Discretionary trade execution via IB'
                                    })
                                ]
                            })
                        ]
                    }),
                    editingOrder && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt-4 rounded-lg border border-warning-500/25 bg-warning-500/10 px-3 py-2 text-[11px] text-warning-500",
                        children: "Update the current IB order, then submit the modification. The instrument stays locked to this order."
                    }),
                    unsupportedOrderType && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-2 rounded-lg border border-error-500/25 bg-error-500/10 px-3 py-2 text-[11px] text-error-500",
                        children: [
                            "This order is ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-mono font-semibold",
                                children: unsupportedOrderType
                            }),
                            ", which this editor does not support. Cancel editing and use IBKR/TWS so the order type and protective price are preserved."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleFormSubmit,
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30c45b9c908c726d$export$2e2bcd8739ae039), {
                            symbol: symbol,
                            secType: secType,
                            isEditing: Boolean(editingOrder),
                            positionSuggestions: positionSuggestions,
                            lookupResults: lookupResults,
                            lookupLoading: lookupLoading,
                            showDropdown: showDropdown,
                            selectedContract: selectedContract,
                            marketPrice: marketPrice,
                            fetchingPrice: fetchingPrice,
                            pricePresentation: marketPricePresentation,
                            onSymbolChange: (nextSymbol)=>{
                                setSymbol(nextSymbol);
                                setSelectedContract(null);
                                setLookupResults([]);
                                clearQuote();
                                setPrice('');
                                if (!showDropdown) setShowDropdown(true);
                            },
                            onSymbolFocus: ()=>{
                                setError(null);
                                setShowDropdown(true);
                            },
                            onSymbolBlur: ()=>{
                                // Delay to allow clicking dropdown items.
                                setTimeout(()=>setShowDropdown(false), 200);
                            },
                            onSecTypeChange: (value)=>{
                                setSecType(value);
                                setSelectedContract(null);
                                setLookupResults([]);
                                clearQuote();
                                setPrice('');
                            },
                            onLookup: handleLookup,
                            onSelectContract: applyContractSelection,
                            onRefreshQuote: refreshSelectedQuote
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $556904b36e690e02$export$2e2bcd8739ae039), {
                            action: action,
                            quantity: quantity,
                            onActionChange: setAction,
                            onQuantityChange: setQuantity
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb20553c6c616bbe$export$2e2bcd8739ae039), {
                            orderType: orderType,
                            price: price,
                            trailingAmount: trailingAmount,
                            trailType: trailType,
                            action: action,
                            marketPrice: marketPrice,
                            fetchingPrice: fetchingPrice,
                            pricePresentation: marketPricePresentation,
                            currency: selectedContract?.currency || 'USD',
                            onOrderTypeChange: (value)=>{
                                setOrderType(value);
                                if ([
                                    'LIMIT',
                                    'MIDPRICE',
                                    'STOP'
                                ].includes(value) && !price && marketPrice !== null && marketPricePresentation.usableForPricing) setPrice(marketPrice.toFixed(2));
                                if (value === 'MARKET' || value === 'MIDPRICE') {
                                    setTif('DAY');
                                    setOutsideRth(false);
                                }
                            },
                            onPriceChange: setPrice,
                            onTrailingAmountChange: setTrailingAmount,
                            onTrailTypeChange: setTrailType,
                            onRefreshQuote: refreshSelectedQuote,
                            onSnapToMarket: handleSnap
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3492ac59acd2adcc$export$2e2bcd8739ae039), {
                            timeInForce: tif,
                            outsideRegularHours: outsideRth,
                            orderType: orderType,
                            onTimeInForceChange: setTif,
                            onOutsideRegularHoursChange: setOutsideRth
                        }),
                        error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2 text-xs text-error-500 bg-error-500/10 p-2 rounded border border-error-500/20",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dAee.default), {
                                    className: "w-3 h-3 flex-shrink-0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: error
                                })
                            ]
                        }),
                        success && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2 text-xs text-success-500 bg-success-500/10 p-2 rounded border border-success-500/20",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jztMd.default), {
                                    className: "w-3 h-3 flex-shrink-0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: success
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex min-w-0 gap-2",
                            children: [
                                (editingOrder || showCancelButton) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kvv04.ThemeButton), {
                                    variant: "ghost",
                                    size: "xs",
                                    type: "button",
                                    onClick: ()=>{
                                        resetForm();
                                        (onCancel || onCancelEditing)?.();
                                    },
                                    disabled: loading,
                                    "aria-label": "Cancel editing",
                                    className: "min-w-0 flex-1 flex items-center justify-center gap-1.5 uppercase tracking-[0.12em] leading-none",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                            className: "w-3.5 h-3.5 shrink-0"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "truncate",
                                            children: "CANCEL"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeButton), {
                                    variant: action === "BUY" ? "success" : "danger",
                                    size: "md",
                                    type: "button",
                                    onClick: handlePlaceOrderClick,
                                    disabled: loading || Boolean(unsupportedOrderType) || !symbol || !quantity || parseInt(quantity) <= 0,
                                    className: editingOrder || showCancelButton ? "min-w-0 flex-[1.2]" : "w-full",
                                    children: loading ? editingOrder ? 'Updating...' : 'Executing...' : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            editingOrder ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                className: "w-3.5 h-3.5 shrink-0"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84e37213187279fb$export$2e2bcd8739ae039), {
                                                className: "w-3.5 h-3.5 shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "truncate",
                                                children: editingOrder ? `MODIFY ${action}` : `PLACE ${action}`
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $1b6f36562471e94f$export$2e2bcd8739ae039 = $1b6f36562471e94f$var$ManualOrderEntry;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");

var $70wbS = parcelRequire("70wbS");

var $kfC4h = parcelRequire("kfC4h");
const $2e391768795d69b3$var$AccountSwitcher = ({ onContextChange: onContextChange, direction: direction = 'down', align: align = 'right', variant: variant = 'default', showIdentity: showIdentity = false, alwaysRender: alwaysRender = false })=>{
    const { login: login } = (0, $70wbS.useAuth)();
    const [context, setContext] = (0, $acw62.useState)(null);
    const [managedAccounts, setManagedAccounts] = (0, $acw62.useState)([]);
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const dropdownRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        fetchContext();
        fetchManagedAccounts();
    }, []);
    (0, $acw62.useEffect)(()=>{
        const id = window.setInterval(fetchManagedAccounts, 10000);
        return ()=>window.clearInterval(id);
    }, []);
    // Close dropdown when clicking outside
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const fetchContext = async ()=>{
        try {
            const response = await (0, $2wVnk.tradingApi).getCurrentContext();
            if (response.success && response.data) setContext(response.data);
        } catch (err) {
            console.warn('Failed to fetch context:', err);
        }
    };
    const fetchManagedAccounts = async ()=>{
        try {
            const response = await (0, $2wVnk.tradingApi).getManagedAccounts();
            if (response.success && response.data?.managed_accounts) setManagedAccounts(response.data?.managed_accounts);
        } catch (err) {
            console.warn('Failed to fetch managed accounts:', err);
        }
    };
    const handleSwitch = async (accountId)=>{
        setLoading(true);
        try {
            const response = await (0, $2wVnk.tradingApi).switchToManagedAccount(accountId);
            if (response.access_token) {
                login(response.access_token);
                setIsOpen(false);
                await fetchContext();
                if (onContextChange) onContextChange();
                // Reload the page to refresh all data
                window.location.reload();
            }
        } catch (err) {
            console.warn('Failed to switch account:', err);
        } finally{
            setLoading(false);
        }
    };
    const handleSwitchBack = async ()=>{
        setLoading(true);
        try {
            const response = await (0, $2wVnk.tradingApi).switchBackToOwnAccount();
            if (response.access_token) {
                login(response.access_token);
                setIsOpen(false);
                await fetchContext();
                if (onContextChange) onContextChange();
                window.location.reload();
            }
        } catch (err) {
            console.warn('Failed to switch back:', err);
        } finally{
            setLoading(false);
        }
    };
    const canSwitchContext = managedAccounts.length > 0 || !!context?.is_acting_as;
    // Don't render if no managed accounts and not acting as someone
    if (!alwaysRender && !canSwitchContext) return null;
    const displayName = context?.first_name ? `${context.first_name}${context.last_name ? ' ' + context.last_name.charAt(0) + '.' : ''}` : context?.username || 'User';
    const isIdentityCompact = variant === 'compact' && showIdentity;
    const dropdownAlignment = isIdentityCompact ? 'left-0 max-w-[calc(100vw-7.25rem)]' : `max-w-[calc(100vw-2rem)] ${align === 'right' ? 'right-0' : 'left-0'}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `relative ${isIdentityCompact ? 'min-w-0 flex-1 max-w-[190px]' : ''}`,
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                onClick: ()=>{
                    if (canSwitchContext) setIsOpen(!isOpen);
                },
                className: `flex items-center gap-2 rounded-lg transition-colors min-w-0 ${variant === 'compact' ? context?.is_acting_as ? `${isIdentityCompact ? 'h-8 w-full px-2 justify-start' : 'w-7 h-7 justify-center flex-shrink-0'} bg-amber-900/30 border border-amber-600/50 text-amber-300 hover:bg-amber-900/50` : `${isIdentityCompact ? 'h-8 w-full px-2 justify-start' : 'w-7 h-7 justify-center flex-shrink-0'} bg-gray-800 border border-gray-600 text-gray-300 ${canSwitchContext ? 'hover:bg-gray-700' : ''}` : `px-3 py-1.5 border w-full text-left ${context?.is_acting_as ? 'bg-amber-900/30 border-amber-600/50 text-amber-300 hover:bg-amber-900/50' : 'bg-gray-800 border-gray-600 text-gray-300 hover:bg-gray-700'}`}`,
                disabled: loading,
                title: variant === 'compact' ? displayName : undefined,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        className: `flex-shrink-0 ${variant === 'compact' ? 'w-3.5 h-3.5' : 'w-4 h-4'} ${context?.is_acting_as ? 'text-amber-400 shadow-[0_0_8px_rgba(251,191,36,0.4)]' : 'text-neon shadow-[0_0_8px_rgba(var(--neon-rgb),0.3)]'}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        })
                    }),
                    isIdentityCompact && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "min-w-0 flex flex-col items-start justify-center leading-none",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "max-w-full truncate text-[11px] font-bold text-white",
                                children: displayName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfC4h.default), {
                                role: context?.role,
                                compact: true,
                                className: "max-[360px]:hidden"
                            })
                        ]
                    }),
                    variant !== 'compact' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-sm font-medium truncate flex-1 min-w-0",
                                children: displayName
                            }),
                            context?.is_acting_as && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-[10px] px-1 py-0.5 bg-amber-600/30 rounded text-amber-200 whitespace-nowrap flex-shrink-0",
                                children: "Acting As"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                className: `w-4 h-4 transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`,
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M19 9l-7 7-7-7"
                                })
                            })
                        ]
                    }),
                    isIdentityCompact && canSwitchContext && /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        className: `w-3 h-3 transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M19 9l-7 7-7-7"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `absolute w-64 ${dropdownAlignment} bg-gray-800 border border-gray-700 rounded-lg shadow-xl z-50 ${direction === 'up' ? 'bottom-full mb-2' : 'top-full mt-2'}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-3 border-b border-gray-700",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-xs text-gray-500 uppercase tracking-wider",
                                children: "Current Account"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mt-1 flex items-center justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "min-w-0 truncate text-sm font-medium text-gray-200",
                                        title: context?.username,
                                        children: context?.username
                                    }),
                                    context && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfC4h.default), {
                                        role: context.role,
                                        compact: true
                                    })
                                ]
                            }),
                            context?.is_acting_as && context.original_user && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "text-xs text-amber-400 mt-1 truncate",
                                children: [
                                    "Managed by: ",
                                    context.original_user.username
                                ]
                            })
                        ]
                    }),
                    context?.is_acting_as && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: handleSwitchBack,
                        disabled: loading,
                        className: "w-full px-3 py-2 text-left text-sm text-blue-400 hover:bg-gray-700 transition-colors flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                className: "w-4 h-4 flex-shrink-0",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
                                })
                            }),
                            "Switch Back to My Account"
                        ]
                    }),
                    managedAccounts.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "px-3 py-2 border-t border-gray-700",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-xs text-gray-500 uppercase tracking-wider",
                                    children: "Managed Accounts"
                                })
                            }),
                            managedAccounts.map((account)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>handleSwitch(account.id),
                                    disabled: loading || context?.user_id === account.id,
                                    className: `w-full px-3 py-2 text-left text-sm transition-colors flex items-center gap-2 ${context?.user_id === account.id ? 'text-gray-500 cursor-not-allowed' : 'text-gray-300 hover:bg-gray-700'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "w-4 h-4 flex-shrink-0",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "min-w-0 flex-1 truncate",
                                            children: [
                                                account.first_name || account.username,
                                                account.last_name && ` ${account.last_name}`
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfC4h.default), {
                                            role: account.role,
                                            compact: true
                                        }),
                                        context?.user_id === account.id && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "ml-auto text-xs text-gray-600 flex-shrink-0",
                                            children: "(current)"
                                        })
                                    ]
                                }, account.id))
                        ]
                    })
                ]
            })
        ]
    });
};
var $2e391768795d69b3$export$2e2bcd8739ae039 = $2e391768795d69b3$var$AccountSwitcher;



var $kfC4h = parcelRequire("kfC4h");

var $bKJAw = parcelRequire("bKJAw");
var $gjSmI = parcelRequire("gjSmI");
var $a5TAH = parcelRequire("a5TAH");
var $4wROA = parcelRequire("4wROA");
var $gn8IX = parcelRequire("gn8IX");
var $gKB5x = parcelRequire("gKB5x");
var $aqBpg = parcelRequire("aqBpg");
var $i9lAt = parcelRequire("i9lAt");
var $eUAhq = parcelRequire("eUAhq");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $bee7e1f6335e67ab$export$2e2bcd8739ae039 = (0, $b4WUK.default)("House", [
    [
        "path",
        {
            d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
            key: "5wwlr5"
        }
    ],
    [
        "path",
        {
            d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
            key: "1d0kgt"
        }
    ]
]);


var $kwEKL = parcelRequire("kwEKL");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $131c05e6196e399a$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ListChecks", [
    [
        "path",
        {
            d: "m3 17 2 2 4-4",
            key: "1jhpwq"
        }
    ],
    [
        "path",
        {
            d: "m3 7 2 2 4-4",
            key: "1obspn"
        }
    ],
    [
        "path",
        {
            d: "M13 6h8",
            key: "15sg57"
        }
    ],
    [
        "path",
        {
            d: "M13 12h8",
            key: "h98zly"
        }
    ],
    [
        "path",
        {
            d: "M13 18h8",
            key: "oe0vm4"
        }
    ]
]);

/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $5473793717b51056$export$2e2bcd8739ae039 = (0, $b4WUK.default)("LogOut", [
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ],
    [
        "polyline",
        {
            points: "16 17 21 12 16 7",
            key: "1gabdz"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "9",
            y1: "12",
            y2: "12",
            key: "1uyos4"
        }
    ]
]);


var $4mRnX = parcelRequire("4mRnX");
var $iSlX2 = parcelRequire("iSlX2");
var $iIubC = parcelRequire("iIubC");
var $cSGqD = parcelRequire("cSGqD");
var $753mY = parcelRequire("753mY");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $0f45c1e8ae52ad76$export$2e2bcd8739ae039 = (0, $b4WUK.default)("User", [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
]);


var $hPAJY = parcelRequire("hPAJY");

var $2wVnk = parcelRequire("2wVnk");

var $70wbS = parcelRequire("70wbS");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");

var $7dAee = parcelRequire("7dAee");
var $a5TAH = parcelRequire("a5TAH");
var $bbkWX = parcelRequire("bbkWX");
var $jFR94 = parcelRequire("jFR94");
var $iIubC = parcelRequire("iIubC");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $b42daf8f5fabfd7f$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ShoppingBag", [
    [
        "path",
        {
            d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z",
            key: "hou9p0"
        }
    ],
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M16 10a4 4 0 0 1-8 0",
            key: "1ltviw"
        }
    ]
]);


var $hiXj7 = parcelRequire("hiXj7");
var $hPAJY = parcelRequire("hPAJY");

var $k8QNV = parcelRequire("k8QNV");

var $8Zl6K = parcelRequire("8Zl6K");
const $09681d67b125daf0$var$NotificationFeed = ({ onClose: onClose, onUnreadCountChange: onUnreadCountChange })=>{
    const [notifications, setNotifications] = (0, $acw62.useState)([]);
    const [unreadCount, setUnreadCount] = (0, $acw62.useState)(0);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [showSettings, setShowSettings] = (0, $acw62.useState)(false);
    const [preferences, setPreferences] = (0, $acw62.useState)({
        notify_email_signal: false,
        notify_email_fill: true,
        notify_email_error: true,
        notify_email_warning: true,
        notify_email_system: false,
        notify_sound_enabled: true
    });
    const [savingPrefs, setSavingPrefs] = (0, $acw62.useState)(false);
    const [activeFilter, setActiveFilter] = (0, $acw62.useState)('ALL');
    const fetchData = (0, $acw62.useCallback)(async ()=>{
        try {
            const [notifRes, countRes, contextRes] = await Promise.all([
                (0, $2wVnk.tradingApi).getNotifications(50),
                (0, $2wVnk.tradingApi).getUnreadCount(),
                (0, $2wVnk.tradingApi).getCurrentContext()
            ]);
            if (notifRes.success) setNotifications(notifRes.data);
            if (countRes.success) setUnreadCount(countRes.data.count);
            if (contextRes.success && contextRes.data) setPreferences(contextRes.data.preferences);
        } catch (err) {
            console.error('Failed to fetch notifications:', err);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (onUnreadCountChange) onUnreadCountChange(unreadCount);
    }, [
        unreadCount,
        onUnreadCountChange
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchData();
        const interval = setInterval(fetchData, 15000); // Poll every 15s
        return ()=>clearInterval(interval);
    }, [
        fetchData
    ]);
    const handleTogglePref = async (key)=>{
        setSavingPrefs(true);
        const newPrefs = {
            ...preferences,
            [key]: !preferences[key]
        };
        setPreferences(newPrefs); // Optimistic wrap
        try {
            await (0, $2wVnk.tradingApi).updateNotificationPreferences({
                [key]: newPrefs[key]
            });
        } catch  {
            // Revert on error
            setPreferences(preferences);
        } finally{
            setSavingPrefs(false);
        }
    };
    const handleMarkRead = async (id)=>{
        try {
            const res = await (0, $2wVnk.tradingApi).markNotificationRead(id);
            if (res.success) {
                setNotifications((prev)=>prev.map((n)=>n.id === id ? {
                            ...n,
                            is_read: true
                        } : n));
                setUnreadCount((prev)=>Math.max(0, prev - 1));
            }
        } catch (err) {
            console.error('Failed to mark notification as read:', err);
        }
    };
    const handleMarkAllRead = async ()=>{
        try {
            const res = await (0, $2wVnk.tradingApi).markAllRead();
            if (res.success) {
                setNotifications((prev)=>prev.map((n)=>({
                            ...n,
                            is_read: true
                        })));
                setUnreadCount(0);
            }
        } catch (err) {
            console.error('Failed to mark all as read:', err);
        }
    };
    const getIcon = (type)=>{
        switch(type){
            case 'SIGNAL':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiXj7.default), {
                    className: "w-4 h-4 text-blue-400"
                });
            case 'FILL':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b42daf8f5fabfd7f$export$2e2bcd8739ae039), {
                    className: "w-4 h-4 text-emerald-400"
                });
            case 'ERROR':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dAee.default), {
                    className: "w-4 h-4 text-red-500"
                });
            case 'WARNING':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dAee.default), {
                    className: "w-4 h-4 text-yellow-500"
                });
            default:
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jFR94.default), {
                    className: "w-4 h-4 text-muted"
                });
        }
    };
    const getPriorityClass = (priority)=>{
        switch(priority){
            case 'success':
                return 'border-emerald-500/30 bg-emerald-500/5';
            case 'error':
                return 'border-red-500/30 bg-red-500/5';
            case 'warning':
                return 'border-yellow-500/30 bg-yellow-500/5';
            default:
                return 'border-white/10 bg-white/5';
        }
    };
    const filteredNotifications = notifications.filter((n)=>activeFilter === 'ALL' || n.type === activeFilter);
    const getFilterButton = (filter, label)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
            onClick: ()=>setActiveFilter(filter),
            className: `px-3 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest transition-all duration-200 border ${activeFilter === filter ? 'bg-neon text-black border-neon shadow-[0_0_15px_rgba(92,246,205,0.4)]' : 'bg-white/5 text-muted border-white/10 hover:text-white hover:bg-white/10'}`,
            children: label
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col h-full bg-surface/95 backdrop-blur-2xl border-l border-white/10 shadow-[-20px_0_40px_rgba(0,0,0,0.5)]",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between p-6 border-b border-white/5 bg-white/5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5TAH.default), {
                                        className: "w-5 h-5 text-neon"
                                    }),
                                    unreadCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-pulse",
                                        children: unreadCount > 9 ? '9+' : unreadCount
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "text-sm font-bold uppercase tracking-widest text-white",
                                children: "Activity"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-4",
                        children: [
                            unreadCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: handleMarkAllRead,
                                className: "text-[10px] font-bold uppercase tracking-tighter text-neon hover:text-white transition-colors flex items-center gap-1 group",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbkWX.default), {
                                        className: "w-3 h-3 group-hover:scale-110 transition-transform"
                                    }),
                                    "Clear"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setShowSettings(!showSettings),
                                className: `p-1.5 rounded-lg hover:bg-white/10 transition ${showSettings ? 'text-neon bg-white/5' : 'text-muted hover:text-white'}`,
                                title: "Email Preferences",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIubC.default), {
                                    className: "w-5 h-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: onClose,
                                className: "p-1.5 rounded-lg hover:bg-white/10 text-muted hover:text-white transition",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    })
                ]
            }),
            !showSettings && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-2 p-4 border-b border-white/5 bg-black/10 overflow-x-auto no-scrollbar",
                children: [
                    getFilterButton('ALL', 'All'),
                    getFilterButton('SIGNAL', 'Signals'),
                    getFilterButton('FILL', 'Trades'),
                    getFilterButton('WARNING', 'Warnings'),
                    getFilterButton('ERROR', 'Errors')
                ]
            }),
            showSettings && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-5 border-b border-white/5 bg-black/20",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "text-[10px] font-bold text-white uppercase tracking-widest mb-4 opacity-50",
                        children: "Email Alert Preferences"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs font-semibold text-muted group-hover:text-white transition",
                                        children: "Trade Signals"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_email_signal,
                                                onChange: ()=>handleTogglePref('notify_email_signal'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_email_signal ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_email_signal ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-muted'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs font-semibold text-muted group-hover:text-white transition",
                                        children: "Order Fills"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_email_fill,
                                                onChange: ()=>handleTogglePref('notify_email_fill'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_email_fill ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_email_fill ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-muted'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs font-semibold text-muted group-hover:text-white transition",
                                        children: "Order Errors (Critical)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_email_error,
                                                onChange: ()=>handleTogglePref('notify_email_error'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_email_error ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_email_error ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-muted'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs font-semibold text-muted group-hover:text-white transition",
                                        children: "Data Quality Warnings"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_email_warning,
                                                onChange: ()=>handleTogglePref('notify_email_warning'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_email_warning ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_email_warning ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-muted'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs font-semibold text-muted group-hover:text-white transition",
                                        children: "System Status"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_email_system,
                                                onChange: ()=>handleTogglePref('notify_email_system'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_email_system ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_email_system ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-muted'}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h-px bg-white/10 my-1"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "flex items-center justify-between cursor-pointer group",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "text-xs font-semibold text-neon group-hover:text-white transition",
                                        children: "Sound Alerts"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                className: "sr-only",
                                                checked: preferences.notify_sound_enabled,
                                                onChange: ()=>handleTogglePref('notify_sound_enabled'),
                                                disabled: savingPrefs
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `w-8 h-4 bg-white/10 rounded-full transition-colors ${preferences.notify_sound_enabled ? 'bg-neon' : ''}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `dot absolute left-[3px] top-[3px] w-2.5 h-2.5 rounded-full transition-transform transform ${preferences.notify_sound_enabled ? 'translate-x-[16px] bg-black shadow-[0_0_8px_rgba(92,246,205,0.8)]' : 'bg-black'}`
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 overflow-y-auto scrollbar-thin p-4 space-y-3",
                children: loading && notifications.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex justify-center p-8",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Zl6K.default), {
                        size: "md"
                    })
                }) : filteredNotifications.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "h-full flex flex-col items-center justify-center text-muted gap-4 opacity-30 pb-20",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jFR94.default), {
                            className: "w-12 h-12"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-sm font-medium tracking-wide",
                            children: activeFilter === 'ALL' ? 'No recent events' : `No ${activeFilter.toLowerCase()} events`
                        })
                    ]
                }) : filteredNotifications.map((n)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        onClick: ()=>!n.is_read && handleMarkRead(n.id),
                        className: `relative group cursor-pointer p-4 rounded-xl border transition-all duration-200 hover:shadow-lg ${getPriorityClass(n.priority)} ${!n.is_read ? 'ring-1 ring-neon/20' : 'opacity-70 hover:opacity-100'}`,
                        children: [
                            !n.is_read && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "absolute top-4 right-4 w-2 h-2 bg-neon rounded-full shadow-[0_0_8px_rgba(var(--neon-rgb),0.5)]"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "p-1.5 rounded-lg bg-surface/50 border border-white/5",
                                                        children: getIcon(n.type)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-[10px] font-black text-muted uppercase tracking-widest",
                                                        children: n.type
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-[10px] font-mono text-muted/60",
                                                children: (0, $k8QNV.formatTimeET)(n.timestamp)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "space-y-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: `text-xs font-bold leading-tight ${n.is_read ? 'text-white/80' : 'text-white'}`,
                                                children: n.title
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-[11px] leading-relaxed text-white/50 italic",
                                                children: n.message
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, n.id))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-4 border-t border-white/5 text-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-[10px] text-muted tracking-widest uppercase opacity-30",
                    children: "ALGO TRADER NOTIFICATION ENGINE"
                })
            })
        ]
    });
};
var $09681d67b125daf0$export$2e2bcd8739ae039 = $09681d67b125daf0$var$NotificationFeed;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kTCPA = parcelRequire("kTCPA");
var $7ZFis = parcelRequire("7ZFis");
var $i9lAt = parcelRequire("i9lAt");
var $6JulE = parcelRequire("6JulE");
var $bTepa = parcelRequire("bTepa");
var $hPAJY = parcelRequire("hPAJY");
var $biC54 = parcelRequire("biC54");

var $2wVnk = parcelRequire("2wVnk");

var $9u0TL = parcelRequire("9u0TL");
const $8f2865e61a04185b$var$activeStatuses = [
    'queued',
    'running',
    'cancelling'
];
const $8f2865e61a04185b$var$statusClass = (status)=>{
    if (status === 'completed') return 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20';
    if (status === 'failed') return 'text-red-400 bg-red-500/10 border-red-500/20';
    if (status === 'cancelled') return 'text-muted bg-white/5 border-white/10';
    if (status === 'cancelling') return 'text-amber-300 bg-amber-500/10 border-amber-500/20';
    return 'text-neon bg-neon/10 border-neon/20';
};
const $8f2865e61a04185b$var$storageClass = (status)=>{
    if (status === 'saved' || status === 'cached' || status === 'synced') return 'text-emerald-300 bg-emerald-500/10 border-emerald-500/20';
    if (status === 'failed') return 'text-amber-300 bg-amber-500/10 border-amber-500/20';
    if (status === 'skipped' || status === 'not_attempted') return 'text-muted bg-white/5 border-white/10';
    return 'text-neon bg-neon/10 border-neon/20';
};
const $8f2865e61a04185b$var$StorageBadges = ({ task: task })=>{
    const local = task.storage?.local;
    const lake = task.storage?.research_lake;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-wrap gap-1.5",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: `inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[9px] font-black uppercase tracking-widest ${$8f2865e61a04185b$var$storageClass(local?.status)}`,
                title: local?.message || 'Trader DB storage status',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6JulE.default), {
                        className: "w-3 h-3"
                    }),
                    "DB ",
                    local?.status || 'pending'
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: `inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[9px] font-black uppercase tracking-widest ${$8f2865e61a04185b$var$storageClass(lake?.status)}`,
                title: lake?.message || 'Research Lake sync status',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ZFis.default), {
                        className: "w-3 h-3"
                    }),
                    "Lake ",
                    lake?.status || 'pending'
                ]
            })
        ]
    });
};
const $8f2865e61a04185b$var$formatDateTime = (value)=>{
    if (!value) return '-';
    return new Date(value).toLocaleString([], {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};
const $8f2865e61a04185b$var$TaskDrawer = ({ onClose: onClose, onTaskCountChange: onTaskCountChange })=>{
    const [tasks, setTasks] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)('');
    const [activeFilter, setActiveFilter] = (0, $acw62.useState)('ALL');
    const fetchTasks = (0, $acw62.useCallback)(async ()=>{
        try {
            const nextTasks = await (0, $2wVnk.tradingApi).getDataDownloadTasks();
            setTasks(nextTasks);
            setError('');
            onTaskCountChange?.(nextTasks.filter((task)=>$8f2865e61a04185b$var$activeStatuses.includes(task.status)).length);
        } catch (err) {
            setError(err.message || 'Failed to load tasks');
        } finally{
            setLoading(false);
        }
    }, [
        onTaskCountChange
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchTasks();
        const interval = window.setInterval(fetchTasks, 3000);
        return ()=>window.clearInterval(interval);
    }, [
        fetchTasks
    ]);
    const filteredTasks = (0, $acw62.useMemo)(()=>{
        if (activeFilter === 'ACTIVE') return tasks.filter((task)=>$8f2865e61a04185b$var$activeStatuses.includes(task.status));
        if (activeFilter === 'DONE') return tasks.filter((task)=>!$8f2865e61a04185b$var$activeStatuses.includes(task.status));
        return tasks;
    }, [
        activeFilter,
        tasks
    ]);
    const cancelTask = async (taskId)=>{
        try {
            await (0, $2wVnk.tradingApi).cancelDataDownloadTask(taskId);
            await fetchTasks();
        } catch (err) {
            setError(err.message || 'Failed to cancel task');
        }
    };
    const getFilterButton = (filter, label)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
            onClick: ()=>setActiveFilter(filter),
            className: `px-3 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest transition-all duration-200 border ${activeFilter === filter ? 'bg-neon text-black border-neon shadow-[0_0_15px_rgba(92,246,205,0.4)]' : 'bg-white/5 text-muted border-white/10 hover:text-white hover:bg-white/10'}`,
            children: label
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col h-full bg-surface/95 backdrop-blur-2xl border-l border-white/10 shadow-[-20px_0_40px_rgba(0,0,0,0.5)]",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between p-6 border-b border-white/5 bg-white/5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $131c05e6196e399a$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-neon"
                                    }),
                                    tasks.some((task)=>$8f2865e61a04185b$var$activeStatuses.includes(task.status)) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "absolute -top-1 -right-1 w-2.5 h-2.5 bg-neon rounded-full animate-pulse"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "text-sm font-bold uppercase tracking-widest text-white",
                                children: "Tasks"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: fetchTasks,
                                className: "p-1.5 rounded-lg hover:bg-white/10 text-muted hover:text-white transition",
                                title: "Refresh tasks",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                                    className: "w-5 h-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: onClose,
                                className: "p-1.5 rounded-lg hover:bg-white/10 text-muted hover:text-white transition",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-2 p-4 border-b border-white/5 bg-black/10 overflow-x-auto no-scrollbar",
                children: [
                    getFilterButton('ALL', 'All'),
                    getFilterButton('ACTIVE', 'Running'),
                    getFilterButton('DONE', 'Done')
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mx-4 mt-4 border border-red-500/20 bg-red-500/10 text-red-300 px-3 py-2 rounded-xl text-xs",
                children: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 overflow-y-auto scrollbar-thin p-4 space-y-3",
                children: loading && tasks.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "text-center text-muted text-sm py-10 animate-pulse",
                    children: "Loading tasks..."
                }) : filteredTasks.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "h-full flex flex-col items-center justify-center text-muted gap-4 opacity-30 pb-20",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kTCPA.default), {
                            className: "w-12 h-12"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-sm font-medium tracking-wide",
                            children: activeFilter === 'ACTIVE' ? 'No running tasks' : 'No tasks found'
                        })
                    ]
                }) : filteredTasks.map((task)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "rounded-xl border border-white/10 bg-white/[0.03] p-4 space-y-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-start justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "min-w-0 flex items-start gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "mt-0.5 rounded-lg bg-surface/50 border border-white/5 p-1.5",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i9lAt.default), {
                                                    className: "w-4 h-4 text-neon"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "text-xs font-black text-white truncate",
                                                        children: [
                                                            task.request.display_name || task.request.symbols?.join(', ') || task.request.symbol || '-',
                                                            " ",
                                                            task.request.sec_type || 'STK',
                                                            task.request.stk_type ? `/${task.request.stk_type}` : '',
                                                            " ",
                                                            task.request.timeframe
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "text-[10px] text-muted font-mono",
                                                        children: [
                                                            task.request.data_source,
                                                            " ",
                                                            task.request.fetch_profile || 'balanced',
                                                            " #",
                                                            task.id
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `px-2 py-1 rounded-lg border text-[9px] font-black uppercase tracking-widest ${$8f2865e61a04185b$var$statusClass(task.status)}`,
                                        children: task.status
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "space-y-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "h-1.5 bg-black/30 rounded-full overflow-hidden",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `h-full transition-all ${task.status === 'failed' ? 'bg-red-400' : task.status === 'completed' ? 'bg-emerald-400' : 'bg-neon'}`,
                                            style: {
                                                width: `${[
                                                    'completed',
                                                    'failed'
                                                ].includes(task.status) ? 100 : task.progress}%`
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center justify-between text-[10px] text-muted",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    task.progress,
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: $8f2865e61a04185b$var$formatDateTime(task.updated_at)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-start justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($8f2865e61a04185b$var$StorageBadges, {
                                                task: task
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-[11px] text-white/60 leading-relaxed",
                                                children: task.message
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "text-[10px] text-muted font-mono mt-1",
                                                children: [
                                                    task.request.start_date,
                                                    " to ",
                                                    task.request.end_date,
                                                    (0, $9u0TL.formatDownloadTaskBarCount)(task.bars) ? ` | ${(0, $9u0TL.formatDownloadTaskBarCount)(task.bars)} bars` : ''
                                                ]
                                            })
                                        ]
                                    }),
                                    task.can_cancel !== false && $8f2865e61a04185b$var$activeStatuses.includes(task.status) && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>cancelTask(task.id),
                                        className: "p-1.5 text-red-400 hover:bg-red-500/10 rounded-lg shrink-0",
                                        title: "Cancel task",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $biC54.default), {
                                            className: "w-4 h-4"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, task.id))
            })
        ]
    });
};
var $8f2865e61a04185b$export$2e2bcd8739ae039 = $8f2865e61a04185b$var$TaskDrawer;



var $cfqjJ = parcelRequire("cfqjJ");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $f79f43cbfab696d1$var$MarketEvents = ({ compact: compact = false })=>{
    const [activeTab, setActiveTab] = (0, $acw62.useState)('economic');
    const economicContainer = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        // Economic Calendar Widget
        if (activeTab === 'economic' && economicContainer.current) {
            economicContainer.current.innerHTML = ''; // Clear previous
            const script = document.createElement('script');
            script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-events.js';
            script.async = true;
            script.innerHTML = JSON.stringify({
                "colorTheme": "dark",
                "isTransparent": true,
                "width": "100%",
                "height": "100%",
                "locale": "en",
                "importanceFilter": "0,1",
                "currencyFilter": "USD"
            });
            economicContainer.current.appendChild(script);
        }
    // Earnings Calendar Widget (placeholder/future implementation)
    }, [
        activeTab
    ]);
    const tabSwitcher = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center gap-1 bg-black/20 rounded-lg p-1",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>setActiveTab('economic'),
                className: `px-3 py-1.5 rounded-md text-xs font-medium transition-all ${activeTab === 'economic' ? 'bg-neon/10 text-neon shadow-sm' : 'text-muted hover:text-white hover:bg-white/5'}`,
                children: "Economic"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>setActiveTab('earnings'),
                className: `px-3 py-1.5 rounded-md text-xs font-medium transition-all ${activeTab === 'earnings' ? 'bg-neon/10 text-neon shadow-sm' : 'text-muted hover:text-white hover:bg-white/5'}`,
                children: "Earnings"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `${compact ? 'h-[68vh]' : 'h-full p-6'} flex flex-col`,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `flex-1 flex flex-col relative ${compact ? 'min-h-[420px]' : 'panel min-h-[600px]'}`,
            children: [
                compact ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-center justify-end border-b border-white/10 px-3 py-3",
                    children: tabSwitcher
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "px-4 py-4 flex items-center justify-between border-b border-white/10 bg-white/5",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "font-semibold text-neon flex items-center gap-2",
                                    children: "Market Events"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-xs text-muted",
                                    children: "Economic calendar and future releases"
                                })
                            ]
                        }),
                        tabSwitcher
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex-1 relative bg-surface/50",
                    children: [
                        activeTab === 'economic' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tradingview-widget-container absolute inset-0 w-full h-full",
                            ref: economicContainer,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tradingview-widget-container__widget h-full w-full"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tradingview-widget-copyright",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "https://www.tradingview.com/",
                                        rel: "noopener nofollow",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "blue-text",
                                            children: "Track all markets on TradingView"
                                        })
                                    })
                                })
                            ]
                        }),
                        activeTab === 'earnings' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "absolute inset-0 flex items-center justify-center text-muted flex-col gap-2",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Earnings calendar coming soon"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $f79f43cbfab696d1$export$2e2bcd8739ae039 = $f79f43cbfab696d1$var$MarketEvents;



var $9qjJe = parcelRequire("9qjJe");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $70wbS = parcelRequire("70wbS");

var $7jD0c = parcelRequire("7jD0c");
const $16ee1e6757ab6af4$export$f51d452c10d5b956 = (0, $7jD0c.useDispatch).withTypes();
const $16ee1e6757ab6af4$export$a7347740d65f620b = (0, $7jD0c.useSelector).withTypes();



var $iDqdB = parcelRequire("iDqdB");

var $8OE6H = parcelRequire("8OE6H");

var $jtEPT = parcelRequire("jtEPT");
const $01ad0b73f9df3fa4$var$initialState = {
    userId: null,
    username: null
};
const $01ad0b73f9df3fa4$var$sessionSlice = (0, $iDqdB.createSlice)({
    name: 'session',
    initialState: $01ad0b73f9df3fa4$var$initialState,
    reducers: {
        sessionChanged: (_state, action)=>action.payload,
        sessionCleared: ()=>$01ad0b73f9df3fa4$var$initialState
    }
});
const { sessionChanged: $01ad0b73f9df3fa4$export$134f78b20a6d7058, sessionCleared: $01ad0b73f9df3fa4$export$4f6ed4f612720419 } = $01ad0b73f9df3fa4$var$sessionSlice.actions;
const $01ad0b73f9df3fa4$export$6f57813fe9f31bf9 = (0, $iDqdB.configureStore)({
    reducer: {
        session: $01ad0b73f9df3fa4$var$sessionSlice.reducer,
        [(0, $jtEPT.tradingApiSlice).reducerPath]: (0, $jtEPT.tradingApiSlice).reducer
    },
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, $jtEPT.tradingApiSlice).middleware)
});
(0, $8OE6H.setupListeners)($01ad0b73f9df3fa4$export$6f57813fe9f31bf9.dispatch);



var $jtEPT = parcelRequire("jtEPT");

const $489e57e116e551f3$export$7c0d05a5f8d89647 = ({ children: children })=>{
    const { token: token, user: user } = (0, $70wbS.useAuth)();
    const dispatch = (0, $16ee1e6757ab6af4$export$f51d452c10d5b956)();
    const userId = user?.id ?? null;
    const username = user?.username ?? null;
    const previousIdentity = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const nextIdentity = token && userId !== null ? `${userId}:${token}` : null;
        if (token && userId !== null) {
            dispatch((0, $01ad0b73f9df3fa4$export$134f78b20a6d7058)({
                userId: userId,
                username: username
            }));
            (0, $ee10d9a55e84bc57$export$51b87650e98265a6).configure(token, String(userId));
        } else {
            dispatch((0, $01ad0b73f9df3fa4$export$4f6ed4f612720419)());
            (0, $ee10d9a55e84bc57$export$51b87650e98265a6).configure(null, null);
        }
        // Do not reset on initial mount: account query subscriptions may already
        // be active, and deleting their first successful response can strand the
        // page in `isLoading` (especially under React StrictMode). Reset only when
        // an established identity genuinely changes or is cleared.
        if (previousIdentity.current !== null && previousIdentity.current !== nextIdentity) dispatch((0, $jtEPT.tradingApiSlice).util.resetApiState());
        previousIdentity.current = nextIdentity;
    }, [
        dispatch,
        token,
        userId,
        username
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children
    });
};



var $cYtEX = parcelRequire("cYtEX");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $fa7706f9ee0421dc$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Target", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "6",
            key: "1vlfrh"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "2",
            key: "1c9p78"
        }
    ]
]);



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2Kpom = parcelRequire("2Kpom");
var $75jMV = parcelRequire("75jMV");
var $fkh1V = parcelRequire("fkh1V");
var $sUw6Q = parcelRequire("sUw6Q");
var $5ArKp = parcelRequire("5ArKp");
var $id7Ro = parcelRequire("id7Ro");
var $jQdKn = parcelRequire("jQdKn");
var $hiXj7 = parcelRequire("hiXj7");
var $4reVr = parcelRequire("4reVr");

var $8Zl6K = parcelRequire("8Zl6K");

var $iqWry = parcelRequire("iqWry");

var $k8QNV = parcelRequire("k8QNV");

var $b1rqt = parcelRequire("b1rqt");

var $jtEPT = parcelRequire("jtEPT");
const $a7bcc54e85b36e52$var$AccountSummary = ({ refreshInterval: refreshInterval = 30000 })=>{
    const { data: portfolio = null, isLoading: loading, isFetching: refreshing, error: portfolioError, refetch: refetch } = (0, $jtEPT.usePortfolioQuery)(undefined, {
        pollingInterval: refreshInterval,
        skipPollingIfUnfocused: true
    });
    const blockingError = portfolioError && !portfolio ? 'Failed to fetch account data' : null;
    const refreshError = portfolioError && portfolio ? 'Live refresh failed; keeping the last account values.' : null;
    const [hideValues, setHideValues] = (0, $acw62.useState)(()=>{
        if (typeof window === 'undefined') return false;
        const saved = window.localStorage.getItem('accountSummaryHideValues');
        return saved === 'true';
    });
    (0, $acw62.useEffect)(()=>{
        if (typeof window !== 'undefined') window.localStorage.setItem('accountSummaryHideValues', hideValues ? 'true' : 'false');
    }, [
        hideValues
    ]);
    const getCurrencyIcon = (size = 14)=>{
        const currency = portfolio?.data?.currency || 'USD';
        const symbol = (0, $b1rqt.getCurrencySymbol)(currency);
        if (symbol !== '$') return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "font-bold text-[14px] text-muted",
            children: symbol
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75jMV.default), {
            size: size,
            className: "text-muted"
        });
    };
    const isStale = !!portfolio?.data?.stale;
    const hasSnapshot = portfolio?.data?.snapshot_available !== false;
    const isInitializing = portfolio?.data?.connection_status === 'initializing';
    const isUnavailable = portfolio?.data?.connection_status === 'unavailable';
    const availableMarginPct = portfolio?.data?.available_margin_pct;
    (0, $acw62.useEffect)(()=>{
        if (!isInitializing) return;
        const retryId = window.setTimeout(()=>refetch(), 2000);
        return ()=>window.clearTimeout(retryId);
    }, [
        isInitializing,
        portfolio?.timestamp,
        refetch
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `panel full-bleed-panel lg:h-full transition-all duration-300 ${isStale ? 'border-warning-500/20 bg-warning-500/5' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px-6 py-5 flex items-center justify-between border-b border-white/10",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `p-2 rounded-lg transition-colors ${isStale ? 'bg-warning-500/10 text-warning-500' : 'bg-neon/10 text-neon'}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4reVr.default), {
                                    className: "w-5 h-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "space-y-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "text-lg font-bold text-white tracking-tight",
                                                children: "Account Summary"
                                            }),
                                            isStale && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "relative group cursor-help z-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-[9px] uppercase font-black tracking-wider px-2 py-0.5 rounded bg-warning-500/20 text-warning-500 border border-warning-500/30 animate-pulse",
                                                        children: isInitializing ? 'Connecting' : hasSnapshot ? 'Stale Data' : 'Offline'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "absolute left-0 top-full mt-2 hidden group-hover:block w-64 p-3 bg-surface border border-warning-500/30 rounded-xl shadow-xl text-xs font-normal text-warning-500 leading-normal normal-case pointer-events-none",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "absolute bottom-full left-4 border-4 border-transparent border-b-surface"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "font-bold mb-1",
                                                                children: isInitializing ? 'Synchronizing Account' : isUnavailable ? 'Account Data Unavailable' : hasSnapshot ? 'Account Data Stale' : 'No Cached Account Data'
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "opacity-80",
                                                                children: isInitializing ? 'IB is connected and account data is still synchronizing. This panel will refresh automatically.' : isUnavailable ? 'The IB socket is online, but account values did not arrive. The backend will keep retrying automatically.' : hasSnapshot ? 'Live streaming is currently unavailable. Displaying the last cached values recorded when connection was active.' : 'The gateway is offline and this account does not have a persisted summary yet.'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-xs text-muted",
                                        children: isInitializing ? 'Connecting to IB and synchronizing account data' : isUnavailable ? "IB connected \u2014 account values currently unavailable" : isStale ? hasSnapshot ? 'Showing offline cached snapshot' : "Offline \u2014 no cached snapshot available" : 'Real-time portfolio and P&L oversight'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>setHideValues((prev)=>!prev),
                        className: "text-xs px-3 py-1.5 rounded-lg border border-white/10 bg-white/5 text-foreground hover:bg-white/10 transition flex items-center gap-2",
                        "aria-label": hideValues ? 'Show account values' : 'Hide account values',
                        children: hideValues ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $sUw6Q.default), {
                            size: 14
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fkh1V.default), {
                            size: 14
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-4 space-y-5",
                children: [
                    loading && !portfolio && !blockingError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center py-8",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Zl6K.default), {
                            size: "lg"
                        })
                    }),
                    blockingError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iqWry.default), {
                        error: blockingError,
                        onRetry: ()=>refetch(),
                        message: "Failed to load account data"
                    }),
                    refreshError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "rounded-xl border border-warning-500/20 bg-warning-500/5 px-4 py-3 text-xs text-warning-300",
                        children: refreshError
                    }),
                    portfolio?.success && !blockingError && isStale && !hasSnapshot && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "rounded-xl border border-warning-500/20 bg-warning-500/5 px-4 py-8 text-center text-sm text-warning-300/80",
                        children: isInitializing ? "Connecting to IB and synchronizing this account\u2026" : isUnavailable ? 'IB is connected, but account values are unavailable. Synchronization will continue in the background.' : 'Connect this account once to create its first persisted account snapshot.'
                    }),
                    portfolio?.success && !blockingError && (!isStale || hasSnapshot) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "space-y-4 text-sm text-foreground",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/6 border border-white/10 hover:border-neon/30'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "Net liquidation"
                                                    }),
                                                    getCurrencyIcon()
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `mt-2 text-lg font-semibold text-foreground ${refreshing ? 'refreshing-text' : ''}`,
                                                children: (0, $b1rqt.formatCurrency)(portfolio.data?.net_liquidation, portfolio.data?.currency, hideValues)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/6 border border-white/10 hover:border-neon/30'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "Available funds"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4reVr.default), {
                                                        size: 14,
                                                        className: "text-muted"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `mt-2 text-lg font-semibold text-foreground ${refreshing ? 'refreshing-text' : ''}`,
                                                children: (0, $b1rqt.formatCurrency)(portfolio.data?.available_funds, portfolio.data?.currency, hideValues)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "space-y-0.5 text-[11px]",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center justify-between gap-2 text-emerald-300",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "inline-flex items-center gap-1",
                                                                title: "Percentage of net liquidation currently available for new positions.",
                                                                children: [
                                                                    "Available margin",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $id7Ro.default), {
                                                                        className: "h-3 w-3 text-emerald-300/70",
                                                                        "aria-label": "Available margin information"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "font-semibold",
                                                                children: availableMarginPct !== undefined && availableMarginPct !== null ? `${availableMarginPct.toFixed(2)}%` : "\u2014"
                                                            })
                                                        ]
                                                    }),
                                                    portfolio.data?.init_margin_req !== undefined && portfolio.data?.init_margin_req !== null && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center justify-between gap-2 text-muted",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "inline-flex items-center gap-1",
                                                                title: "Initial margin currently reserved by open positions.",
                                                                children: [
                                                                    "Initial margin used",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $id7Ro.default), {
                                                                        className: "h-3 w-3 text-muted/70",
                                                                        "aria-label": "Initial margin information"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: (0, $b1rqt.formatCurrency)(portfolio.data.init_margin_req, portfolio.data.currency, hideValues)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/6 border border-white/10 hover:border-neon/30'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "Buying power"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ArKp.default), {
                                                        size: 14,
                                                        className: "text-muted"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `mt-2 text-lg font-semibold text-foreground ${refreshing ? 'refreshing-text' : ''}`,
                                                children: (0, $b1rqt.formatCurrency)(portfolio.data?.buying_power, portfolio.data?.currency, hideValues)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/6 border border-white/10 hover:border-neon/30'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "Realized P&L (today)"
                                                    }),
                                                    portfolio.data?.realized_pnl_today !== undefined && portfolio.data?.realized_pnl_today !== null && portfolio.data?.realized_pnl_today < 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jQdKn.default), {
                                                        size: 14,
                                                        className: "text-red-400"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiXj7.default), {
                                                        size: 14,
                                                        className: "text-emerald-400"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `mt-2 text-lg font-semibold ${refreshing ? 'refreshing-text' : 'text-foreground'}`,
                                                children: (0, $b1rqt.formatCurrency)(portfolio.data?.realized_pnl_today, portfolio.data?.currency, hideValues)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/6 border border-white/10 hover:border-neon/30'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "Unrealized P&L (today)"
                                                    }),
                                                    portfolio.data?.unrealized_pnl_today !== undefined && portfolio.data?.unrealized_pnl_today !== null && portfolio.data?.unrealized_pnl_today < 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jQdKn.default), {
                                                        size: 14,
                                                        className: "text-red-400"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiXj7.default), {
                                                        size: 14,
                                                        className: "text-emerald-400"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `mt-2 text-lg font-semibold ${refreshing ? 'refreshing-text' : 'text-foreground'}`,
                                                children: (0, $b1rqt.formatCurrency)(portfolio.data?.unrealized_pnl_today, portfolio.data?.currency, hideValues)
                                            })
                                        ]
                                    }),
                                    portfolio.data?.pnl_timestamp && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `rounded-xl transition p-3 space-y-2 ${isStale ? 'bg-warning-500/5 border border-warning-500/20' : 'bg-white/6 border border-white/10'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-xs font-semibold text-muted",
                                                        children: "P&L timestamp"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Kpom.default), {
                                                        size: 14,
                                                        className: "text-muted"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "mt-2 text-xs font-semibold text-foreground",
                                                children: (0, $k8QNV.formatDateTimeET)(portfolio.data?.pnl_timestamp)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a7bcc54e85b36e52$export$2e2bcd8739ae039 = $a7bcc54e85b36e52$var$AccountSummary;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2Kpom = parcelRequire("2Kpom");
var $75jMV = parcelRequire("75jMV");
var $fkh1V = parcelRequire("fkh1V");
var $sUw6Q = parcelRequire("sUw6Q");
var $iIubC = parcelRequire("iIubC");
var $jQdKn = parcelRequire("jQdKn");
var $hiXj7 = parcelRequire("hiXj7");

var $2wVnk = parcelRequire("2wVnk");

var $8Zl6K = parcelRequire("8Zl6K");

var $iqWry = parcelRequire("iqWry");

var $cfqjJ = parcelRequire("cfqjJ");

var $2jex3 = parcelRequire("2jex3");

var $k8QNV = parcelRequire("k8QNV");

var $b1rqt = parcelRequire("b1rqt");

var $70wbS = parcelRequire("70wbS");

var $jtEPT = parcelRequire("jtEPT");
const $2b80c7f69ff3fe88$var$InvestorAccountSummary = ({ refreshInterval: refreshInterval = 30000, isConnected: isConnected = true })=>{
    const { user: user } = (0, $70wbS.useAuth)();
    const isInvestor = user?.role === 'investor';
    const { data: portfolio = null, isLoading: loading, isFetching: refreshing, error: portfolioError, refetch: refetchPortfolio } = (0, $jtEPT.usePortfolioQuery)(undefined, {
        pollingInterval: isConnected ? refreshInterval : 0
    });
    const blockingError = portfolioError && !portfolio ? 'Failed to fetch account data' : null;
    const refreshError = portfolioError && portfolio ? 'Live refresh failed; keeping the last account values.' : null;
    const [hideValues, setHideValues] = (0, $acw62.useState)(()=>{
        if (typeof window === 'undefined') return false;
        const saved = window.localStorage.getItem('accountSummaryHideValues');
        return saved === 'true';
    });
    const [showConfigModal, setShowConfigModal] = (0, $acw62.useState)(false);
    const [controlState, setControlState] = (0, $acw62.useState)(null);
    const [configLoading, setConfigLoading] = (0, $acw62.useState)(false);
    const [gatewayError, setGatewayError] = (0, $acw62.useState)(null);
    // Auto-clear gateway error after 8 seconds
    (0, $acw62.useEffect)(()=>{
        if (gatewayError) {
            const timer = setTimeout(()=>setGatewayError(null), 8000);
            return ()=>clearTimeout(timer);
        }
    }, [
        gatewayError
    ]);
    const fetchControlState = (0, $acw62.useCallback)(async (silent = false)=>{
        if (!silent) setConfigLoading(true);
        try {
            const response = await (0, $2wVnk.tradingApi).getSystemControlState();
            if (response.success && response.data) {
                setControlState(response.data);
                if (!silent) setShowConfigModal(true);
            }
        } catch (err) {
            console.warn("Failed to fetch control state:", err);
            if (!silent) setShowConfigModal(true);
        } finally{
            if (!silent) setConfigLoading(false);
        }
    }, []);
    const hasAccountData = Boolean(portfolio?.data?.account_type && portfolio.data.account_type !== 'N/A' && portfolio.data.net_liquidation !== undefined && portfolio.data.net_liquidation !== null);
    const isEffectivelyConnected = portfolio?.data?.connection_status === 'connected' || isConnected && hasAccountData;
    const isInitializing = portfolio?.data?.connection_status === 'initializing';
    const isUnavailable = portfolio?.data?.connection_status === 'unavailable';
    const hasSnapshot = portfolio?.data?.snapshot_available !== false;
    (0, $acw62.useEffect)(()=>{
        if (!isInitializing) return;
        const retryId = window.setTimeout(()=>refetchPortfolio(), 2000);
        return ()=>window.clearTimeout(retryId);
    }, [
        isInitializing,
        portfolio?.timestamp,
        refetchPortfolio
    ]);
    (0, $acw62.useEffect)(()=>{
        // Always fetch control state silently to see if we have gateway controls available
        fetchControlState(true);
    }, [
        fetchControlState
    ]);
    // Polling for control state if modal is open OR if we are showing the start button (waiting for connect)
    (0, $acw62.useEffect)(()=>{
        let intervalId;
        if (showConfigModal || !controlState?.ib_connected && controlState?.gateway_configured) intervalId = setInterval(()=>fetchControlState(true), 5000);
        return ()=>{
            if (intervalId) clearInterval(intervalId);
        };
    }, [
        showConfigModal,
        controlState?.ib_connected,
        controlState?.gateway_configured,
        fetchControlState
    ]);
    (0, $acw62.useEffect)(()=>{
        if (typeof window !== 'undefined') window.localStorage.setItem('accountSummaryHideValues', hideValues ? 'true' : 'false');
    }, [
        hideValues
    ]);
    const isConfigured = controlState?.gateway_configured;
    const currency = portfolio?.data?.currency || 'USD';
    const isStale = !!portfolio?.data?.stale;
    // A persisted snapshot remains useful when IB is disconnected. Only hide
    // values when the backend confirms that no account snapshot exists.
    const canDisplayValues = hasSnapshot && hasAccountData;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `panel full-bleed-panel w-full lg:h-full relative transition-all duration-300 ${isStale ? 'border-warning-500/20 bg-warning-500/5' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px-6 py-5 flex flex-col sm:flex-row sm:items-center justify-between border-b border-white/10 relative z-10 gap-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "space-y-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "text-xl font-bold text-white",
                                        children: "Portfolio Overview"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `text-xs px-2 py-0.5 rounded-full border ${isInitializing ? 'bg-warning-500/10 text-warning-400 border-warning-500/20' : isEffectivelyConnected ? isStale ? 'bg-warning-500/10 text-warning-400 border-warning-500/20' : 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' : 'bg-red-500/10 text-red-400 border-red-500/20'}`,
                                                children: isInitializing ? 'Connecting' : isUnavailable ? 'Account Unavailable' : isStale ? 'Stale Data' : isEffectivelyConnected ? 'Connected' : isConnected ? 'Not Configured' : 'Offline'
                                            }),
                                            isStale && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "relative group cursor-help z-50",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-[10px] uppercase font-black tracking-wider px-2 py-0.5 rounded bg-warning-500/20 text-warning-500 border border-warning-500/30 animate-pulse",
                                                        children: "Stale"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "absolute right-0 top-full mt-2 hidden group-hover:block w-64 p-3 bg-surface border border-warning-500/30 rounded-xl shadow-xl text-xs font-normal text-warning-500 leading-normal normal-case pointer-events-none",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "absolute bottom-full right-4 border-4 border-transparent border-b-surface"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "font-bold mb-1",
                                                                children: isInitializing ? 'Synchronizing Account' : isUnavailable ? 'Account Data Unavailable' : 'Portfolio Data Stale'
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "opacity-80",
                                                                children: isInitializing ? 'IB is connected and account data is still synchronizing. This panel will refresh automatically.' : isUnavailable ? 'The IB socket is online, but account values did not arrive. The backend will keep retrying automatically.' : 'Live streaming is currently offline. Displaying last cached values recorded when connection was active.'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-sm text-muted",
                                children: isInitializing ? 'Connecting to IB and synchronizing account data' : isUnavailable ? "IB connected \u2014 account values currently unavailable" : isStale ? 'Showing offline cached snapshot' : 'Real-time account performance'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between sm:justify-end gap-3 w-full sm:w-auto",
                        children: [
                            !isInvestor && !isInitializing && (!isEffectivelyConnected || controlState && isConfigured) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    controlState && isConfigured ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jex3.default), {
                                                controlState: controlState,
                                                onRefresh: async ()=>{
                                                    await fetchControlState(true);
                                                },
                                                onConfigureNeeded: ()=>setShowConfigModal(true),
                                                onError: (msg)=>setGatewayError(msg),
                                                variant: "slim",
                                                className: "h-10 text-sm px-4 min-w-[120px]"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>setShowConfigModal(true),
                                                className: "h-10 w-10 flex items-center justify-center rounded-xl bg-white/5 border border-white/10 text-muted hover:text-white hover:bg-white/10 transition",
                                                title: "Configure Connection",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIubC.default), {
                                                    size: 18
                                                })
                                            })
                                        ]
                                    }) : !isEffectivelyConnected && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>fetchControlState(false),
                                        disabled: configLoading,
                                        className: "flex items-center gap-2 px-4 py-2 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-medium shadow-lg shadow-emerald-500/20 transition-all disabled:opacity-50 disabled:shadow-none",
                                        children: [
                                            configLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIubC.default), {
                                                size: 16
                                            }),
                                            "Configure Connection"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "h-8 w-px bg-white/10 mx-1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setHideValues((prev)=>!prev),
                                className: "p-2.5 rounded-xl border border-white/10 bg-white/5 text-muted hover:text-white hover:bg-white/10 transition flex items-center justify-center",
                                "aria-label": hideValues ? 'Show account values' : 'Hide account values',
                                title: hideValues ? 'Show values' : 'Hide values',
                                children: hideValues ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $sUw6Q.default), {
                                    size: 18
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fkh1V.default), {
                                    size: 18
                                })
                            })
                        ]
                    })
                ]
            }),
            gatewayError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-red-500/10 border-b border-red-500/20 px-6 py-2 flex items-center justify-between animate-in slide-in-from-top-2 duration-200",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm text-red-400",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse"
                            }),
                            gatewayError
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>setGatewayError(null),
                        className: "text-xs text-red-400/70 hover:text-red-300",
                        children: "Dismiss"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-6",
                children: [
                    loading && !portfolio && !blockingError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center py-8",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Zl6K.default), {
                            size: "lg"
                        })
                    }),
                    blockingError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iqWry.default), {
                        error: blockingError,
                        onRetry: ()=>refetchPortfolio(),
                        message: "Failed to load account data"
                    }),
                    refreshError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-4 rounded-xl border border-warning-500/20 bg-warning-500/5 px-4 py-3 text-xs text-warning-300",
                        children: refreshError
                    }),
                    portfolio?.success && !blockingError && isStale && !hasSnapshot && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "rounded-xl border border-warning-500/20 bg-warning-500/5 px-4 py-8 text-center text-sm text-warning-300/80",
                        children: isInitializing ? "Connecting to IB and synchronizing this account\u2026" : isUnavailable ? 'IB is connected, but account values are unavailable. Synchronization will continue in the background.' : 'Connect this account once to create its first persisted account snapshot.'
                    }),
                    portfolio?.success && !blockingError && (!isStale || hasSnapshot) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "space-y-6",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `rounded-xl transition duration-300 p-5 relative overflow-hidden group ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/10 border border-white/10 hover:border-neon/30'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75jMV.default), {
                                                size: 48
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-sm font-medium text-gray-400 mb-1",
                                            children: "Net Liquidation Value"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: `text-3xl font-bold text-white tracking-tight ${refreshing ? 'animate-pulse' : ''}`,
                                            children: !canDisplayValues ? '---' : (0, $b1rqt.formatCurrency)(portfolio.data?.net_liquidation, currency, hideValues)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt-4 flex items-center gap-2 text-xs text-muted",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Kpom.default), {
                                                    size: 12
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    children: [
                                                        "Updated: ",
                                                        (0, $k8QNV.formatDateTimeET)(portfolio.data?.timestamp)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `rounded-xl transition duration-300 p-5 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/5 border border-white/10 hover:bg-white/10'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center justify-between mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "text-sm font-medium text-gray-400",
                                                    children: "Realized P&L (Today)"
                                                }),
                                                portfolio.data?.realized_pnl_today !== undefined && portfolio.data?.realized_pnl_today < 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jQdKn.default), {
                                                    size: 16,
                                                    className: "text-red-400"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiXj7.default), {
                                                    size: 16,
                                                    className: "text-emerald-400"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: `text-2xl font-bold tracking-tight ${(portfolio.data?.realized_pnl_today || 0) >= 0 ? 'text-emerald-400' : 'text-red-400'} ${refreshing ? 'animate-pulse' : ''}`,
                                            children: !canDisplayValues ? '---' : (0, $b1rqt.formatCurrency)(portfolio.data?.realized_pnl_today, currency, hideValues)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `rounded-xl transition duration-300 p-5 ${isStale ? 'bg-warning-500/5 border border-warning-500/20 hover:border-warning-500/35' : 'bg-white/5 border border-white/10 hover:bg-white/10'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center justify-between mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "text-sm font-medium text-gray-400",
                                                    children: "Unrealized P&L (Today)"
                                                }),
                                                portfolio.data?.unrealized_pnl_today !== undefined && portfolio.data?.unrealized_pnl_today < 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jQdKn.default), {
                                                    size: 16,
                                                    className: "text-red-400"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiXj7.default), {
                                                    size: 16,
                                                    className: "text-emerald-400"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: `text-2xl font-bold tracking-tight ${(portfolio.data?.unrealized_pnl_today || 0) >= 0 ? 'text-emerald-400' : 'text-red-400'} ${refreshing ? 'animate-pulse' : ''}`,
                                            children: !canDisplayValues ? '---' : (0, $b1rqt.formatCurrency)(portfolio.data?.unrealized_pnl_today, currency, hideValues)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfqjJ.default), {
                isOpen: showConfigModal,
                onClose: ()=>setShowConfigModal(false),
                onSuccess: ()=>{
                    setShowConfigModal(false);
                    refetchPortfolio(); // Refresh portfolio data after config
                },
                currentUsername: controlState?.ib_username,
                currentMode: controlState?.ib_mode,
                savedGateways: controlState?.saved_gateways
            })
        ]
    });
};
var $2b80c7f69ff3fe88$export$2e2bcd8739ae039 = $2b80c7f69ff3fe88$var$InvestorAccountSummary;



var $ayMG0 = parcelRequire("ayMG0");

var $kvv04 = parcelRequire("kvv04");

var $acw62 = parcelRequire("acw62");

var $02HYJ = parcelRequire("02HYJ");
var $kTCPA = parcelRequire("kTCPA");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $dc81eef52ef659a2$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Circle", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
]);


var $7ZFis = parcelRequire("7ZFis");
var $4Yp7M = parcelRequire("4Yp7M");
var $dkOIy = parcelRequire("dkOIy");
var $iIubC = parcelRequire("iIubC");
var $lsK68 = parcelRequire("lsK68");

var $2wVnk = parcelRequire("2wVnk");

var $cfqjJ = parcelRequire("cfqjJ");
const $7fbca3b5910df173$var$InvestorQuickStart = ()=>{
    const [showConfigModal, setShowConfigModal] = (0, $acw62.useState)(false);
    const [controlState, setControlState] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [activeAction, setActiveAction] = (0, $acw62.useState)(null);
    const [gatewayError, setGatewayError] = (0, $acw62.useState)(null);
    const [setupRefreshing, setSetupRefreshing] = (0, $acw62.useState)(false);
    const abortControllerRef = (0, $acw62.useRef)(null);
    const fetchControlState = async ()=>{
        try {
            const response = await (0, $2wVnk.tradingApi).getSystemControlState();
            if (response.success && response.data) setControlState(response.data);
        } catch (err) {
            console.warn("Failed to fetch control state:", err);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchControlState();
        const id = setInterval(fetchControlState, 5000);
        return ()=>clearInterval(id);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!gatewayError) return;
        const timer = setTimeout(()=>setGatewayError(null), 10000);
        return ()=>clearTimeout(timer);
    }, [
        gatewayError
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, []);
    const handleConfigureClick = async ()=>{
        setLoading(true);
        setGatewayError(null);
        try {
            const response = await (0, $2wVnk.tradingApi).getSystemControlState();
            if (response.success && response.data) {
                setControlState(response.data);
                setShowConfigModal(true);
            }
        } catch (err) {
            console.warn("Failed to open configuration:", err);
            setShowConfigModal(true);
        } finally{
            setLoading(false);
        }
    };
    const isGatewayActive = controlState?.gateway_running ?? controlState?.ib_connected ?? false;
    const isBrokerConnected = controlState?.ib_connected ?? false;
    const isConfigured = controlState?.gateway_configured ?? false;
    const showSetupPreparing = setupRefreshing && !isConfigured;
    const handleGatewayConfigSuccess = async ()=>{
        setSetupRefreshing(true);
        setGatewayError(null);
        await fetchControlState();
        setTimeout(()=>setSetupRefreshing(false), 2500);
    };
    const handleCancel = async ()=>{
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
        setLoading(false);
        setActiveAction(null);
        try {
            // Explicitly stop the gateway to ensure cleanup
            await (0, $2wVnk.tradingApi).controlIBGateway("stop");
            await fetchControlState();
        } catch (err) {
            console.warn("Failed to stop gateway during cancellation:", err);
        }
    };
    const handleConnectClick = async ()=>{
        if (!controlState) return;
        if (!isConfigured && !isGatewayActive) {
            handleConfigureClick();
            return;
        }
        // If we are currently connecting, clicking again acts as a cancel action
        if (loading && activeAction === "start") {
            await handleCancel();
            return;
        }
        setLoading(true);
        setGatewayError(null);
        const action = isGatewayActive ? "stop" : "start";
        setActiveAction(action);
        // Cancel any existing controller and establish a new one
        if (abortControllerRef.current) abortControllerRef.current.abort();
        const controller = new AbortController();
        abortControllerRef.current = controller;
        try {
            const response = await (0, $2wVnk.tradingApi).controlIBGateway(action);
            if (response.success) {
                if (action === "start") {
                    // Poll for connection progress up to 30 seconds
                    let attempts = 0;
                    let maxAttempts = 30;
                    while(attempts < maxAttempts && abortControllerRef.current === controller){
                        await fetchControlState();
                        try {
                            const status = await (0, $2wVnk.tradingApi).getSystemControlState();
                            if (status.success && status.data) {
                                const statusData = status.data;
                                // Update hint/error states if any
                                if (statusData.gateway_hint) maxAttempts = Math.max(maxAttempts, 120); // extend window if user action is pending
                                if (statusData.connection_error) {
                                    const lower = statusData.connection_error.toLowerCase();
                                    const isFatal = lower.includes("invalid credential") || lower.includes("trading mode mismatch") || lower.includes("returned exit status") || lower.includes("failed to decrypt") || lower.includes("fatal");
                                    if (isFatal) {
                                        setGatewayError(statusData.connection_error);
                                        await (0, $2wVnk.tradingApi).controlIBGateway("stop");
                                        break;
                                    }
                                }
                                if (statusData.ib_connected) break;
                            }
                        } catch (e) {
                            console.warn("Failed to poll status:", e);
                        }
                        await new Promise((resolve)=>setTimeout(resolve, 1000));
                        attempts++;
                    }
                }
                await fetchControlState();
            } else setGatewayError(response.error || response.message || `Failed to ${action} gateway`);
        } catch (err) {
            if (err.name === 'AbortError') console.log('Broker connection connection cancelled');
            else setGatewayError(err.message || "Failed to control gateway");
        } finally{
            if (abortControllerRef.current === controller) {
                setLoading(false);
                setActiveAction(null);
                abortControllerRef.current = null;
            }
        }
    };
    const show2FABanner = controlState?.gateway_running && !controlState?.ib_connected;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-4 w-full",
        children: [
            gatewayError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "rounded-xl bg-error-500/10 border border-error-500/20 px-4 py-3 flex items-start justify-between gap-4 animate-in slide-in-from-top-2 duration-200",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-start gap-2.5 text-sm text-error-500",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02HYJ.default), {
                                size: 16,
                                className: "text-error-500 mt-0.5 flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: gatewayError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeButton), {
                        variant: "danger",
                        size: "sm",
                        type: "button",
                        onClick: ()=>setGatewayError(null),
                        children: "Dismiss"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-3 gap-4 items-stretch",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: handleConfigureClick,
                        disabled: loading,
                        className: `w-full min-h-[112px] text-left rounded-xl bg-white/5 border p-4 flex items-center justify-between hover:bg-white/10 transition-colors duration-300 group cursor-pointer focus:outline-none focus:ring-1 focus:ring-neon/40 disabled:opacity-50 ${isConfigured ? 'border-success-500/30 shadow-[0_0_15px_rgba(16,185,129,0.05)]' : 'border-white/10'}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `h-10 w-10 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform flex-shrink-0 ${isConfigured ? 'bg-success-500/20 text-success-500' : 'bg-white/10 text-muted'}`,
                                        children: loading || showSetupPreparing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                            size: 20,
                                            className: "animate-spin"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIubC.default), {
                                            size: 20
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "text-sm font-semibold text-white",
                                                children: "1. Configure IB Connection"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-xs text-muted",
                                                children: showSetupPreparing ? 'Saving setup and preparing broker controls...' : 'Set up your Interactive Brokers connection details.'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex-shrink-0 ml-2",
                                children: isConfigured ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kTCPA.default), {
                                    className: "w-5 h-5 text-success-500 drop-shadow-[0_0_8px_rgba(16,185,129,0.5)] animate-in zoom-in-50 duration-300"
                                }) : showSetupPreparing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                    className: "w-5 h-5 text-info-500 animate-spin"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dc81eef52ef659a2$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 text-muted/40"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col gap-3 w-full h-full",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                onClick: handleConnectClick,
                                disabled: !controlState || showSetupPreparing || loading && activeAction === "stop",
                                className: `w-full flex-1 min-h-[112px] text-left rounded-xl bg-white/5 border p-4 flex items-center justify-between hover:bg-white/10 transition-colors duration-300 group cursor-pointer focus:outline-none focus:ring-1 focus:ring-neon/40 disabled:opacity-50 ${loading && activeAction === "start" ? 'border-warning-500/30 shadow-[0_0_15px_rgba(245,158,11,0.05)] bg-warning-500/5' : isGatewayActive ? 'border-success-500/30 shadow-[0_0_15px_rgba(16,185,129,0.05)]' : 'border-white/10'}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `h-10 w-10 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform flex-shrink-0 ${loading && activeAction === "start" ? 'bg-warning-500/20 text-warning-500' : isGatewayActive ? 'bg-error-500/20 text-error-500' : 'bg-info-500/20 text-info-500'}`,
                                                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                    size: 20,
                                                    className: "animate-spin"
                                                }) : isGatewayActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsK68.default), {
                                                    size: 20
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dkOIy.default), {
                                                    size: 20
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        className: "text-sm font-semibold text-white flex items-center gap-2",
                                                        children: showSetupPreparing ? "2. Preparing Broker" : loading && activeAction === "start" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "2. Connecting to Broker..."
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "text-[10px] bg-error-500/20 text-error-500 border border-error-500/30 px-1.5 py-0.5 rounded animate-pulse",
                                                                    children: "Click to Cancel"
                                                                })
                                                            ]
                                                        }) : isGatewayActive ? "2. Disconnect Broker" : "2. Connect to Broker"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-xs text-muted",
                                                        children: showSetupPreparing ? "Broker controls will be ready in a moment." : loading && activeAction === "start" ? "Establishing secure session. Click anywhere on this button to cancel connection." : isGatewayActive ? "Disconnect from Interactive Brokers." : "Launch the connection to begin the broker session."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex-shrink-0 ml-2",
                                        children: loading && activeAction === "start" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                            className: "w-5 h-5 text-warning-500 animate-spin"
                                        }) : isGatewayActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kTCPA.default), {
                                            className: "w-5 h-5 text-success-500 drop-shadow-[0_0_8px_rgba(16,185,129,0.5)] animate-in zoom-in-50 duration-300"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dc81eef52ef659a2$export$2e2bcd8739ae039), {
                                            className: "w-5 h-5 text-muted/40"
                                        })
                                    })
                                ]
                            }),
                            show2FABanner && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w-full rounded-xl bg-warning-500/10 border border-warning-500/20 p-3.5 flex flex-col gap-2.5 shadow-[0_0_15px_rgba(245,158,11,0.05)] animate-pulse",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-start gap-2.5",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02HYJ.default), {
                                                size: 16,
                                                className: "text-warning-500 mt-0.5 flex-shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        className: "text-xs font-semibold text-warning-500",
                                                        children: "Action Required: Complete 2FA"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-[10px] text-warning-500/80 leading-relaxed mt-1",
                                                        children: controlState?.gateway_hint || "Gateway connection is starting. Please check your mobile phone for an Interactive Brokers (IB Key) 2FA push notification to approve the secure session."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-1.5 text-[10px] text-warning-500 font-semibold bg-warning-500/20 px-2.5 py-1 rounded border border-warning-500/30 w-max",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                size: 10,
                                                className: "animate-spin"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Awaiting 2FA Confirmation"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `min-h-[112px] rounded-xl bg-white/5 border p-4 flex items-center justify-between hover:bg-white/10 transition-colors duration-300 group ${isBrokerConnected ? 'border-success-500/30 shadow-[0_0_15px_rgba(16,185,129,0.05)]' : 'border-white/10'}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `h-10 w-10 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform flex-shrink-0 mt-0.5 ${isBrokerConnected ? 'bg-success-500/20 text-success-500' : 'bg-white/10 text-muted'}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ZFis.default), {
                                            size: 20
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "text-sm font-semibold text-white",
                                                children: "3. Monitor Anytime"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-xs text-muted",
                                                children: "You can close this window; trading runs 24/7 in the cloud."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-[10px] text-warning-500/85 mt-1",
                                                children: "Reconnects require mobile 2FA; auto-restart runs Sunday night."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex-shrink-0 ml-2",
                                children: isBrokerConnected ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kTCPA.default), {
                                    className: "w-5 h-5 text-success-500 drop-shadow-[0_0_8px_rgba(16,185,129,0.5)] animate-in zoom-in-50 duration-300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dc81eef52ef659a2$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 text-muted/40"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfqjJ.default), {
                        isOpen: showConfigModal,
                        onClose: ()=>setShowConfigModal(false),
                        onSuccess: handleGatewayConfigSuccess,
                        currentUsername: controlState?.ib_username,
                        currentMode: controlState?.ib_mode,
                        savedGateways: controlState?.saved_gateways
                    })
                ]
            })
        ]
    });
};
var $7fbca3b5910df173$export$2e2bcd8739ae039 = $7fbca3b5910df173$var$InvestorQuickStart;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");

var $bKJAw = parcelRequire("bKJAw");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $176d5bb5050be9a3$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Moon", [
    [
        "path",
        {
            d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z",
            key: "a7tn18"
        }
    ]
]);

/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $552554c986ed6ef6$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Sun", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "m17.66 17.66 1.41 1.41",
            key: "ptbguv"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "m6.34 17.66-1.41 1.41",
            key: "1m8zz5"
        }
    ],
    [
        "path",
        {
            d: "m19.07 4.93-1.41 1.41",
            key: "1shlcs"
        }
    ]
]);


var $hiXj7 = parcelRequire("hiXj7");

var $jtEPT = parcelRequire("jtEPT");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $02HYJ = parcelRequire("02HYJ");
var $kTCPA = parcelRequire("kTCPA");
var $5ArKp = parcelRequire("5ArKp");

var $b1rqt = parcelRequire("b1rqt");
const $aa65f0128508696a$var$StrategyMarginStatus = ({ status: status, compact: compact = false })=>{
    const required = status?.free_margin_required;
    const available = status?.free_margin_available;
    const sufficient = status?.free_margin_available_for_strategy;
    const currency = status?.free_margin_currency || 'USD';
    const badge = sufficient === true ? {
        label: 'Available',
        className: 'border-emerald-400/20 bg-emerald-400/10 text-emerald-300',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kTCPA.default), {
            className: "h-3.5 w-3.5"
        })
    } : sufficient === false ? {
        label: 'Shortfall',
        className: 'border-rose-400/20 bg-rose-400/10 text-rose-300',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02HYJ.default), {
            className: "h-3.5 w-3.5"
        })
    } : {
        label: 'Unavailable',
        className: 'border-white/10 bg-white/5 text-muted',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ArKp.default), {
            className: "h-3.5 w-3.5"
        })
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `rounded-xl border border-white/10 bg-black/20 ${compact ? 'p-3' : 'p-4'}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-[10px] font-black uppercase tracking-[0.16em] text-muted",
                                children: "Free margin"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mt-1 text-xs text-white/60",
                                children: status?.free_margin_basis || 'Waiting for strategy sizing'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider ${badge.className}`,
                        children: [
                            badge.icon,
                            badge.label
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `mt-3 grid gap-3 ${compact ? 'grid-cols-2' : 'grid-cols-1 sm:grid-cols-3'}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-[10px] uppercase tracking-wider text-muted",
                                children: "Required"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mt-1 font-mono text-sm font-semibold text-white",
                                children: (0, $b1rqt.formatCurrency)(required, currency)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-[10px] uppercase tracking-wider text-muted",
                                children: "Available"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mt-1 font-mono text-sm font-semibold text-white",
                                children: (0, $b1rqt.formatCurrency)(available, currency)
                            })
                        ]
                    }),
                    !compact && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "text-[10px] uppercase tracking-wider text-muted",
                                children: "Shortfall"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `mt-1 font-mono text-sm font-semibold ${status?.free_margin_shortfall ? 'text-rose-300' : 'text-emerald-300'}`,
                                children: (0, $b1rqt.formatCurrency)(status?.free_margin_shortfall, currency)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt-3 text-[10px] leading-relaxed text-white/40",
                children: "Estimated from current strategy sizing; IB available funds are the account availability check."
            })
        ]
    });
};
var $aa65f0128508696a$export$2e2bcd8739ae039 = $aa65f0128508696a$var$StrategyMarginStatus;


const $14cc9ec74b1dced6$var$InvestorStrategyView = ()=>{
    const onStatus = (0, $jtEPT.useStrategyStatusQuery)('ON', {
        pollingInterval: 30000
    }).data;
    const orbStatus = (0, $jtEPT.useStrategyStatusQuery)('ORB', {
        pollingInterval: 30000
    }).data;
    const dtStatus = (0, $jtEPT.useStrategyStatusQuery)('DT', {
        pollingInterval: 30000
    }).data;
    const nqmmStatus = (0, $jtEPT.useStrategyStatusQuery)('NQMM', {
        pollingInterval: 30000
    }).data;
    const [configs, setConfigs] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>{
        const fetchConfigs = async ()=>{
            try {
                const [onConfig, orbConfig, dtConfig, nqmmConfig] = await Promise.all([
                    (0, $2wVnk.tradingApi).getStrategyDbConfig('ON'),
                    (0, $2wVnk.tradingApi).getStrategyDbConfig('ORB'),
                    (0, $2wVnk.tradingApi).getStrategyDbConfig('DT'),
                    (0, $2wVnk.tradingApi).getStrategyDbConfig('NQMM')
                ]);
                setConfigs({
                    ON: onConfig,
                    ORB: orbConfig,
                    DT: dtConfig,
                    NQMM: nqmmConfig
                });
            } catch (error) {
                console.warn('Failed to fetch strategy configuration for investor view', error);
            }
        };
        fetchConfigs();
        const interval = setInterval(fetchConfigs, 30000);
        return ()=>clearInterval(interval);
    }, []);
    const strategies = (0, $acw62.useMemo)(()=>{
        const getSymbols = (name, status)=>{
            const active = status?.data?.selected_symbols || status?.data?.active_symbols;
            if (name === 'NQMM' && Array.isArray(active) && active.length > 0) return active;
            const configured = configs[name]?.data?.config?.symbols;
            if (Array.isArray(configured) && configured.length > 0) return configured;
            return Array.isArray(active) ? active : [];
        };
        return {
            ON: {
                enabled: Boolean(onStatus?.data?.enabled),
                hydrated: Boolean(onStatus?.data?.hydrated),
                runtimeStale: Boolean(onStatus?.data?.runtime_stale),
                statusLoaded: Boolean(onStatus?.success && onStatus?.data),
                symbols: getSymbols('ON', onStatus)
            },
            ORB: {
                enabled: Boolean(orbStatus?.data?.enabled),
                hydrated: Boolean(orbStatus?.data?.hydrated),
                runtimeStale: Boolean(orbStatus?.data?.runtime_stale),
                statusLoaded: Boolean(orbStatus?.success && orbStatus?.data),
                symbols: getSymbols('ORB', orbStatus)
            },
            DT: {
                enabled: Boolean(dtStatus?.data?.enabled),
                hydrated: Boolean(dtStatus?.data?.hydrated),
                runtimeStale: Boolean(dtStatus?.data?.runtime_stale),
                statusLoaded: Boolean(dtStatus?.success && dtStatus?.data),
                symbols: getSymbols('DT', dtStatus)
            },
            NQMM: {
                enabled: Boolean(nqmmStatus?.data?.enabled),
                hydrated: Boolean(nqmmStatus?.data?.hydrated),
                runtimeStale: Boolean(nqmmStatus?.data?.runtime_stale),
                statusLoaded: Boolean(nqmmStatus?.success && nqmmStatus?.data),
                symbols: getSymbols('NQMM', nqmmStatus),
                sleeveAllocation: nqmmStatus?.data?.sleeve_allocation ?? nqmmStatus?.data?.position_size,
                universeSize: nqmmStatus?.data?.universe_size ?? configs.NQMM?.data?.config?.constituent_count
            }
        };
    }, [
        configs,
        dtStatus,
        nqmmStatus,
        onStatus,
        orbStatus
    ]);
    const StatusBadge = ({ strategy: strategy })=>{
        const label = !strategy.statusLoaded ? 'Unavailable' : !strategy.enabled ? 'Disabled' : strategy.runtimeStale ? 'Stale' : !strategy.hydrated ? 'Starting' : 'Enabled';
        const active = strategy.statusLoaded && strategy.enabled && !strategy.runtimeStale;
        const className = !strategy.statusLoaded ? 'bg-white/5 text-muted border-white/5' : !strategy.enabled ? 'bg-white/5 text-muted border-white/5' : strategy.runtimeStale ? 'bg-warning-500/10 text-warning-400 border-warning-500/20' : 'bg-success-500/10 text-success-500 border-success-500/20';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `flex items-center gap-1.5 px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border ${className}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: `w-1.5 h-1.5 rounded-full ${active ? 'bg-success-500 animate-pulse' : 'bg-gray-500'}`
                }),
                label
            ]
        });
    };
    const SymbolTags = ({ symbols: symbols })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flex flex-wrap gap-1.5 mt-3",
            children: symbols.map((sym)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "px-1.5 py-0.5 rounded bg-white/5 border border-white/5 text-[10px] font-mono text-muted",
                    children: sym
                }, sym))
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "panel full-bleed-panel",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-6 border-b border-white/10",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-3 mb-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "p-2 rounded-lg bg-neon/10 text-neon",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bKJAw.default), {
                                className: "w-5 h-5"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "text-lg font-bold text-white",
                                    children: "Strategy Overview"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-sm text-muted",
                                    children: "Configured automated systems and their current runtime status."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-white/10",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-6 space-y-4 hover:bg-white/2 transition duration-300",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-start justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-2 rounded-lg bg-indigo-500/20 text-indigo-400",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00b4789eeda33397$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        className: "font-bold text-white",
                                                        children: "Opening Range Breakout"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "text-xs font-mono text-muted mt-0.5",
                                                        children: "STRATEGY: ORB"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(StatusBadge, {
                                        strategy: strategies.ORB
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-sm text-gray-400 leading-relaxed",
                                children: "An intraday strategy that seeks to participate in strong moves after the market opens, with defined risk controls and no overnight exposure."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(SymbolTags, {
                                symbols: strategies.ORB.symbols
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa65f0128508696a$export$2e2bcd8739ae039), {
                                status: orbStatus?.data,
                                compact: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "text-xs font-semibold text-muted uppercase tracking-wider mb-2",
                                        children: "Key Features"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "grid grid-cols-2 gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-indigo-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-indigo-400/50"
                                                    }),
                                                    "Morning Volatility"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-indigo-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-indigo-400/50"
                                                    }),
                                                    "Momentum Based"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-indigo-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-indigo-400/50"
                                                    }),
                                                    "Strict Stop Loss"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-indigo-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-indigo-400/50"
                                                    }),
                                                    "No Overnight Risk"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-6 space-y-4 hover:bg-white/2 transition duration-300",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-start justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-2 rounded-lg bg-orange-500/20 text-orange-400",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $552554c986ed6ef6$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        className: "font-bold text-white",
                                                        children: "Intraday Trend"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "text-xs font-mono text-muted mt-0.5",
                                                        children: "STRATEGY: DT"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(StatusBadge, {
                                        strategy: strategies.DT
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-sm text-gray-400 leading-relaxed",
                                children: "An intraday trend-following strategy that responds to market movement during the session and closes positions before the day ends."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(SymbolTags, {
                                symbols: strategies.DT.symbols
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa65f0128508696a$export$2e2bcd8739ae039), {
                                status: dtStatus?.data,
                                compact: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "text-xs font-semibold text-muted uppercase tracking-wider mb-2",
                                        children: "Key Features"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "grid grid-cols-2 gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-orange-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-orange-400/50"
                                                    }),
                                                    "Trend Following"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-orange-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-orange-400/50"
                                                    }),
                                                    "Volatility Adaptive"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-orange-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-orange-400/50"
                                                    }),
                                                    "Dynamic Risk Mgmt"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-orange-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-orange-400/50"
                                                    }),
                                                    "EOD Exit"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-6 space-y-4 hover:bg-white/2 transition duration-300",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-start justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-2 rounded-lg bg-purple-500/20 text-purple-400",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $176d5bb5050be9a3$export$2e2bcd8739ae039), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        className: "font-bold text-white",
                                                        children: "Overnight Swing"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "text-xs font-mono text-muted mt-0.5",
                                                        children: "STRATEGY: ON"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(StatusBadge, {
                                        strategy: strategies.ON
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-sm text-gray-400 leading-relaxed",
                                children: "A long overnight strategy designed to capture moves between market sessions, with positions closed during the following trading session."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(SymbolTags, {
                                symbols: strategies.ON.symbols
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa65f0128508696a$export$2e2bcd8739ae039), {
                                status: onStatus?.data,
                                compact: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "text-xs font-semibold text-muted uppercase tracking-wider mb-2",
                                        children: "Key Features"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "grid grid-cols-2 gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-purple-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-purple-400/50"
                                                    }),
                                                    "Overnight Edge"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-purple-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-purple-400/50"
                                                    }),
                                                    "Mean Reversion"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-purple-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-purple-400/50"
                                                    }),
                                                    "Diversified"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-purple-200/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-purple-400/50"
                                                    }),
                                                    "Gap Capture"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p-6 space-y-4 hover:bg-white/2 transition duration-300",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-start justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-2 rounded-lg bg-success-500/20 text-success-500",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiXj7.default), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        className: "font-bold text-white",
                                                        children: "Nasdaq-100 Momentum"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "text-xs font-mono text-muted mt-0.5",
                                                        children: "STRATEGY: NQMM"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(StatusBadge, {
                                        strategy: strategies.NQMM
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "text-sm text-gray-400 leading-relaxed",
                                children: "A long-only portfolio sleeve that ranks Nasdaq-100 stocks by relative momentum and periodically reallocates toward stronger names."
                            }),
                            strategies.NQMM.universeSize !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "text-[10px] font-mono text-success-500/80",
                                children: [
                                    "Database QQQ universe: ",
                                    strategies.NQMM.universeSize,
                                    " constituents"
                                ]
                            }),
                            strategies.NQMM.symbols.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)(SymbolTags, {
                                symbols: strategies.NQMM.symbols.slice(0, 12)
                            }),
                            strategies.NQMM.symbols.length > 12 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "text-[10px] text-muted -mt-2",
                                children: [
                                    "+",
                                    strategies.NQMM.symbols.length - 12,
                                    " more active names"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa65f0128508696a$export$2e2bcd8739ae039), {
                                status: nqmmStatus?.data,
                                compact: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pt-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "text-xs font-semibold text-muted uppercase tracking-wider mb-2",
                                        children: "Key Features"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "grid grid-cols-2 gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-success-500/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-success-500/50"
                                                    }),
                                                    "Monthly Rebalance"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-success-500/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-success-500/50"
                                                    }),
                                                    "Cross-Sectional Rank"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-success-500/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-success-500/50"
                                                    }),
                                                    "Portfolio Sleeve"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "text-xs text-success-500/70 flex items-center gap-1.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w-1 h-1 rounded-full bg-success-500/50"
                                                    }),
                                                    "Long Only"
                                                ]
                                            })
                                        ]
                                    }),
                                    strategies.NQMM.sleeveAllocation !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mt-3 text-[10px] font-mono text-success-500/80",
                                        children: [
                                            "Sleeve allocation: ",
                                            (strategies.NQMM.sleeveAllocation * 100).toFixed(1),
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $14cc9ec74b1dced6$export$2e2bcd8739ae039 = $14cc9ec74b1dced6$var$InvestorStrategyView;



var $ayMG0 = parcelRequire("ayMG0");

var $kvv04 = parcelRequire("kvv04");

var $alUHf = parcelRequire("alUHf");

var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");

var $eUAhq = parcelRequire("eUAhq");

var $8Zl6K = parcelRequire("8Zl6K");

var $iqWry = parcelRequire("iqWry");

var $k8QNV = parcelRequire("k8QNV");
const $5d093e3c912a4830$var$DASHBOARD_LOG_FETCH_LIMIT = 2000;
const $5d093e3c912a4830$var$DASHBOARD_LOG_DISPLAY_LIMIT = 1000;
const $5d093e3c912a4830$var$LogViewer = ()=>{
    const [logs, setLogs] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [levelFilter, setLevelFilter] = (0, $acw62.useState)('ALL');
    const [componentFilter, setComponentFilter] = (0, $acw62.useState)('ALL');
    const [autoScroll, setAutoScroll] = (0, $acw62.useState)(true);
    const logsContainerRef = (0, $acw62.useRef)(null);
    const logsFingerprintRef = (0, $acw62.useRef)('');
    const requestInFlightRef = (0, $acw62.useRef)(false);
    const fetchLogs = (0, $acw62.useCallback)(async (isInitialLoad = false)=>{
        if (requestInFlightRef.current) return;
        requestInFlightRef.current = true;
        if (isInitialLoad) setLoading(true);
        setError(null);
        try {
            // Stagger initial API call for initial load
            if (isInitialLoad) await new Promise((resolve)=>setTimeout(resolve, 300));
            const response = await (0, $2wVnk.tradingApi).getRecentLogs($5d093e3c912a4830$var$DASHBOARD_LOG_FETCH_LIMIT, levelFilter === 'ALL' ? undefined : levelFilter);
            if (response.success && response.data) {
                const nextLogs = response.data?.logs || [];
                const first = nextLogs[0];
                const last = nextLogs[nextLogs.length - 1];
                const fingerprint = [
                    nextLogs.length,
                    first?.timestamp,
                    first?.message,
                    last?.timestamp,
                    last?.message
                ].join('|');
                if (fingerprint !== logsFingerprintRef.current) {
                    logsFingerprintRef.current = fingerprint;
                    setLogs(nextLogs);
                }
            } else if (isInitialLoad) setLogs([]);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to fetch logs');
            if (isInitialLoad) setLogs([]);
        } finally{
            requestInFlightRef.current = false;
            setLoading(false);
        }
    }, [
        levelFilter
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchLogs(true);
    }, [
        fetchLogs
    ]);
    (0, $acw62.useEffect)(()=>{
        const refreshWhenVisible = ()=>{
            if (document.visibilityState === 'visible') fetchLogs();
        };
        const intervalId = window.setInterval(refreshWhenVisible, 10000);
        document.addEventListener('visibilitychange', refreshWhenVisible);
        return ()=>{
            window.clearInterval(intervalId);
            document.removeEventListener('visibilitychange', refreshWhenVisible);
        };
    }, [
        fetchLogs
    ]);
    (0, $acw62.useEffect)(()=>{
        // Auto-scroll to bottom when new logs arrive
        if (autoScroll && logsContainerRef.current) logsContainerRef.current.scrollTop = logsContainerRef.current.scrollHeight;
    }, [
        logs,
        autoScroll
    ]);
    const getLevelColor = (level)=>(0, $alUHf.themeToneTextClasses)[(0, $alUHf.getLogLevelTone)(level)];
    const getLevelBadge = (level)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeBadge), {
            tone: (0, $alUHf.getLogLevelTone)(level),
            children: level
        });
    const formatTimestamp = (timestamp)=>{
        return (0, $k8QNV.formatTimeET)(timestamp);
    };
    const handleScroll = ()=>{
        if (logsContainerRef.current) {
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = logsContainerRef.current;
            const isNearBottom = scrollHeight - scrollTop - clientHeight < 50;
            setAutoScroll(isNearBottom);
        }
    };
    const levels = [
        'ALL',
        'INFO',
        'WARNING',
        'ERROR'
    ];
    const strategyComponents = [
        'ONStrategy',
        'ORBStrategy',
        'ATRDTStrategy'
    ];
    const visibleLogs = (0, $acw62.useMemo)(()=>{
        const filtered = componentFilter === 'ALL' ? logs : logs.filter((log)=>log.component === componentFilter);
        // Keep the dashboard DOM bounded while retaining a longer recent window.
        return filtered.slice(-$5d093e3c912a4830$var$DASHBOARD_LOG_DISPLAY_LIMIT);
    }, [
        componentFilter,
        logs
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "panel full-bleed-panel w-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "px-6 py-5 border-b border-white/10",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col gap-3 md:flex-row md:items-center md:justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-2 rounded-lg bg-neon/10 text-neon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eUAhq.default), {
                                        className: "w-5 h-5"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "space-y-0.5",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "text-lg font-bold text-white tracking-tight",
                                            children: "System Logs"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-xs text-muted font-medium",
                                            children: "Real-time telemetry, execution logs, and system alerts."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-3 md:justify-end",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex items-center gap-2 text-xs",
                                    children: levels.map((lvl)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>setLevelFilter(lvl),
                                            className: `px-2.5 py-1 rounded-lg border text-[11px] font-semibold transition ${levelFilter === lvl ? 'border-neon text-neon bg-neon/10' : 'border-white/15 text-muted hover:text-foreground hover:border-neon/40'}`,
                                            children: lvl
                                        }, lvl))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-2 text-[11px] text-muted",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "uppercase tracking-[0.16em]",
                                            children: "Strategies"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>setComponentFilter('ALL'),
                                                    className: `px-2 py-1 rounded-lg transition ${componentFilter === 'ALL' ? 'bg-white/10 text-foreground' : 'text-muted hover:text-foreground hover:bg-white/5'}`,
                                                    children: "All"
                                                }),
                                                strategyComponents.map((name)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: ()=>setComponentFilter(name),
                                                        className: `px-2 py-1 rounded-lg transition ${componentFilter === name ? 'bg-neon/15 text-neon' : 'text-muted hover:text-foreground hover:bg-white/5'}`,
                                                        children: name.replace('Strategy', '')
                                                    }, name))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "flex items-center gap-2 text-xs text-muted",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            id: "auto-scroll",
                                            checked: autoScroll,
                                            onChange: (e)=>setAutoScroll(e.target.checked),
                                            className: "h-3 w-3 text-neon focus:ring-neon border-line bg-dark-1"
                                        }),
                                        "Auto-scroll"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-5",
                children: [
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iqWry.default), {
                        error: error,
                        onRetry: ()=>fetchLogs(),
                        message: "Failed to load logs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "h-80 overflow-hidden",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            ref: logsContainerRef,
                            onScroll: handleScroll,
                            className: "h-full overflow-y-auto scrollbar-thin p-4 font-mono text-xs text-foreground",
                            children: loading && logs.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex justify-center items-center h-full",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Zl6K.default), {
                                    size: "lg"
                                })
                            }) : logs.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex justify-center items-center h-full text-muted",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-4xl mb-4",
                                            children: "\uD83D\uDCCB"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "No logs available"
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "space-y-0.5",
                                children: visibleLogs.map((log, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex flex-col sm:hidden hover:bg-dark-4 p-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center justify-between w-full mb-1 text-[10px] text-muted",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "flex items-center space-x-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        children: formatTimestamp(log.timestamp)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "truncate max-w-[120px]",
                                                                        children: log.logger
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                children: getLevelBadge(log.level)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "flex-1 break-words text-sm",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: getLevelColor(log.level),
                                                            children: log.message
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "hidden sm:flex items-start space-x-3 hover:bg-dark-4 p-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "text-[11px] text-muted mt-0.5 min-w-[80px] flex-shrink-0",
                                                        children: formatTimestamp(log.timestamp)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "min-w-[80px] flex-shrink-0 mt-0.5",
                                                        children: getLevelBadge(log.level)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "text-[11px] text-muted min-w-[100px] flex-shrink-0 mt-0.5",
                                                        children: log.logger
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "flex-1 break-words",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: getLevelColor(log.level),
                                                            children: log.message
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `${log.timestamp}-${index}`))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-muted",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center flex-wrap gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            logs.length,
                                            " entries"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            "Level: ",
                                            levelFilter
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            "Auto-scroll: ",
                                            autoScroll ? 'On' : 'Off'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeButton), {
                                        variant: "ghost",
                                        size: "sm",
                                        onClick: ()=>setAutoScroll(true),
                                        disabled: autoScroll,
                                        children: "Go to Latest"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeButton), {
                                        variant: "secondary",
                                        size: "sm",
                                        onClick: ()=>fetchLogs(),
                                        children: "Refresh"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $5d093e3c912a4830$export$2e2bcd8739ae039 = $5d093e3c912a4830$var$LogViewer;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");

var $4wROA = parcelRequire("4wROA");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $8872a1d80d2463f9$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Tag", [
    [
        "path",
        {
            d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
            key: "vktsd0"
        }
    ],
    [
        "circle",
        {
            cx: "7.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "kqv944"
        }
    ]
]);


var $hPAJY = parcelRequire("hPAJY");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");

var $iqWry = parcelRequire("iqWry");

var $k8QNV = parcelRequire("k8QNV");

var $b1rqt = parcelRequire("b1rqt");

var $7s03j = parcelRequire("7s03j");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $di5Ac = parcelRequire("di5Ac");
var $hPAJY = parcelRequire("hPAJY");
const $1ce8a6e7c3701980$export$233c8e1804dc7af2 = (order, filter)=>{
    const target = filter.trim().toUpperCase();
    if (!target) return true;
    return [
        order.symbol,
        order.rootSymbol,
        order.localSymbol,
        order.lastTradeDateOrContractMonth
    ].some((value)=>String(value || '').toUpperCase().includes(target));
};
const $1ce8a6e7c3701980$var$OrderSymbolFilter = ({ orders: orders, value: value, onChange: onChange })=>{
    const symbols = (0, $acw62.useMemo)(()=>Array.from(new Set(orders.map((order)=>String(order.symbol || order.rootSymbol || order.localSymbol || '').trim().toUpperCase()).filter(Boolean))).sort(), [
        orders
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-wrap items-center gap-2 rounded-xl border border-white/10 bg-white/[0.025] px-3 py-2.5",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "mr-1 text-[10px] font-black uppercase tracking-widest text-white/40",
                children: "Quick symbol"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                type: "button",
                onClick: ()=>onChange(''),
                className: `rounded-lg border px-2.5 py-1.5 text-[10px] font-bold uppercase tracking-wider transition-colors ${!value ? 'border-neon/30 bg-neon/10 text-neon' : 'border-white/10 text-white/50 hover:border-white/20 hover:text-white'}`,
                children: "All"
            }),
            symbols.map((symbol)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    type: "button",
                    onClick: ()=>onChange(symbol),
                    className: `rounded-lg border px-2.5 py-1.5 text-[10px] font-bold tracking-wider transition-colors ${value.toUpperCase() === symbol ? 'border-neon/30 bg-neon/10 text-neon' : 'border-white/10 text-white/50 hover:border-neon/25 hover:text-neon'}`,
                    children: symbol
                }, symbol)),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: "relative ml-auto min-w-[180px] flex-1 sm:max-w-[240px]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $di5Ac.default), {
                        className: "pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-white/35"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "search",
                        value: value,
                        onChange: (event)=>onChange(event.target.value),
                        placeholder: "Filter symbol\u2026",
                        "aria-label": "Filter orders by symbol",
                        className: "h-8 w-full rounded-lg border border-white/10 bg-black/20 pl-8 pr-8 text-xs text-white outline-none placeholder:text-white/30 focus:border-neon/40"
                    }),
                    value && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>onChange(''),
                        className: "absolute right-1.5 top-1/2 -translate-y-1/2 rounded p-1 text-white/40 hover:bg-white/10 hover:text-white",
                        "aria-label": "Clear symbol filter",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                            className: "h-3.5 w-3.5"
                        })
                    })
                ]
            })
        ]
    });
};
var $1ce8a6e7c3701980$export$2e2bcd8739ae039 = $1ce8a6e7c3701980$var$OrderSymbolFilter;


const $5f3266c1f84cfee9$var$OpenOrders = ({ refreshInterval: refreshInterval = 30000, onEditOrder: onEditOrder, securityTypeFilter: securityTypeFilter = 'ALL' })=>{
    const [orders, setOrders] = (0, $acw62.useState)([]);
    const [page, setPage] = (0, $acw62.useState)(1);
    const pageSize = 10; // Increased page size for better oversight
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [refreshing, setRefreshing] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [errorHeader, setErrorHeader] = (0, $acw62.useState)("Failed to load data");
    const [lastUpdated, setLastUpdated] = (0, $acw62.useState)(null);
    const [symbolFilter, setSymbolFilter] = (0, $acw62.useState)('');
    const [cancellingId, setCancellingId] = (0, $acw62.useState)(null);
    const [snapshotStatus, setSnapshotStatus] = (0, $acw62.useState)({
        stale: false,
        available: true,
        connectionStatus: 'connected'
    });
    const hasFetchedOrdersRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const currentPageRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(page);
    currentPageRef.current = page;
    const fetchOrders = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (isInitialLoad = false, pageOverride)=>{
        const hasData = hasFetchedOrdersRef.current;
        if (isInitialLoad || !hasData) setLoading(true);
        else setRefreshing(true);
        setError(null);
        try {
            if (isInitialLoad) await new Promise((resolve)=>setTimeout(resolve, 500));
            const response = await (0, $2wVnk.tradingApi).getOpenOrders(pageOverride ?? currentPageRef.current, pageSize, securityTypeFilter);
            if (response.success && response.data) {
                setOrders(response.data?.orders || []);
                setSnapshotStatus({
                    stale: !!response.data.stale,
                    available: response.data.snapshot_available !== false,
                    connectionStatus: response.data.connection_status || 'connected'
                });
            } else {
                setOrders([]);
                if (response.error) {
                    setError(response.error);
                    setErrorHeader("Failed to load open orders");
                }
            }
            const ts = response.timestamp || new Date().toISOString();
            setLastUpdated((0, $k8QNV.formatTimeET)(ts));
            hasFetchedOrdersRef.current = true;
        } catch (err) {
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            setError(err instanceof Error ? err.message : 'Failed to fetch open orders');
            setErrorHeader("Failed to load open orders");
            setOrders([]);
        } finally{
            setLoading(false);
            setRefreshing(false);
        }
    }, [
        pageSize,
        securityTypeFilter
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleRefresh = ()=>fetchOrders(false, page);
        window.addEventListener('trading-data-refresh', handleRefresh);
        return ()=>window.removeEventListener('trading-data-refresh', handleRefresh);
    }, [
        fetchOrders,
        page
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchOrders(true, 1);
    }, [
        fetchOrders
    ]);
    (0, $acw62.useEffect)(()=>{
        const refreshWhenVisible = ()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            fetchOrders(false, page);
        };
        const intervalId = setInterval(refreshWhenVisible, refreshInterval);
        document.addEventListener('visibilitychange', refreshWhenVisible);
        window.addEventListener('focus', refreshWhenVisible);
        return ()=>{
            clearInterval(intervalId);
            document.removeEventListener('visibilitychange', refreshWhenVisible);
            window.removeEventListener('focus', refreshWhenVisible);
        };
    }, [
        fetchOrders,
        page,
        refreshInterval
    ]);
    (0, $acw62.useEffect)(()=>{
        if (snapshotStatus.connectionStatus !== 'initializing') return;
        const retryId = window.setTimeout(()=>fetchOrders(false, page), 2000);
        return ()=>window.clearTimeout(retryId);
    }, [
        fetchOrders,
        page,
        snapshotStatus.connectionStatus
    ]);
    const getSideBadge = (side)=>{
        const variants = {
            BUY: 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30',
            SELL: 'bg-rose-500/20 text-rose-300 border border-rose-500/30'
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: `inline-flex items-center px-2.5 py-1 text-[11px] font-black tracking-widest uppercase rounded ${variants[side] || 'bg-white/10 text-white/70 border border-white/20'}`,
            children: side
        });
    };
    const getStatusBadge = (status)=>{
        const variants = {
            Submitted: 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30',
            PreSubmitted: 'bg-white/10 text-white/50 border border-white/10',
            Cancelled: 'bg-rose-500/20 text-rose-300 border border-rose-500/30',
            Filled: 'bg-emerald-500/30 text-emerald-50 border border-emerald-500/50'
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: `inline-flex items-center px-3 py-1 text-[10px] font-black tracking-[0.15em] uppercase rounded-sm shadow-sm ${variants[status] || 'bg-white/5 text-white/40 border border-white/10'}`,
            children: status
        });
    };
    const getOrderTypeBadge = (orderType)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "inline-flex items-center px-1.5 py-0.5 text-[10px] font-black bg-white/10 border border-white/20 text-white/90 uppercase tracking-tighter",
            children: orderType
        });
    };
    const getDisplayPrice = (order)=>{
        const type = (order.order_type || '').toUpperCase();
        const currency = order.currency || 'USD';
        if (type === 'MKT') return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "text-white/30 font-black tracking-tighter uppercase italic text-[13px]",
            children: "Market"
        });
        if (type === 'MIDPRICE') return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "text-cyan-300 font-black tracking-tighter uppercase italic text-[13px]",
            children: "Midpoint"
        });
        if (type === 'STP') return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "text-rose-400 font-mono text-[14px] font-bold",
            children: (0, $b1rqt.formatCurrency)(order.stop_price, currency)
        });
        if (type === 'LMT') return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "text-emerald-400 font-mono text-[14px] font-bold",
            children: (0, $b1rqt.formatCurrency)(order.limit_price, currency)
        });
        if (type === 'TRAIL') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col leading-none font-mono",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-rose-400 text-[14px] font-bold",
                    children: order.trailing_stop_price ? (0, $b1rqt.formatCurrency)(order.trailing_stop_price, currency) : 'Pending'
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "text-[10px] text-amber-400 font-black tracking-tighter italic",
                    children: [
                        "Trail: ",
                        order.trailing_percent ? `${order.trailing_percent}%` : (0, $b1rqt.formatCurrency)(order.stop_price, currency)
                    ]
                })
            ]
        });
        if (type === 'STPLMT') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col leading-none font-mono",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-emerald-400 text-[14px] font-bold",
                    children: (0, $b1rqt.formatCurrency)(order.limit_price, currency)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "text-[10px] text-rose-400 font-black tracking-tighter italic",
                    children: [
                        "STP: ",
                        (0, $b1rqt.formatCurrency)(order.stop_price, currency)
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "font-mono text-[14px] font-bold text-white",
            children: (0, $b1rqt.formatCurrency)(order.limit_price || order.stop_price || 0, currency)
        });
    };
    const getDisplaySymbol = (order)=>{
        if ((order.secType || '').toUpperCase() === 'FUT') return order.localSymbol || (order.symbol && order.lastTradeDateOrContractMonth ? `${order.symbol} ${order.lastTradeDateOrContractMonth}` : order.symbol);
        return order.symbol;
    };
    const getOriginBadge = (origin)=>{
        const normalized = (origin || 'UNKNOWN').toUpperCase();
        const variants = {
            LOCAL: 'border border-neon text-neon bg-neon/10 shadow-[0_0_15px_rgba(0,255,153,0.2)]',
            RECOVERED: 'border border-rose-500 text-rose-300 bg-rose-500/20'
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: `inline-flex items-center px-2 py-1 text-[10px] font-black uppercase rounded-sm ${variants[normalized] || 'border border-white/20 text-white/60 bg-white/10'}`,
            children: normalized === 'LOCAL' ? 'SYSTEM' : normalized
        });
    };
    const handleCancelOrder = async (orderId)=>{
        if (!orderId || cancellingId !== null) return;
        setCancellingId(orderId);
        setError(null);
        try {
            const response = await (0, $2wVnk.tradingApi).cancelOrder(orderId);
            if (!response.success) {
                setError(response.error || `Failed to cancel order ${orderId}`);
                setErrorHeader("Order Cancellation Failed");
            } else {
                setOrders((prev)=>prev.map((order)=>order.order_id === orderId ? {
                            ...order,
                            status: 'Cancelled',
                            remaining_quantity: 0
                        } : order));
                window.dispatchEvent(new CustomEvent('trading-data-refresh'));
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : `Failed to cancel order ${orderId}`);
            setErrorHeader("Order Cancellation Failed");
        } finally{
            setCancellingId(null);
        }
    };
    const handleEditOrder = (order)=>{
        if ((order.status || '').toUpperCase() === 'CANCELLED') return;
        onEditOrder?.(order);
        window.setTimeout(()=>{
            document.getElementById('manual-order-entry')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }, 0);
    };
    const orderColumns = [
        {
            id: 'order_id',
            header: 'ID',
            accessor: 'order_id',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        order.parent_id && order.parent_id !== 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-neon/60 ml-1",
                            children: "\u2514\u2500\u2500"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "font-mono text-white/40 text-[11px] font-bold tracking-tight",
                            children: order.order_id
                        })
                    ]
                })
        },
        {
            id: 'symbol',
            header: 'Symbol',
            accessor: (o)=>o.symbol || '',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "font-semibold text-[12px] tracking-tight text-white",
                            children: getDisplaySymbol(order)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-[10px] text-white/30 font-black uppercase tracking-widest",
                            children: order.secType || 'STK'
                        })
                    ]
                })
        },
        {
            id: 'origin',
            header: 'Origin',
            accessor: (o)=>`${o.origin || ''} ${o.strategy || ''}`,
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col gap-1.5",
                    children: [
                        getOriginBadge(order.origin),
                        order.strategy && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-[10px] font-black text-white/30 uppercase tracking-[0.2em]",
                            children: order.strategy
                        })
                    ]
                })
        },
        {
            id: 'side',
            header: 'Side',
            accessor: 'side',
            sortable: true,
            render: (order)=>getSideBadge(order.side)
        },
        {
            id: 'order_type',
            header: 'Type',
            accessor: 'order_type',
            sortable: true,
            render: (order)=>getOrderTypeBadge(order.order_type)
        },
        {
            id: 'quantity',
            header: 'Size',
            accessor: 'quantity',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col font-mono leading-tight",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "font-black text-white text-[14px]",
                            children: order.quantity?.toLocaleString()
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex gap-2 text-[10px] font-bold mt-0.5",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "text-emerald-400",
                                    children: [
                                        "F: ",
                                        order.filled_quantity?.toLocaleString() ?? 0
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "text-white/20",
                                    children: [
                                        "R: ",
                                        order.remaining_quantity?.toLocaleString() ?? order.quantity?.toLocaleString()
                                    ]
                                })
                            ]
                        })
                    ]
                })
        },
        {
            id: 'price',
            header: 'Price',
            accessor: (o)=>o.limit_price || o.stop_price || 0,
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "font-mono font-black",
                    children: getDisplayPrice(order)
                })
        },
        {
            id: 'status',
            header: 'Status',
            accessor: 'status',
            sortable: true,
            render: (order)=>getStatusBadge(order.status || 'Unknown')
        },
        {
            id: 'timestamp',
            header: 'Time',
            accessor: 'timestamp',
            sortable: true,
            align: 'right',
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-white/60 font-mono font-bold text-[12px]",
                    children: (0, $k8QNV.formatTimeET)(order.timestamp)
                })
        },
        {
            id: 'actions',
            header: 'Actions',
            accessor: 'order_id',
            align: 'right',
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center justify-end gap-2",
                    children: [
                        onEditOrder && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            className: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-wider border border-neon/30 text-neon bg-neon/10 hover:bg-neon/20 active:scale-95 transition-all disabled:opacity-30",
                            disabled: refreshing || cancellingId !== null || (order.status || '').toUpperCase() === 'CANCELLED',
                            onClick: (e)=>{
                                e.stopPropagation();
                                handleEditOrder(order);
                            },
                            title: "Edit this order in Manual Order",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                    className: "w-3 h-3"
                                }),
                                "Edit"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "px-3 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-wider border border-rose-500/30 text-rose-200 bg-rose-500/10 hover:bg-rose-500/20 active:scale-95 transition-all disabled:opacity-30",
                            disabled: refreshing || cancellingId === order.order_id || (order.status || '').toUpperCase() === 'CANCELLED',
                            onClick: (e)=>{
                                e.stopPropagation();
                                handleCancelOrder(order.order_id);
                            },
                            children: cancellingId === order.order_id ? 'Wait' : 'Cancel'
                        })
                    ]
                })
        }
    ];
    const displayOrders = (0, $acw62.useMemo)(()=>{
        const filteredOrders = securityTypeFilter === 'ALL' ? orders : orders.filter((order)=>(order.secType || 'STK').toUpperCase() === securityTypeFilter);
        const symbolFilteredOrders = filteredOrders.filter((order)=>(0, $1ce8a6e7c3701980$export$233c8e1804dc7af2)(order, symbolFilter));
        const topLevel = symbolFilteredOrders.filter((o)=>!o.parent_id || o.parent_id === 0);
        const children = symbolFilteredOrders.filter((o)=>o.parent_id && o.parent_id !== 0);
        const result = [];
        topLevel.forEach((parent)=>{
            result.push(parent);
            const myChildren = children.filter((c)=>c.parent_id === parent.order_id);
            result.push(...myChildren);
        });
        const orphans = children.filter((c)=>!topLevel.find((p)=>p.order_id === c.parent_id));
        result.push(...orphans);
        return result;
    }, [
        orders,
        securityTypeFilter,
        symbolFilter
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center justify-between px-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "text-sm font-bold text-neon tracking-tight uppercase mb-0.5",
                                    children: "Open Orders"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap-2 text-[10px] text-muted font-bold opacity-30 uppercase tracking-[0.2em]",
                                    children: [
                                        refreshing ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "animate-pulse text-neon",
                                            children: "Refreshing..."
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: snapshotStatus.connectionStatus === 'initializing' ? 'Synchronizing' : snapshotStatus.stale ? 'Offline Snapshot' : 'Live Data Feed'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "\u2022"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: lastUpdated ?? "\u2014"
                                        })
                                    ]
                                })
                            ]
                        }),
                        onEditOrder && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-[10px] font-bold uppercase tracking-wider text-white/35",
                            children: "Click Edit or an order row to load it into Manual Order"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ce8a6e7c3701980$export$2e2bcd8739ae039), {
                        orders: orders,
                        value: symbolFilter,
                        onChange: setSymbolFilter
                    }),
                    snapshotStatus.stale && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-4 rounded-xl border border-warning-500/25 bg-warning-500/10 px-4 py-3 text-xs text-warning-300",
                        children: snapshotStatus.connectionStatus === 'initializing' ? 'IB is connected and open orders are synchronizing. This panel will refresh automatically.' : snapshotStatus.available ? "Gateway offline \u2014 showing the last persisted open-order snapshot." : "Gateway offline \u2014 no persisted open-order snapshot is available yet."
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iqWry.default), {
                            error: error,
                            onRetry: ()=>fetchOrders(),
                            message: errorHeader
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s03j.DataTable), {
                        data: displayOrders,
                        columns: orderColumns,
                        compact: true,
                        loading: loading,
                        onRowClick: handleEditOrder,
                        emptyMessage: snapshotStatus.stale && !snapshotStatus.available ? snapshotStatus.connectionStatus === 'initializing' ? "Synchronizing open orders\u2026" : "No persisted open-order snapshot available" : "No open orders in the queue.",
                        rowClassName: (order)=>order.parent_id && order.parent_id !== 0 ? 'bg-white/[0.015]' : ''
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-end items-center gap-3 mt-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "px-6 py-2 rounded-xl border border-white/5 bg-white/5 text-[10px] font-bold text-muted hover:text-foreground hover:bg-white/10 disabled:opacity-30 transition-all uppercase tracking-widest active:scale-95 shadow-lg",
                                disabled: page <= 1 || refreshing,
                                onClick: ()=>{
                                    const nextPage = Math.max(1, page - 1);
                                    setPage(nextPage);
                                    fetchOrders(false, nextPage);
                                },
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "px-4 py-2 bg-black/40 rounded-xl border border-white/10 text-[10px] font-black text-neon shadow-[0_0_15px_rgba(0,255,153,0.1)]",
                                children: page.toString().padStart(2, '0')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "px-6 py-2 rounded-xl border border-white/5 bg-white/5 text-[10px] font-bold text-muted hover:text-foreground hover:bg-white/10 disabled:opacity-30 transition-all uppercase tracking-widest active:scale-95 shadow-lg",
                                disabled: orders.length < pageSize || refreshing,
                                onClick: ()=>{
                                    const nextPage = page + 1;
                                    setPage(nextPage);
                                    fetchOrders(false, nextPage);
                                },
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $5f3266c1f84cfee9$export$2e2bcd8739ae039 = $5f3266c1f84cfee9$var$OpenOrders;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");

var $iqWry = parcelRequire("iqWry");

var $k8QNV = parcelRequire("k8QNV");

var $b1rqt = parcelRequire("b1rqt");

var $7s03j = parcelRequire("7s03j");

const $c775cf1fce7c60c6$var$FilledOrders = ({ refreshInterval: refreshInterval = 30000, securityTypeFilter: securityTypeFilter = 'ALL' })=>{
    const [orders, setOrders] = (0, $acw62.useState)([]);
    const [page, setPage] = (0, $acw62.useState)(1);
    const pageSize = 10;
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [refreshing, setRefreshing] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [lastUpdated, setLastUpdated] = (0, $acw62.useState)(null);
    const [symbolFilter, setSymbolFilter] = (0, $acw62.useState)('');
    const [snapshotStatus, setSnapshotStatus] = (0, $acw62.useState)({
        stale: false,
        available: true,
        connectionStatus: 'connected'
    });
    const hasFetchedOrdersRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const currentPageRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(page);
    currentPageRef.current = page;
    const fetchOrders = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (isInitialLoad = false, pageOverride)=>{
        const hasData = hasFetchedOrdersRef.current;
        if (isInitialLoad || !hasData) setLoading(true);
        else setRefreshing(true);
        setError(null);
        try {
            if (isInitialLoad) await new Promise((resolve)=>setTimeout(resolve, 500));
            const response = await (0, $2wVnk.tradingApi).getFilledOrdersToday(pageOverride ?? currentPageRef.current, pageSize, securityTypeFilter);
            if (response.success && response.data) {
                setOrders(response.data?.orders || []);
                setSnapshotStatus({
                    stale: !!response.data.stale,
                    available: response.data.snapshot_available !== false,
                    connectionStatus: response.data.connection_status || 'connected'
                });
            } else setOrders([]);
            const ts = response.timestamp || new Date().toISOString();
            setLastUpdated((0, $k8QNV.formatTimeET)(ts));
            hasFetchedOrdersRef.current = true;
        } catch (err) {
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            setError(err instanceof Error ? err.message : 'Failed to fetch filled orders');
            setOrders([]);
        } finally{
            setLoading(false);
            setRefreshing(false);
        }
    }, [
        pageSize,
        securityTypeFilter
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleRefresh = ()=>fetchOrders(false, page);
        window.addEventListener('trading-data-refresh', handleRefresh);
        return ()=>window.removeEventListener('trading-data-refresh', handleRefresh);
    }, [
        fetchOrders,
        page
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchOrders(true, 1);
    }, [
        fetchOrders
    ]);
    (0, $acw62.useEffect)(()=>{
        const refreshWhenVisible = ()=>{
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            fetchOrders(false, page);
        };
        const intervalId = setInterval(refreshWhenVisible, refreshInterval);
        document.addEventListener('visibilitychange', refreshWhenVisible);
        window.addEventListener('focus', refreshWhenVisible);
        return ()=>{
            clearInterval(intervalId);
            document.removeEventListener('visibilitychange', refreshWhenVisible);
            window.removeEventListener('focus', refreshWhenVisible);
        };
    }, [
        fetchOrders,
        page,
        refreshInterval
    ]);
    (0, $acw62.useEffect)(()=>{
        if (snapshotStatus.connectionStatus !== 'initializing') return;
        const retryId = window.setTimeout(()=>fetchOrders(false, page), 2000);
        return ()=>window.clearTimeout(retryId);
    }, [
        fetchOrders,
        page,
        snapshotStatus.connectionStatus
    ]);
    const getSideBadge = (side)=>{
        const variants = {
            BUY: 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30',
            SELL: 'bg-rose-500/20 text-rose-300 border border-rose-500/30'
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: `inline-flex items-center px-2 py-1 text-[11px] font-black tracking-widest uppercase rounded ${variants[side] || 'bg-white/10 text-white/70 border border-white/20'}`,
            children: side
        });
    };
    const getStatusBadge = (status)=>{
        const variants = {
            FILLED: 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 shadow-[0_0_15px_rgba(16,185,129,0.2)]',
            PARTIALLYFILLED: 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20'
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: `inline-flex items-center px-3 py-1 text-[10px] font-black tracking-[0.1em] uppercase rounded-sm shadow-sm ${variants[status.toUpperCase()] || 'bg-white/10 text-white/50 border border-white/10'}`,
            children: status
        });
    };
    const getDisplaySymbol = (order)=>{
        if ((order.secType || '').toUpperCase() === 'FUT') return order.localSymbol || (order.symbol && order.lastTradeDateOrContractMonth ? `${order.symbol} ${order.lastTradeDateOrContractMonth}` : order.symbol);
        return order.symbol;
    };
    const orderColumns = [
        {
            id: 'order_id',
            header: 'ID',
            accessor: 'order_id',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "font-mono text-white/40 text-[11px] font-bold",
                    children: order.order_id
                })
        },
        {
            id: 'symbol',
            header: 'Symbol',
            accessor: 'symbol',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "font-semibold text-[12px] tracking-tight text-white",
                            children: getDisplaySymbol(order)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-[10px] text-white/30 font-black uppercase tracking-widest",
                            children: order.intent || order.secType || 'STK'
                        })
                    ]
                })
        },
        {
            id: 'side',
            header: 'Side',
            accessor: 'side',
            sortable: true,
            render: (order)=>getSideBadge(order.side)
        },
        {
            id: 'filled_quantity',
            header: 'Filled Size',
            accessor: 'filled_quantity',
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-2 font-mono",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "font-black text-white text-[14px]",
                            children: order.filled_quantity?.toLocaleString()
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-white/20",
                            children: "/"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-white/50 text-[11px] font-bold",
                            children: order.quantity?.toLocaleString()
                        })
                    ]
                })
        },
        {
            id: 'fill_price',
            header: 'Fill Price',
            accessor: (o)=>o.fill_price || o.limit_price || 0,
            sortable: true,
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "font-mono font-black text-white text-[14px]",
                    children: (0, $b1rqt.formatCurrency)(order.fill_price ?? order.limit_price ?? 0, order.currency ?? undefined)
                })
        },
        {
            id: 'status',
            header: 'Status',
            accessor: 'status',
            sortable: true,
            render: (order)=>getStatusBadge(order.status || '')
        },
        {
            id: 'timestamp',
            header: 'Timestamp',
            accessor: 'timestamp',
            sortable: true,
            align: 'right',
            render: (order)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col items-end leading-none",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-white/80 font-mono font-black text-[12px]",
                            children: (0, $k8QNV.formatTimeET)(order.timestamp)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-[9px] text-white/30 font-bold uppercase mt-1 tracking-tighter",
                            children: (0, $k8QNV.formatDateTimeET)(order.timestamp).split(' ')[0]
                        })
                    ]
                })
        }
    ];
    const displayOrders = (0, $acw62.useMemo)(()=>{
        const securityFiltered = securityTypeFilter === 'ALL' ? orders : orders.filter((order)=>(order.secType || 'STK').toUpperCase() === securityTypeFilter);
        return securityFiltered.filter((order)=>(0, $1ce8a6e7c3701980$export$233c8e1804dc7af2)(order, symbolFilter));
    }, [
        orders,
        securityTypeFilter,
        symbolFilter
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center justify-between px-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-center gap-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-sm font-bold text-neon tracking-tight uppercase mb-0.5",
                                children: "Filled Orders Today"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2 text-[10px] text-muted font-bold opacity-30 uppercase tracking-[0.2em]",
                                children: [
                                    refreshing ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "animate-pulse text-neon",
                                        children: "Refreshing..."
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: snapshotStatus.connectionStatus === 'initializing' ? 'Synchronizing' : snapshotStatus.stale ? 'Offline Snapshot' : 'Execution History'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: lastUpdated ?? "\u2014"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ce8a6e7c3701980$export$2e2bcd8739ae039), {
                        orders: orders,
                        value: symbolFilter,
                        onChange: setSymbolFilter
                    }),
                    snapshotStatus.stale && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-4 rounded-xl border border-warning-500/25 bg-warning-500/10 px-4 py-3 text-xs text-warning-300",
                        children: snapshotStatus.connectionStatus === 'initializing' ? 'IB is connected and executions are synchronizing. This panel will refresh automatically.' : snapshotStatus.available ? "Gateway offline \u2014 showing the last persisted filled-order snapshot." : "Gateway offline \u2014 no persisted filled-order snapshot is available yet."
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iqWry.default), {
                            error: error,
                            onRetry: ()=>fetchOrders(),
                            message: "Failed to load filled orders"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s03j.DataTable), {
                        data: displayOrders,
                        columns: orderColumns,
                        compact: true,
                        loading: loading,
                        emptyMessage: snapshotStatus.stale && !snapshotStatus.available ? snapshotStatus.connectionStatus === 'initializing' ? "Synchronizing executions\u2026" : "No persisted filled-order snapshot available" : "No executions recorded today."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-end items-center gap-3 mt-6",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "px-6 py-2 rounded-xl border border-white/5 bg-white/5 text-[10px] font-bold text-muted hover:text-foreground hover:bg-white/10 disabled:opacity-30 transition-all uppercase tracking-widest active:scale-95 shadow-lg",
                                disabled: page <= 1 || refreshing,
                                onClick: ()=>{
                                    const nextPage = Math.max(1, page - 1);
                                    setPage(nextPage);
                                    fetchOrders(false, nextPage);
                                },
                                children: "Previous"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "px-4 py-2 bg-black/40 rounded-xl border border-white/10 text-[10px] font-black text-neon shadow-[0_0_15px_rgba(0,255,153,0.1)]",
                                children: page.toString().padStart(2, '0')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "px-6 py-2 rounded-xl border border-white/5 bg-white/5 text-[10px] font-bold text-muted hover:text-foreground hover:bg-white/10 disabled:opacity-30 transition-all uppercase tracking-widest active:scale-95 shadow-lg",
                                disabled: orders.length < pageSize || refreshing,
                                onClick: ()=>{
                                    const nextPage = page + 1;
                                    setPage(nextPage);
                                    fetchOrders(false, nextPage);
                                },
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $c775cf1fce7c60c6$export$2e2bcd8739ae039 = $c775cf1fce7c60c6$var$FilledOrders;



var $k8QNV = parcelRequire("k8QNV");

var $jtEPT = parcelRequire("jtEPT");


var $7eyud = parcelRequire("7eyud");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4Yp7M = parcelRequire("4Yp7M");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $6e6f609e8c3a110b$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Maximize2", [
    [
        "polyline",
        {
            points: "15 3 21 3 21 9",
            key: "mznyad"
        }
    ],
    [
        "polyline",
        {
            points: "9 21 3 21 3 15",
            key: "1avn1i"
        }
    ],
    [
        "line",
        {
            x1: "21",
            x2: "14",
            y1: "3",
            y2: "10",
            key: "ota7mn"
        }
    ],
    [
        "line",
        {
            x1: "3",
            x2: "10",
            y1: "21",
            y2: "14",
            key: "1atl0r"
        }
    ]
]);


var $di5Ac = parcelRequire("di5Ac");
var $hPAJY = parcelRequire("hPAJY");

var $2wVnk = parcelRequire("2wVnk");

var $2RwSR = parcelRequire("2RwSR");

var $ip1r2 = parcelRequire("ip1r2");

var $dghaF = parcelRequire("dghaF");

var $iiQft = parcelRequire("iiQft");

var $92f5k = parcelRequire("92f5k");

var $7eyud = parcelRequire("7eyud");

var $a6l6I = parcelRequire("a6l6I");
const $0fd65599a8e822ef$var$timeframeOptions = [
    {
        value: '1min',
        label: '1 minute'
    },
    {
        value: '5min',
        label: '5 minutes'
    },
    {
        value: '15min',
        label: '15 minutes'
    },
    {
        value: '30min',
        label: '30 minutes'
    },
    {
        value: '1h',
        label: '1 hour'
    },
    {
        value: '1d',
        label: '1 day'
    }
];
const $0fd65599a8e822ef$var$durationOptions = [
    {
        value: '1 D',
        label: '1 day'
    },
    {
        value: '5 D',
        label: '5 days'
    },
    {
        value: '2 W',
        label: '2 weeks'
    },
    {
        value: '1 M',
        label: '1 month'
    },
    {
        value: '3 M',
        label: '3 months'
    },
    {
        value: '6 M',
        label: '6 months'
    },
    {
        value: '1 Y',
        label: '1 year'
    }
];
const $0fd65599a8e822ef$var$movingAverageOptions = [
    {
        value: 'off',
        label: 'Off'
    },
    {
        value: 'sma',
        label: 'SMA'
    },
    {
        value: 'ema',
        label: 'EMA'
    }
];
const $0fd65599a8e822ef$var$movingAverageColors = [
    (0, $a6l6I.themeColors).neon,
    (0, $a6l6I.themeColors).warningBright,
    (0, $a6l6I.themeColors).info
];
const $0fd65599a8e822ef$var$chartBars = (bars)=>bars.filter((0, $2RwSR.isValidHistoricalBar)).map((bar)=>({
            time: bar.time,
            open: bar.open,
            high: bar.high,
            low: bar.low,
            close: bar.close,
            volume: bar.volume ?? 0
        })).sort((a, b)=>a.time - b.time);
const $0fd65599a8e822ef$var$toIsoDate = (time)=>new Date(time * 1000).toISOString();
const $0fd65599a8e822ef$var$averageData = (bars, period, kind)=>{
    if (bars.length < period) return [];
    if (kind === 'sma') {
        const result = [];
        let sum = 0;
        bars.forEach((bar, index)=>{
            sum += bar.close;
            if (index >= period) sum -= bars[index - period].close;
            if (index >= period - 1) result.push({
                date: $0fd65599a8e822ef$var$toIsoDate(bar.time),
                value: sum / period
            });
        });
        return result;
    }
    const multiplier = 2 / (period + 1);
    const result = [];
    let previous = bars.slice(0, period).reduce((sum, bar)=>sum + bar.close, 0) / period;
    result.push({
        date: $0fd65599a8e822ef$var$toIsoDate(bars[period - 1].time),
        value: previous
    });
    bars.slice(period).forEach((bar)=>{
        previous = (bar.close - previous) * multiplier + previous;
        result.push({
            date: $0fd65599a8e822ef$var$toIsoDate(bar.time),
            value: previous
        });
    });
    return result;
};
const $0fd65599a8e822ef$var$defaultVisibleBars = (timeframe)=>{
    if (timeframe === '1d') return 180;
    if (timeframe === '1min') return 240;
    return 220;
};
const $0fd65599a8e822ef$var$displaySymbol = (position)=>position.display_symbol || position.local_symbol || position.symbol;
const $0fd65599a8e822ef$var$getHistorySymbol = (position)=>position.secType === 'FUT' ? position.local_symbol || position.display_symbol || position.symbol : position.symbol;
const $0fd65599a8e822ef$var$PositionChartModal = ({ position: position, onClose: onClose, inline: inline = false, onOpenModal: onOpenModal })=>{
    const [timeframe, setTimeframe] = (0, $acw62.useState)('15min');
    const [duration, setDuration] = (0, $acw62.useState)('1 M');
    const [chartStyle, setChartStyle] = (0, $acw62.useState)('candles');
    const [ma20, setMa20] = (0, $acw62.useState)('off');
    const [ma50, setMa50] = (0, $acw62.useState)('off');
    const [ma200, setMa200] = (0, $acw62.useState)('off');
    const [historySymbol, setHistorySymbol] = (0, $acw62.useState)(()=>$0fd65599a8e822ef$var$getHistorySymbol(position));
    const [symbolInput, setSymbolInput] = (0, $acw62.useState)(()=>$0fd65599a8e822ef$var$getHistorySymbol(position));
    const [bars, setBars] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const positionIdentity = position.position_key || position.contract_key || `${position.secType || 'STK'}:${position.symbol}:${position.local_symbol || ''}`;
    const nextHistorySymbol = $0fd65599a8e822ef$var$getHistorySymbol(position);
    (0, $acw62.useEffect)(()=>{
        setHistorySymbol(nextHistorySymbol);
        setSymbolInput(nextHistorySymbol);
    }, [
        nextHistorySymbol,
        positionIdentity
    ]);
    (0, $acw62.useEffect)(()=>{
        if (inline) return undefined;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const handleEscape = (event)=>{
            if (event.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEscape);
        return ()=>{
            document.body.style.overflow = previousOverflow;
            document.removeEventListener('keydown', handleEscape);
        };
    }, [
        inline,
        onClose
    ]);
    (0, $acw62.useEffect)(()=>{
        const controller = new AbortController();
        const loadHistory = async ()=>{
            setLoading(true);
            setError(null);
            try {
                const response = await (0, $2wVnk.tradingApi).getHistoricalData(historySymbol, timeframe, duration, 'ibkr', controller.signal);
                if (!response.success || !Array.isArray(response.data)) throw new Error(response.error || 'No historical data returned');
                if (!controller.signal.aborted) setBars($0fd65599a8e822ef$var$chartBars(response.data));
            } catch (err) {
                if (!controller.signal.aborted) {
                    setBars([]);
                    setError(err instanceof Error ? err.message : 'Failed to load chart');
                }
            } finally{
                if (!controller.signal.aborted) setLoading(false);
            }
        };
        loadHistory();
        return ()=>controller.abort();
    }, [
        historySymbol,
        timeframe,
        duration
    ]);
    const chartData = (0, $acw62.useMemo)(()=>bars.map((bar)=>({
                date: $0fd65599a8e822ef$var$toIsoDate(bar.time),
                open: bar.open,
                high: bar.high,
                low: bar.low,
                close: bar.close,
                volume: bar.volume
            })), [
        bars
    ]);
    const lineOverlays = (0, $acw62.useMemo)(()=>{
        const configs = [
            {
                period: 20,
                kind: ma20,
                color: $0fd65599a8e822ef$var$movingAverageColors[0]
            },
            {
                period: 50,
                kind: ma50,
                color: $0fd65599a8e822ef$var$movingAverageColors[1]
            },
            {
                period: 200,
                kind: ma200,
                color: $0fd65599a8e822ef$var$movingAverageColors[2]
            }
        ];
        return configs.flatMap((config)=>{
            if (config.kind === 'off') return [];
            const data = $0fd65599a8e822ef$var$averageData(bars, config.period, config.kind);
            return data.length ? [
                {
                    title: `${config.kind.toUpperCase()} ${config.period}`,
                    color: config.color,
                    lineWidth: 2,
                    data: data
                }
            ] : [];
        });
    }, [
        bars,
        ma20,
        ma50,
        ma200
    ]);
    const volumeData = (0, $acw62.useMemo)(()=>bars.map((bar)=>({
                date: $0fd65599a8e822ef$var$toIsoDate(bar.time),
                value: bar.volume,
                color: bar.close >= bar.open ? (0, $a6l6I.themeColors).success : (0, $a6l6I.themeColors).danger
            })), [
        bars
    ]);
    const loadChartSymbol = ()=>{
        const nextSymbol = symbolInput.trim().toUpperCase();
        if (!nextSymbol || nextSymbol === historySymbol) return;
        setHistorySymbol(nextSymbol);
    };
    const handleSymbolInputKeyDown = (event)=>{
        if (event.key === 'Enter') {
            event.preventDefault();
            loadChartSymbol();
        }
    };
    const maSelect = (period, value, onChange)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex shrink-0 items-center gap-1",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "text-[9px] font-bold uppercase tracking-wide text-muted",
                    children: [
                        "MA",
                        period
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iiQft.ChartToolbarSelect), {
                    value: value,
                    options: $0fd65599a8e822ef$var$movingAverageOptions,
                    onChange: onChange,
                    ariaLabel: `Moving average ${period}`,
                    title: `Moving average ${period}`,
                    widthClassName: "w-[58px]"
                })
            ]
        });
    const chartToolbar = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iiQft.ChartToolbar), {
        leading: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex shrink-0 items-center gap-1.5",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-xs font-bold tracking-tight text-white",
                            children: $0fd65599a8e822ef$var$displaySymbol(position)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "rounded border border-neon/20 bg-neon/10 px-1 py-0.5 text-[8px] font-bold uppercase tracking-wider text-neon",
                            children: position.secType || 'STK'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex h-7 w-[128px] shrink-0 overflow-hidden rounded-md border border-white/10 bg-black/20 focus-within:border-neon/50",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            value: symbolInput,
                            onChange: (event)=>setSymbolInput(event.target.value.toUpperCase()),
                            onKeyDown: handleSymbolInputKeyDown,
                            "aria-label": "Chart symbol",
                            className: "min-w-0 flex-1 bg-transparent px-2 text-[10px] font-bold text-white outline-none placeholder:text-white/25",
                            placeholder: "Underlying stock"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex items-center border-l border-white/10",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                                size: "compact",
                                iconOnly: true,
                                onClick: loadChartSymbol,
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $di5Ac.default), {
                                    className: "h-3.5 w-3.5"
                                }),
                                label: "Load chart symbol"
                            })
                        })
                    ]
                })
            ]
        }),
        chartStyle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iiQft.ChartStyleToggle), {
            value: chartStyle,
            onChange: setChartStyle
        }),
        settings: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iiQft.ChartToolbarSelect), {
                    value: duration,
                    options: $0fd65599a8e822ef$var$durationOptions,
                    onChange: (value)=>setDuration(value),
                    ariaLabel: "Chart lookback",
                    title: "Lookback",
                    widthClassName: "w-[86px]"
                }),
                maSelect(20, ma20, (value)=>setMa20(value)),
                maSelect(50, ma50, (value)=>setMa50(value)),
                maSelect(200, ma200, (value)=>setMa200(value))
            ]
        }),
        trailing: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iiQft.ChartToolbarSelect), {
                    value: timeframe,
                    options: $0fd65599a8e822ef$var$timeframeOptions,
                    onChange: (value)=>setTimeframe(value),
                    ariaLabel: "Chart bar interval",
                    title: "Bar interval",
                    widthClassName: "w-[102px]"
                }),
                inline && onOpenModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                    size: "compact",
                    iconOnly: true,
                    onClick: onOpenModal,
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e6f609e8c3a110b$export$2e2bcd8739ae039), {
                        className: "h-3.5 w-3.5"
                    }),
                    label: "Open position chart in modal",
                    title: "Open full chart"
                }),
                !inline && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ip1r2.default), {
                    size: "compact",
                    iconOnly: true,
                    onClick: onClose,
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                        className: "h-3.5 w-3.5"
                    }),
                    label: "Close position chart"
                })
            ]
        })
    });
    const chartPlot = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `relative min-h-0 flex-1 ${inline ? 'h-[320px] min-h-[280px]' : 'min-h-[320px]'} p-1`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92f5k.LightweightChart), {
                data: chartData,
                volumeData: volumeData,
                lineOverlays: lineOverlays,
                type: "symbol",
                symbolStyle: chartStyle,
                lineColor: (0, $a6l6I.themeColors).neon,
                resolution: timeframe === '1d' ? '1D' : 'native',
                timeVisible: timeframe !== '1d',
                initialVisibleBars: $0fd65599a8e822ef$var$defaultVisibleBars(timeframe),
                latestVisibleBars: $0fd65599a8e822ef$var$defaultVisibleBars(timeframe),
                showLatestControl: true,
                hideControls: true
            }, `${positionIdentity}:${historySymbol}:${timeframe}:${duration}`),
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center bg-[#0e0e12]/65",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-2 rounded-lg border border-white/10 bg-black/30 px-3 py-2 text-xs text-muted",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                            className: "h-4 w-4 animate-spin text-neon"
                        }),
                        " Loading history\u2026"
                    ]
                })
            }),
            !loading && error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center px-6 text-center text-sm text-rose-300",
                children: error
            }),
            !loading && !error && bars.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "absolute inset-0 flex items-center justify-center text-sm text-muted",
                children: [
                    "No historical bars available for ",
                    historySymbol,
                    "."
                ]
            })
        ]
    });
    if (inline) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dghaF.default), {
        className: "w-full border-t border-white/10",
        toolbar: chartToolbar,
        children: chartPlot
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7eyud.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "fixed inset-0 z-[1000] flex items-center justify-center bg-black/85 p-4 backdrop-blur-md",
            onClick: (event)=>{
                if (event.target === event.currentTarget) onClose();
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "h-[min(94vh,900px)] w-full max-w-[1400px] overflow-hidden rounded-2xl border border-white/10 bg-[#0e0e12] shadow-[0_0_60px_rgba(0,0,0,0.55)]",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dghaF.default), {
                    className: "h-full",
                    toolbar: chartToolbar,
                    children: chartPlot
                })
            })
        })
    });
};
var $0fd65599a8e822ef$export$2e2bcd8739ae039 = $0fd65599a8e822ef$var$PositionChartModal;



class $15840e16c159feea$export$6339b3d8d8e13ec3 {
    constructor(api){
        this.api = api;
    }
    listTags() {
        return this.api.getStrategyDescriptionTags();
    }
    saveTag(form) {
        const name = form.name.trim();
        const description = form.description.trim();
        if (form.editingTagId !== null) return this.api.updateStrategyDescriptionTag(form.editingTagId, {
            name: name,
            description: description || null,
            color: form.color
        });
        return this.api.createStrategyDescriptionTag({
            name: name,
            description: description || undefined,
            color: form.color
        });
    }
    deleteTag(tagId) {
        return this.api.deleteStrategyDescriptionTag(tagId);
    }
    savePositionMetadata(positionKey, strategyName, tagIds) {
        return this.api.updatePositionMetadata(positionKey, strategyName.trim() || null, tagIds);
    }
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $iSlX2 = parcelRequire("iSlX2");
var $2w97G = parcelRequire("2w97G");
var $hPAJY = parcelRequire("hPAJY");

var $7eyud = parcelRequire("7eyud");

var $d7aJR = parcelRequire("d7aJR");
const $dc0c58967a03c01f$var$PositionStrategyTagModals = ({ state: state, strategyNameOptions: strategyNameOptions })=>{
    const { strategyTags: strategyTags, managerOpen: managerOpen, setManagerOpen: setManagerOpen, editorPosition: editorPosition, setEditorPosition: setEditorPosition, selectedTagIds: selectedTagIds, setSelectedTagIds: setSelectedTagIds, strategyLabelOverride: strategyLabelOverride, setStrategyLabelOverride: setStrategyLabelOverride, editingTagId: editingTagId, tagName: tagName, setTagName: setTagName, tagDescription: tagDescription, setTagDescription: setTagDescription, tagColor: tagColor, setTagColor: setTagColor, tagBusy: tagBusy, tagError: tagError, openManagerFromEditor: openManagerFromEditor, resetTagForm: resetTagForm, editTag: editTag, saveStrategyTag: saveStrategyTag, removeStrategyTag: removeStrategyTag, savePositionTags: savePositionTags } = state;
    const automaticStrategyLabels = editorPosition ? (0, $d7aJR.getPositionStrategies)(editorPosition).filter((strategy)=>strategy !== 'UNASSIGNED') : [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            managerOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7eyud.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 z-[1000] flex items-center justify-center bg-black/80 p-4 backdrop-blur-md",
                    onClick: (event)=>{
                        if (event.target === event.currentTarget) setManagerOpen(false);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex max-h-[90vh] w-full max-w-xl flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#0e0e12] shadow-[0_0_50px_rgba(0,0,0,0.5)]",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-start justify-between border-b border-white/10 px-6 py-5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2 text-neon",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8872a1d80d2463f9$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        className: "text-lg font-bold text-white",
                                                        children: "Position labels"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "mt-1 text-xs leading-relaxed text-muted",
                                                children: "Create reusable notes such as \u201Cearnings hedge\u201D or \u201Creview later\u201D."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setManagerOpen(false),
                                        className: "rounded-lg p-2 text-white/45 transition-colors hover:bg-white/5 hover:text-white",
                                        "aria-label": "Close label manager",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                            className: "h-4 w-4"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "space-y-5 overflow-y-auto p-6",
                                children: [
                                    tagError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "rounded-lg border border-rose-500/25 bg-rose-500/10 px-3 py-2 text-xs text-rose-200",
                                        children: tagError
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                                        onSubmit: saveStrategyTag,
                                        className: "space-y-3 rounded-xl border border-white/10 bg-white/[0.03] p-4",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        className: "text-xs font-bold uppercase tracking-wider text-white/75",
                                                        children: editingTagId ? 'Edit label' : 'New label'
                                                    }),
                                                    editingTagId && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        onClick: resetTagForm,
                                                        className: "text-[10px] font-bold uppercase tracking-wider text-white/45 hover:text-white",
                                                        children: "Cancel edit"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "grid gap-3 sm:grid-cols-[1fr_auto]",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        className: "space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "text-[10px] font-bold uppercase tracking-wider text-muted",
                                                                children: "Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                value: tagName,
                                                                onChange: (event)=>setTagName(event.target.value),
                                                                maxLength: 80,
                                                                placeholder: "e.g. Earnings hedge",
                                                                className: "w-full rounded-lg border border-white/10 bg-black/20 px-3 py-2 text-sm text-white outline-none transition-colors placeholder:text-white/25 focus:border-neon/50",
                                                                required: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        className: "space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "text-[10px] font-bold uppercase tracking-wider text-muted",
                                                                children: "Color"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "color",
                                                                value: tagColor,
                                                                onChange: (event)=>setTagColor(event.target.value.toUpperCase()),
                                                                className: "block h-[38px] w-full cursor-pointer rounded-lg border border-white/10 bg-black/20 p-1",
                                                                "aria-label": "Label color"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "block space-y-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-[10px] font-bold uppercase tracking-wider text-muted",
                                                        children: "Description (optional)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        value: tagDescription,
                                                        onChange: (event)=>setTagDescription(event.target.value),
                                                        maxLength: 500,
                                                        rows: 2,
                                                        placeholder: "Short explanation shown when hovering the tag",
                                                        className: "w-full resize-none rounded-lg border border-white/10 bg-black/20 px-3 py-2 text-sm text-white outline-none transition-colors placeholder:text-white/25 focus:border-neon/50"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "submit",
                                                disabled: tagBusy || !tagName.trim(),
                                                className: "inline-flex items-center gap-1.5 rounded-lg border border-neon/30 bg-neon/10 px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-neon transition-colors hover:bg-neon/20 disabled:cursor-not-allowed disabled:opacity-40",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSlX2.default), {
                                                        className: "h-3 w-3"
                                                    }),
                                                    editingTagId ? 'Save changes' : 'Add label'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/55",
                                                children: "Your labels"
                                            }),
                                            strategyTags.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "rounded-xl border border-dashed border-white/10 px-4 py-5 text-center text-xs text-muted",
                                                children: "No position labels yet."
                                            }) : strategyTags.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center justify-between gap-3 rounded-xl border border-white/10 bg-white/[0.03] px-3 py-2.5",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "min-w-0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "flex items-center gap-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "h-2.5 w-2.5 shrink-0 rounded-full",
                                                                            style: {
                                                                                backgroundColor: (0, $d7aJR.getStrategyTagColor)(tag)
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "truncate text-sm font-bold text-white",
                                                                            children: tag.name
                                                                        })
                                                                    ]
                                                                }),
                                                                tag.description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "mt-1 truncate text-xs text-muted",
                                                                    children: tag.description
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex shrink-0 items-center gap-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>editTag(tag),
                                                                    disabled: tagBusy,
                                                                    className: "rounded-lg p-2 text-white/45 transition-colors hover:bg-white/5 hover:text-neon disabled:opacity-40",
                                                                    "aria-label": `Edit ${tag.name}`,
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                                                        className: "h-3.5 w-3.5"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>removeStrategyTag(tag),
                                                                    disabled: tagBusy,
                                                                    className: "rounded-lg p-2 text-white/45 transition-colors hover:bg-rose-500/10 hover:text-rose-300 disabled:opacity-40",
                                                                    "aria-label": `Delete ${tag.name}`,
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2w97G.default), {
                                                                        className: "h-3.5 w-3.5"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, tag.id))
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            editorPosition && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7eyud.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 z-[1000] flex items-center justify-center bg-black/80 p-4 backdrop-blur-md",
                    onClick: (event)=>{
                        if (event.target === event.currentTarget) setEditorPosition(null);
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "max-h-[90vh] w-full max-w-md overflow-y-auto rounded-2xl border border-white/10 bg-[#0e0e12] p-6 shadow-[0_0_50px_rgba(0,0,0,0.5)]",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-5 flex items-start justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2 text-neon",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8872a1d80d2463f9$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        className: "text-lg font-bold text-white",
                                                        children: "Position labels"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "mt-1 text-xs text-muted",
                                                children: (0, $d7aJR.getPositionDisplaySymbol)(editorPosition)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setEditorPosition(null),
                                        className: "rounded-lg p-2 text-white/45 transition-colors hover:bg-white/5 hover:text-white",
                                        "aria-label": "Close position labels",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                            className: "h-4 w-4"
                                        })
                                    })
                                ]
                            }),
                            tagError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mb-4 rounded-lg border border-rose-500/25 bg-rose-500/10 px-3 py-2 text-xs text-rose-200",
                                children: tagError
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                className: "mb-5 rounded-xl border border-neon/20 bg-neon/[0.04] p-4",
                                "aria-labelledby": "automatic-position-strategies",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-wrap items-center justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                id: "automatic-position-strategies",
                                                className: "text-[10px] font-bold uppercase tracking-wider text-white/70",
                                                children: "Strategy label"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "rounded border border-neon/20 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-neon/70",
                                                children: "Automatic attribution"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mt-2 flex flex-wrap gap-1.5",
                                        children: automaticStrategyLabels.length > 0 ? automaticStrategyLabels.map((strategy)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "rounded border border-neon/25 bg-neon/10 px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-neon",
                                                children: strategy
                                            }, strategy)) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "rounded border border-white/10 bg-white/[0.03] px-2 py-1 text-[10px] font-semibold text-white/45",
                                            children: "No automatic strategy label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt-2 text-[10px] leading-relaxed text-muted",
                                        children: "This attribution identifies which strategy opened the position. Set a display name below without changing order ownership or automatic closes."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        htmlFor: "custom-position-strategy",
                                        className: "mt-4 block text-[10px] font-bold uppercase tracking-wider text-white/70",
                                        children: "Display name"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "custom-position-strategy",
                                                type: "text",
                                                list: "position-strategy-name-options",
                                                value: strategyLabelOverride,
                                                onChange: (event)=>setStrategyLabelOverride(event.target.value),
                                                maxLength: 80,
                                                placeholder: automaticStrategyLabels.join(' + ') || 'Name this strategy label',
                                                className: "min-w-0 flex-1 rounded-lg border border-white/10 bg-black/30 px-3 py-2 text-sm text-white placeholder:text-white/25 outline-none transition-colors focus:border-neon/50"
                                            }),
                                            strategyLabelOverride.trim() && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setStrategyLabelOverride(''),
                                                className: "inline-flex shrink-0 items-center gap-1 rounded-lg border border-rose-400/20 px-2.5 py-2 text-[10px] font-bold uppercase tracking-wider text-rose-200/75 transition-colors hover:bg-rose-400/10 hover:text-rose-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                                        className: "h-3 w-3"
                                                    }),
                                                    "Use automatic"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("datalist", {
                                        id: "position-strategy-name-options",
                                        children: strategyNameOptions.map((name)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: name
                                            }, name))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setStrategyLabelOverride('UNASSIGNED'),
                                        className: "mt-2 rounded-md border border-white/10 px-2 py-1 text-[10px] font-semibold text-white/60 hover:border-rose-400/30 hover:text-white",
                                        children: "Remove strategy name"
                                    }),
                                    strategyNameOptions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mt-2 flex flex-wrap items-center gap-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "mr-1 text-[10px] uppercase tracking-wider text-white/40",
                                                children: "Strategy names:"
                                            }),
                                            strategyNameOptions.map((name)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setStrategyLabelOverride(name),
                                                    className: `rounded-md border px-2 py-1 text-[10px] font-semibold transition-colors ${strategyLabelOverride.trim() === name ? 'border-neon/40 bg-neon/10 text-neon' : 'border-white/10 text-white/55 hover:border-neon/30 hover:text-neon'}`,
                                                    children: name
                                                }, name))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt-2 text-[10px] leading-relaxed text-muted",
                                        children: "Leave blank to show the automatic name, or remove the name for this position. This changes the displayed label only."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                                className: "space-y-2",
                                "aria-labelledby": "position-description-tags",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center justify-between gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        id: "position-description-tags",
                                                        className: "text-[10px] font-bold uppercase tracking-wider text-white/65",
                                                        children: "Descriptive labels"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "mt-0.5 text-[10px] text-muted",
                                                        children: "Notes and reminders attached to this position."
                                                    })
                                                ]
                                            }),
                                            selectedTagIds.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setSelectedTagIds([]),
                                                className: "text-[10px] font-bold uppercase tracking-wider text-white/45 transition-colors hover:text-rose-300",
                                                children: "Remove all labels"
                                            })
                                        ]
                                    }),
                                    strategyTags.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "rounded-xl border border-dashed border-white/10 px-4 py-5 text-center text-xs text-muted",
                                        children: "Create a position label first, then attach it here."
                                    }) : strategyTags.map((tag)=>{
                                        const checked = selectedTagIds.includes(tag.id);
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: `flex items-center justify-between gap-3 rounded-xl border px-3 py-2.5 transition-colors ${checked ? 'border-neon/30 bg-neon/10' : 'border-white/10 bg-white/[0.03]'}`,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "min-w-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-center gap-2 text-sm font-bold text-white",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "h-2.5 w-2.5 shrink-0 rounded-full",
                                                                    style: {
                                                                        backgroundColor: (0, $d7aJR.getStrategyTagColor)(tag)
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "truncate",
                                                                    children: tag.name
                                                                }),
                                                                checked && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "shrink-0 text-[9px] font-bold uppercase tracking-wider text-neon",
                                                                    children: "Attached"
                                                                })
                                                            ]
                                                        }),
                                                        tag.description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "mt-0.5 truncate text-xs text-muted",
                                                            children: tag.description
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>setSelectedTagIds((ids)=>checked ? ids.filter((id)=>id !== tag.id) : [
                                                                ...ids,
                                                                tag.id
                                                            ]),
                                                    className: `inline-flex shrink-0 items-center gap-1 rounded-lg border px-2.5 py-1.5 text-[10px] font-bold uppercase tracking-wider transition-colors ${checked ? 'border-rose-400/20 text-rose-200/75 hover:bg-rose-400/10 hover:text-rose-100' : 'border-neon/20 text-neon/80 hover:bg-neon/10 hover:text-neon'}`,
                                                    "aria-label": `${checked ? 'Remove' : 'Add'} ${tag.name} ${checked ? 'from' : 'to'} position`,
                                                    children: [
                                                        checked ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                                            className: "h-3 w-3"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSlX2.default), {
                                                            className: "h-3 w-3"
                                                        }),
                                                        checked ? 'Remove' : 'Add'
                                                    ]
                                                })
                                            ]
                                        }, tag.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mt-6 flex items-center justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onClick: openManagerFromEditor,
                                        className: "inline-flex items-center gap-1.5 rounded-lg border border-white/10 px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-white/60 transition-colors hover:border-neon/30 hover:text-neon",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSlX2.default), {
                                                className: "h-3 w-3"
                                            }),
                                            "Manage labels"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setEditorPosition(null),
                                                className: "rounded-lg border border-white/10 px-4 py-2 text-[10px] font-bold uppercase tracking-wider text-white/60 transition-colors hover:bg-white/5 hover:text-white",
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                onClick: savePositionTags,
                                                disabled: tagBusy,
                                                className: "rounded-lg border border-neon/30 bg-neon/10 px-4 py-2 text-[10px] font-bold uppercase tracking-wider text-neon transition-colors hover:bg-neon/20 disabled:opacity-40",
                                                children: tagBusy ? "Saving\u2026" : 'Save labels'
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $dc0c58967a03c01f$export$2e2bcd8739ae039 = $dc0c58967a03c01f$var$PositionStrategyTagModals;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bKJAw = parcelRequire("bKJAw");
var $2Kpom = parcelRequire("2Kpom");
var $753mY = parcelRequire("753mY");
var $jQdKn = parcelRequire("jQdKn");
var $hiXj7 = parcelRequire("hiXj7");
var $4reVr = parcelRequire("4reVr");

var $b1rqt = parcelRequire("b1rqt");

var $7s03j = parcelRequire("7s03j");

var $iqWry = parcelRequire("iqWry");


var $d7aJR = parcelRequire("d7aJR");
const $da11ef7f6a0c25de$var$POSITION_COLUMN_STORAGE_KEY = 'dashboardPositionsHiddenColumns_v1';
const $da11ef7f6a0c25de$var$DEFAULT_HIDDEN_POSITION_COLUMNS = [
    'margin_used'
];
const $da11ef7f6a0c25de$var$POSITION_COLUMN_OPTIONS = [
    {
        id: 'secType',
        label: 'Type'
    },
    {
        id: 'strategy',
        label: 'Strategy'
    },
    {
        id: 'strategy_tags',
        label: 'Labels'
    },
    {
        id: 'quantity',
        label: 'Quantity'
    },
    {
        id: 'avg_cost',
        label: 'Entry Price'
    },
    {
        id: 'current_price',
        label: 'Market Price'
    },
    {
        id: 'market_value',
        label: 'Market Value'
    },
    {
        id: 'margin_used',
        label: 'Margin'
    },
    {
        id: 'daily_pnl',
        label: 'Daily P&L'
    },
    {
        id: 'daily_pnl_pct',
        label: 'Daily %'
    },
    {
        id: 'unrealized_pnl',
        label: 'Unrealized P&L'
    }
];
const $da11ef7f6a0c25de$var$getInitialHiddenPositionColumns = ()=>{
    if (typeof window === 'undefined') return new Set($da11ef7f6a0c25de$var$DEFAULT_HIDDEN_POSITION_COLUMNS);
    try {
        const stored = window.localStorage.getItem($da11ef7f6a0c25de$var$POSITION_COLUMN_STORAGE_KEY);
        if (stored === null) return new Set($da11ef7f6a0c25de$var$DEFAULT_HIDDEN_POSITION_COLUMNS);
        const parsed = JSON.parse(stored);
        if (!Array.isArray(parsed)) return new Set($da11ef7f6a0c25de$var$DEFAULT_HIDDEN_POSITION_COLUMNS);
        return new Set(parsed.filter((id)=>typeof id === 'string' && $da11ef7f6a0c25de$var$POSITION_COLUMN_OPTIONS.some(({ id: validId })=>validId === id)));
    } catch  {
        return new Set($da11ef7f6a0c25de$var$DEFAULT_HIDDEN_POSITION_COLUMNS);
    }
};
const $da11ef7f6a0c25de$var$getDailyAssetChangePercent = (position)=>{
    if (position.daily_pnl === undefined || position.daily_pnl === null) return null;
    const dailyPnl = Number(position.daily_pnl);
    if (!Number.isFinite(dailyPnl)) return null;
    const brokerMarketValue = position.market_value === undefined || position.market_value === null ? Number.NaN : Number(position.market_value);
    const parsedMultiplier = Number(position.multiplier);
    const multiplier = Number.isFinite(parsedMultiplier) && parsedMultiplier > 0 ? parsedMultiplier : 1;
    const currentMarketValue = Number.isFinite(brokerMarketValue) ? brokerMarketValue : Number(position.current_price) * Number(position.quantity) * multiplier;
    const previousMarketValue = currentMarketValue - dailyPnl;
    if (!Number.isFinite(previousMarketValue) || Math.abs(previousMarketValue) < 0.000001) return null;
    return dailyPnl / previousMarketValue * 100;
};
const $da11ef7f6a0c25de$var$OpenPositionsTable = ({ positions: positions, hasAnyPositions: hasAnyPositions, positionsSucceeded: positionsSucceeded, loading: loading, refreshing: refreshing, error: error, lastUpdated: lastUpdated, accountCurrency: accountCurrency, stale: stale, snapshotAvailable: snapshotAvailable, initializing: initializing, connectionUnavailable: connectionUnavailable, onRetry: onRetry, onClosePosition: onClosePosition, onOpenPositionChart: onOpenPositionChart, onEditPositionTags: onEditPositionTags })=>{
    const [expandedChartPositionKey, setExpandedChartPositionKey] = (0, $acw62.useState)(null);
    const [hiddenColumnIds, setHiddenColumnIds] = (0, $acw62.useState)($da11ef7f6a0c25de$var$getInitialHiddenPositionColumns);
    const [columnMenuOpen, setColumnMenuOpen] = (0, $acw62.useState)(false);
    const columnMenuRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        try {
            window.localStorage.setItem($da11ef7f6a0c25de$var$POSITION_COLUMN_STORAGE_KEY, JSON.stringify([
                ...hiddenColumnIds
            ]));
        } catch  {
        // Keep column selection usable when browser storage is unavailable.
        }
    }, [
        hiddenColumnIds
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!columnMenuOpen) return undefined;
        const closeOnOutsideClick = (event)=>{
            if (!columnMenuRef.current?.contains(event.target)) setColumnMenuOpen(false);
        };
        const closeOnEscape = (event)=>{
            if (event.key === 'Escape') setColumnMenuOpen(false);
        };
        document.addEventListener('mousedown', closeOnOutsideClick);
        document.addEventListener('keydown', closeOnEscape);
        return ()=>{
            document.removeEventListener('mousedown', closeOnOutsideClick);
            document.removeEventListener('keydown', closeOnEscape);
        };
    }, [
        columnMenuOpen
    ]);
    const toggleColumn = (columnId)=>{
        setHiddenColumnIds((current)=>{
            const next = new Set(current);
            if (next.has(columnId)) next.delete(columnId);
            else next.add(columnId);
            return next;
        });
    };
    const columns = [
        {
            id: 'symbol',
            header: 'Symbol',
            accessor: 'symbol',
            sortable: true,
            className: 'w-[1%]',
            headerClassName: 'w-[1%]',
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "font-semibold text-[12px] tracking-tight text-white",
                        children: (0, $d7aJR.getPositionDisplaySymbol)(position)
                    })
                })
        },
        {
            id: 'secType',
            header: 'Type',
            accessor: (position)=>position.secType || 'STK',
            sortable: true,
            className: 'text-white/70 text-[12px]'
        },
        {
            id: 'strategy',
            header: 'Strategy',
            accessor: (position)=>(0, $d7aJR.getPositionDisplayStrategies)(position).join(', '),
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex flex-wrap gap-1",
                            children: (0, $d7aJR.getPositionDisplayStrategies)(position).map((strategy, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    title: (position.strategy_order_lots || []).filter((lot)=>lot.strategy === ((0, $d7aJR.getPositionStrategies)(position)[index] || strategy)).map((lot)=>`${lot.strategy}: opened ${lot.opened_at || 'date unavailable'}${lot.opening_order_id ? ` by order #${lot.opening_order_id}` : ''}`).join('\n') || undefined,
                                    className: `rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${strategy === 'UNASSIGNED' ? 'border border-white/10 bg-white/5 text-white/45' : 'border border-neon/20 bg-neon/10 text-neon'}`,
                                    children: strategy
                                }, strategy))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: (event)=>{
                                event.stopPropagation();
                                onEditPositionTags(position);
                            },
                            className: "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-white/10 text-white/40 transition-colors hover:border-neon/30 hover:bg-neon/10 hover:text-neon",
                            title: "Edit position strategy label",
                            "aria-label": `Edit position strategy label for ${(0, $d7aJR.getPositionDisplaySymbol)(position)}`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c2a827dd5c2d433$export$2e2bcd8739ae039), {
                                className: "h-3 w-3"
                            })
                        })
                    ]
                })
        },
        {
            id: 'strategy_tags',
            header: 'Labels',
            headerInfo: 'Descriptive labels attached to this position for notes and reminders.',
            accessor: (position)=>(position.strategy_tags || []).map((tag)=>tag.name).join(', '),
            sortable: true,
            className: 'w-[1%]',
            headerClassName: 'w-[1%]',
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex max-w-[200px] flex-wrap items-center gap-1",
                    children: [
                        (position.strategy_tags || []).map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                title: tag.description || tag.name,
                                className: "max-w-[76px] truncate rounded border px-1 py-0.5 text-[9px] font-bold tracking-wide text-white/85",
                                style: {
                                    borderColor: `${(0, $d7aJR.getStrategyTagColor)(tag)}66`,
                                    backgroundColor: `${(0, $d7aJR.getStrategyTagColor)(tag)}1A`
                                },
                                children: tag.name
                            }, tag.id)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: (event)=>{
                                event.stopPropagation();
                                onEditPositionTags(position);
                            },
                            className: "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded border border-dashed border-white/20 text-white/50 transition-colors hover:border-neon/40 hover:text-neon",
                            title: position.strategy_tags?.length ? 'Edit position labels' : 'Add position labels',
                            "aria-label": position.strategy_tags?.length ? 'Edit position labels' : 'Add position labels',
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8872a1d80d2463f9$export$2e2bcd8739ae039), {
                                className: "h-3 w-3"
                            })
                        })
                    ]
                })
        },
        {
            id: 'quantity',
            header: 'Quantity',
            accessor: 'quantity',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `flex items-center gap-1.5 ${position.quantity && position.quantity < 0 ? 'text-rose-400' : 'text-white'}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "font-mono text-[14px] font-bold",
                        children: position.quantity
                    })
                })
        },
        {
            id: 'avg_cost',
            header: 'Entry Price',
            accessor: 'avg_cost',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "text-white/90 font-mono text-[13px]",
                    children: position.avg_cost !== undefined && position.avg_cost !== null ? (0, $b1rqt.formatCurrency)(position.avg_cost, position.currency) : '-'
                })
        },
        {
            id: 'current_price',
            header: 'Mkt Price',
            accessor: 'current_price',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: `font-mono text-[13px] font-bold ${refreshing ? 'animate-pulse text-neon' : 'text-white/90'}`,
                    children: [
                        position.current_price !== undefined && position.current_price !== null ? (0, $b1rqt.formatCurrency)(position.current_price, position.currency) : '-',
                        position.quote_stale && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "ml-1 text-[9px] text-amber-300",
                            children: "Stale"
                        })
                    ]
                })
        },
        {
            id: 'market_value',
            header: 'Market Value',
            accessor: 'market_value',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: `font-mono text-[13px] font-bold ${refreshing ? 'animate-pulse text-neon' : 'text-white/80'}`,
                    children: (0, $b1rqt.formatCurrency)(position.market_value, position.currency)
                })
        },
        {
            id: 'margin_used',
            header: 'Margin',
            headerInfo: 'Estimated margin allocated to this position. The percentage is relative to total account value.',
            accessor: 'margin_used',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "font-mono text-[13px] font-bold text-white/80 leading-tight",
                    children: [
                        position.margin_used_pct !== undefined && position.margin_used_pct !== null && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                position.margin_used_pct.toFixed(2),
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "text-[11px] font-normal text-muted",
                            children: (0, $d7aJR.formatPlainNumber)(position.margin_used)
                        })
                    ]
                })
        },
        {
            id: 'daily_pnl',
            header: 'Daily P&L',
            accessor: 'daily_pnl',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `font-black font-mono text-[14px] ${(position.daily_pnl || 0) < 0 ? 'text-rose-400' : (position.daily_pnl || 0) > 0 ? 'text-emerald-400' : 'text-white/40'}`,
                    children: position.daily_pnl !== undefined && position.daily_pnl !== null ? (0, $b1rqt.formatCurrency)(position.daily_pnl, position.currency) : '-'
                })
        },
        {
            id: 'daily_pnl_pct',
            header: 'Daily %',
            headerInfo: 'Estimated underlying daily price change, calculated from daily P&L and the prior position value.',
            accessor: (position)=>$da11ef7f6a0c25de$var$getDailyAssetChangePercent(position),
            sortable: true,
            render: (position)=>{
                const dailyPercent = $da11ef7f6a0c25de$var$getDailyAssetChangePercent(position);
                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `font-black font-mono text-[13px] ${dailyPercent === null ? 'text-white/40' : dailyPercent > 0 ? 'text-emerald-400' : dailyPercent < 0 ? 'text-rose-400' : 'text-white/80'}`,
                    children: dailyPercent === null ? "\u2014" : `${dailyPercent > 0 ? '+' : ''}${dailyPercent.toFixed(2)}%`
                });
            }
        },
        {
            id: 'unrealized_pnl',
            header: 'Unrealized P&L',
            accessor: 'unrealized_pnl',
            sortable: true,
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `font-black font-mono text-[14px] ${(position.unrealized_pnl || 0) < 0 ? 'text-rose-400' : (position.unrealized_pnl || 0) > 0 ? 'text-emerald-400' : 'text-white/40'}`,
                    children: position.unrealized_pnl !== undefined && position.unrealized_pnl !== null ? (0, $b1rqt.formatCurrency)(position.unrealized_pnl, position.currency) : '-'
                })
        },
        {
            id: 'actions',
            header: 'Actions',
            accessor: 'id',
            align: 'right',
            render: (position)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "px-3 py-1.5 rounded-lg border border-rose-500/30 bg-rose-500/10 text-[10px] font-bold uppercase tracking-[0.12em] text-rose-200 hover:bg-rose-500/20 active:scale-95 transition-all disabled:opacity-50",
                    disabled: refreshing,
                    onClick: (event)=>{
                        event.stopPropagation();
                        onClosePosition(position);
                    },
                    children: "Close"
                })
        }
    ];
    const visibleColumns = columns.filter((column)=>column.id === 'symbol' || column.id === 'actions' || !hiddenColumnIds.has(column.id));
    const totalPositionValue = positions.reduce((sum, position)=>{
        const marketValue = position.market_value !== undefined && position.market_value !== null ? Number(position.market_value) : Number.NaN;
        if (Number.isFinite(marketValue)) return sum + Math.abs(marketValue);
        const price = Number(position.current_price);
        const quantity = Number(position.quantity);
        const parsedMultiplier = Number(position.multiplier);
        const multiplier = Number.isFinite(parsedMultiplier) && parsedMultiplier > 0 ? parsedMultiplier : 1;
        return Number.isFinite(price) && Number.isFinite(quantity) ? sum + Math.abs(price * quantity * multiplier) : sum;
    }, 0);
    const totalDailyPnl = positions.reduce((sum, position)=>sum + (position.daily_pnl || 0), 0);
    const isDailyPositive = totalDailyPnl >= 0;
    const totalUnrealized = positions.reduce((sum, position)=>sum + (position.unrealized_pnl || 0), 0);
    const isPositive = totalUnrealized >= 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex min-h-0 flex-1 flex-col space-y-6",
        children: [
            stale && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "rounded-xl border border-warning-500/25 bg-warning-500/10 px-4 py-3 text-xs text-warning-300",
                children: initializing ? 'IB is connected and positions are synchronizing. This panel will refresh automatically.' : connectionUnavailable ? "IB is connected, but live positions are temporarily unavailable \u2014 showing the latest persisted snapshot." : !snapshotAvailable ? "Gateway offline \u2014 no persisted position snapshot is available yet." : "Gateway offline \u2014 showing the last persisted position snapshot."
            }),
            !error && positionsSucceeded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3 pb-2",
                children: [
                    hasAnyPositions && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-[10px] font-bold uppercase tracking-wider text-emerald-400",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa7706f9ee0421dc$export$2e2bcd8739ae039), {
                                        size: 12
                                    }),
                                    positions.length,
                                    " Active ",
                                    positions.length === 1 ? 'Position' : 'Positions'
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[10px] font-bold uppercase tracking-wider text-white/80",
                                title: "Gross market value of the positions matching the current filters",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4reVr.default), {
                                        size: 12
                                    }),
                                    "Total value: ",
                                    (0, $b1rqt.formatCurrency)(totalPositionValue, accountCurrency)
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[10px] font-bold uppercase tracking-wider ${isDailyPositive ? 'text-emerald-400' : 'text-rose-400'}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bKJAw.default), {
                                        size: 12
                                    }),
                                    "Daily P&L: ",
                                    (0, $b1rqt.formatCurrency)(totalDailyPnl, accountCurrency)
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[10px] font-bold uppercase tracking-wider ${isPositive ? 'text-emerald-400' : 'text-rose-400'}`,
                                children: [
                                    isPositive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiXj7.default), {
                                        size: 12
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jQdKn.default), {
                                        size: 12
                                    }),
                                    "Unrealized: ",
                                    (0, $b1rqt.formatCurrency)(totalUnrealized, accountCurrency)
                                ]
                            }),
                            lastUpdated && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-[10px] font-bold uppercase tracking-wider text-muted",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Kpom.default), {
                                        size: 12
                                    }),
                                    "Refreshed: ",
                                    lastUpdated
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "relative ml-auto",
                        ref: columnMenuRef,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setColumnMenuOpen((open)=>!open),
                                "aria-label": "Choose visible position fields",
                                "aria-expanded": columnMenuOpen,
                                className: "inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-white/70 transition-colors hover:border-neon/30 hover:bg-neon/10 hover:text-neon",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $753mY.default), {
                                        className: "h-3.5 w-3.5"
                                    }),
                                    "Fields"
                                ]
                            }),
                            columnMenuOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "absolute right-0 top-full z-30 mt-2 max-h-[70vh] w-56 overflow-y-auto rounded-xl border border-white/10 bg-slate-950 p-3 shadow-2xl",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mb-2 px-1 text-[9px] font-bold uppercase tracking-widest text-muted",
                                        children: "Shown fields"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "space-y-1",
                                        children: $da11ef7f6a0c25de$var$POSITION_COLUMN_OPTIONS.map(({ id: id, label: label })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 text-xs text-white/75 transition-colors hover:bg-white/5 hover:text-white",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "checkbox",
                                                        checked: !hiddenColumnIds.has(id),
                                                        onChange: ()=>toggleColumn(id),
                                                        className: "h-3.5 w-3.5 accent-teal-400"
                                                    }),
                                                    label
                                                ]
                                            }, id))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iqWry.default), {
                error: error,
                onRetry: onRetry,
                message: "Failed to load positions"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7s03j.DataTable), {
                data: positions,
                columns: visibleColumns,
                className: "min-h-0 flex-1",
                compact: true,
                loading: loading,
                onRowClick: (position)=>{
                    const rowKey = (0, $d7aJR.getPositionRowKey)(position);
                    setExpandedChartPositionKey((current)=>current === rowKey ? null : rowKey);
                },
                getRowKey: (0, $d7aJR.getPositionRowKey),
                expandedRowKey: expandedChartPositionKey,
                renderExpandedRow: (position)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fd65599a8e822ef$export$2e2bcd8739ae039), {
                        position: position,
                        inline: true,
                        onClose: ()=>setExpandedChartPositionKey(null),
                        onOpenModal: ()=>onOpenPositionChart(position)
                    }),
                emptyMessage: stale && !snapshotAvailable ? initializing ? "Synchronizing positions\u2026" : 'No persisted position snapshot available' : 'No open positions found',
                initialSort: {
                    id: 'unrealized_pnl',
                    direction: 'desc'
                }
            })
        ]
    });
};
var $da11ef7f6a0c25de$export$2e2bcd8739ae039 = $da11ef7f6a0c25de$var$OpenPositionsTable;



var $acw62 = parcelRequire("acw62");

var $d7aJR = parcelRequire("d7aJR");
function $9bfc52f3a5011dc8$export$6641edcb96c6f745({ service: service, refreshAfterDelete: refreshAfterDelete, refreshAfterSave: refreshAfterSave }) {
    const [strategyTags, setStrategyTags] = (0, $acw62.useState)([]);
    const [managerOpen, setManagerOpen] = (0, $acw62.useState)(false);
    const [editorPosition, setEditorPosition] = (0, $acw62.useState)(null);
    const [selectedTagIds, setSelectedTagIds] = (0, $acw62.useState)([]);
    const [strategyLabelOverride, setStrategyLabelOverride] = (0, $acw62.useState)('');
    const [editingTagId, setEditingTagId] = (0, $acw62.useState)(null);
    const [tagName, setTagName] = (0, $acw62.useState)('');
    const [tagDescription, setTagDescription] = (0, $acw62.useState)('');
    const [tagColor, setTagColor] = (0, $acw62.useState)('#14B8A6');
    const [tagBusy, setTagBusy] = (0, $acw62.useState)(false);
    const [tagError, setTagError] = (0, $acw62.useState)(null);
    const loadStrategyTags = (0, $acw62.useCallback)(async ()=>{
        try {
            const response = await service.listTags();
            if (response.success) {
                setStrategyTags(response.data?.tags || []);
                setTagError(null);
            } else if (managerOpen) setTagError(response.error || 'Failed to load position labels');
        } catch (err) {
            if (managerOpen) setTagError(err instanceof Error ? err.message : 'Failed to load position labels');
        }
    }, [
        managerOpen,
        service
    ]);
    (0, $acw62.useEffect)(()=>{
        loadStrategyTags();
    }, [
        loadStrategyTags
    ]);
    const openManager = ()=>{
        setTagError(null);
        setManagerOpen(true);
    };
    const openPositionTagEditor = (position)=>{
        setTagError(null);
        setEditorPosition({
            ...position,
            position_key: (0, $d7aJR.getPositionMetadataKey)(position)
        });
        setSelectedTagIds((position.strategy_tags || []).map((tag)=>tag.id));
        setStrategyLabelOverride(position.custom_strategy_name || '');
    };
    const openManagerFromEditor = ()=>{
        setEditorPosition(null);
        openManager();
    };
    const resetTagForm = ()=>{
        setEditingTagId(null);
        setTagName('');
        setTagDescription('');
        setTagColor('#14B8A6');
    };
    const editTag = (tag)=>{
        setEditingTagId(tag.id);
        setTagName(tag.name);
        setTagDescription(tag.description || '');
        setTagColor(tag.color || '#14B8A6');
    };
    const saveStrategyTag = async (event)=>{
        event.preventDefault();
        if (!tagName.trim()) return;
        setTagBusy(true);
        setTagError(null);
        try {
            const response = await service.saveTag({
                editingTagId: editingTagId,
                name: tagName,
                description: tagDescription,
                color: tagColor
            });
            if (!response.success) {
                setTagError(response.error || 'Failed to save position label');
                return;
            }
            resetTagForm();
            await loadStrategyTags();
        } catch (err) {
            setTagError(err instanceof Error ? err.message : 'Failed to save position label');
        } finally{
            setTagBusy(false);
        }
    };
    const removeStrategyTag = async (tag)=>{
        if (!window.confirm(`Delete the \u{201C}${tag.name}\u{201D} label? Existing position links will be removed.`)) return;
        setTagBusy(true);
        setTagError(null);
        try {
            const response = await service.deleteTag(tag.id);
            if (!response.success) {
                setTagError(response.error || 'Failed to delete position label');
                return;
            }
            if (editingTagId === tag.id) resetTagForm();
            setSelectedTagIds((ids)=>ids.filter((id)=>id !== tag.id));
            await loadStrategyTags();
            await refreshAfterDelete();
        } catch (err) {
            setTagError(err instanceof Error ? err.message : 'Failed to delete position label');
        } finally{
            setTagBusy(false);
        }
    };
    const savePositionTags = async ()=>{
        if (!editorPosition) return;
        const positionKey = (0, $d7aJR.getPositionMetadataKey)(editorPosition);
        setTagBusy(true);
        setTagError(null);
        try {
            const response = await service.savePositionMetadata(positionKey, strategyLabelOverride, selectedTagIds);
            if (!response.success) {
                setTagError(response.error || 'Failed to update position labels');
                return;
            }
            setEditorPosition(null);
            await refreshAfterSave();
        } catch (err) {
            setTagError(err instanceof Error ? err.message : 'Failed to update position labels');
        } finally{
            setTagBusy(false);
        }
    };
    return {
        strategyTags: strategyTags,
        managerOpen: managerOpen,
        setManagerOpen: setManagerOpen,
        editorPosition: editorPosition,
        setEditorPosition: setEditorPosition,
        selectedTagIds: selectedTagIds,
        setSelectedTagIds: setSelectedTagIds,
        strategyLabelOverride: strategyLabelOverride,
        setStrategyLabelOverride: setStrategyLabelOverride,
        editingTagId: editingTagId,
        tagName: tagName,
        setTagName: setTagName,
        tagDescription: tagDescription,
        setTagDescription: setTagDescription,
        tagColor: tagColor,
        setTagColor: setTagColor,
        tagBusy: tagBusy,
        tagError: tagError,
        setTagError: setTagError,
        openManager: openManager,
        openPositionTagEditor: openPositionTagEditor,
        openManagerFromEditor: openManagerFromEditor,
        resetTagForm: resetTagForm,
        editTag: editTag,
        saveStrategyTag: saveStrategyTag,
        removeStrategyTag: removeStrategyTag,
        savePositionTags: savePositionTags
    };
}



var $d7aJR = parcelRequire("d7aJR");
const $cca2f94cfcbe1305$var$PositionsOrdersPanel = ({ refreshInterval: refreshInterval = 30000, onEditOrder: onEditOrder, className: className = '' })=>{
    const positionTagService = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new (0, $15840e16c159feea$export$6339b3d8d8e13ec3)((0, $2wVnk.tradingApi)), []);
    const { data: positions = null, isLoading: loading, isFetching: refreshing, error: positionsError, refetch: refetchPositions } = (0, $jtEPT.usePositionsQuery)(undefined, {
        pollingInterval: refreshInterval,
        skipPollingIfUnfocused: true
    });
    const { data: ordersData, refetch: refetchOrders } = (0, $jtEPT.useOpenOrdersQuery)({
        page: 1,
        pageSize: 100
    }, {
        pollingInterval: refreshInterval,
        skipPollingIfUnfocused: true
    });
    const [actionError, setActionError] = (0, $acw62.useState)(null);
    const [activeTab, setActiveTab] = (0, $acw62.useState)('positions');
    const [strategyFilter, setStrategyFilter] = (0, $acw62.useState)('ALL');
    const [securityTypeFilter, setSecurityTypeFilter] = (0, $acw62.useState)('ALL');
    const [pendingClose, setPendingClose] = (0, $acw62.useState)(null);
    const [chartPosition, setChartPosition] = (0, $acw62.useState)(null);
    const tagManagement = (0, $9bfc52f3a5011dc8$export$6641edcb96c6f745)({
        service: positionTagService,
        refreshAfterDelete: ()=>refetchPositions(),
        refreshAfterSave: ()=>refetchPositions().unwrap()
    });
    const { openManager: openStrategyTagManager, openPositionTagEditor: openPositionTagEditor } = tagManagement;
    const lastUpdated = positions?.timestamp ? (0, $k8QNV.formatTimeET)(positions.timestamp) : null;
    const openOrdersCount = (ordersData?.data?.orders || []).filter((order)=>securityTypeFilter === 'ALL' || (0, $d7aJR.getSecurityType)(order) === securityTypeFilter).length;
    const error = actionError || (positionsError && !positions ? 'Failed to fetch positions' : null);
    const positionsStale = !!positions?.data?.stale;
    const positionsSnapshotAvailable = positions?.data?.snapshot_available !== false;
    const positionsInitializing = positions?.data?.connection_status === 'initializing';
    const ordersInitializing = ordersData?.data?.connection_status === 'initializing';
    const quoteIdentifiers = (0, $d7aJR.getPositionQuoteIdentifiers)(positions?.data?.positions || []);
    const liveQuotes = (0, $ee10d9a55e84bc57$export$d969c99f03d34b97)(quoteIdentifiers);
    const quoteConnectionStatus = (0, $ee10d9a55e84bc57$export$2341ff61511dbf4b)();
    const displayedPositions = (positions?.data?.positions || []).map((position, index)=>{
        const identifier = String(quoteIdentifiers[index] || '').toUpperCase();
        return (0, $d7aJR.addLiveQuoteToPosition)(position, liveQuotes[identifier], quoteConnectionStatus, positionsStale);
    });
    const strategyOptions = (0, $d7aJR.getPositionStrategyOptions)(displayedPositions);
    const strategyNameOptions = (0, $d7aJR.getPositionStrategyNameOptions)(displayedPositions);
    const filteredPositions = (0, $d7aJR.filterPositions)(displayedPositions, strategyFilter, securityTypeFilter);
    const fetchPositions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        setActionError(null);
        try {
            await Promise.all([
                refetchPositions().unwrap(),
                refetchOrders().unwrap()
            ]);
        } catch (err) {
            setActionError(err instanceof Error ? err.message : 'Failed to fetch positions');
        }
    }, [
        refetchOrders,
        refetchPositions
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleRefresh = ()=>fetchPositions();
        window.addEventListener('trading-data-refresh', handleRefresh);
        return ()=>window.removeEventListener('trading-data-refresh', handleRefresh);
    }, [
        fetchPositions
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!positionsInitializing && !ordersInitializing) return;
        const retryId = window.setTimeout(()=>fetchPositions(), 2000);
        return ()=>window.clearTimeout(retryId);
    }, [
        fetchPositions,
        ordersInitializing,
        positions?.timestamp,
        positionsInitializing
    ]);
    const accountCurrency = positions?.data?.currency || 'USD';
    const handleCloseClick = (position)=>{
        if (!position.symbol || position.quantity === undefined) return;
        // Calculate the closing order details
        const qty = position.quantity;
        const side = qty < 0 ? 'BUY' : 'SELL';
        setPendingClose({
            symbol: position.symbol,
            displaySymbol: (0, $d7aJR.getPositionDisplaySymbol)(position),
            quantity: Math.abs(qty),
            side: side,
            secType: position.secType || 'STK',
            contract: {
                con_id: position.con_id,
                exchange: position.exchange,
                currency: position.currency,
                local_symbol: position.local_symbol,
                trading_class: position.trading_class,
                last_trade_date_or_contract_month: position.last_trade_date_or_contract_month,
                multiplier: position.multiplier
            }
        });
    };
    const handleCancelClose = ()=>{
        setPendingClose(null);
    };
    const pendingCloseDraft = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!pendingClose) return null;
        return {
            symbol: pendingClose.symbol,
            rootSymbol: pendingClose.symbol,
            side: pendingClose.side,
            quantity: pendingClose.quantity,
            order_type: 'MARKET',
            secType: pendingClose.secType,
            strategy: 'MANUAL',
            tif: 'DAY',
            outside_rth: false,
            con_id: pendingClose.contract.con_id,
            exchange: pendingClose.contract.exchange,
            currency: pendingClose.contract.currency,
            localSymbol: pendingClose.contract.local_symbol,
            tradingClass: pendingClose.contract.trading_class,
            lastTradeDateOrContractMonth: pendingClose.contract.last_trade_date_or_contract_month,
            multiplier: pendingClose.contract.multiplier
        };
    }, [
        pendingClose
    ]);
    const handleCloseOrderSubmitted = ()=>{
        setPendingClose(null);
        setActionError(null);
        fetchPositions();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `panel full-bleed-panel flex min-h-0 w-full flex-col ${className}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex shrink-0 flex-col justify-between gap-4 border-b border-white/10 px-6 py-5 sm:flex-row sm:items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "p-2 rounded-lg bg-neon/10 text-neon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4wROA.default), {
                                    className: "w-5 h-5"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "text-lg font-bold text-white tracking-tight",
                                        children: "Positions & Orders"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-sm text-muted",
                                        children: "Real-time portfolio oversight and execution logs."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center p-1 bg-white/5 border border-white/10 rounded-xl",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>setActiveTab('positions'),
                                className: `px-4 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-all duration-300 flex items-center gap-2 ${activeTab === 'positions' ? 'bg-neon/10 text-neon shadow-[0_0_15px_rgba(45,212,191,0.1)]' : 'text-muted hover:text-white hover:bg-white/5'}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "Positions"
                                    }),
                                    filteredPositions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[9px] font-black leading-none ${activeTab === 'positions' ? 'bg-neon text-black shadow-[0_0_10px_rgba(var(--neon-rgb),0.4)]' : 'bg-white/10 text-white/60 border border-white/10'}`,
                                        children: filteredPositions.length
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>setActiveTab('orders'),
                                className: `px-4 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-all duration-300 flex items-center gap-2 ${activeTab === 'orders' ? 'bg-neon/10 text-neon shadow-[0_0_15px_rgba(45,212,191,0.1)]' : 'text-muted hover:text-white hover:bg-white/5'}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "Orders"
                                    }),
                                    openOrdersCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[9px] font-black leading-none ${activeTab === 'orders' ? 'bg-neon text-black shadow-[0_0_10px_rgba(var(--neon-rgb),0.4)]' : 'bg-white/10 text-white/60 border border-white/10'}`,
                                        children: openOrdersCount
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex min-h-0 flex-1 flex-col p-6",
                children: [
                    !actionError && (positions?.success || ordersData?.success) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-6 flex flex-wrap items-center gap-x-2 gap-y-2",
                        children: [
                            activeTab === 'positions' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onClick: openStrategyTagManager,
                                        className: "mr-2 inline-flex items-center gap-1.5 rounded-full border border-neon/25 bg-neon/10 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-neon transition-colors hover:border-neon/50 hover:bg-neon/15",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8872a1d80d2463f9$export$2e2bcd8739ae039), {
                                                className: "h-3 w-3"
                                            }),
                                            "Manage tags"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mr-1 text-[10px] font-bold uppercase tracking-wider text-muted",
                                        children: "Strategy"
                                    }),
                                    [
                                        'ALL',
                                        ...strategyOptions
                                    ].map((strategy)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setStrategyFilter(strategy),
                                            className: `rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors ${strategyFilter === strategy ? 'border-neon/40 bg-neon/15 text-neon' : 'border-white/10 bg-white/5 text-white/55 hover:border-white/20 hover:text-white'}`,
                                            children: strategy === 'ALL' ? 'All strategies' : strategy
                                        }, strategy)),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mx-1 hidden h-4 w-px bg-white/10 sm:block"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mr-1 text-[10px] font-bold uppercase tracking-wider text-muted",
                                children: "Asset"
                            }),
                            (0, $d7aJR.securityTypeOptions).map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setSecurityTypeFilter(option.value),
                                    className: `rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors ${securityTypeFilter === option.value ? 'border-neon/40 bg-neon/15 text-neon' : 'border-white/10 bg-white/5 text-white/55 hover:border-white/20 hover:text-white'}`,
                                    children: option.label
                                }, option.value))
                        ]
                    }),
                    activeTab === 'positions' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da11ef7f6a0c25de$export$2e2bcd8739ae039), {
                        positions: filteredPositions,
                        hasAnyPositions: displayedPositions.length > 0,
                        positionsSucceeded: positions?.success === true,
                        loading: loading,
                        refreshing: refreshing,
                        error: error,
                        lastUpdated: lastUpdated,
                        accountCurrency: accountCurrency,
                        stale: positionsStale,
                        snapshotAvailable: positionsSnapshotAvailable,
                        initializing: positionsInitializing,
                        connectionUnavailable: positions?.data?.connection_status === 'unavailable',
                        onRetry: ()=>void fetchPositions(),
                        onClosePosition: handleCloseClick,
                        onOpenPositionChart: setChartPosition,
                        onEditPositionTags: openPositionTagEditor
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "animate-in fade-in slide-in-from-bottom-2 duration-300",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f3266c1f84cfee9$export$2e2bcd8739ae039), {
                                refreshInterval: refreshInterval,
                                onEditOrder: onEditOrder,
                                securityTypeFilter: securityTypeFilter
                            }, `open-orders-${securityTypeFilter}`),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c775cf1fce7c60c6$export$2e2bcd8739ae039), {
                                refreshInterval: refreshInterval,
                                securityTypeFilter: securityTypeFilter
                            }, `filled-orders-${securityTypeFilter}`)
                        ]
                    })
                ]
            }),
            chartPosition && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fd65599a8e822ef$export$2e2bcd8739ae039), {
                position: chartPosition,
                onClose: ()=>setChartPosition(null)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dc0c58967a03c01f$export$2e2bcd8739ae039), {
                state: tagManagement,
                strategyNameOptions: strategyNameOptions
            }),
            pendingCloseDraft && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7eyud.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 z-[1000] flex items-center justify-center bg-black/55 p-0 backdrop-blur-sm animate-in fade-in duration-300 sm:p-4",
                    onClick: (event)=>{
                        if (event.target === event.currentTarget) handleCancelClose();
                    },
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": `Close ${pendingCloseDraft.symbol}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "relative max-h-[100dvh] w-full max-w-2xl overflow-y-auto animate-in zoom-in duration-300 sm:max-h-[calc(100vh-2rem)]",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: handleCancelClose,
                                "aria-label": "Close order modal",
                                title: "Close",
                                className: "absolute right-3 top-3 z-10 rounded-lg p-2 text-white/50 transition-colors hover:bg-white/10 hover:text-white",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                    className: "h-4 w-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b6f36562471e94f$export$2e2bcd8739ae039), {
                                prefillOrder: pendingCloseDraft,
                                inModal: true,
                                showCancelButton: true,
                                onCancel: handleCancelClose,
                                onOrderSubmitted: handleCloseOrderSubmitted
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $cca2f94cfcbe1305$export$2e2bcd8739ae039 = $cca2f94cfcbe1305$var$PositionsOrdersPanel;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2wVnk = parcelRequire("2wVnk");

var $bKJAw = parcelRequire("bKJAw");
var $kTCPA = parcelRequire("kTCPA");
var $6Plhc = parcelRequire("6Plhc");
var $fpYe5 = parcelRequire("fpYe5");
var $jFR94 = parcelRequire("jFR94");
var $di5Ac = parcelRequire("di5Ac");
parcelRequire("jl3Sp");
var $2zES5 = parcelRequire("2zES5");

var $k8QNV = parcelRequire("k8QNV");
const $68b74abbcb17504f$var$SignalLogPanel = ({ fullBleed: fullBleed = false })=>{
    const [signals, setSignals] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [strategy, setStrategy] = (0, $acw62.useState)('');
    const [symbol, setSymbol] = (0, $acw62.useState)('');
    const [limit, setLimit] = (0, $acw62.useState)(50);
    const [expandedId, setExpandedId] = (0, $acw62.useState)(null);
    const fetchSignals = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const response = await (0, $2wVnk.tradingApi).getStrategySignals({
                strategy: strategy || undefined,
                symbol: symbol || undefined,
                limit: limit
            });
            if (response && response.success) setSignals(response.data ?? []);
        } catch (err) {
            console.error('Failed to fetch signals:', err);
        } finally{
            setLoading(false);
        }
    }, [
        strategy,
        symbol,
        limit
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchSignals();
        // Poll every 30s if looking at recent signals
        const id = setInterval(fetchSignals, 30000);
        return ()=>clearInterval(id);
    }, [
        fetchSignals
    ]);
    const getSignalColor = (signal)=>{
        switch(signal){
            case 'BUY':
                return 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20';
            case 'SELL':
                return 'text-red-400 bg-red-500/10 border-red-500/20';
            default:
                return 'text-gray-400 bg-white/5 border-white/10';
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `panel flex flex-col h-[600px] ${fullBleed ? 'full-bleed-panel' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-4 border-b border-white/10 bg-white/5 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bKJAw.default), {
                                className: "w-5 h-5 text-neon"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "text-md font-semibold text-white",
                                children: "Signal History"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-xs text-muted ml-2",
                                children: "Audit trail of strategy decisions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2zES5.CustomSelect), {
                                value: strategy,
                                onChange: setStrategy,
                                options: [
                                    {
                                        value: '',
                                        label: 'All Strategies'
                                    },
                                    {
                                        value: 'ON',
                                        label: 'Overnight (ON)'
                                    },
                                    {
                                        value: 'ORB',
                                        label: 'ORB'
                                    },
                                    {
                                        value: 'DT',
                                        label: 'Day Trade (DT)'
                                    },
                                    {
                                        value: 'NQMM',
                                        label: 'Nasdaq Momentum (NQMM)'
                                    }
                                ],
                                buttonClassName: "bg-surface border-white/10 rounded-lg px-3 py-1 text-xs text-foreground h-8",
                                className: "min-w-[150px]",
                                align: "right",
                                ariaLabel: "Strategy filter"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                placeholder: "Symbol...",
                                value: symbol,
                                onChange: (e)=>setSymbol(e.target.value.toUpperCase()),
                                className: "bg-surface border border-white/10 rounded-lg px-3 py-1 text-xs text-foreground w-24 outline-none focus:border-neon/50"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: fetchSignals,
                                className: "p-1.5 rounded-lg hover:bg-white/10 text-muted transition",
                                title: "Refresh",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $di5Ac.default), {
                                    className: "w-4 h-4"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex-1 overflow-y-auto scrollbar-thin",
                children: loading && signals.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex items-center justify-center p-12",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "animate-spin rounded-full h-8 w-8 border-b-2 border-neon"
                    })
                }) : signals.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-col items-center justify-center p-12 text-muted",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jFR94.default), {
                            className: "w-8 h-8 mb-2 opacity-20"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "No signals found matching filters."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "w-full text-left border-collapse",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            className: "sticky top-0 bg-surface/90 backdrop-blur-md z-10",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                className: "text-[10px] uppercase tracking-wider text-muted border-b border-white/5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Time (NY)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Strategy"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Symbol"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Signal"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-4 py-3 font-semibold",
                                        children: "Execution"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-4 py-3 font-semibold"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            className: "text-xs divide-y divide-white/5",
                            children: signals.map((sig)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            className: `group hover:bg-white/5 transition-colors cursor-pointer ${expandedId === sig.id ? 'bg-white/5' : ''}`,
                                            onClick: ()=>setExpandedId(expandedId === sig.id ? null : sig.id),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 py-3 text-muted whitespace-nowrap font-mono text-[11px]",
                                                    children: (0, $k8QNV.formatDateTimeET)(sig.timestamp)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 py-3 font-medium text-foreground",
                                                    children: sig.strategy
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "px-2 py-0.5 rounded bg-white/5 font-mono text-white/80",
                                                        children: sig.symbol
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `px-2 py-0.5 rounded-full border text-[10px] font-bold ${getSignalColor(sig.signal)}`,
                                                        children: sig.signal
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "px-4 py-3 font-mono text-muted",
                                                    children: [
                                                        "$",
                                                        sig.price?.toFixed(2) || '---'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 py-3",
                                                    children: sig.was_executed ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex items-center gap-1 text-emerald-400",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kTCPA.default), {
                                                                className: "w-3.5 h-3.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "text-[10px] font-semibold uppercase tracking-tighter",
                                                                children: "Filled"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-muted text-[10px] uppercase tracking-tighter opacity-50",
                                                        children: "Log Only"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "px-4 py-3 text-right",
                                                    children: expandedId === sig.id ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fpYe5.default), {
                                                        className: "w-4 h-4 text-muted"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Plhc.default), {
                                                        className: "w-4 h-4 text-muted opacity-0 group-hover:opacity-100"
                                                    })
                                                })
                                            ]
                                        }),
                                        expandedId === sig.id && /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                            className: "bg-white/5 border-x-2 border-neon/20",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                colSpan: 7,
                                                className: "px-8 py-4",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "flex items-start justify-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-[10px] uppercase text-muted mb-1 font-bold tracking-widest",
                                                                            children: "Reason"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-foreground text-sm leading-relaxed",
                                                                            children: sig.reason || 'N/A'
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "text-right",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-[10px] uppercase text-muted mb-1 font-bold tracking-widest",
                                                                            children: "Signal ID"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "text-muted font-mono",
                                                                            children: sig.id
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        sig.metadata_json && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "text-[10px] uppercase text-muted mb-2 font-bold tracking-widest",
                                                                    children: "Technical Metadata"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "grid grid-cols-2 md:grid-cols-4 gap-4 p-3 rounded-xl bg-black/40 border border-white/5 border-dashed",
                                                                    children: Object.entries(sig.metadata_json).map(([k, v])=>typeof v !== 'object' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "text-[9px] text-muted-foreground uppercase opacity-70 mb-0.5",
                                                                                    children: k.replace(/_/g, ' ')
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "font-mono text-white/90",
                                                                                    children: typeof v === 'number' ? v.toFixed(4) : String(v)
                                                                                })
                                                                            ]
                                                                        }, k) : null)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }, sig.id))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-3 border-t border-white/10 bg-surface/50 flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "text-[10px] text-muted italic",
                        children: [
                            "Showing latest ",
                            signals.length,
                            " evaluations"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-[10px] text-muted uppercase font-bold pr-1",
                                children: "Show"
                            }),
                            [
                                25,
                                50,
                                100
                            ].map((val)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setLimit(val),
                                    className: `w-7 h-7 rounded flex items-center justify-center text-[10px] font-bold border transition ${limit === val ? 'bg-neon/20 border-neon/40 text-neon' : 'bg-white/5 border-white/10 text-muted hover:text-white'}`,
                                    children: val
                                }, val))
                        ]
                    })
                ]
            })
        ]
    });
};
var $68b74abbcb17504f$export$2e2bcd8739ae039 = $68b74abbcb17504f$var$SignalLogPanel;



var $ayMG0 = parcelRequire("ayMG0");

var $kvv04 = parcelRequire("kvv04");

var $acw62 = parcelRequire("acw62");

var $02HYJ = parcelRequire("02HYJ");
var $bbkWX = parcelRequire("bbkWX");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $2db246ad160134fa$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Code", [
    [
        "polyline",
        {
            points: "16 18 22 12 16 6",
            key: "z7tu5w"
        }
    ],
    [
        "polyline",
        {
            points: "8 6 2 12 8 18",
            key: "1eg1df"
        }
    ]
]);


var $fkh1V = parcelRequire("fkh1V");
var $jmfXa = parcelRequire("jmfXa");
var $bTepa = parcelRequire("bTepa");
var $h4JTL = parcelRequire("h4JTL");
var $iPuRt = parcelRequire("iPuRt");
var $iIubC = parcelRequire("iIubC");

var $2wVnk = parcelRequire("2wVnk");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $017c9ffbbe41ea60$var$isConfigObject = (value)=>value !== null && typeof value === 'object' && !Array.isArray(value);
const $017c9ffbbe41ea60$var$StrategyConfigPreview = ({ config: config })=>{
    const symbols = Array.isArray(config.symbols) ? config.symbols : [];
    const hasSymbols = Boolean(config.symbols);
    const symbolConfig = $017c9ffbbe41ea60$var$isConfigObject(config.symbol_config) ? config.symbol_config : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "ux-scrollbar h-full overflow-y-auto pr-3 space-y-5",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-5 rounded-2xl bg-white/5 border border-white/10",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w-1.5 h-1.5 rounded-full bg-blue-400"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "text-sm text-blue-400 uppercase font-black tracking-[0.2em]",
                                children: "Global Control Deck"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-3",
                        children: Object.entries(config).map(([key, value])=>{
                            if (key === 'symbol_config' || key === 'symbols' || typeof value === 'object') return null;
                            const isLeverage = key === 'leverage' || key === 'position_size';
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex justify-between items-center py-2 border-b border-white/5 last:border-0 group overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `text-sm font-bold tracking-tight break-all mr-4 ${isLeverage ? 'text-blue-300' : 'text-white/40 group-hover:text-white/60 transition-colors'}`,
                                        children: key
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex-shrink-0 flex items-center gap-2",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: `text-sm font-mono font-bold ${isLeverage ? 'text-neon px-2 py-0.5 bg-neon/10 rounded border border-neon/20' : 'text-white/80'}`,
                                            children: [
                                                typeof value === 'boolean' ? value ? 'ACTIVE' : 'INERT' : String(value),
                                                isLeverage ? 'x' : ''
                                            ]
                                        })
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            }),
            hasSymbols && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-5 rounded-2xl bg-white/5 border border-white/10",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 mb-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w-1.5 h-1.5 rounded-full bg-neon shadow-[0_0_8px_var(--neon)]"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "text-sm text-neon uppercase font-black tracking-[0.2em]",
                                children: "Authorized Tickertape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex flex-wrap gap-2.5",
                        children: symbols.map((symbol, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "px-4 py-1.5 bg-neon/5 text-neon text-xs font-black rounded-lg border border-neon/20 tracking-tighter",
                                children: String(symbol)
                            }, `${String(symbol)}-${index}`))
                    })
                ]
            }),
            Object.keys(symbolConfig).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-5 rounded-2xl bg-white/5 border border-white/10",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 mb-5",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w-1.5 h-1.5 rounded-full bg-amber-400"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "text-sm text-amber-400 uppercase font-black tracking-[0.2em]",
                                children: "Symbol Overrides"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "grid grid-cols-1 gap-4",
                        children: Object.entries(symbolConfig).map(([symbol, value])=>{
                            const overrides = $017c9ffbbe41ea60$var$isConfigObject(value) ? value : {};
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p-4 rounded-xl bg-black/30 border border-white/5 hover:border-white/10 transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center space-x-3 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-sm font-black text-white tracking-widest leading-none",
                                                children: symbol
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "h-[1px] flex-grow bg-white/10"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "grid grid-cols-2 gap-x-8 gap-y-1.5",
                                        children: Object.entries(overrides).map(([key, override])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex justify-between items-center text-xs overflow-hidden",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-white/30 font-bold uppercase tracking-[0.1em] break-all mr-4",
                                                        children: key
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "text-white/90 font-mono font-bold flex-shrink-0",
                                                        children: [
                                                            String(override),
                                                            key === 'leverage' ? 'x' : ''
                                                        ]
                                                    })
                                                ]
                                            }, key))
                                    })
                                ]
                            }, symbol);
                        })
                    })
                ]
            })
        ]
    });
};
var $017c9ffbbe41ea60$export$2e2bcd8739ae039 = $017c9ffbbe41ea60$var$StrategyConfigPreview;


const $2679bfccb5235935$var$isConfigObject = (value)=>value !== null && typeof value === 'object' && !Array.isArray(value);
const $2679bfccb5235935$var$normalizeBySchema = (current, schema)=>{
    if (Array.isArray(schema)) return Array.isArray(current) ? current : schema;
    if (!$2679bfccb5235935$var$isConfigObject(schema)) return current !== undefined ? current : schema;
    const result = {};
    Object.entries(schema).forEach(([key, schemaValue])=>{
        const currentValue = $2679bfccb5235935$var$isConfigObject(current) && Object.prototype.hasOwnProperty.call(current, key) ? current[key] : undefined;
        result[key] = $2679bfccb5235935$var$normalizeBySchema(currentValue, schemaValue);
    });
    return result;
};
const $2679bfccb5235935$var$normalizeSymbolConfig = (currentConfig, schemaConfig, symbols)=>{
    if (!$2679bfccb5235935$var$isConfigObject(schemaConfig)) return currentConfig || {};
    const schemaSymbols = Object.keys(schemaConfig);
    const template = schemaSymbols.length > 0 ? schemaConfig[schemaSymbols[0]] : {};
    const targetSymbols = symbols.length > 0 ? symbols.map(String) : schemaSymbols;
    const currentBySymbol = $2679bfccb5235935$var$isConfigObject(currentConfig) ? currentConfig : {};
    return targetSymbols.reduce((result, symbol)=>{
        const symbolSchema = schemaConfig[symbol] || template;
        result[symbol] = $2679bfccb5235935$var$normalizeBySchema(currentBySymbol[symbol], symbolSchema);
        return result;
    }, {});
};
const $2679bfccb5235935$var$normalizePositionSizes = (currentSizes, schemaSizes, symbols)=>{
    if (!$2679bfccb5235935$var$isConfigObject(schemaSizes)) return currentSizes || {};
    const targetSymbols = symbols.length > 0 ? symbols.map(String) : Object.keys(schemaSizes);
    const currentBySymbol = $2679bfccb5235935$var$isConfigObject(currentSizes) ? currentSizes : {};
    return targetSymbols.reduce((result, symbol)=>{
        if (Object.prototype.hasOwnProperty.call(currentBySymbol, symbol)) result[symbol] = currentBySymbol[symbol];
        else if (Object.prototype.hasOwnProperty.call(schemaSizes, symbol)) result[symbol] = schemaSizes[symbol];
        return result;
    }, {});
};
const $2679bfccb5235935$export$992e8ffd1033aa08 = (current, schema)=>{
    if (!$2679bfccb5235935$var$isConfigObject(schema)) return current;
    const normalized = $2679bfccb5235935$var$normalizeBySchema(current, schema);
    const symbols = Array.isArray(normalized.symbols) ? normalized.symbols : Array.isArray(schema.symbols) ? schema.symbols : [];
    const currentConfig = $2679bfccb5235935$var$isConfigObject(current) ? current : {};
    if (schema.symbol_config) normalized.symbol_config = $2679bfccb5235935$var$normalizeSymbolConfig(currentConfig.symbol_config, schema.symbol_config, symbols);
    if (schema.position_sizes) normalized.position_sizes = $2679bfccb5235935$var$normalizePositionSizes(currentConfig.position_sizes, schema.position_sizes, symbols);
    return normalized;
};


const $a8a9d9ff69f432e4$var$StrategyConfigPanel = ({ strategyName: strategyName, onConfigChange: onConfigChange, readOnly: readOnly = false, fullBleed: fullBleed = false })=>{
    const [configJson, setConfigJson] = (0, $acw62.useState)('');
    const [isEnabled, setIsEnabled] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [success, setSuccess] = (0, $acw62.useState)(null);
    const [isPreview, setIsPreview] = (0, $acw62.useState)(readOnly);
    const [showHistory, setShowHistory] = (0, $acw62.useState)(false);
    const [jsonError, setJsonError] = (0, $acw62.useState)(null);
    const [version, setVersion] = (0, $acw62.useState)(null);
    const [updatedAt, setUpdatedAt] = (0, $acw62.useState)(null);
    const [history, setHistory] = (0, $acw62.useState)([]);
    const [historyLoading, setHistoryLoading] = (0, $acw62.useState)(false);
    const [configSchema, setConfigSchema] = (0, $acw62.useState)(null);
    const validateJson = (0, $acw62.useCallback)((val)=>{
        try {
            JSON.parse(val);
            setJsonError(null);
            return true;
        } catch (validationError) {
            setJsonError(validationError instanceof Error ? validationError.message : 'Invalid JSON');
            return false;
        }
    }, []);
    const fetchHistory = (0, $acw62.useCallback)(async ()=>{
        setHistoryLoading(true);
        try {
            const res = await (0, $2wVnk.tradingApi).getStrategyDbConfigHistory(strategyName);
            if (res.success) setHistory(res.data?.history || []);
        } catch (err) {
            console.error("Failed to fetch history:", err);
        } finally{
            setHistoryLoading(false);
        }
    }, [
        strategyName
    ]);
    const fetchConfig = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $2wVnk.tradingApi).getStrategyDbConfig(strategyName);
            if (response.success && response.data) {
                const config = response.data.config;
                setIsEnabled(config.enabled);
                setVersion(config.version || 1);
                setUpdatedAt(config.updated_at);
                setConfigSchema(config.config_schema || config.config_json || {});
                const jsonStr = JSON.stringify(config.config_json || {}, null, 2);
                setConfigJson(jsonStr);
                validateJson(jsonStr);
            } else throw new Error(response.message || 'Failed to fetch config');
        } catch (err) {
            console.warn(err);
            setError('Failed to load configuration. Strategy might not be initialized yet.');
        } finally{
            setLoading(false);
        }
    }, [
        strategyName,
        validateJson
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchConfig();
    }, [
        fetchConfig
    ]);
    (0, $acw62.useEffect)(()=>{
        if (readOnly) {
            setIsPreview(true);
            setShowHistory(false);
        }
    }, [
        readOnly
    ]);
    (0, $acw62.useEffect)(()=>{
        if (showHistory) fetchHistory();
    }, [
        showHistory,
        fetchHistory
    ]);
    const handleTextChange = (val)=>{
        setConfigJson(val);
        validateJson(val);
    };
    const handleFormat = ()=>{
        try {
            const parsed = JSON.parse(configJson);
            const formatted = JSON.stringify((0, $2679bfccb5235935$export$992e8ffd1033aa08)(parsed, configSchema), null, 2);
            setConfigJson(formatted);
            setJsonError(null);
        } catch  {
            setError('Cannot format invalid JSON');
        }
    };
    const handleSave = async ()=>{
        setSaving(true);
        setError(null);
        setSuccess(null);
        try {
            // Validate JSON
            let parsedConfig;
            try {
                parsedConfig = JSON.parse(configJson);
            } catch  {
                throw new Error('Invalid JSON format');
            }
            const res = await (0, $2wVnk.tradingApi).updateStrategyDbConfig(strategyName, {
                is_enabled: isEnabled,
                config_json: parsedConfig
            });
            const message = res?.message || res?.data?.message || 'Configuration saved successfully.';
            setSuccess(message);
            // Refresh Strategy Oversight immediately after hot reload so the
            // displayed values and pending rebalance state match the save.
            window.dispatchEvent(new CustomEvent('trading-data-refresh'));
            if (onConfigChange) onConfigChange();
        } catch (err) {
            console.warn(err);
            setError(err.message || 'Failed to save configuration');
        } finally{
            setSaving(false);
        }
    };
    const handleReset = async ()=>{
        if (!window.confirm(`Are you sure you want to reset ${strategyName} configuration to defaults? This will erase all custom settings.`)) return;
        setSaving(true);
        setError(null);
        setSuccess(null);
        try {
            const res = await (0, $2wVnk.tradingApi).resetStrategyDbConfig(strategyName);
            if (res.success) {
                setSuccess(res.message || 'Configuration reset to defaults.');
                await fetchConfig();
                window.dispatchEvent(new CustomEvent('trading-data-refresh'));
                if (onConfigChange) onConfigChange();
            } else throw new Error(res.error || res.message || 'Reset failed');
        } catch (err) {
            console.warn(err);
            setError(err.message || 'Failed to reset configuration');
        } finally{
            setSaving(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center justify-center p-12 bg-white/5 rounded-2xl border border-white/10",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                className: "w-6 h-6 text-neon animate-spin"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "ml-3 text-muted text-sm font-medium tracking-wide italic leading-none",
                children: "Retrieving telemetry..."
            })
        ]
    });
    const renderPreview = ()=>{
        try {
            const config = JSON.parse(configJson);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $017c9ffbbe41ea60$export$2e2bcd8739ae039), {
                config: config
            });
        } catch  {
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col items-center justify-center h-80 bg-error-500/5 rounded-xl border border-dashed border-error-500/20",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02HYJ.default), {
                        className: "w-8 h-8 text-error-500 mb-3 opacity-50"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-error-500 text-sm font-bold uppercase tracking-widest mb-2",
                        children: "Malformed JSON Buffer"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeButton), {
                        variant: "ghost",
                        size: "xs",
                        onClick: ()=>setIsPreview(false),
                        className: "uppercase",
                        children: "Return to Source Editor"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `panel fade-in ${fullBleed ? 'full-bleed-panel' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px-4 py-4 border-b border-white/10 flex items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2.5 min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "p-1.5 rounded-lg bg-neon/10 text-neon shadow-[0_0_10px_rgba(92,246,205,0.1)] flex-shrink-0",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIubC.default), {
                                    className: "w-4 h-4"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                        className: "text-sm font-bold text-white tracking-tight leading-tight truncate",
                                        children: [
                                            strategyName,
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-muted font-normal text-xs",
                                                children: "Config"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-[9px] text-muted uppercase font-black tracking-[0.15em] mt-0.5 truncate",
                                        children: "Parameters & Overrides"
                                    })
                                ]
                            })
                        ]
                    }),
                    !readOnly && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex-shrink-0 flex items-center p-1 bg-white/5 border border-white/10 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setIsPreview(false),
                                title: "Edit JSON source",
                                className: `flex items-center justify-center w-7 h-7 rounded-md transition-all duration-200 ${!isPreview ? "bg-neon/10 text-neon shadow-[0_0_10px_rgba(45,212,191,0.1)]" : "text-muted hover:text-white hover:bg-white/5"}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2db246ad160134fa$export$2e2bcd8739ae039), {
                                    className: "w-3.5 h-3.5"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>{
                                    setIsPreview(false);
                                    setShowHistory(!showHistory);
                                },
                                title: "View history",
                                className: `flex items-center justify-center w-7 h-7 rounded-md transition-all duration-200 ${showHistory ? "bg-warning-500/10 text-warning-500 shadow-[0_0_10px_rgba(251,191,36,0.1)]" : "text-muted hover:text-white hover:bg-white/5"}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jmfXa.default), {
                                    className: "w-3.5 h-3.5"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>{
                                    setShowHistory(false);
                                    setIsPreview(true);
                                },
                                title: "Preview config",
                                className: `flex items-center justify-center w-7 h-7 rounded-md transition-all duration-200 ${isPreview && !showHistory ? "bg-neon/10 text-neon shadow-[0_0_10px_rgba(45,212,191,0.1)]" : "text-muted hover:text-white hover:bg-white/5"}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fkh1V.default), {
                                    className: "w-3.5 h-3.5"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "px-6 py-2 bg-white/5 border-b border-white/5 flex items-center justify-between",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "text-[10px] font-black uppercase tracking-widest text-white/40",
                            children: [
                                "Version ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-neon",
                                    children: version
                                })
                            ]
                        }),
                        updatedAt && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "text-[10px] font-black uppercase tracking-widest text-white/40",
                            children: [
                                "Last Modified ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-white/60",
                                    children: new Date(updatedAt).toLocaleString()
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-6",
                children: !isPreview && !showHistory ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between items-end mb-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center space-x-2 px-1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `w-1.5 h-1.5 rounded-full ${jsonError ? 'bg-error-500 animate-pulse' : 'bg-neon shadow-[0_0_5px_var(--neon)]'}`
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `text-[10px] font-black uppercase tracking-widest ${jsonError ? 'text-error-500' : 'text-neon opacity-80'}`,
                                            children: jsonError ? 'Integrity Check Failed' : 'JSON Standard Compliant'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeButton), {
                                    variant: "secondary",
                                    size: "xs",
                                    onClick: handleFormat,
                                    className: "uppercase tracking-tighter",
                                    children: "Re-format Source"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "relative group",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: configJson,
                                    onChange: (e)=>handleTextChange(e.target.value),
                                    className: `ux-scrollbar w-full h-80 bg-black/40 text-info-500/90 font-mono text-xs p-5 rounded-xl border transition-all duration-300 focus:outline-none ${jsonError ? 'border-error-500/30 focus:border-error-500/50' : 'border-white/5 focus:border-neon/30 focus:bg-black/60 shadow-inner'}`,
                                    spellCheck: false
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "absolute inset-0 rounded-xl pointer-events-none border border-white/5 group-hover:border-white/10 transition-colors"
                                })
                            ]
                        }),
                        jsonError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "text-[10px] text-error-500/80 font-mono bg-error-500/5 p-3 rounded-lg border border-error-500/10 fade-in",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-error-500 font-bold",
                                    children: "ERROR:"
                                }),
                                " ",
                                jsonError
                            ]
                        })
                    ]
                }) : showHistory ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fade-in h-80 overflow-y-auto ux-scrollbar bg-black/20 rounded-xl border border-white/5 p-4 space-y-3",
                    children: historyLoading && history.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col items-center justify-center h-full space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                                className: "w-5 h-5 text-neon animate-spin opacity-50"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-[10px] text-muted uppercase font-black tracking-widest",
                                children: "Retrieving Timeline..."
                            })
                        ]
                    }) : history.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col items-center justify-center h-full space-y-4 opacity-40",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jmfXa.default), {
                                className: "w-8 h-8 text-muted"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-[10px] text-muted uppercase font-black tracking-widest",
                                children: "No previous iterations found"
                            })
                        ]
                    }) : history.map((entry, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p-4 rounded-xl bg-white/5 border border-white/5 hover:border-white/10 transition-all group",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex justify-between items-start mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "text-[10px] font-black text-warning-500 uppercase tracking-widest block mb-1",
                                                    children: [
                                                        "Iteration ",
                                                        entry.version
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "text-[9px] text-muted font-bold uppercase tracking-tighter italic",
                                                    children: entry.created_at ? new Date(entry.created_at).toLocaleString() : 'Timestamp unavailable'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeButton), {
                                            variant: "ghost",
                                            size: "xs",
                                            onClick: ()=>{
                                                setConfigJson(JSON.stringify(entry.config_json, null, 2));
                                                setShowHistory(false);
                                                setSuccess(`Version ${entry.version} restored to editor. Commit to apply.`);
                                            },
                                            className: "uppercase tracking-widest opacity-0 group-hover:opacity-100",
                                            children: "Restore"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "h-24 overflow-hidden relative rounded-lg border border-white/5 bg-black/20 p-2 cursor-pointer",
                                    onClick: ()=>{
                                        setConfigJson(JSON.stringify(entry.config_json, null, 2));
                                        setShowHistory(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                            className: "text-[9px] font-mono text-white/30 truncate",
                                            children: JSON.stringify(entry.config_json, null, 2)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"
                                        })
                                    ]
                                })
                            ]
                        }, idx))
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fade-in h-80 overflow-hidden",
                    children: renderPreview()
                })
            }),
            (error || success) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px-6 pb-2",
                children: [
                    error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-4 text-error-500 text-xs font-bold bg-error-500/10 p-4 rounded-xl border border-error-500/20 flex items-center gap-3 fade-in",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02HYJ.default), {
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: error
                            })
                        ]
                    }),
                    success && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-4 text-neon text-xs font-bold bg-neon/5 p-4 rounded-xl border border-neon/20 flex items-center gap-3 fade-in",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbkWX.default), {
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: success
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "px-6 py-5 bg-white/[0.02] border-t border-white/10 flex flex-wrap justify-between items-center gap-4",
                children: readOnly ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kvv04.ThemeButton), {
                    variant: "ghost",
                    size: "sm",
                    onClick: fetchConfig,
                    className: "flex items-center gap-2 uppercase tracking-widest",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                            className: `w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`
                        }),
                        "Sync"
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kvv04.ThemeButton), {
                            variant: "danger",
                            size: "sm",
                            onClick: handleReset,
                            className: "flex items-center gap-2 uppercase tracking-widest",
                            disabled: saving,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h4JTL.default), {
                                    className: "w-3.5 h-3.5"
                                }),
                                "Factory Reset"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kvv04.ThemeButton), {
                                    variant: "ghost",
                                    size: "sm",
                                    onClick: fetchConfig,
                                    className: "flex items-center gap-2 uppercase tracking-widest",
                                    disabled: saving,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                                            className: `w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`
                                        }),
                                        "Sync"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: handleSave,
                                    disabled: saving || !!jsonError,
                                    className: `flex items-center gap-2 px-8 py-2.5 text-black text-xs font-black uppercase tracking-widest rounded-xl transition-all duration-500 shadow-[0_0_20px_rgba(92,246,205,0.1)] active:scale-95 ${saving || !!jsonError ? 'bg-white/10 text-white/30 cursor-not-allowed border border-white/10' : 'bg-neon hover:shadow-[0_0_30px_rgba(42,212,191,0.3)] hover:brightness-110'}`,
                                    children: [
                                        saving ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                                            className: "w-4 h-4 animate-spin text-black"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iPuRt.default), {
                                            className: "w-4 h-4"
                                        }),
                                        saving ? 'Transmitting' : 'Commit Config'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $a8a9d9ff69f432e4$export$2e2bcd8739ae039 = $a8a9d9ff69f432e4$var$StrategyConfigPanel;



var $ayMG0 = parcelRequire("ayMG0");

var $kvv04 = parcelRequire("kvv04");

var $acw62 = parcelRequire("acw62");

var $4Yp7M = parcelRequire("4Yp7M");

var $2wVnk = parcelRequire("2wVnk");

var $8Zl6K = parcelRequire("8Zl6K");

var $iqWry = parcelRequire("iqWry");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $660412148adf18c8$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CalendarX", [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "m14 14-4 4",
            key: "rymu2i"
        }
    ],
    [
        "path",
        {
            d: "m10 14 4 4",
            key: "3sz06r"
        }
    ]
]);


var $6Plhc = parcelRequire("6Plhc");
var $fkh1V = parcelRequire("fkh1V");
var $4Yp7M = parcelRequire("4Yp7M");
var $gsAgU = parcelRequire("gsAgU");
var $dkOIy = parcelRequire("dkOIy");
var $jv5sm = parcelRequire("jv5sm");

var $k8QNV = parcelRequire("k8QNV");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bbkWX = parcelRequire("bbkWX");
var $hPAJY = parcelRequire("hPAJY");
const $88f734cc7ae55940$export$688c2074ab98e60 = (signal)=>{
    if (signal == null) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold bg-white/10 text-white/60 border border-white/10",
        children: "PENDING"
    });
    if (typeof signal === 'boolean') return signal ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-500/20 text-emerald-400 border border-emerald-500/30",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbkWX.default), {
                size: 10,
                strokeWidth: 3
            }),
            " PASS"
        ]
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold bg-rose-500/20 text-rose-400 border border-rose-500/30",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                size: 10,
                strokeWidth: 3
            }),
            " FAIL"
        ]
    });
    const labels = {
        BUY: "BUY",
        SELL: "SELL",
        HOLD: "HOLD",
        SKIP: "SKIP",
        ERROR: "ERROR"
    };
    const variants = {
        BUY: "bg-emerald-500/50 text-emerald-100",
        SELL: "bg-rose-500/15 text-rose-100",
        HOLD: "bg-white/10 text-white/90",
        SKIP: "bg-white/10 text-white/90",
        ERROR: "bg-rose-500/20 text-rose-100"
    };
    const signalStr = String(signal).toUpperCase();
    const variantClass = variants[signalStr] || "bg-white/10 text-white/90";
    const label = labels[signalStr] || signalStr;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: `px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${variantClass}`,
        children: label
    });
};
const $88f734cc7ae55940$export$615c2a87f9eca3f3 = (signal)=>{
    const labels = {
        BUY: "BUY",
        SELL: "SELL",
        HOLD: "HOLD",
        BUY_PENDING: "BUY ",
        NO_POSITION: "NO POSITION"
    };
    const variants = {
        BUY: "bg-emerald-500/20 text-emerald-400 border border-emerald-500/30 ",
        SELL: "bg-rose-500/20 text-rose-400 border border-rose-500/30",
        HOLD: "bg-white/10 text-white/90",
        BUY_PENDING: "bg-emerald-500/20 text-emerald-400 border border-emerald-500/30",
        NO_POSITION: "bg-white/10 text-white/90"
    };
    const signalStr = signal || "N/A";
    const variantClass = variants[signalStr] || "bg-white/10 text-white/90";
    const label = labels[signalStr] || signalStr;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: `inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold border border-emerald-500/30 ${variantClass}`,
        children: label
    });
};
const $88f734cc7ae55940$export$ea4a31c1561d9e94 = (side)=>{
    const labels = {
        BUY: 'BUY',
        SELL: 'SELL',
        LONG: 'LONG',
        SHORT: 'SHORT'
    };
    const variants = {
        BUY: 'bg-emerald-500/10 text-emerald-200 border border-emerald-400/30',
        SELL: 'bg-red-500/10 text-red-200 border border-red-400/30',
        LONG: 'bg-emerald-500/10 text-emerald-200 border border-emerald-400/30',
        SHORT: 'bg-red-500/10 text-red-200 border border-red-400/30'
    };
    const variantClass = variants[side?.toUpperCase()] || 'border border-line text-white/90 bg-surface';
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: `inline-flex items-center px-2.5 py-0.5 text-[10px] font-semibold tracking-wide uppercase ${variantClass}`,
        children: labels[side?.toUpperCase()] || side
    });
};



var $1rBba = parcelRequire("1rBba");

var $9qjJe = parcelRequire("9qjJe");


var $35Xbi = parcelRequire("35Xbi");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $77e7m = parcelRequire("77e7m");
const $a93dfe2b9d7772af$var$money = (value)=>{
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0 ? `$${numeric.toFixed(2)}` : "\u2014";
};
const $a93dfe2b9d7772af$var$LiveStrategyPrice = ({ symbol: symbol, evaluatedPrice: evaluatedPrice, evaluatedQuote: evaluatedQuote, initialLiveQuote: initialLiveQuote, decisionPrice: decisionPrice, decisionSource: decisionSource, decisionLabel: decisionLabel, executionPrice: executionPrice, executionQuote: executionQuote, executionLabel: executionLabel, streamedQuoteOverride: streamedQuoteOverride, priceClassName: priceClassName = "text-white" })=>{
    const connectionStatus = (0, $ee10d9a55e84bc57$export$2341ff61511dbf4b)();
    const streamedQuoteFromStore = (0, $ee10d9a55e84bc57$export$79ae38ef14e32131)(streamedQuoteOverride === undefined ? (0, $77e7m.quoteSubscriptionIdentifier)(symbol, evaluatedQuote) : null);
    const streamedQuote = streamedQuoteOverride === undefined ? streamedQuoteFromStore : streamedQuoteOverride;
    const separateExecutionContract = Boolean(executionPrice != null && executionQuote?.contract_key && executionQuote.contract_key !== evaluatedQuote?.contract_key);
    const streamedExecutionQuote = (0, $ee10d9a55e84bc57$export$79ae38ef14e32131)(separateExecutionContract ? (0, $77e7m.quoteSubscriptionIdentifier)(executionQuote?.symbol || symbol, executionQuote) : null);
    const liveQuote = streamedQuote || initialLiveQuote;
    const livePrice = liveQuote?.price ?? evaluatedPrice;
    const hasDisplayedPrice = Number.isFinite(Number(livePrice)) && Number(livePrice) > 0;
    const displayedQuote = liveQuote || evaluatedQuote;
    const presentation = (0, $77e7m.getPricePresentation)({
        quote: displayedQuote,
        connectionStatus: connectionStatus,
        hasPrice: hasDisplayedPrice,
        streamed: Boolean(streamedQuote)
    });
    const executionPresentation = (0, $77e7m.getPricePresentation)({
        quote: streamedExecutionQuote || executionQuote,
        connectionStatus: connectionStatus,
        hasPrice: executionPrice != null,
        streamed: Boolean(streamedExecutionQuote)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col items-end gap-0.5 leading-tight",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `font-semibold ${priceClassName}`,
                        children: $a93dfe2b9d7772af$var$money(livePrice)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `rounded border px-1 py-0.5 text-[8px] font-bold uppercase tracking-wide ${presentation.badgeClassName}`,
                        children: presentation.status
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "text-[9px] text-white/45",
                title: evaluatedQuote?.received_at || evaluatedQuote?.exchange_time || undefined,
                children: [
                    "Engine ",
                    $a93dfe2b9d7772af$var$money(evaluatedPrice),
                    evaluatedQuote?.sequence != null ? ` \xb7 #${evaluatedQuote.sequence}` : ""
                ]
            }),
            decisionPrice != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "text-[9px] text-sky-300/70",
                title: decisionSource || undefined,
                children: [
                    decisionLabel || "Decision",
                    " ",
                    $a93dfe2b9d7772af$var$money(decisionPrice)
                ]
            }),
            executionPrice != null && separateExecutionContract && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "text-[9px] text-neon/80",
                children: [
                    executionLabel || "Exec",
                    " ",
                    $a93dfe2b9d7772af$var$money(streamedExecutionQuote?.price ?? executionPrice),
                    streamedExecutionQuote ? ` \xb7 ${executionPresentation.status.toLowerCase()}` : ""
                ]
            }),
            executionPrice != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "text-[9px] text-neon/70",
                title: executionQuote?.received_at || executionQuote?.exchange_time || undefined,
                children: [
                    separateExecutionContract ? "Sizing ref" : "Exec ref",
                    " ",
                    $a93dfe2b9d7772af$var$money(executionPrice),
                    executionQuote?.sequence != null ? ` \xb7 #${executionQuote.sequence}` : ""
                ]
            })
        ]
    });
};
var $a93dfe2b9d7772af$export$2e2bcd8739ae039 = $a93dfe2b9d7772af$var$LiveStrategyPrice;


const $8edc0845c31b7212$var$ONStrategyContent = ({ onStatus: onStatus, handleStrategyToggle: handleStrategyToggle, strategyToggleLoading: strategyToggleLoading })=>{
    const [showRules, setShowRules] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [expandedSymbol, setExpandedSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [showConfigModal, setShowConfigModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    if (!onStatus) return null;
    const hasData = !!onStatus.data;
    const onData = onStatus.data;
    const latestOnTimestamp = onData && onData.timestamp ? (0, $k8QNV.formatDateTimeET)(onData.timestamp) : null;
    const onEnabled = hasData ? onStatus.data?.enabled : false;
    const toggleState = strategyToggleLoading.ON;
    const onPositions = onData?.positions || {};
    const onPositionEntries = Object.entries(onPositions).filter(([, qty])=>typeof qty === "number" && qty !== 0);
    const onPositionMeta = onData?.position || {};
    const symbolStatus = onData?.symbol_status || {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-muted",
                                children: "Strategy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-semibold text-foreground",
                                children: "ON"
                            }),
                            onData?.version && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "px-1.5 py-0.5 rounded-md bg-white/5 border border-white/10 text-[10px] text-muted font-mono",
                                title: "Strategy Logic Version",
                                children: [
                                    "v",
                                    onData.version
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>handleStrategyToggle("ON", onEnabled),
                        disabled: !!toggleState,
                        "aria-busy": !!toggleState,
                        className: `min-w-[104px] justify-center px-3 py-1.5 rounded-lg font-semibold uppercase flex text-sm items-center gap-1 transition disabled:cursor-wait disabled:opacity-80 ${toggleState ? "bg-amber-400/10 text-amber-300 border border-amber-400/20" : onEnabled ? "bg-neon-soft text-neon" : "text-muted hover:text-foreground hover:bg-white/10"}`,
                        children: [
                            toggleState ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                size: 14,
                                className: "animate-spin"
                            }) : onEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gsAgU.default), {
                                size: 14
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dkOIy.default), {
                                size: 14
                            }),
                            toggleState === "starting" ? "Starting" : toggleState === "pausing" ? "Pausing" : onEnabled ? "Pause" : "Start"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-foreground",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>setShowRules(!showRules),
                        className: "flex items-center gap-2 mb-4 px-4 py-2 rounded-xl bg-white/5 border border-white/10 text-[11px] font-black uppercase tracking-[0.2em] text-muted hover:text-white hover:bg-white/10 transition-all shadow-inner group",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `p-1 rounded-md transition-all ${showRules ? 'bg-neon/20 text-neon' : 'bg-white/10 text-white/40 group-hover:text-white'}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jv5sm.default), {
                                    size: 14,
                                    className: showRules ? 'animate-pulse' : ''
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    showRules ? 'Hide' : 'Show',
                                    " Strategy Conditions & Rules"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `ml-auto transition-transform duration-300 ${showRules ? 'rotate-180 text-neon' : ''}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "m6 9 6 6 6-6"
                                    })
                                })
                            })
                        ]
                    }),
                    showRules && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2 mb-6 animate-in fade-in slide-in-from-top-2 duration-300",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-neon/10 text-neon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jv5sm.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Entry Conditions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Price must be above ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "SMA30"
                                                            }),
                                                            " and ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "SMA200"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Entry window: ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "15:55 - 16:00 ET"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-amber-500/10 text-amber-400",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $660412148adf18c8$export$2e2bcd8739ae039), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Market Closure Rules"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-amber-400/90",
                                                                children: "No Entry"
                                                            }),
                                                            " if tomorrow is a ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Weekend"
                                                            }),
                                                            " or ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Holiday"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Positions are liquidated at ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "09:30 ET"
                                                            }),
                                                            " next trading day"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-4 rounded-2xl bg-white/6 text-sm text-foreground",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-col gap-3 mb-3 sm:flex-row sm:items-center sm:justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-3 min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "text-sm font-semibold text-neon",
                                                children: "Signal Analysis"
                                            }),
                                            onData?.config_source && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setShowConfigModal(true),
                                                className: `inline-flex min-h-7 shrink-0 items-center gap-1.5 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors ${onData.config_source === 'USER' ? 'bg-neon/10 text-neon border border-neon/20' : 'bg-white/5 text-muted border border-white/10'} hover:bg-white/10 hover:text-white`,
                                                title: "View current ON strategy setup",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fkh1V.default), {
                                                        className: "h-3.5 w-3.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "whitespace-nowrap",
                                                        children: onData.config_source === 'USER' ? 'User Config' : 'System Default'
                                                    }),
                                                    onData.config_version && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "whitespace-nowrap",
                                                        children: [
                                                            "v",
                                                            onData.config_version
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    latestOnTimestamp && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "px-3 py-1.5 rounded-xl bg-white/5 border border-white/10 flex flex-wrap items-center gap-2 self-start sm:self-auto",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-[10px] text-muted uppercase font-bold tracking-wider",
                                                children: "Latest Data"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-[11px] text-white font-semibold",
                                                children: latestOnTimestamp
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "overflow-x-auto scrollbar-thin rounded-xl border border-white/5 bg-surface",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    className: "min-w-full divide-y divide-white/10 text-[13px] text-foreground",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            className: "bg-black/60",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Symbol"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Signal"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Technical"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Trading Day"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Price"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                        children: "SMAs (S/L)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Size"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Lev"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Reason"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            className: "divide-y divide-white/5",
                                            children: Object.keys(symbolStatus).length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    colSpan: 9,
                                                    className: "px-3 py-4 text-center text-muted",
                                                    children: [
                                                        hasData ? "Market closed or no scan data available" : "Strategy offline",
                                                        onStatus.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "text-rose-400 mt-1",
                                                            children: onStatus.error
                                                        })
                                                    ]
                                                })
                                            }) : Object.keys(symbolStatus).map((symbol)=>{
                                                const data = symbolStatus[symbol];
                                                const isExpanded = expandedSymbol === symbol;
                                                const currentPrice = Number(data?.current_price);
                                                const smaShort = Number(data?.sma_short);
                                                const smaLong = Number(data?.sma_long);
                                                const isSignalLevel = (0, $35Xbi.hasFreshLevels)(data, onData?.levels_date || onData?.timestamp) && (0, $35Xbi.isValidPriceLevel)(currentPrice) && (0, $35Xbi.isValidPriceLevel)(smaShort) && (0, $35Xbi.isValidPriceLevel)(smaLong) && currentPrice > smaShort && currentPrice > smaLong;
                                                if (!data || Object.keys(data).length === 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    className: "hover:bg-white/5 transition-colors",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-3 py-2 font-medium text-foreground",
                                                            children: symbol
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            colSpan: 8,
                                                            className: "px-3 py-2 text-muted italic",
                                                            children: "No data available"
                                                        })
                                                    ]
                                                }, symbol);
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            className: `transition-colors cursor-pointer ${isSignalLevel ? "bg-emerald-500/15 hover:bg-emerald-500/20 ring-1 ring-inset ring-emerald-400/20" : "hover:bg-white/5"}`,
                                                            onClick: ()=>setExpandedSymbol(isExpanded ? null : symbol),
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-4 py-3 font-bold text-[14px] text-white",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "flex items-center gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Plhc.default), {
                                                                                className: `w-3.5 h-3.5 text-muted transition-transform ${isExpanded ? "rotate-180 text-neon" : ""}`
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "flex flex-col",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        children: symbol
                                                                                    }),
                                                                                    data.execution_sec_type === 'FUT' && data.execution_display_symbol && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        className: "flex items-center gap-1 text-[10px] text-neon/80 font-mono font-bold uppercase tracking-wider",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                children: data.execution_display_symbol
                                                                                            }),
                                                                                            data.execution_price_delayed && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "rounded border border-amber-400/20 bg-amber-400/10 px-1 text-[9px] text-amber-300",
                                                                                                children: "Delayed"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-3 py-2",
                                                                    children: (0, $88f734cc7ae55940$export$615c2a87f9eca3f3)(data.informative_signal)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-3 py-2",
                                                                    children: (0, $88f734cc7ae55940$export$688c2074ab98e60)(data.technical_signal)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-3 py-2",
                                                                    children: (0, $88f734cc7ae55940$export$688c2074ab98e60)(data.next_day_is_trading)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-4 py-3 text-right font-mono",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93dfe2b9d7772af$export$2e2bcd8739ae039), {
                                                                        symbol: symbol,
                                                                        evaluatedPrice: data.current_price,
                                                                        evaluatedQuote: data.evaluated_quote,
                                                                        initialLiveQuote: data.live_quote,
                                                                        executionPrice: data.execution_price,
                                                                        executionQuote: data.execution_quote,
                                                                        executionLabel: data.execution_display_symbol
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-4 py-3 text-right font-mono text-white/80",
                                                                    children: data.sma_short && data.sma_long ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "text-emerald-400",
                                                                                children: [
                                                                                    "$",
                                                                                    Number(data.sma_short).toFixed(2)
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "mx-1",
                                                                                children: "/"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "text-amber-400",
                                                                                children: [
                                                                                    "$",
                                                                                    Number(data.sma_long).toFixed(2)
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }) : "N/A"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                    className: "px-4 py-3 text-right font-mono text-white/80",
                                                                    children: [
                                                                        data.calculated_size ?? "\u2014",
                                                                        data.execution_sec_type === 'FUT' && data.calculated_size !== undefined && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "ml-1 text-[10px] text-white/40",
                                                                            children: "ct"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-4 py-3 text-right font-mono text-white/80",
                                                                    children: data.leverage ? `${(data.leverage * 100).toFixed(0)}%` : "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "px-4 py-3 text-white/70 max-w-[200px] truncate",
                                                                    title: data.reason,
                                                                    children: data.reason
                                                                })
                                                            ]
                                                        }),
                                                        isExpanded && /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                colSpan: 9,
                                                                className: "p-0 bg-black/20",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1rBba.default), {
                                                                    symbol: symbol,
                                                                    timeframe: "1d",
                                                                    label: "ON",
                                                                    strategy: "ON",
                                                                    status: {
                                                                        ...data,
                                                                        levels_date: data.levels_date || onData?.levels_date || onData?.timestamp
                                                                    }
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, symbol);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    onPositionEntries.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-3 rounded-2xl bg-white/6 text-sm text-foreground",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "text-sm font-semibold text-neon",
                                        children: "Current Position"
                                    }),
                                    latestOnTimestamp && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "text-[11px] text-muted",
                                        children: [
                                            "Latest Data: ",
                                            latestOnTimestamp
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "overflow-x-auto scrollbar-thin rounded-xl border border-white/5 bg-surface",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    className: "min-w-full divide-y divide-white/10 text-[13px] text-foreground",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            className: "bg-black/60",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Symbol"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Quantity"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Entry Price"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        scope: "col",
                                                        className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                        children: "Entry Time"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            className: "divide-y divide-white/5",
                                            children: onPositionEntries.map(([sym, qty])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    className: "hover:bg-white/5 transition-colors",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-4 py-3 whitespace-nowrap font-bold text-[14px] text-white",
                                                            children: sym
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-4 py-3 whitespace-nowrap font-medium",
                                                            children: qty
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-4 py-3 whitespace-nowrap",
                                                            children: onPositionMeta?.entry_price ? `$${Number(onPositionMeta.entry_price).toFixed(2)}` : "N/A"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-4 py-3 whitespace-nowrap text-white/70",
                                                            children: onPositionMeta?.entry_time ? (0, $k8QNV.formatDateTimeET)(onPositionMeta.entry_time) : "N/A"
                                                        })
                                                    ]
                                                }, sym))
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9qjJe.default), {
                isOpen: showConfigModal,
                onClose: ()=>setShowConfigModal(false),
                title: "ON Strategy Setup",
                width: "max-w-4xl",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8a9d9ff69f432e4$export$2e2bcd8739ae039), {
                    strategyName: "ON",
                    readOnly: true
                })
            })
        ]
    });
};
var $8edc0845c31b7212$export$2e2bcd8739ae039 = $8edc0845c31b7212$var$ONStrategyContent;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7dAee = parcelRequire("7dAee");
var $6Plhc = parcelRequire("6Plhc");
var $fkh1V = parcelRequire("fkh1V");
var $4Yp7M = parcelRequire("4Yp7M");
var $gsAgU = parcelRequire("gsAgU");
var $dkOIy = parcelRequire("dkOIy");
var $jv5sm = parcelRequire("jv5sm");

var $k8QNV = parcelRequire("k8QNV");

var $1rBba = parcelRequire("1rBba");

var $9qjJe = parcelRequire("9qjJe");


var $35Xbi = parcelRequire("35Xbi");


const $043e45dd87bbf767$var$ORBSymbolRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ symbol: symbol, status: status, levelsDateIso: levelsDateIso, marketOpen: marketOpen, expanded: expanded, onToggle: onToggle })=>{
    const quoteIdentifier = status?.evaluated_quote?.local_symbol || symbol;
    const streamedQuote = (0, $ee10d9a55e84bc57$export$79ae38ef14e32131)(quoteIdentifier);
    const livePrice = Number(streamedQuote?.price ?? status?.live_quote?.price ?? status?.current_price);
    const decisionPrice = Number(status.decision_price);
    const signalPrice = Number.isFinite(decisionPrice) && decisionPrice > 0 ? decisionPrice : Number(status.current_price);
    const resistance = Number(status.resistance);
    const support = Number(status.support);
    const hasCurrentLevels = (0, $35Xbi.hasFreshLevels)(status, levelsDateIso) && (0, $35Xbi.isCurrentNySessionDate)(status, levelsDateIso) && (0, $35Xbi.isValidPriceLevel)(resistance) && (0, $35Xbi.isValidPriceLevel)(support);
    const levelTone = (0, $35Xbi.getAdaptiveLevelTone)({
        price: (0, $35Xbi.isValidPriceLevel)(livePrice) ? livePrice : signalPrice,
        lowerLevel: support,
        upperLevel: resistance,
        levelsReady: hasCurrentLevels,
        earlySession: (0, $35Xbi.isEarlyRegularSession)(),
        marketOpen: marketOpen
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                className: "cursor-pointer transition-colors hover:bg-white/5",
                style: levelTone.rowStyle,
                title: levelTone.label,
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 font-bold text-[14px] text-white",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Plhc.default), {
                                    className: `w-3.5 h-3.5 text-muted transition-transform ${expanded ? "rotate-180 text-neon" : ""}`
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: symbol
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `block text-[10px] font-medium ${levelTone.priceClass}`,
                                            children: levelTone.label
                                        }),
                                        status.execution_sec_type === "FUT" && status.execution_display_symbol && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "block text-[10px] font-mono font-normal text-amber-300/80",
                                            children: [
                                                "\u2192 ",
                                                status.execution_display_symbol
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `px-4 py-3 text-right font-mono ${levelTone.priceClass}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93dfe2b9d7772af$export$2e2bcd8739ae039), {
                            symbol: symbol,
                            evaluatedPrice: status.current_price,
                            evaluatedQuote: status.evaluated_quote,
                            initialLiveQuote: status.live_quote,
                            decisionPrice: status.decision_price,
                            decisionSource: status.decision_price_source,
                            decisionLabel: "5m decision",
                            streamedQuoteOverride: streamedQuote,
                            priceClassName: levelTone.priceClass
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.daily_open ? `$${Number(status.daily_open).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.atr_value ? `$${Number(status.atr_value).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `px-4 py-3 text-right font-mono ${levelTone.lowerClass}`,
                        children: status.support ? `$${Number(status.support).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `px-4 py-3 text-right font-mono ${levelTone.upperClass}`,
                        children: status.resistance ? `$${Number(status.resistance).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.current_vwap ? `$${Number(status.current_vwap).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                        className: "px-4 py-3 text-right font-mono text-white/80",
                        children: [
                            status.calculated_size ? status.calculated_size : "\u2014",
                            status.execution_sec_type === 'FUT' && status.calculated_size !== undefined && status.calculated_size !== null && status.calculated_size !== 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ml-1 text-[10px] text-white/40",
                                children: "ct"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono text-white/80",
                        children: status.current_leverage ? `${status.current_leverage}x` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-medium",
                        children: status.position ? typeof status.position === 'number' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                status.position,
                                status.execution_sec_type === 'FUT' && status.position !== 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "ml-1 text-[10px] text-white/40",
                                    children: "ct"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                status.position.shares || 0,
                                status.execution_sec_type === 'FUT' && (status.position.shares || 0) !== 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "ml-1 text-[10px] text-white/40",
                                    children: "ct"
                                })
                            ]
                        }) : "\u2014"
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                    colSpan: 10,
                    className: "p-0 bg-black/20",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1rBba.default), {
                        symbol: symbol,
                        timeframe: "5min",
                        label: "ORB",
                        strategy: "ORB",
                        status: {
                            ...status,
                            levels_date: status.levels_date || levelsDateIso
                        }
                    })
                })
            })
        ]
    });
});
const $043e45dd87bbf767$var$ORBStrategyContent = ({ orbStatusState: orbStatusState, handleStrategyToggle: handleStrategyToggle, strategyToggleLoading: strategyToggleLoading })=>{
    const [showRules, setShowRules] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [expandedSymbol, setExpandedSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [showConfigModal, setShowConfigModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [marketOpen, setMarketOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $35Xbi.isRegularMarketOpen)());
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const updateMarketState = ()=>setMarketOpen((0, $35Xbi.isRegularMarketOpen)());
        const interval = window.setInterval(updateMarketState, 30000);
        return ()=>window.clearInterval(interval);
    }, []);
    if (!orbStatusState) return null;
    const orbData = orbStatusState.data || {};
    const orbEnabled = orbData.enabled ?? false;
    const toggleState = strategyToggleLoading.ORB;
    const levelsDateIso = orbData?.levels_date;
    const levelsDate = levelsDateIso && !Number.isNaN(Date.parse(levelsDateIso)) ? (0, $k8QNV.formatDateTimeET)(levelsDateIso) : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-muted",
                                children: "Strategy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-semibold text-foreground",
                                children: "ORB"
                            }),
                            orbData?.version && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "px-1.5 py-0.5 rounded-md bg-white/5 border border-white/10 text-[10px] text-muted font-mono",
                                title: "Strategy Logic Version",
                                children: [
                                    "v",
                                    orbData.version
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>handleStrategyToggle("ORB", orbEnabled),
                        disabled: !!toggleState,
                        "aria-busy": !!toggleState,
                        className: `min-w-[104px] justify-center px-3 py-1.5 rounded-lg font-semibold uppercase flex text-sm items-center gap-1 transition disabled:cursor-wait disabled:opacity-80 ${toggleState ? "bg-amber-400/10 text-amber-300 border border-amber-400/20" : orbEnabled ? "bg-neon-soft text-neon" : "text-muted hover:text-foreground hover:bg-white/10"}`,
                        children: [
                            toggleState ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                size: 14,
                                className: "animate-spin"
                            }) : orbEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gsAgU.default), {
                                size: 14
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dkOIy.default), {
                                size: 14
                            }),
                            toggleState === "starting" ? "Starting" : toggleState === "pausing" ? "Pausing" : orbEnabled ? "Pause" : "Start"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-foreground",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>setShowRules(!showRules),
                        className: "flex items-center gap-2 mb-4 px-4 py-2 rounded-xl bg-white/5 border border-white/10 text-[11px] font-black uppercase tracking-[0.2em] text-muted hover:text-white hover:bg-white/10 transition-all shadow-inner group",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `p-1 rounded-md transition-all ${showRules ? 'bg-neon/20 text-neon' : 'bg-white/10 text-white/40 group-hover:text-white'}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jv5sm.default), {
                                    size: 14,
                                    className: showRules ? 'animate-pulse' : ''
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    showRules ? 'Hide' : 'Show',
                                    " Strategy Conditions & Rules"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `ml-auto transition-transform duration-300 ${showRules ? 'rotate-180 text-neon' : ''}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "m6 9 6 6 6-6"
                                    })
                                })
                            })
                        ]
                    }),
                    showRules && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2 mb-6 animate-in fade-in slide-in-from-top-2 duration-300",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-neon/10 text-neon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jv5sm.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Entry Conditions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Price breakout of ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Opening Range"
                                                            }),
                                                            " (Open \xb1 ATR factor)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Entry window: ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "09:35 - 09:35:30 ET"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Confirmed by ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "5-minute bar"
                                                            }),
                                                            " close"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-amber-500/10 text-amber-400",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dAee.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Strategy Rules"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Positions liquidated at ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "15:30 ET"
                                                            }),
                                                            " (EOD)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "ATR-based ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Stop Loss"
                                                            }),
                                                            " set at entry"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Optional ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "VWAP Exit"
                                                            }),
                                                            " if enabled"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt-2 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-foreground",
                children: levelsDate && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rounded-xl bg-white/6 border border-white/10 px-3 py-2 flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-muted mr-2",
                            children: "Latest Data"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-foreground font-semibold",
                            children: levelsDate
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mt-4 rounded-2xl bg-white/6 text-sm text-foreground",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-sm font-semibold text-neon",
                                children: "Symbol Status"
                            }),
                            orbData.config_source && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex items-center gap-2",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>setShowConfigModal(true),
                                    className: `inline-flex min-h-7 shrink-0 items-center gap-1.5 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors ${orbData.config_source === 'USER' ? 'bg-neon/10 text-neon border border-neon/20' : 'bg-white/5 text-muted border border-white/10'} hover:bg-white/10 hover:text-white`,
                                    title: "View current ORB strategy setup",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fkh1V.default), {
                                            className: "h-3.5 w-3.5"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "whitespace-nowrap",
                                            children: orbData.config_source === 'USER' ? 'User Config' : 'System Default'
                                        }),
                                        orbData.config_version && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "whitespace-nowrap",
                                            children: [
                                                "v",
                                                orbData.config_version
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overflow-x-auto scrollbar-thin rounded-xl border border-white/5 bg-surface",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "min-w-full divide-y divide-white/10 text-[13px] text-foreground",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "bg-black/60",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                children: "Symbol"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Price"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Open"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "ATR"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "ORB Low"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "ORB High"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "VWAP"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Size"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Lev"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Position"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    className: "divide-y divide-white/5",
                                    children: orbData.symbol_status && Object.keys(orbData.symbol_status).length > 0 ? Object.entries(orbData.symbol_status).map(([symbol, status])=>/*#__PURE__*/ (0, $ayMG0.jsx)($043e45dd87bbf767$var$ORBSymbolRow, {
                                            symbol: symbol,
                                            status: status,
                                            levelsDateIso: levelsDateIso,
                                            marketOpen: marketOpen,
                                            expanded: expandedSymbol === symbol,
                                            onToggle: ()=>setExpandedSymbol((current)=>current === symbol ? null : symbol)
                                        }, symbol)) : /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            colSpan: 10,
                                            className: "px-3 py-4 text-center text-muted",
                                            children: orbEnabled ? "Waiting for market data..." : "Strategy offline"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9qjJe.default), {
                isOpen: showConfigModal,
                onClose: ()=>setShowConfigModal(false),
                title: "ORB Strategy Setup",
                width: "max-w-4xl",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8a9d9ff69f432e4$export$2e2bcd8739ae039), {
                    strategyName: "ORB",
                    readOnly: true
                })
            })
        ]
    });
};
var $043e45dd87bbf767$export$2e2bcd8739ae039 = $043e45dd87bbf767$var$ORBStrategyContent;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7dAee = parcelRequire("7dAee");
var $6Plhc = parcelRequire("6Plhc");
var $fkh1V = parcelRequire("fkh1V");
var $4Yp7M = parcelRequire("4Yp7M");
var $gsAgU = parcelRequire("gsAgU");
var $dkOIy = parcelRequire("dkOIy");
var $jv5sm = parcelRequire("jv5sm");

var $k8QNV = parcelRequire("k8QNV");

var $1rBba = parcelRequire("1rBba");

var $9qjJe = parcelRequire("9qjJe");


var $35Xbi = parcelRequire("35Xbi");


const $405b868a9af90f76$var$DTSymbolRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ symbol: symbol, status: status, levelsDateIso: levelsDateIso, expanded: expanded, onToggle: onToggle, chartWidth: chartWidth, marketOpen: marketOpen })=>{
    const quoteIdentifier = status?.evaluated_quote?.local_symbol || symbol;
    const streamedQuote = (0, $ee10d9a55e84bc57$export$79ae38ef14e32131)(quoteIdentifier);
    const liveStatusPrice = Number(streamedQuote?.price ?? status.live_quote?.price ?? status.current_price);
    const dailyOpen = Number(status.daily_open);
    const threshold = Number(status.intraday_threshold);
    const hasCurrentLevels = (0, $35Xbi.hasFreshLevels)(status, levelsDateIso) && (0, $35Xbi.isCurrentNySessionDate)(status, levelsDateIso) && (0, $35Xbi.isValidPriceLevel)(liveStatusPrice) && (0, $35Xbi.isValidPriceLevel)(dailyOpen) && Number.isFinite(threshold) && threshold > 0;
    const levelTone = (0, $35Xbi.getAdaptiveLevelTone)({
        price: liveStatusPrice,
        lowerLevel: dailyOpen - threshold,
        upperLevel: dailyOpen + threshold,
        levelsReady: hasCurrentLevels,
        earlySession: (0, $35Xbi.isEarlyRegularSession)(),
        marketOpen: marketOpen
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                className: "cursor-pointer transition-colors hover:bg-white/5",
                style: levelTone.rowStyle,
                title: levelTone.label,
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 font-bold text-[14px] text-white",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Plhc.default), {
                                    className: `w-3.5 h-3.5 text-muted transition-transform ${expanded ? "rotate-180 text-neon" : ""}`
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: symbol
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `block text-[10px] font-medium ${levelTone.priceClass}`,
                                            children: levelTone.label
                                        }),
                                        status.execution_sec_type === "FUT" && status.execution_display_symbol && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "block text-[10px] font-mono font-normal text-amber-300/80",
                                            children: [
                                                "\u2192 ",
                                                status.execution_display_symbol
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `px-4 py-3 text-right font-mono ${levelTone.priceClass}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93dfe2b9d7772af$export$2e2bcd8739ae039), {
                            symbol: symbol,
                            evaluatedPrice: status.current_price,
                            evaluatedQuote: status.evaluated_quote,
                            initialLiveQuote: status.live_quote,
                            decisionPrice: status.entry_type === "bar_close" ? status.decision_price : null,
                            decisionSource: status.decision_price_source,
                            decisionLabel: status.decision_label || (status.decision_price_source === "confirmed_5m_bar_close" ? "5m close" : "30m close"),
                            streamedQuoteOverride: streamedQuote,
                            priceClassName: levelTone.priceClass
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.daily_open ? `$${Number(status.daily_open).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.atr_value ? `$${Number(status.atr_value).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `px-4 py-3 text-right font-mono ${levelTone.upperClass}`,
                        children: status.daily_open && status.intraday_threshold ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: levelTone.upperClass,
                                    children: [
                                        "$",
                                        (Number(status.daily_open) + Number(status.intraday_threshold)).toFixed(2)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mx-1 text-muted",
                                    children: "/"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: levelTone.lowerClass,
                                    children: [
                                        "$",
                                        (Number(status.daily_open) - Number(status.intraday_threshold)).toFixed(2)
                                    ]
                                })
                            ]
                        }) : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono",
                        children: status.current_vwap ? `$${Number(status.current_vwap).toFixed(2)}` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-white/70",
                        children: status.threshold_window || "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-white/60 font-mono text-[12px]",
                        children: status.last_entry_time ? status.last_entry_time.slice(0, 5) : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-white/70 text-xs uppercase",
                        children: status.execution_mode || "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono text-white/80",
                        children: status.sl_atr_factor ? status.sl_atr_factor.toFixed(2) : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                        className: "px-4 py-3 text-right font-mono text-white/80",
                        children: [
                            status.calculated_size === 0 && Number(status.leverage) > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "inline-flex items-center gap-1 text-amber-400 font-semibold",
                                title: "Position size is 0 (Equity too low for 1 share with current leverage)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dAee.default), {
                                        size: 12,
                                        className: "inline text-amber-400 shrink-0"
                                    }),
                                    "0"
                                ]
                            }) : status.calculated_size ?? "\u2014",
                            status.execution_sec_type === 'FUT' && status.calculated_size !== undefined && status.calculated_size !== null && status.calculated_size !== 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ml-1 text-[10px] text-white/40",
                                children: "ct"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-mono text-white/80",
                        children: status.leverage ? `${status.leverage}x` : "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-medium",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: (status.trades_today || 0) >= (status.max_trades || 1) ? "text-rose-400" : "text-muted",
                            children: [
                                status.trades_today || 0,
                                "/",
                                status.max_trades || 1
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "px-4 py-3 text-right font-medium",
                        children: status.position?.shares !== 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                status.position?.shares,
                                status.execution_sec_type === 'FUT' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "ml-1 text-[10px] text-white/40",
                                    children: "ct"
                                })
                            ]
                        }) : "\u2014"
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                    colSpan: 14,
                    className: "p-0 bg-black/20",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "sticky left-0 box-border min-w-0 overflow-hidden",
                        style: chartWidth ? {
                            width: `${chartWidth}px`
                        } : undefined,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1rBba.default), {
                            symbol: symbol,
                            timeframe: "30min",
                            label: "ATR-DT",
                            strategy: "DT",
                            status: {
                                ...status,
                                levels_date: status.levels_date || levelsDateIso
                            }
                        })
                    })
                })
            })
        ]
    });
});
const $405b868a9af90f76$var$DTStrategyContent = ({ dtStatus: dtStatus, handleStrategyToggle: handleStrategyToggle, strategyToggleLoading: strategyToggleLoading })=>{
    const [showRules, setShowRules] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [expandedSymbol, setExpandedSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [showConfigModal, setShowConfigModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [marketOpen, setMarketOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $35Xbi.isRegularMarketOpen)());
    const tableViewportRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [chartWidth, setChartWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const dtData = dtStatus?.data || {};
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const viewport = tableViewportRef.current;
        if (!viewport) return;
        const updateWidth = ()=>setChartWidth(Math.floor(viewport.clientWidth));
        updateWidth();
        const observer = new ResizeObserver(updateWidth);
        observer.observe(viewport);
        return ()=>observer.disconnect();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const updateMarketState = ()=>setMarketOpen((0, $35Xbi.isRegularMarketOpen)());
        const interval = window.setInterval(updateMarketState, 30000);
        return ()=>window.clearInterval(interval);
    }, []);
    if (!dtStatus) return null;
    const hasData = !!dtStatus?.data;
    const levelsDateIso = dtData?.levels_date;
    const levelsDate = levelsDateIso && !Number.isNaN(Date.parse(levelsDateIso)) ? (0, $k8QNV.formatDateTimeET)(levelsDateIso) : undefined;
    const dtEnabled = dtData?.enabled ?? false;
    const toggleState = strategyToggleLoading.DT;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center justify-between mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-muted",
                                children: "Strategy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-semibold text-foreground",
                                children: "ATR-DT"
                            }),
                            dtData?.version && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "px-1.5 py-0.5 rounded-md bg-white/5 border border-white/10 text-[10px] text-muted font-mono",
                                children: [
                                    "v",
                                    dtData.version
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>handleStrategyToggle("DT", dtEnabled),
                        disabled: !!toggleState,
                        "aria-busy": !!toggleState,
                        className: `min-w-[104px] justify-center px-3 py-1.5 rounded-lg font-semibold uppercase flex text-sm items-center gap-1 transition disabled:cursor-wait disabled:opacity-80 ${toggleState ? "bg-amber-400/10 text-amber-300 border border-amber-400/20" : dtEnabled ? "bg-neon-soft text-neon" : "text-muted hover:text-foreground hover:bg-white/10"}`,
                        children: [
                            toggleState ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                size: 14,
                                className: "animate-spin"
                            }) : dtEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gsAgU.default), {
                                size: 14
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dkOIy.default), {
                                size: 14
                            }),
                            toggleState === "starting" ? "Starting" : toggleState === "pausing" ? "Pausing" : dtEnabled ? "Pause" : "Start"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-foreground",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>setShowRules(!showRules),
                        className: "flex items-center gap-2 mb-4 px-4 py-2 rounded-xl bg-white/5 border border-white/10 text-[11px] font-black uppercase tracking-[0.2em] text-muted hover:text-white hover:bg-white/10 transition-all shadow-inner group",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `p-1 rounded-md transition-all ${showRules ? 'bg-neon/20 text-neon' : 'bg-white/10 text-white/40 group-hover:text-white'}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jv5sm.default), {
                                    size: 14,
                                    className: showRules ? 'animate-pulse' : ''
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    showRules ? 'Hide' : 'Show',
                                    " Strategy Conditions & Rules"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `ml-auto transition-transform duration-300 ${showRules ? 'rotate-180 text-neon' : ''}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "m6 9 6 6 6-6"
                                    })
                                })
                            })
                        ]
                    }),
                    showRules && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-2 mb-6 animate-in fade-in slide-in-from-top-2 duration-300",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-neon/10 text-neon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jv5sm.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Entry Conditions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Price deviation from ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Daily Open"
                                                            }),
                                                            " exceeds ATR threshold"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Variable thresholds for ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "First"
                                                            }),
                                                            " vs ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Second Window"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-neon/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Entry via ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Bar Close"
                                                            }),
                                                            " (H/HH) or ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Traps"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3 shadow-lg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 mb-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-amber-500/10 text-amber-400",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dAee.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Strategy Rules"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Positions liquidated at ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "15:30 ET"
                                                            }),
                                                            " (EOD)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "Daily limit of ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "1 trade"
                                                            }),
                                                            " per symbol (default)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "flex items-start gap-2 text-[11px] text-muted leading-relaxed",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mt-1 w-1 h-1 rounded-full bg-amber-400/50 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "No entries after ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "text-white/80",
                                                                children: "Last Entry Time"
                                                            }),
                                                            " cutoff"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt-2 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-foreground",
                children: levelsDate && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rounded-xl bg-white/6 border border-white/10 px-3 py-2 flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-muted mr-2",
                            children: "Latest Data"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-foreground font-semibold",
                            children: levelsDate
                        })
                    ]
                })
            }),
            hasData && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mt-4 rounded-2xl bg-white/6 text-sm text-foreground",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-sm font-semibold text-neon",
                                children: "Symbol Status"
                            }),
                            dtStatus.data?.config_source && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex items-center gap-2",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>setShowConfigModal(true),
                                    className: `inline-flex min-h-7 shrink-0 items-center gap-1.5 rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider transition-colors ${dtStatus.data.config_source === 'USER' ? 'bg-neon/10 text-neon border border-neon/20' : 'bg-white/5 text-muted border border-white/10'} hover:bg-white/10 hover:text-white`,
                                    title: "View current ATR-DT strategy setup",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fkh1V.default), {
                                            className: "h-3.5 w-3.5"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "whitespace-nowrap",
                                            children: dtStatus.data.config_source === 'USER' ? 'User Config' : 'System Default'
                                        }),
                                        dtStatus.data.config_version && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "whitespace-nowrap",
                                            children: [
                                                "v",
                                                dtStatus.data.config_version
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: tableViewportRef,
                        className: "overflow-x-auto scrollbar-thin rounded-xl border border-white/5 bg-surface",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "min-w-full divide-y divide-white/10 text-[13px] text-foreground",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "bg-black/60",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                children: "Symbol"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Price"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Open"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "ATR"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Threshold"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "VWAP"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                children: "Window"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider text-[11px]",
                                                children: "Cutoff"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-left font-bold text-white/90 uppercase tracking-wider",
                                                children: "Mode"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "SL Factor"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Size"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Lev"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Trades"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                scope: "col",
                                                className: "px-4 py-4 text-right font-bold text-white/90 uppercase tracking-wider",
                                                children: "Position"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    className: "divide-y divide-white/5",
                                    children: dtStatus.data?.symbol_status && Object.keys(dtStatus.data?.symbol_status || {}).length > 0 ? Object.entries(dtStatus.data?.symbol_status || {}).map(([symbol, status])=>/*#__PURE__*/ (0, $ayMG0.jsx)($405b868a9af90f76$var$DTSymbolRow, {
                                            symbol: symbol,
                                            status: status,
                                            levelsDateIso: levelsDateIso,
                                            expanded: expandedSymbol === symbol,
                                            onToggle: ()=>setExpandedSymbol((current)=>current === symbol ? null : symbol),
                                            chartWidth: chartWidth,
                                            marketOpen: marketOpen
                                        }, symbol)) : /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            colSpan: 14,
                                            className: "px-3 py-4 text-center text-muted",
                                            children: dtEnabled ? "Waiting for market data..." : "Strategy offline"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9qjJe.default), {
                isOpen: showConfigModal,
                onClose: ()=>setShowConfigModal(false),
                title: "ATR-DT Strategy Setup",
                width: "max-w-4xl",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8a9d9ff69f432e4$export$2e2bcd8739ae039), {
                    strategyName: "DT",
                    readOnly: true
                })
            })
        ]
    });
};
var $405b868a9af90f76$export$2e2bcd8739ae039 = $405b868a9af90f76$var$DTStrategyContent;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $02HYJ = parcelRequire("02HYJ");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $76d71077487353ea$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ArrowRightLeft", [
    [
        "path",
        {
            d: "m16 3 4 4-4 4",
            key: "1x1c3m"
        }
    ],
    [
        "path",
        {
            d: "M20 7H4",
            key: "zbl0bi"
        }
    ],
    [
        "path",
        {
            d: "m8 21-4-4 4-4",
            key: "h9nckh"
        }
    ],
    [
        "path",
        {
            d: "M4 17h16",
            key: "g4d7ey"
        }
    ]
]);

/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $7c62dd403424a2a8$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CalendarClock", [
    [
        "path",
        {
            d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5",
            key: "1osxxc"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M3 10h5",
            key: "r794hk"
        }
    ],
    [
        "path",
        {
            d: "M17.5 17.5 16 16.3V14",
            key: "akvzfd"
        }
    ],
    [
        "circle",
        {
            cx: "16",
            cy: "16",
            r: "6",
            key: "qoo3c4"
        }
    ]
]);


var $6Plhc = parcelRequire("6Plhc");
var $fpYe5 = parcelRequire("fpYe5");
var $fkh1V = parcelRequire("fkh1V");
var $4Yp7M = parcelRequire("4Yp7M");
var $gsAgU = parcelRequire("gsAgU");
var $dkOIy = parcelRequire("dkOIy");
var $iSlX2 = parcelRequire("iSlX2");
var $bTepa = parcelRequire("bTepa");
var $hiXj7 = parcelRequire("hiXj7");


var $9qjJe = parcelRequire("9qjJe");

var $2wVnk = parcelRequire("2wVnk");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $k8QNV = parcelRequire("k8QNV");
const $94ad89d94b510f88$export$e7c2806c498ca04c = (value, _fraction = false)=>{
    if (value === undefined || value === null || !Number.isFinite(Number(value))) return "\u2014";
    return `${(Number(value) * 100).toFixed(1)}%`;
};
const $94ad89d94b510f88$export$d68f5a36fb886d13 = (value)=>{
    if (!value) return "\u2014";
    try {
        return (0, $k8QNV.formatDateTimeET)(value);
    } catch  {
        return value;
    }
};
const $94ad89d94b510f88$export$859fa52db42cf485 = (value)=>{
    if (!value) return "\u2014";
    const match = String(value).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return String(value);
    return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC'
    }).format(new Date(`${match[1]}-${match[2]}-${match[3]}T12:00:00Z`));
};
const $94ad89d94b510f88$export$9e1dd5059e1fa82 = (value)=>value ? `${String(value).slice(0, 5)} ET` : "\u2014";
const $94ad89d94b510f88$export$4505f314868b99ef = (value)=>value === undefined || value === null || !Number.isFinite(Number(value)) ? "\u2014" : `$${Number(value).toFixed(2)}`;
const $94ad89d94b510f88$export$88014ce576d8bf84 = (value)=>{
    if (value === undefined || value === null || !Number.isFinite(Number(value))) return "\u2014";
    const quantity = Number(value);
    return quantity > 0 ? `+${quantity}` : `${quantity}`;
};
const $94ad89d94b510f88$export$50ed74e268265b5c = (row, action, quantity)=>{
    const quote = row.price_quote;
    const bid = Number(quote?.bid);
    const ask = Number(quote?.ask);
    const currentPrice = Number(row.current_price);
    const midpoint = Number.isFinite(bid) && bid > 0 && Number.isFinite(ask) && ask >= bid ? (bid + ask) / 2 : currentPrice;
    return {
        symbol: row.symbol,
        action: action,
        quantity: quantity,
        openInModal: true,
        secType: 'STK',
        orderType: 'MIDPRICE',
        price: Number.isFinite(midpoint) && midpoint > 0 ? midpoint : undefined
    };
};
const $94ad89d94b510f88$export$ba0a9709164c99ad = (symbolInput, quantityInput, priceInput)=>{
    const symbol = symbolInput.trim().toUpperCase();
    const quantity = Number.parseFloat(quantityInput);
    if (!symbol || Number.isNaN(quantity) || quantity === 0) return null;
    const parsedPrice = priceInput.trim() ? Number.parseFloat(priceInput) : undefined;
    return {
        symbol: symbol,
        quantity: quantity,
        current_price: parsedPrice && !Number.isNaN(parsedPrice) ? parsedPrice : undefined
    };
};


const $fcff60eb004bfbb5$var$NQMMCandidateTable = ({ title: title, icon: icon, candidates: candidates, rebalanceWindowOpen: rebalanceWindowOpen })=>{
    const prepareOrder = (row, action, quantity)=>{
        window.dispatchEvent(new CustomEvent('nqmm-prepare-order', {
            detail: (0, $94ad89d94b510f88$export$50ed74e268265b5c)(row, action, quantity)
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "rounded-2xl border border-white/10 bg-black/20 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px-4 py-3 border-b border-white/10 flex items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            icon,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 text-[10px] uppercase tracking-wider",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "text-emerald-300",
                                children: [
                                    candidates.filter((candidate)=>(candidate.rebalance_quantity ?? 0) > 0).length,
                                    " buy"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "text-rose-300",
                                children: [
                                    candidates.filter((candidate)=>(candidate.rebalance_quantity ?? 0) < 0).length,
                                    " sell"
                                ]
                            })
                        ]
                    })
                ]
            }),
            candidates.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "px-4 py-6 text-center text-xs text-muted",
                children: rebalanceWindowOpen ? 'No buy or sell orders are needed for the scheduled target.' : 'Order suggestions appear during the scheduled rebalance window. Momentum rankings refresh daily.'
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "max-h-80 overflow-x-auto overflow-y-auto ux-scrollbar",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: "w-full min-w-[620px] text-[11px]",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            className: "sticky top-0 bg-[#111827] text-[9px] uppercase tracking-wider text-muted",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2 text-left",
                                        children: "Symbol"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Target"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Current"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Change"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Action"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "px-3 py-2 text-right",
                                        children: "Momentum"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "sticky right-0 bg-[#111827] px-3 py-2 text-right",
                                        children: "Order"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            children: candidates.map((row)=>{
                                const currentQuantity = row.current_quantity ?? row.position?.shares ?? 0;
                                const targetQuantity = row.target_quantity ?? 0;
                                const quantityChange = row.rebalance_quantity ?? targetQuantity - currentQuantity;
                                const orderAction = quantityChange > 0 ? 'BUY' : 'SELL';
                                const orderQuantity = Math.abs(quantityChange);
                                const canPrepareOrder = quantityChange !== 0;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    className: "border-t border-white/5 hover:bg-white/[0.03]",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            className: "px-3 py-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "font-semibold text-white",
                                                    children: row.symbol
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "text-[9px] text-muted",
                                                    children: [
                                                        "Rank ",
                                                        row.rank ?? "\u2014",
                                                        " \xb7 ",
                                                        row.candidate_reason || 'Momentum candidate'
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            className: "px-3 py-1.5 text-right",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "font-mono text-[10px] text-white",
                                                    children: (0, $94ad89d94b510f88$export$4505f314868b99ef)(row.current_price)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `text-[8px] uppercase tracking-wider ${row.price_status === 'LIVE' ? 'text-emerald-300' : row.price_status === 'UNAVAILABLE' ? 'text-rose-300' : 'text-amber-300'}`,
                                                    children: row.price_status || "\u2014"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-3 py-1.5 text-right font-mono text-white/70",
                                            children: targetQuantity
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "px-3 py-1.5 text-right font-mono text-white/70",
                                            children: currentQuantity
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: `px-3 py-1.5 text-right font-mono font-semibold ${quantityChange > 0 ? 'text-emerald-300' : quantityChange < 0 ? 'text-rose-300' : 'text-white/50'}`,
                                            children: (0, $94ad89d94b510f88$export$88014ce576d8bf84)(quantityChange)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            className: `px-3 py-1.5 text-right font-semibold uppercase tracking-wider ${orderAction === 'SELL' ? 'text-rose-300' : 'text-emerald-300'}`,
                                            children: [
                                                orderAction,
                                                " ",
                                                orderQuantity
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: `px-3 py-1.5 text-right font-mono ${Number(row.momentum) >= 0 ? 'text-emerald-300' : 'text-rose-300'}`,
                                            children: (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(row.momentum)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "sticky right-0 bg-[#111827] px-3 py-1.5 text-right",
                                            children: canPrepareOrder ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>prepareOrder(row, orderAction, orderQuantity),
                                                className: `rounded-md border px-2 py-1 text-[9px] font-bold uppercase tracking-wider transition ${orderAction === 'BUY' ? 'border-emerald-400/30 bg-emerald-400/10 text-emerald-300 hover:bg-emerald-400/20' : 'border-rose-400/30 bg-rose-400/10 text-rose-300 hover:bg-rose-400/20'}`,
                                                title: `Review an IBKR MIDPRICE ${orderAction} rebalance order in a modal`,
                                                children: [
                                                    orderAction,
                                                    " MID"
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-[9px] uppercase tracking-wider text-white/30",
                                                children: "No order"
                                            })
                                        })
                                    ]
                                }, `rebalance-${row.symbol}`);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $fcff60eb004bfbb5$export$2e2bcd8739ae039 = $fcff60eb004bfbb5$var$NQMMCandidateTable;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bbkWX = parcelRequire("bbkWX");
var $4Yp7M = parcelRequire("4Yp7M");
var $iSlX2 = parcelRequire("iSlX2");
var $2w97G = parcelRequire("2w97G");
var $hPAJY = parcelRequire("hPAJY");

var $9qjJe = parcelRequire("9qjJe");

const $074ab7f992860515$var$NQMMHistoryCorrectionModal = ({ isOpen: isOpen, onClose: onClose, historyLoading: historyLoading, historyError: historyError, submittingSymbol: submittingSymbol, previousPositions: previousPositions, currentPositions: currentPositions, addPreviousPosition: addPreviousPosition, deletePreviousPosition: deletePreviousPosition })=>{
    const [manualSymbol, setManualSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [manualQuantity, setManualQuantity] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('100');
    const [manualPrice, setManualPrice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    if (!isOpen) return null;
    const stockPositions = currentPositions.filter((position)=>!position.secType || [
            'STK',
            'CFD'
        ].includes(position.secType));
    const handleManualSubmit = async (event)=>{
        event.preventDefault();
        const correction = (0, $94ad89d94b510f88$export$ba0a9709164c99ad)(manualSymbol, manualQuantity, manualPrice);
        if (!correction) return;
        await addPreviousPosition(correction);
        setManualSymbol('');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9qjJe.default), {
        isOpen: isOpen,
        onClose: onClose,
        title: "Correct previous NQMM positions",
        width: "max-w-4xl",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-start justify-between gap-3 rounded-xl border border-white/10 bg-white/5 px-3 py-3 text-xs text-muted",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "Select a current stock position or manually enter a symbol and share count to update NQMM's 10-record position history."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            className: "text-muted hover:text-white",
                            "aria-label": "Close",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                size: 16
                            })
                        })
                    ]
                }),
                historyError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "rounded-lg border border-rose-400/20 bg-rose-400/5 px-3 py-2 text-xs text-rose-300",
                    children: historyError
                }),
                historyLoading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center justify-center py-8 text-sm text-muted",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                            size: 16,
                            className: "mr-2 animate-spin text-neon"
                        }),
                        " Loading positions\u2026"
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                            onSubmit: handleManualSubmit,
                            className: "rounded-xl border border-white/10 bg-white/5 p-3 space-y-3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "text-[10px] font-bold uppercase tracking-wider text-neon",
                                    children: "Add custom position record"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "grid grid-cols-1 sm:grid-cols-3 gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "block text-[10px] text-muted mb-1 font-semibold uppercase",
                                                    children: "Symbol"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "e.g. NVDA",
                                                    value: manualSymbol,
                                                    onChange: (event)=>setManualSymbol(event.target.value.toUpperCase()),
                                                    className: "w-full rounded-lg border border-white/10 bg-black/40 px-2.5 py-1.5 text-xs text-white uppercase placeholder:text-muted/50 focus:border-neon focus:outline-none",
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "block text-[10px] text-muted mb-1 font-semibold uppercase",
                                                    children: "Shares / Quantity"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "number",
                                                    step: "any",
                                                    placeholder: "e.g. 100",
                                                    value: manualQuantity,
                                                    onChange: (event)=>setManualQuantity(event.target.value),
                                                    className: "w-full rounded-lg border border-white/10 bg-black/40 px-2.5 py-1.5 text-xs text-white placeholder:text-muted/50 focus:border-neon focus:outline-none",
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "block text-[10px] text-muted mb-1 font-semibold uppercase",
                                                    children: "Price (Optional)"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "number",
                                                    step: "any",
                                                    placeholder: "e.g. 125.50",
                                                    value: manualPrice,
                                                    onChange: (event)=>setManualPrice(event.target.value),
                                                    className: "w-full rounded-lg border border-white/10 bg-black/40 px-2.5 py-1.5 text-xs text-white placeholder:text-muted/50 focus:border-neon focus:outline-none"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex justify-end",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "submit",
                                        disabled: !manualSymbol.trim() || submittingSymbol !== null,
                                        className: "inline-flex items-center gap-1.5 rounded-lg border border-neon/30 bg-neon/10 px-3 py-1.5 text-xs font-bold text-neon hover:bg-neon/20 transition-all disabled:opacity-50",
                                        children: [
                                            submittingSymbol === manualSymbol.trim().toUpperCase() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                size: 14,
                                                className: "animate-spin text-neon"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSlX2.default), {
                                                size: 14
                                            }),
                                            "Save Record"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mb-2 text-[10px] font-bold uppercase tracking-wider text-muted",
                                    children: "Current broker stock positions"
                                }),
                                stockPositions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "rounded-xl border border-white/10 bg-black/20 px-3 py-4 text-center text-xs text-muted",
                                    children: "No active stock positions in broker account. Use the form above to add a manual position."
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "overflow-hidden rounded-xl border border-white/10",
                                    children: stockPositions.map((position)=>{
                                        const existing = previousPositions.some((item)=>item.symbol === position.symbol);
                                        const isSubmitting = submittingSymbol === position.symbol;
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center justify-between gap-3 border-b border-white/5 px-3 py-2 last:border-b-0",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "min-w-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "font-semibold text-white",
                                                            children: position.symbol
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "text-[10px] text-muted",
                                                            children: [
                                                                position.quantity,
                                                                " shares \xb7 ",
                                                                position.current_price ? (0, $94ad89d94b510f88$export$4505f314868b99ef)(position.current_price) : 'price unavailable'
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    type: "button",
                                                    disabled: isSubmitting,
                                                    onClick: ()=>addPreviousPosition(position),
                                                    className: "inline-flex shrink-0 items-center gap-1 rounded-lg border border-neon/30 bg-neon/10 px-2.5 py-1.5 text-[10px] font-bold uppercase tracking-wider text-neon hover:bg-neon/20 disabled:opacity-50",
                                                    children: [
                                                        isSubmitting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                            size: 13,
                                                            className: "animate-spin text-neon"
                                                        }) : existing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbkWX.default), {
                                                            size: 13
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSlX2.default), {
                                                            size: 13
                                                        }),
                                                        existing ? 'Correct' : 'Add'
                                                    ]
                                                })
                                            ]
                                        }, `${position.symbol}-${position.contract_key || 'stock'}`);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mb-2 text-[10px] font-bold uppercase tracking-wider text-muted",
                                    children: "Recorded Previous 10 Positions"
                                }),
                                previousPositions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "rounded-xl border border-white/10 bg-black/20 px-3 py-5 text-center text-xs text-muted",
                                    children: "No manual corrections recorded yet."
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "overflow-hidden rounded-xl border border-white/10",
                                    children: previousPositions.map((position)=>{
                                        const isDeleting = submittingSymbol === position.symbol;
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center justify-between gap-3 border-b border-white/5 px-3 py-2 last:border-b-0",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-semibold text-white",
                                                            children: position.symbol
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "ml-2 text-xs text-muted",
                                                            children: [
                                                                position.quantity,
                                                                " shares"
                                                            ]
                                                        }),
                                                        position.current_price ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "ml-2 text-[10px] text-muted",
                                                            children: [
                                                                "(",
                                                                (0, $94ad89d94b510f88$export$4505f314868b99ef)(position.current_price),
                                                                ")"
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-[10px] text-muted",
                                                            children: position.recorded_at ? (0, $94ad89d94b510f88$export$d68f5a36fb886d13)(position.recorded_at) : "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            disabled: isDeleting,
                                                            onClick: ()=>deletePreviousPosition(position.symbol),
                                                            className: "text-muted hover:text-rose-300 disabled:opacity-50",
                                                            "aria-label": `Remove ${position.symbol}`,
                                                            children: isDeleting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                                size: 14,
                                                                className: "animate-spin text-rose-300"
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2w97G.default), {
                                                                size: 14
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, position.id);
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $074ab7f992860515$export$2e2bcd8739ae039 = $074ab7f992860515$var$NQMMHistoryCorrectionModal;



var $jtEPT = parcelRequire("jtEPT");

var $d7aJR = parcelRequire("d7aJR");

const $d36af3c0ee385315$var$NQMMStrategyContent = ({ nqmmStatus: nqmmStatus, handleStrategyToggle: handleStrategyToggle, strategyToggleLoading: strategyToggleLoading, refreshNQMMStatus: refreshNQMMStatus, rankingRefreshLoading: rankingRefreshLoading })=>{
    const [showConfigModal, setShowConfigModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [showHistoryModal, setShowHistoryModal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [historyLoading, setHistoryLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [historyError, setHistoryError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [previousPositions, setPreviousPositions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [currentPositions, setCurrentPositions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [showAllRankings, setShowAllRankings] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [semiAutomaticSetting, setSemiAutomaticSetting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [semiAutomaticSaving, setSemiAutomaticSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [semiAutomaticError, setSemiAutomaticError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const data = nqmmStatus?.data;
    const { data: portfolioPositions } = (0, $jtEPT.usePositionsQuery)(undefined, {
        pollingInterval: 10000,
        skipPollingIfUnfocused: true
    });
    const info = data?.strategy_info || {};
    const rankings = data?.rankings || [];
    const selectedSymbols = data?.selected_symbols || data?.active_symbols || [];
    const hasPortfolioSnapshot = portfolioPositions?.success === true && portfolioPositions.data?.snapshot_available !== false;
    const positions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>hasPortfolioSnapshot ? (0, $d7aJR.getNQMMPortfolioPositions)(portfolioPositions?.data?.positions || []) : data?.positions || {}, [
        hasPortfolioSnapshot,
        portfolioPositions?.data?.positions,
        data?.positions
    ]);
    const managedSymbols = new Set((data?.managed_symbols ?? Object.keys(data?.target_positions || {})).map((symbol)=>symbol.toUpperCase()));
    const manualUnmanagedSymbols = new Set((data?.manual_unmanaged_symbols || []).map((symbol)=>symbol.toUpperCase()));
    const previousPositionSymbols = new Set((data?.previous_positions || []).map((position)=>position.symbol.toUpperCase()));
    const toggleState = strategyToggleLoading.NQMM;
    const enabled = data?.enabled ?? false;
    const rebalanceStatus = data?.rebalance_status || info.rebalance_status || "NOT_RUN";
    const rankingStatus = data?.ranking_status || "NOT_RUN";
    const displayedRankings = rankings.length > 0 ? showAllRankings ? rankings : rankings.slice(0, 25) : [];
    const currentPositionRows = Object.entries(positions).map(([symbol, quantity])=>({
            symbol: symbol,
            quantity: Number(quantity)
        })).filter(({ symbol: symbol, quantity: quantity })=>Number.isFinite(quantity) && quantity !== 0 && (hasPortfolioSnapshot || !manualUnmanagedSymbols.has(symbol.toUpperCase()) && (managedSymbols.has(symbol.toUpperCase()) || previousPositionSymbols.has(symbol.toUpperCase())))).sort((left, right)=>left.symbol.localeCompare(right.symbol));
    const buyCandidates = data?.buy_candidates || [];
    const sellCandidates = data?.sell_candidates || [];
    const reportedRebalanceCandidates = data?.rebalance_candidates ?? [
        ...buyCandidates.filter((candidate)=>(candidate.rebalance_quantity ?? 0) > 0),
        ...sellCandidates.filter((candidate)=>(candidate.rebalance_quantity ?? 0) < 0)
    ];
    const rebalanceTime = data?.rebalance_time || info.rebalance_time;
    const sleeveAllocation = data?.sleeve_allocation ?? info.sleeve_allocation ?? data?.position_size;
    const cashBuffer = data?.cash_buffer ?? info.cash_buffer;
    const topN = data?.top_n ?? info.top_n;
    const maxPositionAllocation = data?.max_position_allocation ?? info.max_position_allocation;
    const lookbackMonths = data?.lookback_months ?? info.lookback_months;
    const skipRecentMonths = data?.skip_recent_months ?? info.skip_recent_months;
    const tradingDaysPerMonth = data?.trading_days_per_month ?? info.trading_days_per_month;
    const minMomentum = data?.min_momentum ?? info.min_momentum;
    const requirePositiveMomentum = data?.require_positive_momentum ?? info.require_positive_momentum;
    const maxConcurrentHistoryRequests = data?.max_concurrent_history_requests ?? info.max_concurrent_history_requests;
    const semiAutomatic = data?.semi_automatic ?? info.semi_automatic ?? true;
    const positionSizingMethod = data?.position_sizing_method || info.position_sizing_method || "inverse_volatility";
    const sizingLabel = positionSizingMethod === "equal_weight" ? "Equal weight" : "Inverse volatility";
    const qqqAbove200Sma = data?.qqq_above_200_sma ?? info.qqq_above_200_sma;
    const requireQqqAbove200Sma = data?.require_qqq_above_200_sma ?? info.require_qqq_above_200_sma;
    const qqqPrice = data?.qqq_price ?? info.qqq_price;
    const qqq200Sma = data?.qqq_200_sma ?? info.qqq_200_sma;
    const qqqDataAsOf = data?.qqq_data_as_of ?? info.qqq_data_as_of;
    const configChangePending = data?.config_change_pending ?? info.config_change_pending;
    const nextRebalanceAt = data?.next_rebalance_at ?? info.next_rebalance_at;
    const nextRebalanceLabel = `${(0, $94ad89d94b510f88$export$859fa52db42cf485)(data?.next_rebalance_date || info.next_rebalance_date)} \xb7 ${(0, $94ad89d94b510f88$export$9e1dd5059e1fa82)(rebalanceTime)}`;
    const qqqRegime = qqqAbove200Sma === true ? "Above 200 SMA" : qqqAbove200Sma === false ? "Below 200 SMA" : "Unavailable";
    const rebalanceTargetsReady = Boolean(data?.rebalance_targets_ready);
    const reportedPendingOrders = data?.pending_rebalance_orders ?? reportedRebalanceCandidates.filter((candidate)=>(candidate.rebalance_quantity ?? 0) !== 0).length;
    const rebalanceWindowOpen = Boolean(data?.rebalance_window_open || data?.rebalance_due || rebalanceStatus === "PENDING_SEMI_AUTOMATIC" && rebalanceTargetsReady && reportedPendingOrders > 0 || rebalanceStatus === "REBALANCE_DUE");
    const rebalanceCandidates = rebalanceWindowOpen && rebalanceTargetsReady ? reportedRebalanceCandidates : [];
    const pendingBuyOrders = rebalanceCandidates.filter((c)=>(c.rebalance_quantity ?? 0) > 0).length;
    const pendingSellOrders = rebalanceCandidates.filter((c)=>(c.rebalance_quantity ?? 0) < 0).length;
    const totalPendingOrders = rebalanceTargetsReady ? data?.pending_rebalance_orders ?? pendingBuyOrders + pendingSellOrders : 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const configured = data?.semi_automatic ?? info.semi_automatic;
        if (typeof configured === "boolean") setSemiAutomaticSetting(configured);
    }, [
        data?.semi_automatic,
        info.semi_automatic
    ]);
    const handleSemiAutomaticToggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (semiAutomaticSaving) return;
        const nextValue = !semiAutomaticSetting;
        const previousValue = semiAutomaticSetting;
        setSemiAutomaticSetting(nextValue);
        setSemiAutomaticSaving(true);
        setSemiAutomaticError(null);
        try {
            const response = await (0, $2wVnk.tradingApi).updateStrategyDbConfig("NQMM", {
                config_json: {
                    semi_automatic: nextValue
                }
            });
            if (!response.success) throw new Error(response.message || "Failed to update NQMM execution mode");
            window.dispatchEvent(new CustomEvent("trading-data-refresh"));
        } catch (error) {
            setSemiAutomaticSetting(previousValue);
            setSemiAutomaticError(error instanceof Error ? error.message : "Failed to update NQMM execution mode");
        } finally{
            setSemiAutomaticSaving(false);
        }
    }, [
        semiAutomaticSaving,
        semiAutomaticSetting
    ]);
    const statusPositionFallback = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Object.entries(positions).map(([symbol, quantity])=>({
                symbol: symbol,
                quantity: Number(quantity),
                secType: "STK",
                timestamp: new Date().toISOString()
            })).filter((position)=>Number.isFinite(position.quantity) && position.quantity !== 0), [
        positions
    ]);
    const openHistoryModal = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        setShowHistoryModal(true);
        setHistoryLoading(true);
        setHistoryError(null);
        const [historyResult, positionsResult] = await Promise.allSettled([
            (0, $2wVnk.tradingApi).getNQMMPreviousPositions(),
            (0, $2wVnk.tradingApi).getPositions()
        ]);
        if (historyResult.status === "fulfilled") setPreviousPositions(historyResult.value.data?.previous_positions || []);
        else setHistoryError(historyResult.reason instanceof Error ? historyResult.reason.message : "Failed to load previous position corrections");
        if (positionsResult.status === "fulfilled") setCurrentPositions(positionsResult.value.data?.positions || []);
        else {
            // Pausing NQMM must not disable correction history.  If the account
            // endpoint is temporarily unavailable, use the position snapshot that
            // already backs the paused strategy status so existing stock holdings
            // can still be recorded without starting the strategy.
            setCurrentPositions(statusPositionFallback);
            if (statusPositionFallback.length === 0 && historyResult.status === "fulfilled") setHistoryError("Current positions are unavailable while disconnected from the account");
        }
        setHistoryLoading(false);
    }, [
        statusPositionFallback
    ]);
    const [submittingSymbol, setSubmittingSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const addPreviousPosition = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (position)=>{
        setSubmittingSymbol(position.symbol);
        setHistoryError(null);
        try {
            const response = await (0, $2wVnk.tradingApi).addNQMMPreviousPosition({
                symbol: position.symbol,
                quantity: position.quantity,
                avg_cost: position.avg_cost,
                current_price: position.current_price,
                market_value: position.market_value
            });
            if (response.success && response.data?.previous_positions) {
                setPreviousPositions(response.data.previous_positions);
                window.dispatchEvent(new CustomEvent("trading-data-refresh"));
            } else if (response.error || response.message) setHistoryError(response.error || response.message || "Failed to save position correction");
        } catch (error) {
            setHistoryError(error instanceof Error ? error.message : "Failed to save position correction");
        } finally{
            setSubmittingSymbol(null);
        }
    }, []);
    const deletePreviousPosition = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (symbol)=>{
        setSubmittingSymbol(symbol);
        setHistoryError(null);
        try {
            const response = await (0, $2wVnk.tradingApi).deleteNQMMPreviousPosition(symbol);
            if (response.success && response.data?.previous_positions) {
                setPreviousPositions(response.data.previous_positions);
                window.dispatchEvent(new CustomEvent("trading-data-refresh"));
            } else if (response.error || response.message) setHistoryError(response.error || response.message || "Failed to remove position correction");
        } catch (error) {
            setHistoryError(error instanceof Error ? error.message : "Failed to remove position correction");
        } finally{
            setSubmittingSymbol(null);
        }
    }, []);
    if (!data) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "rounded-2xl border border-amber-400/20 bg-amber-400/5 px-4 py-6 text-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "text-sm font-semibold text-amber-200",
                        children: "NQMM status unavailable"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mt-1 text-xs text-muted",
                        children: "The trading session is offline or has not finished loading. Ranking data will appear when the engine reconnects."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: openHistoryModal,
                        className: "mt-4 inline-flex items-center gap-1.5 rounded-lg border border-neon/30 bg-neon/10 px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-neon hover:bg-neon/20",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSlX2.default), {
                                size: 14
                            }),
                            " Correct previous 10"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $074ab7f992860515$export$2e2bcd8739ae039), {
                isOpen: showHistoryModal,
                onClose: ()=>setShowHistoryModal(false),
                historyLoading: historyLoading,
                historyError: historyError,
                submittingSymbol: submittingSymbol,
                previousPositions: previousPositions,
                currentPositions: currentPositions,
                addPreviousPosition: addPreviousPosition,
                deletePreviousPosition: deletePreviousPosition
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-4 flex flex-wrap items-center justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2 text-sm min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-muted",
                                children: "Strategy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-semibold text-foreground",
                                children: "NQMM"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "text-muted hidden sm:inline",
                                children: "Nasdaq-100 Monthly Momentum"
                            }),
                            data.config_version && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "px-1.5 py-0.5 rounded-md bg-white/5 border border-white/10 text-[10px] text-muted font-mono",
                                children: [
                                    "v",
                                    data.config_version
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>handleStrategyToggle("NQMM", enabled),
                        disabled: !!toggleState,
                        "aria-busy": !!toggleState,
                        className: `inline-flex min-w-[76px] shrink-0 items-center justify-center gap-1 rounded-md px-2.5 py-1.5 text-[11px] font-semibold uppercase transition disabled:cursor-wait disabled:opacity-80 ${toggleState ? "bg-amber-400/10 text-amber-300 border border-amber-400/20" : enabled ? "bg-neon-soft text-neon" : "text-muted hover:text-foreground hover:bg-white/10"}`,
                        children: [
                            toggleState ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                size: 14,
                                className: "animate-spin"
                            }) : enabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gsAgU.default), {
                                size: 14
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dkOIy.default), {
                                size: 14
                            }),
                            toggleState === "starting" ? "Starting" : toggleState === "pausing" ? "Pausing" : enabled ? "Pause" : "Start"
                        ]
                    })
                ]
            }),
            rebalanceWindowOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-5 rounded-2xl border border-amber-400/30 bg-amber-500/10 p-4 text-amber-200 shadow-lg shadow-amber-500/5",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-start gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $02HYJ.default), {
                            className: "h-5 w-5 text-amber-400 shrink-0 mt-0.5"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex-1 min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex items-center gap-2 font-bold text-amber-300 text-sm",
                                    children: "Rebalance Window Open \xb7 Action Required"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mt-1 text-xs text-amber-200/90 leading-relaxed",
                                    children: data?.rebalance_warning || `${data.effective_rebalance_frequency || info.effective_rebalance_frequency || data.rebalance_frequency || info.rebalance_frequency || "Monthly"} rebalance is scheduled for today (${(0, $94ad89d94b510f88$export$859fa52db42cf485)(data?.next_rebalance_date || info.next_rebalance_date)} \xb7 ${(0, $94ad89d94b510f88$export$9e1dd5059e1fa82)(rebalanceTime)}). ${totalPendingOrders > 0 ? `${totalPendingOrders} order(s) are pending execution to align portfolio with target allocations.` : "Portfolio targets are ready."}`
                                }),
                                totalPendingOrders > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mt-2.5 flex flex-wrap items-center gap-2 text-xs font-semibold text-amber-300",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-amber-200/80",
                                            children: "Pending orders:"
                                        }),
                                        pendingBuyOrders > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "px-2 py-0.5 rounded bg-emerald-500/20 text-emerald-300 border border-emerald-500/30 font-mono text-[11px]",
                                            children: [
                                                pendingBuyOrders,
                                                " BUY"
                                            ]
                                        }),
                                        pendingSellOrders > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "px-2 py-0.5 rounded bg-rose-500/20 text-rose-300 border border-rose-500/30 font-mono text-[11px]",
                                            children: [
                                                pendingSellOrders,
                                                " SELL"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "text-amber-200/70 text-[11px]",
                                            children: "(Use the order buttons in the rebalance table below to execute)"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-2 xl:grid-cols-5 gap-3 mb-5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$Metric, {
                        label: "Portfolio sleeve",
                        value: (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(sleeveAllocation, true)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$Metric, {
                        label: "Current allocation",
                        value: (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(data?.current_allocation, true)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$Metric, {
                        label: "Selected stocks",
                        value: `${selectedSymbols.length}/${topN ?? "\u2014"}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$Metric, {
                        label: "Ranking universe",
                        value: `${data?.universe_size ?? info.universe_size ?? data?.universe?.length ?? "\u2014"}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$Metric, {
                        label: "Next rebalance",
                        value: `${nextRebalanceLabel}${rebalanceWindowOpen ? " (Window Open)" : ""}`,
                        valueClass: rebalanceWindowOpen ? "text-amber-300 font-bold" : "text-white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-5 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-white/10 bg-black/20 px-4 py-3 text-[11px]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "h-2 w-2 rounded-full bg-neon"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-bold uppercase tracking-wider text-white/80",
                                children: "QQQ 200-day SMA regime"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${qqqAbove200Sma === true ? "border-emerald-400/30 bg-emerald-400/10 text-emerald-300" : qqqAbove200Sma === false ? "border-amber-400/30 bg-amber-400/10 text-amber-300" : "border-white/10 bg-white/5 text-muted"}`,
                                children: qqqRegime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-x-4 gap-y-1 font-mono text-white/60",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    "Close ",
                                    qqqPrice !== undefined && qqqPrice !== null ? `$${Number(qqqPrice).toFixed(2)}` : "\u2014"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    "200 SMA ",
                                    qqq200Sma !== undefined && qqq200Sma !== null ? `$${Number(qqq200Sma).toFixed(2)}` : "\u2014"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: qqqDataAsOf ? `as of ${(0, $94ad89d94b510f88$export$859fa52db42cf485)(qqqDataAsOf)}` : "data unavailable"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: requireQqqAbove200Sma ? "text-neon" : "text-white/40",
                                children: requireQqqAbove200Sma ? "Hold filter ON" : "Hold filter OFF"
                            })
                        ]
                    })
                ]
            }),
            configChangePending && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-5 rounded-xl border border-amber-400/25 bg-amber-400/10 px-4 py-3 text-xs text-amber-200",
                children: [
                    "NQMM settings changed. Targets and orders will update at the next scheduled rebalance, using the prior trading session's close.",
                    nextRebalanceAt ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "ml-1 font-semibold text-amber-100",
                        children: [
                            "Next rebalance: ",
                            (0, $94ad89d94b510f88$export$d68f5a36fb886d13)(nextRebalanceAt),
                            "."
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb-5 rounded-2xl border border-white/10 bg-black/20 overflow-hidden text-[11px]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "px-4 py-3 border-b border-white/10 flex items-center justify-between gap-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiXj7.default), {
                                        size: 16,
                                        className: "text-neon"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                        children: "Current positions"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "text-[10px] text-muted uppercase tracking-wider",
                                children: [
                                    currentPositionRows.length,
                                    " open",
                                    hasPortfolioSnapshot ? portfolioPositions?.data?.stale ? " \xb7 stale" : "" : " \xb7 strategy snapshot"
                                ]
                            })
                        ]
                    }),
                    currentPositionRows.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "px-4 py-4 text-xs text-muted",
                        children: "No current NQMM positions reported. Previous-position corrections remain observational and do not place orders."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-1.5 p-2",
                        children: currentPositionRows.map(({ symbol: symbol, quantity: quantity })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "rounded-lg border border-white/10 bg-white/5 px-2.5 py-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center justify-between gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-[11px] font-semibold tracking-tight text-white",
                                                children: symbol
                                            }),
                                            previousPositionSymbols.has(symbol.toUpperCase()) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "rounded bg-neon/10 px-1 py-0.5 text-[8px] font-bold uppercase tracking-wider text-neon",
                                                children: "History"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mt-0.5 text-[10px] text-muted",
                                        children: [
                                            quantity,
                                            " shares"
                                        ]
                                    })
                                ]
                            }, symbol))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid-cols-1 xl:grid-cols-[1fr_1.5fr] gap-4 mb-5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "min-w-0 p-4 rounded-2xl bg-white/5 border border-white/10 space-y-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-col gap-3 border-b border-white/10 pb-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex min-w-0 items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p-1.5 rounded-lg bg-emerald-500/10 text-emerald-400",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiXj7.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "truncate text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Strategy information"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex w-full flex-wrap items-center gap-1.5",
                                        children: [
                                            data.config_source && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setShowConfigModal(true),
                                                title: data.config_source === "USER" ? "Open saved user configuration" : "Open system default configuration",
                                                className: "inline-flex min-w-0 flex-1 items-center justify-center gap-1 rounded-md border border-white/10 bg-white/5 px-2 py-1.5 text-[9px] font-bold uppercase tracking-wider text-muted hover:bg-white/10 hover:text-white sm:flex-none",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fkh1V.default), {
                                                        className: "h-3.5 w-3.5 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: data.config_source === "USER" ? "User config" : "Defaults"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                onClick: openHistoryModal,
                                                title: "Correct the previous ten NQMM position records",
                                                className: "inline-flex min-w-0 flex-1 items-center justify-center gap-1 rounded-md border border-white/10 bg-white/5 px-2 py-1.5 text-[9px] font-bold uppercase tracking-wider text-muted hover:bg-white/10 hover:text-white sm:flex-none",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSlX2.default), {
                                                        className: "h-3.5 w-3.5 shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "Correct 10"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                role: "switch",
                                                "aria-checked": semiAutomaticSetting,
                                                "aria-busy": semiAutomaticSaving,
                                                onClick: handleSemiAutomaticToggle,
                                                disabled: semiAutomaticSaving,
                                                title: semiAutomaticSetting ? "Semi-automatic: review each NQMM order before submitting" : "Automatic: NQMM may submit rebalance orders on schedule",
                                                className: "inline-flex min-w-0 flex-1 items-center justify-center gap-1.5 rounded-md border border-white/10 bg-white/5 px-2 py-1.5 text-[9px] font-bold uppercase tracking-wider text-muted transition hover:bg-white/10 hover:text-white disabled:cursor-wait disabled:opacity-70 sm:flex-none",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: semiAutomaticSetting ? "text-neon" : "text-amber-300",
                                                        children: semiAutomaticSaving ? "Saving\u2026" : semiAutomaticSetting ? "Semi-auto" : "Automatic"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `relative h-3.5 w-6 shrink-0 rounded-full transition ${semiAutomaticSetting ? "bg-neon/70" : "bg-white/20"}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: `absolute top-0.5 h-2.5 w-2.5 rounded-full bg-white transition ${semiAutomaticSetting ? "left-3" : "left-0.5"}`
                                                        })
                                                    }),
                                                    semiAutomaticSaving && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                        className: "h-3 w-3 shrink-0 animate-spin text-amber-300"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "text-[11px] text-muted leading-relaxed",
                                children: [
                                    "Long-only cross-sectional momentum across the configured Nasdaq-100 universe. It uses a ",
                                    lookbackMonths ?? "\u2014",
                                    "-month lookback, skips ",
                                    skipRecentMonths ?? "\u2014",
                                    " recent months, and selects ",
                                    requirePositiveMomentum ? "positive-momentum " : "eligible ",
                                    "names using capped ",
                                    sizingLabel.toLowerCase(),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "grid grid-cols-1 gap-x-5 gap-y-2 text-[11px] sm:grid-cols-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Portfolio sleeve",
                                        value: (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(sleeveAllocation, true)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Cash buffer",
                                        value: (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(cashBuffer, true)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Selected stocks",
                                        value: `${selectedSymbols.length} / ${topN ?? "\u2014"}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Max per stock",
                                        value: (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(maxPositionAllocation, true)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Lookback",
                                        value: `${lookbackMonths ?? "\u2014"} months`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Skip recent",
                                        value: skipRecentMonths === 0 ? "None" : `${skipRecentMonths ?? "\u2014"} month${skipRecentMonths === 1 ? "" : "s"}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Trading days / month",
                                        value: `${tradingDaysPerMonth ?? "\u2014"}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Sizing",
                                        value: sizingLabel
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Vol window",
                                        value: `${data.volatility_lookback_months ?? info.volatility_lookback_months ?? "\u2014"} months`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Min momentum",
                                        value: (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(minMomentum)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Positive momentum",
                                        value: requirePositiveMomentum ? "Required" : "Allowed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Schedule",
                                        value: `${data.effective_rebalance_frequency || info.effective_rebalance_frequency || data.rebalance_frequency || info.rebalance_frequency || "monthly"} \xb7 last working day \xb7 ${(0, $94ad89d94b510f88$export$9e1dd5059e1fa82)(rebalanceTime)}${rebalanceTime?.startsWith("15:00") ? " \xb7 1h before close" : ""}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "QQQ regime",
                                        value: `${qqqRegime}${data.qqq_price && data.qqq_200_sma ? ` \xb7 $${Number(data.qqq_price).toFixed(2)} / $${Number(data.qqq_200_sma).toFixed(2)}` : ""}`,
                                        valueClass: qqqAbove200Sma === false ? "text-amber-300" : qqqAbove200Sma === true ? "text-emerald-300" : "text-muted"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "QQQ hold filter",
                                        value: requireQqqAbove200Sma ? "Only above 200 SMA" : "Off"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Rebalance cadence",
                                        value: "Month end only"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Execution",
                                        value: semiAutomatic ? "Semi-auto \xb7 order buttons" : "Automatic",
                                        valueClass: semiAutomatic ? "text-neon" : "text-amber-300"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Next action",
                                        value: nextRebalanceLabel,
                                        valueClass: configChangePending ? "text-amber-300" : "text-white/80"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "History requests",
                                        value: `${maxConcurrentHistoryRequests ?? "\u2014"} at a time`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Last run",
                                        value: (0, $94ad89d94b510f88$export$d68f5a36fb886d13)(data.last_rebalance_date || info.last_rebalance_date)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Rebalance status",
                                        value: rebalanceStatus,
                                        valueClass: rebalanceStatus === "ERROR" ? "text-rose-300" : "text-emerald-300"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Momentum data",
                                        value: rankingStatus,
                                        valueClass: rankingStatus === "ERROR" ? "text-rose-300" : rankingStatus === "RUNNING" ? "text-amber-300" : "text-emerald-300"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Momentum close",
                                        value: data.ranking_data_as_of ? (0, $94ad89d94b510f88$export$859fa52db42cf485)(data.ranking_data_as_of) : (0, $94ad89d94b510f88$export$d68f5a36fb886d13)(data.last_ranking_at)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d36af3c0ee385315$var$InfoRow, {
                                        label: "Cash buffer",
                                        value: (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(data.cash_buffer, true)
                                    })
                                ]
                            }),
                            data.rebalance_error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "rounded-lg border border-rose-400/20 bg-rose-400/5 px-3 py-2 text-[11px] text-rose-300",
                                children: data.rebalance_error
                            }),
                            semiAutomaticError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "rounded-lg border border-rose-400/20 bg-rose-400/5 px-3 py-2 text-[11px] text-rose-300",
                                children: semiAutomaticError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "rounded-2xl border border-white/10 bg-black/20 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "px-4 py-3 border-b border-white/10 flex items-center justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c62dd403424a2a8$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "text-neon"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "text-xs font-bold uppercase tracking-wider text-white/90",
                                                children: "Nasdaq momentum"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "text-[10px] text-muted uppercase tracking-wider",
                                                children: showAllRankings ? `${rankings.length} stocks` : `Top ${data.top_n ?? info.top_n ?? "\u2014"}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                onClick: refreshNQMMStatus,
                                                disabled: rankingRefreshLoading,
                                                "aria-busy": rankingRefreshLoading,
                                                "aria-label": "Refresh Nasdaq momentum rankings",
                                                title: "Reload the latest Nasdaq momentum snapshot",
                                                className: "inline-flex items-center gap-1 rounded-md border border-white/10 bg-white/5 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-muted hover:bg-white/10 hover:text-white disabled:cursor-wait disabled:opacity-60",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bTepa.default), {
                                                        size: 13,
                                                        className: rankingRefreshLoading ? "animate-spin" : ""
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "hidden sm:inline",
                                                        children: rankingRefreshLoading ? "Refreshing" : "Refresh"
                                                    })
                                                ]
                                            }),
                                            rankings.length > 25 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>setShowAllRankings((current)=>!current),
                                                "aria-expanded": showAllRankings,
                                                className: "inline-flex items-center gap-1 rounded-md border border-white/10 bg-white/5 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-muted hover:bg-white/10 hover:text-white",
                                                children: [
                                                    showAllRankings ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fpYe5.default), {
                                                        size: 13
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Plhc.default), {
                                                        size: 13
                                                    }),
                                                    showAllRankings ? "Collapse" : "Show all"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "max-h-[70vh] overflow-y-auto ux-scrollbar",
                                children: displayedRankings.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "px-4 py-10 text-center text-xs text-muted",
                                    children: rankingStatus === "RUNNING" ? "Refreshing completed daily momentum data\u2026" : data.ranking_error || (enabled ? "Waiting for the daily momentum snapshot." : "No ranking snapshot yet \u2014 the shared history backfill may still be running.")
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    className: "w-full text-xs",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            className: "sticky top-0 bg-[#111827] text-[10px] uppercase tracking-wider text-muted",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "px-4 py-2 text-left",
                                                        children: "Rank"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "px-4 py-2 text-left",
                                                        children: "Symbol"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        children: "Momentum"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        children: "Volatility"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        title: "Indicative targets based on the current ranking; actual trades use approved rebalance targets",
                                                        children: "Indicative %"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        children: "Indicative shares"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        children: "Position shares"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "px-4 py-2 text-right",
                                                        children: "Indicative change"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: displayedRankings.map((row)=>{
                                                const quantity = hasPortfolioSnapshot ? positions[row.symbol.toUpperCase()] ?? 0 : row.position?.shares ?? (managedSymbols.has(row.symbol.toUpperCase()) ? positions[row.symbol] : 0) ?? 0;
                                                const targetQuantity = row.indicative_target_quantity ?? row.target_quantity ?? data.target_positions?.[row.symbol] ?? 0;
                                                const quantityChange = Number(targetQuantity) - Number(quantity);
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    className: `${row.selected ? "bg-emerald-400/10" : ""} border-t border-white/5`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-4 py-2 font-mono text-muted",
                                                            children: row.rank ?? "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-4 py-2 font-bold text-white",
                                                            children: row.symbol
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: `px-4 py-2 text-right font-mono ${Number(row.momentum) >= 0 ? "text-emerald-300" : "text-rose-300"}`,
                                                            children: row.ranking_status === "INSUFFICIENT_HISTORY" ? "No history" : (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(row.momentum)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-4 py-2 text-right font-mono text-white/70",
                                                            children: (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(row.realized_volatility)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-4 py-2 text-right font-mono text-white/70",
                                                            children: (0, $94ad89d94b510f88$export$e7c2806c498ca04c)(row.indicative_target_allocation ?? row.target_allocation)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-4 py-2 text-right font-mono text-white/70",
                                                            children: targetQuantity
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "px-4 py-2 text-right font-mono text-white/70",
                                                            children: quantity
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: `px-4 py-2 text-right font-mono ${quantityChange > 0 ? "text-emerald-300" : quantityChange < 0 ? "text-rose-300" : "text-white/50"}`,
                                                            children: (0, $94ad89d94b510f88$export$88014ce576d8bf84)(quantityChange)
                                                        })
                                                    ]
                                                }, row.symbol);
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-5",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fcff60eb004bfbb5$export$2e2bcd8739ae039), {
                    title: "Rebalance to target",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $76d71077487353ea$export$2e2bcd8739ae039), {
                        size: 16,
                        className: "text-neon"
                    }),
                    candidates: rebalanceCandidates,
                    rebalanceWindowOpen: rebalanceWindowOpen && rebalanceTargetsReady
                })
            }),
            showConfigModal && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9qjJe.default), {
                isOpen: showConfigModal,
                onClose: ()=>setShowConfigModal(false),
                title: "NQMM Strategy Setup",
                width: "max-w-5xl",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8a9d9ff69f432e4$export$2e2bcd8739ae039), {
                    strategyName: "NQMM",
                    readOnly: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $074ab7f992860515$export$2e2bcd8739ae039), {
                isOpen: showHistoryModal,
                onClose: ()=>setShowHistoryModal(false),
                historyLoading: historyLoading,
                historyError: historyError,
                submittingSymbol: submittingSymbol,
                previousPositions: previousPositions,
                currentPositions: currentPositions,
                addPreviousPosition: addPreviousPosition,
                deletePreviousPosition: deletePreviousPosition
            })
        ]
    });
};
const $d36af3c0ee385315$var$Metric = ({ label: label, value: value, valueClass: valueClass = "text-white" })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "p-3 rounded-xl bg-white/5 border border-white/10 min-w-0",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-[10px] uppercase tracking-wider font-bold text-muted mb-1",
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `text-sm font-semibold truncate ${valueClass}`,
                title: value,
                children: value
            })
        ]
    });
const $d36af3c0ee385315$var$InfoRow = ({ label: label, value: value, valueClass: valueClass = "text-white/80" })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex min-w-0 items-center justify-between gap-2 border-b border-white/5 py-1.5",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "min-w-0 truncate text-muted",
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: `min-w-0 truncate font-mono text-right ${valueClass}`,
                title: value,
                children: value
            })
        ]
    });
var $d36af3c0ee385315$export$2e2bcd8739ae039 = $d36af3c0ee385315$var$NQMMStrategyContent;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kTCPA = parcelRequire("kTCPA");
var $2Kpom = parcelRequire("2Kpom");
const $510383d360d7e23a$var$HydrationStatus = ({ hydrated: hydrated, enabled: enabled, strategyName: strategyName })=>{
    if (!enabled) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5 border border-white/5 shadow-inner",
        children: hydrated ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kTCPA.default), {
                    size: 12,
                    className: "text-emerald-400"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "text-[10px] font-bold text-emerald-400 uppercase tracking-tight",
                    children: [
                        strategyName,
                        " Hydrated"
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Kpom.default), {
                    size: 12,
                    className: "text-amber-400 animate-spin-slow"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "text-[10px] font-bold text-amber-400 uppercase tracking-tight",
                    children: [
                        strategyName,
                        " Hydrating..."
                    ]
                })
            ]
        })
    });
};
var $510383d360d7e23a$export$2e2bcd8739ae039 = $510383d360d7e23a$var$HydrationStatus;




var $jtEPT = parcelRequire("jtEPT");

var $hwNGq = parcelRequire("hwNGq");
const $403b440ebfd250ba$var$StrategyStatus = ({ className: className = '' })=>{
    const [activeTab, setActiveTab] = (0, $acw62.useState)("ORB");
    const pollingOptions = (strategy)=>({
            pollingInterval: activeTab === strategy ? 10000 : 60000,
            skipPollingIfUnfocused: true
        });
    const onQuery = (0, $jtEPT.useStrategyStatusQuery)('ON', pollingOptions('ON'));
    const orbQuery = (0, $jtEPT.useStrategyStatusQuery)('ORB', pollingOptions('ORB'));
    const dtQuery = (0, $jtEPT.useStrategyStatusQuery)('DT', pollingOptions('DT'));
    const nqmmQuery = (0, $jtEPT.useStrategyStatusQuery)('NQMM', pollingOptions('NQMM'));
    const morbQuery = (0, $jtEPT.useStrategyStatusQuery)('MORB', pollingOptions('MORB'));
    const [onStatus, setOnStatus] = (0, $acw62.useState)(null);
    const [orbStatusState, setOrbStatusState] = (0, $acw62.useState)(null);
    const [dtStatus, setDtStatus] = (0, $acw62.useState)(null);
    const [nqmmStatus, setNqmmStatus] = (0, $acw62.useState)(null);
    const [nqmmRefreshLoading, setNqmmRefreshLoading] = (0, $acw62.useState)(false);
    const [morbStatus, setMorbStatus] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [strategyToggleLoading, setStrategyToggleLoading] = (0, $acw62.useState)({});
    const pendingStrategyTargets = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    const strategyToggleLoadingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    const loading = onQuery.isLoading || orbQuery.isLoading || dtQuery.isLoading || nqmmQuery.isLoading || morbQuery.isLoading;
    const queryError = onQuery.error || orbQuery.error || dtQuery.error || nqmmQuery.error || morbQuery.error;
    const applyPendingTarget = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((strategyName, status)=>{
        const pendingEnabled = pendingStrategyTargets.current[strategyName];
        if (pendingEnabled === undefined) return status;
        return {
            ...status,
            data: {
                ...status.data,
                enabled: pendingEnabled
            }
        };
    }, []);
    const setToggleLoadingForStrategy = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((strategyName, action)=>{
        strategyToggleLoadingRef.current = {
            ...strategyToggleLoadingRef.current
        };
        if (action) strategyToggleLoadingRef.current[strategyName] = action;
        else delete strategyToggleLoadingRef.current[strategyName];
        setStrategyToggleLoading(strategyToggleLoadingRef.current);
    }, []);
    const fetchData = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        setError(null);
        try {
            const [onStatusData, orbStatusData, dtStatusData, nqmmStatusData, morbStatusData] = await Promise.all([
                onQuery.refetch().unwrap(),
                orbQuery.refetch().unwrap(),
                dtQuery.refetch().unwrap(),
                nqmmQuery.refetch().unwrap(),
                morbQuery.refetch().unwrap()
            ]);
            setOnStatus(applyPendingTarget("ON", onStatusData));
            setOrbStatusState(applyPendingTarget("ORB", orbStatusData));
            setDtStatus(applyPendingTarget("DT", dtStatusData));
            setNqmmStatus(applyPendingTarget("NQMM", nqmmStatusData));
            setMorbStatus(applyPendingTarget("MORB", morbStatusData));
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to fetch strategy data");
        }
    }, [
        applyPendingTarget,
        dtQuery,
        morbQuery,
        nqmmQuery,
        onQuery,
        orbQuery
    ]);
    const refreshNQMMStatus = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        setNqmmRefreshLoading(true);
        setError(null);
        try {
            const status = await nqmmQuery.refetch().unwrap();
            setNqmmStatus(applyPendingTarget("NQMM", status));
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to refresh Nasdaq momentum");
        } finally{
            setNqmmRefreshLoading(false);
        }
    }, [
        applyPendingTarget,
        nqmmQuery
    ]);
    const updateStrategyEnabled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((strategyName, enabled)=>{
        const updater = (prev)=>prev ? {
                ...prev,
                data: {
                    ...prev.data,
                    enabled: Boolean(enabled)
                }
            } : prev;
        if (strategyName === "ORB") setOrbStatusState(updater);
        else if (strategyName === "DT") setDtStatus(updater);
        else if (strategyName === "NQMM") setNqmmStatus(updater);
        else if (strategyName === "MORB") setMorbStatus(updater);
        else setOnStatus(updater);
    }, []);
    const handleStrategyToggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (strategyName, currentlyEnabled)=>{
        if (strategyToggleLoadingRef.current[strategyName]) return;
        const newState = !currentlyEnabled;
        pendingStrategyTargets.current[strategyName] = newState;
        setToggleLoadingForStrategy(strategyName, newState ? "starting" : "pausing");
        updateStrategyEnabled(strategyName, newState);
        try {
            const response = await (0, $2wVnk.tradingApi).setStrategyEnabled(strategyName, newState);
            if (!response.success) throw new Error(response.message || `Failed to update ${strategyName} strategy state`);
            await fetchData();
            updateStrategyEnabled(strategyName, newState);
        } catch (err) {
            setError(err instanceof Error ? err.message : `Failed to update ${strategyName} strategy state`);
            delete pendingStrategyTargets.current[strategyName];
            updateStrategyEnabled(strategyName, currentlyEnabled);
        } finally{
            delete pendingStrategyTargets.current[strategyName];
            setToggleLoadingForStrategy(strategyName, null);
        }
    }, [
        fetchData,
        setToggleLoadingForStrategy,
        updateStrategyEnabled
    ]);
    const strategySummaries = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            {
                name: "ORB",
                enabled: orbStatusState?.data?.enabled
            },
            {
                name: "DT",
                enabled: dtStatus?.data?.enabled
            },
            {
                name: "ON",
                enabled: onStatus?.data?.enabled
            },
            {
                name: "NQMM",
                enabled: nqmmStatus?.data?.enabled
            },
            {
                name: "MORB",
                enabled: morbStatus?.data?.enabled
            }
        ], [
        dtStatus?.data?.enabled,
        morbStatus?.data?.enabled,
        nqmmStatus?.data?.enabled,
        onStatus?.data?.enabled,
        orbStatusState?.data?.enabled
    ]);
    const runningCount = strategySummaries.filter((strategy)=>strategy.enabled).length;
    const pausedCount = strategySummaries.length - runningCount;
    const activeStatus = activeTab === "ON" ? onStatus?.data : activeTab === "DT" ? dtStatus?.data : activeTab === "NQMM" ? nqmmStatus?.data : activeTab === "MORB" ? morbStatus?.data : orbStatusState?.data;
    (0, $acw62.useEffect)(()=>{
        if (onQuery.data) setOnStatus(applyPendingTarget('ON', onQuery.data));
        if (orbQuery.data) setOrbStatusState(applyPendingTarget('ORB', orbQuery.data));
        if (dtQuery.data) setDtStatus(applyPendingTarget('DT', dtQuery.data));
        if (nqmmQuery.data) setNqmmStatus(applyPendingTarget('NQMM', nqmmQuery.data));
        if (morbQuery.data) setMorbStatus(applyPendingTarget('MORB', morbQuery.data));
    }, [
        applyPendingTarget,
        dtQuery.data,
        morbQuery.data,
        nqmmQuery.data,
        onQuery.data,
        orbQuery.data
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleRefresh = ()=>fetchData();
        window.addEventListener('trading-data-refresh', handleRefresh);
        return ()=>window.removeEventListener('trading-data-refresh', handleRefresh);
    }, [
        fetchData
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `panel full-bleed-panel flex min-h-0 w-full flex-col ${className}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex shrink-0 flex-col gap-4 border-b border-white/10 px-6 py-5 sm:flex-row sm:items-center sm:justify-between",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "p-2 rounded-lg bg-neon/10 text-neon",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa7706f9ee0421dc$export$2e2bcd8739ae039), {
                                className: "w-5 h-5"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-y-0.5",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "text-lg font-bold text-white tracking-tight",
                                    children: "Strategy Oversight"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "text-xs text-muted",
                                    children: "Real-time signal analysis and lifecycle control"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeTabBar), {
                "aria-label": "Strategy sections",
                children: [
                    "ORB",
                    "DT",
                    "ON",
                    "NQMM",
                    "MORB"
                ].map((tab)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kvv04.ThemeButton), {
                        "aria-pressed": activeTab === tab,
                        variant: activeTab === tab ? 'secondary' : 'ghost',
                        size: "sm",
                        onClick: ()=>setActiveTab(tab),
                        children: tab
                    }, tab))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex min-h-0 flex-1 flex-col p-5",
                children: [
                    loading && !(onStatus && onStatus.data) && !(orbStatusState && orbStatusState.data) && !(dtStatus && dtStatus.data) && !(nqmmStatus && nqmmStatus.data) && !(morbStatus && morbStatus.data) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center py-8",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Zl6K.default), {
                            size: "lg"
                        })
                    }),
                    (error || queryError && !(onStatus || orbStatusState || dtStatus || nqmmStatus || morbStatus)) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iqWry.default), {
                        error: error || 'Failed to fetch strategy data',
                        onRetry: ()=>fetchData(),
                        message: "Failed to load strategy data"
                    }),
                    onStatus || orbStatusState || dtStatus || nqmmStatus || morbStatus ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "space-y-4 text-foreground",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-4 mb-1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-success-500/10 border border-success-500/20 text-success-400",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-[10px] uppercase font-black tracking-wider",
                                                        children: "Running"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "min-w-5 h-5 px-1 rounded-full bg-success-500/20 text-center text-xs font-black leading-5",
                                                        children: runningCount
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-white/60",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "text-[10px] uppercase font-black tracking-wider",
                                                        children: "Paused"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "min-w-5 h-5 px-1 rounded-full bg-white/10 text-center text-xs font-black leading-5",
                                                        children: pausedCount
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `h-2 w-2 rounded-full ${strategyToggleLoading.ORB ? "bg-warning-500 animate-pulse" : orbStatusState?.data?.enabled ? "bg-success-500 animate-pulse" : "bg-white/30"}`
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "uppercase text-xs font-bold text-white/70",
                                                        children: "ORB"
                                                    }),
                                                    strategyToggleLoading.ORB && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                        className: "h-3 w-3 animate-spin text-warning-500"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `h-2 w-2 rounded-full ${strategyToggleLoading.DT ? "bg-warning-500 animate-pulse" : dtStatus?.data?.enabled ? "bg-success-500 animate-pulse" : "bg-white/30"}`
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "uppercase text-xs font-bold text-white/70",
                                                        children: "DT"
                                                    }),
                                                    strategyToggleLoading.DT && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                        className: "h-3 w-3 animate-spin text-warning-500"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `h-2 w-2 rounded-full ${strategyToggleLoading.ON ? "bg-warning-500 animate-pulse" : onStatus?.data?.enabled ? "bg-success-500 animate-pulse" : "bg-white/30"}`
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "uppercase text-xs font-bold text-white/70",
                                                        children: "ON"
                                                    }),
                                                    strategyToggleLoading.ON && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                        className: "h-3 w-3 animate-spin text-warning-500"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `h-2 w-2 rounded-full ${strategyToggleLoading.NQMM ? "bg-warning-500 animate-pulse" : nqmmStatus?.data?.enabled ? "bg-success-500 animate-pulse" : "bg-white/30"}`
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "uppercase text-xs font-bold text-white/70",
                                                        children: "NQMM"
                                                    }),
                                                    strategyToggleLoading.NQMM && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                        className: "h-3 w-3 animate-spin text-warning-500"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2 px-2 py-1 rounded-full bg-white/5",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `h-2 w-2 rounded-full ${strategyToggleLoading.MORB ? "bg-warning-500 animate-pulse" : morbStatus?.data?.enabled ? "bg-success-500 animate-pulse" : "bg-white/30"}`
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "uppercase text-xs font-bold text-white/70",
                                                        children: "MORB"
                                                    }),
                                                    strategyToggleLoading.MORB && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                                                        className: "h-3 w-3 animate-spin text-warning-500"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    activeStatus && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `flex items-center gap-2 rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide ${activeStatus.runtime_stale ? "border-warning-500/25 bg-warning-500/10 text-warning-500" : "border-info-500/20 bg-info-500/10 text-info-500"}`,
                                        title: activeStatus.runtime_synced_at ? `Trading engine snapshot: ${activeStatus.runtime_synced_at}` : "Status is served by this trading engine process",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `h-1.5 w-1.5 rounded-full ${activeStatus.runtime_stale ? "bg-warning-500" : "bg-info-500 animate-pulse"}`
                                            }),
                                            activeStatus.runtime_stale ? "Engine sync delayed" : "Engine synced"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 ml-auto",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $510383d360d7e23a$export$2e2bcd8739ae039), {
                                                enabled: orbStatusState?.data?.enabled,
                                                hydrated: orbStatusState?.data?.hydrated,
                                                strategyName: "ORB"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $510383d360d7e23a$export$2e2bcd8739ae039), {
                                                enabled: dtStatus?.data?.enabled,
                                                hydrated: dtStatus?.data?.hydrated,
                                                strategyName: "DT"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $510383d360d7e23a$export$2e2bcd8739ae039), {
                                                enabled: onStatus?.data?.enabled,
                                                hydrated: onStatus?.data?.hydrated,
                                                strategyName: "ON"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $510383d360d7e23a$export$2e2bcd8739ae039), {
                                                enabled: nqmmStatus?.data?.enabled,
                                                hydrated: nqmmStatus?.data?.hydrated,
                                                strategyName: "NQMM"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $510383d360d7e23a$export$2e2bcd8739ae039), {
                                                enabled: morbStatus?.data?.enabled,
                                                hydrated: morbStatus?.data?.hydrated,
                                                strategyName: "MORB"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            activeStatus && /*#__PURE__*/ (0, $ayMG0.jsx)($403b440ebfd250ba$var$StrategyOverview, {
                                strategy: activeTab,
                                status: activeStatus
                            }),
                            activeStatus && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa65f0128508696a$export$2e2bcd8739ae039), {
                                status: activeStatus
                            }),
                            activeTab === "ORB" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $043e45dd87bbf767$export$2e2bcd8739ae039), {
                                orbStatusState: orbStatusState,
                                handleStrategyToggle: handleStrategyToggle,
                                strategyToggleLoading: strategyToggleLoading
                            }),
                            activeTab === "DT" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $405b868a9af90f76$export$2e2bcd8739ae039), {
                                dtStatus: dtStatus,
                                handleStrategyToggle: handleStrategyToggle,
                                strategyToggleLoading: strategyToggleLoading
                            }),
                            activeTab === "ON" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8edc0845c31b7212$export$2e2bcd8739ae039), {
                                onStatus: onStatus,
                                handleStrategyToggle: handleStrategyToggle,
                                strategyToggleLoading: strategyToggleLoading
                            }),
                            activeTab === "NQMM" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d36af3c0ee385315$export$2e2bcd8739ae039), {
                                nqmmStatus: nqmmStatus,
                                handleStrategyToggle: handleStrategyToggle,
                                strategyToggleLoading: strategyToggleLoading,
                                refreshNQMMStatus: refreshNQMMStatus,
                                rankingRefreshLoading: nqmmRefreshLoading
                            }),
                            activeTab === "MORB" && /*#__PURE__*/ (0, $ayMG0.jsx)($403b440ebfd250ba$var$ManagedORBOverview, {
                                status: morbStatus,
                                handleStrategyToggle: handleStrategyToggle,
                                strategyToggleLoading: strategyToggleLoading
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
const $403b440ebfd250ba$var$StrategyOverview = ({ strategy: strategy, status: status })=>{
    const description = (0, $hwNGq.getStrategyDescription)(strategy);
    const symbols = status.active_symbols?.length ? status.active_symbols : status.managed_symbols || [];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "rounded-2xl border border-neon/15 bg-neon/[0.04] px-4 py-3.5 sm:px-5",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "text-[10px] font-black uppercase tracking-[0.18em] text-neon",
                                    children: "Strategy overview"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rounded-full border border-white/10 bg-white/5 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white/60",
                                    children: description.label
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mt-2 max-w-4xl text-sm leading-relaxed text-white/75",
                            children: description.overview
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "shrink-0 text-left text-[10px] text-white/45 sm:text-right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "font-bold uppercase tracking-wider text-white/60",
                            children: "Tracked symbols"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt-1 max-w-[260px] sm:max-w-[320px]",
                            children: symbols.length ? symbols.join(', ') : 'None currently reported'
                        })
                    ]
                })
            ]
        })
    });
};
const $403b440ebfd250ba$var$ManagedORBOverview = ({ status: status, handleStrategyToggle: handleStrategyToggle, strategyToggleLoading: strategyToggleLoading })=>{
    const enabled = status?.data?.enabled;
    const toggleState = strategyToggleLoading.MORB;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex flex-col gap-3 rounded-2xl border border-white/10 bg-white/[0.025] px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "text-sm font-bold text-white",
                        children: "Managed ORB control"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mt-1 text-xs leading-relaxed text-muted",
                        children: "Configure selected symbols, entry quality gates, staged stops, and T+3 reductions from the Managed ORB page."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                onClick: ()=>void handleStrategyToggle('MORB', enabled),
                disabled: Boolean(toggleState),
                className: `inline-flex h-9 shrink-0 items-center justify-center gap-2 rounded-xl border px-4 text-[10px] font-black uppercase tracking-widest transition disabled:cursor-not-allowed disabled:opacity-50 ${enabled ? 'border-warning-500/30 bg-warning-500/10 text-warning-500 hover:bg-warning-500/20' : 'border-neon/30 bg-neon/10 text-neon hover:bg-neon/20'}`,
                children: [
                    toggleState && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Yp7M.default), {
                        className: "h-3.5 w-3.5 animate-spin"
                    }),
                    toggleState ? toggleState === 'starting' ? "Starting\u2026" : "Pausing\u2026" : enabled ? 'Pause strategy' : 'Start strategy'
                ]
            })
        ]
    });
};
var $403b440ebfd250ba$export$2e2bcd8739ae039 = $403b440ebfd250ba$var$StrategyStatus;


const $bb1467a6a85beade$export$987dd53eec1f61cf = (nodeEnvironment)=>nodeEnvironment !== "production";
const $bb1467a6a85beade$export$b570d1d3dcedde62 = (hostname)=>hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
const $bb1467a6a85beade$var$runtimeNodeEnvironment = typeof process === 'undefined' ? undefined : process.env?.NODE_ENV;
const $bb1467a6a85beade$var$runtimeLocation = typeof window === 'undefined' ? undefined : window.location;
const $bb1467a6a85beade$export$44b010f4f4d8063 = $bb1467a6a85beade$var$runtimeNodeEnvironment ? $bb1467a6a85beade$export$987dd53eec1f61cf($bb1467a6a85beade$var$runtimeNodeEnvironment) : $bb1467a6a85beade$export$b570d1d3dcedde62($bb1467a6a85beade$var$runtimeLocation?.hostname ?? '');



const $2abb2f023fad02d4$var$ControlPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("itzRU")));

const $2abb2f023fad02d4$var$TradeLogPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("rViNl")));

const $2abb2f023fad02d4$var$Backtester = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("k2dSa")));

const $2abb2f023fad02d4$var$OptimizationResultsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("g2DAj")));

const $2abb2f023fad02d4$var$BacktestDashboard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("1JNaZ")));

const $2abb2f023fad02d4$var$SharedBacktestsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("e9VH6")));

const $2abb2f023fad02d4$var$DataPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("9SjZD")));

const $2abb2f023fad02d4$var$PositionsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("2Bjzh")));

const $2abb2f023fad02d4$var$ManagedORBPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("6fN4Y")));

const $2abb2f023fad02d4$var$PortfolioPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("8EkpO")));

const $2abb2f023fad02d4$var$PortfolioHistoryPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("e83Ha")));

const $2abb2f023fad02d4$var$AdminPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("9ONAt")));

const $2abb2f023fad02d4$var$AdminLogsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("f0rfV")));

const $2abb2f023fad02d4$var$DevComponentsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("7dI3I")));
const $2abb2f023fad02d4$var$pageLoadingFallback = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
    className: "flex min-h-[40vh] items-center justify-center",
    role: "status",
    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "text-sm text-muted",
        children: "Loading page\u2026"
    })
});
const $2abb2f023fad02d4$var$AppRoutes = ({ user: user, userContext: userContext, systemStatus: systemStatus, editingOrder: editingOrder, onEditingOrderChange: onEditingOrderChange })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
        fallback: $2abb2f023fad02d4$var$pageLoadingFallback,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex min-h-[calc(100vh-5rem)] w-full flex-col gap-0 px-0 py-0",
                        children: [
                            user?.role === 'investor' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7fbca3b5910df173$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "grid grid-cols-1 gap-0 lg:grid-cols-3 lg:auto-rows-fr",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `flex flex-col gap-0 lg:h-full ${user?.role === 'investor' ? 'lg:col-span-3' : 'lg:col-span-2'}`,
                                        children: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b80c7f69ff3fe88$export$2e2bcd8739ae039), {
                                            isConnected: !!systemStatus?.data?.ib_connected
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7bcc54e85b36e52$export$2e2bcd8739ae039), {})
                                    }),
                                    user?.role !== 'investor' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "flex flex-col gap-0 lg:h-full lg:border-l lg:border-white/10",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b6f36562471e94f$export$2e2bcd8739ae039), {
                                            editingOrder: editingOrder,
                                            onCancelEditing: ()=>onEditingOrderChange(null),
                                            onOrderModified: ()=>onEditingOrderChange(null)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex min-h-0 flex-1 flex-col gap-0",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cca2f94cfcbe1305$export$2e2bcd8739ae039), {
                                        className: "min-h-[560px] flex-1",
                                        onEditOrder: onEditingOrderChange
                                    }),
                                    user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $14cc9ec74b1dced6$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $403b440ebfd250ba$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            user?.role !== 'investor' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d093e3c912a4830$export$2e2bcd8739ae039), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/control",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$ControlPage, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/trades",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$TradeLogPage, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/analysis",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/strategies",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex min-h-[calc(100vh-5rem)] w-full flex-col gap-0 px-0 py-0",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "panel full-bleed-panel page-heading",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                        className: "flex items-center gap-2 text-2xl font-bold tracking-tight text-white",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa7706f9ee0421dc$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-neon"
                                            }),
                                            "Strategies"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "text-sm text-muted",
                                        children: "Live status, monthly momentum rankings, and settings for ON, ORB, DT, and NQMM. Managed ORB has a dedicated workspace."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $403b440ebfd250ba$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "panel full-bleed-panel",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "page-heading",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "text-lg font-bold tracking-tight text-white",
                                            children: "Configuration"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-0 lg:grid-cols-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8a9d9ff69f432e4$export$2e2bcd8739ae039), {
                                                strategyName: "DT",
                                                fullBleed: true
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8a9d9ff69f432e4$export$2e2bcd8739ae039), {
                                                strategyName: "ORB",
                                                fullBleed: true
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8a9d9ff69f432e4$export$2e2bcd8739ae039), {
                                                strategyName: "ON",
                                                fullBleed: true
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8a9d9ff69f432e4$export$2e2bcd8739ae039), {
                                                strategyName: "NQMM",
                                                fullBleed: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lg:col-span-1 border-t divider-line pt-0",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68b74abbcb17504f$export$2e2bcd8739ae039), {
                                    fullBleed: true
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/backtest",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$SharedBacktestsPage, {}, user?.id) : /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$BacktestDashboard, {}, user?.id)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/data",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$DataPage, {
                        canManageSharedMarketData: userContext?.role === 'admin' || userContext?.is_superuser === true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/positions",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$PositionsPage, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/managed-orb",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$ManagedORBPage, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/backtest/:id",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$SharedBacktestsPage, {}, user?.id) : /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$Backtester, {}, user?.id)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/backtest/strategy/:strategyId",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$Backtester, {}, user?.id)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/portfolio",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$PortfolioPage, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/portfolio/history",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$PortfolioHistoryPage, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/optimization/:id",
                    element: user?.role === 'investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$OptimizationResultsPage, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/admin",
                    element: user?.role === 'admin' ? /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$AdminPage, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/admin/logs",
                    element: user?.role === 'admin' ? /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$AdminLogsPage, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "/dev/components",
                    element: (0, $bb1467a6a85beade$export$44b010f4f4d8063) ? /*#__PURE__*/ (0, $ayMG0.jsx)($2abb2f023fad02d4$var$DevComponentsPage, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/",
                        replace: true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                        to: "/",
                        replace: true
                    })
                })
            ]
        })
    });
var $2abb2f023fad02d4$export$2e2bcd8739ae039 = $2abb2f023fad02d4$var$AppRoutes;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aqBpg = parcelRequire("aqBpg");/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $f474c893b5a1302e$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CodeXml", [
    [
        "path",
        {
            d: "m18 16 4-4-4-4",
            key: "1inbqp"
        }
    ],
    [
        "path",
        {
            d: "m6 8-4 4 4 4",
            key: "15zrgr"
        }
    ],
    [
        "path",
        {
            d: "m14.5 4-5 16",
            key: "e7oirm"
        }
    ]
]);


var $8UJ0B = parcelRequire("8UJ0B");
var $1A3et = parcelRequire("1A3et");
var $hPAJY = parcelRequire("hPAJY");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

const $81f6c230720bc32f$var$gallerySections = [
    {
        id: 'theme',
        label: 'Theme & type'
    },
    {
        id: 'skeletons',
        label: 'Page skeletons'
    },
    {
        id: 'buttons',
        label: 'Buttons & variants'
    },
    {
        id: 'switches',
        label: 'Switches & toggles'
    },
    {
        id: 'tables',
        label: 'Tables'
    },
    {
        id: 'pagination',
        label: 'Pagination'
    },
    {
        id: 'sidebars',
        label: 'Sidebars'
    },
    {
        id: 'charts',
        label: 'Charts'
    },
    {
        id: 'overlays',
        label: 'Modals & popups'
    },
    {
        id: 'inventory',
        label: 'Component inventory'
    }
];
const $81f6c230720bc32f$var$DevFloatingMenu = ()=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    if (!(0, $bb1467a6a85beade$export$44b010f4f4d8063)) return null;
    const openSection = (sectionId)=>{
        setIsOpen(false);
        if (location.pathname !== '/dev/components') {
            navigate(`/dev/components#${sectionId}`);
            return;
        }
        document.getElementById(sectionId)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "fixed bottom-4 right-4 z-[80] flex flex-col items-end gap-2",
        children: [
            isOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "w-[min(20rem,calc(100vw-2rem))] overflow-hidden rounded-2xl border border-neon/25 bg-surface shadow-[0_24px_80px_rgba(0,0,0,0.65)]",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between border-b border-white/10 bg-neon/[0.06] px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "flex h-7 w-7 items-center justify-center rounded-lg border border-neon/20 bg-neon/10 text-neon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f474c893b5a1302e$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-xs font-semibold text-white",
                                                children: "Developer tools"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "text-[9px] uppercase tracking-[0.14em] text-muted",
                                                children: "Local development"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: ()=>setIsOpen(false),
                                className: "icon-action flex h-7 w-7 items-center justify-center",
                                "aria-label": "Close developer menu",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                    className: "h-3.5 w-3.5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: ()=>openSection('theme'),
                        className: "flex w-full items-center justify-between border-b border-white/10 px-4 py-3 text-left transition hover:bg-neon/[0.07]",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "flex items-center gap-2 text-xs font-semibold text-neon",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1A3et.default), {
                                        className: "h-4 w-4"
                                    }),
                                    "Theme & component gallery"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aqBpg.default), {
                                className: "h-4 w-4 text-muted"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "max-h-[min(55vh,28rem)] overflow-y-auto p-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "px-2 pb-1 pt-1 text-[9px] font-bold uppercase tracking-[0.16em] text-muted",
                                children: "Jump to section"
                            }),
                            $81f6c230720bc32f$var$gallerySections.map((section)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>openSection(section.id),
                                    className: "group flex w-full items-center justify-between rounded-lg px-2.5 py-2 text-left text-[11px] text-white/70 transition hover:bg-white/5 hover:text-white",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8UJ0B.default), {
                                                    className: "h-3.5 w-3.5 text-muted group-hover:text-neon"
                                                }),
                                                section.label
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aqBpg.default), {
                                            className: "h-3.5 w-3.5 text-muted/50 group-hover:text-neon"
                                        })
                                    ]
                                }, section.id))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                onClick: ()=>setIsOpen((open)=>!open),
                "aria-expanded": isOpen,
                "aria-label": isOpen ? 'Close developer tools' : 'Open developer tools',
                title: "Developer tools",
                className: "flex h-12 items-center gap-2 rounded-full border border-neon/40 bg-surface px-4 text-neon shadow-[0_8px_32px_rgba(0,0,0,0.5)] transition hover:border-neon/70 hover:bg-surface-2 hover:shadow-[0_0_24px_rgba(92,246,205,0.18)]",
                children: [
                    isOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                        className: "h-4 w-4"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f474c893b5a1302e$export$2e2bcd8739ae039), {
                        className: "h-4 w-4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "text-[10px] font-bold uppercase tracking-[0.16em]",
                        children: "Dev"
                    })
                ]
            })
        ]
    });
};
var $81f6c230720bc32f$export$2e2bcd8739ae039 = $81f6c230720bc32f$var$DevFloatingMenu;



const $cd93687958c8007e$var$Login = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("7J9BS")));

const $cd93687958c8007e$var$Register = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("1pkT4")));

const $cd93687958c8007e$var$SetupAccountPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(()=>(parcelRequire("2vhh3")));

const $cd93687958c8007e$var$logo = new URL((parcelRequire("eiFyw"))).href;
var $9daf6457d16e01ee$exports = {};
$9daf6457d16e01ee$exports = import.meta.resolve("48ECC");


const $cd93687958c8007e$var$notificationSound = new URL($9daf6457d16e01ee$exports).href;
const $cd93687958c8007e$var$pageLoadingFallback = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
    className: "flex min-h-[40vh] items-center justify-center",
    role: "status",
    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "text-sm text-muted",
        children: "Loading page\u2026"
    })
});
const $cd93687958c8007e$var$LiveClock = ({ value: value })=>{
    const [time, setTime] = (0, $acw62.useState)(()=>new Date().toLocaleTimeString());
    (0, $acw62.useEffect)(()=>{
        if (value) return;
        const intervalId = window.setInterval(()=>setTime(new Date().toLocaleTimeString()), 1000);
        return ()=>window.clearInterval(intervalId);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: value || time
    });
};
const $cd93687958c8007e$var$AppContent = ()=>{
    const { isAuthenticated: isAuthenticated, isUserLoading: isUserLoading, user: user, userProfileError: userProfileError, logout: logout, refreshUserProfile: refreshUserProfile } = (0, $70wbS.useAuth)();
    const navigate = (0, $aphAM.useNavigate)();
    const location = (0, $aphAM.useLocation)();
    const [navOpen, setNavOpen] = (0, $acw62.useState)(false);
    const [systemStatus, setSystemStatus] = (0, $acw62.useState)(null);
    const [systemControlState, setSystemControlState] = (0, $acw62.useState)(null);
    const [systemStatusTs, setSystemStatusTs] = (0, $acw62.useState)('');
    const [isSidebarCollapsed, setIsSidebarCollapsed] = (0, $acw62.useState)(true);
    const [isNotificationDrawerOpen, setIsNotificationDrawerOpen] = (0, $acw62.useState)(false);
    const [isTaskDrawerOpen, setIsTaskDrawerOpen] = (0, $acw62.useState)(false);
    const [unreadCount, setUnreadCount] = (0, $acw62.useState)(0);
    const [activeTaskCount, setActiveTaskCount] = (0, $acw62.useState)(0);
    const [userContext, setUserContext] = (0, $acw62.useState)(null);
    const [isSettingsDropdownOpen, setIsSettingsDropdownOpen] = (0, $acw62.useState)(false);
    const [isGatewayConfigModalOpen, setIsGatewayConfigModalOpen] = (0, $acw62.useState)(false);
    const [isEventsModalOpen, setIsEventsModalOpen] = (0, $acw62.useState)(false);
    const [isManualOrderModalOpen, setIsManualOrderModalOpen] = (0, $acw62.useState)(false);
    const [preparedNQMMOrder, setPreparedNQMMOrder] = (0, $acw62.useState)(null);
    const [editingOrder, setEditingOrder] = (0, $acw62.useState)(null);
    // Ref for sound throttling and change detection
    const prevUnreadCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const lastSoundPlayedAt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const notificationAudio = (0, $acw62.useMemo)(()=>new Audio($cd93687958c8007e$var$notificationSound), []);
    (0, $acw62.useEffect)(()=>{
        const handlePreparedNQMMOrder = (event)=>{
            const detail = event.detail;
            if (!detail?.openInModal) return;
            const order = (0, $33d0b97b7d1aebeb$export$6d11c9454f4c762b)(detail);
            if (!order) return;
            setPreparedNQMMOrder(order);
            setIsManualOrderModalOpen(true);
        };
        window.addEventListener('nqmm-prepare-order', handlePreparedNQMMOrder);
        return ()=>window.removeEventListener('nqmm-prepare-order', handlePreparedNQMMOrder);
    }, []);
    const openManualOrderModal = ()=>{
        setPreparedNQMMOrder(null);
        setIsManualOrderModalOpen(true);
    };
    const closeManualOrderModal = ()=>{
        setIsManualOrderModalOpen(false);
        setPreparedNQMMOrder(null);
    };
    // Redirect to login if not authenticated
    (0, $acw62.useEffect)(()=>{
        if (!isAuthenticated && location.pathname !== '/login' && location.pathname !== '/register' && location.pathname !== '/setup-account') navigate('/login');
    }, [
        isAuthenticated,
        location.pathname,
        navigate
    ]);
    // Lightweight system status poller for header/sidebar badges
    const fetchSystemStatus = async ()=>{
        if (!isAuthenticated) return;
        try {
            const response = await (0, $2wVnk.tradingApi).getSystemControlState();
            if (response.success && response.data) {
                setSystemControlState(response.data);
                setSystemStatus({
                    success: true,
                    data: {
                        running: response.data.system_enabled,
                        ib_connected: response.data.ib_connected,
                        version: response.data.version,
                        timestamp: response.data.timestamp
                    },
                    timestamp: response.data.timestamp
                });
                setSystemStatusTs(new Date().toLocaleTimeString());
            }
        } catch  {
        // ignore header status errors
        }
    };
    const fetchUnreadCount = async ()=>{
        if (!isAuthenticated) return;
        try {
            const res = await (0, $2wVnk.tradingApi).getUnreadCount();
            if (res.success) setUnreadCount(res.data.count);
        } catch  {
        // ignore
        }
    };
    const fetchTaskCount = async ()=>{
        if (!isAuthenticated || user?.role === 'investor') return;
        try {
            const tasks = await (0, $2wVnk.tradingApi).getDataDownloadTasks();
            setActiveTaskCount(tasks.filter((task)=>[
                    'queued',
                    'running',
                    'cancelling'
                ].includes(task.status)).length);
        } catch  {
        // ignore
        }
    };
    const fetchUserContext = async ()=>{
        if (!isAuthenticated) return;
        try {
            const res = await (0, $2wVnk.tradingApi).getCurrentContext();
            if (res.success) setUserContext(res.data);
        } catch  {
        // ignore
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (isAuthenticated && !isUserLoading) {
            fetchSystemStatus();
            fetchUnreadCount();
            fetchTaskCount();
            fetchUserContext();
            const id = setInterval(()=>{
                fetchSystemStatus();
                fetchUnreadCount();
                fetchTaskCount();
                fetchUserContext();
            }, 10000); // Poll faster (10s) for responsive notifications
            return ()=>clearInterval(id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAuthenticated,
        isUserLoading,
        user?.role
    ]);
    // Sound Effect Trigger
    (0, $acw62.useEffect)(()=>{
        if (unreadCount > prevUnreadCount.current) {
            const soundEnabled = userContext?.preferences?.notify_sound_enabled ?? true;
            if (soundEnabled) {
                const now = Date.now();
                if (now - lastSoundPlayedAt.current > 500) {
                    notificationAudio.play().catch(()=>{
                    // Ignore audio play errors (e.g. browser interaction policy)
                    });
                    lastSoundPlayedAt.current = now;
                }
            }
        }
        prevUnreadCount.current = unreadCount;
    }, [
        unreadCount,
        userContext,
        notificationAudio
    ]);
    const navItems = (0, $acw62.useMemo)(()=>{
        const items = [
            {
                label: 'Dashboard',
                path: '/',
                icon: (0, $bee7e1f6335e67ab$export$2e2bcd8739ae039)
            }
        ];
        if (user?.role === 'investor') items.push({
            label: 'Shared Backtests',
            path: '/backtest',
            icon: (0, $bKJAw.default)
        });
        // Investor backtests are read-only and show only accessible shared results.
        if (user?.role !== 'investor') items.push({
            label: 'Strategies',
            path: '/strategies',
            icon: (0, $gjSmI.default)
        }, {
            label: 'Backtest',
            path: '/backtest',
            icon: (0, $bKJAw.default)
        }, {
            label: 'Data',
            path: '/data',
            icon: (0, $i9lAt.default)
        }, {
            label: 'Positions',
            path: '/positions',
            icon: (0, $4wROA.default)
        }, {
            label: 'Managed ORB',
            path: '/managed-orb',
            icon: (0, $753mY.default)
        }, {
            label: 'Portfolio',
            path: '/portfolio',
            icon: (0, $4mRnX.default)
        }, {
            label: 'Trade Logs',
            path: '/trades',
            icon: (0, $kwEKL.default)
        });
        return items;
    }, [
        user?.role
    ]);
    const handleNavigate = (path)=>{
        navigate(path);
        setNavOpen(false);
    };
    if (location.pathname === '/login') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
        fallback: $cd93687958c8007e$var$pageLoadingFallback,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$Login, {})
    });
    if (location.pathname === '/register') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
        fallback: $cd93687958c8007e$var$pageLoadingFallback,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$Register, {})
    });
    if (location.pathname.startsWith('/setup-account')) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Suspense, {
        fallback: $cd93687958c8007e$var$pageLoadingFallback,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$SetupAccountPage, {})
    });
    if (!isAuthenticated) return null; // or loading spinner while redirecting
    if (isUserLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "min-h-screen auth-shell flex items-center justify-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "w-8 h-8 border-4 border-neon/30 border-t-neon rounded-full animate-spin"
        })
    });
    if (isAuthenticated && !user) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "min-h-screen auth-shell flex items-center justify-center p-4 text-foreground",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "auth-card max-w-md space-y-4 p-6 text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "text-lg font-bold",
                    children: "Account profile unavailable"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-sm text-muted",
                    children: userProfileError || 'The server could not confirm this account.'
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-center gap-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "rounded-lg border border-neon/40 px-4 py-2 text-sm text-neon",
                            onClick: refreshUserProfile,
                            children: "Try again"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "rounded-lg border border-white/20 px-4 py-2 text-sm text-white/70",
                            onClick: logout,
                            children: "Sign out"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "min-h-screen app-shell text-foreground relative overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: `fixed top-0 right-0 z-30 topbar border-b transition-all duration-300 ease-in-out ${isSidebarCollapsed ? 'left-20' : 'left-60'} ${navOpen ? 'left-0' : ''} lg:block hidden`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w-full px-4 lg:px-6 py-2 flex items-center justify-between gap-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-2 sm:gap-3 xl:gap-5 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 xl:gap-4 text-[10px] font-bold tracking-tight uppercase shrink-0",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: `flex items-center gap-1.5 xl:gap-2 px-2 xl:px-2.5 py-1 rounded-lg border ${systemStatus?.data?.running ? systemStatus?.data?.ib_connected ? 'bg-success-50 border-success-500/20 text-success-500' : 'bg-warning-50 border-warning-500/20 text-warning-500' : 'bg-error-50 border-error-500/20 text-error-500'}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `h-1.5 w-1.5 rounded-full shrink-0 ${systemStatus?.data?.running ? systemStatus?.data?.ib_connected ? 'bg-success-500 animate-pulse' : 'bg-warning-500 animate-pulse' : 'bg-error-500'}`
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "whitespace-nowrap",
                                                        children: systemStatus?.data?.running ? systemStatus?.data?.ib_connected ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "hidden xl:inline",
                                                                    children: "Trading "
                                                                }),
                                                                "Active"
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "hidden xl:inline",
                                                                    children: "Trading "
                                                                }),
                                                                "Stopped"
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "hidden xl:inline",
                                                                    children: "Trading "
                                                                }),
                                                                "Disabled"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-1.5 xl:gap-2 px-2 xl:px-2.5 py-1 rounded-lg bg-info-50 border border-info-500/20",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `h-1.5 w-1.5 rounded-full shrink-0 ${systemStatus?.data?.ib_connected ? 'bg-info-500 animate-pulse' : 'bg-error-500'}`
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: `whitespace-nowrap ${systemStatus?.data?.ib_connected ? 'text-info-500' : 'text-error-500'}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "hidden xl:inline",
                                                                children: "Connection "
                                                            }),
                                                            systemStatus?.data?.ib_connected ? 'Sync' : 'Lost'
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "h-4 w-px divider shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap-2 shrink-0",
                                        children: [
                                            user?.role !== 'investor' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7o8DG.default), {
                                                controlState: systemControlState,
                                                onRefresh: fetchSystemStatus,
                                                onError: (err)=>console.error(err),
                                                variant: "slim",
                                                iconSize: 13,
                                                className: "h-7 text-[11px] px-2.5 gap-1.5 shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jex3.default), {
                                                controlState: systemControlState,
                                                gatewayId: systemControlState?.saved_gateways?.find((g)=>g.is_active)?.id,
                                                onRefresh: fetchSystemStatus,
                                                onConfigureNeeded: ()=>setIsGatewayConfigModalOpen(true),
                                                onError: (err)=>console.error(err),
                                                variant: "slim",
                                                iconSize: 13,
                                                className: "h-7 text-[11px] px-2.5 gap-1.5 shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "relative shrink-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: ()=>setIsSettingsDropdownOpen(!isSettingsDropdownOpen),
                                                        className: `h-8 w-8 flex items-center justify-center rounded-lg icon-action ${isSettingsDropdownOpen ? 'bg-neon text-black border-neon shadow-neon/20' : ''}`,
                                                        title: "System Settings",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIubC.default), {
                                                            className: "w-4 h-4"
                                                        })
                                                    }),
                                                    isSettingsDropdownOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "fixed inset-0 z-40",
                                                                onClick: ()=>setIsSettingsDropdownOpen(false)
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "absolute top-full mt-2 right-0 w-56 panel-surface z-50 animate-in fade-in slide-in-from-top-2",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "p-2 space-y-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                            onClick: ()=>{
                                                                                navigate('/control');
                                                                                setIsSettingsDropdownOpen(false);
                                                                            },
                                                                            className: "menu-item",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iIubC.default), {
                                                                                    className: "w-4 h-4 text-neon"
                                                                                }),
                                                                                "Advanced Control"
                                                                            ]
                                                                        }),
                                                                        user?.role === 'admin' && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                            onClick: ()=>{
                                                                                navigate('/admin');
                                                                                setIsSettingsDropdownOpen(false);
                                                                            },
                                                                            className: "menu-item",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cSGqD.default), {
                                                                                    className: "w-4 h-4 text-emerald-400"
                                                                                }),
                                                                                "Admin Dashboard"
                                                                            ]
                                                                        }),
                                                                        user?.role === 'admin' && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                            onClick: ()=>{
                                                                                navigate('/admin/logs');
                                                                                setIsSettingsDropdownOpen(false);
                                                                            },
                                                                            className: "menu-item",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eUAhq.default), {
                                                                                    className: "w-4 h-4 text-neon"
                                                                                }),
                                                                                "Logs"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap-1.5 xl:gap-2 shrink-0",
                                children: [
                                    user?.role !== 'investor' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: openManualOrderModal,
                                        className: "relative h-8 w-8 flex items-center justify-center rounded-lg icon-action group shrink-0",
                                        title: "Place manual order",
                                        "aria-label": "Place manual order",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSlX2.default), {
                                            className: "w-4 h-4 group-hover:scale-110 transition-transform"
                                        })
                                    }),
                                    user?.role !== 'investor' && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>setIsTaskDrawerOpen(true),
                                        className: "relative h-8 w-8 flex items-center justify-center rounded-lg icon-action group shrink-0",
                                        title: "Background tasks",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $131c05e6196e399a$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4 group-hover:scale-110 transition-transform"
                                            }),
                                            activeTaskCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "absolute top-1.5 right-1.5 min-w-3.5 h-3.5 px-1 bg-neon text-black text-[9px] font-bold rounded-full flex items-center justify-center border border-surface shadow-[0_0_8px_rgba(var(--neon-rgb),0.5)]",
                                                children: activeTaskCount > 9 ? '9+' : activeTaskCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>setIsNotificationDrawerOpen(true),
                                        className: "relative h-8 w-8 flex items-center justify-center rounded-lg icon-action group shrink-0",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5TAH.default), {
                                                className: "w-4 h-4 group-hover:scale-110 transition-transform"
                                            }),
                                            unreadCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "absolute top-1.5 right-1.5 w-3.5 h-3.5 bg-error-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center border border-surface shadow-[0_0_8px_rgba(var(--danger-rgb),0.5)]",
                                                children: unreadCount > 9 ? '9+' : unreadCount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "h-6 w-px divider mx-1 xl:mx-2 shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "h-8 flex items-center gap-1.5 xl:gap-2 pl-1.5 pr-1 rounded-lg panel-section border backdrop-blur-sm shrink-0",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "flex items-center shrink-0",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e391768795d69b3$export$2e2bcd8739ae039), {
                                                    variant: "compact"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "h-4 w-px divider shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap-2 min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex flex-col items-end justify-center leading-none min-w-0 max-w-[80px] xl:max-w-[140px]",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "text-[10px] font-black text-foreground leading-none tracking-tight truncate w-full text-right",
                                                                title: userContext?.is_acting_as ? `${userContext.original_user?.username} (${userContext.username})` : user?.username,
                                                                children: userContext?.is_acting_as ? `${userContext.original_user?.username} (${userContext.username})` : user?.username
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "mt-0.5 flex items-center justify-end gap-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfC4h.default), {
                                                                        role: userContext?.role || user?.role,
                                                                        compact: true
                                                                    }),
                                                                    userContext?.is_acting_as && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "rounded-full border border-amber-500/25 bg-amber-500/10 px-1.5 py-0.5 text-[8px] font-black uppercase leading-none tracking-widest text-amber-400",
                                                                        children: "Manager"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `w-6 h-6 rounded-md flex items-center justify-center border transition-all shrink-0 ${userContext?.is_acting_as ? 'bg-amber-500/10 border-amber-500/25 shadow-[0_0_15px_rgba(var(--warning-rgb),0.1)]' : 'bg-neon/10 border-neon/20 shadow-[0_0_15px_rgba(var(--neon-rgb),0.1)]'}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                                            className: `w-3 h-3 ${userContext?.is_acting_as ? 'text-amber-400' : 'text-neon'}`
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: logout,
                                                        className: "w-7 h-7 flex items-center justify-center rounded-md text-muted hover:text-error-500 hover:bg-error-50/10 transition group shrink-0",
                                                        title: "Sign Out",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                                            className: "w-3.5 h-3.5 group-hover:scale-110 transition-transform"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w-full border-t border-white/5 bg-surface px-4 lg:px-6 py-1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "relative flex items-center justify-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5b0fd0c87ae8709d$export$361f331cf51c8057), {}),
                                user?.role !== 'investor' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setIsEventsModalOpen(true),
                                    className: "absolute right-0 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-md border border-neon/25 bg-neon/10 text-neon transition-colors hover:border-neon/50 hover:bg-neon/20",
                                    title: "Market events",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gn8IX.default), {
                                        className: "w-3.5 h-3.5"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: "sticky top-0 z-30 topbar border-b lg:hidden px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex min-w-0 items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex shrink-0 items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "h-8 w-8 flex items-center justify-center rounded-md border border-white/10 bg-transparent text-muted shadow-none transition hover:border-neon/40 hover:bg-neon/5 hover:text-neon",
                                        onClick: ()=>setNavOpen(!navOpen),
                                        "aria-label": navOpen ? 'Close navigation' : 'Open navigation',
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "space-y-1.5 w-5",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `block h-0.5 w-full bg-current transition ${navOpen ? 'translate-y-2 rotate-45' : ''}`
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `block h-0.5 w-full bg-current transition ${navOpen ? 'opacity-0' : ''}`
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `block h-0.5 w-full bg-current transition ${navOpen ? '-translate-y-2 -rotate-45' : ''}`
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: $cd93687958c8007e$var$logo,
                                        alt: "Logo",
                                        className: "w-8 h-8 rounded-lg cursor-pointer hover:scale-105 transition-transform",
                                        onClick: ()=>handleNavigate('/'),
                                        title: "Go to Dashboard"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex min-w-0 flex-1 items-center justify-end gap-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e391768795d69b3$export$2e2bcd8739ae039), {
                                        variant: "compact",
                                        showIdentity: true,
                                        alwaysRender: true
                                    }),
                                    user?.role !== 'investor' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: openManualOrderModal,
                                                className: "relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-neon/25 bg-neon/10 text-neon transition-colors hover:border-neon/50 hover:bg-neon/20",
                                                title: "Place manual order",
                                                "aria-label": "Place manual order",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iSlX2.default), {
                                                    className: "h-4 w-4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>setIsEventsModalOpen(true),
                                                className: "relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-neon/25 bg-neon/10 text-neon transition-colors hover:border-neon/50 hover:bg-neon/20",
                                                title: "Market events",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gn8IX.default), {
                                                    className: "h-4 w-4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>setIsTaskDrawerOpen(true),
                                                className: "icon-action relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $131c05e6196e399a$export$2e2bcd8739ae039), {
                                                        className: "h-4 w-4"
                                                    }),
                                                    activeTaskCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "absolute -top-1 -right-1 min-w-4 h-4 px-1 bg-neon text-black text-[10px] font-bold rounded-full flex items-center justify-center border-2 border-surface",
                                                        children: activeTaskCount > 9 ? '9+' : activeTaskCount
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>setIsNotificationDrawerOpen(true),
                                        className: "icon-action relative inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5TAH.default), {
                                                className: "h-4 w-4"
                                            }),
                                            unreadCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "absolute -top-1 -right-1 w-4 h-4 bg-error-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center border-2 border-surface",
                                                children: unreadCount > 9 ? '9+' : unreadCount
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-2 grid grid-cols-2 items-stretch gap-2 border-t border-white/10 pt-2",
                        children: [
                            user?.role !== 'investor' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7o8DG.default), {
                                controlState: systemControlState,
                                onRefresh: fetchSystemStatus,
                                onError: (err)=>console.error(err),
                                variant: "slim",
                                iconSize: 13,
                                className: "h-8 min-w-0 w-full rounded-md px-2 text-[10px] sm:text-[11px]"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2jex3.default), {
                                controlState: systemControlState,
                                gatewayId: systemControlState?.saved_gateways?.find((g)=>g.is_active)?.id,
                                onRefresh: fetchSystemStatus,
                                onConfigureNeeded: ()=>setIsGatewayConfigModalOpen(true),
                                onError: (err)=>console.error(err),
                                variant: "slim",
                                iconSize: 13,
                                className: "h-8 min-w-0 w-full rounded-md px-2 text-[10px] sm:text-[11px]"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("aside", {
                className: `hidden lg:flex fixed top-0 left-0 h-full ${isSidebarCollapsed ? 'w-20' : 'w-60'} flex-col sidebar-shell z-40 transition-all duration-300 ease-in-out border-r`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `p-4 flex items-center ${isSidebarCollapsed ? 'justify-center' : 'justify-between'} transition-all duration-300`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                onClick: ()=>handleNavigate('/'),
                                className: `flex items-center gap-3 cursor-pointer group ${isSidebarCollapsed ? 'justify-center w-full' : ''}`,
                                title: "Go to Dashboard",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: $cd93687958c8007e$var$logo,
                                        alt: "GetUndiluted Trader",
                                        className: "w-9 h-9 rounded-lg hover:scale-105 transition-transform"
                                    }),
                                    !isSidebarCollapsed && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-lg text-foreground font-bold tracking-tight group-hover:text-neon transition-colors",
                                            children: "GetUndiluted"
                                        })
                                    })
                                ]
                            }),
                            !isSidebarCollapsed && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setIsSidebarCollapsed(true),
                                className: "h-8 w-8 flex items-center justify-center rounded-md text-muted shadow-none hover:text-foreground hover:bg-neon/5 transition",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKB5x.default), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    }),
                    isSidebarCollapsed && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w-full flex justify-center mb-4",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>setIsSidebarCollapsed(false),
                            className: "h-8 w-8 flex items-center justify-center rounded-md text-muted shadow-none hover:text-foreground hover:bg-neon/5 transition",
                            "aria-label": "Expand navigation",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aqBpg.default), {
                                className: "w-5 h-5"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex-1 -space-y-px overflow-y-auto scrollbar-thin px-2",
                        children: navItems.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>handleNavigate(item.path),
                                className: `group relative flex items-center transition-all duration-200 ${isSidebarCollapsed ? 'w-10 h-10 justify-center mx-auto rounded-md' : 'w-full min-h-9 justify-between rounded-none border-y border-x-0 border-white/10 px-2 py-1.5 text-xs'} ${location.pathname === item.path ? 'bg-neon/10 text-neon border-neon/20' : 'text-muted hover:text-foreground hover:bg-neon/10'}`,
                                title: isSidebarCollapsed ? item.label : '',
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: `flex items-center gap-2 font-medium tracking-wide ${isSidebarCollapsed ? '' : 'mr-2 text-xs'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "inline-flex h-6 w-6 items-center justify-center rounded-none transition-colors",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(item.icon, {
                                                    className: "h-4 w-4"
                                                })
                                            }),
                                            !isSidebarCollapsed && item.label
                                        ]
                                    }),
                                    !isSidebarCollapsed && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `h-1.5 w-1.5 rounded-full ${location.pathname === item.path ? 'bg-neon' : 'bg-transparent'}`
                                    }),
                                    isSidebarCollapsed && location.pathname === item.path && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "absolute left-0 top-1/2 -translate-y-1/2 h-7 w-0.5 bg-neon"
                                    })
                                ]
                            }, item.path))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `mt-auto p-4 ${isSidebarCollapsed ? 'px-2' : 'px-6'} flex flex-col items-center gap-2`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col items-center gap-1 text-[9px] text-muted font-mono uppercase tracking-widest mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "opacity-70",
                                    children: systemStatus?.data?.version ? `v${systemStatus.data.version}` : 'Loading...'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "opacity-50",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$LiveClock, {
                                        value: systemStatusTs
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            navOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "fixed inset-0 z-40 lg:hidden",
                role: "dialog",
                "aria-modal": "true",
                "aria-label": "Navigation",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "absolute inset-0 overlay-backdrop shadow-[inset_0_0_100px_rgba(var(--overlay-rgb),0.5)]",
                        onClick: ()=>setNavOpen(false)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "absolute inset-0 flex h-[100dvh] w-full flex-col sidebar-shell overflow-y-auto p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] sm:p-4 sm:pb-4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between gap-3 border-b border-white/10 pb-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        onClick: ()=>handleNavigate('/'),
                                        className: "flex min-w-0 items-center gap-3 cursor-pointer group",
                                        title: "Go to Dashboard",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: $cd93687958c8007e$var$logo,
                                                alt: "GetUndiluted Trader",
                                                className: "h-9 w-9 shrink-0 rounded-lg hover:scale-105 transition-transform"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "truncate text-sm font-semibold text-foreground group-hover:text-neon transition-colors",
                                                        children: "GetUndiluted Trader"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "text-[10px] uppercase tracking-[0.16em] text-muted",
                                                        children: "Navigation"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setNavOpen(false),
                                        className: "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-white/10 text-muted transition hover:border-neon/40 hover:bg-neon/5 hover:text-neon",
                                        "aria-label": "Close navigation",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hPAJY.default), {
                                            className: "h-4 w-4"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb-1 mt-4 px-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted",
                                children: "Navigate"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "-space-y-px",
                                children: [
                                    user?.role !== 'investor' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>{
                                            setNavOpen(false);
                                            setIsTaskDrawerOpen(true);
                                        },
                                        className: "w-full border-y border-x-0 border-white/10 px-2 py-1.5 text-left text-xs rounded-none transition text-muted hover:border-neon/20 hover:text-foreground hover:bg-neon/10",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "flex items-center justify-between text-xs font-semibold uppercase tracking-[0.05em]",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "inline-flex h-6 w-6 items-center justify-center rounded-none",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $131c05e6196e399a$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4"
                                                            })
                                                        }),
                                                        "Tasks"
                                                    ]
                                                }),
                                                activeTaskCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "bg-neon text-black text-[10px] px-2 py-0.5 rounded-full",
                                                    children: activeTaskCount
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>{
                                            setNavOpen(false);
                                            setIsNotificationDrawerOpen(true);
                                        },
                                        className: "w-full border-y border-x-0 border-white/10 px-2 py-1.5 text-left text-xs rounded-none transition text-muted hover:border-neon/20 hover:text-foreground hover:bg-neon/10",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "flex items-center justify-between text-xs font-semibold uppercase tracking-[0.05em]",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "inline-flex h-6 w-6 items-center justify-center rounded-none",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5TAH.default), {
                                                                className: "h-4 w-4"
                                                            })
                                                        }),
                                                        "Activity"
                                                    ]
                                                }),
                                                unreadCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "bg-error-500 text-white text-[10px] px-2 py-0.5 rounded-full",
                                                    children: unreadCount
                                                })
                                            ]
                                        })
                                    }),
                                    navItems.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>handleNavigate(item.path),
                                            className: `w-full rounded-none border-y border-x-0 border-white/10 px-2 py-1.5 text-left text-xs transition ${location.pathname === item.path ? 'bg-neon/10 text-neon border-neon/20' : 'text-muted hover:text-foreground hover:bg-neon/10'}`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.05em]",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "inline-flex h-6 w-6 items-center justify-center rounded-none",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(item.icon, {
                                                            className: "h-4 w-4"
                                                        })
                                                    }),
                                                    item.label
                                                ]
                                            })
                                        }, item.path))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mt-auto border-t border-white/10 pt-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center justify-between gap-3 px-2 py-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex min-w-0 items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-success-500/20 bg-success-50 text-success-500",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039), {
                                                            className: "h-3.5 w-3.5"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "min-w-0",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "truncate text-xs font-semibold text-foreground",
                                                                children: user?.username || 'User'
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "mt-1 flex items-center gap-1.5",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfC4h.default), {
                                                                        role: userContext?.role || user?.role,
                                                                        compact: true
                                                                    }),
                                                                    userContext?.is_acting_as && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "text-[8px] font-bold uppercase tracking-widest text-amber-400",
                                                                        children: "Manager"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    setNavOpen(false);
                                                    logout();
                                                },
                                                className: "inline-flex h-8 shrink-0 items-center gap-1.5 rounded-md border border-error-500/20 px-2.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-error-500 transition hover:bg-error-50 hover:text-error-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5473793717b51056$export$2e2bcd8739ae039), {
                                                        className: "h-3.5 w-3.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "Logout"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center justify-between px-2 pt-2 text-[10px] text-muted",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Last update"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "font-semibold text-foreground",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$LiveClock, {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                className: `relative z-10 min-h-screen w-full transition-all duration-300 ease-in-out ${isSidebarCollapsed ? 'lg:pl-20' : 'lg:pl-60'} pt-0 lg:pt-20`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2abb2f023fad02d4$export$2e2bcd8739ae039), {
                    user: user,
                    userContext: userContext,
                    systemStatus: systemStatus,
                    editingOrder: editingOrder,
                    onEditingOrderChange: setEditingOrder
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $81f6c230720bc32f$export$2e2bcd8739ae039), {}),
            isNotificationDrawerOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "fixed inset-0 z-[100] transition-opacity duration-300",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "absolute inset-0 overlay-backdrop",
                        onClick: ()=>setIsNotificationDrawerOpen(false)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("aside", {
                        className: `absolute top-0 right-0 h-full w-full sm:w-[400px] transform transition-transform duration-300 ease-out border-l divider-line shadow-2xl ${isNotificationDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09681d67b125daf0$export$2e2bcd8739ae039), {
                            onClose: ()=>setIsNotificationDrawerOpen(false),
                            onUnreadCountChange: setUnreadCount
                        })
                    })
                ]
            }),
            isTaskDrawerOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "fixed inset-0 z-[100] transition-opacity duration-300",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "absolute inset-0 overlay-backdrop",
                        onClick: ()=>setIsTaskDrawerOpen(false)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("aside", {
                        className: `absolute top-0 right-0 h-full w-full sm:w-[420px] transform transition-transform duration-300 ease-out border-l divider-line shadow-2xl ${isTaskDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f2865e61a04185b$export$2e2bcd8739ae039), {
                            onClose: ()=>setIsTaskDrawerOpen(false),
                            onTaskCountChange: setActiveTaskCount
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfqjJ.default), {
                isOpen: isGatewayConfigModalOpen,
                onClose: ()=>setIsGatewayConfigModalOpen(false),
                onSuccess: ()=>{
                    setIsGatewayConfigModalOpen(false);
                    fetchSystemStatus();
                },
                currentUsername: systemControlState?.ib_username,
                currentMode: systemControlState?.ib_mode,
                savedGateways: systemControlState?.saved_gateways
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9qjJe.default), {
                isOpen: isEventsModalOpen,
                onClose: ()=>setIsEventsModalOpen(false),
                title: "Market Events",
                width: "max-w-4xl",
                flush: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f79f43cbfab696d1$export$2e2bcd8739ae039), {
                    compact: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9qjJe.default), {
                isOpen: isManualOrderModalOpen,
                onClose: closeManualOrderModal,
                title: preparedNQMMOrder ? 'Review NQMM Rebalance Order' : 'Place Manual Order',
                width: "max-w-2xl",
                flush: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b6f36562471e94f$export$2e2bcd8739ae039), {
                    inModal: true,
                    showCancelButton: true,
                    preparedNQMMOrder: preparedNQMMOrder,
                    onCancel: closeManualOrderModal,
                    onOrderSubmitted: closeManualOrderModal
                })
            })
        ]
    });
};
const $cd93687958c8007e$var$App = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.BrowserRouter), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $70wbS.AuthProvider), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cYtEX.GlobalErrorProvider), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $489e57e116e551f3$export$7c0d05a5f8d89647), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cd93687958c8007e$var$AppContent, {})
                })
            })
        })
    });
};
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;




var $7jD0c = parcelRequire("7jD0c");

(0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById('root')).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7jD0c.Provider), {
        store: (0, $01ad0b73f9df3fa4$export$6f57813fe9f31bf9),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=web_layer.98cbaf81.js.map
